export const NoviceTrainerBadge = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="467.814"
      height="343.243"
      version="1.1"
      viewBox="0 0 123.776 90.816"
    >
      <defs>
        <clipPath id="clipPath18039" clipPathUnits="userSpaceOnUse">
          <path d="M9370.95 6814.77c-40.84 87.31-123.16 268.11-107.47 274.32-9.78-3.86 18.53-75.58 51.12-150.2 40.72-8.1 84.2-12.55 129.43-12.55 14.28 0 28.4.44 42.3 1.29 2.79-.84 5.07-1.29 6.77-1.29 1.08 0 1.93.18 2.52.56.42.28 1 .78 1.72 1.5 129.7 10.08 240.44 56.49 303.19 121.71 45.35-58.94 88.32-118.9 95.01-123.21.59-.38 1.43-.56 2.51-.56 22.4 0 146.35 78.32 199.35 105.77-22.9-61.77-67.4-159.06-94.3-216.58-53.17 17.66-108.2 30.9-164.65 39.43l-10.2 1.51c-12.58 1.78-25.17 3.37-37.58 4.63-4.82.53-9.7.94-14.57 1.31l-5.68.48c-10.14.84-20.22 1.7-30.35 2.22-13.09.69-26.29.95-39.69 1.16l-3.07.08c-2.83.13-5.66.22-8.53.22h-1.93c-17.78 0-36.16-.55-55.73-1.68l-3.16-.19c-17.73-1.05-36.29-2.66-53.36-4.65l-3.38-.4c-69.33-8.04-136.35-23.28-200.27-44.88m518.35 159.73c-1.08 0-1.92.19-2.51.57-12.77 8.22-154.06 219.36-195.34 238.86 41.28-19.5 182.57-230.64 195.34-238.86.59-.38 1.43-.57 2.51-.57 26.01.01 188.7 105.44 218.8 114.55.4.14.8.2 1.2.2 1.5 0 2.4-1.19 2.7-3.43-.3 2.24-1.2 3.43-2.7 3.43-.4 0-.8-.06-1.2-.2-30.1-9.11-192.79-114.54-218.8-114.55m222.8 110.55v0m0 .09v0m0 .11v0m0 .12v0m0 .11v0m0 .12c0 .03 0 .07-.1.1.1-.03.1-.07.1-.1m-.1.11v0m-848.52 3.38c.02.01.04.02.06.02-.02 0-.04-.01-.06-.02m.06.02c.02.01.04.02.05.02-.01 0-.03-.01-.05-.02m.07.03c.01 0 .03 0 .04.01-.01-.01-.03-.01-.04-.01m.06.02c.02 0 .03 0 .04.01-.01-.01-.02-.01-.04-.01m.07.02h.04-.04m.07.01c.01 0 .02.01.03.01-.01 0-.02-.01-.03-.01m.06.01c.01.01.02.01.03.01-.01 0-.02 0-.03-.01m.08.02h.02-.02m.07.01h.02-.02m.07.01h.02-.02m.08.01h.01-.01"></path>
        </clipPath>
        <linearGradient
          id="linearGradient18047"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(789.26 -789.26) rotate(78.69 11.703 2.885)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#d0d710" stopOpacity="1"></stop>
          <stop offset="0.024" stopColor="#d0d710" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#1a7d40" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath18061" clipPathUnits="userSpaceOnUse">
          <path d="M9444.03 6926.34c-45.23 0-88.71 4.45-129.43 12.55-32.59 74.62-60.9 146.34-51.12 150.2.02.01.04.02.06.02.02.01.04.02.05.02.01 0 .01 0 .02.01.01 0 .03 0 .04.01.01 0 .02 0 .02.01.02 0 .03 0 .04.01.01 0 .02 0 .03.01h.04c.01.01.02.01.03.01.01 0 .02.01.03.01h.03c.01.01.02.01.03.01.02 0 .03 0 .05.01h.02c.01 0 .03.01.05.01h.02c.02 0 .03 0 .05.01h.02c.02 0 .04 0 .06.01h.23c-6.28 0-1.73-19.32 8.66-48.41l1.3.05c28.12-8.52 172.06-101.19 211.97-113.26-13.9-.85-28.02-1.29-42.3-1.29m53.31 2.06c20.82 20.82 159.38 221.26 198.23 237.73v.7c-.27.22-.69.34-.41.34.08 0 .21-.01.41-.03.21.02.34.03.43.03.29 0-.13-.12-.43-.34v-.7c19.29-8.17 63.14-61.66 104.96-116.02-62.75-65.22-173.49-111.63-303.19-121.71m-232.05 160.74h-.02.02"></path>
        </clipPath>
        <linearGradient
          id="linearGradient18069"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(789.26 -789.26) rotate(78.69 11.703 2.885)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#dee70a" stopOpacity="1"></stop>
          <stop offset="0.024" stopColor="#dee70a" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#00a650" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath18083" clipPathUnits="userSpaceOnUse">
          <path d="M8385.36 5075.97c-185.35.01-289.02 44.47-213.43 68.45 101.81 32.28 327.77 255.77 365.05 300.5 37.25 44.71 44.69 69.53-67.07 104.28-111.76 34.78-471.77 275.64-509.06 315.39-12.82 13.65-7.72 18.2 18.44 18.2 49.9 0 176.41-16.57 401.23-18.2-224.8 1.62-351.18 18.16-401.1 18.16-1.34 0-2.63-.01-3.86-.03 71.17-16.88 205.99-46.51 404.96-47.92 1.67-.01 3.31-.01 4.98-.01 132.82 0 242.34 38.75 332.7 86.55 0-3.02.02-5.98.05-8.99-43.2-85.13-8.2-205.91 6.51-255.47 25.99-87.53 142.55-354.62 208.37-464.44 2.76 1.15 5.46 2.29 8.13 3.43-82.76-37.14-196.79-77.5-337.28-101.09-80.02-13.44-154.23-18.81-218.62-18.81m.11 788.6c-1.34 0-2.7.01-4.04.01 1.32 0 2.61-.01 3.92-.01 133.27.01 243.05 39.01 333.58 87.02v-.08c-90.5-47.97-200.29-86.94-333.46-86.94"></path>
        </clipPath>
        <linearGradient
          id="linearGradient18091"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-908.725 908.725) rotate(-13.016 22.39 47.129)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#1a7d40" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#d0d710" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#d0d710" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath18109" clipPathUnits="userSpaceOnUse">
          <path d="M10988.3 5075.97c-64.4 0-138.6 5.37-218.6 18.81-140.7 23.63-254.9 64.1-337.7 101.29 2.8-1.2 5.7-2.41 8.6-3.63 65.8 109.82 182.4 376.91 208.4 464.44 14.7 49.58 49.7 170.44 6.4 255.59.1 2.97.1 5.89.1 8.88 90.3-47.8 199.9-86.56 332.7-86.56 1.6 0 3.3 0 4.9.01 19.7.14 38.8.56 57.2 1.21 9.4-40.47 34.5-75.52 69-99.36l-57.5-86.07c15.7 17.62 41.3 47.09 68.8 78.86 17.8-10.46 37.7-18.1 59.1-22.23-109.6-70.26-229.5-140.44-285.9-158.01-111.8-34.75-104.3-59.57-67.1-104.28 37.3-44.73 263.3-268.22 365-300.5 75.7-23.98-28-68.45-213.4-68.45m418.2 782.57c.3 4.32.5 8.68.5 13.09 0 3.59-.1 7.15-.4 10.68 15.2-1.48 16.7-6.56 6.2-17.72-1.5-1.67-3.7-3.7-6.3-6.05m-418.3 6.03c-133.2 0-242.9 38.97-333.4 86.93v.09c90.5-48.01 200.3-87.02 333.5-87.02 1.3 0 2.6.01 3.9.01-1.3 0-2.7-.01-4-.01m4.9.02c18.4.13 36.2.37 53.3.68-17.1-.32-34.9-.55-53.3-.68"></path>
        </clipPath>
        <linearGradient
          id="linearGradient18117"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="rotate(-13.016 30032.55 -42090.006) scale(908.711)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#1a7d40" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#d0d710" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#d0d710" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath18135" clipPathUnits="userSpaceOnUse">
          <path d="M9959.87 5017.47c-13.8 9.94-30.32 18.58-49.9 25.31a154.628 154.628 0 01-33.61 7.52c.22 3.73.33 7.48.33 11.26 0 .87-.01 1.72-.02 2.58 409.43 83.16 716.93 436.07 716.93 858.85 0 24.61-1.1 48.98-3.1 73.07-14.5 170.99-79.4 328.06-180.3 457.15.4.24.7.46 1.1.7-164.8 210.44-425.1 346.39-718.16 346.39h-1.98c-144.71 0-281.5-33.14-402.72-92.02 13.26 25.01 22.67 42.82 23.46 44.53l.01.01c-.17 0-16.09-21.89-37.57-51.53a912.06 912.06 0 01-41.57-22.47c-21.18 8.14-44.39 12.63-68.72 12.63-15.6 0-30.75-1.85-45.19-5.32 1.67 1.18 3.29 2.32 4.96 3.49a973.716 973.716 0 00156.73 89.48 965.997 965.997 0 0063 25.95c9.06 3.37 18.21 6.62 27.4 9.72 63.92 21.6 130.94 36.84 200.27 44.88l3.38.4c17.07 1.99 35.63 3.6 53.36 4.65l3.16.19c19.57 1.13 37.95 1.68 55.73 1.68h1.93c2.87 0 5.7-.09 8.53-.22l3.07-.08c13.4-.21 26.6-.47 39.69-1.16 10.13-.52 20.21-1.38 30.35-2.22l5.68-.48c4.87-.37 9.75-.78 14.57-1.31 12.41-1.26 25-2.85 37.58-4.63l10.2-1.51c56.45-8.53 111.48-21.77 164.65-39.43 9.2-3.06 18.3-6.25 27.4-9.58 5.3-1.91 10.5-3.88 15.7-5.89 4.1-1.56 8.1-3.14 12.1-4.75a968.834 968.834 0 00154.1-78.25 964.57 964.57 0 00148.1-114.26c35.4-33.24 68.4-69.31 98.7-108.01l10.1-14.61 1-1.47 31.3-45.38c24-36.15 45.3-73.74 63.8-112.51 4.8-9.89 9.3-19.86 13.7-29.9a924.12 924.12 0 0037.8-103.56c16.2-54.24 27.3-109.89 33.2-166.62l.3-2.38c1.4-14.25 2.5-28.55 3.3-42.93.5-7.93.8-15.88 1.1-23.84v-.09c.1-2.86.1-5.73.2-8.6l.2-6.24c.1-4.54.3-9.06.3-13.67v-1.64c0-2.99 0-5.91-.1-8.88-3-266.63-120.1-507.13-305.9-677.15-6.1-5.57-12.2-11.03-18.4-16.46-6.8-5.91-13.8-11.77-20.7-17.5-36.4-29.89-75.1-57.21-115.7-81.7a978.418 978.418 0 00-172.1-81.9 982.396 982.396 0 00-62.73-20.29m-665.85 42.95a982.592 982.592 0 00-57.54 27.23 973.615 973.615 0 00-180.57 119.86 902.91 902.91 0 00-13.3 11.34 962.72 962.72 0 00-18.45 16.47c-185.75 170-302.86 410.45-305.91 677.03-.03 3.01-.05 5.97-.05 8.99-.01.54-.01 1.11-.01 1.65 0 4.2.12 8.29.31 12.46l.16 6.74 36.6-.17 2.76-.01-2.69.05-36.63.76c.06 2.91.14 5.78.23 8.69v.08c.25 7.97.6 15.93 1.05 23.85a910.076 910.076 0 0024.52 164.19c2.22 9.12 4.57 18.15 7.07 27.17a923.008 923.008 0 0039.15 112.44c26.23 62.12 59.1 121.05 97.77 175.92a958.854 958.854 0 0081.66 100.63 937.01 937.01 0 0020.71 21.6c1.27 1.28 2.53 2.55 3.8 3.82a157.403 157.403 0 01-10.94-57.76c0-16.35 2.51-32.16 7.19-47.1-126.35-150.96-202.11-343.56-202.11-553.36 0-371.11 236.99-688.4 571.78-816.66-25.87-10.35-48.62-26.17-66.56-45.91"></path>
        </clipPath>
        <linearGradient
          id="linearGradient18143"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(1254.052 -1254.052) rotate(76.211 7.033 2.36)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#e64120" stopOpacity="1"></stop>
          <stop offset="0.952" stopColor="#e61d25" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e61d25" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath18153" clipPathUnits="userSpaceOnUse">
          <path d="M9690.97 6743.04c-465.39 0-844.18-367.85-844.18-820.05 0-452.24 378.73-820.17 844.37-820.17 463.94 0 842.74 366.48 844.44 817.09l.1 2.6c0 180.94-59.3 352.22-171.4 495.63l-29.2 37.39c-151 171.74-367.16 275.46-600.19 286.47l-2.3.11c-6.18.28-12.33.51-18.44.65-2.58.07-5.04.1-7.44.1l-8.11.13c-1.78.05-3.59.05-5.48.05h-2.17"></path>
        </clipPath>
        <linearGradient
          id="linearGradient18159"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1688.89 0 0 -1688.89 8846.79 5922.92)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#fcd405" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e61d25" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath18169" clipPathUnits="userSpaceOnUse">
          <path d="M9872.68 5100.45c-9.54 45.67-35.55 85.37-71.51 112.58 301.93 43.99 543.93 266.24 608.93 553.11 65 39.74 125.7 84.68 181.1 134.12-27.5-397.18-326.7-721.98-718.52-799.81m-370.32 6.07c-21.71 8.61-45.6 13.38-70.67 13.38-.43 0-.86 0-1.29-.01-348.78 102.26-608.4 404.33-638.41 769.35 55.89-48.51 116.85-92.49 182.14-131.29 67.18-280.63 304.1-497.83 599.8-543.83-35.09-26.04-60.92-63.88-71.57-107.6"></path>
        </clipPath>
        <linearGradient
          id="linearGradient18175"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-1651.53 1651.53) rotate(-90 -.851 5.017)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f6e604" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e64120" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath18185" clipPathUnits="userSpaceOnUse">
          <path d="M8974.13 5757.95c-65.29 38.8-126.25 82.78-182.14 131.29-.72 8.84-1.32 17.77-1.77 26.68 9.8 196.46 86.03 375.97 207.32 517.73.24-.14.47-.27.71-.41-90.03-111.48-153.56-255.39-151.46-348.09.6-27.7 4.51-38.89 10.55-38.89 20.02 0 63.53 122.6 88.82 174.77 9.07 18.72 28.15 48.01 53.53 81.94l-.38-.57c15.71 17.63 41.32 47.09 68.75 78.86 13.08-7.67 27.3-13.83 42.36-18.2-97.46-121.4-155.53-274.16-155.53-440.07 0-9.01.17-17.97.51-26.9 1.66-47.36 8.05-93.55 18.73-138.14m1435.97 8.19c11.3 49.84 17.3 101.64 17.3 154.78v2.07c0 171.56-62.1 329.06-165.7 452.37 41.6 18.54 81.8 39.02 120.6 61.32 122.7-142.14 199.9-322.67 209.8-520.4-.2-5.36-.5-10.68-.9-16.02-55.4-49.44-116.1-94.38-181.1-134.12m-1621.3 156.85c0 209.8 75.76 402.4 202.11 553.36.01-.01.01-.03.01-.04-125.38-149.81-200.91-340.63-202.05-548.57-.04-1.58-.07-3.16-.07-4.75m444 755.82c-.01.01-.02.01-.03.01a912.06 912.06 0 0041.57 22.47c-.01-.01-.01-.02-.02-.03a904.718 904.718 0 01-41.52-22.45m55.62 29.45l.02.02c121.22 58.88 258.01 92.02 402.72 92.02-144.7 0-281.49-33.14-402.74-92.04"></path>
        </clipPath>
        <linearGradient
          id="linearGradient18191"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-1651.53 1651.53) rotate(-90 -.851 5.017)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f3ee04" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#f58113" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath18201" clipPathUnits="userSpaceOnUse">
          <path d="M10261.7 6375.36c-134.8 160.58-339.84 263.18-569.57 263.47h-1.06c-126.44 0-245.46-31.01-349.41-85.62-4.41 22.95-13.82 44.28-27.15 62.99-.87 2.16-2.29 4.08-4.26 5.71-9.06 11.64-19.68 22.16-31.58 31.28 123.61 61.93 263.89 96.91 412.55 96.91 277.47 0 525.58-121.81 691.08-313.42-38.8-22.3-79-42.78-120.6-61.32m-1263.45 57.88c-.24.14-.47.27-.71.41 2.7 3.15 5.42 6.29 8.16 9.4.08-.15.17-.29.25-.43-2.59-3.1-5.15-6.22-7.7-9.38"></path>
        </clipPath>
        <linearGradient
          id="linearGradient18207"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-1651.53 1651.53) rotate(-90 -.851 5.017)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#efee0b" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#f6c009" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath18217" clipPathUnits="userSpaceOnUse">
          <path d="M10410.2 6453.21c-164.7 210.7-425.04 346.83-718.12 347.09h1.06c293.06 0 553.36-135.95 718.16-346.39-.4-.24-.7-.46-1.1-.7"></path>
        </clipPath>
        <linearGradient
          id="linearGradient18225"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(1254.052 -1254.052) rotate(76.211 7.033 2.36)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f58113" stopOpacity="1"></stop>
          <stop offset="0.952" stopColor="#ee2622" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#ee2622" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath18235" clipPathUnits="userSpaceOnUse">
          <path d="M10590.5 5996.06c-14.5 170.99-79.4 328.06-180.3 457.15 100.9-129.09 165.8-286.16 180.3-457.15"></path>
        </clipPath>
        <clipPath id="clipPath18253" clipPathUnits="userSpaceOnUse">
          <path d="M10592.1 5916.28c-9.9 197.73-87.1 378.26-209.8 520.4 9.3 5.4 18.7 10.92 27.9 16.53 100.9-129.09 165.8-286.16 180.3-457.15 2-24.09 3.1-48.46 3.1-73.07 0 6.19-.4 12.33-.5 18.52-.2-8.43-.5-16.86-1-25.23"></path>
        </clipPath>
        <clipPath id="clipPath18287" clipPathUnits="userSpaceOnUse">
          <path d="M8790.22 5915.92c-.44 8.51-.75 17.02-.93 25.59-.05-4.61-.29-9.18-.42-13.77 1.14 207.94 76.67 398.76 202.05 548.57.18-.57.36-1.14.55-1.7a910.676 910.676 0 01-20.43-25.48c8.76-5.25 17.59-10.42 26.5-15.48-121.29-141.76-197.52-321.27-207.32-517.73m443.75 762.44l-1.17.45a904.718 904.718 0 0041.52 22.45c-.38-.53-.76-1.05-1.15-1.59a902.043 902.043 0 01-39.2-21.31m53.77 28.61c.23.43.46.86.68 1.29 121.25 58.9 258.04 92.04 402.8 92.04h.83c-145.4-.17-282.72-33.77-404.31-93.33"></path>
        </clipPath>
        <clipPath id="clipPath18303" clipPathUnits="userSpaceOnUse">
          <path d="M10410.2 6453.21c-164.7 210.68-425.07 346.81-718.15 347.09h.03c293.08-.26 553.42-136.39 718.12-347.09"></path>
        </clipPath>
        <linearGradient
          id="linearGradient18311"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(1254.052 -1254.052) rotate(76.211 7.033 2.36)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f6c009" stopOpacity="1"></stop>
          <stop offset="0.952" stopColor="#f14c1c" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#f14c1c" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath18321" clipPathUnits="userSpaceOnUse">
          <path d="M8997.54 6433.65c-8.91 5.06-17.74 10.23-26.5 15.48 6.66 8.62 13.47 17.11 20.43 25.48 3.6-11.05 8.39-21.61 14.23-31.56a915.31 915.31 0 01-8.16-9.4m1384.76 3.03c-165.5 191.61-413.61 313.42-691.08 313.42-148.66 0-288.94-34.98-412.55-96.91-4.57 3.5-9.33 6.8-14.26 9.88 8.36 15.71 16.35 30.75 23.33 43.9 121.59 59.56 258.91 93.16 404.31 93.33 293.08-.28 553.45-136.41 718.15-347.09-9.2-5.61-18.6-11.13-27.9-16.53m-1130.44 233.56c-5.78 3-11.75 5.71-17.89 8.12a902.043 902.043 0 0039.2 21.31c-6.69-9.23-13.9-19.19-21.31-29.43"></path>
        </clipPath>
        <linearGradient
          id="linearGradient18327"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-1651.53 1651.53) rotate(-90 -.851 5.017)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#eced0f" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#f4de06" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath18339" clipPathUnits="userSpaceOnUse">
          <path d="M9727.42 5247.05a189.844 189.844 0 01-40.59 4.37c-13.33 0-26.35-1.38-38.91-4.01-153.18 8.63-293.72 62.8-407.62 148.82-5.02 33.73-7.65 68.2-7.65 103.28 0 20.68.9 41.16 2.67 61.4l63.9-191.61h562.88l212.7.23 251.8 755.47-1.7 1.17c5.9-3.18 11.7-6.43 17.5-9.76 26.7-74.02 41.2-153.6 41.2-236.46 0-101.81-21.9-198.63-61.3-286.29-122.8-198.72-342.07-334.68-594.88-346.61m699.98 674.76v0m-735.59 717.02H9691.12 9691.81"></path>
        </clipPath>
        <linearGradient
          id="linearGradient18345"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-1357.38 1357.38) rotate(-90 -1.205 5.935)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#e61d25" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#fcd405" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath18355" clipPathUnits="userSpaceOnUse">
          <path d="M10322.3 5593.66c39.4 87.66 61.3 184.48 61.3 286.29 0 82.86-14.5 162.44-41.2 236.46a731.24 731.24 0 0068.9-44.8c-70.2 323.68-365.4 566.75-719.17 567.22 406.17-.51 735.27-320.88 735.27-715.84v-1.18-.09c-.1 6.66-.3 13.21-.5 19.79-3.7-127-41.4-245.71-104.6-347.85m-630.49 1045.17h-.69H9691.81"></path>
        </clipPath>
        <linearGradient
          id="linearGradient18361"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1280.94 0 0 -1280.94 9146.42 6018.63)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#fcd405" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e61d25" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath18371" clipPathUnits="userSpaceOnUse">
          <path d="M8955.4 5896.09c-.34 8.93-.51 17.89-.51 26.9 0 165.91 58.07 318.67 155.53 440.07.02 0 .04-.01.06-.01-97.45-121.41-155.51-274.15-155.51-440.06v-1.34-.73c0-8.3.15-16.59.43-24.83"></path>
        </clipPath>
        <linearGradient
          id="linearGradient18377"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-1651.53 1651.53) rotate(-90 -.851 5.017)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f6ad0c" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#ec4a1d" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath18387" clipPathUnits="userSpaceOnUse">
          <path d="M9341.67 6553.17c0 .01-.01.03-.01.04 103.95 54.61 222.97 85.62 349.41 85.62h.05-2.85c-.27-.01-.53-.01-.81-.01h-1.23c-.16-.01-.31-.01-.47-.01h-.76c-.16 0-.33-.01-.49-.01h-.74c-.17-.01-.32-.01-.49-.01-.25 0-.5 0-.75-.01h-.49c-.25-.01-.5-.01-.75-.01-.16 0-.3-.01-.45-.01-.28 0-.53 0-.8-.01-.14 0-.3 0-.44-.01-.25 0-.56 0-.8-.01h-.42c-.27-.01-.57-.01-.85-.02-.13 0-.25 0-.38-.01-.3 0-.6-.01-.89-.01-.11 0-.22-.01-.32-.01-.33 0-.68-.01-1-.02h-.23l-1.2-.03h-.01c-2.93-.07-5.86-.15-8.78-.25h-.02c-.41-.02-.82-.03-1.24-.05h-.01c-.41-.01-.82-.03-1.23-.04h-.03c-115.69-4.36-224.52-34.67-320.52-85.12m350.46 85.66h-.32.32"></path>
        </clipPath>
        <linearGradient
          id="linearGradient18393"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-1651.53 1651.53) rotate(-90 -.851 5.017)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f5b30c" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#f28813" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath18403" clipPathUnits="userSpaceOnUse">
          <path d="M9240.3 5396.23c-168.25 127.05-278.28 323.57-284.7 545.28-.27-6.6-.61-13.17-.63-19.86v1.34c0 165.91 58.06 318.65 155.51 440.06 16.93-4.9 34.92-7.54 53.57-7.54 99.59 0 180.43 75.21 180.43 167.94 0 3.01-.08 6-.25 8.97 92.43 40.68 195.04 63.33 303.14 63.33 321.37 0 594.63-200.2 695.03-479.34-5.8 3.33-11.6 6.58-17.5 9.76l-7.5 5.24-.7-.9.7.9-621.78 431.48-.07.06-8.57 5.99-639.81-443.89 188.15-564.14a704.696 704.696 0 01-2.67-61.4c0-35.08 2.63-69.55 7.65-103.28m101.37 1156.92v.02c96 50.45 204.83 80.76 320.52 85.12-115.68-4.36-224.5-34.67-320.52-85.14m320.55 85.14c.41.01.82.03 1.23.04-.41-.01-.82-.03-1.23-.04m1.24.04c.42.02.83.03 1.24.05-.41-.02-.82-.03-1.24-.05M9673.51 6638.63l1.2.03-1.2-.03m2.75.06c.29 0 .59.01.89.01-.3 0-.59-.01-.89-.01m1.27.02c.28.01.58.01.85.02-.28-.01-.57-.01-.85-.02m1.27.02c.24.01.55.01.8.01-.26 0-.54 0-.8-.01m1.24.02c.27.01.52.01.8.01-.27 0-.54 0-.8-.01m1.25.02c.25 0 .5 0 .75.01-.25-.01-.5-.01-.75-.01m1.24.01c.25.01.5.01.75.01-.25 0-.5 0-.75-.01m1.24.02h.74-.74m1.23.01h.76-.76m1.23.01h.77-.77m1.23 0c.28 0 .54 0 .81.01-.28-.01-.53-.01-.81-.01m1.24.01h.88-.88m1.23 0h1.19-1.19"></path>
        </clipPath>
        <linearGradient
          id="linearGradient18409"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-1357.38 1357.38) rotate(-90 -1.205 5.935)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#d71f26" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#f7980f" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath18419" clipPathUnits="userSpaceOnUse">
          <path d="M10411.3 6071.61c-22 16.13-45 31.11-68.9 44.8-100.4 279.14-373.66 479.34-695.03 479.34-108.1 0-210.71-22.65-303.14-63.33-.4 7.03-1.26 13.96-2.56 20.73 96.02 50.47 204.84 80.78 320.52 85.14h.03c.41.01.82.03 1.23.04h.01c.42.02.83.03 1.24.05h.02c2.92.1 5.85.18 8.78.25h.01l1.2.03h.23c.33.01.67.02 1 .02.1 0 .21.01.32.01.3 0 .59.01.89.01.13.01.25.01.38.01.28.01.57.01.85.02h.42c.26.01.54.01.8.01.14.01.3.01.44.01.26.01.53.01.8.01.15 0 .29.01.45.01.25 0 .5 0 .75.01h.49c.25.01.5.01.75.01.17 0 .32 0 .49.01h.74c.16 0 .33.01.49.01h.76c.16 0 .31 0 .47.01h1.23c.28 0 .53 0 .81.01h3.86c353.77-.47 648.97-243.54 719.17-567.22"></path>
        </clipPath>
        <linearGradient
          id="linearGradient18425"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1280.94 0 0 -1280.94 9146.42 6018.63)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f7980f" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#d71f26" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath18435" clipPathUnits="userSpaceOnUse">
          <path d="M9801.17 5213.03c-21.49 16.27-46.54 28.07-73.75 34.02 252.81 11.93 472.08 147.89 594.88 346.61 63.2 102.14 100.9 220.85 104.6 347.85.2-6.58.4-13.13.5-19.79v-.8c0-53.14-6-104.94-17.3-154.78-65-286.87-307-509.12-608.93-553.11m-227.24 1.09c-295.7 46-532.62 263.2-599.8 543.83-10.68 44.59-17.07 90.78-18.73 138.14-.28 8.24-.43 16.53-.43 24.83v.73c.02 6.69.36 13.26.63 19.86 6.42-221.71 116.45-418.23 284.7-545.28 113.9-86.02 254.44-140.19 407.62-148.82-27.25-5.7-52.37-17.26-73.99-33.29"></path>
        </clipPath>
        <linearGradient
          id="linearGradient18441"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1472.38 0 0 -1472.38 8954.97 5573.3)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f6e604" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e64120" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath18459" clipPathUnits="userSpaceOnUse">
          <path d="M9901.76 4693.34c-51.25 0-133.47 15.57-173.65 72.84-24.27 34.61-33.44 71.17-31.48 105.78 90.59 4.62 164.62 73.05 177.93 161.12 9.91-1.08 19.88-3.27 29.79-6.67 131.15-45.08 116.75-188.52 38.92-209.01-9.27-2.44-17.89-3.51-25.91-3.51-59.29 0-84.73 58.84-84.73 58.84-4.75 1.93-8.74 2.83-12.06 2.83-42.46 0 28.83-147.74 112.47-166.75 28.64-6.51 7.59-15.47-31.28-15.47m-124.3 181.41c-21.45 0-58.16-38.52-38.95-81.83 26.87-60.63 111.22-92.78 160.1-92.79 2.11 0 4.14.06 6.11.18 0 0-125.53 84.27-114.28 146.61 3.55 19.65-3.1 27.83-12.98 27.83m140.57 90.91c-53.15 0-75.66-65.18-45.34-106.57 0 0 11.34-24.32 48.07-24.33 9.79 0 21.37 1.73 35.03 6.1 64.91 20.77 35.49 113.38-25.97 123.78-4.08.69-8.02 1.02-11.79 1.02"></path>
        </clipPath>
        <radialGradient
          id="radialGradient18467"
          cx="0"
          cy="0"
          r="1"
          fx="0"
          fy="0"
          gradientTransform="matrix(-249.961 0 0 249.961 9938.48 4872.89)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#eaec0d" stopOpacity="1"></stop>
          <stop offset="0.448" stopColor="#f8c608" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#f05b1a" stopOpacity="1"></stop>
        </radialGradient>
        <clipPath id="clipPath18477" clipPathUnits="userSpaceOnUse">
          <path d="M9920.76 4834.76c-36.73.01-48.07 24.33-48.07 24.33-30.32 41.39-7.81 106.57 45.34 106.57 3.77 0 7.71-.33 11.79-1.02 61.46-10.4 90.88-103.01 25.97-123.78-13.66-4.37-25.24-6.1-35.03-6.1"></path>
        </clipPath>
        <radialGradient
          id="radialGradient18485"
          cx="0"
          cy="0"
          r="1"
          fx="0"
          fy="0"
          gradientTransform="matrix(-249.961 0 0 249.961 9938.48 4872.89)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#eaec0d" stopOpacity="1"></stop>
          <stop offset="0.448" stopColor="#f5e005" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#f89d1a" stopOpacity="1"></stop>
        </radialGradient>
        <clipPath id="clipPath18497" clipPathUnits="userSpaceOnUse">
          <path d="M9898.61 4700.13c-48.88.01-133.23 32.16-160.1 92.79-19.21 43.31 17.5 81.83 38.95 81.83 9.88 0 16.53-8.18 12.98-27.83-11.25-62.34 114.28-146.61 114.28-146.61-1.97-.12-4-.18-6.11-.18"></path>
        </clipPath>
        <radialGradient
          id="radialGradient18505"
          cx="0"
          cy="0"
          r="1"
          fx="0"
          fy="0"
          gradientTransform="matrix(-249.961 0 0 249.961 9938.48 4872.89)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#eaec0d" stopOpacity="1"></stop>
          <stop offset="0.448" stopColor="#f5e005" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#f89d1a" stopOpacity="1"></stop>
        </radialGradient>
        <clipPath id="clipPath18521" clipPathUnits="userSpaceOnUse">
          <path d="M9471.92 4693.34c-38.87 0-59.91 8.96-31.27 15.47 54.96 12.49 104.58 80.55 120.11 125.77 8.03 7.65 15.28 16.01 21.63 24.97-.28-3.53-.03-7.72.86-12.63 11.25-62.34-114.28-146.61-114.28-146.61 1.97-.12 4-.18 6.11-.18 48.88 0 133.24 32.16 160.1 92.79 19.19 43.31-17.51 81.83-38.96 81.83-1.64 0-3.2-.23-4.63-.7a162.31 162.31 0 018.91 18.45c23.17-11.89 49.11-19.14 76.55-20.54 1.96-34.61-7.22-71.17-31.49-105.78-40.18-57.27-122.4-72.84-173.64-72.84"></path>
        </clipPath>
        <radialGradient
          id="radialGradient18529"
          cx="0"
          cy="0"
          r="1"
          fx="0"
          fy="0"
          gradientTransform="translate(9435.21 4872.89) scale(249.961)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#eaec0d" stopOpacity="1"></stop>
          <stop offset="0.448" stopColor="#f8c608" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#f05b1a" stopOpacity="1"></stop>
        </radialGradient>
        <clipPath id="clipPath18541" clipPathUnits="userSpaceOnUse">
          <path d="M9475.08 4700.13c-2.11 0-4.14.06-6.11.18 0 0 125.53 84.27 114.28 146.61-.89 4.91-1.14 9.1-.86 12.63 3.31 4.68 6.39 9.52 9.2 14.5 1.43.47 2.99.7 4.63.7 21.45 0 58.15-38.52 38.96-81.83-26.86-60.63-111.22-92.79-160.1-92.79"></path>
        </clipPath>
        <radialGradient
          id="radialGradient18549"
          cx="0"
          cy="0"
          r="1"
          fx="0"
          fy="0"
          gradientTransform="translate(9435.21 4872.89) scale(249.961)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#eaec0d" stopOpacity="1"></stop>
          <stop offset="0.448" stopColor="#f5e005" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#f89d1a" stopOpacity="1"></stop>
        </radialGradient>
        <clipPath id="clipPath18565" clipPathUnits="userSpaceOnUse">
          <path d="M9684.32 4924.1c-26.36 0-51.08 6.95-72.44 19.12.14 2.48.22 4.99.23 7.5 1.29-.81 2.58-1.6 3.89-2.37l.21-.12c8.19-4.77 16.93-8.71 26.1-11.7 13.14-4.29 27.15-6.64 41.72-6.64H9684.32c73.85 0 133.88 59.09 135.44 132.54v.08c.01.15.01.31.01.46v.12c.01.35.02.7.02 1.06V5065.37c0 47.7-24.63 89.64-61.86 113.78.19.37.39.74.58 1.1 9.04-5.65 17.38-12.3 24.89-19.8 25.32-25.32 40.96-60.25 40.96-98.89 0-38.62-15.63-73.53-40.93-98.86-26.08-23.96-60.87-38.6-99.11-38.6m-134.79 155.01c-1.13.91-2.28 1.81-3.44 2.69 4.43 30.53 18.7 57.84 39.52 78.65 23.65 23.65 55.69 38.86 91.3 40.76.09-.17.19-.35.29-.53-66.96-3.46-121.03-55.5-127.67-121.57m204.85 102.85c-20.17 11.93-43.62 18.91-68.79 18.91h-1.27c-1.54 0-3.07-.03-4.6-.08l-.44.53c1.73.06 3.47.1 5.22.1 25.63-.01 49.63-6.89 70.28-18.91l-.4-.55"></path>
        </clipPath>
        <linearGradient
          id="linearGradient18573"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-289.707 289.707) rotate(90 -25.2 -8.229)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#1a7d40" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#d0d710" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#d0d710" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath18587" clipPathUnits="userSpaceOnUse">
          <path d="M9684.5 4921.71c-26.63 0-51.51 7.44-72.69 20.35.03.39.05.77.07 1.16 21.36-12.17 46.08-19.12 72.44-19.12 38.24 0 73.03 14.64 99.11 38.6l-.03-.03c-25.33-25.31-60.26-40.96-98.9-40.96"></path>
        </clipPath>
        <linearGradient
          id="linearGradient18595"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-289.707 289.707) rotate(90 -25.2 -8.229)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#285337" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#848623" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#848623" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath18609" clipPathUnits="userSpaceOnUse">
          <path d="M9684.32 4929.89h-.16c25.01.03 48.36 6.96 68.47 18.79l-15.9 27.88c-15.45-9.18-33.42-14.55-52.7-14.55-18.89 0-36.56 5.16-51.79 14l.07.12a104.352 104.352 0 00-27.52 23.31c-4.91 15.52-12.16 30.1-21.37 43.39-1.62 7.25-2.47 14.8-2.47 22.54l.08 1.88-18.15-.03a175.59 175.59 0 01-13.35 11.89c6.64 66.07 60.71 118.11 127.67 121.57.01-.02.03-.05.04-.07-19.14-1.18-37.19-6.4-53.38-14.71l16.68-27.58c13.63 6.62 28.88 10.45 45.05 10.45 3.64 0 7.23-.19 10.77-.56 3.83-6.25 7.64-12.37 11.07-17.86a89.09 89.09 0 01-20.07 2.72c-.02 0-.04 0-.06.01h-.47c-.14.01-.29.01-.44.01H9685.79c-.13.01-.26.01-.39.01-48.96 0-88.76-39.32-89.48-88.13v-.02c0-.14-.01-.29-.01-.44v-.41-.08-.41-.33-.09-.08-.17-.14-.2c.01-.05.01-.1.01-.15v-.17-.05-.11c0-.09 0-.18.01-.27v-.25-.11c.01-.08.01-.16.01-.23v-.09c0-.08.01-.16.01-.24v-.06c.58-19.19 7.22-36.84 18.06-51.15 16.24-22.69 42.81-37.47 72.84-37.47 49.41 0 89.47 40.05 89.47 89.48 0 .95-.02 1.89-.04 2.84 2.48-2.86 4.08-4.69 4.41-5.03.03-.03.05-.04.06-.04.14 0-1.64 2.99-4.6 7.81-1.24 20.1-9.11 38.4-21.45 52.74-2.12 2.61-4.4 5.11-6.8 7.47v.06c-3.74 3.66-7.8 6.99-12.13 9.95 3.84 7.21 13.59 25.51 22.16 41.62 37.23-24.14 61.86-66.08 61.86-113.78l-.09 1.93-32.11.18.09-2.11c0-37.85-20.42-70.87-50.78-88.89l15.94-27.84c39.23 23.09 65.89 65.24 66.92 113.79-1.56-73.45-61.59-132.54-135.44-132.54m-42.01 6.64c-9.17 2.99-17.91 6.93-26.1 11.7 8.21-4.76 16.94-8.7 26.1-11.7m-26.31 11.82c-1.31.77-2.6 1.56-3.89 2.37 0 .05 0 .11.01.17 1.3-.83 2.62-1.63 3.96-2.41l-.08-.13m203.76 114.16c.01.15.01.31.01.46 0-.15 0-.31-.01-.46m.01.58c.01.35.02.7.02 1.06 0-.36-.01-.71-.02-1.06m.02 1.21v0m0 .54v0m-92.94 79.09l-18.47 22.28c9.6-2.19 18.69-5.72 27.09-10.37l-8.62-11.91m-47.09 56.81l-.04.05c1.53.05 3.06.08 4.6.08h.64c-1.74-.01-3.48-.05-5.2-.13"></path>
        </clipPath>
        <linearGradient
          id="linearGradient18617"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-289.707 289.707) rotate(90 -25.2 -8.229)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#00a650" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#dfe80a" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#dfe80a" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath18627" clipPathUnits="userSpaceOnUse">
          <path d="M9686.85 4972.25c-30.03 0-56.6 14.78-72.84 37.47a90.508 90.508 0 0122.72-21.13 90.185 90.185 0 00-12.22 11.46c3.46 19.27 12.1 46.28 33.02 70.79 10.16 11.93 24.05 21.03 39.03 27.97l-23.46-35.18c5.49 6.18 14.78 16.89 24.47 28.14l-27.27-116.26c4.92-.84 9.95-1.37 15.1-1.37 23.14 0 44.16 8.86 60.04 23.28l1.9 100.75c11.04-12.85 22.73-26.45 28.94-33.6.02-.95.04-1.89.04-2.84 0-49.43-40.06-89.48-89.47-89.48m89.3 95.06c-6.48 10.56-18.61 29.87-28.53 45.62l.04 2.07c3.3.68 6.5 1.28 9.56 1.82-.82 1.09-1.65 2.17-2.52 3.23 12.34-14.34 20.21-32.64 21.45-52.74"></path>
        </clipPath>
        <clipPath id="clipPath18639" clipPathUnits="userSpaceOnUse">
          <path d="M9754.08 5181.55c-20.2 12.16-43.84 19.2-69.12 19.32h.63c25.17 0 48.62-6.98 68.79-18.91l-.3-.41"></path>
        </clipPath>
        <linearGradient
          id="linearGradient18647"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-289.707 289.707) rotate(90 -25.2 -8.229)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#01a550" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#dce40b" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#dce40b" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath18657" clipPathUnits="userSpaceOnUse">
          <path d="M9735.47 5155.84c-8.4 4.65-17.49 8.18-27.09 10.37l-28.62 34.53c1.72.08 3.46.12 5.2.13 25.28-.12 48.92-7.16 69.12-19.32l-18.61-25.71m-94.93 2.48l-16.68 27.58c16.19 8.31 34.24 13.53 53.38 14.71 5.03-9.12 12.11-20.96 19.12-32.4-3.54.37-7.13.56-10.77.56-16.17 0-31.42-3.83-45.05-10.45"></path>
        </clipPath>
        <linearGradient
          id="linearGradient18665"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-289.707 289.707) rotate(90 -25.2 -8.229)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#03a74f" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#e6eb08" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e6eb08" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath18677" clipPathUnits="userSpaceOnUse">
          <path d="M9595.92 5062.23V5062.24v-.01m-.01.88v0m0 .91v0m0 .49s0 .01 0 0m.01.44v0m89.92 88.14h-.05.05"></path>
        </clipPath>
        <clipPath id="clipPath18689" clipPathUnits="userSpaceOnUse">
          <path d="M9595.92 5062.22v0m-.01.94v0m89.94 89.93h-.02.02m-.45.01"></path>
        </clipPath>
        <clipPath id="clipPath18701" clipPathUnits="userSpaceOnUse">
          <path d="M9685.4 4974.14c-5.15 0-10.18.53-15.1 1.37l27.27 116.26c3.36 3.91 6.77 7.87 10.09 11.73 9.25 3.57 18.67 6.42 27.66 8.68 3.68-4.29 7.81-9.1 12.02-14.01l-1.9-100.75c-15.88-14.42-36.9-23.28-60.04-23.28m62.22 138.79c-.38.61-.77 1.22-1.15 1.82.4.09.8.17 1.19.25l-.04-2.07"></path>
        </clipPath>
        <clipPath id="clipPath18713" clipPathUnits="userSpaceOnUse">
          <path d="M9747.9 5127.52c-3.74 3.67-7.8 7.01-12.14 9.98 0 .01.01.02.01.03 4.33-2.96 8.39-6.29 12.13-9.95v-.06"></path>
        </clipPath>
        <clipPath id="clipPath18725" clipPathUnits="userSpaceOnUse">
          <path d="M9595.95 5060.87v0m-.01.3v0m-.01.32v0m0 .36c-.01.09-.01.18-.01.27 0-.09 0-.18.01-.27m-.01.43V5062.29v-.01m-.01.32v0m0 .34v0m0 .34v0m111.53 87.06a89.105 89.105 0 01-20.08 2.73 89.09 89.09 0 0020.07-2.72l.01-.01m-20.14 2.74h-.41.41m-.47 0c-.07.01-.14.01-.21.01h-.23c.15 0 .3 0 .44-.01m-.52.01h-.36.36m-.52 0c-.13.01-.26.01-.39.01.13 0 .26 0 .39-.01"></path>
        </clipPath>
        <clipPath id="clipPath18737" clipPathUnits="userSpaceOnUse">
          <path d="M9624.51 5000.05a89.653 89.653 0 00-10.07 13.82l94.07 133.2c.38-.07.75-.15 1.12-.22.21-.34.42-.67.62-.99l-9.59-40.91-4.1-6.14c-14.98-6.94-28.87-16.04-39.03-27.97-20.92-24.51-29.56-51.52-33.02-70.79m15.81 132.54a88.79 88.79 0 008.05 5.02l-8.05-5.02"></path>
        </clipPath>
        <clipPath id="clipPath18749" clipPathUnits="userSpaceOnUse">
          <path d="M9624.23 4998.44c-16.77 15.74-27.53 37.79-28.28 62.43v.06c0 .08-.01.16-.01.24v.09c0 .07 0 .15-.01.23v.36c-.01.09-.01.18-.01.27v.1c.29-18.92 6.53-36.38 16.84-50.73l1.68 2.38c2.92-4.93 6.29-9.56 10.07-13.82-.1-.54-.19-1.08-.28-1.61m-28.31 63.85v.16c0 .05 0 .1-.01.15v.05c.01-.12.01-.24.01-.36m-.01.47V5062.76m0 .45v0m0 .4v0m0 .49v0m0 .41c0 .15.01.3.01.44 0-.14-.01-.29-.01-.44m.01.46c.72 48.81 40.52 88.13 89.48 88.13-4.82 0-9.51-.48-14.14-1.22l-22.89-14.27a88.79 88.79 0 01-8.05-5.02l-27.99-17.43c-10.07-14.24-16.13-31.49-16.41-50.19m113.71 81.88c-.37.07-.74.15-1.12.22l.52.73c.2-.32.4-.64.6-.95m-2.15 3.43c-6.7 1.72-13.66 2.71-20.86 2.81.07 0 .14 0 .21-.01h.47c.02-.01.04-.01.06-.01 6.92-.15 13.64-1.09 20.08-2.73a.21.21 0 01.04-.06m-20.89 2.81h-.34.34m-.52 0h-.22.22"></path>
        </clipPath>
        <clipPath id="clipPath18761" clipPathUnits="userSpaceOnUse">
          <path d="M9614.44 5013.87c-7.86 13.29-12.38 28.78-12.38 45.35 0 30.36 15.13 57.2 38.26 73.37l8.05 5.02c12.8 7.06 27.51 11.08 43.16 11.08 5.81 0 11.49-.56 16.98-1.62l-94.07-133.2"></path>
        </clipPath>
        <clipPath id="clipPath18773" clipPathUnits="userSpaceOnUse">
          <path d="M9595.92 5062.24v0m-.01.41v0m0 .43v0m90.71 90.01h-.03.03m-.37 0h-.18.18m-.42 0c-.14 0-.29.01-.43.01.13 0 .26 0 .39-.01h.04"></path>
        </clipPath>
        <clipPath id="clipPath18785" clipPathUnits="userSpaceOnUse">
          <path d="M9612.76 5011.49c-10.31 14.35-16.55 31.81-16.84 50.73v.07c0 .12 0 .24-.01.36v1.86c0 .01 0 0 0 0 0 .15.01.3.01.44v.02c.28 18.7 6.34 35.95 16.41 50.19l27.99 17.43c-23.13-16.17-38.26-43.01-38.26-73.37 0-16.57 4.52-32.06 12.38-45.35l-1.68-2.38m35.61 126.12l22.89 14.27c4.63.74 9.32 1.22 14.14 1.22.14 0 .29-.01.43-.01h.79c7.2-.1 14.16-1.09 20.86-2.81.52-.84 1.04-1.67 1.55-2.48l-.52-.73a89.53 89.53 0 01-16.98 1.62c-15.65 0-30.36-4.02-43.16-11.08"></path>
        </clipPath>
        <clipPath id="clipPath18797" clipPathUnits="userSpaceOnUse">
          <path d="M9754.7 5120.05a87.7 87.7 0 01-6.81 7.09l.01.38c2.4-2.36 4.68-4.86 6.8-7.47"></path>
        </clipPath>
        <clipPath id="clipPath18809" clipPathUnits="userSpaceOnUse">
          <path d="M9747.66 5115l.23 12.14a87.7 87.7 0 006.81-7.09c.87-1.06 1.7-2.14 2.52-3.23-3.06-.54-6.26-1.14-9.56-1.82"></path>
        </clipPath>
        <clipPath id="clipPath18821" clipPathUnits="userSpaceOnUse">
          <path d="M9707.66 5103.5c6.58 7.67 12.8 14.93 17.55 20.48 2.52-2.95 6.05-7.06 10.11-11.8-8.99-2.26-18.41-5.11-27.66-8.68m-7 1.45l9.59 40.91c3.65-5.81 6.7-10.6 8.62-13.61l-18.21-27.3"></path>
        </clipPath>
        <clipPath id="clipPath18833" clipPathUnits="userSpaceOnUse">
          <path d="M9747.89 5127.14c-3.85 3.6-8.02 6.86-12.46 9.74.03.07.07.13.1.2 1.59-.9 3.15-1.85 4.68-2.84a95.896 95.896 0 01-4.46 3.25l.01.01c4.34-2.97 8.4-6.31 12.14-9.98l-.01-.38"></path>
        </clipPath>
        <clipPath id="clipPath18845" clipPathUnits="userSpaceOnUse">
          <path d="M9746.47 5114.75c-5.28 8.39-9.83 15.59-12.38 19.63.01.01.49.91 1.34 2.5 4.44-2.88 8.61-6.14 12.46-9.74l-.23-12.14c-.39-.08-.79-.16-1.19-.25"></path>
        </clipPath>
        <clipPath id="clipPath18857" clipPathUnits="userSpaceOnUse">
          <path d="M9740.21 5134.24c-1.53.99-3.09 1.94-4.68 2.84.07.13.15.27.22.41 1.52-1.04 3.01-2.13 4.46-3.25"></path>
        </clipPath>
        <clipPath id="clipPath18869" clipPathUnits="userSpaceOnUse">
          <path d="M9684.03 4929.89c-14.57 0-28.58 2.35-41.72 6.64 13.18-4.29 27.24-6.62 41.85-6.64h-.13m-67.82 18.34l-.21.12.21-.12"></path>
        </clipPath>
        <linearGradient
          id="linearGradient18877"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-289.707 289.707) rotate(90 -25.2 -8.229)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#24633b" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#a3a521" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#a3a521" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath18887" clipPathUnits="userSpaceOnUse">
          <path d="M9684.16 4929.89c-14.61.02-28.67 2.35-41.85 6.64-9.16 3-17.89 6.94-26.1 11.7l-.21.12.08.13c.07-.04.14-.09.22-.13l15.94 27.66c15.23-8.84 32.9-14 51.79-14 19.28 0 37.25 5.37 52.7 14.55l15.9-27.88c-20.11-11.83-43.46-18.76-68.47-18.79"></path>
        </clipPath>
        <linearGradient
          id="linearGradient18895"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-289.707 289.707) rotate(90 -25.2 -8.229)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#128846" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#aeb41d" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#aeb41d" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath18905" clipPathUnits="userSpaceOnUse">
          <path d="M9819.76 5062.43v0m.01.54v0m.02 1.18v0m0 .54v0"></path>
        </clipPath>
        <linearGradient
          id="linearGradient18913"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-289.707 289.707) rotate(90 -25.2 -8.229)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#206d3c" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#b5ba1b" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#b5ba1b" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath18923" clipPathUnits="userSpaceOnUse">
          <path d="M9752.84 4948.64l-15.94 27.84c30.36 18.02 50.78 51.04 50.78 88.89l-.09 2.11 32.11-.18.09-1.93v-.53-.15-.39-.15c0-.36-.01-.71-.02-1.06v-.12c0-.15 0-.31-.01-.46v-.08c-1.03-48.55-27.69-90.7-66.92-113.79"></path>
        </clipPath>
        <linearGradient
          id="linearGradient18931"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-289.707 289.707) rotate(90 -25.2 -8.229)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#069a4d" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#c3cb15" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#c3cb15" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath18941" clipPathUnits="userSpaceOnUse">
          <path d="M9616.08 4948.48c-1.34.78-2.66 1.58-3.96 2.41v1.01c0 16.52-2.56 32.47-7.33 47.54 7.72-9.27 17.03-17.18 27.52-23.31l-.07-.12c-.08.05-.17.1-.26.15l-15.9-27.68m-32.66 94.35a170.859 170.859 0 01-20.54 24.39l18.15.03-.08-1.88c0-7.74.85-15.29 2.47-22.54"></path>
        </clipPath>
        <linearGradient
          id="linearGradient18949"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-289.707 289.707) rotate(90 -25.2 -8.229)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#01a34f" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#ccd412" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#ccd412" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath18959" clipPathUnits="userSpaceOnUse">
          <path d="M9616.3 4948.35c-.08.04-.15.09-.22.13l15.9 27.68c.09-.05.18-.1.26-.15l-15.94-27.66"></path>
        </clipPath>
        <linearGradient
          id="linearGradient18967"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-289.707 289.707) rotate(90 -25.2 -8.229)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#1b7b3f" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#9fa322" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#9fa322" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath18977" clipPathUnits="userSpaceOnUse">
          <path d="M9780.75 5059.5c-.01 0-.03.01-.06.04-.33.34-1.93 2.17-4.41 5.03-.03.91-.08 1.83-.13 2.74 2.96-4.82 4.74-7.81 4.6-7.81"></path>
        </clipPath>
        <linearGradient
          id="linearGradient18985"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-289.707 289.707) rotate(90 -25.2 -8.229)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#9edca2" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#f3f7a5" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#f3f7a5" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath18995" clipPathUnits="userSpaceOnUse">
          <path d="M9776.28 5064.57c-6.21 7.15-17.9 20.75-28.94 33.6l.28 14.76c9.92-15.75 22.05-35.06 28.53-45.62.05-.91.1-1.83.13-2.74"></path>
        </clipPath>
        <clipPath id="clipPath19007" clipPathUnits="userSpaceOnUse">
          <path d="M9747.34 5098.17c-4.21 4.91-8.34 9.72-12.02 14.01 3.81.96 7.54 1.81 11.15 2.57.38-.6.77-1.21 1.15-1.82l-.28-14.76"></path>
        </clipPath>
        <clipPath id="clipPath19019" clipPathUnits="userSpaceOnUse">
          <path d="M9735.32 5112.18c-4.06 4.74-7.59 8.85-10.11 11.8l8.88 10.4c2.55-4.04 7.1-11.24 12.38-19.63-3.61-.76-7.34-1.61-11.15-2.57"></path>
        </clipPath>
        <clipPath id="clipPath19031" clipPathUnits="userSpaceOnUse">
          <path d="M9677.2 5200.68c-.1.18-.2.36-.29.53.79.05 1.57.08 2.37.11l.44-.53c-.84-.03-1.69-.06-2.52-.11"></path>
        </clipPath>
        <linearGradient
          id="linearGradient19039"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-289.707 289.707) rotate(90 -25.2 -8.229)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#a2dda7" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#eff4a5" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#eff4a5" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath19053" clipPathUnits="userSpaceOnUse">
          <path d="M9726.3 5143.18c-1.32.68-2.66 1.32-4.01 1.94a88.688 88.688 0 01-14.86 5.23c-3.43 5.49-7.24 11.61-11.07 17.86 4.09-.43 8.1-1.1 12.02-2l18.47-22.28-.55-.75m-49.06 57.43c-.01.02-.03.05-.04.07.83.05 1.68.08 2.52.11l.04-.05c-.85-.03-1.68-.08-2.52-.13"></path>
        </clipPath>
        <clipPath id="clipPath19071" clipPathUnits="userSpaceOnUse">
          <path d="M9708.38 5166.21c-3.92.9-7.93 1.57-12.02 2-7.01 11.44-14.09 23.28-19.12 32.4.84.05 1.67.1 2.52.13l28.62-34.53"></path>
        </clipPath>
        <linearGradient
          id="linearGradient19079"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-289.707 289.707) rotate(90 -25.2 -8.229)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#9edb9f" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#f4f7a6" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#f4f7a6" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath19089" clipPathUnits="userSpaceOnUse">
          <path d="M9726.3 5143.17c-1.32.68-2.66 1.33-4.01 1.95 1.35-.62 2.69-1.26 4.01-1.94v-.01"></path>
        </clipPath>
        <clipPath id="clipPath19101" clipPathUnits="userSpaceOnUse">
          <path d="M9722.29 5145.12c-2.21 1-4.47 1.91-6.77 2.74a87.83 87.83 0 01-8.08 2.48l-.01.01a88.688 88.688 0 0014.86-5.23"></path>
        </clipPath>
        <clipPath id="clipPath19113" clipPathUnits="userSpaceOnUse">
          <path d="M9710.25 5145.86c-.2.32-.41.65-.62.99l.81-.18-.19-.81"></path>
        </clipPath>
        <clipPath id="clipPath19125" clipPathUnits="userSpaceOnUse">
          <path d="M9710.44 5146.67l-.81.18c-.2.31-.4.63-.6.95l1.21 1.72c-.91.27-1.84.52-2.76.76-.02.02-.03.04-.04.06 2.75-.7 5.44-1.53 8.08-2.48-1.47.52-2.95 1.01-4.46 1.46l-.62-2.65"></path>
        </clipPath>
        <clipPath id="clipPath19137" clipPathUnits="userSpaceOnUse">
          <path d="M9709.03 5147.8c-.51.81-1.03 1.64-1.55 2.48.92-.24 1.85-.49 2.76-.76l-1.21-1.72"></path>
        </clipPath>
        <clipPath id="clipPath19149" clipPathUnits="userSpaceOnUse">
          <path d="M9726.29 5143.15c-3.47 1.8-7.06 3.37-10.77 4.71 2.3-.83 4.56-1.74 6.77-2.74 1.35-.62 2.69-1.27 4.01-1.95l-.01-.02"></path>
        </clipPath>
        <clipPath id="clipPath19161" clipPathUnits="userSpaceOnUse">
          <path d="M9718.87 5132.25c-1.92 3.01-4.97 7.8-8.62 13.61l.19.81c5.19-1.12 10.2-2.69 15.01-4.67l-1.01-1.39-5.57-8.36"></path>
        </clipPath>
        <clipPath id="clipPath19173" clipPathUnits="userSpaceOnUse">
          <path d="M9725.45 5142a88.357 88.357 0 01-15.01 4.67l.62 2.65c1.51-.45 2.99-.94 4.46-1.46 3.71-1.34 7.3-2.91 10.77-4.71l-.84-1.15"></path>
        </clipPath>
        <clipPath id="clipPath19185" clipPathUnits="userSpaceOnUse">
          <path d="M9673.1 5063.63l23.46 35.18c.99.46 1.98.91 2.97 1.34l-1.96-8.38c-9.69-11.25-18.98-21.96-24.47-28.14"></path>
        </clipPath>
        <clipPath id="clipPath19197" clipPathUnits="userSpaceOnUse">
          <path d="M9697.57 5091.77l1.96 8.38c2.69 1.19 5.4 2.3 8.13 3.35-3.32-3.86-6.73-7.82-10.09-11.73"></path>
        </clipPath>
        <clipPath id="clipPath19209" clipPathUnits="userSpaceOnUse">
          <path d="M9696.56 5098.81l4.1 6.14-1.13-4.8c-.99-.43-1.98-.88-2.97-1.34"></path>
        </clipPath>
        <clipPath id="clipPath19221" clipPathUnits="userSpaceOnUse">
          <path d="M9699.53 5100.15l1.13 4.8 18.21 27.3c1.41-2.21 2.21-3.46 2.21-3.46s1.54-1.8 4.13-4.81c-4.75-5.55-10.97-12.81-17.55-20.48-2.73-1.05-5.44-2.16-8.13-3.35"></path>
        </clipPath>
        <clipPath id="clipPath19235" clipPathUnits="userSpaceOnUse">
          <path d="M9757.93 5179.15c-1.2.77-2.41 1.54-3.63 2.27l.26.44c-.06.03-.12.07-.18.1l.4.55c1.25-.74 2.5-1.49 3.73-2.26-.19-.36-.39-.73-.58-1.1"></path>
        </clipPath>
        <clipPath id="clipPath19257" clipPathUnits="userSpaceOnUse">
          <path d="M9735.77 5137.53a91.846 91.846 0 01-7.36 4.53l-1.56 1.87 8.62 11.91c.61-.34 1.22-.68 1.83-1.03h.79l16.21 26.61c1.22-.73 2.43-1.5 3.63-2.27-8.57-16.11-18.32-34.41-22.16-41.62"></path>
        </clipPath>
        <clipPath id="clipPath19275" clipPathUnits="userSpaceOnUse">
          <path d="M9754.3 5181.42c-.08.05-.14.09-.22.13l.3.41c.06-.03.12-.07.18-.1l-.26-.44"></path>
        </clipPath>
        <linearGradient
          id="linearGradient19283"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-289.707 289.707) rotate(90 -25.2 -8.229)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#9fdca3" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#f1f6a5" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#f1f6a5" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath19293" clipPathUnits="userSpaceOnUse">
          <path d="M9738.09 5154.81h-.79c-.61.35-1.22.69-1.83 1.03l18.61 25.71c.08-.04.14-.08.22-.13l-16.21-26.61"></path>
        </clipPath>
        <clipPath id="clipPath19311" clipPathUnits="userSpaceOnUse">
          <path d="M9735.76 5137.5a88.519 88.519 0 01-7.33 4.53l-.02.03c2.53-1.4 4.99-2.91 7.36-4.53 0-.01-.01-.02-.01-.03"></path>
        </clipPath>
        <clipPath id="clipPath19323" clipPathUnits="userSpaceOnUse">
          <path d="M9735.43 5136.88c-1.09.7-2.19 1.38-3.31 2.04 1.15-.59 2.29-1.2 3.41-1.84-.03-.07-.07-.13-.1-.2m.32.61a91.838 91.838 0 01-7.28 4.5l-.04.04c2.52-1.4 4.97-2.9 7.33-4.53l-.01-.01"></path>
        </clipPath>
        <clipPath id="clipPath19335" clipPathUnits="userSpaceOnUse">
          <path d="M9734.09 5134.38c-1.39 2.2-2.19 3.46-2.19 3.46l-1.67 2.02c.63-.31 1.26-.62 1.89-.94 1.12-.66 2.22-1.34 3.31-2.04-.85-1.59-1.33-2.49-1.34-2.5"></path>
        </clipPath>
        <clipPath id="clipPath19347" clipPathUnits="userSpaceOnUse">
          <path d="M9735.53 5137.08c-1.12.64-2.26 1.25-3.41 1.84-.63.32-1.26.63-1.89.94l-1.76 2.13c2.5-1.39 4.93-2.89 7.28-4.5-.07-.14-.15-.28-.22-.41"></path>
        </clipPath>
        <clipPath id="clipPath19359" clipPathUnits="userSpaceOnUse">
          <path d="M9728.41 5142.06c-.7.38-1.4.75-2.11 1.12l.55.75 1.56-1.87"></path>
        </clipPath>
        <linearGradient
          id="linearGradient19367"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-289.707 289.707) rotate(90 -25.2 -8.229)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#e4f5e1" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#fbfce5" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#fbfce5" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath19377" clipPathUnits="userSpaceOnUse">
          <path d="M9728.43 5142.03c-.7.39-1.41.77-2.13 1.14v.01c.71-.37 1.41-.74 2.11-1.12l.02-.03"></path>
        </clipPath>
        <clipPath id="clipPath19389" clipPathUnits="userSpaceOnUse">
          <path d="M9728.47 5141.99c-.72.39-1.45.78-2.18 1.16l.01.02c.72-.37 1.43-.75 2.13-1.14l.04-.04"></path>
        </clipPath>
        <clipPath id="clipPath19401" clipPathUnits="userSpaceOnUse">
          <path d="M9725.21 5123.98c-2.59 3.01-4.13 4.81-4.13 4.81s-.8 1.25-2.21 3.46l5.57 8.36 1.01 1.39c1.62-.67 3.21-1.38 4.78-2.14l1.67-2.02s.8-1.26 2.19-3.46l-8.88-10.4"></path>
        </clipPath>
        <clipPath id="clipPath19413" clipPathUnits="userSpaceOnUse">
          <path d="M9730.23 5139.86c-1.57.76-3.16 1.47-4.78 2.14l.84 1.15c.73-.38 1.46-.77 2.18-1.16l1.76-2.13"></path>
        </clipPath>
        <clipPath id="clipPath19451" clipPathUnits="userSpaceOnUse">
          <path d="M9456.32 4796.58c-9.83 0-20.02 1.37-30.31 4.08-24.82 6.53-45.18 23.59-57.86 46.73 4.1 4.77 8.18 9.52 12.2 14.2 9.84-21.58 27.21-38.18 50.05-44.19 9.27-2.44 17.89-3.51 25.91-3.51 59.3.01 84.76 58.84 84.76 58.84 4.74 1.93 8.74 2.83 12.05 2.83 14.56 0 15.74-17.38 7.64-40.98-8.87-8.45-18.69-16.03-29.29-22.6 8.41 15.08 13 27.27 15.24 35.91-12.19-17.91-35.7-43.59-73.04-49.88-5.48-.92-11.26-1.43-17.35-1.43"></path>
        </clipPath>
        <clipPath id="clipPath19463" clipPathUnits="userSpaceOnUse">
          <path d="M9456.31 4813.89c-8.02 0-16.64 1.07-25.91 3.51-22.84 6.01-40.21 22.61-50.05 44.19 1.81 2.11 3.61 4.2 5.4 6.28 5.36-11.93 15.74-21.76 32.15-27.01 13.66-4.37 25.24-6.1 35.03-6.1 36.73 0 48.08 24.33 48.08 24.33 28.52 38.96 10.25 99-36.32 105.91 7.52 14.12 20.39 38.26 34.85 65.42 9.98-60.23 48.4-110.98 100.96-137.92a162.31 162.31 0 00-8.91-18.45c-5.03-1.64-8.56-6.26-9.2-14.5-6.35-8.96-13.6-17.32-21.63-24.97 8.1 23.6 6.92 40.98-7.64 40.98-3.31 0-7.31-.9-12.05-2.83 0 0-25.46-58.83-84.76-58.84"></path>
        </clipPath>
        <clipPath id="clipPath19475" clipPathUnits="userSpaceOnUse">
          <path d="M9452.93 4834.76c-9.79 0-21.37 1.73-35.03 6.1-16.41 5.25-26.79 15.08-32.15 27.01 39.32 45.8 71.95 84.03 71.95 84.03s2.58 4.83 6.99 13.1c46.57-6.91 64.84-66.95 36.32-105.91 0 0-11.35-24.33-48.08-24.33m-26.7 65.37c-6.35 0-12.06-1.69-16.12-5.6-19.29-18.53 12.29-51.49 38.57-51.49 4.4 0 8.66.93 12.5 3 35.97 19.45-6.17 54.09-34.95 54.09"></path>
        </clipPath>
        <clipPath id="clipPath19487" clipPathUnits="userSpaceOnUse">
          <path d="M9448.68 4843.04c-26.28 0-57.86 32.96-38.57 51.49 4.06 3.91 9.77 5.6 16.12 5.6 28.78 0 70.92-34.64 34.95-54.09-3.84-2.07-8.1-3-12.5-3"></path>
        </clipPath>
        <clipPath id="clipPath19499" clipPathUnits="userSpaceOnUse">
          <path d="M9582.39 4859.55c.64 8.24 4.17 12.86 9.2 14.5a168.74 168.74 0 00-9.2-14.5"></path>
        </clipPath>
        <clipPath id="clipPath19511" clipPathUnits="userSpaceOnUse">
          <path d="M9600.5 4892.5c-52.56 26.94-90.98 77.69-100.96 137.92 10.47 19.67 21.78 40.92 32.51 61.1 1.68-1.05 3.33-2.12 4.97-3.22-1.56-8.67-2.38-17.61-2.38-26.74 0-55.95 30.67-104.73 76.11-130.47a157.574 157.574 0 00-10.25-38.59"></path>
        </clipPath>
        <clipPath id="clipPath19523" clipPathUnits="userSpaceOnUse">
          <path d="M9611.88 4943.22c-7.85 4.48-15.25 9.66-22.11 15.46-1.42 1.3-2.8 2.63-4.16 3.99-25.32 25.33-40.97 60.26-40.97 98.89 0 6.88.49 13.64 1.45 20.24 1.16-.88 2.31-1.78 3.44-2.69-.46-4.52-.69-9.1-.69-13.74v-.53-.15-.4-.14c.01-.36.01-.72.02-1.08v-.1c0-.16.01-.32.01-.47v-.08l.03-1.13v-.01c1.38-46.57 26.27-87.25 63.21-110.56-.01-2.51-.09-5.02-.23-7.5"></path>
        </clipPath>
        <clipPath id="clipPath19535" clipPathUnits="userSpaceOnUse">
          <path d="M9610.75 4931.09c-45.44 25.74-76.11 74.52-76.11 130.47 0 9.13.82 18.07 2.38 26.74.79-.52 1.57-1.06 2.35-1.6-1.18-7.52-1.8-15.23-1.8-23.09 0-54.47 29.69-102.02 73.78-127.33-.18-1.74-.38-3.47-.6-5.19m-20.98 27.59c-30.06 25.41-49.74 62.7-51.88 104.63.37 7.65 1.33 15.15 2.83 22.45 1.82-1.29 3.61-2.61 5.37-3.96-.96-6.6-1.45-13.36-1.45-20.24 0-38.63 15.65-73.56 40.97-98.89 1.36-1.36 2.74-2.69 4.16-3.99"></path>
        </clipPath>
        <clipPath id="clipPath19547" clipPathUnits="userSpaceOnUse">
          <path d="M9537.89 5063.31c-.07 1.3-.11 2.61-.15 3.92-.01-1.21-.17-2.4-.17-3.62 0 7.86.62 15.57 1.8 23.09.45-.31.9-.63 1.35-.94-1.5-7.3-2.46-14.8-2.83-22.45"></path>
        </clipPath>
        <clipPath id="clipPath19559" clipPathUnits="userSpaceOnUse">
          <path d="M9611.81 4942.06a140.199 140.199 0 00-22.04 16.62c6.86-5.8 14.26-10.98 22.11-15.46a45.1 45.1 0 00-.07-1.16"></path>
        </clipPath>
        <clipPath id="clipPath19571" clipPathUnits="userSpaceOnUse">
          <path d="M9611.35 4936.28c-44.09 25.31-73.78 72.86-73.78 127.33 0-1.26.16-2.49.19-3.75.03 1.16.08 2.31.13 3.45 2.14-41.93 21.82-79.22 51.88-104.63 6.77-6.24 14.15-11.81 22.04-16.62-.12-1.94-.27-3.87-.46-5.78"></path>
        </clipPath>
        <clipPath id="clipPath19583" clipPathUnits="userSpaceOnUse">
          <path d="M9537.76 5059.86c-.03 1.26-.19 2.49-.19 3.75 0 1.22.16 2.41.17 3.62.04-1.31.08-2.62.15-3.92-.05-1.14-.1-2.29-.13-3.45"></path>
        </clipPath>
        <clipPath id="clipPath19595" clipPathUnits="userSpaceOnUse">
          <path d="M9612.11 4950.72c-36.94 23.31-61.83 63.99-63.21 110.56 1.39-46.54 26.3-87.09 63.22-110.39-.01-.06-.01-.12-.01-.17m-7.32 48.72c-10.29 12.37-17.74 27.15-21.37 43.39 9.21-13.29 16.46-27.87 21.37-43.39m-55.89 61.85l-.03 1.13.03-1.13m-.03 1.21c0 .15-.01.31-.01.47 0-.16.01-.32.01-.47m-.01.57c-.01.36-.01.72-.02 1.08.01-.36.01-.72.02-1.08m-.02 1.22v0m0 .55v0m0 .53c0 4.64.23 9.22.69 13.74 4.66-3.75 9.12-7.71 13.35-11.89l-13.97-.01-.07-1.84"></path>
        </clipPath>
        <clipPath id="clipPath19607" clipPathUnits="userSpaceOnUse">
          <path d="M9548.9 5061.28v0m-.03 1.14v0m-.01.55v0m-.02 1.18v0m0 .54v0"></path>
        </clipPath>
        <clipPath id="clipPath19619" clipPathUnits="userSpaceOnUse">
          <path d="M9612.12 4950.89c-36.92 23.3-61.83 63.85-63.22 110.39v.01l-.03 1.13v.08c0 .15-.01.31-.01.47v.1c-.01.36-.01.72-.02 1.08V5065.37l.07 1.84 13.97.01c7.62-7.51 14.5-15.67 20.54-24.39 3.63-16.24 11.08-31.02 21.37-43.39 4.77-15.07 7.33-31.02 7.33-47.54v-1.01"></path>
        </clipPath>
        <clipPath id="clipPath19667" clipPathUnits="userSpaceOnUse">
          <path d="M9413.82 5017.47c-12.31 3.53-24.56 7.3-36.66 11.29a972.923 972.923 0 00-38.58 13.62 962.224 962.224 0 00-44.56 18.04c17.94 19.74 40.69 35.56 66.56 45.91a914.45 914.45 0 01135.38-40.16c-4.42-6.13-8.82-12.21-13.12-18.15-6.45-1.33-12.83-3.08-19.12-5.24-19.58-6.73-36.1-15.37-49.9-25.31"></path>
        </clipPath>
        <clipPath id="clipPath19679" clipPathUnits="userSpaceOnUse">
          <path d="M9501.35 5102.14c-24.02 5-47.69 10.93-70.95 17.75.43.01.86.01 1.29.01 25.07 0 48.96-4.77 70.67-13.38-.36-1.46-.69-2.92-1.01-4.38"></path>
        </clipPath>
        <clipPath id="clipPath19691" clipPathUnits="userSpaceOnUse">
          <path d="M9495.96 5066.17a914.45 914.45 0 00-135.38 40.16c21.44 8.58 45.04 13.4 69.82 13.56a914.694 914.694 0 0170.95-17.75 189.473 189.473 0 01-4.27-34.43c-.37-.52-.74-1.03-1.12-1.54"></path>
        </clipPath>
        <clipPath id="clipPath19703" clipPathUnits="userSpaceOnUse">
          <path d="M9359.12 4868.97c-2.96 9.8-4.72 20.25-5.13 31.15-1.4 38.38 14.62 84.8 59.83 117.35 13.8 9.94 30.32 18.58 49.9 25.31 6.29 2.16 12.67 3.91 19.12 5.24l-16.35-22.62c-75.43-27.19-101.33-87.44-94.1-136.54l-13.27-19.89"></path>
        </clipPath>
        <clipPath id="clipPath19715" clipPathUnits="userSpaceOnUse">
          <path d="M9372.39 4888.86c-7.23 49.1 18.67 109.35 94.1 136.54-22.29-30.84-38.94-53.9-38.94-53.9l-12.74-19.09c-16.23-11.59-27.61-29.41-31.78-47.61l-10.64-15.94"></path>
        </clipPath>
        <clipPath id="clipPath19727" clipPathUnits="userSpaceOnUse">
          <path d="M9383.03 4904.8c4.17 18.2 15.55 36.02 31.78 47.61l-31.78-47.61"></path>
        </clipPath>
        <clipPath id="clipPath19739" clipPathUnits="userSpaceOnUse">
          <path d="M9497.08 5067.71c.38 11.78 1.83 23.28 4.27 34.43.32 1.46.65 2.92 1.01 4.38a187.08 187.08 0 0017.13-7.83c-7.36-10.17-14.93-20.63-22.41-30.98"></path>
        </clipPath>
        <clipPath id="clipPath19753" clipPathUnits="userSpaceOnUse">
          <path d="M9287.41 4754.07l4.76 14.59 32.21 48.26c3.67-2.53 7.44-4.93 11.31-7.2-17.54-20.33-34.34-39.71-48.28-55.65"></path>
        </clipPath>
        <radialGradient
          id="radialGradient19761"
          cx="0"
          cy="0"
          r="1"
          fx="0"
          fy="0"
          gradientTransform="matrix(1933.26 0 0 -1689.56 9691.48 5852.54)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#abd4aa" stopOpacity="1"></stop>
          <stop offset="0.461" stopColor="#b0ccac" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#b5b5b1" stopOpacity="1"></stop>
        </radialGradient>
        <clipPath id="clipPath19775" clipPathUnits="userSpaceOnUse">
          <path d="M9335.69 4809.72c-3.87 2.27-7.64 4.67-11.31 7.2l34.74 52.05c2.31-7.63 5.34-14.87 9.03-21.58-10.78-12.53-21.76-25.28-32.46-37.67"></path>
        </clipPath>
        <clipPath id="clipPath19787" clipPathUnits="userSpaceOnUse">
          <path d="M9482.84 5048.02c4.3 5.94 8.7 12.02 13.12 18.15l1.07-.23a191.457 191.457 0 01.28-15.65c-4.85-.52-9.68-1.28-14.47-2.27"></path>
        </clipPath>
        <clipPath id="clipPath19799" clipPathUnits="userSpaceOnUse">
          <path d="M9497.03 5065.94l-1.07.23c.38.51.75 1.02 1.12 1.54-.02-.59-.03-1.18-.05-1.77"></path>
        </clipPath>
        <clipPath id="clipPath19811" clipPathUnits="userSpaceOnUse">
          <path d="M9368.15 4847.39c-3.69 6.71-6.72 13.95-9.03 21.58l13.27 19.89c1.42-9.63 4.12-18.83 7.96-27.27-4.02-4.68-8.1-9.43-12.2-14.2m98.34 178.01l16.35 22.62c4.79.99 9.62 1.75 14.47 2.27.35-5.81.95-11.55 1.81-17.21-9.91-1.08-19.88-3.27-29.77-6.67-.96-.33-1.92-.67-2.86-1.01"></path>
        </clipPath>
        <clipPath id="clipPath19823" clipPathUnits="userSpaceOnUse">
          <path d="M9380.35 4861.59c-3.84 8.44-6.54 17.64-7.96 27.27l10.64 15.94c-2.93-12.79-2.3-25.78 2.72-36.93-1.79-2.08-3.59-4.17-5.4-6.28m34.46 90.82l12.74 19.09s16.65 23.06 38.94 53.9c.94.34 1.9.68 2.86 1.01 9.89 3.4 19.86 5.59 29.77 6.67.13-.89.27-1.77.42-2.66-14.46-27.16-27.33-51.3-34.85-65.42-2.91.43-5.93.66-9.05.66-3.77 0-7.71-.33-11.78-1.02-10.79-1.83-20.58-6.18-29.05-12.23"></path>
        </clipPath>
        <clipPath id="clipPath19835" clipPathUnits="userSpaceOnUse">
          <path d="M9385.75 4867.87c-5.02 11.15-5.65 24.14-2.72 36.93l31.78 47.61c8.47 6.05 18.26 10.4 29.05 12.23 4.07.69 8.01 1.02 11.78 1.02 3.12 0 6.14-.23 9.05-.66-4.41-8.27-6.99-13.1-6.99-13.1s-32.63-38.23-71.95-84.03"></path>
        </clipPath>
        <clipPath id="clipPath19847" clipPathUnits="userSpaceOnUse">
          <path d="M9499.54 5030.42c-.15.89-.29 1.77-.42 2.66-.86 5.66-1.46 11.4-1.81 17.21a191.457 191.457 0 00-.28 15.65c.02.59.03 1.18.05 1.77 7.48 10.35 15.05 20.81 22.41 30.98 4.3-2.24 8.49-4.63 12.56-7.17-10.73-20.18-22.04-41.43-32.51-61.1"></path>
        </clipPath>
        <clipPath id="clipPath19861" clipPathUnits="userSpaceOnUse">
          <path d="M9110.42 6363.06c-15.06 4.37-29.28 10.53-42.36 18.2 3.02 3.51 6.08 7.06 9.15 10.61 13.58-6.55 27.33-12.89 41.22-19.01-2.7-3.24-5.38-6.51-8.01-9.8"></path>
        </clipPath>
        <clipPath id="clipPath19873" clipPathUnits="userSpaceOnUse">
          <path d="M9118.43 6372.86c-13.89 6.12-27.64 12.46-41.22 19.01 18.15 21.05 36.68 42.62 53.36 62.07 44.74 44.44 91.39 83.36 132.62 105.03 40.91 21.51 56.62 43.97 51.32 57.23 13.33-18.71 22.74-40.04 27.15-62.99-86.22-45.29-162.05-106.79-223.23-180.35m122.33 245.74c3.6 6.77 7.25 13.63 10.9 20.48 8.91 4.85 17.91 9.55 27.01 14.11 11.9-9.12 22.52-19.64 31.58-31.28-4.69 3.89-12.46 6.13-23.07 6.13-11.98 0-27.57-2.86-46.42-9.44"></path>
        </clipPath>
        <clipPath id="clipPath19885" clipPathUnits="userSpaceOnUse">
          <path d="M9251.66 6639.08c4.28 8.06 8.56 16.11 12.75 23.99 4.93-3.08 9.69-6.38 14.26-9.88-9.1-4.56-18.1-9.26-27.01-14.11"></path>
        </clipPath>
        <clipPath id="clipPath19897" clipPathUnits="userSpaceOnUse">
          <path d="M9110.48 6363.05c-.02 0-.04.01-.06.01 2.63 3.29 5.31 6.56 8.01 9.8.01 0 .04-.02.05-.02-2.69-3.24-5.36-6.51-8-9.79"></path>
        </clipPath>
        <clipPath id="clipPath19909" clipPathUnits="userSpaceOnUse">
          <path d="M9118.48 6372.84c-.01 0-.04.02-.05.02 61.18 73.56 137.01 135.06 223.23 180.35 0-.01.01-.03.01-.04-86.17-45.29-162.03-106.81-223.19-180.33"></path>
        </clipPath>
        <clipPath id="clipPath19921" clipPathUnits="userSpaceOnUse">
          <path d="M9164.05 6355.51c-18.65 0-36.64 2.64-53.57 7.54 2.64 3.28 5.31 6.55 8 9.79 61.16 73.52 137.02 135.04 223.19 180.33v-.02c-73.5-38.64-139.49-89.09-195.25-148.74 58.02 52.42 124.73 95.85 197.81 128.01.17-2.97.25-5.96.25-8.97 0-92.73-80.84-167.94-180.43-167.94"></path>
        </clipPath>
        <clipPath id="clipPath19933" clipPathUnits="userSpaceOnUse">
          <path d="M9146.42 6404.41c55.76 59.65 121.75 110.1 195.25 148.74 1.3-6.77 2.16-13.7 2.56-20.73-73.08-32.16-139.79-75.59-197.81-128.01"></path>
        </clipPath>
        <clipPath id="clipPath19945" clipPathUnits="userSpaceOnUse">
          <path d="M9130.57 6453.94c33.53 39.08 59.5 69.51 59.5 69.51s23.99 45 50.69 95.15c18.85 6.58 34.44 9.44 46.42 9.44 10.61 0 18.38-2.24 23.07-6.13 1.46-1.88 2.88-3.78 4.26-5.71 5.3-13.26-10.41-35.72-51.32-57.23-41.23-21.67-87.88-60.59-132.62-105.03"></path>
        </clipPath>
        <clipPath id="clipPath19957" clipPathUnits="userSpaceOnUse">
          <path d="M8994.66 6581.21c20.21 51.43 66.64 91.08 124.2 104.92a973.123 973.123 0 01-124.2-104.92"></path>
        </clipPath>
        <clipPath id="clipPath19969" clipPathUnits="userSpaceOnUse">
          <path d="M8990.91 6476.35a157.259 157.259 0 00-7.19 47.1c0 20.3 3.86 39.75 10.94 57.76a973.123 973.123 0 00124.2 104.92c14.44 3.47 29.59 5.32 45.19 5.32 24.33 0 47.54-4.49 68.72-12.63-92.49-53.14-174.39-121.86-241.86-202.47"></path>
        </clipPath>
        <clipPath id="clipPath19981" clipPathUnits="userSpaceOnUse">
          <path d="M8990.92 6476.31c0 .01 0 .03-.01.04 67.47 80.61 149.37 149.33 241.86 202.47.01 0 .02 0 .03-.01-92.5-53.14-174.41-121.89-241.88-202.5"></path>
        </clipPath>
        <clipPath id="clipPath19993" clipPathUnits="userSpaceOnUse">
          <path d="M9005.95 6442.62c-.08.14-.17.28-.25.43 4.45 5.05 8.95 10.05 13.52 15.01a711.37 711.37 0 01-13.27-15.44m75.02 76.27a902.948 902.948 0 00132.42 98.16c-3.68-5.08-7.28-10.06-10.76-14.88-33.91-17.1-74.58-43.68-120.86-82.61-.27-.23-.53-.45-.8-.67"></path>
        </clipPath>
        <clipPath id="clipPath20005" clipPathUnits="userSpaceOnUse">
          <path d="M8991.47 6474.61c-.19.56-.37 1.13-.55 1.7 67.47 80.61 149.38 149.36 241.88 202.5l1.17-.45c-92.84-53.46-174.96-122.63-242.5-203.75"></path>
        </clipPath>
        <clipPath id="clipPath20017" clipPathUnits="userSpaceOnUse">
          <path d="M9005.7 6443.05c-5.84 9.95-10.63 20.51-14.23 31.56 67.54 81.12 149.66 150.29 242.5 203.75a187.67 187.67 0 0017.89-8.12c-12.71-17.56-26.03-35.98-38.47-53.19a902.948 902.948 0 01-132.42-98.16c-21.38-18.06-42.08-38.59-61.75-60.83-4.57-4.96-9.07-9.96-13.52-15.01"></path>
        </clipPath>
        <clipPath id="clipPath20029" clipPathUnits="userSpaceOnUse">
          <path d="M9056.75 6388.47c-20.83 14.39-38.22 32.87-50.8 54.15a711.37 711.37 0 0013.27 15.44c19.67 22.24 40.37 42.77 61.75 60.83.27.22.53.44.8.67 46.28 38.93 86.95 65.51 120.86 82.61l-42.72-59.12-103.16-154.58"></path>
        </clipPath>
        <clipPath id="clipPath20041" clipPathUnits="userSpaceOnUse">
          <path d="M8999.31 6302.4l.38.57c18.73 25.05 40.88 52.61 64.99 80.33 1.11-.69 2.24-1.37 3.38-2.04-27.43-31.77-53.04-61.23-68.75-78.86"></path>
        </clipPath>
        <linearGradient
          id="linearGradient20047"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-1651.53 1651.53) rotate(-90 -.851 5.017)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f8f8a5" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#fbd9aa" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath20059" clipPathUnits="userSpaceOnUse">
          <path d="M9274.34 6701.29c21.48 29.64 37.4 51.53 37.57 51.53l-.01-.01c-.79-1.71-10.2-19.52-23.46-44.53-4.74-2.3-9.41-4.61-14.1-6.99"></path>
        </clipPath>
        <linearGradient
          id="linearGradient20067"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(1254.052 -1254.052) rotate(76.211 7.033 2.36)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f8cbac" stopOpacity="1"></stop>
          <stop offset="0.952" stopColor="#fab9b0" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#fab9b0" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath20077" clipPathUnits="userSpaceOnUse">
          <path d="M9274.32 6701.26c.01.01.01.02.02.03 4.69 2.38 9.36 4.69 14.1 6.99l-.02-.02c-4.71-2.29-9.44-4.64-14.1-7"></path>
        </clipPath>
        <clipPath id="clipPath20093" clipPathUnits="userSpaceOnUse">
          <path d="M9273.17 6699.67c.39.54.77 1.06 1.15 1.59 4.66 2.36 9.39 4.71 14.1 7-.22-.43-.45-.86-.68-1.29-4.87-2.38-9.75-4.83-14.57-7.3"></path>
        </clipPath>
        <linearGradient
          id="linearGradient20099"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-1651.53 1651.53) rotate(-90 -.851 5.017)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f7f8a7" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#faeca8" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath20109" clipPathUnits="userSpaceOnUse">
          <path d="M9264.41 6663.07a188.47 188.47 0 01-12.55 7.17c7.41 10.24 14.62 20.2 21.31 29.43 4.82 2.47 9.7 4.92 14.57 7.3-6.98-13.15-14.97-28.19-23.33-43.9"></path>
        </clipPath>
        <linearGradient
          id="linearGradient20115"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-1651.53 1651.53) rotate(-90 -.851 5.017)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f6f8a8" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#f9f5a4" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath20125" clipPathUnits="userSpaceOnUse">
          <path d="M9068.06 6381.26c-1.14.67-2.27 1.35-3.38 2.04 2.97 3.42 5.98 6.85 9.01 10.27 1.18-.58 2.33-1.13 3.52-1.7-3.07-3.55-6.13-7.1-9.15-10.61"></path>
        </clipPath>
        <clipPath id="clipPath20137" clipPathUnits="userSpaceOnUse">
          <path d="M9077.21 6391.87c-1.19.57-2.34 1.12-3.52 1.7 18.2 20.53 37.35 40.97 56.88 60.37a31146.41 31146.41 0 00-53.36-62.07m125.42 210.3c3.48 4.82 7.08 9.8 10.76 14.88a897.211 897.211 0 0038.27 22.03c-3.65-6.85-7.3-13.71-10.9-20.48-11.52-4.02-24.26-9.43-38.13-16.43"></path>
        </clipPath>
        <clipPath id="clipPath20149" clipPathUnits="userSpaceOnUse">
          <path d="M9213.39 6617.05c12.44 17.21 25.76 35.63 38.47 53.19 4.29-2.24 8.48-4.63 12.55-7.17-4.19-7.88-8.47-15.93-12.75-23.99a897.211 897.211 0 01-38.27-22.03"></path>
        </clipPath>
        <clipPath id="clipPath20161" clipPathUnits="userSpaceOnUse">
          <path d="M9064.68 6383.3c-2.7 1.66-5.34 3.38-7.93 5.17l103.16 154.58 42.72 59.12c13.87 7 26.61 12.41 38.13 16.43-26.7-50.15-50.69-95.15-50.69-95.15s-25.97-30.43-59.5-69.51c-19.53-19.4-38.68-39.84-56.88-60.37-3.03-3.42-6.04-6.85-9.01-10.27"></path>
        </clipPath>
        <clipPath id="clipPath20199" clipPathUnits="userSpaceOnUse">
          <path d="M11222.5 5703.73c-11.3.23-22.2 1.42-32.8 3.48 98.2 62.97 188.1 126 216.8 151.33-.9-10.83-2.9-21.37-5.9-31.54-37.6-28.88-104.4-75.36-178.1-123.27m31.3 170.21c1.9 3.47 5.7 10.7 11 20.52 19.9 1.34 37.9 2.66 54 3.84 34.8 2.52 59.9 4.34 77.3 4.34 2.3 0 5 0 7.9-.1 1.3-6.61 2.2-13.37 2.6-20.23-3.3.33-7.4.48-12.2.48-25.6 0-71.5-4.38-140.6-8.85"></path>
        </clipPath>
        <clipPath id="clipPath20211" clipPathUnits="userSpaceOnUse">
          <path d="M11189.7 5707.21c-21.4 4.13-41.3 11.77-59.1 22.23 39.2 45.39 82 95.47 105.1 122.41 71.3 9.9 125.4 22.1 162.4 30.87-1.2.02-2.5.03-3.9.03-25.6 0-71.4-4.36-140.4-8.83v.02c69.1 4.47 115 8.85 140.6 8.85 4.8 0 8.9-.15 12.2-.48.3-3.53.4-7.09.4-10.68 0-4.41-.2-8.77-.5-13.09-28.7-25.33-118.6-88.36-216.8-151.33"></path>
        </clipPath>
        <clipPath id="clipPath20223" clipPathUnits="userSpaceOnUse">
          <path d="M11235.7 5851.85c10.5 12.3 16.9 19.78 16.9 19.78s.4.79 1.2 2.29c69 4.47 114.8 8.83 140.4 8.83 1.4 0 2.7-.01 3.9-.03-37-8.77-91.1-20.97-162.4-30.87"></path>
        </clipPath>
        <clipPath id="clipPath20247" clipPathUnits="userSpaceOnUse">
          <path d="M11046.4 5865.27c-.1 2.11-.2 4.23-.2 6.36 0 4.54.2 9.05.6 13.51 69.1 1.26 127.4 3.86 176.1 6.69-.3-.4-.5-.61-.5-.61l-13.3-19.97c-45.9-2.54-100-4.82-162.7-5.98"></path>
        </clipPath>
        <clipPath id="clipPath20259" clipPathUnits="userSpaceOnUse">
          <path d="M11119.3 5736.65c-34.5 23.84-59.6 58.89-69 99.36 52.5 1.86 99.9 5.63 142.2 10.41l-73.2-109.77m-72.9 128.62c62.7 1.16 116.8 3.44 162.7 5.98v-.02c-45.9-2.53-100-4.8-162.7-5.96"></path>
        </clipPath>
        <clipPath id="clipPath20271" clipPathUnits="userSpaceOnUse">
          <path d="M11050.3 5836.01c-2.2 9.48-3.5 19.26-3.9 29.26 62.7 1.16 116.8 3.43 162.7 5.96l-16.6-24.81c-42.3-4.78-89.7-8.55-142.2-10.41"></path>
        </clipPath>
        <clipPath id="clipPath20283" clipPathUnits="userSpaceOnUse">
          <path d="M11061.8 5650.58l57.5 86.07c3.6-2.53 7.4-4.93 11.3-7.21-27.5-31.77-53.1-61.24-68.8-78.86"></path>
        </clipPath>
        <linearGradient
          id="linearGradient20291"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="rotate(-13.016 30032.55 -42090.006) scale(908.711)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#a2dda7" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#eff4a5" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#eff4a5" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath20301" clipPathUnits="userSpaceOnUse">
          <path d="M11326.9 6011.25c-4 2.54-8.2 4.93-12.5 7.17 31.9 44.04 59.8 82.58 60 82.58v-.01c-1.2-2.63-22.8-43.34-47.5-89.74"></path>
        </clipPath>
        <radialGradient
          id="radialGradient20309"
          cx="0"
          cy="0"
          r="1"
          fx="0"
          fy="0"
          gradientTransform="matrix(1894.09 0 0 -1645.04 9672.93 5863.96)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#adc8ac" stopOpacity="1"></stop>
          <stop offset="0.37" stopColor="#adc8ac" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#b5b5b1" stopOpacity="1"></stop>
        </radialGradient>
        <clipPath id="clipPath20319" clipPathUnits="userSpaceOnUse">
          <path d="M11222.9 5891.83c5 6.9 51.3 71.11 91.5 126.59 4.3-2.24 8.5-4.63 12.5-7.17-22.5-42.4-47.6-89.56-62.1-116.79-13.1-.87-27.1-1.76-41.9-2.63"></path>
        </clipPath>
        <clipPath id="clipPath20331" clipPathUnits="userSpaceOnUse">
          <path d="M11209.1 5871.25l13.3 19.97s.2.21.5.61c14.8.87 28.8 1.76 41.9 2.63-5.3-9.82-9.1-17.05-11-20.52-13.9-.91-28.8-1.82-44.7-2.69"></path>
        </clipPath>
        <clipPath id="clipPath20343" clipPathUnits="userSpaceOnUse">
          <path d="M11130.6 5729.44c-3.9 2.28-7.7 4.68-11.3 7.21l73.2 109.77c15.1 1.7 29.4 3.52 43.2 5.43-23.1-26.94-65.9-77.02-105.1-122.41m78.5 141.79v.02c15.9.87 30.8 1.78 44.7 2.69v-.02c-13.9-.9-28.8-1.81-44.7-2.69"></path>
        </clipPath>
        <clipPath id="clipPath20355" clipPathUnits="userSpaceOnUse">
          <path d="M11192.5 5846.42l16.6 24.81c15.9.88 30.8 1.79 44.7 2.69-.8-1.5-1.2-2.29-1.2-2.29s-6.4-7.48-16.9-19.78c-13.8-1.91-28.1-3.73-43.2-5.43"></path>
        </clipPath>
        <clipPath id="clipPath24465" clipPathUnits="userSpaceOnUse">
          <path d="M9320.44 5400.52l-.02.05 132.56 205.3-132.54-205.35m600.23 205.35h-47.05l.2 10.31h46.89l148.39 445.32c2.1.04 3.3.04 3.3.04l.1.04.1-.04-151.93-455.67m-318.59 0h-149.1l-32 96c.1.22.8 1.77 2.15 4.49l30.06-90.18h151.07l-2.18-10.31"></path>
        </clipPath>
        <linearGradient
          id="linearGradient24473"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-523.7211 523.7211) rotate(81.607 -15.328 -5.667)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#416125" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#6b892a" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#6b892a" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath24485" clipPathUnits="userSpaceOnUse">
          <path d="M9920.71 5616.18h-46.89l8.06 425.53c91.88 17.1 170.72 19.47 187.22 19.79l-148.39-445.32m-316.45 0h-151.07l-30.06 90.18c11.67 23.52 71.65 135.05 206.02 237.76 15.73 12.03 32.99 22.82 51.29 32.51l-76.18-360.45"></path>
        </clipPath>
        <clipPath id="clipPath24497" clipPathUnits="userSpaceOnUse">
          <path d="M9862.28 5399.3h-541.44l-.4 1.22 132.54 205.35h467.69l132.73-205.54-.3-.82-190.82-.21m144.52 1.74l-121.65 188.1h-397.06l-121.42-188.1h640.13"></path>
        </clipPath>
        <linearGradient
          id="linearGradient24505"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-523.7211 523.7211) rotate(81.607 -15.328 -5.667)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#394d2a" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#566924" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#566924" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath24517" clipPathUnits="userSpaceOnUse">
          <path d="M10006.8 5401.04h-640.13l121.42 188.1h397.06l121.65-188.1"></path>
        </clipPath>
        <clipPath id="clipPath24529" clipPathUnits="userSpaceOnUse">
          <path d="M9320.42 5400.57l-10.16 30.44 125.02 193.62-112.97 338.95c.54.64 1.09 1.28 1.62 1.9l63.7-191.07 5.5 8.01 3.78-10.33 24.06-70.24s0 .01.01.02l32-96-132.56-205.3m-7.53 591.26l-2.49 7.45c1.35-2.11 2.57-4.02 3.65-5.71l-1.16-1.74m-24.54 42.35l-195.14 47.62-10.47 31.41.46.32 192.12-58.51c4.53-7.27 8.9-14.26 13.03-20.84"></path>
        </clipPath>
        <linearGradient
          id="linearGradient24537"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-523.7211 523.7211) rotate(81.607 -15.328 -5.667)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#3d5828" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#617b28" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#617b28" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath24549" clipPathUnits="userSpaceOnUse">
          <path d="M10053.5 5400.55l-132.83 205.32 151.93 455.67 216.7 52.83 1.7-1.2-11.8-35.53-202.1-49.32-135.6-406.78 122.4-189.64-10.4-31.35"></path>
        </clipPath>
        <linearGradient
          id="linearGradient24557"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-523.7211 523.7211) rotate(81.607 -15.328 -5.667)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#394d2a" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#566a24" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#566a24" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath24569" clipPathUnits="userSpaceOnUse">
          <path d="M10053.4 5400.33l-132.73 205.54 132.83-205.32-.1-.22"></path>
        </clipPath>
        <linearGradient
          id="linearGradient24577"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-523.7211 523.7211) rotate(81.607 -15.328 -5.667)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#323d29" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#485321" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#485321" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath24589" clipPathUnits="userSpaceOnUse">
          <path d="M10063.9 5431.9l-122.4 189.64 135.6 406.78 202.1 49.32-215.3-645.74"></path>
        </clipPath>
        <clipPath id="clipPath24601" clipPathUnits="userSpaceOnUse">
          <path d="M10069.2 5423.71l-5.3 8.19 215.3 645.74 8.7 2.13-218.7-656.06"></path>
        </clipPath>
        <clipPath id="clipPath24613" clipPathUnits="userSpaceOnUse">
          <path d="M9310.26 5431.01l-217.05 650.79 195.14-47.62c8.82-14.06 16.51-26.18 22.05-34.9l2.49-7.45-114.66-171.89c26.32 29.65 87.13 100.49 124.08 143.64l112.97-338.95-125.02-193.62"></path>
        </clipPath>
        <clipPath id="clipPath24625" clipPathUnits="userSpaceOnUse">
          <path d="M9307.55 5426.8l-218.67 656.06 4.33-1.06 217.05-650.79-2.71-4.21"></path>
        </clipPath>
        <clipPath id="clipPath24637" clipPathUnits="userSpaceOnUse">
          <path d="M9301.1 6074.3l-10.99 2.08-14.82 17.88 31.63-6.84 358.13 248.46 10.43 188.57 10.66 7.39-10.17-193.13-228.57-161.22c2.1 3.99 3.38 6.47 3.63 7.01v.01c-.07 0-2.6-3.44-6.89-9.32L9301.1 6074.3m-42.7 8.1l-172.81 32.79 22.09 15.33 139.81-30.25c3.62-5.96 7.28-11.95 10.91-17.87"></path>
        </clipPath>
        <clipPath id="clipPath24649" clipPathUnits="userSpaceOnUse">
          <path d="M9085.59 6115.19l-19.98 3.79-.62.15.01-.03-.19.03 621.72 431.33.06.26.12-.13v-7.84l-.57-10.91-10.66-7.39.49 8.79-.22-.09-.08.09-.07-.24-577.25-400.47 9.33-2.01-22.09-15.33"></path>
        </clipPath>
        <clipPath id="clipPath24661" clipPathUnits="userSpaceOnUse">
          <path d="M9686.92 6550.59l-.1.07.1.06v-.13"></path>
        </clipPath>
        <clipPath id="clipPath24673" clipPathUnits="userSpaceOnUse">
          <path d="M9065.61 6118.98l-.61.12-.01.03.62-.15"></path>
        </clipPath>
        <clipPath id="clipPath24685" clipPathUnits="userSpaceOnUse">
          <path d="M10072.6 6061.54l-.1.04 144.5 35.18-144.4-35.22m3.2 9.99l-378.72 264.41-9.09 195.73 9.54-6.62 10.45-189.17 358.12-248.46 199.8 43.21 22.5-15.67-212.6-43.43"></path>
        </clipPath>
        <clipPath id="clipPath24697" clipPathUnits="userSpaceOnUse">
          <path d="M10288.4 6114.96l-22.5 15.67 8.8 1.9L9697.45 6533l-.08.24-.1-.09-.19.09.45-8.19-9.54 6.62-.87 18.79-.2-3.73v3.86l.12.13.08-.26 621.68-431.33-.1-.03v.03l-.7-.17-19.6-4m20.3 4.14l.1.03-.1-.03m.1.03"></path>
        </clipPath>
        <clipPath id="clipPath24709" clipPathUnits="userSpaceOnUse">
          <path d="M9686.71 6550.59v.13l.11-.06-.11-.07"></path>
        </clipPath>
        <clipPath id="clipPath24721" clipPathUnits="userSpaceOnUse">
          <path d="M10072.6 6061.54l144.4 35.22 72.3 17.61-216.7-52.83"></path>
        </clipPath>
        <clipPath id="clipPath24733" clipPathUnits="userSpaceOnUse">
          <path d="M10289.3 6114.37l19.4 4.73-19.4-4.73m18.7 4.59l.7.17v-.03l-.7-.14"></path>
        </clipPath>
        <clipPath id="clipPath24745" clipPathUnits="userSpaceOnUse">
          <path d="M9686.71 6542.75v7.84l.11.07.1-.07v-3.86l-.21-3.98"></path>
        </clipPath>
        <clipPath id="clipPath24757" clipPathUnits="userSpaceOnUse">
          <path d="M10066.1 6087.42l-358.12 248.46-10.45 189.17 568.37-394.42-199.8-43.21"></path>
        </clipPath>
        <clipPath id="clipPath24769" clipPathUnits="userSpaceOnUse">
          <path d="M10265.9 6130.63l-568.37 394.42-.45 8.19.19-.09.1.09.08-.24 577.25-400.47-8.8-1.9"></path>
        </clipPath>
        <clipPath id="clipPath24781" clipPathUnits="userSpaceOnUse">
          <path d="M9306.92 6087.42l-31.63 6.84-78.07 94.17c9.76-20.12 29.47-53.86 50.27-88.16l-139.81 30.25 567.8 393.93-10.43-188.57-358.13-248.46"></path>
        </clipPath>
        <clipPath id="clipPath24793" clipPathUnits="userSpaceOnUse">
          <path d="M9107.68 6130.52l-9.33 2.01L9675.6 6533l.07.24.08-.09.22.09-.49-8.79-567.8-393.93"></path>
        </clipPath>
        <clipPath id="clipPath24807" clipPathUnits="userSpaceOnUse">
          <path d="M9387.63 5774.41l-63.7 191.07c.55.64 1.08 1.26 1.62 1.88l67.58-184.94-5.5-8.01"></path>
        </clipPath>
        <clipPath id="clipPath24819" clipPathUnits="userSpaceOnUse">
          <path d="M9393.13 5782.42l-67.58 184.94c1.09 1.28 2.15 2.53 3.19 3.74l64.55-188.45-.16-.23m-5.75 335.41l13.55 19.33 31.42 21.8c-3.34-4.6-7.01-9.67-10.91-15.06l-34.06-26.07m47.87 36.64l5.43 10.27 85.38 59.24-90.81-69.51"></path>
        </clipPath>
        <clipPath id="clipPath24831" clipPathUnits="userSpaceOnUse">
          <path d="M9873.62 5605.87h-271.54l2.18 10.31h269.56l-.2-10.31"></path>
        </clipPath>
        <clipPath id="clipPath24843" clipPathUnits="userSpaceOnUse">
          <path d="M9873.82 5616.18h-269.56l76.18 360.45c61.59 32.61 134.94 52.7 201.44 65.08l-8.06-425.53"></path>
        </clipPath>
        <clipPath id="clipPath24855" clipPathUnits="userSpaceOnUse">
          <path d="M9873.62 5605.87h-271.54 271.54"></path>
        </clipPath>
        <clipPath id="clipPath24867" clipPathUnits="userSpaceOnUse">
          <path d="M9420.98 5701.87l-16.79 50.38-9.77 32.04 1.84 2.67 26.87-80.6c-1.35-2.72-2.05-4.27-2.15-4.49"></path>
        </clipPath>
        <clipPath id="clipPath24879" clipPathUnits="userSpaceOnUse">
          <path d="M9423.13 5706.36l-26.87 80.6 41.48 60.29c17.92-20.81 31.08-36 32.66-37.63.08-.07.13-.11.15-.11.59-.01-11.1 19.11-27.5 45.47l296 430.26 5.79-3.89-64.4-304.72c-18.3-9.69-35.56-20.48-51.29-32.51-134.37-102.71-194.35-214.24-206.02-237.76"></path>
        </clipPath>
        <clipPath id="clipPath24891" clipPathUnits="userSpaceOnUse">
          <path d="M9420.97 5701.85l-24.06 70.24 7.44-20.35-.16.51 16.79-50.38c-.01-.01-.01-.02-.01-.02"></path>
        </clipPath>
        <clipPath id="clipPath24903" clipPathUnits="userSpaceOnUse">
          <path d="M10069.1 6061.5l.6 1.79 2.7-1.75s-1.2 0-3.3-.04"></path>
        </clipPath>
        <clipPath id="clipPath24915" clipPathUnits="userSpaceOnUse">
          <path d="M9881.88 6041.71l2.72 143.76-90.59 62.88 275.69-185.06-.6-1.79c-16.5-.32-95.34-2.69-187.22-19.79"></path>
        </clipPath>
        <clipPath id="clipPath24927" clipPathUnits="userSpaceOnUse">
          <path d="M9404.35 5751.74l-7.44 20.35-3.62 10.56 1.13 1.64 9.77-32.04.16-.51m668.05 309.8l-2.7 1.75-275.69 185.06-48.96 33.99-.21-.99-5.79 3.89.59.85-61.99 43.04-.12-.06-.08.06-.04-.15-151.35-105 149.91 114.73 396.43-277.17"></path>
        </clipPath>
        <clipPath id="clipPath24939" clipPathUnits="userSpaceOnUse">
          <path d="M9394.42 5784.29l-29.09 95.46 30.93-92.79-1.84-2.67"></path>
        </clipPath>
        <clipPath id="clipPath24951" clipPathUnits="userSpaceOnUse">
          <path d="M9396.26 5786.96l-30.93 92.79-24.48 80.33c25.18-29.38 67.47-78.67 96.89-112.83l-41.48-60.29m46.79 68.02c-29.71 47.76-74.88 119.3-90.48 143.99.42.8 40.83 76.64 69.75 131.13l268.98 187.18 47.75-32.04-296-430.26"></path>
        </clipPath>
        <clipPath id="clipPath24963" clipPathUnits="userSpaceOnUse">
          <path d="M9393.29 5782.65l-64.55 188.45c.45.52.9 1.04 1.33 1.55 3.06-3.56 6.69-7.8 10.78-12.57l24.48-80.33 29.09-95.46-1.13-1.64m29.03 347.45c4.68 8.82 9.06 17.08 12.93 24.37l90.81 69.51 151.35 105 .04.15.08-.06.12.06 61.99-43.04-.59-.85-47.75 32.04-268.98-187.18"></path>
        </clipPath>
        <clipPath id="clipPath24975" clipPathUnits="userSpaceOnUse">
          <path d="M9680.44 5976.63l64.4 304.72 49.17-33 90.59-62.88-2.72-143.76c-66.5-12.38-139.85-32.47-201.44-65.08"></path>
        </clipPath>
        <clipPath id="clipPath24987" clipPathUnits="userSpaceOnUse">
          <path d="M9794.01 6248.35l-49.17 33 .21.99 48.96-33.99"></path>
        </clipPath>
        <clipPath id="clipPath24999" clipPathUnits="userSpaceOnUse">
          <path d="M9327.08 6031.79l-12.79 15.44-1.94 6.34 58.55 40.74-43.82-62.52"></path>
        </clipPath>
        <clipPath id="clipPath25011" clipPathUnits="userSpaceOnUse">
          <path d="M9314.29 6047.23l-7.44 8.97 80.53 61.63-16.48-23.52-58.55-40.74 1.94-6.34"></path>
        </clipPath>
        <clipPath id="clipPath25023" clipPathUnits="userSpaceOnUse">
          <path d="M9334.24 6023.16l-7.16 8.63 43.82 62.52 29.55 20.56c-25.72-35.58-54.06-74.86-66.21-91.71"></path>
        </clipPath>
        <clipPath id="clipPath25035" clipPathUnits="userSpaceOnUse">
          <path d="M9370.9 6094.31l16.48 23.52 34.06 26.07c-6.49-8.97-13.63-18.84-20.99-29.03l-29.55-20.56"></path>
        </clipPath>
        <clipPath id="clipPath25047" clipPathUnits="userSpaceOnUse">
          <path d="M9470.55 5809.51c-.02 0-.07.04-.15.11-1.58 1.63-14.74 16.82-32.66 37.63l5.31 7.73c16.4-26.36 28.09-45.48 27.5-45.47"></path>
        </clipPath>
        <clipPath id="clipPath25059" clipPathUnits="userSpaceOnUse">
          <path d="M9437.74 5847.25c-29.42 34.16-71.71 83.45-96.89 112.83l-5.66 18.56c10.7 12.5 17.38 20.33 17.38 20.33 15.6-24.69 60.77-96.23 90.48-143.99l-5.31-7.73"></path>
        </clipPath>
        <clipPath id="clipPath25071" clipPathUnits="userSpaceOnUse">
          <path d="M9340.85 5960.08c-4.09 4.77-7.72 9.01-10.78 12.57 1.79 2.1 3.5 4.1 5.12 5.99l5.66-18.56"></path>
        </clipPath>
        <clipPath id="clipPath25083" clipPathUnits="userSpaceOnUse">
          <path d="M9314.05 5993.57c-1.08 1.69-2.3 3.6-3.65 5.71l-10.7 32.13-11.35 2.77c-4.13 6.58-8.5 13.57-13.03 20.84l20.47-6.23 14.81-40.52-.63-.9 4.43-13.27-.35-.53"></path>
        </clipPath>
        <linearGradient
          id="linearGradient25091"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-523.7211 523.7211) rotate(81.607 -15.328 -5.667)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#c3d0ab" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#cfdaa9" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#cfdaa9" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath25101" clipPathUnits="userSpaceOnUse">
          <path d="M9310.4 5999.28c-5.54 8.72-13.23 20.84-22.05 34.9l11.35-2.77 10.7-32.13"></path>
        </clipPath>
        <clipPath id="clipPath25113" clipPathUnits="userSpaceOnUse">
          <path d="M9290.11 6076.38l-31.71 6.02c-3.63 5.92-7.29 11.91-10.91 17.87l27.8-6.01 14.82-17.88"></path>
        </clipPath>
        <clipPath id="clipPath25125" clipPathUnits="userSpaceOnUse">
          <path d="M9275.29 6094.26l-27.8 6.01c-20.8 34.3-40.51 68.04-50.27 88.16l78.07-94.17"></path>
        </clipPath>
        <clipPath id="clipPath25139" clipPathUnits="userSpaceOnUse">
          <path d="M9314.4 5994.1l-4.43 13.27.63.9 4.69-12.84-.89-1.33"></path>
        </clipPath>
        <clipPath id="clipPath25151" clipPathUnits="userSpaceOnUse">
          <path d="M9315.29 5995.43l-4.69 12.84 3.64 5.19 4.43-12.95-3.38-5.08"></path>
        </clipPath>
        <clipPath id="clipPath25163" clipPathUnits="userSpaceOnUse">
          <path d="M9321.44 6023.74l-7.15 23.49 12.79-15.44-5.64-8.05"></path>
        </clipPath>
        <clipPath id="clipPath25175" clipPathUnits="userSpaceOnUse">
          <path d="M9314.24 6013.46l-13.14 38.34 5.75 4.4 7.44-8.97 7.15-23.49-7.2-10.28"></path>
        </clipPath>
        <clipPath id="clipPath25187" clipPathUnits="userSpaceOnUse">
          <path d="M9325.44 6010.65l-4 13.09 5.64 8.05 7.16-8.63c-3.86-5.34-6.09-8.44-6.09-8.44l-2.71-4.07"></path>
        </clipPath>
        <clipPath id="clipPath25199" clipPathUnits="userSpaceOnUse">
          <path d="M9318.67 6000.51l-4.43 12.95 7.2 10.28 4-13.09-6.77-10.14"></path>
        </clipPath>
        <clipPath id="clipPath25211" clipPathUnits="userSpaceOnUse">
          <path d="M9322.31 5963.58l-9.42 28.25 1.16 1.74c.38-.6.75-1.18 1.1-1.72l8.78-26.37c-.53-.62-1.08-1.26-1.62-1.9"></path>
        </clipPath>
        <clipPath id="clipPath25229" clipPathUnits="userSpaceOnUse">
          <path d="M9198.23 5819.94l114.66 171.89 9.42-28.25c-36.95-43.15-97.76-113.99-124.08-143.64"></path>
        </clipPath>
        <clipPath id="clipPath25241" clipPathUnits="userSpaceOnUse">
          <path d="M9323.93 5965.48l-8.78 26.37c1.48-2.32 2.62-4.11 3.39-5.3l7.01-19.19c-.54-.62-1.07-1.24-1.62-1.88"></path>
        </clipPath>
        <clipPath id="clipPath25253" clipPathUnits="userSpaceOnUse">
          <path d="M9325.55 5967.36l-7.01 19.19c.72-1.13 1.1-1.72 1.1-1.72s2.68-3.14 7.33-8.56l1.77-5.17c-1.04-1.21-2.1-2.46-3.19-3.74"></path>
        </clipPath>
        <clipPath id="clipPath25265" clipPathUnits="userSpaceOnUse">
          <path d="M9328.74 5971.1l-1.77 5.17c.96-1.11 1.99-2.32 3.1-3.62-.43-.51-.88-1.03-1.33-1.55"></path>
        </clipPath>
        <clipPath id="clipPath25277" clipPathUnits="userSpaceOnUse">
          <path d="M9444.14 6175.19c4.29 5.88 6.82 9.32 6.89 9.32v-.01c-.25-.54-1.53-3.02-3.63-7.01l-3.26-2.3"></path>
        </clipPath>
        <clipPath id="clipPath25291" clipPathUnits="userSpaceOnUse">
          <path d="M9421.44 6143.9c3.9 5.39 7.57 10.46 10.91 15.06l8.33 5.78-5.43-10.27-13.81-10.57"></path>
        </clipPath>
        <clipPath id="clipPath25303" clipPathUnits="userSpaceOnUse">
          <path d="M9352.57 5998.97c-3.51 5.56-5.53 8.75-5.53 8.75l-12.8 15.44c12.15 16.85 40.49 56.13 66.21 91.71l21.87 15.23c-28.92-54.49-69.33-130.33-69.75-131.13"></path>
        </clipPath>
        <clipPath id="clipPath25315" clipPathUnits="userSpaceOnUse">
          <path d="M9400.45 6114.87c7.36 10.19 14.5 20.06 20.99 29.03l13.81 10.57c-3.87-7.29-8.25-15.55-12.93-24.37l-21.87-15.23"></path>
        </clipPath>
        <clipPath id="clipPath25327" clipPathUnits="userSpaceOnUse">
          <path d="M9315.15 5991.85c-.35.54-.72 1.12-1.1 1.72l.35.53.75-2.25"></path>
        </clipPath>
        <linearGradient
          id="linearGradient25335"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-523.7211 523.7211) rotate(81.607 -15.328 -5.667)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f0f2e7" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#f3f6e6" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#f3f6e6" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath25345" clipPathUnits="userSpaceOnUse">
          <path d="M9318.54 5986.55c-.77 1.19-1.91 2.98-3.39 5.3l-.75 2.25.89 1.33 3.25-8.88"></path>
        </clipPath>
        <clipPath id="clipPath25357" clipPathUnits="userSpaceOnUse">
          <path d="M9326.97 5976.27c-4.65 5.42-7.33 8.56-7.33 8.56s-.38.59-1.1 1.72l-3.25 8.88 3.38 5.08 8.3-24.24"></path>
        </clipPath>
        <clipPath id="clipPath25369" clipPathUnits="userSpaceOnUse">
          <path d="M9335.19 5978.64l-9.75 32.01 2.71 4.07s2.23 3.1 6.09 8.44l12.8-15.44s2.02-3.19 5.53-8.75c0 0-6.68-7.83-17.38-20.33"></path>
        </clipPath>
        <clipPath id="clipPath25381" clipPathUnits="userSpaceOnUse">
          <path d="M9330.07 5972.65c-1.11 1.3-2.14 2.51-3.1 3.62l-8.3 24.24 6.77 10.14 9.75-32.01c-1.62-1.89-3.33-3.89-5.12-5.99"></path>
        </clipPath>
        <clipPath clipPathUnits="userSpaceOnUse">
          <path d="M9456.32 4796.58c-9.83 0-20.02 1.37-30.31 4.08-24.82 6.53-45.18 23.59-57.86 46.73 4.1 4.77 8.18 9.52 12.2 14.2 9.84-21.58 27.21-38.18 50.05-44.19 9.27-2.44 17.89-3.51 25.91-3.51 59.3.01 84.76 58.84 84.76 58.84 4.74 1.93 8.74 2.83 12.05 2.83 14.56 0 15.74-17.38 7.64-40.98-8.87-8.45-18.69-16.03-29.29-22.6 8.41 15.08 13 27.27 15.24 35.91-12.19-17.91-35.7-43.59-73.04-49.88-5.48-.92-11.26-1.43-17.35-1.43"></path>
        </clipPath>
        <linearGradient
          id="linearGradient128959"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-1651.53 1651.53) rotate(-90 -.851 5.017)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient18207"
        ></linearGradient>
        <linearGradient
          id="linearGradient128961"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(1254.052 -1254.052) rotate(76.211 7.033 2.36)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient18225"
        ></linearGradient>
        <linearGradient
          id="linearGradient128963"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(1254.052 -1254.052) rotate(76.211 7.033 2.36)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient18225"
        ></linearGradient>
        <linearGradient
          id="linearGradient128965"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-1651.53 1651.53) rotate(-90 -.851 5.017)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient18207"
        ></linearGradient>
        <linearGradient
          id="linearGradient128967"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-1651.53 1651.53) rotate(-90 -.851 5.017)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient18207"
        ></linearGradient>
        <linearGradient
          id="linearGradient128969"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-289.707 289.707) rotate(90 -25.2 -8.229)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient18985"
        ></linearGradient>
        <linearGradient
          id="linearGradient128971"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-289.707 289.707) rotate(90 -25.2 -8.229)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient19039"
        ></linearGradient>
        <linearGradient
          id="linearGradient128973"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-289.707 289.707) rotate(90 -25.2 -8.229)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient18985"
        ></linearGradient>
        <linearGradient
          id="linearGradient128975"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-289.707 289.707) rotate(90 -25.2 -8.229)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient19079"
        ></linearGradient>
        <linearGradient
          id="linearGradient128977"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-289.707 289.707) rotate(90 -25.2 -8.229)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient19039"
        ></linearGradient>
        <linearGradient
          id="linearGradient128979"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-289.707 289.707) rotate(90 -25.2 -8.229)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient18985"
        ></linearGradient>
        <linearGradient
          id="linearGradient128981"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-289.707 289.707) rotate(90 -25.2 -8.229)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient19079"
        ></linearGradient>
        <linearGradient
          id="linearGradient128983"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-1651.53 1651.53) rotate(-90 -.851 5.017)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient20047"
        ></linearGradient>
        <linearGradient
          id="linearGradient128985"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-1651.53 1651.53) rotate(-90 -.851 5.017)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient20047"
        ></linearGradient>
        <linearGradient
          id="linearGradient128987"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-523.7211 523.7211) rotate(81.607 -15.328 -5.667)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient25091"
        ></linearGradient>
        <linearGradient
          id="linearGradient128989"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-523.7211 523.7211) rotate(81.607 -15.328 -5.667)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient25091"
        ></linearGradient>
      </defs>
      <g transform="translate(-41.307 -77.922)">
        <path
          fill="#275437"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M89.805 85.698c.789 1.988 2.164 5.063 3.496 7.867a145.81 145.81 0 019.789-1.765l.105-.015.105.015c1.155.164 5.157.761 9.789 1.765 1.33-2.804 2.706-5.879 3.496-7.867-.43.244-.889.51-1.309.753-2.925 1.695-4.276 2.437-4.938 2.437a.937.937 0 01-.518-.15c-.28-.18-.548-.53-1.93-2.416-1.152-1.57-3.751-5.116-4.695-5.848-.942.73-3.543 4.276-4.696 5.848-1.382 1.886-1.65 2.236-1.93 2.415a.94.94 0 01-.517.151c-.626 0-1.782-.608-4.938-2.437-.42-.244-.878-.509-1.309-.753m24.236 10.582l-.637-.141a144.884 144.884 0 00-10.21-1.87c-1.323.19-5.494.823-10.208 1.87l-.637.141-.34-.708c-5.288-11.004-4.926-11.839-4.636-12.51.23-.53.704-.797 1.182-.652.515.157 1.607.782 3.345 1.789 1.213.703 3.145 1.822 3.933 2.139.3-.385.81-1.08 1.273-1.711 2.891-3.945 4.57-6.071 5.576-6.57a.957.957 0 01.49-.135h.035a.994.994 0 01.5.136c1.007.498 2.684 2.624 5.577 6.569.463.631.972 1.326 1.273 1.71.788-.316 2.719-1.435 3.933-2.138 1.739-1.007 2.829-1.632 3.344-1.789.476-.145.952.122 1.182.652.289.67.652 1.505-4.636 12.51l-.339.708"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18039)">
            <path
              fill="url(#linearGradient18047)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9370.95 6814.77c-40.84 87.31-123.16 268.11-107.47 274.32-9.78-3.86 18.53-75.58 51.12-150.2 40.72-8.1 84.2-12.55 129.43-12.55 14.28 0 28.4.44 42.3 1.29 2.79-.84 5.07-1.29 6.77-1.29 1.08 0 1.93.18 2.52.56.42.28 1 .78 1.72 1.5 129.7 10.08 240.44 56.49 303.19 121.71 45.35-58.94 88.32-118.9 95.01-123.21.59-.38 1.43-.56 2.51-.56 22.4 0 146.35 78.32 199.35 105.77-22.9-61.77-67.4-159.06-94.3-216.58-53.17 17.66-108.2 30.9-164.65 39.43l-10.2 1.51c-12.58 1.78-25.17 3.37-37.58 4.63-4.82.53-9.7.94-14.57 1.31l-5.68.48c-10.14.84-20.22 1.7-30.35 2.22-13.09.69-26.29.95-39.69 1.16l-3.07.08c-2.83.13-5.66.22-8.53.22h-1.93c-17.78 0-36.16-.55-55.73-1.68l-3.16-.19c-17.73-1.05-36.29-2.66-53.36-4.65l-3.38-.4c-69.33-8.04-136.35-23.28-200.27-44.88m518.35 159.73c-1.08 0-1.92.19-2.51.57-12.77 8.22-154.06 219.36-195.34 238.86 41.28-19.5 182.57-230.64 195.34-238.86.59-.38 1.43-.57 2.51-.57 26.01.01 188.7 105.44 218.8 114.55.4.14.8.2 1.2.2 1.5 0 2.4-1.19 2.7-3.43-.3 2.24-1.2 3.43-2.7 3.43-.4 0-.8-.06-1.2-.2-30.1-9.11-192.79-114.54-218.8-114.55m222.8 110.55v0m0 .09v0m0 .11v0m0 .12v0m0 .11v0m0 .12c0 .03 0 .07-.1.1.1-.03.1-.07.1-.1m-.1.11v0m-848.52 3.38c.02.01.04.02.06.02-.02 0-.04-.01-.06-.02m.06.02c.02.01.04.02.05.02-.01 0-.03-.01-.05-.02m.07.03c.01 0 .03 0 .04.01-.01-.01-.03-.01-.04-.01m.06.02c.02 0 .03 0 .04.01-.01-.01-.02-.01-.04-.01m.07.02h.04-.04m.07.01c.01 0 .02.01.03.01-.01 0-.02-.01-.03-.01m.06.01c.01.01.02.01.03.01-.01 0-.02 0-.03-.01m.08.02h.02-.02m.07.01h.02-.02m.07.01h.02-.02m.08.01h.01-.01"
            ></path>
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M88.644 85.311c1.105.335 7.285 4.357 7.805 4.022.454-.292 5.636-7.84 7.054-8.44v-.025c-.012-.01-.033-.014 0-.01.034-.004.013 0 0 .01v.025c1.418.6 6.6 8.148 7.054 8.44.452.29 5.16-2.697 7.125-3.712.466-1.26.681-2.102.374-2.009-1.108.335-7.287 4.356-7.807 4.021-.454-.292-5.502-7.838-6.92-8.44a.181.181 0 00-.134-.035.179.179 0 00-.134.036c-1.418.6-6.467 8.147-6.92 8.44-.52.334-6.7-3.687-7.806-4.022-.282-.085-.125.615.263 1.701l.046-.002"
        ></path>
        <path
          fill="#1d733b"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M88.335 83.612a.082.082 0 00-.011-.003h-.001-.002a.142.142 0 00-.029-.004h-.008.008c.013 0 .027.002.043.007M88.268 83.61v-.001m.006-.001h.002-.002m.002 0l.002-.001h-.002m.002 0h.002-.002m.002 0h.002-.002M103.345 79.203v-.001m-.005-.001V79.2m-.01-.004"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18061)">
            <path
              fill="url(#linearGradient18069)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9444.03 6926.34c-45.23 0-88.71 4.45-129.43 12.55-32.59 74.62-60.9 146.34-51.12 150.2.02.01.04.02.06.02.02.01.04.02.05.02.01 0 .01 0 .02.01.01 0 .03 0 .04.01.01 0 .02 0 .02.01.02 0 .03 0 .04.01.01 0 .02 0 .03.01h.04c.01.01.02.01.03.01.01 0 .02.01.03.01h.03c.01.01.02.01.03.01.02 0 .03 0 .05.01h.02c.01 0 .03.01.05.01h.02c.02 0 .03 0 .05.01h.02c.02 0 .04 0 .06.01h.23c-6.28 0-1.73-19.32 8.66-48.41l1.3.05c28.12-8.52 172.06-101.19 211.97-113.26-13.9-.85-28.02-1.29-42.3-1.29m53.31 2.06c20.82 20.82 159.38 221.26 198.23 237.73v.7c-.27.22-.69.34-.41.34.08 0 .21-.01.41-.03.21.02.34.03.43.03.29 0-.13-.12-.43-.34v-.7c19.29-8.17 63.14-61.66 104.96-116.02-62.75-65.22-173.49-111.63-303.19-121.71m-232.05 160.74h-.02.02"
            ></path>
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M96.121 89.307c-1.408-.426-6.485-3.695-7.477-3.996l-.046.002c-.367-1.026-.527-1.708-.306-1.708.01 0 .018.001.029.004h.002l.012.003c1.061.322 6.8 4.041 7.716 4.041a.165.165 0 00.09-.02c.453-.292 5.502-7.838 6.92-8.44a.173.173 0 01.11-.036.24.24 0 01.024.001.234.234 0 01.022 0c.044 0 .08.012.112.036l.004.002.005.002.005.002.005.002.005.002.006.003c.824.39 2.78 2.946 4.403 5.143-.171.217-.356.43-.555.636-1.476-1.918-3.022-3.805-3.703-4.093v-.024c.01-.008.025-.012.015-.012h-.015a.17.17 0 00-.015 0c-.01 0 .005.004.015.012v.024c-1.37.581-6.259 7.652-6.993 8.387-.129.01-.259.019-.389.027"
        ></path>
        <path
          fill="#275437"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M81.35 140.317l.933.278c2.295.685 4.635 1.11 6.107 1.11.616 0 .926-.072 1.066-.124-.83-2.9-5.882-17.72-7.284-20.808-.8-1.765-1.107-2.184-1.273-2.318-.224-.21-.645-.255-.954-.255-.122 0-.256.006-.397.02-1.06.1-2.658 1.22-4.508 2.515-3.853 2.699-9.678 6.776-17.812 6.776l-.179-.001c-5.322-.039-9.057-.312-11.528-.492a77.864 77.864 0 00-2.13-.138c2.893 2.3 13.525 9.298 17.024 10.386 2.366.736 3.393 1.381 3.665 2.303.269.907-.331 1.729-.97 2.494-1.027 1.235-9.224 9.559-13.204 10.82l-.092.03c.918.437 3.459 1.016 7.415 1.016 2.458 0 5.012-.22 7.593-.653 9.347-1.57 15.38-5.32 16.75-6.239l-.223-6.72m-33.222 12.706c-.068-.455.108-1.08 1.356-1.475 3.31-1.051 11.052-8.58 12.552-10.383.192-.23.779-.935.7-1.198-.047-.17-.415-.643-2.737-1.363-4.14-1.29-16.93-9.896-18.262-11.315-.147-.159-.603-.643-.358-1.209.268-.613 1.053-.613 1.521-.613.61 0 1.496.064 2.724.153 2.454.18 6.159.449 11.435.488h.17c7.691 0 13.077-3.768 17.008-6.521 2.096-1.467 3.752-2.626 5.178-2.763 1.13-.108 1.912.112 2.388.56.36.273.744.82 1.645 2.81 1.442 3.174 6.69 18.577 7.397 21.145.107.387.248.966.522 1.511.137.275-11.026 8.967-26.31 11.808-3.062.569-5.292.672-7.827.672-3.248 0-8.819-.485-9.102-2.308"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18083)">
            <path
              fill="url(#linearGradient18091)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M8385.36 5075.97c-185.35.01-289.02 44.47-213.43 68.45 101.81 32.28 327.77 255.77 365.05 300.5 37.25 44.71 44.69 69.53-67.07 104.28-111.76 34.78-471.77 275.64-509.06 315.39-12.82 13.65-7.72 18.2 18.44 18.2 49.9 0 176.41-16.57 401.23-18.2-224.8 1.62-351.18 18.16-401.1 18.16-1.34 0-2.63-.01-3.86-.03 71.17-16.88 205.99-46.51 404.96-47.92 1.67-.01 3.31-.01 4.98-.01 132.82 0 242.34 38.75 332.7 86.55 0-3.02.02-5.98.05-8.99-43.2-85.13-8.2-205.91 6.51-255.47 25.99-87.53 142.55-354.62 208.37-464.44 2.76 1.15 5.46 2.29 8.13 3.43-82.76-37.14-196.79-77.5-337.28-101.09-80.02-13.44-154.23-18.81-218.62-18.81m.11 788.6c-1.34 0-2.7.01-4.04.01 1.32 0 2.61-.01 3.92-.01 133.27.01 243.05 39.01 333.58 87.02v-.08c-90.5-47.97-200.29-86.94-333.46-86.94"
            ></path>
          </g>
        </g>
        <path
          fill="#f6f254"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M49.752 152.215c3.592-1.14 11.563-9.024 12.878-10.601.315-.38.57-.717.72-1.031.374.601-.019 1.242-.72 2.082-1.315 1.577-9.286 9.462-12.878 10.601-.156.05-.28.1-.393.155-.72-.42-.666-.87.393-1.206"
        ></path>
        <path
          fill="#f6f254"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M79.538 118.573c-3.678.35-10.336 9.374-22.427 9.286-7.02-.05-11.775-1.095-14.286-1.69 1.66-.033 6.142.581 14.286.64 12.09.087 18.749-8.936 22.427-9.288 2.294-.217 2.478 1.131 2.288 2.176-.157-.705-.74-1.27-2.288-1.124"
        ></path>
        <path
          fill="#275437"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M88.962 137c-1.778-5.443-4.648-13.565-7.07-17.37l-.166-.04s-.55-2.094-4.133-.21c-3.36 1.765-6.027 4.106-8.323 5.311-1.892 3.012-.56 7.611-.015 9.445.917 3.088 5.029 12.51 7.35 16.384 4.21-1.758 5.737-3.124 5.737-3.124l7.57-5.075s-.355-2.16-.95-5.321"
        ></path>
        <path
          fill="#275437"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M124.819 147.037c1.369.918 7.401 4.669 16.75 6.239 2.579.433 5.133.653 7.591.653 3.959 0 6.499-.58 7.416-1.016l-.088-.03c-3.983-1.261-12.178-9.585-13.212-10.82-.635-.766-1.231-1.587-.966-2.494.271-.922 1.298-1.567 3.665-2.304 3.5-1.088 14.132-8.086 17.025-10.385-.536.022-1.242.073-2.13.138-2.47.18-6.206.453-11.526.491l-.184.001c-8.131 0-13.955-4.076-17.808-6.775-1.852-1.296-3.45-2.415-4.512-2.516a4.204 4.204 0 00-.395-.02c-.31 0-.73.045-.952.255-.166.135-.473.554-1.274 2.318-1.404 3.09-6.456 17.909-7.285 20.809.141.052.452.124 1.07.124 1.47 0 3.81-.426 6.102-1.11l.935-.279-.222 6.72m24.341 8.294c-2.536 0-4.766-.104-7.824-.673-15.286-2.84-26.448-11.532-26.31-11.807.271-.546.416-1.125.518-1.51.71-2.57 5.959-17.973 7.398-21.147.903-1.99 1.288-2.536 1.648-2.81.472-.448 1.255-.667 2.384-.56 1.429.138 3.084 1.297 5.18 2.763 3.933 2.753 9.316 6.522 17.006 6.522h.173a161 161 0 0011.434-.489c1.228-.089 2.113-.153 2.727-.153.466 0 1.252 0 1.517.614.247.565-.208 1.05-.357 1.209-1.333 1.419-14.121 10.025-18.263 11.315-2.318.72-2.688 1.192-2.734 1.362-.081.264.505.968.699 1.198 1.502 1.803 9.242 9.332 12.551 10.384 1.25.394 1.426 1.02 1.355 1.474-.279 1.823-5.852 2.308-9.102 2.308"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18109)">
            <path
              fill="url(#linearGradient18117)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M10988.3 5075.97c-64.4 0-138.6 5.37-218.6 18.81-140.7 23.63-254.9 64.1-337.7 101.29 2.8-1.2 5.7-2.41 8.6-3.63 65.8 109.82 182.4 376.91 208.4 464.44 14.7 49.58 49.7 170.44 6.4 255.59.1 2.97.1 5.89.1 8.88 90.3-47.8 199.9-86.56 332.7-86.56 1.6 0 3.3 0 4.9.01 19.7.14 38.8.56 57.2 1.21 9.4-40.47 34.5-75.52 69-99.36l-57.5-86.07c15.7 17.62 41.3 47.09 68.8 78.86 17.8-10.46 37.7-18.1 59.1-22.23-109.6-70.26-229.5-140.44-285.9-158.01-111.8-34.75-104.3-59.57-67.1-104.28 37.3-44.73 263.3-268.22 365-300.5 75.7-23.98-28-68.45-213.4-68.45m418.2 782.57c.3 4.32.5 8.68.5 13.09 0 3.59-.1 7.15-.4 10.68 15.2-1.48 16.7-6.56 6.2-17.72-1.5-1.67-3.7-3.7-6.3-6.05m-418.3 6.03c-133.2 0-242.9 38.97-333.4 86.93v.09c90.5-48.01 200.3-87.02 333.5-87.02 1.3 0 2.6.01 3.9.01-1.3 0-2.7-.01-4-.01m4.9.02c18.4.13 36.2.37 53.3.68-17.1-.32-34.9-.55-53.3-.68"
            ></path>
          </g>
        </g>
        <path
          fill="#f6f254"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M156.636 152.215c-3.588-1.14-11.56-9.024-12.877-10.601-.314-.38-.568-.717-.72-1.031-.373.601.022 1.242.72 2.082 1.316 1.577 9.29 9.462 12.877 10.601.159.05.286.1.395.155.723-.42.667-.87-.395-1.206"
        ></path>
        <path
          fill="#f6f254"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M126.85 118.573c3.68.35 10.337 9.374 22.427 9.286 7.024-.05 11.776-1.095 14.287-1.69-1.658-.033-6.141.581-14.287.64-12.09.087-18.747-8.936-22.426-9.288-2.293-.217-2.477 1.131-2.29 2.176.163-.705.745-1.27 2.29-1.124"
        ></path>
        <path
          fill="#275437"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M117.425 137c1.781-5.443 4.653-13.565 7.073-17.37l.166-.04s.55-2.094 4.134-.21c3.359 1.765 6.026 4.106 8.322 5.311 1.895 3.012.561 7.611.018 9.445-.917 3.088-5.03 12.51-7.352 16.384-4.209-1.758-5.74-3.124-5.74-3.124l-7.57-5.075s.36-2.16.949-5.321"
        ></path>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M104.58 102.344c-1.549-1.21-1.266-4.613-1.281-5.573v.921c0-.149-.01-.307-.01-.341v-.58c-.002.275-.022.712-.086 1.217 0 0-.452 3.412-1.27 4.12-1.56 1.365-5.117 1.354-5.104 1.344.002-.002.124-.004.399.003 6.009.127 6.009 5.991 6.06 7.915v-.968c.006.07.011.128.011.162v.806c.128-4.554.114-7.433 5.356-7.818 1.736-.133-2.265.2-4.075-1.208"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18135)">
            <path
              fill="url(#linearGradient18143)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9959.87 5017.47c-13.8 9.94-30.32 18.58-49.9 25.31a154.628 154.628 0 01-33.61 7.52c.22 3.73.33 7.48.33 11.26 0 .87-.01 1.72-.02 2.58 409.43 83.16 716.93 436.07 716.93 858.85 0 24.61-1.1 48.98-3.1 73.07-14.5 170.99-79.4 328.06-180.3 457.15.4.24.7.46 1.1.7-164.8 210.44-425.1 346.39-718.16 346.39h-1.98c-144.71 0-281.5-33.14-402.72-92.02 13.26 25.01 22.67 42.82 23.46 44.53l.01.01c-.17 0-16.09-21.89-37.57-51.53a912.06 912.06 0 01-41.57-22.47c-21.18 8.14-44.39 12.63-68.72 12.63-15.6 0-30.75-1.85-45.19-5.32 1.67 1.18 3.29 2.32 4.96 3.49a973.716 973.716 0 00156.73 89.48 965.997 965.997 0 0063 25.95c9.06 3.37 18.21 6.62 27.4 9.72 63.92 21.6 130.94 36.84 200.27 44.88l3.38.4c17.07 1.99 35.63 3.6 53.36 4.65l3.16.19c19.57 1.13 37.95 1.68 55.73 1.68h1.93c2.87 0 5.7-.09 8.53-.22l3.07-.08c13.4-.21 26.6-.47 39.69-1.16 10.13-.52 20.21-1.38 30.35-2.22l5.68-.48c4.87-.37 9.75-.78 14.57-1.31 12.41-1.26 25-2.85 37.58-4.63l10.2-1.51c56.45-8.53 111.48-21.77 164.65-39.43 9.2-3.06 18.3-6.25 27.4-9.58 5.3-1.91 10.5-3.88 15.7-5.89 4.1-1.56 8.1-3.14 12.1-4.75a968.834 968.834 0 00154.1-78.25 964.57 964.57 0 00148.1-114.26c35.4-33.24 68.4-69.31 98.7-108.01l10.1-14.61 1-1.47 31.3-45.38c24-36.15 45.3-73.74 63.8-112.51 4.8-9.89 9.3-19.86 13.7-29.9a924.12 924.12 0 0037.8-103.56c16.2-54.24 27.3-109.89 33.2-166.62l.3-2.38c1.4-14.25 2.5-28.55 3.3-42.93.5-7.93.8-15.88 1.1-23.84v-.09c.1-2.86.1-5.73.2-8.6l.2-6.24c.1-4.54.3-9.06.3-13.67v-1.64c0-2.99 0-5.91-.1-8.88-3-266.63-120.1-507.13-305.9-677.15-6.1-5.57-12.2-11.03-18.4-16.46-6.8-5.91-13.8-11.77-20.7-17.5-36.4-29.89-75.1-57.21-115.7-81.7a978.418 978.418 0 00-172.1-81.9 982.396 982.396 0 00-62.73-20.29m-665.85 42.95a982.592 982.592 0 00-57.54 27.23 973.615 973.615 0 00-180.57 119.86 902.91 902.91 0 00-13.3 11.34 962.72 962.72 0 00-18.45 16.47c-185.75 170-302.86 410.45-305.91 677.03-.03 3.01-.05 5.97-.05 8.99-.01.54-.01 1.11-.01 1.65 0 4.2.12 8.29.31 12.46l.16 6.74 36.6-.17 2.76-.01-2.69.05-36.63.76c.06 2.91.14 5.78.23 8.69v.08c.25 7.97.6 15.93 1.05 23.85a910.076 910.076 0 0024.52 164.19c2.22 9.12 4.57 18.15 7.07 27.17a923.008 923.008 0 0039.15 112.44c26.23 62.12 59.1 121.05 97.77 175.92a958.854 958.854 0 0081.66 100.63 937.01 937.01 0 0020.71 21.6c1.27 1.28 2.53 2.55 3.8 3.82a157.403 157.403 0 01-10.94-57.76c0-16.35 2.51-32.16 7.19-47.1-126.35-150.96-202.11-343.56-202.11-553.36 0-371.11 236.99-688.4 571.78-816.66-25.87-10.35-48.62-26.17-66.56-45.91"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18153)">
            <path
              fill="url(#linearGradient18159)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9690.97 6743.04c-465.39 0-844.18-367.85-844.18-820.05 0-452.24 378.73-820.17 844.37-820.17 463.94 0 842.74 366.48 844.44 817.09l.1 2.6c0 180.94-59.3 352.22-171.4 495.63l-29.2 37.39c-151 171.74-367.16 275.46-600.19 286.47l-2.3.11c-6.18.28-12.33.51-18.44.65-2.58.07-5.04.1-7.44.1l-8.11.13c-1.78.05-3.59.05-5.48.05h-2.17"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18169)">
            <path
              fill="url(#linearGradient18175)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9872.68 5100.45c-9.54 45.67-35.55 85.37-71.51 112.58 301.93 43.99 543.93 266.24 608.93 553.11 65 39.74 125.7 84.68 181.1 134.12-27.5-397.18-326.7-721.98-718.52-799.81m-370.32 6.07c-21.71 8.61-45.6 13.38-70.67 13.38-.43 0-.86 0-1.29-.01-348.78 102.26-608.4 404.33-638.41 769.35 55.89-48.51 116.85-92.49 182.14-131.29 67.18-280.63 304.1-497.83 599.8-543.83-35.09-26.04-60.92-63.88-71.57-107.6"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18185)">
            <path
              fill="url(#linearGradient18191)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M8974.13 5757.95c-65.29 38.8-126.25 82.78-182.14 131.29-.72 8.84-1.32 17.77-1.77 26.68 9.8 196.46 86.03 375.97 207.32 517.73.24-.14.47-.27.71-.41-90.03-111.48-153.56-255.39-151.46-348.09.6-27.7 4.51-38.89 10.55-38.89 20.02 0 63.53 122.6 88.82 174.77 9.07 18.72 28.15 48.01 53.53 81.94l-.38-.57c15.71 17.63 41.32 47.09 68.75 78.86 13.08-7.67 27.3-13.83 42.36-18.2-97.46-121.4-155.53-274.16-155.53-440.07 0-9.01.17-17.97.51-26.9 1.66-47.36 8.05-93.55 18.73-138.14m1435.97 8.19c11.3 49.84 17.3 101.64 17.3 154.78v2.07c0 171.56-62.1 329.06-165.7 452.37 41.6 18.54 81.8 39.02 120.6 61.32 122.7-142.14 199.9-322.67 209.8-520.4-.2-5.36-.5-10.68-.9-16.02-55.4-49.44-116.1-94.38-181.1-134.12m-1621.3 156.85c0 209.8 75.76 402.4 202.11 553.36.01-.01.01-.03.01-.04-125.38-149.81-200.91-340.63-202.05-548.57-.04-1.58-.07-3.16-.07-4.75m444 755.82c-.01.01-.02.01-.03.01a912.06 912.06 0 0041.57 22.47c-.01-.01-.01-.02-.02-.03a904.718 904.718 0 01-41.52-22.45m55.62 29.45l.02.02c121.22 58.88 258.01 92.02 402.72 92.02-144.7 0-281.49-33.14-402.74-92.04"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18201)">
            <path
              fill="url(#linearGradient128959)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M10261.7 6375.36c-134.8 160.58-339.84 263.18-569.57 263.47h-1.06c-126.44 0-245.46-31.01-349.41-85.62-4.41 22.95-13.82 44.28-27.15 62.99-.87 2.16-2.29 4.08-4.26 5.71-9.06 11.64-19.68 22.16-31.58 31.28 123.61 61.93 263.89 96.91 412.55 96.91 277.47 0 525.58-121.81 691.08-313.42-38.8-22.3-79-42.78-120.6-61.32m-1263.45 57.88c-.24.14-.47.27-.71.41 2.7 3.15 5.42 6.29 8.16 9.4.08-.15.17-.29.25-.43-2.59-3.1-5.15-6.22-7.7-9.38"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18217)">
            <path
              fill="url(#linearGradient128961)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M10410.2 6453.21c-164.7 210.7-425.04 346.83-718.12 347.09h1.06c293.06 0 553.36-135.95 718.16-346.39-.4-.24-.7-.46-1.1-.7"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18235)">
            <path
              fill="url(#linearGradient128963)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M10590.5 5996.06c-14.5 170.99-79.4 328.06-180.3 457.15 100.9-129.09 165.8-286.16 180.3-457.15"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18253)">
            <path
              fill="url(#linearGradient128965)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M10592.1 5916.28c-9.9 197.73-87.1 378.26-209.8 520.4 9.3 5.4 18.7 10.92 27.9 16.53 100.9-129.09 165.8-286.16 180.3-457.15 2-24.09 3.1-48.46 3.1-73.07 0 6.19-.4 12.33-.5 18.52-.2-8.43-.5-16.86-1-25.23"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18287)">
            <path
              fill="url(#linearGradient128967)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M8790.22 5915.92c-.44 8.51-.75 17.02-.93 25.59-.05-4.61-.29-9.18-.42-13.77 1.14 207.94 76.67 398.76 202.05 548.57.18-.57.36-1.14.55-1.7a910.676 910.676 0 01-20.43-25.48c8.76-5.25 17.59-10.42 26.5-15.48-121.29-141.76-197.52-321.27-207.32-517.73m443.75 762.44l-1.17.45a904.718 904.718 0 0041.52 22.45c-.38-.53-.76-1.05-1.15-1.59a902.043 902.043 0 01-39.2-21.31m53.77 28.61c.23.43.46.86.68 1.29 121.25 58.9 258.04 92.04 402.8 92.04h.83c-145.4-.17-282.72-33.77-404.31-93.33"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18303)">
            <path
              fill="url(#linearGradient18311)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M10410.2 6453.21c-164.7 210.68-425.07 346.81-718.15 347.09h.03c293.08-.26 553.42-136.39 718.12-347.09"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18321)">
            <path
              fill="url(#linearGradient18327)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M8997.54 6433.65c-8.91 5.06-17.74 10.23-26.5 15.48 6.66 8.62 13.47 17.11 20.43 25.48 3.6-11.05 8.39-21.61 14.23-31.56a915.31 915.31 0 01-8.16-9.4m1384.76 3.03c-165.5 191.61-413.61 313.42-691.08 313.42-148.66 0-288.94-34.98-412.55-96.91-4.57 3.5-9.33 6.8-14.26 9.88 8.36 15.71 16.35 30.75 23.33 43.9 121.59 59.56 258.91 93.16 404.31 93.33 293.08-.28 553.45-136.41 718.15-347.09-9.2-5.61-18.6-11.13-27.9-16.53m-1130.44 233.56c-5.78 3-11.75 5.71-17.89 8.12a902.043 902.043 0 0039.2 21.31c-6.69-9.23-13.9-19.19-21.31-29.43"
            ></path>
          </g>
        </g>
        <path
          fill="#f7ef43"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M103.347 154.393c-17.353 0-31.455-13.508-31.816-30.298-.002.218-.017.435-.017.653 0 17.096 14.254 30.953 31.833 30.953 17.58 0 31.836-13.857 31.836-30.953 0-.218-.014-.435-.017-.653-.36 16.79-14.464 30.298-31.819 30.298"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18339)">
            <path
              fill="url(#linearGradient18345)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9727.42 5247.05a189.844 189.844 0 01-40.59 4.37c-13.33 0-26.35-1.38-38.91-4.01-153.18 8.63-293.72 62.8-407.62 148.82-5.02 33.73-7.65 68.2-7.65 103.28 0 20.68.9 41.16 2.67 61.4l63.9-191.61h562.88l212.7.23 251.8 755.47-1.7 1.17c5.9-3.18 11.7-6.43 17.5-9.76 26.7-74.02 41.2-153.6 41.2-236.46 0-101.81-21.9-198.63-61.3-286.29-122.8-198.72-342.07-334.68-594.88-346.61m699.98 674.76v0m-735.59 717.02H9691.12 9691.81"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18355)">
            <path
              fill="url(#linearGradient18361)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M10322.3 5593.66c39.4 87.66 61.3 184.48 61.3 286.29 0 82.86-14.5 162.44-41.2 236.46a731.24 731.24 0 0068.9-44.8c-70.2 323.68-365.4 566.75-719.17 567.22 406.17-.51 735.27-320.88 735.27-715.84v-1.18-.09c-.1 6.66-.3 13.21-.5 19.79-3.7-127-41.4-245.71-104.6-347.85m-630.49 1045.17h-.69H9691.81"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18371)">
            <path
              fill="url(#linearGradient18377)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M8955.4 5896.09c-.34 8.93-.51 17.89-.51 26.9 0 165.91 58.07 318.67 155.53 440.07.02 0 .04-.01.06-.01-97.45-121.41-155.51-274.15-155.51-440.06v-1.34-.73c0-8.3.15-16.59.43-24.83"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18387)">
            <path
              fill="url(#linearGradient18393)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9341.67 6553.17c0 .01-.01.03-.01.04 103.95 54.61 222.97 85.62 349.41 85.62h.05-2.85c-.27-.01-.53-.01-.81-.01h-1.23c-.16-.01-.31-.01-.47-.01h-.76c-.16 0-.33-.01-.49-.01h-.74c-.17-.01-.32-.01-.49-.01-.25 0-.5 0-.75-.01h-.49c-.25-.01-.5-.01-.75-.01-.16 0-.3-.01-.45-.01-.28 0-.53 0-.8-.01-.14 0-.3 0-.44-.01-.25 0-.56 0-.8-.01h-.42c-.27-.01-.57-.01-.85-.02-.13 0-.25 0-.38-.01-.3 0-.6-.01-.89-.01-.11 0-.22-.01-.32-.01-.33 0-.68-.01-1-.02h-.23l-1.2-.03h-.01c-2.93-.07-5.86-.15-8.78-.25h-.02c-.41-.02-.82-.03-1.24-.05h-.01c-.41-.01-.82-.03-1.23-.04h-.03c-115.69-4.36-224.52-34.67-320.52-85.12m350.46 85.66h-.32.32"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18403)">
            <path
              fill="url(#linearGradient18409)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9240.3 5396.23c-168.25 127.05-278.28 323.57-284.7 545.28-.27-6.6-.61-13.17-.63-19.86v1.34c0 165.91 58.06 318.65 155.51 440.06 16.93-4.9 34.92-7.54 53.57-7.54 99.59 0 180.43 75.21 180.43 167.94 0 3.01-.08 6-.25 8.97 92.43 40.68 195.04 63.33 303.14 63.33 321.37 0 594.63-200.2 695.03-479.34-5.8 3.33-11.6 6.58-17.5 9.76l-7.5 5.24-.7-.9.7.9-621.78 431.48-.07.06-8.57 5.99-639.81-443.89 188.15-564.14a704.696 704.696 0 01-2.67-61.4c0-35.08 2.63-69.55 7.65-103.28m101.37 1156.92v.02c96 50.45 204.83 80.76 320.52 85.12-115.68-4.36-224.5-34.67-320.52-85.14m320.55 85.14c.41.01.82.03 1.23.04-.41-.01-.82-.03-1.23-.04m1.24.04c.42.02.83.03 1.24.05-.41-.02-.82-.03-1.24-.05M9673.51 6638.63l1.2.03-1.2-.03m2.75.06c.29 0 .59.01.89.01-.3 0-.59-.01-.89-.01m1.27.02c.28.01.58.01.85.02-.28-.01-.57-.01-.85-.02m1.27.02c.24.01.55.01.8.01-.26 0-.54 0-.8-.01m1.24.02c.27.01.52.01.8.01-.27 0-.54 0-.8-.01m1.25.02c.25 0 .5 0 .75.01-.25-.01-.5-.01-.75-.01m1.24.01c.25.01.5.01.75.01-.25 0-.5 0-.75-.01m1.24.02h.74-.74m1.23.01h.76-.76m1.23.01h.77-.77m1.23 0c.28 0 .54 0 .81.01-.28-.01-.53-.01-.81-.01m1.24.01h.88-.88m1.23 0h1.19-1.19"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18419)">
            <path
              fill="url(#linearGradient18425)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M10411.3 6071.61c-22 16.13-45 31.11-68.9 44.8-100.4 279.14-373.66 479.34-695.03 479.34-108.1 0-210.71-22.65-303.14-63.33-.4 7.03-1.26 13.96-2.56 20.73 96.02 50.47 204.84 80.78 320.52 85.14h.03c.41.01.82.03 1.23.04h.01c.42.02.83.03 1.24.05h.02c2.92.1 5.85.18 8.78.25h.01l1.2.03h.23c.33.01.67.02 1 .02.1 0 .21.01.32.01.3 0 .59.01.89.01.13.01.25.01.38.01.28.01.57.01.85.02h.42c.26.01.54.01.8.01.14.01.3.01.44.01.26.01.53.01.8.01.15 0 .29.01.45.01.25 0 .5 0 .75.01h.49c.25.01.5.01.75.01.17 0 .32 0 .49.01h.74c.16 0 .33.01.49.01h.76c.16 0 .31 0 .47.01h1.23c.28 0 .53 0 .81.01h3.86c353.77-.47 648.97-243.54 719.17-567.22"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18435)">
            <path
              fill="url(#linearGradient18441)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9801.17 5213.03c-21.49 16.27-46.54 28.07-73.75 34.02 252.81 11.93 472.08 147.89 594.88 346.61 63.2 102.14 100.9 220.85 104.6 347.85.2-6.58.4-13.13.5-19.79v-.8c0-53.14-6-104.94-17.3-154.78-65-286.87-307-509.12-608.93-553.11m-227.24 1.09c-295.7 46-532.62 263.2-599.8 543.83-10.68 44.59-17.07 90.78-18.73 138.14-.28 8.24-.43 16.53-.43 24.83v.73c.02 6.69.36 13.26.63 19.86 6.42-221.71 116.45-418.23 284.7-545.28 113.9-86.02 254.44-140.19 407.62-148.82-27.25-5.7-52.37-17.26-73.99-33.29"
            ></path>
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M99.073 95.833c1.483-.112 3.01.451 2.269 1.096-.742.643-5.749 3.533-7.937 1.747-2.187-1.787 3.925-2.709 5.668-2.843"
        ></path>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M81.85 103.703c-4.64 3.901-8.385 11.112-8.29 15.325.092 4.212 2.344-2.397 3.505-4.794 1.162-2.396 6.973-9.708 11.185-11.922 4.211-2.214.853-4.71-6.4 1.39"
        ></path>
        <path
          fill="#ef391f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M108.338 161.8s1.156 2.674 3.903 1.951c2.746-.723 3.254-5.783-1.373-7.373-4.627-1.59-9.614 4.337-6.217 9.18 2.492 3.553 9.572 2.557 7.23 2.024-3.181-.723-5.856-6.723-3.543-5.783"
        ></path>
        <path
          fill="#ef391f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M111.328 163.264a3 3 0 00.758-.104c.932-.245 1.587-1.199 1.63-2.372.05-1.33-.725-3.035-3.047-3.833a4.212 4.212 0 00-1.372-.23c-1.821 0-3.603 1.166-4.542 2.97-.94 1.806-.795 3.815.396 5.512 1.085 1.546 3.24 2.188 5.077 2.294-2.049-1.364-3.5-4.19-3.362-5.423.068-.6.478-.99 1.047-.99.201 0 .415.048.654.145l.233.095.099.229c.03.067.774 1.707 2.429 1.707m-2.031-7.76c.602 0 1.197.1 1.77.296 2.953 1.015 3.934 3.266 3.87 5.033-.063 1.716-1.084 3.126-2.54 3.509a4.216 4.216 0 01-1.07.144c-1.677 0-2.695-1.086-3.189-1.81.08.311.248.753.558 1.302.674 1.193 1.948 2.697 3.32 3.008.673.154.99.458.94.906-.045.394-.332.847-2.179.847-2.243 0-5.162-.744-6.626-2.83-1.46-2.083-1.636-4.553-.48-6.777 1.147-2.204 3.355-3.628 5.626-3.628"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18459)">
            <path
              fill="url(#radialGradient18467)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9901.76 4693.34c-51.25 0-133.47 15.57-173.65 72.84-24.27 34.61-33.44 71.17-31.48 105.78 90.59 4.62 164.62 73.05 177.93 161.12 9.91-1.08 19.88-3.27 29.79-6.67 131.15-45.08 116.75-188.52 38.92-209.01-9.27-2.44-17.89-3.51-25.91-3.51-59.29 0-84.73 58.84-84.73 58.84-4.75 1.93-8.74 2.83-12.06 2.83-42.46 0 28.83-147.74 112.47-166.75 28.64-6.51 7.59-15.47-31.28-15.47m-124.3 181.41c-21.45 0-58.16-38.52-38.95-81.83 26.87-60.63 111.22-92.78 160.1-92.79 2.11 0 4.14.06 6.11.18 0 0-125.53 84.27-114.28 146.61 3.55 19.65-3.1 27.83-12.98 27.83m140.57 90.91c-53.15 0-75.66-65.18-45.34-106.57 0 0 11.34-24.32 48.07-24.33 9.79 0 21.37 1.73 35.03 6.1 64.91 20.77 35.49 113.38-25.97 123.78-4.08.69-8.02 1.02-11.79 1.02"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18477)">
            <path
              fill="url(#radialGradient18485)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9920.76 4834.76c-36.73.01-48.07 24.33-48.07 24.33-30.32 41.39-7.81 106.57 45.34 106.57 3.77 0 7.71-.33 11.79-1.02 61.46-10.4 90.88-103.01 25.97-123.78-13.66-4.37-25.24-6.1-35.03-6.1"
            ></path>
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M111.156 162.74c.944.51 2.596-.946 1.802-1.71-.794-.763-3.352.873-1.802 1.71"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18497)">
            <path
              fill="url(#radialGradient18505)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9898.61 4700.13c-48.88.01-133.23 32.16-160.1 92.79-19.21 43.31 17.5 81.83 38.95 81.83 9.88 0 16.53-8.18 12.98-27.83-11.25-62.34 114.28-146.61 114.28-146.61-1.97-.12-4-.18-6.11-.18"
            ></path>
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M109.446 167.413s-2.352-1.87-2.535-2.798c-.183-.928-.993.813-.153 1.638.84.824 2.688 1.16 2.688 1.16"
        ></path>
        <path
          fill="#ef391f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M98.053 161.8s-1.158 2.674-3.905 1.951c-2.746-.723-3.252-5.783 1.374-7.373 4.626-1.59 9.614 4.337 6.217 9.18-2.493 3.553-9.572 2.557-7.23 2.024 3.182-.723 5.856-6.723 3.544-5.783"
        ></path>
        <path
          fill="#ef391f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M97.492 161.557l.099-.23.231-.094c.24-.097.454-.144.655-.144.569 0 .98.388 1.047.989.138 1.233-1.314 4.06-3.362 5.423 1.837-.106 3.992-.748 5.076-2.294 1.191-1.697 1.336-3.706.397-5.511-.938-1.805-2.721-2.97-4.542-2.97a4.22 4.22 0 00-1.372.23c-2.322.797-3.096 2.502-3.047 3.832.043 1.173.699 2.127 1.63 2.372.262.069.517.104.759.104 1.653 0 2.399-1.64 2.429-1.707m5.226-2.425c1.156 2.224.982 4.694-.48 6.777-1.463 2.086-4.381 2.83-6.625 2.83-1.846 0-2.134-.453-2.178-.847-.05-.448.266-.752.94-.906 1.372-.311 2.645-1.815 3.32-3.008.308-.549.476-.991.556-1.303-.493.725-1.511 1.81-3.188 1.81-.347 0-.707-.048-1.07-.143-1.455-.383-2.477-1.793-2.54-3.51-.065-1.766.918-4.017 3.87-5.032a5.432 5.432 0 011.77-.296c2.271 0 4.48 1.424 5.625 3.628"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18521)">
            <path
              fill="url(#radialGradient18529)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9471.92 4693.34c-38.87 0-59.91 8.96-31.27 15.47 54.96 12.49 104.58 80.55 120.11 125.77 8.03 7.65 15.28 16.01 21.63 24.97-.28-3.53-.03-7.72.86-12.63 11.25-62.34-114.28-146.61-114.28-146.61 1.97-.12 4-.18 6.11-.18 48.88 0 133.24 32.16 160.1 92.79 19.19 43.31-17.51 81.83-38.96 81.83-1.64 0-3.2-.23-4.63-.7a162.31 162.31 0 018.91 18.45c23.17-11.89 49.11-19.14 76.55-20.54 1.96-34.61-7.22-71.17-31.49-105.78-40.18-57.27-122.4-72.84-173.64-72.84"
            ></path>
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M95.234 162.74c-.944.51-2.596-.946-1.801-1.71.793-.763 3.35.873 1.801 1.71"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18541)">
            <path
              fill="url(#radialGradient18549)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9475.08 4700.13c-2.11 0-4.14.06-6.11.18 0 0 125.53 84.27 114.28 146.61-.89 4.91-1.14 9.1-.86 12.63 3.31 4.68 6.39 9.52 9.2 14.5 1.43.47 2.99.7 4.63.7 21.45 0 58.15-38.52 38.96-81.83-26.86-60.63-111.22-92.79-160.1-92.79"
            ></path>
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M96.944 167.413s2.352-1.87 2.535-2.798c.184-.928.993.813.153 1.638-.84.824-2.688 1.16-2.688 1.16"
        ></path>
        <path
          fill="#ef391f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M103.195 149.851a5.293 5.293 0 00-5.287 5.287 5.292 5.292 0 005.287 5.286 5.293 5.293 0 005.286-5.286 5.293 5.293 0 00-5.286-5.287"
        ></path>
        <path
          fill="#ef391f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M103.195 151.262a3.88 3.88 0 00-3.876 3.876 3.88 3.88 0 003.876 3.875 3.88 3.88 0 003.875-3.875 3.88 3.88 0 00-3.875-3.876m0 10.573a6.705 6.705 0 01-6.698-6.697 6.705 6.705 0 016.698-6.698 6.706 6.706 0 016.697 6.698 6.706 6.706 0 01-6.697 6.697"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18565)">
            <path
              fill="url(#linearGradient18573)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9684.32 4924.1c-26.36 0-51.08 6.95-72.44 19.12.14 2.48.22 4.99.23 7.5 1.29-.81 2.58-1.6 3.89-2.37l.21-.12c8.19-4.77 16.93-8.71 26.1-11.7 13.14-4.29 27.15-6.64 41.72-6.64H9684.32c73.85 0 133.88 59.09 135.44 132.54v.08c.01.15.01.31.01.46v.12c.01.35.02.7.02 1.06V5065.37c0 47.7-24.63 89.64-61.86 113.78.19.37.39.74.58 1.1 9.04-5.65 17.38-12.3 24.89-19.8 25.32-25.32 40.96-60.25 40.96-98.89 0-38.62-15.63-73.53-40.93-98.86-26.08-23.96-60.87-38.6-99.11-38.6m-134.79 155.01c-1.13.91-2.28 1.81-3.44 2.69 4.43 30.53 18.7 57.84 39.52 78.65 23.65 23.65 55.69 38.86 91.3 40.76.09-.17.19-.35.29-.53-66.96-3.46-121.03-55.5-127.67-121.57m204.85 102.85c-20.17 11.93-43.62 18.91-68.79 18.91h-1.27c-1.54 0-3.07-.03-4.6-.08l-.44.53c1.73.06 3.47.1 5.22.1 25.63-.01 49.63-6.89 70.28-18.91l-.4-.55"
            ></path>
          </g>
        </g>
        <path
          fill="#294231"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M108.223 155.138h-.177a4.917 4.917 0 01-1.445 3.488 4.919 4.919 0 01-3.489 1.445 4.918 4.918 0 01-3.488-1.445 4.917 4.917 0 01-1.446-3.488c0-1.363.553-2.596 1.446-3.489a4.918 4.918 0 013.488-1.445c1.364 0 2.596.552 3.49 1.445a4.916 4.916 0 011.444 3.489h.353a5.287 5.287 0 10-10.575.001 5.287 5.287 0 0010.575-.001h-.176"
        ></path>
        <path
          fill="#216f39"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M108.271 155.069a5.178 5.178 0 00-2.512-4.184l.106-.201a5.174 5.174 0 012.418 4.381c0-.043-.005-.085-.007-.127a5.61 5.61 0 01-.005.13m-10.231-.784l-.048-.033a5.179 5.179 0 017.777-3.626l-.135.187a5.144 5.144 0 00-2.747-.654l-.191-.23c.033.068.073.146.121.233a5.174 5.174 0 00-4.777 4.123"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18587)">
            <path
              fill="url(#linearGradient18595)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9684.5 4921.71c-26.63 0-51.51 7.44-72.69 20.35.03.39.05.77.07 1.16 21.36-12.17 46.08-19.12 72.44-19.12 38.24 0 73.03 14.64 99.11 38.6l-.03-.03c-25.33-25.31-60.26-40.96-98.9-40.96"
            ></path>
          </g>
        </g>
        <path
          fill="#212723"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M103.106 160.242a5.15 5.15 0 01-2.574-.685c.007-.067.012-.135.016-.204a4.91 4.91 0 002.564.718 4.919 4.919 0 003.49-1.445c.97-.893 1.6-2.151 1.669-3.557l.005.129c.001-.045.007-.088.007-.133a5.177 5.177 0 01-5.177 5.177"
        ></path>
        <path
          fill="#294b34"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M108.276 155.198l-.005-.13.005-.13c.001.042.007.084.007.127 0 .045-.005.088-.007.133"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18609)">
            <path
              fill="url(#linearGradient18617)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9684.32 4929.89h-.16c25.01.03 48.36 6.96 68.47 18.79l-15.9 27.88c-15.45-9.18-33.42-14.55-52.7-14.55-18.89 0-36.56 5.16-51.79 14l.07.12a104.352 104.352 0 00-27.52 23.31c-4.91 15.52-12.16 30.1-21.37 43.39-1.62 7.25-2.47 14.8-2.47 22.54l.08 1.88-18.15-.03a175.59 175.59 0 01-13.35 11.89c6.64 66.07 60.71 118.11 127.67 121.57.01-.02.03-.05.04-.07-19.14-1.18-37.19-6.4-53.38-14.71l16.68-27.58c13.63 6.62 28.88 10.45 45.05 10.45 3.64 0 7.23-.19 10.77-.56 3.83-6.25 7.64-12.37 11.07-17.86a89.09 89.09 0 01-20.07 2.72c-.02 0-.04 0-.06.01h-.47c-.14.01-.29.01-.44.01H9685.79c-.13.01-.26.01-.39.01-48.96 0-88.76-39.32-89.48-88.13v-.02c0-.14-.01-.29-.01-.44v-.41-.08-.41-.33-.09-.08-.17-.14-.2c.01-.05.01-.1.01-.15v-.17-.05-.11c0-.09 0-.18.01-.27v-.25-.11c.01-.08.01-.16.01-.23v-.09c0-.08.01-.16.01-.24v-.06c.58-19.19 7.22-36.84 18.06-51.15 16.24-22.69 42.81-37.47 72.84-37.47 49.41 0 89.47 40.05 89.47 89.48 0 .95-.02 1.89-.04 2.84 2.48-2.86 4.08-4.69 4.41-5.03.03-.03.05-.04.06-.04.14 0-1.64 2.99-4.6 7.81-1.24 20.1-9.11 38.4-21.45 52.74-2.12 2.61-4.4 5.11-6.8 7.47v.06c-3.74 3.66-7.8 6.99-12.13 9.95 3.84 7.21 13.59 25.51 22.16 41.62 37.23-24.14 61.86-66.08 61.86-113.78l-.09 1.93-32.11.18.09-2.11c0-37.85-20.42-70.87-50.78-88.89l15.94-27.84c39.23 23.09 65.89 65.24 66.92 113.79-1.56-73.45-61.59-132.54-135.44-132.54m-42.01 6.64c-9.17 2.99-17.91 6.93-26.1 11.7 8.21-4.76 16.94-8.7 26.1-11.7m-26.31 11.82c-1.31.77-2.6 1.56-3.89 2.37 0 .05 0 .11.01.17 1.3-.83 2.62-1.63 3.96-2.41l-.08-.13m203.76 114.16c.01.15.01.31.01.46 0-.15 0-.31-.01-.46m.01.58c.01.35.02.7.02 1.06 0-.36-.01-.71-.02-1.06m.02 1.21v0m0 .54v0m-92.94 79.09l-18.47 22.28c9.6-2.19 18.69-5.72 27.09-10.37l-8.62-11.91m-47.09 56.81l-.04.05c1.53.05 3.06.08 4.6.08h.64c-1.74-.01-3.48-.05-5.2-.13"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18627)">
            <g transform="matrix(179.199 0 0 165.2 9603.9 4963.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAiCAYAAADYmxC7AAAABHNCSVQICAgIfAhkiAAAA2tJREFUWIWNWF16GyEMHG3IW+9/td6gB0jS1l+6oD6AYCSEk32xjUAajf5Yy89fP1QV81EIAKCtBfeYnJcFQAv72tgX90ZbMqQNMmXFvigpad8AY7ub+q0tAc1gGIgCaMrgZYBiZr7BihnQIXcsJCCinr6+A+GzJYJ5BsTkXwHRELpTeqxdARSCopwVL8uANMg0UikkAt3y1KRTn8qUqQqFTwEh6BkzvCeC4ZA6p7AMrjUP3MCIKEQUxQyJnIEAfs9MZgLGBoVY4YeB6Pguomgqo4JHokfli9LgXQAT8yZ+mlEGZ8Z5r61VXbbLV2BMzsC2nHDgz2AknBH4fDI7pYZQ9AO9l2RgTHEGhMFYKNgBTuzY2wTqm2esrqayV1ximNezNsGyxVBGQoc/w3fr9VThd0C0UTnNnTGm9AmQPP/KP1J0Yac/Asio7wJveI0j34OyPGzB0VIp9ncChGk/eWoPlzV37NiT4jnTLdJbUDmhr0mibsqSnAHOLEcQu77+6cLnjIfmxrIWQnh6Yi7FZGeZyRWywnf0NKE+Ks6UP9tjxhv9riqjgQ5QX3ndq8srZ8PrfvScgTraz62CCzpBtNEH55ipw+A2VsiIQFHbiTHbwY22O1LJkDVgBRUDrQHA3QgUyHMeBcvw5bxXrOvrPcO/kreR97ZWx/cKmQaMKUshi1ppTyn3PaROD8UZYiD2XXUZZVZaAJAxVh7twjXmnAYP7ECWlA0LoCkzQ013WTOW5m8PkB0sf+uLQ7t74dmIRvv6YtHGRg2j5x4g2IE4PWb1/b5fpsEsTHYJvFVcs4ythOUNlGvEalXPeGTTdJQ/9cWFYnobaBbRaYip59E0nXHh9jkF9CpT+NHWwzeq76MWR9+JCQaho0aVFPbzfahz+KuKq9B4y6y69M/3vrf71QmzEMXYxzJm8BGQQCn3Fqhsr+kpj3oh3j5j6Rr9JnNOJKE3RrN1zivONSakvN9lgop5sDYPQxHADGkOcDICfs1fiT/1xvvU2/26hUmSjXUC8ID4ySoyk/P9KntdK+93cQpEFPHK65Usj/sebojR88Uc/7vindt8Q/kYzdMrOXuvNLv0cIZHxjIs6eXO3qD5BaY8CFT2nxJ7kr2OHZ0JMzW7W+1vTP2zfOq1KcwM8h0qzrD0XGAuW68JCQDwHy7cnmbKeuQlAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18639)">
            <path
              fill="url(#linearGradient18647)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9754.08 5181.55c-20.2 12.16-43.84 19.2-69.12 19.32h.63c25.17 0 48.62-6.98 68.79-18.91l-.3-.41"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18657)">
            <path
              fill="url(#linearGradient18665)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9735.47 5155.84c-8.4 4.65-17.49 8.18-27.09 10.37l-28.62 34.53c1.72.08 3.46.12 5.2.13 25.28-.12 48.92-7.16 69.12-19.32l-18.61-25.71m-94.93 2.48l-16.68 27.58c16.19 8.31 34.24 13.53 53.38 14.71 5.03-9.12 12.11-20.96 19.12-32.4-3.54.37-7.13.56-10.77.56-16.17 0-31.42-3.83-45.05-10.45"
            ></path>
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M100.204 155.22a3.156 3.156 0 014.874-2.646 3.138 3.138 0 00-1.934-.666 3.157 3.157 0 00-1.717 5.804 3.147 3.147 0 01-1.223-2.492"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18677)">
            <g transform="matrix(102.199 0 0 106.2 9589.9 5055.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAWCAYAAAAvg9c4AAAABHNCSVQICAgIfAhkiAAAAIhJREFUOI3llDEOwCAIRT+Gqfe/X9eewYHfRVO0ukHSpExE4PkxoJzXQQSbWjgSUJEEKDOUGuKl5ihNYEKZ0f7PRyrjTUs4EYBaBpTM2Khw5Jc+lFmHF0bIeqP8RXMn8why4WtlacVj8m4qfN6sx1pMq5Uh0cMIgbhS2wC7Tw9dBZ4zeUF28G43M3VE4vtwzh8AAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18689)">
            <g transform="matrix(102.199 0 0 106.2 9589.9 5055.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAWCAYAAAAvg9c4AAAABHNCSVQICAgIfAhkiAAAACRJREFUOI1j/P///38GKgMmahs4auiooaOGjho6auiooYPZUAC6hwQooez3/QAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18701)">
            <g transform="matrix(92.1992 0 0 160.2 9661.9 4963.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAhCAYAAAA74pBqAAAABHNCSVQICAgIfAhkiAAAAgZJREFUSImVlb1y3DAMhHd5iIu8//ulTYrMpIhj30jEpqBAgpQiO2h0JIgPPwR4/Pb9q5AkFlzWq7jmcwBgq4EEkGeILxsB8YQzJQAwvh8BVmcSYBl0BWiRE2sGAYgASMACdAXJoCtIgMLe7iL5DCD2BbYL+AxgnJsBWex/ILeOgRTZP2t2D8j25rpu0OifjFiNZzBH0/rimcd+2LgCrgmQxRy89LKKAyiLrncCAyaejE6iG92hdxB2Z3ze5ulIL0cbJ54m7aPxEZqNL+cMAGoUl/MtrdAZPmoddbcqjls72sRPwz+nF5AKggB2EQWA1YvRCHA2yhm0lAlPXwCwXQWELg0iovjWlFpkEzoBsE2Eq3RQHh8tLeFJXxdHDsLe62Pq9CpO3gT25lz3pTQhIOzNH8lLz3AxbGtynFkjEwB7r2XyFIqW8nCS26TXcNm3p5cplfit1Mqxdo0HQQkUevtTH/1AFVHSzSJBw7imVlCKsIKwt/oYBgB2LyDVanQc9A6Mmxs3K7G3jP2u1nOevXGqz36st6Xwuwpa4xP2Wg27D4NhSMR0uAgHm15jjMLpdtjbj+fLHFEq8H40cxR4jWo7ZjL27XW3rmieCkJib/cylSIyyOAqwn5uL70B81zuKQpSPfKsY/otAPZr+3LyFjK9ElNPpWbN/+hPL5cvxYDMsNVxft/+Aq6GvxMXOGFkAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18713)">
            <g transform="matrix(25.1992 0 0 25.2002 9728.9 5117.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAABHNCSVQICAgIfAhkiAAAACNJREFUCJljvP2c+z8DGmD5jyHEwMCCRYyB5T8DI6bgPyxKAVT+CNgSMGuvAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18725)">
            <g transform="matrix(126.199 0 0 106.2 9589.9 5055.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAWCAYAAADeiIy1AAAABHNCSVQICAgIfAhkiAAAAfNJREFUSImNVUGS5DAIk9y+zv8ftm+YR3TNBu3Bxoh0tmpycmwhQIDNP99fgn0Dnx+xIAIXhnpAOYcONu0nbjbBuxE+jLRtBD46DcOn0xmNBIckQbEJeQh5AgCAECsAd7DxlwgSmE4cN2kChASQgNQDunKdASht1+9f8QQjoWeUJKFnqRYx4Lnphg07jKMMMOM/JIcIPOuM7gRgdtjY41bVRAFgXqnxYj3fqk/p78Gkq5EmWnh0ioXZwc+M2CMFgAsVgGfluKqT4c3NgJCJzLADl0rYrd0kqGZxmRwjy/oyzPRiwmaiK9kllPoM9VpW83jNW0anRc0JuYr+1Bghrk77RaY9o018d/7kOB0G+DG86TT3BoGhTSIDu4FEBGomLvEUWA/nyeU8IWtvl2RQCLEk06pHjUKtM+vX3mOrW83WcTSoLcONZJ9dcu3ZmsWDSKkv1PW056gkWXdYL+yAmpSesdehnVmmY8s6zx76l8bJ4a60Ze33eclMG5N0Ot9RT92rdcpaj006btqPrYJncpyatLk/f7ajcSvwuN/qMiKUfBkcrVE8w/Me/STgPGAbdCSrMfW9jDqJ8uGjvSkVBDDf8Spjz4DAaxvnY1ZZsQW09tceWVdRNtjKKCpRsq57Cog0khpmSasVgJYKh0WpBksNAf8AmthGAgijUfAAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18737)">
            <g transform="matrix(107.199 0 0 159.2 9608.9 4992.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAhCAYAAADdy1suAAAABHNCSVQICAgIfAhkiAAAAmNJREFUSIl1VkuOHSEMrKJZzf3vl20uEGU0elBZYENBE0staPC3sDH89ftLACAsYozdFwEwNnSs36imMLkE5EoOY9LdCc2RKBCqYnMaOBQQQAdBCNKYDz5BIG7OdxA1rSkEBKAEuwumwhUVZ6S+PqHQ9HFskkPJydgjxPPfI9sVHwo8XCdC2/qAwuS2eUCRGBIJy/CABsnb0N2B6fHE7jgIhXgXUPhW3gIu2nJGT0a6ldg88zbTbjNowvnvqZpr9aZwU/4ytlKvgXggfDSsPBBaRFad+RTOkJOKweC8eShNRCHQk5dmqYHoIdBCqARjj8+xaTKQQykAVLc+mYwh5xJBCkoexxQEpe2AK2S4WbkilDl15f5KSS8OXyurlD1vlhLhfbhdVtpHiedenbeSpY1QXpXWhC2qXPPRqTYxLp7ds1GNO+Wpe/hZB6uQwuNU1rBjfbtYGDlbLBpFuALRta6A+lF5iZ+UsHgen7lOrnMBgNqxThLHPP/Tu2bwjIiW19TuUm16e5hUMCDK4sh/309yZwq1FN/UdxsJ4IM9dxuwFU3Oe3p8Ki0UuriNq//tHhbLd5lMdcDJPPkRZCb/R+XVNtdB7obypqt+D4xdh2alHW2ugEXmLbAf/PRYxz3gAgA2aLyrn3dMzutPH0HNt4O1nOzAnrO3/uewJdW//dnbyhFWtvmOhXsaPduTG6nfrWxeeO0Dez+binrMZdDdPD6r7RSYuWvvNt4aLxbO9bs928bJlHeAY1yYj4P3GyS11D/t2ZTmM6qDeC4KTifSiJc3qeGxV9j/6FTA5LU0LRHhpxf8A5lys11OygMrAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18749)">
            <g transform="matrix(126.199 0 0 169.2 9589.9 4992.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAjCAYAAACKPxqrAAAABHNCSVQICAgIfAhkiAAAACtJREFUSIntzUEBAAAEBDD073xa8NkKrJOkDsxFIhKJRCKRSCQSiUSih2gBMN8EQjX9KqMAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18761)">
            <g transform="matrix(121.199 0 0 149.2 9594.9 5007.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAfCAYAAAASsGZ+AAAABHNCSVQICAgIfAhkiAAAAjlJREFUSImVVkuyHCEMkwjL3P+EWeUAryqVHvQWYGzc7pmEzfT4I38QBv76/VMoVsMUC4DALSdK89uKPj0qIkCGIrQC2v8n8PUrgLwFqTO0eirt55qmRZ8RVaj+xd3XWIK2sie1ZT0GOL/Ohgw5QAbOK8v73Vn/BfBJT4xz46VxqC2k5RABnABapGiHHAAaBgTOICf4HaiSZSpXcqNxJ0Yy5uFUBbsHICSB1KqcQadVScH66XTKZ1scKBI7mmbCtxzAYfIah7y2SR6a2O0TuCRgtdScMtCT3FZ/n9FY/X4PkmXOuJlAr4za2sAMTgh6PD8eIK9mBjGzKsuKsir09z0GugHeB8mTrJ6/Omh7ptTj6H63O9nR7Gdbz8RM70HC7DJj0gfiS+4UAeoZEavSbnsXJlAst8mH5BDRKLwyCeizrOqC0DbD+hAxcDJjLBLa/0stAQB2Qzy1eN5ThAT0S9ztGjdm8JmyIYlHMtilJRB/1w7Ge2Vg8ntUFNsoxczbU82T6LHXc28c87JvOREym+KyIemTfLVryBWWweEYWnIV4DEpPuj7pbjJ/k1axpMYLQQjtGVPyVkAAOhjlSREBhHUCXCSwqeEMVEiGKjeMPdV4qpkGdjvDgRnnA1Lc5xPnnSvrxloLdyVvExhM2y0bRRPtbWjeq34q/F+dRNA/3r9gESnLHwKPx60fJ7WkzQ+TeOI6l+vXg64d6AzQ99sQqEcJ4dV1/+MhrbYUmWUDxZg8+wMaTPOJe7xDZLPmGBfJXlmAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18773)">
            <g transform="matrix(106.199 0 0 106.2 9589.9 5055.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAABHNCSVQICAgIfAhkiAAAAS1JREFUOI21VUlywzAMAzS85P8f7LFvaBqhB4uiQktW3Zny5CQIFgoj8+PzIQxDYjs7iACYGow4+KUVmChU/+NO0HZOXYhLurlAJ65aB9ylcVPjz7bzQRxr2AlmjN1x8RtBF5s6Ju7FnolZViUETdyUyZ79scx2XIdPhUE4EpBAvYhdk/1CwFZdGOuXqxbdX4+5kwK10z2r57VI6xTOYz3OBSichlie42yIMPpP01uRV0CcU1wdlsC3dJZBwLG/mdCsmlnIEfMeJ9Y7Qo6zOkZagf8gZH6rFQg1I/2hsXgbXtqfelybQ+kFdDLvrD+r4wPrHuqAta9aGmGEI+N+JoJt/L5Qb6J91C76ZycYatfdpteRrwTAUzzWsbgF7bs59kiO6zGv3iwUJII8s/8AyQ2iAmEoz9wAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18785)">
            <g transform="matrix(126.199 0 0 159.2 9589.9 5002.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAhCAYAAADH97ugAAAABHNCSVQICAgIfAhkiAAAACtJREFUSIntzQEJAAAIAzC1f+fbQhC2AuskqQNzkYhEIpFIJBKJRCLRg2gBs1EEPhzek20AAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18797)">
            <g transform="matrix(25.1992 0 0 20.2002 9738.9 5112.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAECAYAAABGM/VAAAAABHNCSVQICAgIfAhkiAAAADRJREFUCJlNy7EJwDAAxMB7k9b7D5YVsobzLkwgAlVCuZ9Zf8J4BVRUKFfLEjlNxfiu9ggbaqEOxtxgy5gAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18809)">
            <g transform="matrix(25.1992 0 0 25.2002 9738.9 5107.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAABHNCSVQICAgIfAhkiAAAADZJREFUCJlVyrENgDAAA8FzlI79h2MBtiCmCogvT5/zOgoVQ8GogKglirmv3d2Yq+Qz3rN/fAAFUA/SlXFLhAAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18821)">
            <g transform="matrix(53.1992 0 0 58.2002 9690.9 5093.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAMCAYAAAC0qUeeAAAABHNCSVQICAgIfAhkiAAAAH1JREFUKJF9kUESxCAIBHssbvn/D/e0j3D2QGLQmOVgCTbFMOrzPQxgCwkAhDHPiDl1Of/AkukL1bSBV0j0++a7o72DYKf2C4nKNjpmmX01AqGyzhuYE00YowJV04TQcMi54N7VZ73VpG6+iwHvwO7ZuuhOXfnF8+PQe6r5AVIpPNtzrpWaAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18833)">
            <g transform="matrix(25.1992 0 0 25.2002 9728.9 5117.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAABHNCSVQICAgIfAhkiAAAADNJREFUCJldy7ENACAMA8E3SsP+C1IyRUyBIgVcnt5ae1ri2fgBINJqhS8aKK4gANyuAg5CIgniNgd8IwAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18845)">
            <g transform="matrix(30.1992 0 0 35.2002 9723.9 5107.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAHCAYAAAArkDztAAAABHNCSVQICAgIfAhkiAAAAEBJREFUCJlljLENwDAMw6jCW///sFOPCDM0QIyGi2GJdp73lsZYW4EMw59LRcCjYNtbkOpW2l31wDVDKI/vnzABdQUY3EBS8BsAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18857)">
            <g transform="matrix(20.1992 0 0 15.2002 9728.9 5127.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAABHNCSVQICAgIfAhkiAAAABVJREFUCJlj/P///38GJMDEgAYwBADCCgQCxnVWNAAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18869)">
            <path
              fill="url(#linearGradient18877)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9684.03 4929.89c-14.57 0-28.58 2.35-41.72 6.64 13.18-4.29 27.24-6.62 41.85-6.64h-.13m-67.82 18.34l-.21.12.21-.12"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18887)">
            <path
              fill="url(#linearGradient18895)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9684.16 4929.89c-14.61.02-28.67 2.35-41.85 6.64-9.16 3-17.89 6.94-26.1 11.7l-.21.12.08.13c.07-.04.14-.09.22-.13l15.94 27.66c15.23-8.84 32.9-14 51.79-14 19.28 0 37.25 5.37 52.7 14.55l15.9-27.88c-20.11-11.83-43.46-18.76-68.47-18.79"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18905)">
            <path
              fill="url(#linearGradient18913)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9819.76 5062.43v0m.01.54v0m.02 1.18v0m0 .54v0"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18923)">
            <path
              fill="url(#linearGradient18931)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9752.84 4948.64l-15.94 27.84c30.36 18.02 50.78 51.04 50.78 88.89l-.09 2.11 32.11-.18.09-1.93v-.53-.15-.39-.15c0-.36-.01-.71-.02-1.06v-.12c0-.15 0-.31-.01-.46v-.08c-1.03-48.55-27.69-90.7-66.92-113.79"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18941)">
            <path
              fill="url(#linearGradient18949)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9616.08 4948.48c-1.34.78-2.66 1.58-3.96 2.41v1.01c0 16.52-2.56 32.47-7.33 47.54 7.72-9.27 17.03-17.18 27.52-23.31l-.07-.12c-.08.05-.17.1-.26.15l-15.9-27.68m-32.66 94.35a170.859 170.859 0 01-20.54 24.39l18.15.03-.08-1.88c0-7.74.85-15.29 2.47-22.54"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18959)">
            <path
              fill="url(#linearGradient18967)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9616.3 4948.35c-.08.04-.15.09-.22.13l15.9 27.68c.09-.05.18-.1.26-.15l-15.94-27.66"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18977)">
            <path
              fill="url(#linearGradient128969)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9780.75 5059.5c-.01 0-.03.01-.06.04-.33.34-1.93 2.17-4.41 5.03-.03.91-.08 1.83-.13 2.74 2.96-4.82 4.74-7.81 4.6-7.81"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath18995)">
            <g transform="matrix(44.1992 0 0 63.2002 9738.9 5055.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAANCAYAAAB7AEQGAAAABHNCSVQICAgIfAhkiAAAAFlJREFUGJWVkDEOwDAIA03F/5/Rz3XtDFlALYlpFcac0ZnIdZ8OMoLnWTvw3tSEPoEcc0ARAQYXndFmEeqgzZ06WEIMHEVHoO3osq/CAcjfdQD/xS9dUcfyAMavI4+J4vX0AAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19007)">
            <g transform="matrix(25.1992 0 0 35.2002 9728.9 5088.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAHCAYAAADAp4fuAAAABHNCSVQICAgIfAhkiAAAADZJREFUCJlj/Pht2X8GNMCELoBTkAWZw8jwH1UlTODffyYGFkaG/wz//jMx/GdgRJj57z+msQCR7g2bbLHrnAAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19019)">
            <g transform="matrix(34.1992 0 0 39.2002 9719.9 5103.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAABHNCSVQICAgIfAhkiAAAACJJREFUCJlj/Pxt2X8GRgZU8B9CsaALIAMmXBIISRxgICQBc5MGnr7nE70AAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19031)">
            <path
              fill="url(#linearGradient128971)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9677.2 5200.68c-.1.18-.2.36-.29.53.79.05 1.57.08 2.37.11l.44-.53c-.84-.03-1.69-.06-2.52-.11"
            ></path>
          </g>
        </g>
        <path
          fill="#b0c9ad"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M102.845 150.211l-.028-.05.07-.003.041.05a2.305 2.305 0 00-.083.003"
        ></path>
        <path
          fill="#b0daad"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M102.817 150.161a5.922 5.922 0 01-.12-.233l.19.23-.07.003"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19053)">
            <path
              fill="url(#linearGradient128973)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9726.3 5143.18c-1.32.68-2.66 1.32-4.01 1.94a88.688 88.688 0 01-14.86 5.23c-3.43 5.49-7.24 11.61-11.07 17.86 4.09-.43 8.1-1.1 12.02-2l18.47-22.28-.55-.75m-49.06 57.43c-.01.02-.03.05-.04.07.83.05 1.68.08 2.52.11l.04-.05c-.85-.03-1.68-.08-2.52-.13"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19071)">
            <path
              fill="url(#linearGradient128975)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9708.38 5166.21c-3.92.9-7.93 1.57-12.02 2-7.01 11.44-14.09 23.28-19.12 32.4.84.05 1.67.1 2.52.13l28.62-34.53"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19089)">
            <g transform="matrix(20.1992 0 0 15.2002 9714.9 5136.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAABHNCSVQICAgIfAhkiAAAABVJREFUCJlj/PRt6X8GJMDEgAYwBACs5wOS7ZA52gAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19101)">
            <g transform="matrix(30.1992 0 0 20.2002 9699.9 5136.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAECAYAAACtBE5DAAAABHNCSVQICAgIfAhkiAAAAClJREFUCJljfP912X8GNMDI+J+BiRFdlIGB4f9/RgYmDOVQwIKhGkoDAEwrCJLTwtOmAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19113)">
            <g transform="matrix(20.1992 0 0 15.2002 9699.9 5136.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAABHNCSVQICAgIfAhkiAAAABVJREFUCJlj/PRt6X8GJMDEgAYwBACs5wOS7ZA52gAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19125)">
            <g transform="matrix(25.1992 0 0 20.2002 9699.9 5136.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAECAYAAABGM/VAAAAABHNCSVQICAgIfAhkiAAAABVJREFUCJlj/P///38GNMCELkCaIABGbQQELmW8gAAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19137)">
            <g transform="matrix(16.1992 0 0 15.2002 9699.9 5141.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAABHNCSVQICAgIfAhkiAAAABVJREFUCJlj/P///38GKGBiQAIoHACSCgQC2nCLJAAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19149)">
            <g transform="matrix(25.1992 0 0 20.2002 9709.9 5136.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAECAYAAABGM/VAAAAABHNCSVQICAgIfAhkiAAAACRJREFUCJlj/Pxt2X8GNMDCwIjEg0ozoatiYGBgYPmPoZmBAQB8CwaY0DZNfAAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19161)">
            <g transform="matrix(35.1992 0 0 29.2002 9699.9 5122.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAGCAYAAAAPDoR2AAAABHNCSVQICAgIfAhkiAAAACxJREFUCJlj/Px92X8GHIAJlwQDAwMDCwMDAwMDul5GmE5chv7HZex/IuwEAIt0B5pK9nxHAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19173)">
            <g transform="matrix(30.1992 0 0 25.2002 9704.9 5131.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAFCAYAAABmWJ3mAAAABHNCSVQICAgIfAhkiAAAABVJREFUCJlj/P///38GLIAJmyCVJQDrEwQGmj+dQQAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19185)">
            <g transform="matrix(39.1992 0 0 53.2002 9666.9 5055.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAABHNCSVQICAgIfAhkiAAAAFBJREFUGJV9kEEKwDAIBMfg/5+Rz/Xas/aQtqQb0wURZlcF7Th7UqhJX4y4awnEZmCr30AkeAVnuQKABxk5NmjGJuJqJvkZaGrqLX9h+U+4AOzLGo2ReclXAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19197)">
            <g transform="matrix(25.1992 0 0 25.2002 9690.9 5083.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAABHNCSVQICAgIfAhkiAAAABlJREFUCJlj/Pht2X8GNMCELkCh4P//jAwAdSEFlYA5/2MAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19209)">
            <g transform="matrix(15.1992 0 0 25.2002 9690.9 5088.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAFCAYAAACAcVaiAAAABHNCSVQICAgIfAhkiAAAAB1JREFUCJljfP912X8GKGBiQAJMMOH/MJn/2JQBADc+BpAyerL6AAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19221)">
            <g transform="matrix(44.1992 0 0 44.2002 9690.9 5093.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAABHNCSVQICAgIfAhkiAAAADhJREFUGJVj/Px92X+G/wzYASMDA8N/BgYmnAoYIAoYGBgYmPAogYOBVITLDyz4FMDEWNAlsSkGAEwvDJ3FkM/GAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <path
          fill="#fbc6ad"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M105.89 150.638a3.187 3.187 0 00-.09-.054l.435-.602c-.01.023-.154.296-.346.656"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19235)">
            <path
              fill="url(#linearGradient128977)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9757.93 5179.15c-1.2.77-2.41 1.54-3.63 2.27l.26.44c-.06.03-.12.07-.18.1l.4.55c1.25-.74 2.5-1.49 3.73-2.26-.19-.36-.39-.73-.58-1.1"
            ></path>
          </g>
        </g>
        <path
          fill="#b0c9ad"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M105.723 150.95a6.077 6.077 0 00-.131-.08l.042-.058.125.073-.036.066m.142-.267a5.58 5.58 0 00-.096-.059l.03-.04.09.053-.024.046"
        ></path>
        <path
          fill="#b0daad"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M105.759 150.885a8.964 8.964 0 00-.125-.073l.136-.187.095.059-.106.2"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19257)">
            <path
              fill="url(#linearGradient128979)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9735.77 5137.53a91.846 91.846 0 01-7.36 4.53l-1.56 1.87 8.62 11.91c.61-.34 1.22-.68 1.83-1.03h.79l16.21 26.61c1.22-.73 2.43-1.5 3.63-2.27-8.57-16.11-18.32-34.41-22.16-41.62"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19275)">
            <path
              fill="url(#linearGradient19283)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9754.3 5181.42c-.08.05-.14.09-.22.13l.3.41c.06-.03.12-.07.18-.1l-.26-.44"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19293)">
            <path
              fill="url(#linearGradient128981)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9738.09 5154.81h-.79c-.61.35-1.22.69-1.83 1.03l18.61 25.71c.08-.04.14-.08.22-.13l-16.21-26.61"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19311)">
            <g transform="matrix(24.1992 0 0 20.2002 9719.9 5127.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAECAYAAABGM/VAAAAABHNCSVQICAgIfAhkiAAAAB5JREFUCJlj/PRt6X8GNMCELsDAwMDA8u8/pjhWlQB0AgWV/Hs7PAAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19323)">
            <g transform="matrix(24.1992 0 0 20.2002 9719.9 5127.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAECAYAAABGM/VAAAAABHNCSVQICAgIfAhkiAAAACFJREFUCJlj/Px92X+G/wwogOU/kgAjTBBZBUyeiQELAAAJ/QeY9IUodAAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19335)">
            <g transform="matrix(20.1992 0 0 20.2002 9723.9 5127.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAABHNCSVQICAgIfAhkiAAAACBJREFUCJlj/Px92X8GJMDEgAZYGBgYGBj+I6v4j6oCABWpBZf9ulAdAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19347)">
            <g transform="matrix(24.1992 0 0 20.2002 9719.9 5127.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAECAYAAABGM/VAAAAABHNCSVQICAgIfAhkiAAAABVJREFUCJlj/P///38GNMCELkCaIABGbQQELmW8gAAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19359)">
            <path
              fill="url(#linearGradient19367)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9728.41 5142.06c-.7.38-1.4.75-2.11 1.12l.55.75 1.56-1.87"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19377)">
            <g transform="matrix(15.1992 0 0 21.2002 9719.9 5131.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAECAYAAABLLYUHAAAABHNCSVQICAgIfAhkiAAAABlJREFUCJlj/PPnyX8GKGCBsxgYGJgYcHEA5gwE5LjwxG8AAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19389)">
            <g transform="matrix(15.1992 0 0 21.2002 9719.9 5131.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAECAYAAABLLYUHAAAABHNCSVQICAgIfAhkiAAAABVJREFUCJlj/PPnyX8GKGBiQAK4OQC/5APj5cAbXgAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19401)">
            <g transform="matrix(30.1992 0 0 30.2002 9709.9 5117.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAABHNCSVQICAgIfAhkiAAAABVJREFUCJlj/PPnyX8GLIAJmyC9JAA87gPn3ZOgNgAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19413)">
            <g transform="matrix(20.1992 0 0 21.2002 9719.9 5131.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAABHNCSVQICAgIfAhkiAAAABZJREFUCJlj/P///38GJMDEgAYICwAABl0EBLhJJOwAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M105.012 152.118c-.497-.386-.405-1.474-.41-1.782v.295l-.004-.109v-.186a4.09 4.09 0 01-.026.39s-.146 1.09-.408 1.319c-.59.514-2.073.417-1.504.429 1.92.04 1.92 1.918 1.938 2.533v-.311l.003.053v.258c.042-1.457.036-2.379 1.713-2.502.554-.042-.724.064-1.302-.387"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19451)">
            <g transform="matrix(216.199 0 0 97.2002 9359.9 4786.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAUCAYAAAAZb7T/AAAABHNCSVQICAgIfAhkiAAAArZJREFUSImlllGypCAMRU9sdjD7nV3PVwt3Pkgg0OrrmqHKUhHl5HoTsD+/f4kDMNHPwAEW9zD78XF3TT5IQPO+BmrW+6I/7qs/q9633ANvQ9XgBE5/Xo0yPmTWv3r4RNY/bDvkYdy2tl5LG6xugJWCaz72nONofc4YX1Stg73iobqqfgQ8XARwAaysdj6y2nVTvyZ1A7KBAjz6BcgooaqFypgDr/CYAzWmVXLTxXkcafK2KVx3W9ga1GnrOw0K1YFwOwylEzwJHn6GHte2wKumX74DxzvuW6o/J93L0GkUqrnCXWnJsCMlpdkK+m0ipgAGbE5E/+VDQZg+bg682IKekENpOZX0YQPLVYUUxCV0Ot8lopK6ARXA4eNIxk31eKfIM9Oa4OWqOzzHTSJGKYyWqsYATfADNkBIiZf8PYAjgAx8eulrNpWWK2hSVzPDO6giSXNp21XOQVzBjtI3gVWTujuw+zi/VzgNisYkah3YqnpNdsW7XVJS3kGHr9Mkl7B7JUngGTh8nBOzxMqDscIn7/YAnPbO0pvSAzSexXUkW9ghqsjuYQfWuVYSgKK3wYteMd5J2UN9cPg6Jt39nFu2zbKUJ6XFWqdPL2vnBH8CBrzkSehwWxyaK1jY4kgy1hvw3edts8kOmy2SPV1tDaB+/toyPObqyqbaFrDRBzOQq7YkoF9uKn/4OWDz0v0ADG6PAZfgx6IQdsGDuAMO3guFF9W9fwEOOzRPvPD5TSucoFf/wICKndzYmvagcnIuCamL6wzq57FcZ9h9QYlgHpp7GjC3hq9+M4AEEO0bT0efNthUu+VJ+I26C3S8aIW5oEBPTGPZJFns/O6U0MOKyAOsflZ3gebN3OUBdgR8wM4FRTkhb6A/dnlwnXj/ADuhY5f39s2Sl75oIwh4rtHRdg/n/v+EjfYXFLhXUwDIpL4AAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19463)">
            <g transform="matrix(236.199 0 0 231.2 9373.9 4805.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,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"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19475)">
            <g transform="matrix(159.199 0 0 150.2 9378.9 4824.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAfCAYAAABplKSyAAAABHNCSVQICAgIfAhkiAAAAhBJREFUWIW1V1GWwyAInKH53fufck+wr85+RCKKJulrS17aRBFGIKPy9/dHEgAQLkIvSi0Ag34/ulkgAUggBcMfBMFqnwSw7Ko2AhidzwCsgCVIUgXk7u0YRVY1ApaN35cIZDZO1YtECAbWNtdVxWo6icKrQDKAvgVoMT8SQGDLap8V1eqRLGS9gBWmZul4z+E9LQVF4sMgojD8pj6G2iBgc7XvwJIsvh3Pb0di5Iu1VH7AA2OcliDuG79yu+ojnEU6EKPbKyDnrJm1V7ItewZHkQ8+EaUoNoZsZZ7huiNCX3yz5Dih2bz7dXk1NpErjBOC/USwZzbIAuJZn1ukvkZWuyMOKWnSR4Lvz3tlQVolWohubaX4XZaYMubdhfue6+l3wDKAaP8WEb0LpAzvYz3sRanUbuOAc6ptVxuH9LwqxlEu147RQd++3hQ3nWMTl1IxjrM44GoGM7a8W8CrVECAXVfxGsiUkPqtbIiCpzuPOr6Os2jMnc0BNIl180w6rCoSYBFpnMHMabyz5Ek4TUt5Xxm9mCvn2dz/YJ392jalpaHUw0VcKw7zAijA2oJSmoEbQEh3LkAlAHBAz3qXDsAYBQDYJIF8QniALHUzGstH+9lhssZIudpjVHfbGUCMAgRspCs3ILsBp5C6Ek7WGB4WG4BWhGsAcgDYD8UbIT8+d1UM4ojKlThw54JTCRFwIP9WV/z73TO6yAAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19487)">
            <g transform="matrix(120.199 0 0 73.2002 9383.9 4834.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAPCAYAAAARZmTlAAAABHNCSVQICAgIfAhkiAAAACFJREFUOI1j/P///38GGgMmWlswasmoJaOWjFoyagkeAADqZwQa5EAxTQAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19499)">
            <g transform="matrix(24.1992 0 0 30.2002 9575.9 4853.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAGCAYAAAAL+1RLAAAABHNCSVQICAgIfAhkiAAAADtJREFUCJldjLsNwCAUxHyvyP7bsUhKwBQR+bk6WSfnbIf2kAH0kAnFZt6LQoiAeaQG5UNdr598t3Z7ATLmE8fwQkloAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19511)">
            <g transform="matrix(126.199 0 0 217.2 9493.9 4882.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAtCAYAAACwNXvbAAAABHNCSVQICAgIfAhkiAAAAvRJREFUWIWtmF2S4yAMhD/JzCn2Unv/W+zzxGgfECB+7MwkocplDBKtbgnsRP79/WNkIINlgQycgHn/Qy2RrCysgmQrgCrwMBDglM8AyWGYCNgIaDgjMcjvs0scIEcBMRHIhYko8HA5Hwa8B6Z8GShwgHwZkgwOQA0SiN9Rg8PeY1TkoUgEiBh2ShkXkJMi5YMC9kLekhyFkWWB09k9BMHzJOAwb4ElvkqyxUHsIZB8TK08swFTfpWzhJZFarIl+eJSxsTLP8A42O8KxHNESXamyJasSFkDgC7li2AlR82dLtvZF65gWL9ErWxsC/P3jFwiG5MPMrCoMpr54ikyeV4cobzjwhdgWZDDn82Q5MWTeVocXgy7hcOYec6SlRyaYYdnqp6NTyRMLcKdZOZjKr0aa2DmDJLfn7BKaKkoMmM+IrNk8O0gR9hjGiRE4PualaJ+Gqjb1HPu8HOu+sXnVHzqqdJYSugvQHUPVcdqXM85DYeslg3dbbqtOHjZ6BfSlfdOcVqKwcIeUr8flOSrDL53OdJu5JFKOb1rn8NzKN2mSajer6x0kjICSQCocvVjyceqc8xlkLwJoFzKp4PWgVnL1wWrCLAw2RSeDkWwu2ZWBMkqi6DIlXzaopJVwnEsymPrWOyzyqdDtLtFQ7/JR5ivzGa/RTq6QWOwc6wB0efjhm6+F3nSJlVss3xraGvUMbBN01H7jcOVpBFgeA6B6ba7iXA7/PzbrlVeaLpEewcanXVTGLfSvdKefyJ8COiF9hrQC5/g+iPHny58Y6dtcjbaObXXPeUHgY1zs+0eqE7Wj8TZ4SraJUDxr9wRTOvkEpGFiOM9h+suwKlpNLC6eLisBmFrTVuQr/leKKCNTYwqGtV+tInsol203TJa2IToIrtdIdQf0jPIpIBu2VzJNudnYSX9v4ql6vINm9wXi/nApvxcLD4A9agnNjmwGaotPk++cx4HRoNRcbRTBueBzTkxaLmUMbgFaBdpcOa8YbOTbc6bt//DXucS/HVP2gAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19523)">
            <g transform="matrix(83.1992 0 0 154.2 9536.9 4935.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAgCAYAAAD0S5PyAAAABHNCSVQICAgIfAhkiAAAActJREFUSImllVGO2zAMRN/Iuk3P1/v1Vt1dS5x+ULKVNJt1EAMCbCB8niGHjn7/+WXx3lUBukV/A1UtaOgtUEWA88GGHq+DakcEEIidQrOwX4R8UQiJXcKABe1FaxVBOB11iUCElbYugmpHdIlOnl353CT2KJQL1uonhc4oohBAUzmgXxcaXbtTfpA9mY2eIw9E/0FN3aMQht2iUWhkYRu2utPWczshuhPUnCOe99NSs4gntupZmKdZWJwARAgawDegukdCZjYmqM9VGEpsiG9GXj+iEBb70uA2Ctphc4QvHoMOJX2AjI5CI3bOAIaBeNiTE9BnT5atnuP2iMCjvap/YxsFLFNKyX3Ev6FcdpP7cQeqH73cKFitTAvdAkNxLpnillI/R2PNg2JyKt2iRCopNop7JbGRLxgqODMTi4VikGEbG69FTJ1W1rdPyPE7w4aZw7WhLJbqGaS0E+Su+Kw/rGyGLWZfFiWxjHZauI9CQH6gDAUh+2bU9UjqBP0fg+MyqTisnNS9kv4EoJEy+XFW6rG5TxTcSDE47iCvAXyqWNTUZz1YAVoOnMGD8V/8owJmX05F64QuQSZAzs6WkQNdVaI517l8HuTF2j9++chpG4H+bQAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19535)">
            <g transform="matrix(92.1992 0 0 174.2 9527.9 4920.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAkCAYAAABrLwHZAAAABHNCSVQICAgIfAhkiAAAAT5JREFUSImtlkG6wyAIhGdoD9N9T/Huf5/wFpGIikZt2OQr6s8Mxlh+/r6KA4+EAATkKdgLAJ8BygUiAeFPsDcInFY1pQgcOlgyUiYEiKzqhW2FUoB+BIrWyuzpcyvKQqAYcBEWAotdnoYlSA2kB83ZFbXqBiRKoLEm1KWeOaDwBFos2BWrrNSsgnt2xe+gWuVNu+chotvBO7sDdXK9TwkytHujTgBAfUFT5+026nqwVOmy69W5XHm0YquCaI7vHaJxhApFr8qlEt+7WavXewYkq36RjU1alWJMqjkMesPqWcAIqFsUbkRttZWSYb1K3ej0rUw1u8c431ngDjpzxs/xH8sb9aJRk33Ut97gXti7xzu8PuxO8RJsoGAdptr2axu2EXuwjmJhskPtzKj7NviH9G4qHq6yav4d9rBM/AMhKT74pypNtwAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19547)">
            <g transform="matrix(20.1992 0 0 39.2002 9527.9 5055.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAYAAADeM14FAAAABHNCSVQICAgIfAhkiAAAAEpJREFUCJk1zcERAkEMxMD2rOMgExIj97V5HOitkur1eW/d8SebMidUgZ6OumuMWnpSAhXu6kdfZQS9p0wRMUbfE7EYkafxG2J8AcWQGv6HbPo3AAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19559)">
            <g transform="matrix(40.1992 0 0 29.2002 9579.9 4935.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAABHNCSVQICAgIfAhkiAAAAE5JREFUCJlVjsENwDAMAg/Lm3SK7tT9fzF9WEldPiBA2Lqe2xRoAQUq0DIbYQMG09xCRwcGz6CA8imkEeIPDyf3gjxOfC+QWITpVrU5F18XSya3GDWP7gAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19571)">
            <g transform="matrix(92.1992 0 0 140.2 9527.9 4930.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAdCAYAAABIWle8AAAABHNCSVQICAgIfAhkiAAAAOlJREFUSImllUEWwyAIRGfoWbrosve/W+nCmqABAq9sNAbGD5jI5/ulAABVqM5RoZ8x75hAOGYkyDkSlDFviZEAHwSEfwvKdCbhCrbIwHz3Dp2QBA4Sn64qKBCgIlgiA4mSYIHurJknaKySrhhv5+1KV0uTx5Of7k4XiY3gUwCe804XULr73NUuJANncEJna4f4IP+62aCrdLNEZ31dMdtNj25dSFM158zQLQLXoFY3PYFKVyU93UndcvesqwHi/jVc0gzr5uvlYpFAxaQcFOGY9eQf0LdcrH07Zda+0Xv+N2KR7ZtElGb9Cx+UF/cJN5lRAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19583)">
            <g transform="matrix(20.1992 0 0 25.2002 9527.9 5050.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAFCAYAAABirU3bAAAABHNCSVQICAgIfAhkiAAAADBJREFUCJlNyDERgEAAA7C0hxckYAX/Qr6sZEzu91kOhs2lMWPkRAUNYaUr/6zEPz/0/gzQzwvYtgAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19595)">
            <g transform="matrix(78.1992 0 0 140.2 9541.9 4944.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAdCAYAAACjbey/AAAABHNCSVQICAgIfAhkiAAAAbFJREFUOI2dVFty3DAMg2T1Cr3/KXKaXKKdTmZXD6AfFCV6N8k46x/LMwYIgoTS2/tvUQmvPqUrQ3oZj0IBVAKRXiIqXRkUQCR0/ZykdG3gUMJQgnDdk+JgTjBh78sECxja6ErgxXamiTAQEjqNsCtfUlIIA3p1B0cll1rwnwf2d1dCZ/6eYEz5CoDmpPNcvyEpQoJgPlB2FrBU+GT4haFFAOSbOImGEpoSCKApo9I8+ZTgNo7drxIaDVBP54zGDH5GcOeu0JTRmVCVUWnTqLRz+2Ks5c48JWc0pkXm4OZjZcJdz2aWj3FM13fVzkA45TclND7npPztxRSEytGPrgRXWZnBR4IbD0hYwEpT08IeRLL20Eb56AfGzECdRjXaWCszGBS4HzFk5U//tRbGfxqzf1+izj3mqnzKR7kxo095FihgTCVO7Oa1mZcTwb9eLAshRJj5GHCAbaSfB04KjnWl+W1E4VRxXXfY50Xgi+NhGaHyiRSWGfMqjnFkSx92b1Gqk3AChQcP6pxrrKb5LWwij7pfQIsg/mhXG4BQlcATOKayNOV1iSgY6HLdF4V3fP4DMD8aSPx8sO4AAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19607)">
            <g transform="matrix(15.1992 0 0 15.2002 9541.9 5055.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAABHNCSVQICAgIfAhkiAAAAClJREFUCJkFwQkRACAMwLB2hyP0IBJ73B4Sz91TJVmynkEHZEvoMAAhHy9VDDgwN/xwAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19619)">
            <g transform="matrix(78.1992 0 0 131.2 9541.9 4944.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAbCAYAAAB1NA+iAAAABHNCSVQICAgIfAhkiAAAAaxJREFUOI2VlVGO2zAMRB8V9Ri9/Z6nhymKbmKJnH5QcuTtOnACBIYN83E4pGj7+PVTXYYEkvHur/ZiRICbEWHEm5DqZniBCKMXw93eUlIFhIwgAwPDMUJXSzDDi+HK7M2MTsEvqqgBBBACL0a44YALusoVgCEMWcoOGyWZ0cnuvAQIcBldo4zhwUZhU8HDiJcKZEwjJ6QtsDaup4AtCi2MrkKX0VR4hOEqbDHURCFOIPUe6bjLaFGGiid0iwSdDVj99NsemP9UEDI2FVoMyCtADJldRo8so8t4DHUzQfsGUpsKPYyHChK789t4vikhW5TvAX+9ZM0y+nhp78S47wd/jpD6p/8ggL50wnc/MtBHOU3/H7Q66+xK46aCORfbUDY9+trO+uk3usBVCNgzOmSgyhMcedUCqb97JTBa5ET6GKZpqMahWqeU5XzUezwzaI5vZJavpU3oOlT17jec54szSCKVTfB64A6AoaCTgGle7ojlfnl+MHHWx6g/O5DZZ+BZ8KGNAiT2YzwDY4DP9krdvwnM+tgX7FnWA2BdKD5AV4MBqq+Biw8Xtzr/AOEh52H7nKXlAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19667)">
            <g transform="matrix(216.199 0 0 106.2 9287.9 5007.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAWCAYAAABUpxX0AAAABHNCSVQICAgIfAhkiAAAAglJREFUSImtl11ywyAMhCXiY/Sx979XD1GrD0awWsRPMmUmMWAsPq0lkejP17fJPzRdjPnerNmkz3PXKdSsZXAB8g1JFDreN7j63EfQS9D/eG9gQ+uX1mmTD6AZUmmT7fM6LjbbBJD1vVTfgGZ1d7ADXFnZrmtv4Jw5YofQqOoKtoEiIMMyC9rytbeImondOfgW+gQ4wCIk7lk2MYSA5dmn2TUJDkyhP4b1B0uiOjbPqgZqfawi4uFh4ECFT6GPgRmWQVFpkzEx2Ilwtf6MO3A/+w7QO+ApLI4zQM0rR2NGZfnaHHjWBOi3gFFZX0sGAuSiejyP2FM9nN20j912/aRKHwHXGOtjAp0l5Jq8N7ft1zYJ0LBvXtICnPV+NaizeFbsk+Ff8gYc9dptNxyH9f7F9tOke1lU2GFR3SIjKEKq9LLm8y/rSebNDxgU447w1xa4EDDCcgIyrGmM+2JJ1UhOTncOHEDlm9JZ2KXAdTyoWyQkUngrwWgyZrGaowDvyotBeHDiFYScAHNpK7BhGtMyb1zqFvBXqnCIW0g6t8FZvYL1MN4d40JJN4O/HXp4PQAm2mMUVWPgBDaAHpQ9X7+GV7mW/2vwtMuSj4EhxpWT7rRWS61WRvCeLyU7xkNFOATO1OXs3pyIIhJ+TzcWqfCQ6PmvPIrHrcIIzEmHAuwSsUDCwVotFsD/AB2v1oxKFXv+AAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19679)">
            <g transform="matrix(87.1992 0 0 34.2002 9421.9 5093.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAHCAYAAAAF1R1/AAAABHNCSVQICAgIfAhkiAAAAHlJREFUGJWt0LENwzAMRNFPhc4W3sj775AhzEtB2iKQGE4RdaJwDyfaa1vFH46bXzgBAgj7DeIKAiwMEMQ97mMR9Hlz1QE1PDTfC3V76tM5QxO0mmc44QNVHI36d3oTKlBohgsuVHuCbsuXHQlQ7sei7o/ZZHR0JPgGj09MQ1fKDZIAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19691)">
            <g transform="matrix(154.199 0 0 68.2002 9354.9 5059.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAOCAYAAABO3B6yAAAABHNCSVQICAgIfAhkiAAAAWNJREFUOI3FlEtywzAMQwFZPV7vf4zsuoqELkjaiOx8uqpmHHlox3iCQPHn9i384+h/epsE0N6/pwngs3W9ACDAFqLiUQPeQEyAWwBQgPQSagFYRQmoZZ0GUMNBZs7bISTl/czvJpDBBAAZ1GJ8QC7YTPiTLSgQ5d8SAOXGMJiBjtZjlWrx4EF0M2ee2U+crZ1nB2pL0MIBCQDRoZ7Cm4mWYIn5vG7D1SjbCyChNK0+ADR08GsRLhBzwvefCaMLEHrgMgsPOUhhKZ8PdKAc8KvC2JYOYC7oiQuqnwpi5WBErcA4Eo7oYD+E6XtvnQAszlxB6Dxr5H3DkYGwHpoA6Q6YMNoieBXAKxc8jHYe1KU79tBylANbCpf1dr+LejZK/tyO2lvQHaguQC50Zp0AlQ7sK17aMEW51wOATyJAtP3gi1VuCeUwNJA7eoh7DvqDKFNtGoRS7jz88BEaZp6kBqO7gRC/h7eXCuFYAxQAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19703)">
            <g transform="matrix(145.199 0 0 192.2 9344.9 4863.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAoCAYAAADpE0oSAAAABHNCSVQICAgIfAhkiAAAA0dJREFUWIW1l0uS5CAMRDMxd5gTzv0XvTbqBRIkArurY2KIqDBgF08piR+//v4xXACKAQUAARSAxUYd1Dp6iScA0kbdTF6YPJs/jUAD6gK9AMLQ+7wfAqRDyg4fRgQtoM2NYRjQRVSUCWLUQ+GVYEywA3hTWwCaDdVWRDFFsbqcJQHpRin0BLf8ZK/TjSBQWZJrQ+VlO1Dbnyo2AKFYDKhd6XTtUDmUZgMmUJNq40aSmf6mATUUDmi06R5IwCW5omi7hTNstC2UigEjuRboMpUOwGVaJdXFXSruJmwzoOrcHVAFlgPwLcHM31t8y92Axg7mZTO5hptF5SneCjy4eiZXGLEaULc5Wg7QHGsHMSuX+kiusWK5Af5BXeIa8/cJevm7t2mkGW/9P3bLH0qPQc0uXKaTJllJ0JObo7S1ycu6B5q/KxZgbK7eoEXcmtdqzWxjnx26MbDH1cqMc13Uasw0yTKUCbbI0zE4DYDDLwI3kuKRwQ/GnKZTjrculXS5JcHJCX5Su8TyNKVyjFN8h68LgHuOW5dvQm14bTPmAM2KNb4Zzl4lDSXPzQHa1B6WRk8a/S3/15IOEOvrvBlon9YFmsswIK31eawC4HV7+1+lvK5C/Yu9/aBWy1D94bDv5Scjf1F+Bmt2btn6XAxzlTqDLZ2FPxu1D/wPZVUsx5PHg/ny+Rk+1G57M2StlsbDKP4kxsmiTZONB7gd6rE7ed9cuaKT7Jt2w5x3AaIMFN+/bYsqKomr6lrCNndTVVJUQ4x6UpzVyrhVQSfVBvZt0dAX+UvgcaB7BEusvc/Gpc0cgoPqYQimm28AhXPTeMqPA3S0myZXxFFVuxF2c15p1KASB6yDWgWiH2nV3XXeaWyNdbi19V3Fbs5zV5TYXze1a900xg1+hdEYR/BDocLDARfHnrpk+QFuKamGyBuodnvmNhmlHODx7vZxuW2qa8mxNXSGh6nObHVrWoKHazWhKIM9lWUOS6K1mE63TxkIIOAErBBsQggDgOeTZsDCgEhGvzdJcnlSjRXLJXmWGyWuWsopsyZE68tVtQEV94yfwV17YcZcjkOmF683tQ49X8772LUni8Dpbi/en0+XYURk7OvKJU/NagO+Aeq+68N27iJ0AAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19715)">
            <g transform="matrix(116.199 0 0 149.2 9359.9 4882.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAfCAYAAAD9cg1AAAAABHNCSVQICAgIfAhkiAAAAhdJREFUSImtlluu2zAMRM/QukD3v6puqF+tNf0QJUuOnaTNJSDY0WOGHJKK9evnD7MBYVzAAqINhXGA1OcNAOLanKNqvBeXBN+gEQGbQeDINYEiMboDV1Y7icd7YTNsoHx6IuiRELCn1xIgX3ivRt4DHQSFR+8TtMnTZAKBTEVElyxNhmoQbkQYQlChNPD0fjMRULcElnCAEUr9JTcV5jwM8PajWsgGiUJJj4tRwL4x9G8kxxMd+V3yrCPHAKoH2cgB6fkAj+alo51XAtTbEmpRiJQXUIXSkjon1K0sszwP4EJQc7Nptd2B93yr7AhRCZoyRVk5oyTT+w7cfGpVUNlw02wRyVNCQn+Ajd2VUKXU4X1WSxzAtpACEwPYaOi7JkFIprok0W9AFHqHZjN5OmIVamrVMHUCXa1HIkH1F1IlFFNTTYcrX+OAvQL6NFZT7m+ExVkt0iTNAO91sYI/eP4QU4tYQPEkTQd7Be5Lvw/QmSS658fkVH56D3yeX1dFHF24JtCzli/AzySzxXnKvruL37cZM9aFa3k+sYngewCfEKxmP9f7Y4LZjiv6eZRX6/+c0TsSLR1wWHkfeO7Y9/M1RfCo+f9k4Uz9VKI47V4vjtfgg6B3sdiRKv3Ku6ukK6BrYpMfJPdi3K3oNO6sf/Hcb/iw/6JXh8aFvY/FZzI9s/levUxyz8P5yLs2B/3R1Xn/t3lcln8BQr351O1CabMAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19727)">
            <g transform="matrix(49.1992 0 0 63.2002 9373.9 4896.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAANCAYAAACQN/8FAAAABHNCSVQICAgIfAhkiAAAAFZJREFUKJGVkEEOgEAIA1vu/v+T+4fuQUWXhaC9kJBJKeUYhwSCeCSf8p0hSHFRgZX+geyoE/yCNaffXVj8MvrfsLEsZIUN2LvLUnvGzveqR0m2wrHTBBHuDQRjS6q5AAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19739)">
            <g transform="matrix(40.1992 0 0 54.2002 9488.9 5059.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAABHNCSVQICAgIfAhkiAAAAIVJREFUGJVtkMENA0EIA8csSRXXTvpvJQXs4jzY6C668AIzsgx6vw5jQfG3ggGEIQ1xB1JP46meyu1Up2MyjIK9AJcaXIBFkoC3EELbxSGYJvXopaUbaER+g2lcwDIIFJCkwcDSL7gaTKU7mC4XAJLx2iG1+gcuwe6ZQpgktlA6wal+XIkPw49QYkOyVawAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <path
          fill="#b5b5b1"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M88.382 166.804l.89-1.333-.168.514c-.277.317-.523.595-.722.82"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19753)">
            <path
              fill="url(#radialGradient19761)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9287.41 4754.07l4.76 14.59 32.21 48.26c3.67-2.53 7.44-4.93 11.31-7.2-17.54-20.33-34.34-39.71-48.28-55.65"
            ></path>
          </g>
        </g>
        <path
          fill="#fbc6ad"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M97.734 154.08a6.571 6.571 0 00-.443-.252 363.357 363.357 0 012.119-2.914c-.024.052-.264.508-.62 1.18a5.274 5.274 0 00-.625 1.177l-.43.81"
        ></path>
        <path
          fill="#b0c9ad"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M98.165 153.271c.158-.42.37-.816.625-1.178l-.625 1.178"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19775)">
            <g transform="matrix(59.1992 0 0 78.2002 9315.9 4800.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAQCAYAAAAiYZ4HAAAABHNCSVQICAgIfAhkiAAAAKBJREFUKJGFkssNxCAMRN+g9F/JHraOLYrJAUJs57MjgWTDwx4n+v4+BuNGkMd+k1sp9bFmtHKnNAF7BVkCdIG2+oJ6bU+oe0XjyC4X7ltMHioUvcUWGxZYGPALdIDLgywsFwgU5qEOjTAF+Tote6yu6OEPdLxuR9P9BJ+g5CGBgNqArOxpO9znjzXBlqtZzv/SbbXiL7X0Wm2qHj1Xm9oB5GBKMN/IC5wAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19787)">
            <g transform="matrix(29.1992 0 0 35.2002 9474.9 5040.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAHCAYAAAArkDztAAAABHNCSVQICAgIfAhkiAAAAC5JREFUCJlj/LV//X8GZADlMTHgACwYIowwHYzYdTDBVTFik0A2BsUodOMYGRgA758Ef/ACb3wAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19799)">
            <g transform="matrix(16.1992 0 0 16.2002 9488.9 5059.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAABHNCSVQICAgIfAhkiAAAACVJREFUCJktx8ERABAQBLCsuf67Uw3jPPgl2Ws20ErG91HkJcMFxncG2Hq8gcwAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19811)">
            <g transform="matrix(154.199 0 0 216.2 9349.9 4839.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAtCAYAAADP5GkqAAAABHNCSVQICAgIfAhkiAAAAulJREFUWIW1WFuu3SAMHCP2v5JupuuphPsRTAbbPHKrWjo6CRjPeACHRP78/qUQBQCgCABARKG96bnHbAVna/Otj6f6BK0eHHjAl6Daf75/QnMk2xtP1cg8QWqW9QBn0EF/A7zykbdN2ksEUFQGn7IueDMNARVHUxr0ivvEJUVqkJylY2APepoC9jcyHqPBFKAOP78cSE7InpzOZFiVrkYNmdu9LLbBjfwDRHq8hIg8zXUC9yCccQactWlCNiPS22qQXdxWCHN/UCCde5+5DhL1GjwQ2ayFsZ/d3I/MZZCoR/DVWhhtDJz4WbZGxJEon8HF/TwZ354tYFpjNWQSnJKC4gOy+T2vFIPm/l0DI4iswXcFyVuYd8yl3PmWABCcPoB7ItN2Rrq46/DYSZ+B3+wCG0eFh3cAVFDS7L30DF4O4DZ+eqY4Jcjq1HqSuCCvdGzWrwIUDQeTQbCrMG/DySkBOYHf+DsV4uFqJW8m6cr8lG3s5nT3mB7m/eu4nuiewO0T8HZsYvcK/CfbE/ip7B/GflfgX0hdEdDF3K3aU1/3ON7E+9kaUFkrsaoVo0DN7uU5p8nsxI67bIwI/9iyKujGl/RRmQFx300h0k321FeiU6KCb28LIgbcFuMQ20tEcixXJJiIJsDeP8n+IaDSO5O1sCJx2orex4MTTp2cphOuvJKKvEEEc5AtEb6O4IBNwQimjjkpwWqcSgL7TGMdaVVWoJ+Z+NRq7eOajmtHErud9J5Ua3QiEkC8zoJviSSK2juiCioa5no42NncOzXMdrUgWx9hYT/3NXrCLUBEBVYgWzKaVteqiue7jX8qDBJ9sOBOgUCMgJP+CvRErYjw6/q0DohICrQB9f4Wv41jOX0nWqkxjeb/HY/VeRCjar5vRp4EEiK7oLdG5VoVKGhvibP3hbHLGtyD5SMY+1MswxABKlSApkCR8fnU1AAuFDkR4I0zJSBQtSkwEkD/ZCvj42VK5CsPBzysKf4CGu676l+yffIAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19823)">
            <g transform="matrix(145.199 0 0 188.2 9363.9 4853.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAnCAYAAAAYRfjHAAAABHNCSVQICAgIfAhkiAAAApNJREFUWIW9l1ly4zAMRF9zdP/zzKXmBCmz5wPgos2WtyBlpyiC6G4AhBL9/Ptry6gIqBhAhMkI4bZuNq+92TIY0w95HHFVrF1YkFFxOE+ASLACHQgrIgr3sadwENgVUeK5QcVQQ+DiMgCtilQG+AwiMCPQbFU1j2iVEEmBaIcIBKUixIIaoNBE3zLWlKeuu+6AEx6rgB2COwlF9twyIGyzkKAtNUgJ6EEikYt8AgrVCs85UxZQoHpkgAqUVEwCljVgEt0B1mlZ1H4nYNszIEfsP9l0mXJRWawaajUAmeoqPIKx3l4BzfuKr9irZJTsjyhFr3EoFxIjXW7UV3r3SKF5Q8ZIitvjKEE0Z3R9KnaCOtLbZQyQqPMZKMCNdU+DXVLIINOUL3Fn5xrNwd31itqb7Mi08h1kbBGZL7RWNTVSrRgrfWMGzJlDTbWiHF6pAVrytJJAaMS3nIIRbxE17t50fDDzOqyVoNu6T/ef24qeOoFsdIxVWGYA50+hT+1w7+PrrMamD/mcAbXrHRMvylXyOmGgJlBj2hS6p3qb0knrAYE2D9SJWxG1JPjSQQ3SLZjaZ2GPtB54NsAxF+JKKefWjVKTnVTD7wnQ+/vzgHe+IgyOHllwne7Z1aDnfncvXDZxNcSbeIc6DYGLoGdgZxT3L9c37RHRRqWcp+YbNtDK9sFvmOHzqb5qD4G/lYuPK75CVFeBv6E6gd+7rc2uEnyqufQg8LNZKcdazzNwBPBKKZYXzrxRc/fzX55c5/mcUr11+kzDHYH+guJzK43Fs+bp8zLwOty99b2nj7xGY3Xgd9P9iuqDAfJ8kz0mvo4hmSKd9/Xr5t1qG3uneP5f4iyQNp97vkdqO3Bb3P+D9ko+ro/a/y9zd6U/KK9QAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19835)">
            <g transform="matrix(97.1992 0 0 116.2 9373.9 4858.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAYCAYAAAD6S912AAAABHNCSVQICAgIfAhkiAAAAH1JREFUOI3tlEsKgDAMRCfB+9/DC4or24UfWk1/SQQXDqWEljxmQikt6xyAfR0b8qpfBGACNl13QSzBtPwAgC1uJD2A1vTvO/yBdiB5A60SgRaXrg6pBtS6/O6zORNVgZrY7Pq74nLoB3WZYTqaJrBnjmk+lo/HNOTw3tC6i/CcEcXzMs5vAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19847)">
            <g transform="matrix(49.1992 0 0 82.2002 9488.9 5021.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAARCAYAAADkIz3lAAAABHNCSVQICAgIfAhkiAAAAKJJREFUKJF9kW0OwyAMQ58j7n+TnWRHmlTvByENXTskPqQ8Owb0eb+MgbmAxd0YhOEQsIB7wQAgsngI1AQNDtSK4VMkzSZyOuahWtt7BwSYUdF4EGSckQLOvQma++gmNUqQ8JbR2gUdBoLIarXMWs10lIwXfFzcy9CE+/dd3VcUQag9j+QJh37gAOpzbCa83BscxML/w1FP8QRn5qgcT3Be8AsgW0vUYmXm5QAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M95.58 157.598c-1.55-1.21-1.266-4.613-1.281-5.574v.922c0-.15-.01-.307-.01-.342v-.58c-.003.275-.023.712-.086 1.217 0 0-.453 3.413-1.271 4.12-1.844 1.615-6.484 1.305-4.705 1.347 6.009.128 6.009 5.992 6.061 7.916v-.969c.005.071.01.128.01.163v.806c.128-4.554.114-7.434 5.356-7.818 1.736-.134-2.264.2-4.074-1.208"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19861)">
            <g transform="matrix(63.1992 0 0 44.2002 9061.9 6355.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAJCAYAAADpeqZqAAAABHNCSVQICAgIfAhkiAAAAHhJREFUGJV1kEsOwzAIRN9E5P6HzA26j6cLm2KiFMkSePSGjz7XaQALJGYITOWpZ4Rdmuu/5VkfCWmsyvMpaXVAXkaCwMBY3Q7YO7PzOaYhsMpqTDDFJ5x11Axrrnsq/2Aa9APpMLWzX6E3mL4zQMjP4+5wemxXAL6fVTLzOM4ZYgAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19873)">
            <g transform="matrix(279.199 0 0 294.2 9071.9 6365.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAA9CAYAAAD8vnqQAAAABHNCSVQICAgIfAhkiAAABNdJREFUaIHVW+2S3SAIBWvf/0U7fYMN/ZGoiHyZ5HZ2z87tJFGBI6hEU/z75zfBBYICAAAF+yMYZb+WZ0+A8DXdH4TX82Ouh+/oq+2CoCwEd8gRlX6NeDg1Z9mNcNN9XHIaYaImM22Kiqp50SPICe3W0TrAI8y9S/SMbM14MUMuA8/rGuE3ybLQvUvQ07yOdSlbI/wJsrUJ14zQsaNF1lUmOYUw9+4ZcQhEbGjdIFtyJJH9nsCWo+nltqFgRnawqKgIX0LgoShtUl+a6xXPyhCWyw9vwzmjMzw4Nj2qgwCXn49VHlGZdK9zBnaC3JuxrhNjMjIJrsgI1+qsvd/q8PFXunf5xNTqIxIQ7Y/T0oSvBogeT3vLht1+9e5os64GkmDGpqKTzAvSwjbqEL08S/ZKFXEvhAVL3YuWoZHwqN5TsjtgRFeSmmH8OSZ/Wltbj01WYserRRXuePbOihoRjsiOeve9unSXZ8Rb6UKkR2rzJifpVQsLUW0BfiMnkvJi8ARhJBNjuVkTCC95cD1KgK8S5ECIvJpJOtpV7NICghi/zpIk5ZeBRlaVH6yroyycjO7BI5UlLcnueVVro6MT3fHmjtda/aeIUtQofFWP3nuV9uG1872qydrfqCtSsJ+6ecrH3532NvamQ8v+eooilhAQ7KydGjH+zBsER0J+657+RkNny3N4HVdZG258g2++D5YXqU7WjX0k6/C7nZnw6QbdErpLoaX4lSkmE87vrOTv7GMG8Lw6P79HqqWAt9bRaOL5aUh59OfROsE9/F9C9zvAJLqfiH0/uMtLTsBnqGf3aJd22dc0nBZ4vfL6WpwnK+tG0YLKCj7eSa8kgSULa5v13vVo/OYRk/VIzs/1lOQtdKKZsNF7Xzcdrz8P6ffWxMFyhHqqk70+8t21VDEkGcaZWl6HE+XCVsMUulmv3pmKZBuayj4btgDu8sLfBLTyHLSOsUiqG3MvhC1AJ6ory5DViHh7vzk/aQfGc9jugnnUWlZmspahmY3t9Sztvjd3xicAQNGERWvSnT2jPEnbm09Q59sxx647DfO9NAmN5xJ+J+qb1qPu/mzbUFahdji1szENme3NOySfjs2G/g3D2JMpTOm6D6MZzMu6sQ7lDEGELzgIJ4J2uickKarLKWwcn1vebQrsXHg+BvbqaPI1klPbByQBrtCNyeqEcwmGVneWqR8irWPyCSrCAQQFDkIoOD7FWT/DGeEsiexBdJpCUoaspSvrTYC+r2uTBZBbjdZc6yFeI3m4ZsalLVlHbQepTfhBBQp+XUI8wjtqBvRlY5/k0sWBKbUJ7N/FwtG/mbUIA+xvKFsEAfRQzZDMhGxDTxgk2RHK1A2Sn9LdBSfY9HE7Rr0EySTqdO4iyJ7GDM81D5+K9k60+Gya+aw8TTLJuB8ycWXT4k88XLlR8qNEH/wz1KZPLhuZsUj9nz1U7aH0cldC/Pr+i3GG4Pl8xl2SAADVivmmfErsDdIRrAXfTxNnPCEJAFDnfIUdGQqhBckkvQME6mNUi5rRwQL0bHNlCl3uRek9mXtK4hY4sSa7lyVD+ClJAGeMcqO0kJXELSxvNUqzTxJsqEYKOxkQhaw2XqPQDnPkF0kCsDGKCcLDhthLkQwTLxNsYP/v5TLIIQy96AOmfIhgwz9/8JSmE9sRPgAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19885)">
            <g transform="matrix(44.1992 0 0 39.2002 9243.9 6629.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAICAYAAAArzdW1AAAABHNCSVQICAgIfAhkiAAAACtJREFUGJVjfPuG5z8DAcBESAGVFf1nYGT4z8BInEn4FKJYh0shhpuwWQ8ARGII9Og1hvEAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19897)">
            <g transform="matrix(20.1992 0 0 25.2002 9104.9 6355.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAFCAYAAABirU3bAAAABHNCSVQICAgIfAhkiAAAADdJREFUCJkly7ERgDAQAzD5Lx37j8Ji1CGmQL3y3FcThA5rdnT8plZfcmiYspyoSuiJZZNE868PVvUSwJzFIcoAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19909)">
            <g transform="matrix(241.199 0 0 193.2 9109.9 6365.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,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"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19921)">
            <g transform="matrix(246.199 0 0 212.2 9104.9 6346.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAsCAYAAADIIYBkAAAABHNCSVQICAgIfAhkiAAABBFJREFUaIHNWVGS5SAIbCwvsgfY+99qbzCyHwnYIprkTWp2u+rNe1GDNBDAjPz5/UshCgj6BwDK8SWi54BNRChUz7nmQ/1aZRxvgDbx36Df+jXvobx0uBY0AHxLcT1ZzkDknJTkc8454RJ4CwDRPh5h8+d6KZouyVTMUFgYJCESFB8+Ap+T4NFUg1O+lLBnvO9DlEloJGKTosEzwWt+36nYQEKRmvXK1GEpOzK7tWyuRiLTZCGyIA+FUEmMtdU4YmEHW86RWfKVFFopEV66ieYHln8Dk5aTZR8F801SHIYWOy/ghccOQRm5L/llz71D5j/BO2SsaELhFbOtFp9ztLTf/z0UhHD1aq7nH72K543WGr53a17A6BnXi82GDaF2WlV9ub5k5U9QMut17xAp5Q6pHddGxAUkIaboDdUVsjXSJZso3q1NvRkLGbzDhDQoxmPH78Er0UiDXWScWxFZYLW0unXNyO4UalH87rOI+nXXdOqcnYDMxmJTt256bXOIPnmk6rFaDusaIVOoHKSGQhqIHCSSI8CQrR5qlSCKyERW9wYfW2yswQnNoLHoDd9Nxjk+y1xpdm6RDeui2lZXphCjSMjAuS9m5OgFDq9co8sQ46UsMnv4DzKDFxJChkgsktjtCswnzBsh+DRKq4XSQEgxHxyuCh9X8x2RZF3qlSQaj61kSY7CjAgJSRPyVEbCFJtIBSI8n3loIdpvuwgxAKja5DjGGiGWYKSi9Gzn7PlYEaH7dl6ZRctWjcoCBXoQ+qSYxVoCCi0bY2JtQQQzEY0RuiMD4LBGk5H7056aSQzaJESS10oIiufPTB5igJGxkBJSRABpF8RCdhtIMJmbRDBGYPqebB9mtlHRgRSAtNeybkCz5nGKD9IG10SiR3pe6fGyKUcUZk165gqkeCxtJpmAIXjjdmEMovh6ZYdO5gv95Z8KvZTTUblYRCMZ3zmE2h0iIXtxeO3qykRmSM1Afzbi5rHesOJMxnCDRCTiDTWFl41diDnIAJSai8I9NYVZTwyT4kwA90jECh+VbuSRq/AayLi+pIC/xL4jyB61O+Y7Ze6IeBLEvfAy1NXEbcWeIstaiPniWXgZlmSG/TdvHG+/wEjat3htDzwj+S/HEjXNUgHfeuOy6EGzUmSZ62l4GaqeG4rt8hb2jfSUxTlzfapG5Y0kJKxHUpNamn3H6s5Z6ztEAKDa8YWjzRqA4R9QCwEx/rO5vEUZC+Lube5dVBNmyt5ReodIwNAWJL7rDUblPpOVuSLHiOHEyEgA8z+m34Cn5hUp9lqGlTLhQDkQiS3fW6gN/ZQpyIvULtevihrXjFXovQ1PAOqkcH6rX19V4TEJ/CwBRuXN+PjPlfgqFHY9509iaGcyBeL7jQz/QvEMfwEFiaF9BsssoAAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19933)">
            <g transform="matrix(212.199 0 0 164.2 9138.9 6394.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAiCAYAAAAkjjtxAAAABHNCSVQICAgIfAhkiAAABJhJREFUWIW9WMmu3DAMI/2C/v+PFr13YrMHa7OTyZuiQAUMsnmhKVqSh79+/pDwBalhGpGm+YYDRAcgEIoWGgAHgEG72nMHcBLs856DwAmgzyvtXifBE+CZ73US+E3gJPQi8JpjCQAFtARLCC0gyZ4BQvqC8AWAGKItw9ZGgBREgFzfxw/2HQIaIHI+NwEEZO38atMCTaDzaHZMMBMgcbXJpwB9QWhofBlggT5JsyZ2zw20yAm0mReo+a44NBYcPxUG0pqshcG6/HxUbzeZRgqjTIjCsrMek/tIxSvVQxfbvRUML2BvOgbzJgU1kIzWC8DiJVW2SrtY2AM4+fcbl7dnsPO94j5ZVmmuOiGQGlwA6QqA2Xf3fl04W062SfreHPKC4WbyBfzewV/ZSnWjz3d9qrUK6Mlqi4wq34z+AYDHrneSmGP+w6j/2T6SBIDYmMBMJJ5EHm0NNZ9Z3Rs3fZuDebItTtwPZuAoAOMBj/mZUrb/C2u+pAbeSsPfKgALRF/0xbuJLwGdj2xXAqjiTQEaOdnBEgOcxwSbczvYxhckodFy4DC5iBG9lkkFQIQ8T9gClvYqEy27+7qwoyTfN+l5VhgzFZt2N3aXCQFgGKCQiSArkFS9Ydfa9gJ+W0RrfBnUgYZxackCdlZsGdDkWh1MWexD7AszdmubZdHRn/m8MzwLmlm11Y01GUWUlgtYrSBu2bHS09uKDMbn+5VZegHloMfV36Fh4rQaodpa/syrgbVBl6vXwl4fFzk4Wyzs0frl4jmlY3PchcWDBdiu8YVtX8JIZicorhEi3G6M+fcx2dUg2jA51e8qYxcStLF8QKXiKkn64gxhkUGADfdhniq204eCaQciSCaHunhlW7jGb+L5gYHltMCa0pDxMcrXkZuGI106ZZ5gQ7t+X49SRUL1mLWQ0u/T2RFV303MC6aLe1WA+wSu2wqA9p4VlGxX+aKqHHp6IdvfAKbTXhYkvomVBWi4q4BFB+ggHYBSu7tU8tmCZ+ccq6dHrgwPRmUjzJMDBlctC2h7rCyhh70w60mjSqGXKOIbqTDtfeUEuUdvPH60ju3YsmU7JduqiWGkjqsOpclyxuEVbGi3F3bHZJcDGOGBNxpWZc7NTrcF8wVobLqe9wF2AOjOfNHsYOr6Rq8aBE4+VnsHz2Q4rAi+alk1jEXstM2GBBusjfwzJZMKMPy99zV2cZax3wFW53oU4YyTwW4Na8Zgpk9GNIiJfMN0Jtv+bCy3nux6qBuDoC/kwQ52YzcwrmViMG0syjdaCWkazMTgqXlh1p9p7fM++p9YPPse8INeYtfCU6gAcG4YZ3yULGWa9vsFbNFvDVscgM78/p0dM6PocuymFFEDwFLjRtECLuB8d8cfgm/A1m+jTyl8AhYwSSyFOy0hOdyyCQiscvAU2y1d1xBWZTA2sO6JblI48a0UkuETl7PzsgeLrryGyEqsAAoNW3wuYFH063/Fyv+C9TD5oR1zspuDkdbrWqgnSE8cUX3V2BtsEjoLy5E4vo8KV8Cd2PF6ZbYA9ftNEnXzsDCOAdv5c5NWSajPBMHz78ACwB+aHtEdkqKNqQAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19945)">
            <g transform="matrix(203.199 0 0 188.2 9123.9 6447.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAnCAYAAAB5XdqFAAAABHNCSVQICAgIfAhkiAAAAEhJREFUWIXtzsEJwDAMALE0++/srtDHQTFIE+iZmTkL3L8DX4nWRGuiNdGaaE20JloTrYnWRGuiNdGaaE20JloTrYnWRGtroi+XHARKCHlfEAAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19957)">
            <g transform="matrix(140.199 0 0 121.2 8984.9 6571.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAZCAYAAADNAiUZAAAABHNCSVQICAgIfAhkiAAAAV1JREFUSIm11dGSgyAMBdDcwId0dmb//xO3Dxi4JAGtdfvSiujpTRDx+v35E/4oJPsgH748CXSuPoJtJnYsoP+QzmPQcVwz8GssgfiSOl9wH2OQsT5dk54+kW6HjXMi9dFSLpKhYMwXV96PsON8SLfB5BS9CmalZAyjrPYd0TMsA7lvWGM2Z0ZvghNm9yGst+C4rl7GroCcjpIZZlTNwIBdBX06h9m50NOvwCQdY4I2TpvD4oFl0FblAkzT2W2LzkmXoLl2sx1Y7BgzpjTP0C0ICOwf3gEp3UD9I8Ne0XyXIbBhEsEkHa/sHOWeuLK2ktExg9NYxFr6xeYAWgyhrPS2+AgERLQdDNT1NpRVdV6lfZwhB1K6riPZHLKU/C7sZVU9ByndSLzoqd8Apn8tBwh/AYE2ZqBbUPu3jPXRfhe3Sv0KFRktWYAhKdRtczIm9rInL4H+mEwgz6HkgLwBIksFDSL6ZroAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19969)">
            <g transform="matrix(264.199 0 0 231.2 8975.9 6466.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,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"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19981)">
            <g transform="matrix(255.199 0 0 221.2 8984.9 6466.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADUAAAAuCAYAAACI91EoAAAABHNCSVQICAgIfAhkiAAABANJREFUaIHdmdF25CAIhn/Sef8H3bt9gIa9MCggoMnMbs9Ze9pmjAqfKP7J0O9fL8Z/Vl4/Zpne68pFKP4ZFBGQ+rEDyO6S4nsA8MotvVGUQXojItumlA3mT0cqgZnmbQUq9zmo04XnJkSfhLqMpjDeqZ0IZm04uK8A34e6A/OppejHYZjovuiNPcXUBiFyA/9weRwpJgAUbFS5uBmh1dyWQ+g9+GRPsQzggO7APFkcvk849FX5LFIroAcwVSSiflGukHILKlpyO0CRU/7s3IlelOmjrL8N9QQoWzIZBAczQqplBOABCcCLuQr8NYCkSB4ZD1D7yxnKCvf/tmWl46StVyYNIO64jBSTcpZsva6LjGYOAjEI+VQK7u18+6YlL2AXzRKKCTjAfenpeij7pSRCDkNLYUiBdmygMk4EV0J1oNheH3SY8+ZnmDkaAOOrcuMy992vxCZzA+yfQSBwodJFLWDeO0Kwq8DfBdLtBpyCcb6kkaKLyAOZpVdASZSGQRU1B8J85AOJOTpN3wYnSWREjEEJ1EpR01xlU+saqAZRKVb6qfZE5wSnwUKoVZRSvVcA6ehYoMWmtR6Y/gLnwWaojSg9BVrBRIdva+lF0YCLwA7xcfy6zOHPh6BucmKZQHyyoBQovq+z6nG1+er3zMIOfY1sVQnCaac5Snp/WWfls/+N248l48H2EgUuZVGoBitnaiDvqHUxsO0OVzmPxpjclyIApClodeiuyi7Q4mToPQk2UtlyZXxZKPLP9tsA9XqvgO4UDWfHs8vwyJ4DyNVXDmRqOSsZEAe/sb0IbJR6+d2IlFXKs/TRTkQHdwaQ3ZtdGzWvrsuuv+OZp/2hg8dnuQgVBTX1DK+s65nZjbF/WcXX2H6VMB+1Sp/2GLCM3kFczLo/n/z9uCf1KMPsIv3QqeHWSjI0Mhf/EKfVg4bJ03YeMzZLe+3ZUVoqSvwwuD9H9ox7/kZ1mSgYeAT41Pi9/vvgoi8A7Ok609YVwpl2y9L+O1HKpunRnvpkuX8Er8s9qGJS//aXa1HJXpNtQ73z7Uhk+L5E2unR7BzEzWGRRbKvdF1uSP6zq//uitnWxzto5TAtjgRtn+iEPkymcobPIPOZNDUoP2tn9DWFcBlQ9YbWqnQXLV3Xr4tCZIF1tMQBH635bYH9ydrNZVNR3NlH0RKMDMZ9V08Btugo+aUHfCClx5JpNqQdkGh51Pl9yS6QsofvAXUruSX7isAmtUfR8g7dUekVENHZ7b3I9RT1K/tDFLBIKPWtjnhuFHN7Z0hgZhBRM0QicJtbbTz/DDbeVdhpUONO1zMQwPOjRwMZXca7gaviGCqumuU2KXyJ3PP6fGBEzMOszzLbZgABwMnUZdofqpHX2p9gxx4AAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19993)">
            <g transform="matrix(221.199 0 0 193.2 8999.9 6432.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAoCAYAAACB4MgqAAAABHNCSVQICAgIfAhkiAAAApNJREFUWIW9mGGSwyAIhSHt/W+6M3uBDfvDGBEfSFy7dDpNFPGTPK2Gv7/eQsCEuF1fHsxEpMqL36u/lwOFG9qtW4F5Z90Z9JuDjoEF1DPBXHbxILjNdoNW5Qr6CTACzfjYwQzgSCIWJIYeO83AzqzG4KxUrK53Qkd1nlwEScWXSMbspF2XivVDg8AafyyRObQty+ZEaJQJkQIfAqclEkP3mXtutY0dwLAcSLQSTWw3tDYmPQhu4ExSvkx0sNwurf4nEXwcte5wh9VYXcZrhrBGX0PZ6MPd9U5gbUxgcjKJAgADcPS9Co2UmWmb+svPZPupRVNJ13mDuNMXyQTbWraFYmjkj8zbyuEg7s6v2Qx6xVC7joTBQ5rJxGb7Seetrn2y7d/l0Uo3KctaLtcyf16uBzGfQ9Z1u35izycZAtVlkeiSUsm59dkneN3K5sKxPvourXFvw+XJIwqcgZ7Z9sm527ysH/ExabWzPMiqfTyF+9NS7P+f/Sb7CDg71zvt2HGQfWK79ozd5KzXdenj+8/nvMpPYq5l0rWx1z2svc/DW1+4H9edW3iR07qGNpuUGXgPmmiTxjNLKsL04Pn6RJZ+BYdNBqRuzzPUjpaVjfVaynjTuQ6cy/pfTvrVhCbgqzrXg1g9mlU/BE3kgKeyZ1YX2y4Dj8C8chvnsVRw1r1lsIf30hHBej244P6arnwSWrf3K2dO6w/fZKWCTbI+g9dAtkaCunpSI0pKJZ/1GN5/dTx/EuOLfblr7h8xzkLcTkBSV5jyqk7odcOXg0Zr3Wt8fONq6zxIVOesKti5LzvpFCb9TtHLfo3h72Wk+0Y+1Rq4oO5GeHv2nMPjAeT+sJBviRmsKkFAo/kYHg/AgqHvaK3sF1JSMV2t8584AAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath20005)">
            <g transform="matrix(255.199 0 0 221.2 8984.9 6466.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADUAAAAuCAYAAACI91EoAAAABHNCSVQICAgIfAhkiAAAAvZJREFUaIHFmeuy4yAIgCGn+/4vurNv0LA/WhNAQCQmh05nEoPKJ3jHf3//EPyyEGwpPYQ9pfe6YkxFsgCZvB7kI1BXQLLlcsAX4i31AbGg1i3ajNlwPvJ3Og1+zFPk2MlBEOrdWDYEHpDCU+XSlVgwIxCCn+l6EN7ivUHutH2/72ugNFAUXhWQKH+D5HCXoSwgDTMDQsQ6P46H8FY2hytDZbwTwXDjZ3UsWA5Xgqp6JwOSq9/3JsHPPNQIqA4TzS3+aNnK5nBTULNAMczMBKl1jQGIwdX7VAlo1UzPy1FhTxu8MhMhfQtBPL214S4KR3gLMMTdAKNDe430tpc9ZS2tVniKjO9xozd9FjGZeYpXRMSBWDoDmoGxIDI6PaiEC6E0UF/ICKg3KAMykqM7mHCTk+/HS/cARd+8ELTh0Ifywy4jUtkzOOs1rmcvjFGkj/vUdNiNgXRatr0I/NDjYCZUV2k67GIg2eLzwocDC66BhesXb8OXkdVAXBA4YF+PCYXw2dQh8lU3se9vK1tXRmTMCvHKcj3VWsDuE+P9kRhoAJfCcEHobQzDTw+VWrz+VAUi458RDTa9wbm6HbfL9AGygBzMhIpCzy9S5m3Po13SzFiU1S1vRTMbv9q2b1DvoD539Pso9P1pFHraSxXDiP0q+QHY5MsnMwQ6Q5BaVRvAcWC4mfslno8/f95jsSB4WhTIcmdXCr9cFuk1MJ/PtMxGVS+LfItKfcpb3HohF1WSAcpIBJkvZNFx11Sdgbe4CMuuHNz7hkTf7rnve7S5n7qyfD6GHpDbodB5vlME1IpDkRm5a+1+QLVJl78DnMP3eVO3f9N3dn5NIo9+5qIxZsC0rhcFqa2HBiPKXf03Ga+wx2ARkEy/4do8My1YBnlg+P1FomtceJFNoM0Va8juay/ZUBxpXfaUdauX9daVE6Umci/xeUtDVfuVPMKyvifrN3QtIIAEVKrV1Sio82XALKO9dK+cJpfCz/aWN5RLMM+oCMSrQTfgf9/9XrdCDxB4AAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath20017)">
            <g transform="matrix(275.199 0 0 251.2 8984.9 6432.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADkAAAA0CAYAAAAwhpBbAAAABHNCSVQICAgIfAhkiAAAAoxJREFUaIHtmt1yAyEIhSGTy77/U7avEHvROHER9ICy22Z6Op1JV0W+BX8b/vr8KJSoQpxpvhNTj3PP6uxsONlvC5sGqb1Ry6HddqXSIC2tRli2R6BPgcxMXS09pVIhzxyXI9gUyKsmnbbv1InHA5g58bSw2yBRh3dOPOgMvgUScXxWZ1RqoaDAy5Az561yTzxlXQ2nEJugS5AjQK1s13TU2imHz/oMe4t2dBWgZreP9PFJCNIDqDmRIQ20+uKG9AKeKSuq4XSVOs505wO2kn27IK0oSsDfoNYPGPIvAVZVf9KWEJ8dTJHemEBIBMbrQOTOpbbx9rVlnTwDULb32LiPq/c7iH5XETlJrIN6et0yu/psrANWO6gGkAiQD3r33Sdqb3kJwdvnCLF7+m3dTEW4zdBZdZxTC5Cea45ZuV2jliGwlox03bd3WQH01BuV3q1T9k1ZNkZGNTuzAY8CtvWRiD6cfoS1GxBpZ5VsPzQjna7K+4LSInmlJNQlkNFUjeotIyn1D/kuugRyZfeCSK6TdxaPCt3o+Iy782T9Wzs4l0PL/tnRamwCsl6S9pRpMZKR/9+vygtIlJiuMmU0edM2muYdpExfr0ZvVK/PkPOjOm2J5r0ZyaJ80juwy48jeywNlpsfr9oW7vMkP88Csw6io9Wfwi9ZOZi+hHii6ZUFCP0vpI5LKxoyRbWURR2IKuFKMrqevSRBV2Bl29lLDKcrEk3ZqRwzHlimvv6D5oBMxYbsU3YezQhoLZ/9SmkvzNL2HQ8KGl2NtbYWYPVluIQwPag8r7R+DM1uOF/GrS9HtK8AvXCyXsh4kxH42pkFagPZoNWKFBrd+cbC+RUXZJtnp6g9jkfjbaW+1uc3PSzGjBkSOTAAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath20029)">
            <g transform="matrix(212.199 0 0 232.2 8999.9 6379.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAwCAYAAABqkJjhAAAABHNCSVQICAgIfAhkiAAAAE9JREFUaIHtzkENACEQALHj/HteNPCYEJJWQdfMzPeQ/3bglHBNuCZcE64J14RrwjXhmnBNuCZcE64J14RrwjXhmnBNuCZcE64J14RrwrUNk5AEXEE3zzgAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath20041)">
            <path
              fill="url(#linearGradient128983)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M8999.31 6302.4l.38.57c18.73 25.05 40.88 52.61 64.99 80.33 1.11-.69 2.24-1.37 3.38-2.04-27.43-31.77-53.04-61.23-68.75-78.86"
            ></path>
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M78.954 111.344l2.013-3.017c.091.063.184.124.28.183a50.09 50.09 0 00-2.293 2.833"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath20059)">
            <path
              fill="url(#linearGradient20067)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9274.34 6701.29c21.48 29.64 37.4 51.53 37.57 51.53l-.01-.01c-.79-1.71-10.2-19.52-23.46-44.53-4.74-2.3-9.41-4.61-14.1-6.99"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath20077)">
            <path
              fill="url(#linearGradient128985)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9274.32 6701.26c.01.01.01.02.02.03 4.69 2.38 9.36 4.69 14.1 6.99l-.02-.02c-4.71-2.29-9.44-4.64-14.1-7"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath20093)">
            <path
              fill="url(#linearGradient20099)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9273.17 6699.67c.39.54.77 1.06 1.15 1.59 4.66 2.36 9.39 4.71 14.1 7-.22-.43-.45-.86-.68-1.29-4.87-2.38-9.75-4.83-14.57-7.3"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath20109)">
            <path
              fill="url(#linearGradient20115)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9264.41 6663.07a188.47 188.47 0 01-12.55 7.17c7.41 10.24 14.62 20.2 21.31 29.43 4.82 2.47 9.7 4.92 14.57 7.3-6.98-13.15-14.97-28.19-23.33-43.9"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath20125)">
            <g transform="matrix(30.1992 0 0 24.2002 9056.9 6375.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAFCAYAAABmWJ3mAAAABHNCSVQICAgIfAhkiAAAAC1JREFUCJlj/P59yX8GJMAIpVkY0ABMFRPDPwYGhn/o0gwMTHAWmgImDKVQSQDrKwmTkzE3tQAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath20137)">
            <g transform="matrix(193.199 0 0 260.2 9066.9 6384.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAA2CAYAAAC1ItuGAAAABHNCSVQICAgIfAhkiAAAAbhJREFUaIHtmU1ywyAMhQXj+x8jJ+xMd5CF21gBCSQhMOn0LZ0gfTzxozjh6/uRI+yruDMcAMDufP+Awzr8QgXiWR6OOgBIAUm+o4NWAkqgpDFkoIo16AFXxuvHFADKAtnVjt0BnAkmy9MAXAXXzscArobj8zKA4+eXlzZzsM5NnIM2OMpzj2kOX3WtxYA/08GG1+hYfyBTBt1Kta5qUzdjTaYbd5oVywe+ScbHI8B9jhYsVYm9pqCJoy7xat3W8ktd3P43iRjwri30dxy8awt9koP9VebpYj8W2SyskWaiBeBaFyVa7qC2JSEAZS5anLSMGXJQmlA3oXeDmJY/i0Pib9lbfF6Or988oOrl1Sjx6tuXztdZg6sg+TyCTTIbsh0/JnEQ7Q9Nacy2YoAMMkhdYI/xCdAuTqA9FDWHin1Cxxk+Q4ZggBwH4JTg5HrxhJ8kunL7K8EFB1AYFiCDfk366TdvQBUhb5ITsno3MlXYNSw2/6qSlyUt1byLL8hrl3o5SpWT0sF1I1g4yPvhomsPMhot/SPtKB/oXkrOuQYxfFWx2f8r9VTmbmySteKM6WySS7N6mp4RT8xLXQYUQ19jAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath20149)">
            <g transform="matrix(68.1992 0 0 68.2002 9205.9 6610.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAABHNCSVQICAgIfAhkiAAAAEhJREFUKJFj/PZ9+X8GvAC7NAsuCUKAiYGBkQGCSdYIA6QZwIQpRJwBWDQSZwAejfgNIEIjsgFkaUTVzEKaRoRmEm1EgCGkEQBDNAW+kQApAgAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath20161)">
            <g transform="matrix(202.199 0 0 250.2 9047.9 6375.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAA0CAYAAAD8H6qwAAAABHNCSVQICAgIfAhkiAAAAFNJREFUaIHtzsEJACEQALHz+u95bcHHgAhJBVkzM98D/tuBU6I10ZpoTbQmWhOtidZEa6I10ZpoTbQmWhOtidZEa6I10ZpoTbQmWhOtidZEa6K1DeB/BGTvZto3AAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M86.138 102.157c-1.55-1.21-1.266-4.613-1.281-5.574v.922c0-.149-.01-.307-.01-.341v-.58a10.81 10.81 0 01-.086 1.216s-.453 3.413-1.271 4.12c-1.844 1.615-6.484 1.305-4.705 1.348 6.01.127 6.01 5.991 6.062 7.915v-.968c.005.07.01.128.01.162v.806c.127-4.554.113-7.433 5.356-7.818 1.735-.134-2.265.2-4.075-1.208"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath20199)">
            <g transform="matrix(231.199 0 0 217.2 11183.9 5693.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAtCAYAAADoSujCAAAABHNCSVQICAgIfAhkiAAABWJJREFUaIHFWUl27DYMLNDa51q5W84sVBYkJg7qtt0/wXtya6DIQrEAQrT89c/fVAAQgE2gIgAAYlgTuGm/KwAax7kSINDGubAfTQlR9GslRHU87+2aKmjtb+kD3ujvTAesL2Vvw4B0zeBpoBNut68+EAHcOhxpvWOlPY42YiMJALE+2ceDQAQA2duOJmaUeu14JLMLtBN44nCITUFvryKgvWMgBWDrbQkBxY4VEGemWn/XnGDxbGW1ncA7kC/xw+/Z8+EEMEgAAiz6Ye8YxUxt4j4dcDi4gmXWTviLLXi2YNbZSveyExY3ZZrTLBRzKSX2Gyo5pT12xIcDefAMvgCaOipOoA6qm0GyjEp/AGTD9Nrr9CS90tXWNp2c+l0Y7T8eC0ABOmt8mRFv92w1FsJa6UCC3W9ZW5m1OMj3juBSgwXjfN2my1eeby3L7Df2gS5+BmMsRr+2D3ThE+JrzFhZv2XZmXTqSfZFf5IacG47X09Zoi0AXtlhgJZGtnJiBtef7bt9SwmLd0DzgbmZhQNYez6vj0+yyk7lvrgBVXu19/fnlzWlMmqgpPEcrA4wOQtlYd9XRo5ijNMsMCQq6HVQX8JRSCmOPgjkEiVaG3lcCbFFKrMNTNoO8IV9BtNWTNRCqsrsEdxmZoRTJYcUxI0DTJKHlyn5egLfRrlsJfWOfXfK+kmz0MHKAIgSpEIb/zwFrSW5FCfuYEgyi/eo7zfg/XtgZt8YTawLCHrbSro5X4zjz3T/EhINAjUnxpyoyDE7bT9mmJie2DcSJLVz57b6lwLWZ2FTaF2iHUFDL4dlcmRnOS4y8y6dSfuiWtjPQbyVT8qM4UR3ap6ZyzOOxBeVApB7lxKiQ2O9BO4A75+SG+3bQW8/yLY2NnuL/vdquJqyfwERHqVfMirKzTuS2HEHMIG3wFWW2fF33HmJGIsRsMhHGVKbHRAQUAEaQUrv+OEjojgAi4URF2k2PG26tCLgqREnzr59wNuMJcAn+XQHFBAhqGPMFkwt36uooO1a8mx4ZopsldcGzzxZ+6n3kmL9/JxGr2BU3JH+iix1THbCB3YJhQMFfJKRbaPAtlEm9mPbxUiEZx/ZZKAxA1UywgT+IYg90yCxr+qDSpqNkjZviXUlA5tjNaXfJ7tEFcg7BMAeeO7cQI97M+uu+RQPtJnAKh1RiWxlG1l+fmZ/OOA5bvQ2fVLm89mBMSgY0eJS0qH5fG1ZxwJ0kg6KdKYBjw6MhmKKkLHMPxToof99MedJwGZAcQSfpZPz/jvsA8DVbk2bTFHtuUMz+HwxAfbUapIBQ/PYgzepZOk85f3FAQ+wTQwIULZI5g+SZU0gnHVJrL8F3mZAI8O9CmAAuKh04kVS7vefqZccBykTMS1YoETZbdrGBnxOmS5BvCUdd0Bu9lUYFrzsu2UvvOfYVc6lRAdeWbc8b9db5j3Qvwe+O0AB74Fd2Ku0wyps5jX8BnQG7qDRU2UuE/bgD4H35ADGMgDAiysLibMDtv2Wbg5mV+DjDfvnyAvw7+j+6ACr/F9bGvAEHKmkhhVwFqi/BA+MYg4A0GrqPG4aZ7B2Q+N8CzzFQQXPunj9wNwBB/7GS8v+awEdvdWiDPElt1t5f2iXaJeO3CgLmRnTp2XNDqY7W/hiAbT0GeezZHb9/cIBkaH/afvCHcuwvQnrvQzaHifg4OdYXxzoKNbf4yCsvzNovzcDx2dYz3b5/36tHvoOMw48gbb7E/BPsp6tz8Akn6dK1Gy78UT7VOQfB252xY6y+L8xZfPPuGVmnPU0bToa/mHQ2S7ciBrI7r76x1PRMf3nvwKd7Yqvn4FDAEyZZxcb/wfYnf0LvZyejNUoD68AAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath20211)">
            <g transform="matrix(294.199 0 0 193.2 11120.9 5698.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,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"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath20223)">
            <g transform="matrix(178.199 0 0 49.2002 11226.9 5842.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAKCAYAAAAzZJfgAAAABHNCSVQICAgIfAhkiAAAAPtJREFUOI2tlGuOwyAMhL9Be/8j7j3aALM/IMFQqlTVjmTZMmN7nAc68q9xpcHdajAwmcapQA6+YGcgYwoig4/GJ2NnRAGemIz8BA4qGblgHqjz4NFrDxIASs1QtxiDQxxzDnxN5+rRyU2TH73Swm12srjEbZonBFLIiT20iVfuu9qBtE+/a7hhahWZxq6a85/ilanPi+170d/gVcH10d9D8n9quXDzWO6H2l54Ffe/Fn8nehblyrgWxrCK+4A5v5G4iU//+RsYoiZBMQZNQkZOge/p3D06uTX42Ksu3GY/uCzbzYWVct02Y1tTbZJ2i8zCTsEKQ+NyQ9zAHx29mDzq+GrhAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath20247)">
            <g transform="matrix(192.199 0 0 44.2002 11039.9 5856.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAJCAYAAABADm7+AAAABHNCSVQICAgIfAhkiAAAAOBJREFUOI21k1FuxCAMRN84e5beoUfp/c/RTD+MF8KSbdSolhwJGDzPRtHH16cZwgHegBDehJVrh3AYIjUIHMabUIg9IjVq2q3WYpeyroRDfEvtfjsj/RAcYIDHAU68xnPP/auWUSfqWilzqOlIjZX5Fk41KL0CQjOVOuwKmt6pymTQFYjHzdbUPteY4AqsrsbafoIZfUYQjsVm7ah5To8+vbp7BncZMIv+cl6TLIPKsZHJnFg8z7QVy8OTZ/2POExv4Xt5gqfxx2bmv/Us7gNedZrial/3AW+GAAzavWz2B0kxTDK+v+fgAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath20259)">
            <g transform="matrix(178.199 0 0 149.2 11039.9 5727.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAfCAYAAABgfwTIAAAABHNCSVQICAgIfAhkiAAAA8tJREFUWIWNWFuS5CgQk7Jrb7H3jznN3qhS+5FPKNfMEOE2NhiEUimo5q///pVRMAgGwH6Ef8zxY8LLhJ+8DIL9CD+sZ+BlAim86nsCzLtBYN4BwEgABoBZBwiAiDoAkNU3PwIAGaYDrnK9sBrg7vdQ9qfG5/EL0OOYfEQ0ne1q878ABQC6BtXdrmk3LOSmu+sMkIzDry6/Y4pHXSAckoCUyrdi8SdmchIUwGviL8T9EYiu+y6/Y7ijIQL0cxByJpHiAk7Qfx2+r1FYms4QfrCoByBKpLvNlwae5isNaeWX/0FXBaxBma7O69keGKou1nXOAhAauiePd6OraZ86CZh95AUAEYuII0QuhvaugZ6KNOCEpxBq6S58TcqFinfXCJOOEDHfC3T1UjyBzuDBmHe+8QhhplQDZAIjAJegx8z0+LIASQSUZlnvWG3RvlnbhQm9Ji62NrBaqC8yDlCkmrUWOaO3XyDV73Sys3QlEK4R+C1zQktf+Zzb1CFydJdhTks0u42YMFaXCf0aT9OGZiv4IQQXGtxOns+yTDRYWBO1VQRr1daAjosgh60nYKVAKS7bIicDSIiaR9YNwAwftq5WeBH1YismO5lrVhc7gjdAm45nDFeoA6RmEk9pD3MD8GbEV3j3Qsh5x5Z5hu/WU8HkFu5iT8lCAd7irtSverU52Lahe0EoS8k++rJZt+HtsLBYGxYn63Jgj1NEva9x2haOzJyxKpx1Py1hi7tA1Kp8ji294g5x6oylKZys4NLgCvEGV6AtEOrrVrE9QAqKPTW225Xtck59sXYAW/UDHB6Y2qXO2CIPw1SOIgHy0tq8A+II1NJ90N1Rb9/fc19PxKfQJOCNJfC8VxZ6JgB8wiMA77VfbnF36A+WBuBrT7719HlymJW/FYbYI3vqydICJNAJo9rvKAA2m29vKsUur/CVad4lhF+ZyL46VG0ViU2Vddnmk8EiQm8rzGUFAvFeXme3aTaga7veGcIVJhfgHoMW0LfXsYa4M8udaSE4QopVn2ltboZnoJX+72ZtKKfqTDTmWAlAAfDanoIxCHmCGIBlsq0pLrN7Kn3sXZPDUwumNlmDACPeAF4SRMKRx5F19uqMBePIlD4H5K/pHcFjg9aVrOusRenYpIOB5ebbCsQx3uzrS58d+tiPz+zruXOzfCKO5V8KBipsqg23EgNzAERvu8XYRUAuoB5fHRvVvx++CP/D4qJ4hoRvdso7GOarCINIwAVZbLj9a/OSTPnVaOov9PQItqyBkVmw0NUcbtPhSZjHcVvvfVIleE3wP4/mT2Y0ogM2AAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath20271)">
            <g transform="matrix(178.199 0 0 49.2002 11039.9 5827.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAKCAYAAAAzZJfgAAAABHNCSVQICAgIfAhkiAAAAQ1JREFUOI3NkrtyxSAMRM/akPxm/r/NpIu1KXgYMMVNd5lhQELSrlbo5/vL9HWAPjiUsTNSxrQzIRLwCUqIDGTQCeTypow5a1xCOgknDiXgBFLFOGqMis1Z7jobi3dZ6rc3InUP7CVSGhIgtoWKudiPFYvt2e94nVQroJXEBqzE3HGSMTH4FiIP/4OUkaMydt87AdyK1McCPIN7SrzrYRMTGdfcgv3PP2VUk/Xo/lbIHaSoq+X9Vr3VGM8HqarMNmEYyTACbwDnnCA8jvCqijTfmrNVauh4GWMhfGG7k9FKyLMytjkUG2WijvFaiG1IeelelI4Oglhk73EuCpTOrwHg6kC3WuPfC+TA/E6+P/3f1umGJJFSAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath20283)">
            <path
              fill="url(#linearGradient20291)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M11061.8 5650.58l57.5 86.07c3.6-2.53 7.4-4.93 11.3-7.21-27.5-31.77-53.1-61.24-68.8-78.86"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath20301)">
            <path
              fill="url(#radialGradient20309)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M11326.9 6011.25c-4 2.54-8.2 4.93-12.5 7.17 31.9 44.04 59.8 82.58 60 82.58v-.01c-1.2-2.63-22.8-43.34-47.5-89.74"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath20319)">
            <g transform="matrix(116.199 0 0 140.2 11216.9 5885.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAdCAYAAACwuqxLAAAABHNCSVQICAgIfAhkiAAAAMBJREFUSInVldEOgzAIRaHh/3/FZM/7NtmDY1E6KLSYZdeYaEk54UIVH8+NQQl3vTKvVpfqRwBiOBxCwM8iK+yKZaEKuPXQUsCKSB7EKtHZshWlKpixKb0l2w+6IBLTIpDRhJEViPaEmw8JF6uBUbXuzUHOQL6nKzwddqoiSEkab2zz58DogwXxAUaU31cE0hgB5DYhDmgEiVtkgEaje9liVrGg//8ndwC34RWAM+hWQJVqPhXOqBKgChbP6u0WvQB6DzNqLgkZ+AAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath20331)">
            <g transform="matrix(68.1992 0 0 39.2002 11202.9 5861.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAICAYAAADJEc7MAAAABHNCSVQICAgIfAhkiAAAADhJREFUGJVjXHx3+X8GMgALphCyOYzEaMRmMUwM0wAm3JpwuQJFI+mAibBtODUSC1AtIEEjagABAJ6cCjYLdAV8AAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath20343)">
            <g transform="matrix(149.199 0 0 159.2 11111.9 5722.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAhCAYAAAAh3nDkAAAABHNCSVQICAgIfAhkiAAAAfFJREFUWIXVVstyAyEMk5n9/8/o5/XWK+oBDMbYJJsmhzqTyQxrLFl+bOT754sCQiAAAAhRYE0ggtAKkgdPWjk9PIX+K/BD8E/b/wSv4OfB5Q0gL4Mv9mYeAzyKq2f8UPIlkrVm3m66srpnQ+jPjex5egtB5xYRyCL5863mXolN+iAtvtgMpV2eEcm4B09dz5sECKKCKJUzsL2e1v1AoILjcwLVp9ceQgAKIPSnTfvsLWN8FeiRpXMuYJz9G+duA88lywm8ugVLpiJZzkFpyyJo/wn4kIj1uciWVZFWV3YHnYCKKc+ovSXQ2dPNYERC6akVoN2vnMGrEujZ1yVAoEDQB1y0kI0c0Ls96qGWMU0WZhcEZ0uQvJY7uPXXkHOzFYjUXghLQHYCCUhmS7fbK17+9tyvXqVJBAV5YMQ1Mu29M5uumZVfCRTMBrO1vDNyhODyolXsBJr33HpKyDdR1FQnK0snU4PshAYBY8/M9clGw53kX5ToCljSJSDwzNxfwLpI1PRskV/YwN2Lx78DSgLmfa/IQbP3pEiBJAQygJPpDI0LOu9Z61BBLQn93jFK2+1iijqyZtv3UUmGAj7zOwSEq+wKCKwEhj/s5jPzrSSSMmS27HZRAh08Wrk2t4jIHRuKis7UCOgA3K+Std87JgB+ASuCBqVcNhGuAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath20355)">
            <g transform="matrix(77.1992 0 0 44.2002 11183.9 5837.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAYAAAA7KqwyAAAABHNCSVQICAgIfAhkiAAAAFJJREFUKJHNkEsOgCAQQ1/n/qd1L3UxfoIgGFe+hHRCaDtBa1ksBIjk0BkGIPTacCd98dF98oMA759BozM82mAWcpVFSq/9KaS+D7kMHrhzqOYN5n0b7ZdW7D8AAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M158.897 125.152c-1.549-1.21-1.263-4.613-1.28-5.574v.922c0-.149-.011-.307-.011-.342v-.58c0 .276-.021.712-.085 1.217 0 0-.451 3.413-1.27 4.12-1.845 1.615-6.484 1.305-4.706 1.347 6.012.128 6.012 5.992 6.06 7.916v-.969c.008.07.012.128.012.163v.806c.13-4.554.116-7.434 5.358-7.819 1.736-.133-2.265.201-4.078-1.207"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24465)">
            <path
              fill="url(#linearGradient24473)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9320.44 5400.52l-.02.05 132.56 205.3-132.54-205.35m600.23 205.35h-47.05l.2 10.31h46.89l148.39 445.32c2.1.04 3.3.04 3.3.04l.1.04.1-.04-151.93-455.67m-318.59 0h-149.1l-32 96c.1.22.8 1.77 2.15 4.49l30.06-90.18h151.07l-2.18-10.31"
            ></path>
          </g>
        </g>
        <path
          fill="#2a3f2f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M125.136 117.83l.304-.434-21.935-15.222-.002-.002-.303-.211-22.57 15.66 8.891 26.66h19.857l7.504-.008 8.883-26.65-.325-.227-.303.435-.501-.168-8.52 25.553-6.731.007H89.902v.529l.502-.168-8.52-25.546L103.5 103.04l-.301-.435-.304.434.004.002h.001l21.934 15.224.303-.435-.5-.167.5.167"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24485)">
            <g transform="matrix(659.199 0 0 461.2 9416.9 5607.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,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"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24497)">
            <path
              fill="url(#linearGradient24505)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9862.28 5399.3h-541.44l-.4 1.22 132.54 205.35h467.69l132.73-205.54-.3-.82-190.82-.21m144.52 1.74l-121.65 188.1h-397.06l-121.42-188.1h640.13"
            ></path>
          </g>
        </g>
        <path
          fill="#253028"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M116.5 143.752h-.01l.004-.008.007.008m-.01 0H89.9l.369-.572.014.043h19.1l6.732-.007.01-.029.364.566"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24517)">
            <g transform="matrix(653.199 0 0 207.2 9359.9 5391.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,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"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24529)">
            <path
              fill="url(#linearGradient24537)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9320.42 5400.57l-10.16 30.44 125.02 193.62-112.97 338.95c.54.64 1.09 1.28 1.62 1.9l63.7-191.07 5.5 8.01 3.78-10.33 24.06-70.24s0 .01.01.02l32-96-132.56-205.3m-7.53 591.26l-2.49 7.45c1.35-2.11 2.57-4.02 3.65-5.71l-1.16-1.74m-24.54 42.35l-195.14 47.62-10.47 31.41.46.32 192.12-58.51c4.53-7.27 8.9-14.26 13.03-20.84"
            ></path>
          </g>
        </g>
        <path
          fill="#29392c"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M89.898 143.752l-8.64-25.92.642.195-.016.01.369 1.109-.153-.038 7.714 23.145.096-.149.358 1.074-.37.574"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24549)">
            <path
              fill="url(#linearGradient24557)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M10053.5 5400.55l-132.83 205.32 151.93 455.67 216.7 52.83 1.7-1.2-11.8-35.53-202.1-49.32-135.6-406.78 122.4-189.64-10.4-31.35"
            ></path>
          </g>
        </g>
        <path
          fill="#263128"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M116.493 143.744l-.363-.565.367-1.106.187.289 7.715-23.144-.307.075.416-1.254-.06-.042.685-.167-8.64 25.914"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24569)">
            <path
              fill="url(#linearGradient24577)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M10053.4 5400.33l-132.73 205.54 132.83-205.32-.1-.22"
            ></path>
          </g>
        </g>
        <path
          fill="#202421"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M116.49 143.752l-.364-.565.004-.008.364.564-.004.008"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24589)">
            <g transform="matrix(351.199 0 0 659.2 9935.9 5424.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,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"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24601)">
            <g transform="matrix(240.199 0 0 672.2 10055.9 5415.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAACMCAYAAAA+//q0AAAABHNCSVQICAgIfAhkiAAAA91JREFUeJztXV16ozAMnPTjNHuAPc3e/xjNPrQlwchgWaOf8qGnlqRCkxlZRiL08eff3ycuYB/ZAbDsBlLNbiDV7EJAnpdYfbEAgAjm8QgOxWZL95UWXHFgfSCtFWdtHIhkhcAtaGOxxpEkyT0j3sAAF3Dn0pJW54KszeUIGxyBtVeOmD/lNhCrPx24FyP0QIRjjpI8KIgegbD9vRzqcoSeGzx/y6Nx9tQ6KiLJHSN0YIOBqHwK/paz87bAgJqsiTniDs6BteFkP/tQsyU5vfutJknbNl55Xk9JUoEozvv6nSTJtY6oHUyalyRXRiianjTGQnIoLTPtkzbDmipHKrEGbMG9XbN//6C8oMliDdiCe2PksX91AlwWayfSasFxWAP44JR1hMMawJfkYu9o1JCk0Ndi9KHiJTkmrSKsAX1JTva16rFG7GtZwdlY6/e13nxPW6Akj6VVsqEtSzK3rwXQJGmfjxSR5Pl8BLCDC2BtsI4Ix5LbPy24+Wv2YpLkNR+SJenaRYlkzRdIa46sxQKRjLSQLPj8/umjzl0MM5Jcvt71xAro3aqAG2BtEY/+/OUvAtfJESnYDrgiwBTJ3gFXhDXjqlVHkuTlN0+SAXUkRpL7vhYQcI/VoCQVwGRGwm8es7M219cCyoEzXI9EswYcSXJ5j8cUSzJrG0boH3IguENpucThJEl1jlRlbXe/FqCbS4SwNuBUZMQ6TcqQ5JC0GDNAb0lO15FqktzutYwfU6Ykt4yQ+Y+U5Ml8hJ+1Xqwt3f2L1tOksVgTcuTgKu/I0ya6eEkO5ogSXIIkDTlilCQZmL6OdMHlsrafIQITHfJRSfotJJ1rduGYqkNOYk3y1QGm+B5i87uVNYAqSd4MEUiVJLdBl8ha7AwRcGMtfvTmtJDkzxABiiS3daTGzGaKtWavpXcQZiex6b+rWwUYsIltYq8lHCsAjjMfKQBubD4C2ME5A5t/5kMx1njzESCVNW4dsYIzsOZfR4IkGV9HnCRZo44QJMnJkQKS9MuRYEnG5Ygza19blKAl0tOX/HytzKo9qYD6ey1aHVkd5lXtU1/yfKR3VultRSQpz0d63gbAJUryeD6yCUTZ/ev5zNtrERvSh/4UJrjgfA+RzdrG55iR9lpk1iSfeXutWEnGPoPOUZL6vZZ0ngKscZ5lmsLa9sTrY6l2bytTtcdq25ojp+cttZHcx3J8c+bZeauwBmVBrMyaeWLlDo5+PaKwDEmGzBAjJJk2DFWzBhyCqzHVxWAqTD3LtIBpJFkaiGQ9Sf46IK39ALvQvyS4iN1AqtkNpJrdQKrZDaSaXQbIf6vo97x42h8/AAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24613)">
            <g transform="matrix(356.199 0 0 663.2 9085.9 5424.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,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"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24625)">
            <g transform="matrix(236.199 0 0 669.2 9080.9 5419.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAACLCAYAAADIzXEPAAAABHNCSVQICAgIfAhkiAAAA9ZJREFUeJzVnEtyrDAMRUWXd/OG2Uf2vxveIK3GNEJYX8tnlKRK+F6VihhLsP37/dmBYiP/OoYp9juYltfTfAVYYvvgZ+E9zb64JVaedYqmFlFAPHItp0cBypWchfeMmSiUdQreRHHxAADw2m5MFCyZC69jrcPEIlmn0N+dAKaLRxR3pzklwzFuokjWKZ5NGLYDIhTit/1Pz83dqV7J9Gz7Dvtrg/2t82yicMlg1nvxyHsDWL9kdia2HQbqZB3gWjIcrZJ4rmQ45P8nnggqGQ4fEwklw2EzkVgyHDoTE0qGY9xEkaxTPJsolnWKexMLiEfOJgqXzL0ANLFQ1g8Bx49NamCq+Jslh+5OFUqGgzVRqWQ4SBMVS4bjY6J6yXC0VUqGi22rlAwX6/88IRTgEZtjIriJE2cisfvkb2JC68zPxMS+n81EkYalzkQR8YjMRDHxyMCpuGVxS6zH4dkC4pEaYxGWDee2VxuLkMQeZ8hFxiIksdcD8IljEZJY/uR+wliEJHas7ZA4FiGJ1cw7XS6iXTxPeE/QWIQk1tKpwu7pwuIRh7EISayf8B7DWIRk/RjxiHAsQrp+rHhkcCxCsnaO8J6HsQjJ+vniAQD2T39iMfH7V1hTGZiYdQrh42kt8cjgBnB+yXAwj6c1s05BPJ6uIx7pNoBa8XOEn7unC4tHFCeAdcQjgybqCe95MFFbPHJjYg3xGNNOvymZIbynrSweUfUnqohHhk1UE97zaKKyeOTWxArikZOJlYT3M+4NYF3xSFMbmCJ+B2pAP7576pb1+912XH/CuWQ4/PsT5rYAn3UKn+5pYtapdW39icniEV1/YkLJ+EyeFck6RfBsR6x4xH+2I6hkOL6O9nUX+YvNyTqFw2zHPPGI8u6UXzIcwr3T/KxTDO6daopHmLtTrZLhIPZOtbN+Wu66d1pPPNK4Jyb+Sl6SBpfj907rikdyNoAKJJ3puMkzBdqZAN/JMyWWgYZjLOJzNaMaIVrxxFiEXYwEa9Yp0l6MihCPhJvwKhmOEBORWadwNZEtHjGbmCW8R22ignhEbKKSeGTszfiCwnv4N+OLi0foN+MXEY8cb8YvJhwAjqP9lcUj+WMRWjyO9qtknSJ2LMKCxwawWslw+I1FWDBONNjHIiw4jWPoxyIcFveKzftuR+AQTLyJhAmeGBPJo0e+JrLnpt74mJgkHo/C9SYmC+/Je6ncGMs1IJJmO/ShI92TwJfK9aHShpv/0X6ieMRxtkMfqn4V69M9XU04sW76V4U8xSMpXxWKEN4TOnkWLR4J+apQlnjE7atC2cL7077/TvfNW4N2cYIAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24637)">
            <g transform="matrix(616.199 0 0 472.2 9075.9 6067.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAABiCAYAAACYsttCAAAABHNCSVQICAgIfAhkiAAAAY9JREFUeJzt0ttxhDAQBdE7TsD5B+UoHIc1/gDBUEVtAt3nh30IjaC6fn6/uzuXTp3XpJKsTqqS7pf/zuu+vbuy8q77vneu77lmzn/Mfa75tGcl+Tt/f6wf568+9l37c85zrKTr/v8xY3zfnyvjfHufPu5f19hKrWRVUmuc9Xz26vk+xrx1z8x17j6eod/n7o16n3uu2e/6Gnbs8RWhGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHA/QNCF3IvDMRt5QAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24649)">
            <g transform="matrix(639.199 0 0 452.2 9056.9 6106.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIUAAABeCAYAAAANI9fQAAAABHNCSVQICAgIfAhkiAAAAUFJREFUeJzt0sFxwyAAAEFIM6kgfaX/R/AjTiw42xXsvoQEA5Jufn5/rXEx1+9wjTHm5f762aaNeX+6/teN3Xp+Pdd8Oe3pjevaMca6r/8750vHPvsZHu947retWvvjvOPb/R6Tt+/4Zt55znN83f+c1u9//MH1ZvEx/hhwEAUhCkIUhCgIURCiIERBiIIQBSEKQhSEKAhREKIgREGIghAFIQpCFIQoCFEQoiBEQYiCEAUhCkIUhCgIURCiIERBiIIQBSEKQhSEKAhREKIgREGIghAFIQpCFIQoCFEQoiBEQYiCEAUhCkIUhCgIURCiIERBiIIQBSEKQhSEKAhREKIgREGIghAFIQpCFIQoCFEQoiBEQYiCEAUhCkIUhCgIURCiIERBiIIQBSEKQhSEKAhREKIgREGIghAFIQpCFIQoiBvggS9tI/SGzwAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24661)">
            <g transform="matrix(15.1992 0 0 15.2002 9680.9 6543.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAABHNCSVQICAgIfAhkiAAAABVJREFUCJlj1A42+c8ABUwMSACFAwA9KgG3z7VO3AAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24673)">
            <g transform="matrix(15.1992 0 0 15.2002 9056.9 6111.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAABHNCSVQICAgIfAhkiAAAABVJREFUCJlj1Ew3/c8ABUwMSACFAwA/5gHKftPlMwAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24685)">
            <g transform="matrix(615.199 0 0 486.2 9680.9 6053.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAABlCAYAAACFt+v6AAAABHNCSVQICAgIfAhkiAAAAZZJREFUeJzt0sF1wyAUBdH33UD6b8pNpI7wvQAk4jgVzNyNhZAAHU89v786Syfpa5R06rqfNVd1X5/znazRXmeORv7ac/3h+fPePsPed/Tco8+13tY9368kP115VGccc/uiU6meZ6w+vqmTrvW9+9m+97i+/7i+zvW+zvFudTJqfc+Ye6Tvc197fdpvnP9NHQ/+v+/v37nvfW+OHxGaAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwL0A+jh0ODHFCmMAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24697)">
            <g transform="matrix(635.199 0 0 452.2 9680.9 6106.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIQAAABeCAYAAADi4bzuAAAABHNCSVQICAgIfAhkiAAAAUFJREFUeJzt0jFuhDAUQEE7l8kJcq/cv4jTwC7PaFdKnZkKYcM36M3P7681DnM9LscaY8zxtH7WuJrH6nl3dvm5sF3PNV9uG2/ecT61juevZ73ZZnT+5Ru3V2xP3ddfjbzN2//VeXufsO199w+3+fvWnO3xzvnnGR/3E/KfCYIQBCEIQhCEIAhBEIIgBEEIghAEIQhCEIQgCEEQgiAEQQiCEAQhCEIQhCAIQRCCIARBCIIQBCEIQhCEIAhBEIIgBEEIghAEIQhCEIQgCEEQgiAEQQiCEAQhCEIQhCAIQRCCIARBCIIQBCEIQhCEIAhBEIIgBEEIghAEIQhCEIQgCEEQgiAEQQiCEAQhCEIQhCAIQRCCIARBCIIQBCEIQhCEIAhBEIIgBEEIghAEIQhCEIQgCEEQgiAEQQiCEAQhCEIQxC8YxS9tMljX8gAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24709)">
            <g transform="matrix(15.1992 0 0 15.2002 9680.9 6543.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAABHNCSVQICAgIfAhkiAAAABVJREFUCJljVC8w/c8ABUwMSACFAwBA5wHRtcXkXAAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24721)">
            <g transform="matrix(231.199 0 0 68.2002 10064.9 6053.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAOCAYAAABpcp9aAAAABHNCSVQICAgIfAhkiAAAAGRJREFUSIntj9sJwDAMxHSdpnt2mU7p64fzaCcwBQuCjZNzkK77tA0iMYJw1jkzyBBrMM5sxz1AILCx+eSz5k7Z+92ogVBAaO9audh/vfOyOfg5LVBNC1TTAtW0QDUtUE0LVPMA0uExRzZ0EkgAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24733)">
            <g transform="matrix(35.1992 0 0 20.2002 10280.9 6106.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAECAYAAABCxiV9AAAABHNCSVQICAgIfAhkiAAAAB1JREFUCJlj1HYx+M/AwMDA8B9KMSAAEwMeQL4kAO12BKM+dmxcAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24745)">
            <g transform="matrix(15.1992 0 0 25.2002 9680.9 6533.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAFCAYAAACAcVaiAAAABHNCSVQICAgIfAhkiAAAABVJREFUCJljFJnm8Z8BCpgYkACRHAB5owH7X80hWgAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24757)">
            <g transform="matrix(581.199 0 0 457.2 9690.9 6077.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHkAAABfCAYAAADMD2hiAAAABHNCSVQICAgIfAhkiAAAAWJJREFUeJzt0TFSxDAQAMEVOf//I8UbLAIwdzZUkTPdmeW1JNest/fXPTf7x8rDMWvWXAf2rOvMnsvKfpq/b32etdbMsa9z5zn7e/b3fT5n5zZ77vn3PY+vk9a5th73Or85fjn4+93TN+favt/x9u7Y6/L/zzNr78f7mdlPs+fzOp/3+rnHXnPMzNqfzy/DvydygMgBIgeIHCBygMgBIgeIHCBygMgBIgeIHCBygMgBIgeIHCBygMgBIgeIHCBygMgBIgeIHCBygMgBIgeIHCBygMgBIgeIHCBygMgBIgeIHCBygMgBIgeIHCBygMgBIgeIHCBygMgBIgeIHCBygMgBIgeIHCBygMgBIgeIHCBygMgBIgeIHCBygMgBIgeIHCBygMgBIgeIHCBygMgBIgeIHCBygMgBIgeIHCBygMgBIgeIHCBygMgBIgeIHCBygMgBIgeIHCBygMgBIgeIHCBywAclr1hfYf9QNgAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24769)">
            <g transform="matrix(591.199 0 0 419.2 9690.9 6120.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHsAAABXCAYAAAAkqToyAAAABHNCSVQICAgIfAhkiAAAAXFJREFUeJzt0cthwyAUBdELbiTNpN5UaG4WErakFmbOSh94WJ7x8/fbZiRJ2mSd10myzmdbr+967nns62ftd82evfevx/279737fiSZ41j17kjPZ1ezTZPMHgPmntJkrGScH/BqM3qcMd/97H2+G03m6u2csZqZZqzzvj3mXj/2nDtu5/f2ft+P9Li+PL/+z3v+/j3fOT3+s8ucrMsBz/PadK/tyIwwjA1ibBBjgxgbxNggxgYxNoixQYwNYmwQY4MYG8TYIMYGMTaIsUGMDWJsEGODGBvE2CDGBjE2iLFBjA1ibBBjgxgbxNggxgYxNoixQYwNYmwQY4MYG8TYIMYGMTaIsUGMDWJsEGODGBvE2CDGBjE2iLFBjA1ibBBjgxgbxNggxgYxNoixQYwNYmwQY4MYG8TYIMYGMTaIsUGMDWJsEGODGBvE2CDGBjE2iLFBjA1ibBBjgxgbxNggxgYxNoixQYwNYmwQY4MYG8TYIP8ER3F17nUVnAAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24781)">
            <g transform="matrix(582.199 0 0 452.2 9099.9 6077.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHkAAABeCAYAAAAHU7vHAAAABHNCSVQICAgIfAhkiAAAAWlJREFUeJzt0UEWwiAMANHEvfe/o88zJC6gCm1P4MzflRLK6+Tr/exY9PY0165L0ZHXtV7f71N92pdzvOZQnmb2/R2ZHdU59/b3+3fnVt/fr3p8pyJvzzjuv87W8XJccJs57++b9fXs9dzu31ofg9tdxmzWuO9vZuyf1xnvajzUPKA7o3P+j4p4XP6E/o6RAYwMYGQAIwMYGcDIAEYGMDKAkQGMDGBkACMDGBnAyABGBjAygJEBjAxgZAAjAxgZwMgARgYwMoCRAYwMYGQAIwMYGcDIAEYGMDKAkQGMDGBkACMDGBnAyABGBjAygJEBjAxgZAAjAxgZwMgARgYwMoCRAYwMYGQAIwMYGcDIAEYGMDKAkQGMDGBkACMDGBnAyABGBjAygJEBjAxgZAAjAxgZwMgARgYwMoCRAYwMYGQAIwMYGcDIAEYGMDKAkQGMDGBkACMDGBnAyABGBjAygJEBjAxgZAAjA3wA+k1cWU1tihIAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24793)">
            <g transform="matrix(591.199 0 0 419.2 9090.9 6120.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHsAAABXCAYAAAAkqToyAAAABHNCSVQICAgIfAhkiAAAAXxJREFUeJzt0cF1wyAUBdH35TrSTspNh+JnIQRyjivIzF1ZAgFm6uvnuzN1Kkky7ufe75Jk9P7dc/yaXxlrlf1Nf1jjnM/X2Pt+e049vtiO6nWGSiedHPe+nRzzQNWdYySVZMz3R1/vk+TVne5r/DWuddZ3j3lrvXnAevuTnaN7j3Wnet/bPbe611nXPuMx8c+6NXrt3/Obte64b27OPfvxlNS5b/KaW+tu0pXjw53qnzI2iLFBjA1ibBBjgxgbxNggxgYxNoixQYwNYmwQY4MYG8TYIMYGMTaIsUGMDWJsEGODGBvE2CDGBjE2iLFBjA1ibBBjgxgbxNggxgYxNoixQYwNYmwQY4MYG8TYIMYGMTaIsUGMDWJsEGODGBvE2CDGBjE2iLFBjA1ibBBjgxgbxNggxgYxNoixQYwNYmwQY4MYG8TYIMYGMTaIsUGMDWJsEGODGBvE2CDGBjE2iLFBjA1ibBBjgxgbxNggxgYxNoixQYwNYmwQY4P8AuzGbnUjTaxzAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M81.251 117.829l8.336 1.581 13.224-9.327.394-7.47.351 7.567 13.36 9.328 8.22-1.679-8.34 2.032-13.444-9.022-13.368 9.303 3.245 10.648-3.83-10.48-8.148-2.481"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24807)">
            <g transform="matrix(83.1992 0 0 207.2 9315.9 5765.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAArCAYAAACejGMxAAAABHNCSVQICAgIfAhkiAAAAWVJREFUSImdllt6xCAIhQ9+bKcL63q63Qn0oaNBbrFzXrzkVxGUSN8/X4opvauVFBT6OBuYgQTdSsuwbXSggpyld52DBQXYKd3Ok8gN4RyLoGwf76oqwBbuQCvfZrWB0Br08bKf2cIdqI6ZpWiITg2uhdxKpABnoAIYtIPrWxLMZckgQKWHK7HKM+RFboXmnERT5O2leR3G24vs4QqcdTExnHUW0BE4raPkPvEp2Cls51Q27KVjPXj1luwdHVxOcjpouLY9XmE7owAFKBMdDw9/4Gf+ZNBxesxgq9c80aoxOhXoZU85n4KVLgU4G5yBSzbL6V/241OwE19yBtpj4C9ocKwU4PZn0ft3SwBYC9iCfpJgic2xHdiJn3zhRdd8dmCVdaK+dAOR1JclcDN3sNdK1P+Bh7mtQvdS7EELy+ry7V0mFfhVdqnWIQiOLeHmjnEY9HAh8+ik79hzkRxGh9zLwTYVwC9/MMxDTR3C/AAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24819)">
            <g transform="matrix(217.199 0 0 456.2 9315.9 5775.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAABfCAYAAAB88E5QAAAABHNCSVQICAgIfAhkiAAAAHxJREFUeJztzkENwDAMALGu/DlnHPa4KZKNwM/MzFnm/h34QroiXZGuSFekK9IV6Yp0RboiXZGuSFekK9IV6Yp0RboiXZGuSFekK9IV6Yp0RboiXZGuSFekK9IV6Yp0RboiXZGuSFekK9IV6Yp0RboiXZGuSFekK9KVlekX1poEukPUTrEAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24831)">
            <g transform="matrix(289.199 0 0 25.2002 9594.9 5597.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAFCAYAAAAZiY8XAAAABHNCSVQICAgIfAhkiAAAAHNJREFUOI3Fk0sOgCAMBacJx/E0nsezWxcKqcqnRMWuSHhvwkCQeZkUJY1ZnkaKO6a7NiM760DZeJteYAFrRzmoCQuKNAp/SUFezMuMuZB7uSdSPYe48XhHCkAuoHhpwSMn+r2Ul+mRqk1I4UH/aoRUDbwBFUs414pbvQUAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24843)">
            <g transform="matrix(293.199 0 0 442.2 9594.9 5607.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,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"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24855)">
            <g transform="matrix(289.199 0 0 15.2002 9594.9 5597.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAADCAYAAADP0GwKAAAABHNCSVQICAgIfAhkiAAAAE9JREFUKJFjdIpW+s9AAmBiRFL+D0L9Z2BEUfP/PyqfWMDIwMDwj4E8vRjgH3ZhFmyCKJ6CaoZ5CuYZWniKpJCHuotUwAL3HFJsDXVP4QMANOwcu5H3sEIAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24867)">
            <g transform="matrix(44.1992 0 0 102.2 9387.9 5693.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAVCAYAAACUhcTwAAAABHNCSVQICAgIfAhkiAAAAKNJREFUKJF9kcEVwzAIQz95TNMNu0w3NeohdgPEKRc7CshCsvfnJYCQ0csQAC5NYF0AxTznt2vU6TCDRuphFxJK47MOCQ+dF4Dj13wOSjAwnICxEV2ek+7gwmKePuIvydlUKZ6aFnVavXvmYpmXftyEJ03Zs4x7WV9cq1VNDVRlBPDoQW18LRZYY13xFOHa0XBl+liRn9tluCRuA+5VhO+yNsEXTj9SQfvQoTYAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24879)">
            <g transform="matrix(366.199 0 0 596.2 9387.9 5698.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,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"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24891)">
            <g transform="matrix(40.1992 0 0 87.2002 9387.9 5693.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAASCAYAAABmQp92AAAABHNCSVQICAgIfAhkiAAAAHVJREFUKJGFkFEagCAIg0ffTtPNukpnTtcLFhoab8LYP7Tj3IVFEQDgEvPmFVZY6mrfHWxoyh0EgNJDGFTNIUxromR97EaQCwSDIExAoMJACi6elOrOfEHKQrb0JQs5K8bHpq+aWbNbWgMCYmbEH0IfsiTffQPHuzEulXy7bgAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24903)">
            <g transform="matrix(20.1992 0 0 15.2002 10059.9 6053.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAABHNCSVQICAgIfAhkiAAAAB1JREFUCJljnLpd+T8DAwMDA4RkYIExYIDlP5oAAN5MBnRKXNK6AAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24915)">
            <g transform="matrix(289.199 0 0 221.2 9786.9 6034.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAuCAYAAAB04nriAAAABHNCSVQICAgIfAhkiAAAAV1JREFUaIHtmtltxDAMRMlgi0j/PaSMtGTmwzrIEWUnQBabDDjAwquL5rMs+mf04/PdxMlMfVMOyaVt1Vhsm4mbuNAc8eb863iC9w9Dugz2+G83YelUwOwqYHYVMLsKmF0FzK4CZlcBs6uA2VXA7CpgdhUwuwqYXQXMrgJmVwGzq4DZVcDserw6gWfL4EoD7E0x1n6Z4+VfAaOzR206dvyQh0WX0Z8D7jYpHe3pb1KHpQZjFtf3PoP2y4B3vqwUtA16/xWezWWH/VVV9DjbTwNGI9qdPOAZwP+NRrPsfO6MbB2269eBDRPfzbtz2qWxv9nnIE1O15/+5AxjBRSZCS+A1myFrvs8bxCzXfvOZq/tApL1jfVrvoa5+zO881jiWdsqqaA+VmzryL4XovDgoNhcbi087wMfNNSGx5WZFKuc2P6VtZjvkiOeUYyz7F7yVsXKFD9H4f5HnG426/sX1UWYpv/ucwoAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24927)">
            <g transform="matrix(696.199 0 0 606.2 9383.9 5741.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJEAAAB+CAYAAAAkyvN0AAAABHNCSVQICAgIfAhkiAAAAUtJREFUeJzt0kENACAQwDDAv+dDxB6EpFWwx/bMzILgvA7gfyYiMxGZichMRGYiMhORmYjMRGQmIjMRmYnITERmIjITkZmIzERkJiIzEZmJyExEZiIyE5GZiMxEZCYiMxGZichMRGYiMhORmYjMRGQmIjMRmYnITERmIjITkZmIzERkJiIzEZmJyExEZiIyE5GZiMxEZCYiMxGZichMRGYiMhORmYjMRGQmIjMRmYnITERmIjITkZmIzERkJiIzEZmJyExEZiIyE5GZiMxEZCYiMxGZichMRGYiMhORmYjMRGQmIjMRmYnITERmIjITkZmIzERkJiIzEZmJyExEZiIyE5GZiMxEZCYiMxGZichMRGYiMhORmYjMRGQmIjMRmYnITERmIjITkZmIzERkJiIzEZmJyExEZiIyE5GZiMxEZCYiMxGZichMRHYBfksE+JqeaDMAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24939)">
            <g transform="matrix(44.1992 0 0 111.2 9359.9 5775.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAXCAYAAADZTWX7AAAABHNCSVQICAgIfAhkiAAAAL1JREFUKJF1UksWAyEISywH6dF7kN6slXQx4OCnbvQB+QDy9X4Ky9ESsTVwAlg+BI4EUZBKpoUtAZ5yXZwKWACZMZ48zWowaFZzcHTXhpwTZBbMLMOTsM8lT/q1Sj/plrepn3zfHfdLjqh1WkYCAPatwZBgMekgjC540Pe4WYB+MbXR6i25yPmh/Q8Iqqyl7i4Bj+gq8RsTw0dXC2nBuhokYV+0BsjgCvQ+nyy91vIvm5625R4QNn0wAc5d9gdnNWxnOGfOAwAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24951)">
            <g transform="matrix(408.199 0 0 544.2 9335.9 5779.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,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"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24963)">
            <g transform="matrix(428.199 0 0 562.2 9320.9 5775.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFkAAAB1CAYAAAAlZU3iAAAABHNCSVQICAgIfAhkiAAAARhJREFUeJzt0EERACEQwLDj/HteVFAeJAo6XTMzH0f9twNeYHLA5IDJAZMDJgdMDpgcMDlgcsDkgMkBkwMmB0wOmBwwOWBywOSAyQGTAyYHTA6YHDA5YHLA5IDJAZMDJgdMDpgcMDlgcsDkgMkBkwMmB0wOmBwwOWBywOSAyQGTAyYHTA6YHDA5YHLA5IDJAZMDJgdMDpgcMDlgcsDkgMkBkwMmB0wOmBwwOWBywOSAyQGTAyYHTA6YHDA5YHLA5IDJAZMDJgdMDpgcMDlgcsDkgMkBkwMmB0wOmBwwOWBywOSAyQGTAyYHTA6YHDA5YHLA5IDJAZMDJgdMDpgcMDlgcsDkgMkBkwMmB0wOmBwwOWBywOSAyYENbMcE5mcbIkUAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24975)">
            <g transform="matrix(221.199 0 0 322.2 9671.9 5967.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAABDCAYAAADj0zezAAAABHNCSVQICAgIfAhkiAAAAcFJREFUaIHtmkFywyAMRaWOT9D7X6e36FmsLGKD+ZYE6WR+utDfZCAgPcM3eCH9+f02yWTDj2g6uGu350i1MfyuaxF0P/Kew4Hya5Hj36nA2SpwtgqcrQJnq8DZKnC2CpytAmerwNkqcLYKnK0CZ6vA2SpwtgqcrQJnq8DZKnC2CpytAmerwNkqcLYKnK0CZ8pEZPs0hEivBhLpFUGtIAgqg87mx8Gv0J76A+jQ91bw3e71VlkNFkI700P9GdyDFOnFYydwBueFMLRGkCcGz2vj3qcoT7L8Zh44lOv1wXrr93JaYI3MBm6cScfUKlj2h1a4jYd6wQHY5hvZ6hV93qZN5O4rL9DQt1j0mGZu/4+xWmsyb0PocyICn8NcK1xiuC8ctK+xcXjEq9ccogtWOZ7M4JSYHV3RLu6my2WuQzyBc9wgTGabxQzQHhOG0Ljz7ZCIjsMAFK3RHgjioKX0mIkvWcibLFS2qDeroDVEDntMgFe1uqEntPfNMlz53stn9uT1GDXcKmelX7UfJnTmb+HFBX/0rfdneNawIGkGGX4VrlxAnjVQM6u864vBv1Wd41B3/7aLVtrDf+VkyoZG0CIiD2XtsPXGAEF3AAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24987)">
            <g transform="matrix(63.1992 0 0 49.2002 9738.9 6240.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAKCAYAAABv7tTEAAAABHNCSVQICAgIfAhkiAAAABhJREFUKJFj/P///38GEgETqRpGNQ0dTQBNAAQQ818/lAAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath24999)">
            <g transform="matrix(73.1992 0 0 78.2002 9306.9 6024.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAQCAYAAADJViUEAAAABHNCSVQICAgIfAhkiAAAACtJREFUKJFj3H9L5D/DfwYM8J8RTeAfqgAjw38GJkxtxINRzaOaRzVTWzMAH+wGykH0rtMAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath25011)">
            <g transform="matrix(97.1992 0 0 87.2002 9296.9 6039.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAABHNCSVQICAgIfAhkiAAAACFJREFUOI1j/P///38GKgImaho2auCogaMGjho4aiACAAAU0QQg8tfB/wAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath25023)">
            <g transform="matrix(87.1992 0 0 106.2 9320.9 6015.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAWCAYAAADNX8xBAAAABHNCSVQICAgIfAhkiAAAADNJREFUOI1jPPOI/z8DFPz7z8iADP4xoPIZ//9nwAWYcMqQCEYNGjVo1KBRg0YNGjoGAQBkFQfk87XE8AAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath25035)">
            <g transform="matrix(64.1992 0 0 63.2002 9363.9 6087.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAABHNCSVQICAgIfAhkiAAAABpJREFUKJFj/P///38GEgETqRpGNY1qopImANWKBBYuFRhQAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath25047)">
            <g transform="matrix(48.1992 0 0 63.2002 9431.9 5799.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAANCAYAAACQN/8FAAAABHNCSVQICAgIfAhkiAAAAGBJREFUKJGNj9ERgDAIQ+Eu+y/haC7gBMSPiiIFa77o8ZoQ3Y+NUkhFX29UUJS73GB2yEIGyjtEBN1iAleArUBeUdqB7pCrPSBHka47+KONdTdamJUjBZYgX0zRX5EMP07c5xSfI7fFKAAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath25059)">
            <g transform="matrix(126.199 0 0 169.2 9325.9 5837.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAjCAYAAACKPxqrAAAABHNCSVQICAgIfAhkiAAAAPtJREFUSInNlkESwyAIRbXj/W/R23XZtWShppEAAtJOfxadNvCfUEzMr/cTkkJZE0So9s8SbcyJBXlVmd8f0SBOIRVRVeDWF+6GxVTjEda61UILFyStXBK3V8qAWI2t428eBu/+KtpKKIDqkTJAVoDFXAWKegRVQKColVOQCRRhjM2vKnkTwhnfQCm1tllhWsAJ+jZg6D9eE97VXwX9TzlBEaaSwl/lKX2qmEC7lVCmlLaHIfdrJXPrtBWYQV7jlqsAeQFc1u837E6LWv6s27nOA6AypLkDcE2dMg4FmkBSJdgYiwRJOdazxHlm8I4AVwF3fFu3DsSvy/ihAzS5SsPL430IAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath25071)">
            <g transform="matrix(30.1992 0 0 35.2002 9320.9 5952.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAHCAYAAAArkDztAAAABHNCSVQICAgIfAhkiAAAABZJREFUCJlj/P///38GLIAJm+CASwAAtOQECnDvJucAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath25083)">
            <path
              fill="url(#linearGradient128987)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9314.05 5993.57c-1.08 1.69-2.3 3.6-3.65 5.71l-10.7 32.13-11.35 2.77c-4.13 6.58-8.5 13.57-13.03 20.84l20.47-6.23 14.81-40.52-.63-.9 4.43-13.27-.35-.53"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath25101)">
            <g transform="matrix(34.1992 0 0 48.2002 9282.9 5991.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAKCAYAAAB4zEQNAAAABHNCSVQICAgIfAhkiAAAACpJREFUGJVjvPVq6X8GJMDIiGCzYBOES2IThAEm3FKDTJKRAcmfMAFkAADqBAOKjF1VUAAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath25113)">
            <g transform="matrix(58.1992 0 0 40.2002 9239.9 6067.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAICAYAAADN5B7xAAAABHNCSVQICAgIfAhkiAAAACBJREFUGJVjfPF52X8GNPCfAUOIASbEhCmDH4xqIAYAAJ9RBo0b5wv2AAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath25125)">
            <g transform="matrix(92.1992 0 0 106.2 9191.9 6087.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAWCAYAAAAinad/AAAABHNCSVQICAgIfAhkiAAAACxJREFUOI1j/Pp9+X8GKIAziAT/Gf6jaGIiUT9eMGrYqGGjho0aNmrYyDUMAMWsB7oQdwvMAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M89.922 121.74l-.522-1.43-.723-.22c-.193-.31-.394-.635-.596-.965l1.118.212.59.712-.202.155.463 1.353-.128.183"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath25139)">
            <g transform="matrix(20.1992 0 0 29.2002 9301.9 5986.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAGCAYAAADkOT91AAAABHNCSVQICAgIfAhkiAAAABtJREFUCJljvPRw+X8GJMDEgAbIEGBh+I8qAABe3QRmHHYZrwAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath25151)">
            <g transform="matrix(25.1992 0 0 34.2002 9301.9 5986.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAHCAYAAADAp4fuAAAABHNCSVQICAgIfAhkiAAAABVJREFUCJlj/P///38GNMCELkBXQQBEdAQKHkHjRwAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath25163)">
            <g transform="matrix(29.1992 0 0 39.2002 9306.9 6015.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAABHNCSVQICAgIfAhkiAAAABZJREFUCJljfPF5yX8GLIAJm+DglQAAuOADjo++ouAAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath25175)">
            <g transform="matrix(35.1992 0 0 59.2002 9291.9 6005.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAMCAYAAACulacQAAAABHNCSVQICAgIfAhkiAAAABdJREFUGJVj/P///38GHIAJl8SoJDGSAHKRBBSDQymjAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath25187)">
            <g transform="matrix(29.1992 0 0 39.2002 9311.9 6000.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAABHNCSVQICAgIfAhkiAAAABZJREFUCJljfPNl6X8GLIAJm+DglQAAvYcDlJg4l98AAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath25199)">
            <g transform="matrix(25.1992 0 0 39.2002 9306.9 5991.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAABHNCSVQICAgIfAhkiAAAABVJREFUCJlj/P///38GNMCELjDwggCZcAQMnTWfgAAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath25211)">
            <path
              fill="url(#linearGradient128989)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9322.31 5963.58l-9.42 28.25 1.16 1.74c.38-.6.75-1.18 1.1-1.72l8.78-26.37c-.53-.62-1.08-1.26-1.62-1.9"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath25229)">
            <g transform="matrix(140.199 0 0 183.2 9191.9 5813.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAmCAYAAAA4LpBhAAAABHNCSVQICAgIfAhkiAAAAQpJREFUWIW919ERwyAIBuAfz/236FIdoUNoX4JNGjSgIG/JGT7hDLnQ+/OqAEAE1xilyzuxhu7EeNESqm7S38Ip1FKVFCZ0FVOjsy2cQr2qkpbfUG9MWppNORaxhj7mmWzhKPoHyakqHRqIXdEN0PnhrM3igXH4DQfDwyIaAXXRaOyC7sIaOgUu7JKq9Xu6iHHoUCeML1zG4BASbiyNQSt2R51bOAr1GBxCSuyHbsTMqLWF06hHVWo0ChNRzxaKwR/x6KoYqsfvIZV6fk8DKgOAyul/+XMYJvmJDnQjRuUY+AUEgv3EFhASdF1ijCOnhxNbhDmZUFVgb2MZAErLewXodIc6iLSpp419AVkqOzhy6t77AAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath25241)">
            <g transform="matrix(25.1992 0 0 39.2002 9306.9 5957.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAABHNCSVQICAgIfAhkiAAAACxJREFUCJljvPRw+X8GNMDCgCHEwMCEKcTAwILMgWlCUckIU4nFSOxmYhUEAFyKBm3zx5h0AAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath25253)">
            <g transform="matrix(24.1992 0 0 35.2002 9311.9 5957.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAHCAYAAADAp4fuAAAABHNCSVQICAgIfAhkiAAAABVJREFUCJlj/P///38GNMCELkBXQQBEdAQKHkHjRwAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath25265)">
            <g transform="matrix(15.1992 0 0 20.2002 9320.9 5962.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAECAYAAABLLYUHAAAABHNCSVQICAgIfAhkiAAAABVJREFUCJlj/P///38GKGBiQAK4OQDGPgQE7LcZEQAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath25277)">
            <g transform="matrix(20.1992 0 0 25.2002 9435.9 6168.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAFCAYAAABirU3bAAAABHNCSVQICAgIfAhkiAAAAB9JREFUCJljfPxxyX8GBgYGBgZGBgYGBgYmBjRAhgAAIC0DguZr4d8AAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M94.217 116.424l.416-.573.115-.08-.237.449-.294.204"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath25291)">
            <g transform="matrix(35.1992 0 0 34.2002 9411.9 6135.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAABHNCSVQICAgIfAhkiAAAABZJREFUCJlj/P///38GHIAJl8SglAQAJWMECmxdIMEAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath25303)">
            <g transform="matrix(102.199 0 0 144.2 9325.9 5991.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAeCAYAAADD0FVVAAAABHNCSVQICAgIfAhkiAAAADxJREFUSIljfPNl6X8GIgAjMYqggIkEtaOGjho6auiooaOGjho6auiooUPYUBZcEqS0ndAB1V36j4GBAQBCqQTCDi2PtwAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath25315)">
            <g transform="matrix(49.1992 0 0 53.2002 9392.9 6106.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAALCAYAAABGbhwYAAAABHNCSVQICAgIfAhkiAAAABhJREFUGJVj/P///38GIgATMYpGFQ6AQgAQiwQS2ew4CgAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath25327)">
            <path
              fill="url(#linearGradient25335)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M9315.15 5991.85c-.35.54-.72 1.12-1.1 1.72l.35.53.75-2.25"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath25345)">
            <g transform="matrix(20.1992 0 0 25.2002 9306.9 5976.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAFCAYAAABirU3bAAAABHNCSVQICAgIfAhkiAAAABZJREFUCJlj/Pz96X8GJMDEgAbIEAAAO+cD2CaW4rIAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath25357)">
            <g transform="matrix(29.1992 0 0 39.2002 9306.9 5967.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAABHNCSVQICAgIfAhkiAAAABZJREFUCJlj/P///38GLIAJm+DglQAAGh8EDKa+qXYAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath25369)">
            <g transform="matrix(44.1992 0 0 59.2002 9315.9 5971.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAMCAYAAACwXJejAAAABHNCSVQICAgIfAhkiAAAACRJREFUGJVj/PXnyX8GFMDIgA6YMESwADorYsHmUNpZNxgVAQC+VwP1u27uGQAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath25381)">
            <g transform="matrix(29.1992 0 0 53.2002 9311.9 5962.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAALCAYAAABcUvyWAAAABHNCSVQICAgIfAhkiAAAABZJREFUGJVj/P///38GLIAJm+CIkAAASt4EEsgbtOUAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M91.78 120.929c-1.254-.978-1.024-3.733-1.036-4.51v.745l-.009-.274v-.47a9.944 9.944 0 01-.067.985s-.371 2.76-1.031 3.335c-1.492 1.304-5.247 1.057-3.806 1.089 4.86.101 4.86 4.852 4.904 6.406v-.786l.009.135v.651c.103-3.686.09-6.017 4.333-6.33 1.402-.106-1.833.163-3.296-.976"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -238.535 333.698)">
          <g clipPath="url(#clipPath19451)">
            <g transform="matrix(216.199 0 0 97.2002 9359.9 4786.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAUCAYAAAAZb7T/AAAABHNCSVQICAgIfAhkiAAAArZJREFUSImlllGypCAMRU9sdjD7nV3PVwt3Pkgg0OrrmqHKUhHl5HoTsD+/f4kDMNHPwAEW9zD78XF3TT5IQPO+BmrW+6I/7qs/q9633ANvQ9XgBE5/Xo0yPmTWv3r4RNY/bDvkYdy2tl5LG6xugJWCaz72nONofc4YX1Stg73iobqqfgQ8XARwAaysdj6y2nVTvyZ1A7KBAjz6BcgooaqFypgDr/CYAzWmVXLTxXkcafK2KVx3W9ga1GnrOw0K1YFwOwylEzwJHn6GHte2wKumX74DxzvuW6o/J93L0GkUqrnCXWnJsCMlpdkK+m0ipgAGbE5E/+VDQZg+bg682IKekENpOZX0YQPLVYUUxCV0Ot8lopK6ARXA4eNIxk31eKfIM9Oa4OWqOzzHTSJGKYyWqsYATfADNkBIiZf8PYAjgAx8eulrNpWWK2hSVzPDO6giSXNp21XOQVzBjtI3gVWTujuw+zi/VzgNisYkah3YqnpNdsW7XVJS3kGHr9Mkl7B7JUngGTh8nBOzxMqDscIn7/YAnPbO0pvSAzSexXUkW9ghqsjuYQfWuVYSgKK3wYteMd5J2UN9cPg6Jt39nFu2zbKUJ6XFWqdPL2vnBH8CBrzkSehwWxyaK1jY4kgy1hvw3edts8kOmy2SPV1tDaB+/toyPObqyqbaFrDRBzOQq7YkoF9uKn/4OWDz0v0ADG6PAZfgx6IQdsGDuAMO3guFF9W9fwEOOzRPvPD5TSucoFf/wICKndzYmvagcnIuCamL6wzq57FcZ9h9QYlgHpp7GjC3hq9+M4AEEO0bT0efNthUu+VJ+I26C3S8aIW5oEBPTGPZJFns/O6U0MOKyAOsflZ3gebN3OUBdgR8wM4FRTkhb6A/dnlwnXj/ADuhY5f39s2Sl75oIwh4rtHRdg/n/v+EjfYXFLhXUwDIpL4AAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const EliteTrainerBadge = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="529.532"
      height="349.658"
      version="1.1"
      viewBox="0 0 140.105 92.514"
    >
      <defs>
        <clipPath id="clipPath11437" clipPathUnits="userSpaceOnUse">
          <path d="M5485 6782.92c-14.18 22.61-42.99 68.93-72.59 118.86 25.28 4.54 48.68 14 69.02 27.27 26.21-1.78 53.03-2.71 80.34-2.71 18.87 0 37.54.44 55.92 1.29 3.68-.84 6.7-1.29 8.95-1.29 1.43 0 2.54.18 3.32.56.57.28 1.33.78 2.28 1.5 171.46 10.08 317.85 56.5 400.81 121.71 59.95-58.94 116.75-118.9 125.59-123.21.78-.38 1.9-.56 3.33-.56 29.61 0 193.45 78.32 263.59 105.77 16.66 33.92 24.74 57.14 15.63 57.14 29.37 0-119.71-240.97-159.98-305.21-77.85 33.92-160.7 57.89-246.85 70.92l-10.19 1.51c-12.58 1.78-25.17 3.37-37.57 4.63-4.82.53-9.7.94-14.57 1.31l-5.68.48c-10.14.84-20.22 1.7-30.35 2.22-13.09.69-26.29.95-39.7 1.16l-3.07.08c-2.83.13-5.66.22-8.53.22h-1.94c-17.77 0-36.15-.55-55.72-1.68l-3.16-.19c-17.74-1.05-36.29-2.66-53.36-4.65l-3.38-.4c-99.59-11.55-194.4-37.95-282.14-76.73m665.41 191.58c-1.44 0-2.55.19-3.33.57-16.9 8.23-204.07 219.8-258.41 238.92 54.34-19.12 241.51-230.69 258.41-238.92.78-.38 1.89-.57 3.33-.57m-535.35 0c-10.51 0-37.98 9.89-72.16 23.87l.01.01c34.18-13.99 61.63-23.87 72.16-23.88h-.01m272.87 239.74c-.05.02-.11.04-.17.06-1.15.69-2.54 1.04-4.19 1.04h.01c1.64 0 3.03-.35 4.18-1.04.06-.02.12-.04.17-.06m-5.21 1.07a11.718 11.718 0 00.01 0h-.01"></path>
        </clipPath>
        <linearGradient
          id="linearGradient11445"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(818.982 -818.982) rotate(78.69 8.957 -.054)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#2a2f7f" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#069be2" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#069be2" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath11459" clipPathUnits="userSpaceOnUse">
          <path d="M5561.77 6926.34c-27.31 0-54.13.93-80.34 2.71 15.02 9.8 28.37 21.68 39.56 35.18 41-17.51 77.73-32.26 96.7-36.6-18.38-.85-37.05-1.29-55.92-1.29m70.47 2.06c27.52 20.82 210.7 221.26 262.07 237.73v.7c-.37.22-.93.34-.55.34.1 0 .28-.01.55-.03.27.02.44.03.54.03.39 0-.17-.12-.54-.34v-.7c25.49-8.17 83.45-61.66 138.74-116.02-82.96-65.21-229.35-111.63-400.81-121.71"></path>
        </clipPath>
        <linearGradient
          id="linearGradient11467"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(818.982 -818.982) rotate(78.69 8.957 -.054)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#2744a1" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#0eb1de" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#0eb1de" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath11483" clipPathUnits="userSpaceOnUse">
          <path d="M6833.32 4702.62c-159.12 0-334.63 57.92-526.77 160.75-67.91 36.33-122.6 65.34-166.61 88.5 7.94-2.19 16.23-4.48 24.88-6.87 80.14-22.17 149.61-32.95 212.41-32.95 59.06 0 111.06 9.55 157 28.98 26.83-3.41 54.84-7.01 83.98-10.79 9.59-1.23 19.05-2.4 28.58-3.53 83-9.81 162.17-14.8 235.27-14.8h.02c71.09 0 138.19 4.73 200.97 14.15 95.66-11 169.95-19.51 202.74-23.26 38.91 42.95 45.56 71.23 45.72 71.94 2.17-.25 3.28-.37 3.28-.37s-22.04-99.89-243.04-211.7c-80.72-40.86-166.88-60.05-258.43-60.05"></path>
        </clipPath>
        <linearGradient
          id="linearGradient11491"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1371.4 0 0 -1371.4 5963.4 4911.28)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#2a2f7f" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#069be2" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#069be2" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath11503" clipPathUnits="userSpaceOnUse">
          <path d="M7285.79 4902.8c-32.79 3.75-107.08 12.26-202.74 23.26 74.91 11.23 143.65 29.12 205.67 53.58 21.77-2.5 36.58-4.19 42.79-4.9-.16-.71-6.81-28.99-45.72-71.94"></path>
        </clipPath>
        <linearGradient
          id="linearGradient11511"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1371.4 0 0 -1371.4 5963.4 4911.28)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#a8b9dd" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#9fe0f3" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#9fe0f3" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath11521" clipPathUnits="userSpaceOnUse">
          <path d="M7309.65 5006.53c-28.47 3.26-60.19 6.89-94.4 10.82.22.05.41.09.63.15 30.16-3.46 51.1-5.85 60.01-6.87l33.81-3.88-.05-.22"></path>
        </clipPath>
        <clipPath id="clipPath11537" clipPathUnits="userSpaceOnUse">
          <path d="M6882.08 4911.91h-.02c-73.1 0-152.27 4.99-235.27 14.8a3008.2 3008.2 0 00-28.58 3.53c-29.14 3.78-57.15 7.38-83.98 10.79 24.99 10.57 48.17 24.06 69.74 40.53 164.41-19.24 343.3-39.89 479.08-55.5-62.78-9.42-129.88-14.15-200.97-14.15"></path>
        </clipPath>
        <linearGradient
          id="linearGradient11545"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1371.4 0 0 -1371.4 5963.4 4911.28)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#232a69" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#1e5b9e" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#1e5b9e" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath11557" clipPathUnits="userSpaceOnUse">
          <path d="M7083.05 4926.06c-135.78 15.61-314.67 36.26-479.08 55.5 3.33 2.54 6.63 5.16 9.88 7.84 8.21 6.78 15.82 13.39 22.87 19.84 9.28-1.2 18.67-2.41 28.17-3.64 9.59-1.22 19.04-2.41 28.54-3.52 83.14-9.83 162.4-14.82 235.56-14.82 66.7 0 129.4 4 188.19 12.06 72.89-8.39 133.08-15.28 171.54-19.68-62.02-24.46-130.76-42.35-205.67-53.58"></path>
        </clipPath>
        <linearGradient
          id="linearGradient11565"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1371.4 0 0 -1371.4 5963.4 4911.28)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#275194" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#1f70aa" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#1f70aa" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath11579" clipPathUnits="userSpaceOnUse">
          <path d="M6931.77 5016.11c-82.64 0-170.41 6.36-263.17 18.37-1.83.24-3.67.48-5.48.71 60.33 64.27 62.27 106.36 62.25 111.84l-.1 22.18-22.05-2.38c-29.06-3.15-59.91-6.47-91.77-9.9 52.65 11.69 115.46 25.46 190.38 41.67 236.25 51.11 421.64 124.2 561.64 221.88 203.31 51.44 357.87 90.72 357.87 90.72s2.66-18.59-6.13-54.24c36.09 75.82 34.23 119.52 33.56 127.11l3.15.8s17.43-118.88-178.77-333.82c-150.68-165.12-367.61-234.94-641.38-234.94"></path>
        </clipPath>
        <linearGradient
          id="linearGradient11587"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1535.11 0 0 -1535.11 6217.22 5300.49)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#2a2f7f" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#069be2" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#069be2" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath11599" clipPathUnits="userSpaceOnUse">
          <path d="M7363.47 5420.48c42.08 29.36 80.05 60.94 114.08 94.81 145.06 36.74 251.83 63.86 271.22 68.78.67-7.59 2.53-51.29-33.56-127.11 8.79 35.65 6.13 54.24 6.13 54.24s-154.56-39.28-357.87-90.72"></path>
        </clipPath>
        <linearGradient
          id="linearGradient11607"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1535.11 0 0 -1535.11 6217.22 5300.49)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#a8b9dd" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#9fe0f3" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#9fe0f3" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath11621" clipPathUnits="userSpaceOnUse">
          <path d="M6426.73 5137.19c19.95 13.55 37.92 28.16 53.94 43.84a980.81 980.81 0 0122.93 18.13c64.94 14.67 151.42 33.81 266.27 58.66 115.09 24.9 218.58 55.25 310.72 91.23 97.7 24.62 194.86 49.17 282.88 71.43-140-97.68-325.39-170.77-561.64-221.88-74.92-16.21-137.73-29.98-190.38-41.67-59.91-6.44-123.32-13.22-184.72-19.74"></path>
        </clipPath>
        <linearGradient
          id="linearGradient11629"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1535.11 0 0 -1535.11 6217.22 5300.49)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#232a69" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#1e5b9e" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#1e5b9e" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath11641" clipPathUnits="userSpaceOnUse">
          <path d="M7080.59 5349.05c94.41 36.86 176.88 79.62 247.76 128.5 52.55 13.28 102.86 26.01 149.2 37.74-34.03-33.87-72-65.45-114.08-94.81-88.02-22.26-185.18-46.81-282.88-71.43"></path>
        </clipPath>
        <linearGradient
          id="linearGradient11649"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1535.11 0 0 -1535.11 6217.22 5300.49)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#275194" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#1f70aa" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#1f70aa" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath11663" clipPathUnits="userSpaceOnUse">
          <path d="M6549.82 5239.35c53.91 49.95 101.93 105.86 142.95 166.66 194.35 118.25 325.42 243.37 397.67 379.93 130.07 86.89 254.94 170.45 348.66 233.21 12.76-24.11 31.56-44.96 54.54-60.84l-57.44-86.06c15.72 17.62 41.32 47.09 68.75 78.86 27.8-16.32 60.72-25.76 96-25.76.51 0 1.01 0 1.52.01-5.98-28.42-14.4-60.12-26.02-95.31 13.97 34.51 25.17 66.31 34.11 95.54 1.18.05 2.37.12 3.55.2-10.42-34.13-23.93-71.79-41.33-113.16-117.01-278.38-399.9-437.85-809.06-526.37-86.27-18.67-156.62-34.13-213.9-46.91"></path>
        </clipPath>
        <linearGradient
          id="linearGradient11671"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1342.22 0 0 -1342.22 6303.8 5691.24)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#2a2f7f" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#069be2" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#069be2" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath11683" clipPathUnits="userSpaceOnUse">
          <path d="M7090.44 5785.94c13.14 24.85 24.34 50.08 33.61 75.71 108.72 72.62 213.69 142.84 299.68 200.41 3.05-15.12 8.28-29.52 15.37-42.91-93.72-62.76-218.59-146.32-348.66-233.21m486.01 44.11c11.62 35.19 20.04 66.89 26.02 95.31 2.71.02 5.41.09 8.09.23-8.94-29.23-20.14-61.03-34.11-95.54"></path>
        </clipPath>
        <linearGradient
          id="linearGradient11691"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1342.22 0 0 -1342.22 6303.8 5691.24)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#a8b9dd" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#9fe0f3" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#9fe0f3" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath11705" clipPathUnits="userSpaceOnUse">
          <path d="M6692.77 5406.01c33.01 48.91 61.47 100.98 84.81 155.63 34.27 25.83 65.83 52.07 94.65 78.71 71.28 47.49 145.58 97.08 218.21 145.59-72.25-136.56-203.32-261.68-397.67-379.93"></path>
        </clipPath>
        <linearGradient
          id="linearGradient11713"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1342.22 0 0 -1342.22 6303.8 5691.24)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#232a69" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#1e5b9e" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#1e5b9e" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath11725" clipPathUnits="userSpaceOnUse">
          <path d="M6872.23 5640.35c46.45 42.93 85.82 86.92 118.26 132.13 44.45 29.65 89.32 59.61 133.56 89.17-9.27-25.63-20.47-50.86-33.61-75.71-72.63-48.51-146.93-98.1-218.21-145.59"></path>
        </clipPath>
        <linearGradient
          id="linearGradient11733"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1342.22 0 0 -1342.22 6303.8 5691.24)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#275194" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#1f70aa" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#1f70aa" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath11747" clipPathUnits="userSpaceOnUse">
          <path d="M6798.17 5614.26c34.48 96.78 53.23 200.66 53.23 308.73 0 4.61-.14 9.13-.28 13.67l-.21 6.24c-1.15 53.72-6.81 106.66-16.94 158.52 91.46 117.03 157.76 202.05 157.76 202.05s70.94-68.21 51.85-305.76c-2.87-35.53-9.24-69.95-18.8-103.4 25.39 56.15 41.09 115.15 46.09 177.46 17.21 214.04-38.66 290.58-49.89 303.63.9 1.15 1.35 1.74 1.35 1.74s70.94-68.2 51.82-305.76c-14.05-175.1-111.58-323.97-275.98-457.12"></path>
        </clipPath>
        <linearGradient
          id="linearGradient11755"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(810.293 0 0 -810.293 6267.13 5831.16)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#2a2f7f" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#069be2" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#069be2" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath11767" clipPathUnits="userSpaceOnUse">
          <path d="M7024.78 5894.31c9.56 33.45 15.93 67.87 18.8 103.4 19.09 237.55-51.85 305.76-51.85 305.76s-66.3-85.02-157.76-202.05a891.8 891.8 0 01-5.73 27.18c101.6 129.97 181.51 232.4 192.74 246.8 11.23-13.05 67.1-89.59 49.89-303.63-5-62.31-20.7-121.31-46.09-177.46"></path>
        </clipPath>
        <linearGradient
          id="linearGradient11775"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(810.293 0 0 -810.293 6267.13 5831.16)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#a8b9dd" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#9fe0f3" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#9fe0f3" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath11789" clipPathUnits="userSpaceOnUse">
          <path d="M4932.17 4702.62c-91.55.01-177.71 19.19-258.43 60.05-221 111.81-243.03 211.7-243.03 211.7s1.12.12 3.27.37c.17-.77 6.85-29.04 45.72-71.94 32.79 3.75 107.09 12.26 202.75 23.26 62.78-9.42 129.89-14.15 201-14.15 73.08 0 152.24 4.98 235.27 14.8 9.51 1.13 18.97 2.3 28.55 3.53 29.14 3.78 57.15 7.38 83.98 10.79 45.94-19.43 97.93-28.98 157-28.98 62.79 0 132.26 10.78 212.39 32.95 8.68 2.4 16.99 4.69 24.95 6.88-44.01-23.15-98.73-52.18-166.64-88.51-192.14-102.83-367.65-160.76-526.78-160.75"></path>
        </clipPath>
        <linearGradient
          id="linearGradient11797"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1371.39 0 0 -1371.39 4430.71 4911.28)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#2a2f7f" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#069be2" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#069be2" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath11809" clipPathUnits="userSpaceOnUse">
          <path d="M4479.7 4902.8c-38.87 42.9-45.55 71.17-45.72 71.94 6.19.71 21.01 2.4 42.8 4.9 62.01-24.46 130.76-42.35 205.67-53.58-95.66-11-169.96-19.51-202.75-23.26"></path>
        </clipPath>
        <linearGradient
          id="linearGradient11817"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1371.39 0 0 -1371.39 4430.71 4911.28)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#a8b9dd" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#9fe0f3" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#9fe0f3" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath11827" clipPathUnits="userSpaceOnUse">
          <path d="M4455.84 5006.53l-.05.22 33.83 3.88c8.9 1.02 29.83 3.41 60 6.86.2-.04.41-.09.62-.14-34.21-3.93-65.93-7.56-94.4-10.82"></path>
        </clipPath>
        <radialGradient
          id="radialGradient11837"
          cx="0"
          cy="0"
          r="1"
          fx="0"
          fy="0"
          gradientTransform="matrix(1926.14 0 0 -1672.88 5868.85 5863.95)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#252948" stopOpacity="1"></stop>
          <stop offset="0.491" stopColor="#1b335b" stopOpacity="1"></stop>
          <stop offset="0.945" stopColor="#22232f" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#22232f" stopOpacity="1"></stop>
        </radialGradient>
        <clipPath id="clipPath11851" clipPathUnits="userSpaceOnUse">
          <path d="M4883.45 4911.91c-71.11 0-138.22 4.73-201 14.15 135.78 15.61 314.65 36.26 479.06 55.49 21.57-16.46 44.76-29.95 69.74-40.52-26.83-3.41-54.84-7.01-83.98-10.79-9.58-1.23-19.04-2.4-28.55-3.53-83.03-9.82-162.19-14.8-235.27-14.8"></path>
        </clipPath>
        <linearGradient
          id="linearGradient11859"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1371.39 0 0 -1371.39 4430.71 4911.28)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#232a69" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#1e5b9e" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#1e5b9e" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath11871" clipPathUnits="userSpaceOnUse">
          <path d="M4682.45 4926.06c-74.91 11.23-143.66 29.12-205.67 53.58 38.47 4.4 98.65 11.29 171.53 19.67 58.8-8.05 121.48-12.05 188.18-12.05 73.19 0 152.44 4.99 235.57 14.82 9.49 1.11 18.97 2.3 28.6 3.54 9.47 1.22 18.84 2.43 28.08 3.62 7.06-6.44 14.67-13.06 22.89-19.84 3.26-2.69 6.55-5.3 9.88-7.85-164.41-19.23-343.28-39.88-479.06-55.49"></path>
        </clipPath>
        <linearGradient
          id="linearGradient11879"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1371.39 0 0 -1371.39 4430.71 4911.28)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#275194" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#1f70aa" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#1f70aa" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath11893" clipPathUnits="userSpaceOnUse">
          <path d="M4833.72 5016.11c-273.77.01-490.7 69.82-641.38 234.94-52.5 57.51-89.7 108.15-116.03 151.47 35.12 17.78 63.2 46.09 79.33 80.38 63.34-16.07 149.28-37.85 246.37-62.41 140.01-97.69 325.39-170.78 561.65-221.89 74.92-16.21 137.75-29.98 190.41-41.67-31.86 3.42-62.75 6.75-91.81 9.9l-22.06 2.38-.09-22.18c-.03-5.48 1.91-47.57 62.25-111.84-1.82-.23-3.64-.47-5.47-.71-92.76-12.01-180.53-18.37-263.17-18.37"></path>
        </clipPath>
        <linearGradient
          id="linearGradient11901"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1535.08 0 0 -1535.08 4013.19 5300.49)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#2a2f7f" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#069be2" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#069be2" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath11913" clipPathUnits="userSpaceOnUse">
          <path d="M4402.01 5420.49c-97.09 24.56-183.03 46.34-246.37 62.41 8.99 19.11 14.27 40.09 14.98 62.12 34.92-8.85 74.44-18.87 117.31-29.72 34.03-33.87 72.01-65.46 114.08-94.81"></path>
        </clipPath>
        <linearGradient
          id="linearGradient11921"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1535.08 0 0 -1535.08 4013.19 5300.49)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#a8b9dd" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#9fe0f3" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#9fe0f3" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath11935" clipPathUnits="userSpaceOnUse">
          <path d="M5338.74 5137.19c-61.39 6.52-124.77 13.3-184.67 19.74-52.66 11.69-115.49 25.46-190.41 41.67-236.26 51.11-421.64 124.2-561.65 221.89 88.03-22.27 185.2-46.82 282.9-71.44 92.14-35.98 195.63-66.33 310.72-91.23 114.85-24.85 201.33-43.99 266.28-58.66 7.5-6.12 15.1-12.13 22.79-18.03 16.05-15.71 34.06-30.36 54.04-43.94"></path>
        </clipPath>
        <linearGradient
          id="linearGradient11943"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1535.08 0 0 -1535.08 4013.19 5300.49)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#232a69" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#1e5b9e" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#1e5b9e" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath11955" clipPathUnits="userSpaceOnUse">
          <path d="M4684.91 5349.05c-97.7 24.62-194.87 49.17-282.9 71.44-42.07 29.35-80.05 60.94-114.08 94.81 46.37-11.74 96.62-24.46 149.21-37.75 70.88-48.88 153.35-91.64 247.77-128.5"></path>
        </clipPath>
        <linearGradient
          id="linearGradient11963"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1535.08 0 0 -1535.08 4013.19 5300.49)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#275194" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#1f70aa" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#1f70aa" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath11977" clipPathUnits="userSpaceOnUse">
          <path d="M5215.68 5239.35c-57.29 12.78-127.64 28.24-213.91 46.91-409.16 88.52-692.03 247.99-809.07 526.37-117.03 278.4-58.67 388.59-58.67 388.59l2.38-1.59c-6.84-15.62-46.49-124.66 52.62-369.58-69.8 211.56-24.39 297.48-24.39 297.48s244.48-163.94 510.43-341.59c72.24-136.56 203.32-261.68 397.65-379.93 41.02-60.8 89.04-116.71 142.96-166.66"></path>
        </clipPath>
        <linearGradient
          id="linearGradient11985"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1342.23 0 0 -1342.23 4119.48 5691.24)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#2a2f7f" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#069be2" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#069be2" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath11997" clipPathUnits="userSpaceOnUse">
          <path d="M4675.07 5785.94c-265.95 177.65-510.43 341.59-510.43 341.59s-45.41-85.92 24.39-297.48c-99.11 244.92-59.46 353.96-52.62 369.58 25.63-17.19 255.52-171.3 505.04-337.99 9.28-25.63 20.47-50.85 33.62-75.7"></path>
        </clipPath>
        <linearGradient
          id="linearGradient12005"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1342.23 0 0 -1342.23 4119.48 5691.24)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#a8b9dd" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#9fe0f3" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#9fe0f3" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath12019" clipPathUnits="userSpaceOnUse">
          <path d="M5072.72 5406.01c-194.33 118.25-325.41 243.37-397.65 379.93 72.62-48.51 146.89-98.07 218.17-145.57 28.83-26.65 60.38-52.88 94.67-78.73 23.34-54.65 51.8-106.72 84.81-155.63"></path>
        </clipPath>
        <linearGradient
          id="linearGradient12027"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1342.23 0 0 -1342.23 4119.48 5691.24)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#232a69" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#1e5b9e" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#1e5b9e" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath12039" clipPathUnits="userSpaceOnUse">
          <path d="M4893.24 5640.37c-71.28 47.5-145.55 97.06-218.17 145.57-13.15 24.85-24.34 50.07-33.62 75.7 44.25-29.56 89.1-59.5 133.55-89.15 32.42-45.2 71.8-89.2 118.24-132.12"></path>
        </clipPath>
        <linearGradient
          id="linearGradient12047"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1342.23 0 0 -1342.23 4119.48 5691.24)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#275194" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#1f70aa" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#1f70aa" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath12061" clipPathUnits="userSpaceOnUse">
          <path d="M4967.31 5614.28c-164.38 133.14-261.92 282.02-275.97 457.1-19.1 237.56 51.81 305.76 51.81 305.76l1.36-1.74c-11.23-13.05-67.1-89.59-49.87-303.63 4.98-62.31 20.68-121.31 46.09-177.46-9.59 33.45-15.95 67.87-18.81 103.4-19.1 237.55 51.84 305.76 51.84 305.76s66.46-85.22 158.08-202.47a910.903 910.903 0 01-17.25-158.18l39.32-.81-39.35.18-.16-6.74c-.19-4.17-.31-8.26-.31-12.46 0-108.07 18.73-211.93 53.22-308.71"></path>
        </clipPath>
        <linearGradient
          id="linearGradient12069"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(810.288 0 0 -810.288 4688.07 5831.16)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#2a2f7f" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#069be2" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#069be2" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath12081" clipPathUnits="userSpaceOnUse">
          <path d="M4740.73 5894.31c-25.41 56.15-41.11 115.15-46.09 177.46-17.23 214.04 38.64 290.58 49.87 303.63 11.24-14.41 91.35-117.11 193.14-247.31-2.07-8.98-4.01-18.03-5.81-27.09-91.62 117.25-158.08 202.47-158.08 202.47s-70.94-68.21-51.84-305.76c2.86-35.53 9.22-69.95 18.81-103.4"></path>
        </clipPath>
        <linearGradient
          id="linearGradient12089"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(810.288 0 0 -810.288 4688.07 5831.16)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#a8b9dd" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#9fe0f3" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#9fe0f3" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath12099" clipPathUnits="userSpaceOnUse">
          <path d="M6480.67 5181.03c31.76 31.09 55.87 66.38 72.53 106.03 11.25 26.75 19.08 50.34 24.39 71.01 132.25 152.63 211.91 349.72 211.91 564.92 0 24.61-1.04 48.98-3.08 73.07-14.51 170.99-79.43 328.06-180.31 457.15.39.24.76.46 1.15.7-164.81 210.44-425.14 346.39-718.21 346.39H5887.08c-498.34 0-902.38-392.78-902.38-877.31 0-208.55 74.82-400.08 199.79-550.64 5.17-23.87 13.86-52.17 27.78-85.29 16.65-39.61 40.72-74.87 72.43-105.93-7.69 5.9-15.29 11.91-22.79 18.03a961.366 961.366 0 00-36.45 31.25 828.5 828.5 0 00-9.78 8.94c-53.92 49.95-101.94 105.86-142.96 166.66-33.01 48.91-61.47 100.98-84.81 155.63a914.187 914.187 0 00-20.6 52.64c-34.49 96.78-53.22 200.64-53.22 308.71 0 4.2.12 8.29.31 12.46l.16 6.74 39.35-.18-39.32.81a910.903 910.903 0 0023.88 188.79c.37 1.57.74 3.16 1.12 4.72a877.64 877.64 0 007.06 27.48c.27.99.54 2 .82 2.98a919.92 919.92 0 0039.15 112.46c26.23 62.11 59.1 121.04 97.77 175.91a957.824 957.824 0 0081.66 100.63 958.73 958.73 0 0020.71 21.6 971.691 971.691 0 00132.96 112.23 972.554 972.554 0 00132.62 78.13c10.78 5.26 21.65 10.3 32.66 15.17 87.74 38.78 182.55 65.18 282.14 76.73l3.38.4c17.07 1.99 35.62 3.6 53.36 4.65l3.16.19c19.57 1.13 37.95 1.68 55.72 1.68h1.94c2.87 0 5.7-.09 8.53-.22l3.07-.08c13.41-.21 26.61-.47 39.7-1.16 10.13-.52 20.21-1.38 30.35-2.22l5.68-.48c4.87-.37 9.75-.78 14.57-1.31 12.4-1.26 24.99-2.85 37.57-4.63l10.19-1.51c86.15-13.03 169-37 246.85-70.92 11.02-4.8 21.93-9.8 32.75-15a968.267 968.267 0 0094.33-51.98 960.765 960.765 0 00148.15-114.28c35.36-33.23 68.35-69.29 98.67-107.99l10.08-14.62 1.01-1.46 31.31-45.38c23.97-36.15 45.31-73.75 63.85-112.53 4.73-9.88 9.27-19.84 13.63-29.88a914.903 914.903 0 0044.35-126.49c2.47-9.16 4.8-18.34 6.98-27.57.38-1.57.75-3.16 1.11-4.73l.81-3.53a891.8 891.8 0 005.73-27.18c10.13-51.86 15.79-104.8 16.94-158.52l.21-6.24c.14-4.54.28-9.06.28-13.67 0-108.07-18.75-211.95-53.23-308.73a857.03 857.03 0 00-4.15-11.4 925.62 925.62 0 00-16.44-41.22c-23.34-54.65-51.8-106.72-84.81-155.63-41.02-60.8-89.04-116.71-142.95-166.66-3.25-3.01-6.49-5.97-9.78-8.94a978.31 978.31 0 00-36.44-31.25 980.81 980.81 0 00-22.93-18.13"></path>
        </clipPath>
        <linearGradient
          id="linearGradient12107"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(1254.052 -1254.052) rotate(76.211 5.516 .426)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#e64120" stopOpacity="1"></stop>
          <stop offset="0.952" stopColor="#e61d25" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e61d25" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath12117" clipPathUnits="userSpaceOnUse">
          <path d="M5886.88 6743.04c-465.41 0-844.19-367.85-844.19-820.05 0-452.24 378.73-820.17 844.39-820.17 463.91 0 842.75 366.48 844.45 817.09l.06 2.6c0 180.94-59.26 352.22-171.35 495.63l-29.18 37.39c-151.01 171.74-367.2 275.46-600.22 286.47l-2.3.11c-6.18.28-12.33.51-18.44.65-2.58.07-5.04.1-7.45.1l-8.11.13c-1.78.05-3.59.05-5.49.05h-2.17"></path>
        </clipPath>
        <linearGradient
          id="linearGradient12123"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1688.91 0 0 -1688.91 5042.69 5922.92)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#fcd405" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e61d25" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath12133" clipPathUnits="userSpaceOnUse">
          <path d="M5464.92 5318.82c-84.01 56.1-174.01 116.33-249.39 166.88l-18.44 12.36-10.38-19.61c-1.76-3.31-10.65-22.21-8.55-61-106.89 131.94-175.69 294.42-190.27 471.79 55.89-48.51 116.85-92.49 182.14-131.29 40.73-170.16 143.85-316.99 284.67-416.48 3.02-7.63 6.43-15.17 10.22-22.65m835.63 0c2.39 4.71 4.62 9.45 6.71 14.22 149.32 101.08 258.3 254.57 298.76 433.1 65.04 39.74 125.66 84.67 181.09 134.12-12.95-186.92-86.09-357.81-200.72-494.48 4.78 46.71-5.7 69.04-7.62 72.67l-10.39 19.61-18.44-12.36c-75.39-50.55-165.38-110.78-249.39-166.88"></path>
        </clipPath>
        <linearGradient
          id="linearGradient12139"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-1651.53 1651.53) rotate(-90 .3 3.865)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f6e604" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e64120" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath12149" clipPathUnits="userSpaceOnUse">
          <path d="M5170.03 5757.95c-65.29 38.8-126.25 82.78-182.14 131.29-.73 8.84-1.32 17.77-1.78 26.68 9.81 196.46 86.04 375.97 207.33 517.73 38.89-22.13 79.23-42.43 120.88-60.79-102.26-122.93-163.53-279.47-163.53-449.87 0-9.33.19-18.62.55-27.87 1.71-47.01 8.09-92.89 18.69-137.17m1435.99 8.19c11.29 49.84 17.25 101.64 17.25 154.78v2.07c0 171.56-62.1 329.06-165.62 452.37 41.54 18.54 81.76 39.02 120.52 61.32 122.71-142.12 199.93-322.67 209.9-520.37-.27-5.36-.6-10.71-.96-16.05-55.43-49.45-116.05-94.38-181.09-134.12M4984.7 5922.99c0 484.53 404.04 877.31 902.38 877.31-496.68 0-899.66-390.23-902.31-872.56-.04-1.58-.07-3.16-.07-4.75"></path>
        </clipPath>
        <linearGradient
          id="linearGradient12155"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-1651.53 1651.53) rotate(-90 .3 3.865)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f3ee04" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#f58113" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath12165" clipPathUnits="userSpaceOnUse">
          <path d="M5314.32 6372.86c-41.65 18.36-81.99 38.66-120.88 60.79 165.45 193.36 414.74 316.45 693.7 316.45 277.47 0 525.59-121.81 691.03-313.42-38.76-22.3-78.98-42.78-120.52-61.32-134.81 160.58-339.88 263.18-569.61 263.47h-1.06c-231.32 0-437.7-103.73-572.66-265.97"></path>
        </clipPath>
        <linearGradient
          id="linearGradient12171"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-1651.53 1651.53) rotate(-90 .3 3.865)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#efee0b" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#f6c009" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath12181" clipPathUnits="userSpaceOnUse">
          <path d="M6606.11 6453.21c-164.66 210.7-425.04 346.83-718.12 347.09h1.06c293.07 0 553.4-135.95 718.21-346.39-.39-.24-.76-.46-1.15-.7"></path>
        </clipPath>
        <linearGradient
          id="linearGradient12189"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(1254.052 -1254.052) rotate(76.211 5.516 .426)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f58113" stopOpacity="1"></stop>
          <stop offset="0.952" stopColor="#ee2622" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#ee2622" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath12217" clipPathUnits="userSpaceOnUse">
          <path d="M4986.11 5915.92c-.43 8.51-.74 17.02-.92 25.59-.05-4.61-.3-9.18-.42-13.77 2.65 482.33 405.63 872.56 902.37 872.56h.83c-294.89-.34-556.64-138.22-721.03-351.17 8.76-5.25 17.59-10.42 26.5-15.48-121.29-141.76-197.52-321.27-207.33-517.73"></path>
        </clipPath>
        <clipPath id="clipPath12233" clipPathUnits="userSpaceOnUse">
          <path d="M6786.42 5996.06c-14.51 170.99-79.43 328.06-180.32 457.15h.01c100.88-129.09 165.8-286.16 180.31-457.15"></path>
        </clipPath>
        <clipPath id="clipPath12251" clipPathUnits="userSpaceOnUse">
          <path d="M6788.07 5916.31c-9.97 197.7-87.19 378.25-209.9 520.37a1289 1289 0 0127.93 16.53c100.89-129.09 165.81-286.16 180.32-457.15 2.04-24.09 3.08-48.46 3.08-73.07 0 6.19-.37 12.33-.53 18.52-.18-8.43-.48-16.83-.9-25.2"></path>
        </clipPath>
        <clipPath id="clipPath12267" clipPathUnits="userSpaceOnUse">
          <path d="M6606.1 6453.21c-164.64 210.68-425.05 346.81-718.13 347.09h.02c293.08-.26 553.46-136.39 718.12-347.09h-.01"></path>
        </clipPath>
        <linearGradient
          id="linearGradient12275"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(1254.052 -1254.052) rotate(76.211 5.516 .426)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f6c009" stopOpacity="1"></stop>
          <stop offset="0.952" stopColor="#f14c1c" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#f14c1c" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath12285" clipPathUnits="userSpaceOnUse">
          <path d="M5193.44 6433.65c-8.91 5.06-17.74 10.23-26.5 15.48 164.39 212.95 426.14 350.83 721.03 351.17 293.08-.28 553.49-136.41 718.13-347.09a1289 1289 0 00-27.93-16.53c-165.44 191.61-413.56 313.42-691.03 313.42-278.96 0-528.25-123.09-693.7-316.45"></path>
        </clipPath>
        <linearGradient
          id="linearGradient12291"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-1651.53 1651.53) rotate(-90 .3 3.865)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#eced0f" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#f4de06" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath12303" clipPathUnits="userSpaceOnUse">
          <path d="M5994.94 5253.83a190.308 190.308 0 01-23.16 14.58c26.02 3.7 51.54 9.02 76.41 15.84-6.79-8.64-13.32-16.94-19.53-24.83a745.12 745.12 0 00-33.72-5.59m-222.94 1.06a752.927 752.927 0 00-36.77 6.56c-5.87 7.45-12 15.25-18.38 23.36a617.084 617.084 0 0177.17-16.23c-7.66-4.06-15.02-8.64-22.02-13.69m551.95 130.98c1.95 9.79 3.33 19.7 4.14 29.73 1.03 12.82 1.5 24.66 1.51 35.58 108.23 111.75 174.82 264.02 174.83 431.88-.01 101.44-24.33 197.18-67.47 281.74a741.332 741.332 0 00101.4-48.39c26.64-74.02 41.12-153.6 41.12-236.46 0-101.8-21.85-198.63-61.22-286.29-50.14-81.1-116.34-151.76-194.31-207.79m-883.78 7.38c-1.33.99-2.65 1.98-3.98 2.98a704.453 704.453 0 00-6.49 63.11c2.05-2.2 4.1-4.36 6.18-6.53-.03-11.36.43-23.75 1.51-37.21.61-7.52 1.53-14.97 2.78-22.35m1183.1 528.56v0m-735.52 717.02H5887.03 5887.75"></path>
        </clipPath>
        <linearGradient
          id="linearGradient12309"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-1357.38 1357.38) rotate(-90 .196 4.533)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#e61d25" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#fcd405" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath12319" clipPathUnits="userSpaceOnUse">
          <path d="M6518.26 5593.66c39.37 87.66 61.22 184.49 61.22 286.29 0 82.86-14.48 162.44-41.12 236.46a740.396 740.396 0 0068.9-44.8c-70.29 323.68-365.46 566.75-719.22 567.22 406.15-.51 735.23-320.88 735.23-715.84v-1.18-.1c-.02 6.67-.26 13.22-.47 19.8-3.71-127-41.39-245.7-104.54-347.85m-630.51 1045.17h-.71H5887.75"></path>
        </clipPath>
        <linearGradient
          id="linearGradient12325"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1280.96 0 0 -1280.96 5342.31 6018.63)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#fcd405" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e61d25" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath12335" clipPathUnits="userSpaceOnUse">
          <path d="M5151.34 5895.12c-.36 9.25-.55 18.54-.55 27.87 0 170.4 61.27 326.94 163.53 449.87.02-.01.05-.02.06-.03-102.27-122.93-163.51-279.44-163.51-449.84v-1.34-.73c0-8.64.16-17.23.47-25.8"></path>
        </clipPath>
        <linearGradient
          id="linearGradient12341"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-1651.53 1651.53) rotate(-90 .3 3.865)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f6ad0c" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#ec4a1d" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath12351" clipPathUnits="userSpaceOnUse">
          <path d="M5314.38 6372.83c-.01.01-.04.02-.06.03 134.96 162.24 341.34 265.97 572.66 265.97h.05-2.84c-.28-.01-.54-.01-.81-.01h-1.23c-.16-.01-.32-.01-.47-.01h-.76c-.17 0-.32-.01-.5-.01h-.73c-.17-.01-.33-.01-.5-.01-.24 0-.49 0-.73-.01h-.51c-.25-.01-.49-.01-.74-.01-.15 0-.31-.01-.46-.01-.27 0-.51 0-.78-.01-.15 0-.32 0-.46-.01-.25 0-.53 0-.78-.01h-.44c-.27-.01-.55-.01-.82-.02-.14 0-.27 0-.41-.01-.27 0-.59-.01-.86-.01-.12 0-.24-.01-.36-.01-.32-.01-.62-.01-.94-.02h-.28l-1.12-.03h-.09c-2.1-.05-4.17-.1-6.26-.17h-.04c-.42-.01-.8-.03-1.22-.04h-.04c-.39-.01-.79-.03-1.18-.04h-.12c-.37-.02-.76-.03-1.13-.04-.04-.01-.08-.01-.12-.01-.37-.01-.75-.03-1.12-.04-.05 0-.08 0-.13-.01-.4-.01-.78-.02-1.17-.04h-.02c-.4-.02-.83-.03-1.22-.05h-.04c-218.52-8.94-412.41-110.52-541.22-265.36m573.66 266h-.29.29"></path>
        </clipPath>
        <linearGradient
          id="linearGradient12357"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-1651.53 1651.53) rotate(-90 .3 3.865)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f5b30c" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#f28813" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath12367" clipPathUnits="userSpaceOnUse">
          <path d="M5436.19 5396.23c-168.24 127.06-278.28 323.57-284.7 545.28-.26-6.6-.6-13.17-.62-19.86v1.34c0 170.4 61.24 326.91 163.51 449.84 128.81 154.84 322.7 256.42 541.22 265.36-203.24-8.31-385.21-96.78-513.28-233.78 131.4 118.72 307.38 191.34 500.97 191.34 147.63 0 285.13-42.27 400.37-115.01-9.87-13.54-26.2-36.05-45.28-62.43-3.01 1.77-6 3.5-9.04 5.22-90.21 52.12-194.92 81.95-306.58 81.95-151.63 0-290.43-54.99-397.53-146.1-136.06-113.9-222.6-285-222.6-476.32 0-163.8 63.44-312.78 167.07-423.72 1.22-21.3 3.41-42.35 6.49-63.11m1102.17 720.18a741.332 741.332 0 01-101.4 48.39c-51.76 101.46-130.6 186.81-226.98 246.5 15.2 28.65 28.16 53.14 35.96 67.99 134.5-85.6 238.44-212.83 292.42-362.88m-682.72 521.78c.39.02.82.03 1.22.05-.41-.02-.82-.03-1.22-.05m1.24.05c.39.02.77.03 1.17.04-.39-.01-.78-.02-1.17-.04m1.3.05c.37.01.75.03 1.12.04-.37-.01-.75-.03-1.12-.04m1.24.05c.37.01.76.02 1.13.04-.38-.02-.75-.03-1.13-.04m1.25.04c.39.01.79.03 1.18.04-.39-.01-.79-.03-1.18-.04m1.22.04c.42.01.8.03 1.22.04-.41-.01-.81-.03-1.22-.04M5869.5 6638.63l1.12.03-1.12-.03m1.4.03c.32.01.62.01.94.02-.31 0-.62-.01-.94-.02m1.3.03c.27 0 .59.01.86.01-.28 0-.58-.01-.86-.01m1.27.02c.27.01.55.01.82.02-.28-.01-.54-.01-.82-.02m1.26.02c.25.01.53.01.78.01-.27 0-.52 0-.78-.01m1.24.02c.27.01.51.01.78.01-.27 0-.52 0-.78-.01m1.24.02c.25 0 .49 0 .74.01-.25-.01-.49-.01-.74-.01m1.25.01c.24.01.49.01.73.01-.23 0-.5 0-.73-.01m1.23.02h.73-.73m1.23.01h.76-.76m1.23.01h.76-.76m1.23 0c.27 0 .53 0 .81.01-.28-.01-.53-.01-.81-.01m1.23.01h.89-.89m1.24 0h1.19-1.19"></path>
        </clipPath>
        <linearGradient
          id="linearGradient12373"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-1357.38 1357.38) rotate(-90 .196 4.533)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#d71f26" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#f7980f" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath12383" clipPathUnits="userSpaceOnUse">
          <path d="M6607.26 6071.61a740.396 740.396 0 01-68.9 44.8c-53.98 150.05-157.92 277.28-292.42 362.88 4.54 8.64 7.34 14.02 7.81 15.06v.02c-.1 0-3.78-4.99-10.09-13.63-115.24 72.74-252.74 115.01-400.37 115.01-193.59 0-369.57-72.62-500.97-191.34 128.07 137 310.04 225.47 513.28 233.78h.04c.4.02.81.03 1.22.05h.02c.39.02.78.03 1.17.04.05.01.08.01.13.01.37.01.75.03 1.12.04.04 0 .08 0 .12.01.38.01.75.02 1.13.04h.12c.39.01.79.03 1.18.04h.04c.41.01.81.03 1.22.04h.04c2.09.07 4.16.12 6.26.17h.09l1.12.03h.28c.32.01.63.02.94.02.12 0 .24.01.36.01.28 0 .58.01.86.01.14.01.27.01.41.01.28.01.54.01.82.02h.44c.26.01.51.01.78.01.14.01.31.01.46.01.26.01.51.01.78.01.15 0 .31.01.46.01.25 0 .49 0 .74.01h.51c.23.01.5.01.73.01.17 0 .33 0 .5.01h.73c.18 0 .33.01.5.01h.76c.15 0 .31 0 .47.01h1.23c.28 0 .53 0 .81.01h3.85c353.76-.47 648.93-243.54 719.22-567.22"></path>
        </clipPath>
        <linearGradient
          id="linearGradient12389"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1280.96 0 0 -1280.96 5342.31 6018.63)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f7980f" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#d71f26" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath12399" clipPathUnits="userSpaceOnUse">
          <path d="M6012.64 5239.1a193.52 193.52 0 01-17.7 14.73 745.12 745.12 0 0133.72 5.59c-5.61-7.12-10.97-13.91-16.02-20.32m-259.8.01c-5.53 7.01-11.42 14.48-17.61 22.34 12.14-2.48 24.42-4.67 36.77-6.56a190.717 190.717 0 01-19.16-15.78m554.42 93.93c7.53 17.22 13.08 34.81 16.69 52.83 77.97 56.03 144.17 126.69 194.31 207.79 63.15 102.15 100.83 220.85 104.54 347.85.21-6.58.45-13.13.47-19.8v-.79c0-53.14-5.96-104.94-17.25-154.78-40.46-178.53-149.44-332.02-298.76-433.1m-852.56 8.43c-140.82 99.49-243.94 246.32-284.67 416.48-10.6 44.28-16.98 90.16-18.69 137.17-.31 8.57-.47 17.16-.47 25.8v.73c.02 6.69.36 13.26.62 19.86 6.42-221.71 116.46-418.22 284.7-545.28 1.33-1 2.65-1.99 3.98-2.98 2.99-17.65 7.82-34.9 14.53-51.78"></path>
        </clipPath>
        <linearGradient
          id="linearGradient12405"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1472.4 0 0 -1472.4 5150.87 5573.3)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f6e604" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e64120" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath12443" clipPathUnits="userSpaceOnUse">
          <path d="M5378.04 6898.73c-2.05 0-4.08.04-6.1.1-18.17 30.8-32.76 56.71-44.39 78.52 8.81 10.26 17.34 20.2 25.31 29.5 16.9-31.99 38.42-69.44 59.55-105.07-11.13-2-22.62-3.05-34.37-3.05m164.87 99.65c-44.16 18.05-99.53 42.94-144.09 62.17l5.23 6.13s4.99 9.35 12.95 24.29c12.82-5.54 26.97-11.74 42.51-18.55 27.05-11.85 63.61-27.88 95.01-40.81a158.833 158.833 0 00-11.61-33.23"></path>
        </clipPath>
        <clipPath id="clipPath12455" clipPathUnits="userSpaceOnUse">
          <path d="M5412.41 6901.78c-21.13 35.63-42.65 73.08-59.55 105.07 11.09-20.99 24.17-44.32 37.81-67.96 29.25-4.4 59.57-7.72 90.76-9.84-20.34-13.27-43.74-22.73-69.02-27.27m130.49 96.59c-44.15 18.06-99.52 42.94-144.08 62.18 44.56-19.23 99.93-44.12 144.09-62.17l-.01-.01"></path>
        </clipPath>
        <clipPath id="clipPath12467" clipPathUnits="userSpaceOnUse">
          <path d="M5481.43 6929.05c-31.19 2.12-61.51 5.44-90.76 9.84-13.64 23.64-26.72 46.97-37.81 67.96 6.7 7.81 13 15.17 18.73 21.87 38.2-15.47 97.26-42.22 149.4-64.49-11.19-13.5-24.54-25.38-39.56-35.18"></path>
        </clipPath>
        <clipPath id="clipPath12479" clipPathUnits="userSpaceOnUse">
          <path d="M5520.99 6964.23c-52.14 22.27-111.2 49.02-149.4 64.49 12.1 14.13 21.69 25.35 27.23 31.83 44.56-19.24 99.93-44.12 144.08-62.18-5.85-12.22-13.23-23.67-21.91-34.14"></path>
        </clipPath>
        <clipPath id="clipPath12515" clipPathUnits="userSpaceOnUse">
          <path d="M5316.01 6999.54c-40.44 80.09-32.79 93.46-26.13 105.1 4.83 8.46 12.57 14.56 21.61 17.54 4.1 1.35 8.46 2.06 12.94 2.06 3.2 0 6.45-.36 9.72-1.11 10.71-2.46 28.06-9 52.49-19.21-7.92-10.97-12.74-17.65-12.74-17.65l-7.9-11.82c-18.19 7.49-32.39 12.84-40.07 14.6-.59.14-1.13.2-1.61.2h-.02c-8.95 0-1.34-22.35 14.71-55.25l-23-34.46"></path>
        </clipPath>
        <clipPath id="clipPath12527" clipPathUnits="userSpaceOnUse">
          <path d="M5366 7074.45c-18.19 7.49-32.41 12.84-40.09 14.6-.58.13-1.11.2-1.59.2.48 0 1.02-.06 1.61-.2 7.68-1.76 21.88-7.11 40.07-14.6"></path>
        </clipPath>
        <clipPath id="clipPath12539" clipPathUnits="userSpaceOnUse">
          <path d="M5339.01 7034c-16.05 32.9-23.66 55.25-14.71 55.25h.02-.29c-1.55-.09-2.56-.9-3.09-2.36-2.37-6.55 5.09-26.27 18.07-52.89"></path>
        </clipPath>
        <clipPath id="clipPath12551" clipPathUnits="userSpaceOnUse">
          <path d="M5339.01 7034c-12.98 26.62-20.44 46.34-18.07 52.89-2.15-5.98 3.89-22.93 14.81-46.05l1.73.05c1.49-.35 3.22-.82 5.18-1.42l-3.65-5.47m-13.1 55.05c-.59.14-1.12.2-1.61.2h-.27.29c.48 0 1.01-.07 1.59-.2"></path>
        </clipPath>
        <clipPath id="clipPath12563" clipPathUnits="userSpaceOnUse">
          <path d="M5342.66 7039.47c-1.96.6-3.69 1.07-5.18 1.42l-1.73-.05c-10.92 23.12-16.96 40.07-14.81 46.05.53 1.46 1.54 2.27 3.09 2.36h.27c.49 0 1.02-.06 1.61-.2 7.68-1.76 21.9-7.11 40.09-14.6l-23.34-34.98"></path>
        </clipPath>
        <clipPath id="clipPath12575" clipPathUnits="userSpaceOnUse">
          <path d="M5213.29 6845.63l5.1 7.65.7-1.12c-2.06-2.32-3.99-4.5-5.8-6.53"></path>
        </clipPath>
        <radialGradient
          id="radialGradient12585"
          cx="0"
          cy="0"
          r="1"
          fx="0"
          fy="0"
          gradientTransform="matrix(1926.14 0 0 -1672.88 5868.85 5863.95)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#b5bac5" stopOpacity="1"></stop>
          <stop offset="0.491" stopColor="#afcbce" stopOpacity="1"></stop>
          <stop offset="0.945" stopColor="#b5b5b1" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#b5b5b1" stopOpacity="1"></stop>
        </radialGradient>
        <clipPath id="clipPath12595" clipPathUnits="userSpaceOnUse">
          <path d="M5219.09 6852.16l-.7 1.12 52.34 78.42c3.67-2.54 7.43-4.94 11.31-7.21-24.28-28.12-47.13-54.43-62.95-72.33"></path>
        </clipPath>
        <clipPath id="clipPath12607" clipPathUnits="userSpaceOnUse">
          <path d="M5478.4 7206.3a184.26 184.26 0 01-12.56 7.16c31.88 44.05 59.83 82.59 60.05 82.59v-.01c-1.22-2.63-22.81-43.34-47.49-89.74"></path>
        </clipPath>
        <radialGradient
          id="radialGradient12617"
          cx="0"
          cy="0"
          r="1"
          fx="0"
          fy="0"
          gradientTransform="matrix(1917.94 0 0 -1676.18 5887.39 5852.53)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#afcbce" stopOpacity="1"></stop>
          <stop offset="0.242" stopColor="#afcbce" stopOpacity="1"></stop>
          <stop offset="0.945" stopColor="#b5b5b1" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#b5b5b1" stopOpacity="1"></stop>
        </radialGradient>
        <clipPath id="clipPath12627" clipPathUnits="userSpaceOnUse">
          <path d="M5417 7090.97c-11.12 4.81-21.24 9.14-30.36 12.95 17.46 24.16 49.98 69.17 79.2 109.54 4.3-2.23 8.48-4.62 12.56-7.16-22.15-41.65-46.78-87.9-61.4-115.33"></path>
        </clipPath>
        <clipPath id="clipPath12639" clipPathUnits="userSpaceOnUse">
          <path d="M5282.04 6924.49c-3.88 2.27-7.64 4.67-11.31 7.21l45.28 67.84c3.48-6.89 7.31-14.26 11.54-22.19-14.82-17.25-30.45-35.41-45.51-52.86"></path>
        </clipPath>
        <clipPath id="clipPath12651" clipPathUnits="userSpaceOnUse">
          <path d="M5327.55 6977.35c-4.23 7.93-8.06 15.3-11.54 22.19l23 34.46c.51-1.05 1.02-2.1 1.55-3.16 3.72-7.53 7.85-15.58 12.3-23.99-7.97-9.3-16.5-19.24-25.31-29.5m71.27 83.2c-11.84 5.11-22.92 9.83-32.82 13.9l7.9 11.82s4.82 6.68 12.74 17.65c9.12-3.81 19.24-8.14 30.36-12.95-7.96-14.94-12.95-24.29-12.95-24.29l-5.23-6.13"></path>
        </clipPath>
        <clipPath id="clipPath12663" clipPathUnits="userSpaceOnUse">
          <path d="M5352.86 7006.85c-4.45 8.41-8.58 16.46-12.3 23.99 3.72-7.53 7.85-15.57 12.3-23.99m45.96 53.7c-11.85 5.11-22.91 9.82-32.82 13.9 9.9-4.07 20.98-8.79 32.82-13.9"></path>
        </clipPath>
        <clipPath id="clipPath12675" clipPathUnits="userSpaceOnUse">
          <path d="M5340.56 7030.84a451.354 451.354 0 010 0"></path>
        </clipPath>
        <clipPath id="clipPath12687" clipPathUnits="userSpaceOnUse">
          <path d="M5352.86 7006.85c-4.45 8.42-8.58 16.46-12.3 23.99-.53 1.07-1.04 2.11-1.55 3.16l3.65 5.47c7.02-2.15 16.95-5.9 28.93-10.75-5.73-6.7-12.03-14.06-18.73-21.87"></path>
        </clipPath>
        <clipPath id="clipPath12699" clipPathUnits="userSpaceOnUse">
          <path d="M5371.59 7028.72c-11.98 4.85-21.91 8.6-28.93 10.75l23.34 34.98c9.91-4.08 20.97-8.79 32.82-13.9-5.54-6.48-15.13-17.7-27.23-31.83"></path>
        </clipPath>
        <clipPath id="clipPath12737" clipPathUnits="userSpaceOnUse">
          <path d="M4070.26 5399.59c-38.73 63.73-54.22 111.88-60.2 143.27 2.83 3.31 4.78 5.59 5.67 6.64 5.1-30.38 19.82-79.91 60.58-146.98-2-1.01-4.01-1.99-6.05-2.93m100.4 146.64c-65.34 16.57-114.13 28.95-137.82 34.97.85 1.59 1.72 3.23 2.62 4.92 25.28-6.42 72.8-18.48 135.24-34.3 0-.56.01-1.11.01-1.66 0-1.32-.02-2.62-.05-3.93"></path>
        </clipPath>
        <clipPath id="clipPath12749" clipPathUnits="userSpaceOnUse">
          <path d="M4049.32 5391.42c-32.31 54.16-48.81 98.03-57.11 130.57 7.54 8.8 13.66 15.97 17.85 20.87 5.98-31.39 21.47-79.54 60.2-143.27-6.75-3.11-13.74-5.85-20.94-8.17m121.38 160.4c-62.44 15.82-109.96 27.88-135.24 34.3 3.33 6.26 7 13.14 10.88 20.43 39.51-10.03 80.44-20.42 122.32-31.04 1.26-7.73 1.95-15.65 2.04-23.69"></path>
        </clipPath>
        <clipPath id="clipPath12761" clipPathUnits="userSpaceOnUse">
          <path d="M4076.31 5402.52c-40.76 67.07-55.48 116.6-60.58 146.98.37.43.56.66.56.66s.74 1.37 2.09 3.92c3.22-21.61 11.49-54.23 31.9-97.12-8.79 35.65-6.13 54.24-6.13 54.24s42.2-10.72 111.49-28.3c-16.13-34.29-44.21-62.6-79.33-80.38"></path>
        </clipPath>
        <clipPath id="clipPath12773" clipPathUnits="userSpaceOnUse">
          <path d="M4170.62 5545.02c-64.53 16.36-113.35 28.76-138.36 35.11.19.35.39.71.58 1.07 23.69-6.02 72.48-18.4 137.82-34.97-.01-.41-.02-.8-.04-1.21"></path>
        </clipPath>
        <clipPath id="clipPath12785" clipPathUnits="userSpaceOnUse">
          <path d="M4050.28 5456.96c-20.41 42.89-28.68 75.51-31.9 97.12 2.61 4.89 7.5 14.07 13.88 26.05 25.01-6.35 73.83-18.75 138.36-35.11-.71-22.03-5.99-43.01-14.98-62.12-69.29 17.58-111.49 28.3-111.49 28.3s-2.66-18.59 6.13-54.24"></path>
        </clipPath>
        <clipPath id="clipPath12821" clipPathUnits="userSpaceOnUse">
          <path d="M3984.55 5567.37c-.89 13.13.03 20.48.21 21.68l2.08 14.17 2.62 17.82 28.48-7.27c-18.61-25.75-31.8-44.01-31.8-44.01l-1.59-2.39"></path>
        </clipPath>
        <clipPath id="clipPath12835" clipPathUnits="userSpaceOnUse">
          <path d="M4090.64 5689.78c-4.07 2.54-8.26 4.93-12.56 7.17 31.88 44.04 59.84 82.58 60.05 82.58v-.01c-1.22-2.63-22.81-43.34-47.49-89.74"></path>
        </clipPath>
        <radialGradient
          id="radialGradient12845"
          cx="0"
          cy="0"
          r="1"
          fx="0"
          fy="0"
          gradientTransform="matrix(1926.14 0 0 -1672.88 5868.85 5863.95)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#b5bac5" stopOpacity="1"></stop>
          <stop offset="0.491" stopColor="#afcbce" stopOpacity="1"></stop>
          <stop offset="0.945" stopColor="#b5b5b1" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#b5b5b1" stopOpacity="1"></stop>
        </radialGradient>
        <clipPath id="clipPath12855" clipPathUnits="userSpaceOnUse">
          <path d="M3894.28 5407.97c-3.87 2.28-7.64 4.68-11.31 7.21l101.58 152.19c.75-11.08 2.79-26.28 7.66-45.38-24.08-28.14-62.52-73-97.93-114.02m152.06 198.58c-3.3.84-6.55 1.67-9.83 2.5l11.91 1.4c-.7-1.31-1.39-2.61-2.08-3.9"></path>
        </clipPath>
        <clipPath id="clipPath12867" clipPathUnits="userSpaceOnUse">
          <path d="M4036.51 5609.05c-5.27 1.34-10.54 2.68-15.76 4.01l-2.81.71c17.42 24.12 39.6 54.79 60.14 83.18 4.3-2.24 8.49-4.63 12.56-7.17-14.15-26.61-29.31-55.08-42.22-79.33l-11.91-1.4"></path>
        </clipPath>
        <clipPath id="clipPath12879" clipPathUnits="userSpaceOnUse">
          <path d="M4010.06 5542.86c-5.09 26.72-3.28 41.29-3.04 42.95l1.07 7.27 7.11-1.82c.9-.23 7.93-2.01 20.26-5.14-.9-1.69-1.77-3.33-2.62-4.92-10.42 2.64-16 4.06-16 4.06s-.05-.39-.12-1.18l-3.14.79s-1.76-12.03 2.15-35.37c-.89-1.05-2.84-3.33-5.67-6.64"></path>
        </clipPath>
        <clipPath id="clipPath12891" clipPathUnits="userSpaceOnUse">
          <path d="M3992.21 5521.99c-4.87 19.1-6.91 34.3-7.66 45.38l1.59 2.39s13.19 18.26 31.8 44.01l2.81-.71c5.22-1.33 10.49-2.67 15.76-4.01 3.28-.83 6.53-1.66 9.83-2.5-3.88-7.29-7.55-14.17-10.88-20.43-12.33 3.13-19.36 4.91-20.26 5.14l-7.11 1.82-1.07-7.27c-.24-1.66-2.05-16.23 3.04-42.95-4.19-4.9-10.31-12.07-17.85-20.87"></path>
        </clipPath>
        <clipPath id="clipPath12903" clipPathUnits="userSpaceOnUse">
          <path d="M4015.73 5549.5c-3.91 23.34-2.15 35.37-2.15 35.37l3.14-.79c-.29-3.29-.81-13.4 1.66-30-1.35-2.55-2.09-3.92-2.09-3.92s-.19-.23-.56-.66"></path>
        </clipPath>
        <clipPath id="clipPath12915" clipPathUnits="userSpaceOnUse">
          <path d="M4032.26 5580.13c-7.24 1.84-12.49 3.17-15.54 3.95.07.79.12 1.18.12 1.18s5.58-1.42 16-4.06c-.19-.36-.39-.72-.58-1.07"></path>
        </clipPath>
        <clipPath id="clipPath12927" clipPathUnits="userSpaceOnUse">
          <path d="M4018.38 5554.08c-2.47 16.6-1.95 26.71-1.66 30 3.05-.78 8.3-2.11 15.54-3.95-6.38-11.98-11.27-21.16-13.88-26.05"></path>
        </clipPath>
        <clipPath id="clipPath27169" clipPathUnits="userSpaceOnUse">
          <path d="M5882.76 5308.08c-75.44 0-147.71 13.63-214.43 38.54-10.88 13.88-22.05 28.14-33.38 42.61a563.77 563.77 0 0165.64-26.99c56.81-19.34 117.62-29.93 180.98-29.93.17 0 .35.01.52.01.23 0 .47-.01.7-.01 88.82 0 172.89 20.45 247.71 56.89a55930.76 55930.76 0 00-33.37-42.6c-66.71-24.91-138.92-38.52-214.37-38.52m443.67 190.07c-2.25 15.22-5.49 27.51-8.96 37.32 81.15 96.94 130.47 221.43 131.92 357.39v.17c.01.33.01.64.01.97v.23c.01.75.02 1.49.02 2.23V5899.02c0 199.49-103.04 374.89-258.77 475.88 1.76 3.31 3.5 6.58 5.23 9.84 38.3-23.9 73.68-52.08 105.47-83.86 106.95-106.98 173.07-254.61 173.07-417.82 0-117.8-34.44-227.47-93.82-319.61a616.006 616.006 0 00-54.17-65.3m-887.38.02a617.45 617.45 0 00-38.99 45.08c-67.69 96.12-107.43 213.28-107.43 339.81 0 163.21 66.12 310.84 173.07 417.82 99.31 99.28 233.63 163.36 382.93 172.05 1.4-2.58 2.85-5.24 4.35-7.94-299.18-15.49-536.93-262.92-536.93-565.97v-1.11-.31-.84-.3c.01-.74.01-1.51.02-2.25v-.22c0-.32 0-.67.01-.99v-.15c1.45-135.95 50.79-260.44 131.93-357.37-3.47-9.8-6.7-22.1-8.96-37.31m736.54 888.63c-84.37 49.83-182.39 78.96-287.47 78.96-.88 0-1.76-.01-2.63-.01-.9 0-1.8.01-2.7.01-6.45 0-12.88-.11-19.29-.33l-6.57 7.93c8.82.39 17.68.59 26.6.59 108.38 0 209.88-29.15 297.18-80.06-1.7-2.35-3.41-4.71-5.12-7.09"></path>
        </clipPath>
        <linearGradient
          id="linearGradient27177"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1211.8 0 0 -1211.8 5277.63 5883.07)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#2a2f7f" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#069be2" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#069be2" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath27189" clipPathUnits="userSpaceOnUse">
          <path d="M5485.23 6359.38c107.1 91.11 245.9 146.1 397.53 146.1 111.66 0 216.37-29.83 306.58-81.95-90.27 51.19-194.64 80.42-305.81 80.42-151.59 0-290.49-54.33-398.3-144.57"></path>
        </clipPath>
        <linearGradient
          id="linearGradient27195"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-1357.38 1357.38) rotate(-90 .196 4.533)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ee3d1f" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#f8bf09" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath27207" clipPathUnits="userSpaceOnUse">
          <path d="M5883.53 5292.18c-70.06 0-137.26 12.19-199.6 34.55-5.11 6.52-10.33 13.17-15.6 19.89 66.72-24.91 138.99-38.54 214.43-38.54 75.45 0 147.66 13.61 214.37 38.52-5.48-6.99-10.87-13.87-16.19-20.65-61.72-21.87-128.17-33.77-197.41-33.77m443.64 200.58c-.23 1.83-.48 3.64-.74 5.39a616.006 616.006 0 0154.17 65.3 593.183 593.183 0 00-53.43-70.69m-888.66 1.56a595.972 595.972 0 00-38.45 48.93 617.45 617.45 0 0138.99-45.08c-.19-1.27-.37-2.54-.54-3.85"></path>
        </clipPath>
        <linearGradient
          id="linearGradient27215"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1211.8 0 0 -1211.8 5277.63 5883.07)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#242955" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#196195" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#196195" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath27229" clipPathUnits="userSpaceOnUse">
          <path d="M5882.79 5332.31c-.23 0-.47.01-.7.01 89.87.08 174.59 21.47 249.97 58.86l-1.56-1.98c-74.82-36.44-158.89-56.89-247.71-56.89m-182.2 29.93a563.77 563.77 0 00-65.64 26.99c-.02.02-.04.05-.05.07 21.2-10.32 43.13-19.39 65.69-27.06m459.05 64.19l-57.63 101.1c-64.62-38.4-139.79-60.89-220.44-60.89-79.05 0-152.87 21.58-216.61 58.59l.3.53c-128.4 74.97-214.91 213.9-214.91 373.26 0 2.67.33 5.21.39 7.82l-134.31-.19c0-2.58-.38-5.05-.38-7.63 0 303.05 237.75 550.48 536.93 565.97.05-.11.11-.21.17-.31-80.08-4.96-155.51-26.8-223.24-61.56l69.72-115.35c57.05 27.71 120.81 43.71 188.49 43.71 15.22 0 30.25-.8 45.04-2.36 16.02-26.13 31.94-51.74 46.32-74.69-28.21 7.18-57.72 11.15-88.1 11.48h-.11c-.29 0-.57 0-.85.01h-1.22c-.26 0-.5.01-.75.01H5886.8c-206.14-.27-373.24-167.15-373.79-373.25v-.18-.84-.71-.17-.17-.38-.25-.46c.01-.08.01-.19.01-.28v-.38-.1-.22c0-.22.01-.45.01-.66v-.4-.29c.01-.14.01-.29.01-.44v-.22c.01-.16.01-.31.01-.47v-.19c1.25-82.16 29.04-157.84 75.15-218.95 67.85-95.3 179.23-157.46 305.11-157.46 206.7 0 374.26 167.59 374.26 374.3 0 3.98-.06 7.93-.19 11.88 10.37-11.96 17.08-19.61 18.46-21.02.12-.13.2-.19.25-.19.59-.01-6.86 12.54-19.24 32.7-5.16 83.75-37.85 160.03-89.14 219.93a379.616 379.616 0 01-28.97 31.83l.01.31a375.96 375.96 0 01-50.73 41.61c16.06 30.15 56.82 106.7 92.63 174.09 155.73-100.99 258.77-276.39 258.77-475.88 0 2.74-.34 5.39-.38 8.09l-134.33.68c.02-2.93.43-5.78.43-8.77 0-158.35-85.43-296.46-212.46-371.79l57.39-100.24c-.14-.19-.28-.37-.43-.56m157.83 109.04c-.06.16-.12.32-.17.48 81.2 96.77 130.64 220.99 132.09 356.91-1.45-135.96-50.77-260.45-131.92-357.39m-869.46.01c-81.14 96.93-130.48 221.42-131.93 357.37 1.45-135.93 50.88-260.15 132.09-356.93-.05-.15-.1-.3-.16-.44M5316.08 5893c-.01.32-.01.67-.01.99 0-.33 0-.66.01-.99m1133.31.03c.01.32.01.65.01.97 0-.33 0-.64-.01-.97m-1133.32 1.18c-.01.74-.01 1.51-.02 2.25.01-.75.01-1.5.02-2.25m1133.33.02c.01.75.02 1.48.02 2.23 0-.74-.01-1.48-.02-2.23m-1133.35 2.53v0m1133.37.02v0m-1133.37 1.13v0m1133.37.01v0m-388.76 329.73l-77.21 93.12c40.1-9.15 78.08-23.92 113.15-43.32-15.04-20.83-27.72-38.41-35.94-49.8m-196.99 237.58l-.17.2c6.41.22 12.84.33 19.29.33.9 0 1.8-.01 2.7-.01-7.31-.03-14.58-.21-21.82-.52"></path>
        </clipPath>
        <linearGradient
          id="linearGradient27237"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1211.8 0 0 -1211.8 5277.63 5883.07)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#2748a3" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#0fb1dd" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#0fb1dd" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath27247" clipPathUnits="userSpaceOnUse">
          <path d="M5893.31 5509.46c-125.88 0-237.26 62.16-305.11 157.46a377.163 377.163 0 0195.49-89.04 377.553 377.553 0 00-51.11 47.92c14.45 80.59 50.63 193.55 138.1 296.1 42.53 49.88 100.65 87.95 163.31 116.97l-98.16-147.17c22.97 25.84 61.81 70.65 102.34 117.69l-114.05-486.27c20.58-3.5 41.57-5.73 63.17-5.73 96.78 0 184.71 37.06 251.16 97.37l7.97 421.4c46.14-53.74 95.03-110.62 120.96-140.52.13-3.95.19-7.9.19-11.88 0-206.71-167.56-374.3-374.26-374.3m373.54 397.67c-27.09 44.16-77.78 124.9-119.26 190.77l.16 8.67c13.81 2.84 27.18 5.36 39.97 7.59a403.75 403.75 0 01-10.01 12.9c51.29-59.9 83.98-136.18 89.14-219.93"></path>
        </clipPath>
        <clipPath id="clipPath27259" clipPathUnits="userSpaceOnUse">
          <path d="M6174.35 6385.09c-84.46 50.78-183.25 80.17-288.86 80.66.87 0 1.75.01 2.63.01 105.08 0 203.1-29.13 287.47-78.96-.42-.57-.83-1.14-1.24-1.71"></path>
        </clipPath>
        <linearGradient
          id="linearGradient27267"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1211.8 0 0 -1211.8 5277.63 5883.07)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#1d5fae" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#07afe2" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#07afe2" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath27277" clipPathUnits="userSpaceOnUse">
          <path d="M6096.6 6277.45c-35.07 19.4-73.05 34.17-113.15 43.32l-119.78 144.46c7.24.31 14.51.49 21.82.52 105.61-.49 204.4-29.88 288.86-80.66-26.35-36.44-54.79-75.82-77.75-107.64m-396.97 10.32l-69.72 115.35c67.73 34.76 143.16 56.6 223.24 61.56 21.04-38.14 50.68-87.71 80.01-135.56a429.333 429.333 0 01-45.04 2.36c-67.68 0-131.44-16-188.49-43.71"></path>
        </clipPath>
        <linearGradient
          id="linearGradient27285"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1211.8 0 0 -1211.8 5277.63 5883.07)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#1576c5" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#17b3d6" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#17b3d6" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath27297" clipPathUnits="userSpaceOnUse">
          <path d="M5513.02 5888.76V5888.76m-.01 1.85V5890.61m0 1.89v0m375.19 373.43h-.11.11m-1.4 0h.49-.49"></path>
        </clipPath>
        <clipPath id="clipPath27309" clipPathUnits="userSpaceOnUse">
          <path d="M5513.02 5888.75v0m-.01 1.97v0m375.22 375.21h-.04.04m-1.43 0h.49-.49"></path>
        </clipPath>
        <clipPath id="clipPath27321" clipPathUnits="userSpaceOnUse">
          <path d="M5887.29 5517.39c-21.6 0-42.59 2.23-63.17 5.73l114.05 486.27c14.08 16.34 28.35 32.93 42.25 49.11 38.7 14.94 78.08 26.83 115.71 36.29 15.4-17.97 32.64-38.06 50.29-58.63l-7.97-421.4c-66.45-60.31-154.38-97.37-251.16-97.37m260.3 580.51c-1.62 2.57-3.22 5.11-4.81 7.63 1.67.35 3.32.7 4.97 1.04l-.16-8.67"></path>
        </clipPath>
        <clipPath id="clipPath27333" clipPathUnits="userSpaceOnUse">
          <path d="M6148.74 6158.89a377.372 377.372 0 01-50.79 41.8c.02.03.05.08.07.12a375.96 375.96 0 0050.73-41.61l-.01-.31"></path>
        </clipPath>
        <clipPath id="clipPath27345" clipPathUnits="userSpaceOnUse">
          <path d="M5698.81 6180.22c10.76 7.53 21.94 14.5 33.5 20.87l-33.5-20.87"></path>
        </clipPath>
        <clipPath id="clipPath27357" clipPathUnits="userSpaceOnUse">
          <path d="M5513.05 5885.87v0m-.01.66v0m-.01.66v0m0 .69c0 .21-.01.44-.01.66 0-.22.01-.45.01-.66m-.01.98V5888.86m-.01.66V5889.52m0 .71v0m0 .72v0m466.49 363.43c-28.21 7.21-57.72 11.2-88.12 11.53 30.38-.33 59.89-4.3 88.1-11.48.01-.02.01-.03.02-.05m-88.23 11.53c-.29 0-.57 0-.85.01.28-.01.56-.01.85-.01m-.99.01h-.93.93m-1.08 0h-.15c-.11 0-.22 0-.33.01h-.27c.25 0 .49-.01.75-.01m-1.11.01h-.8.8"></path>
        </clipPath>
        <clipPath id="clipPath27369" clipPathUnits="userSpaceOnUse">
          <path d="M5632.58 5625.8a376.534 376.534 0 00-42.1 57.76l393.48 557.16c1.57-.31 3.15-.62 4.71-.94.86-1.38 1.72-2.75 2.57-4.1l-40.14-171.15-17.11-25.66c-62.66-29.02-120.78-67.09-163.31-116.97-87.47-102.55-123.65-215.51-138.1-296.1"></path>
        </clipPath>
        <clipPath id="clipPath27381" clipPathUnits="userSpaceOnUse">
          <path d="M5631.41 5619.04c-71.4 67.05-116.75 161.49-118.36 266.83v.19c0 .15 0 .31-.01.47v.22c0 .15 0 .3-.01.44v.69c0 .21-.01.44-.01.66v.21c.62-80.3 26.8-154.39 70.46-215.11l7 9.92c12.2-20.6 26.31-39.93 42.1-57.76-.41-2.28-.8-4.53-1.17-6.76m-118.39 269.86v.34c0 .1 0 .19-.01.28v.11c.01-.24.01-.49.01-.73m-.01.98V5889.88m0 .92v0m0 .86v0m0 1.02c.55 206.1 167.65 372.98 373.79 373.25-20-.03-39.48-2.05-58.62-5.1l-95.87-59.74a369.171 369.171 0 01-33.5-20.87l-117.16-73c-42.9-60.69-68.42-134.58-68.64-214.54m475.66 347.1c-1.56.32-3.14.63-4.71.94l2.18 3.08 2.53-4.02m-9.01 14.36c-29.03 7.45-59.33 11.63-90.61 11.78h1.37c.28-.01.56-.01.85-.01h.11c30.4-.33 59.91-4.32 88.12-11.53.05-.08.11-.16.16-.24m-90.94 11.79h-.49.49"></path>
        </clipPath>
        <clipPath id="clipPath27393" clipPathUnits="userSpaceOnUse">
          <path d="M5590.48 5683.56c-32.9 55.59-51.81 120.41-51.81 189.7 0 127.06 63.33 239.32 160.14 306.96l33.5 20.87c53.56 29.58 115.15 46.41 180.66 46.41 24.29 0 48.02-2.33 70.99-6.78l-393.48-557.16"></path>
        </clipPath>
        <clipPath id="clipPath27405" clipPathUnits="userSpaceOnUse">
          <path d="M5513.02 5888.78v0m-.01.85v0m0 .9v0m376.04 375.39c-.11 0-.23 0-.33.01.11-.01.22-.01.33-.01m-.86.01h-.9.9"></path>
        </clipPath>
        <clipPath id="clipPath27417" clipPathUnits="userSpaceOnUse">
          <path d="M5583.48 5673.64c-43.66 60.72-69.84 134.81-70.46 215.11v.15c0 .24 0 .49-.01.73V5892.68c.22 79.96 25.74 153.85 68.64 214.54l117.16 73c-96.81-67.64-160.14-179.9-160.14-306.96 0-69.29 18.91-134.11 51.81-189.7l-7-9.92m148.83 527.45l95.87 59.74c19.14 3.05 38.62 5.07 58.62 5.1H5888.72c.1-.01.22-.01.33-.01 31.28-.15 61.58-4.33 90.61-11.78 2.2-3.52 4.35-6.96 6.48-10.34l-2.18-3.08c-22.97 4.45-46.7 6.78-70.99 6.78-65.51 0-127.1-16.83-180.66-46.41"></path>
        </clipPath>
        <clipPath id="clipPath27429" clipPathUnits="userSpaceOnUse">
          <path d="M6177.71 6127.06a376.59 376.59 0 01-28.99 30.26l.02 1.57a379.616 379.616 0 0028.97-31.83"></path>
        </clipPath>
        <clipPath id="clipPath27441" clipPathUnits="userSpaceOnUse">
          <path d="M6147.75 6106.57l.97 50.75a376.59 376.59 0 0028.99-30.26c3.42-4.23 6.76-8.53 10.01-12.9-12.79-2.23-26.16-4.75-39.97-7.59"></path>
        </clipPath>
        <clipPath id="clipPath27453" clipPathUnits="userSpaceOnUse">
          <path d="M5980.42 6058.5c27.53 32.05 53.54 62.42 73.4 85.63 10.57-12.33 25.32-29.53 42.31-49.34-37.63-9.46-77.01-21.35-115.71-36.29m-29.32 6.03l40.14 171.15c15.28-24.28 28.01-44.31 36.05-56.91l-76.19-114.24"></path>
        </clipPath>
        <clipPath id="clipPath27465" clipPathUnits="userSpaceOnUse">
          <path d="M6148.72 6157.32a375.74 375.74 0 01-52.16 40.75l.45.84c6.64-3.76 13.15-7.73 19.53-11.88-6.06 4.72-12.27 9.26-18.62 13.6.02.02.02.04.03.06a377.372 377.372 0 0050.79-41.8l-.02-1.57"></path>
        </clipPath>
        <clipPath id="clipPath27477" clipPathUnits="userSpaceOnUse">
          <path d="M6142.78 6105.53c-22.1 35.09-41.12 65.2-51.79 82.09.11.2 2.1 3.94 5.57 10.45a375.74 375.74 0 0052.16-40.75l-.97-50.75c-1.65-.34-3.3-.69-4.97-1.04"></path>
        </clipPath>
        <clipPath id="clipPath27489" clipPathUnits="userSpaceOnUse">
          <path d="M6116.54 6187.03c-6.38 4.15-12.89 8.12-19.53 11.88.29.56.6 1.13.91 1.72 6.35-4.34 12.56-8.88 18.62-13.6"></path>
        </clipPath>
        <clipPath id="clipPath27501" clipPathUnits="userSpaceOnUse">
          <path d="M5881.57 5332.31c-63.36 0-124.17 10.59-180.98 29.93 56.97-19.33 118.01-29.85 181.5-29.92-.17 0-.35-.01-.52-.01"></path>
        </clipPath>
        <linearGradient
          id="linearGradient27509"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1211.8 0 0 -1211.8 5277.63 5883.07)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#212964" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#1478b4" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#1478b4" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath27519" clipPathUnits="userSpaceOnUse">
          <path d="M5882.09 5332.32c-63.49.07-124.53 10.59-181.5 29.92-22.56 7.67-44.49 16.74-65.69 27.06-9.2 11.75-18.51 23.64-27.83 35.56l57.89 100.37c63.74-37.01 137.56-58.59 216.61-58.59 80.65 0 155.82 22.49 220.44 60.89l57.63-101.1c-9.23-11.8-18.46-23.59-27.58-35.25-75.38-37.39-160.1-58.78-249.97-58.86"></path>
        </clipPath>
        <linearGradient
          id="linearGradient27527"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1211.8 0 0 -1211.8 5277.63 5883.07)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#2a3282" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#0995b9" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#0995b9" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath27537" clipPathUnits="userSpaceOnUse">
          <path d="M6449.39 5892.86v0m.01 1.14v0m.02 2.46v0m0 1.13v0"></path>
        </clipPath>
        <linearGradient
          id="linearGradient27545"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1211.8 0 0 -1211.8 5277.63 5883.07)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#26286e" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#0e88c9" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#0e88c9" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath27555" clipPathUnits="userSpaceOnUse">
          <path d="M6160.07 5426.99l-57.39 100.24c127.03 75.33 212.46 213.44 212.46 371.79 0 2.99-.41 5.84-.43 8.77l134.33-.68c.04-2.7.38-5.35.38-8.09v-1.1-.33-.81-.32c0-.75-.01-1.48-.02-2.23v-.23c0-.32 0-.65-.01-.97v-.17c-1.45-135.92-50.89-260.14-132.09-356.91-7.75 21.62-16.63 30.97-18.53 32.79l-16 15.38-13.63-17.5c-33.18-42.54-71.26-91.31-109.07-139.63"></path>
        </clipPath>
        <linearGradient
          id="linearGradient27563"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1211.8 0 0 -1211.8 5277.63 5883.07)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#2b3892" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#01a8ce" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#01a8ce" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath27573" clipPathUnits="userSpaceOnUse">
          <path d="M5316.08 5892.85v0m-.01 1.14v0m-.02 2.47v0m0 1.14v0"></path>
        </clipPath>
        <linearGradient
          id="linearGradient27581"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1211.8 0 0 -1211.8 5277.63 5883.07)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#282a73" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#0b8fd3" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#0b8fd3" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath27591" clipPathUnits="userSpaceOnUse">
          <path d="M5606.36 5425.76c-38.11 48.73-76.56 97.96-110.02 140.86l-13.65 17.5-15.99-15.38c-1.9-1.82-10.78-11.17-18.53-32.82-81.21 96.78-130.64 221-132.09 356.93v.15c-.01.33-.01.66-.01.99v.22c-.01.75-.01 1.5-.02 2.25v2.56c0 2.58.38 5.05.38 7.63l134.31.19c-.06-2.61-.39-5.15-.39-7.82 0-159.36 86.51-298.29 214.91-373.26l-.3-.53c-.37.21-.73.42-1.09.63l-57.51-100.1"></path>
        </clipPath>
        <linearGradient
          id="linearGradient27599"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1211.8 0 0 -1211.8 5277.63 5883.07)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#2a3b97" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#00acd5" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#00acd5" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath27609" clipPathUnits="userSpaceOnUse">
          <path d="M5607.07 5424.86c-.24.31-.46.59-.71.9l57.51 100.1c.36-.21.72-.42 1.09-.63l-57.89-100.37"></path>
        </clipPath>
        <linearGradient
          id="linearGradient27617"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1211.8 0 0 -1211.8 5277.63 5883.07)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#282e77" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#0e88a8" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#0e88a8" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath27627" clipPathUnits="userSpaceOnUse">
          <path d="M6286.09 5874.43c-.05 0-.13.06-.25.19-1.38 1.41-8.09 9.06-18.46 21.02-.12 3.84-.3 7.68-.53 11.49 12.38-20.16 19.83-32.71 19.24-32.7"></path>
        </clipPath>
        <linearGradient
          id="linearGradient27635"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1211.8 0 0 -1211.8 5277.63 5883.07)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#b3c9eb" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#ace4ea" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#ace4ea" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath27645" clipPathUnits="userSpaceOnUse">
          <path d="M6267.38 5895.64c-25.93 29.9-74.82 86.78-120.96 140.52l1.17 61.74c41.48-65.87 92.17-146.61 119.26-190.77.23-3.81.41-7.65.53-11.49"></path>
        </clipPath>
        <clipPath id="clipPath27657" clipPathUnits="userSpaceOnUse">
          <path d="M6146.42 6036.16c-17.65 20.57-34.89 40.66-50.29 58.63 15.92 4 31.54 7.57 46.65 10.74 1.59-2.52 3.19-5.06 4.81-7.63l-1.17-61.74"></path>
        </clipPath>
        <clipPath id="clipPath27669" clipPathUnits="userSpaceOnUse">
          <path d="M6096.13 6094.79c-16.99 19.81-31.74 37.01-42.31 49.34 22.53 26.33 37.17 43.48 37.17 43.48v.01c10.67-16.89 29.69-47 51.79-82.09-15.11-3.17-30.73-6.74-46.65-10.74"></path>
        </clipPath>
        <clipPath id="clipPath27681" clipPathUnits="userSpaceOnUse">
          <path d="M5852.98 6464.99c-1.5 2.7-2.95 5.36-4.35 7.94 2.76.17 5.53.31 8.3.43l6.57-7.93c-3.51-.11-7.03-.26-10.52-.44"></path>
        </clipPath>
        <linearGradient
          id="linearGradient27689"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1211.8 0 0 -1211.8 5277.63 5883.07)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#b4c3e2" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#ace4f5" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#ace4f5" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath27703" clipPathUnits="userSpaceOnUse">
          <path d="M6058.35 6224.45a367.9 367.9 0 01-16.36 7.92 369.685 369.685 0 01-62.51 22.06c-14.38 22.95-30.3 48.56-46.32 74.69 17.09-1.8 33.86-4.6 50.29-8.35l77.21-93.12c-.82-1.13-1.59-2.2-2.31-3.2m-205.2 240.23c-.06.1-.12.2-.17.31 3.49.18 7.01.33 10.52.44l.17-.2c-3.51-.15-7.03-.34-10.52-.55"></path>
        </clipPath>
        <clipPath id="clipPath27721" clipPathUnits="userSpaceOnUse">
          <path d="M5983.45 6320.77c-16.43 3.75-33.2 6.55-50.29 8.35-29.33 47.85-58.97 97.42-80.01 135.56 3.49.21 7.01.4 10.52.55l119.78-144.46"></path>
        </clipPath>
        <linearGradient
          id="linearGradient27729"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1211.8 0 0 -1211.8 5277.63 5883.07)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#afddf4" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#abe3e7" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#abe3e7" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath27739" clipPathUnits="userSpaceOnUse">
          <path d="M6058.33 6224.41c-5.38 2.78-10.82 5.44-16.34 7.96a367.9 367.9 0 0016.36-7.92c-.01-.01-.02-.02-.02-.04"></path>
        </clipPath>
        <clipPath id="clipPath27751" clipPathUnits="userSpaceOnUse">
          <path d="M6041.99 6232.37c-8.24 3.75-16.65 7.2-25.19 10.35a366.824 366.824 0 01-37.3 11.66c-.01.02-.01.03-.02.05a369.685 369.685 0 0062.51-22.06"></path>
        </clipPath>
        <clipPath id="clipPath27763" clipPathUnits="userSpaceOnUse">
          <path d="M5991.24 6235.68c-.85 1.35-1.71 2.72-2.57 4.1 1.13-.24 2.24-.47 3.37-.72l-.8-3.38"></path>
        </clipPath>
        <clipPath id="clipPath27775" clipPathUnits="userSpaceOnUse">
          <path d="M5992.04 6239.06c-1.13.25-2.24.48-3.37.72l-2.53 4.02 5.07 7.18c-3.83 1.11-7.68 2.16-11.55 3.16-.05.08-.11.16-.16.24 12.71-3.24 25.15-7.14 37.3-11.66-7.29 2.69-14.68 5.16-22.17 7.4l-2.59-11.06"></path>
        </clipPath>
        <clipPath id="clipPath27787" clipPathUnits="userSpaceOnUse">
          <path d="M5986.14 6243.8c-2.13 3.38-4.28 6.82-6.48 10.34 3.87-1 7.72-2.05 11.55-3.16l-5.07-7.18"></path>
        </clipPath>
        <clipPath id="clipPath27799" clipPathUnits="userSpaceOnUse">
          <path d="M6058.28 6224.36a371.76 371.76 0 01-41.48 18.36c8.54-3.15 16.95-6.6 25.19-10.35 5.52-2.52 10.96-5.18 16.34-7.96l-.05-.05"></path>
        </clipPath>
        <clipPath id="clipPath27811" clipPathUnits="userSpaceOnUse">
          <path d="M6027.29 6178.77c-8.04 12.6-20.77 32.63-36.05 56.91l.8 3.38c21.67-4.7 42.64-11.28 62.74-19.56-2.71-3.76-4.19-5.81-4.19-5.81l-23.3-34.92"></path>
        </clipPath>
        <clipPath id="clipPath27823" clipPathUnits="userSpaceOnUse">
          <path d="M6054.78 6219.5a371.278 371.278 0 01-62.74 19.56l2.59 11.06c7.49-2.24 14.88-4.71 22.17-7.4a371.76 371.76 0 0041.48-18.36c-1.32-1.84-2.5-3.47-3.5-4.86"></path>
        </clipPath>
        <clipPath id="clipPath27835" clipPathUnits="userSpaceOnUse">
          <path d="M5835.83 5891.7l98.16 147.17c4.12 1.91 8.25 3.77 12.41 5.6l-8.23-35.08c-40.53-47.04-79.37-91.85-102.34-117.69"></path>
        </clipPath>
        <clipPath id="clipPath27847" clipPathUnits="userSpaceOnUse">
          <path d="M5938.17 6009.39l8.23 35.08c11.24 4.95 22.6 9.63 34.02 14.03-13.9-16.18-28.17-32.77-42.25-49.11"></path>
        </clipPath>
        <clipPath id="clipPath27859" clipPathUnits="userSpaceOnUse">
          <path d="M5933.99 6038.87l17.11 25.66-4.7-20.06a691.39 691.39 0 01-12.41-5.6"></path>
        </clipPath>
        <clipPath id="clipPath27871" clipPathUnits="userSpaceOnUse">
          <path d="M5946.4 6044.47l4.7 20.06 76.19 114.24c5.91-9.25 9.28-14.51 9.28-14.51s6.44-7.51 17.25-20.13a59967.28 59967.28 0 00-73.4-85.63c-11.42-4.4-22.78-9.08-34.02-14.03"></path>
        </clipPath>
        <clipPath id="clipPath27883" clipPathUnits="userSpaceOnUse">
          <path d="M6209.98 6411.3c-3.83 2.37-7.72 4.72-11.6 7.01 19.08 26.38 35.41 48.89 45.28 62.43.78-.49 1.51-.96 2.28-1.45-7.8-14.85-20.76-39.34-35.96-67.99"></path>
        </clipPath>
        <linearGradient
          id="linearGradient27889"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-1357.38 1357.38) rotate(-90 .196 4.533)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f7b9af" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#fce0a9" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath27899" clipPathUnits="userSpaceOnUse">
          <path d="M6245.94 6479.29c-.77.49-1.5.96-2.28 1.45 6.31 8.64 9.99 13.63 10.09 13.63v-.02c-.47-1.04-3.27-6.42-7.81-15.06"></path>
        </clipPath>
        <linearGradient
          id="linearGradient27905"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1280.96 0 0 -1280.96 5342.31 6018.63)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#fce0a9" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#f7b9af" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath27915" clipPathUnits="userSpaceOnUse">
          <path d="M6190.65 6374.9c-5 3.24-10.04 6.4-15.14 9.49l1.1 1.81-1.02.6c1.71 2.38 3.42 4.74 5.12 7.09 5.1-2.98 10.16-6.03 15.17-9.15-1.73-3.26-3.47-6.53-5.23-9.84"></path>
        </clipPath>
        <clipPath id="clipPath27937" clipPathUnits="userSpaceOnUse">
          <path d="M6098.02 6200.81a373.23 373.23 0 01-30.79 18.91l-6.57 7.93c8.22 11.39 20.9 28.97 35.94 49.8 2.61-1.44 5.19-2.9 7.76-4.39h3.31l67.84 111.33c5.1-3.09 10.14-6.25 15.14-9.49-35.81-67.39-76.57-143.94-92.63-174.09"></path>
        </clipPath>
        <clipPath id="clipPath27955" clipPathUnits="userSpaceOnUse">
          <path d="M6175.51 6384.39c-.4.24-.77.46-1.16.7.41.57.82 1.14 1.24 1.71l1.02-.6-1.1-1.81"></path>
        </clipPath>
        <linearGradient
          id="linearGradient27963"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1211.8 0 0 -1211.8 5277.63 5883.07)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#b0d6eb" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#ace4ed" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#ace4ed" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath27973" clipPathUnits="userSpaceOnUse">
          <path d="M6107.67 6273.06h-3.31c-2.57 1.49-5.15 2.95-7.76 4.39 22.96 31.82 51.4 71.2 77.75 107.64.39-.24.76-.46 1.16-.7l-67.84-111.33"></path>
        </clipPath>
        <clipPath id="clipPath27991" clipPathUnits="userSpaceOnUse">
          <path d="M6097.95 6200.69a371.142 371.142 0 01-30.62 18.9l-.1.13a373.23 373.23 0 0030.79-18.91c-.02-.04-.05-.09-.07-.12"></path>
        </clipPath>
        <clipPath id="clipPath28003" clipPathUnits="userSpaceOnUse">
          <path d="M6096.56 6198.07c-4.56 2.96-9.19 5.81-13.88 8.57 4.84-2.47 9.61-5.05 14.33-7.73l-.45-.84m1.36 2.56a373.463 373.463 0 01-30.46 18.81l-.13.15a371.142 371.142 0 0030.62-18.9c-.01-.02-.01-.04-.03-.06"></path>
        </clipPath>
        <clipPath id="clipPath28015" clipPathUnits="userSpaceOnUse">
          <path d="M6090.99 6187.62c-5.82 9.21-9.16 14.49-9.16 14.49l-6.98 8.42c2.62-1.26 5.23-2.56 7.83-3.89 4.69-2.76 9.32-5.61 13.88-8.57-3.47-6.51-5.46-10.25-5.57-10.45"></path>
        </clipPath>
        <clipPath id="clipPath28027" clipPathUnits="userSpaceOnUse">
          <path d="M6097.01 6198.91c-4.72 2.68-9.49 5.26-14.33 7.73-2.6 1.33-5.21 2.63-7.83 3.89l-7.39 8.91a373.463 373.463 0 0030.46-18.81c-.31-.59-.62-1.16-.91-1.72"></path>
        </clipPath>
        <clipPath id="clipPath28039" clipPathUnits="userSpaceOnUse">
          <path d="M6067.23 6219.72c-2.94 1.62-5.9 3.19-8.88 4.73.72 1 1.49 2.07 2.31 3.2l6.57-7.93"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28047"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1211.8 0 0 -1211.8 5277.63 5883.07)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ebf1fa" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#e6f7fa" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e6f7fa" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28057" clipPathUnits="userSpaceOnUse">
          <path d="M6067.33 6219.59c-2.98 1.65-5.98 3.26-9 4.82 0 .02.01.03.02.04 2.98-1.54 5.94-3.11 8.88-4.73l.1-.13"></path>
        </clipPath>
        <clipPath id="clipPath28069" clipPathUnits="userSpaceOnUse">
          <path d="M6067.46 6219.44c-3.03 1.68-6.1 3.32-9.18 4.92l.05.05c3.02-1.56 6.02-3.17 9-4.82l.13-.15"></path>
        </clipPath>
        <clipPath id="clipPath28081" clipPathUnits="userSpaceOnUse">
          <path d="M6053.82 6144.13c-10.81 12.62-17.25 20.13-17.25 20.13s-3.37 5.26-9.28 14.51l23.3 34.92s1.48 2.05 4.19 5.81c6.79-2.8 13.48-5.79 20.07-8.97l6.98-8.42s3.34-5.28 9.16-14.49v-.01s-14.64-17.15-37.17-43.48"></path>
        </clipPath>
        <clipPath id="clipPath28093" clipPathUnits="userSpaceOnUse">
          <path d="M6074.85 6210.53c-6.59 3.18-13.28 6.17-20.07 8.97 1 1.39 2.18 3.02 3.5 4.86 3.08-1.6 6.15-3.24 9.18-4.92l7.39-8.91"></path>
        </clipPath>
        <clipPath id="clipPath30637" clipPathUnits="userSpaceOnUse">
          <path d="M6377.5 4932.05c-62.63 0-131.78 11.4-207.07 32.23-56.47 15.62-97.61 26.76-127.49 34.69 2.59 4.05 5.02 8.21 7.3 12.46 29.74 6.75 70.43 15.78 125.91 27.78 83.42 18.05 153.42 42.47 210.5 73.59 158.77 16.82 318.99 34.14 318.99 34.14s.24-55.92-104.25-142.11c-60.98-50.33-136.01-72.78-223.89-72.78m-187.17 91.36c-30.1 0-49.93-9.76-39.55-19.51 10.38-9.75 50.99-19.51 141.81-19.51 13.3 0 27.69.21 43.21.66 235.25 6.82 341.97 138.8 341.97 138.8s1.65 1.26-.95 1.26c-5.11 0-26.57-4.86-108.93-33.64-124.32-43.43-370.68-68.23-370.68-68.23-2.35.11-4.64.17-6.88.17"></path>
        </clipPath>
        <linearGradient
          id="linearGradient30645"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(928.297 -928.297) rotate(-10.352 -26.186 -37.31)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f05b1a" stopOpacity="1"></stop>
          <stop offset="0.552" stopColor="#f8c608" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#eaec0d" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath30657" clipPathUnits="userSpaceOnUse">
          <path d="M6060.56 5034.2c7.78 20.72 12.04 43.15 12.04 66.56 0 4.6-.17 9.18-.49 13.71 9.88 5.83 20.64 12.17 32.36 19.05 76.95 45.16 133.69 92.97 170.86 144.25 138.81 92.61 286.04 191.32 286.04 191.32s26.17-49.42-26.33-174.28c-52.48-124.83-179.36-196.35-362.83-236.05-46.99-10.17-83.43-18.21-111.65-24.56m493.31 404.04s-225.55-232.55-382.78-300.44c-88.53-38.23-95.5-49.65-72.19-49.65 18.08 0 54.38 6.87 84.97 13.42 70 15 373.32 145 370 336.67"></path>
        </clipPath>
        <linearGradient
          id="linearGradient30665"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(928.306 -928.306) rotate(-38.025 -4.445 -11.821)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f05b1a" stopOpacity="1"></stop>
          <stop offset="0.552" stopColor="#f8c608" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#eaec0d" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath30677" clipPathUnits="userSpaceOnUse">
          <path d="M6069.34 5135.88a188.364 188.364 0 01-19.97 55.8c53.61 28.28 160.14 100.86 192.45 174.89 48.71 111.67 41.93 158.34 41.93 158.34s-174.13-245.77-242.19-320.22c-4.52 6.87-9.47 13.45-14.82 19.67 87.45 110.73 258.43 329.96 258.43 329.96s31.82-30.58 23.25-137.12c-8.56-106.54-86.02-191.44-213.79-266.44-8.98-5.27-17.39-10.22-25.29-14.88"></path>
        </clipPath>
        <linearGradient
          id="linearGradient30685"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(928.276 -928.276) rotate(-38.025 -4.739 -11.723)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f05b1a" stopOpacity="1"></stop>
          <stop offset="0.552" stopColor="#f8c608" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#eaec0d" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath30695" clipPathUnits="userSpaceOnUse">
          <path d="M6049.37 5191.68c-2.43 4.45-5.04 8.78-7.81 13.01 68.06 74.45 242.19 320.22 242.19 320.22s6.78-46.67-41.93-158.34c-32.31-74.03-138.84-146.61-192.45-174.89"></path>
        </clipPath>
        <linearGradient
          id="linearGradient30703"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(928.276 -928.276) rotate(-38.025 -4.739 -11.723)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f89d1a" stopOpacity="1"></stop>
          <stop offset="0.552" stopColor="#f5e005" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#eaec0d" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath30713" clipPathUnits="userSpaceOnUse">
          <path d="M6098.9 5088.15c-23.31 0-16.34 11.42 72.19 49.65 157.23 67.89 382.78 300.44 382.78 300.44 3.32-191.67-300-321.67-370-336.67-30.59-6.55-66.89-13.42-84.97-13.42"></path>
        </clipPath>
        <linearGradient
          id="linearGradient30721"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(928.306 -928.306) rotate(-38.025 -4.445 -11.821)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f89d1a" stopOpacity="1"></stop>
          <stop offset="0.552" stopColor="#f5e005" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#eaec0d" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath30731" clipPathUnits="userSpaceOnUse">
          <path d="M6292.59 4984.39c-90.82 0-131.43 9.76-141.81 19.51-10.38 9.75 9.45 19.51 39.55 19.51 2.24 0 4.53-.06 6.88-.17 0 0 246.36 24.8 370.68 68.23 82.36 28.78 103.82 33.64 108.93 33.64 2.6 0 .95-1.26.95-1.26s-106.72-131.98-341.97-138.8c-15.52-.45-29.91-.66-43.21-.66"></path>
        </clipPath>
        <linearGradient
          id="linearGradient30739"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(928.297 -928.297) rotate(-10.352 -26.186 -37.31)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f89d1a" stopOpacity="1"></stop>
          <stop offset="0.552" stopColor="#f5e005" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#eaec0d" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath30751" clipPathUnits="userSpaceOnUse">
          <path d="M5387.97 4932.05c-87.87.01-162.91 22.45-223.89 72.78-104.48 86.19-104.25 142.11-104.25 142.11s160.25-17.32 318.99-34.14c57.08-31.12 127.08-55.54 210.5-73.59 55.48-12 96.16-21.03 125.91-27.78 2.27-4.25 4.72-8.42 7.3-12.47-29.88-7.92-71.02-19.06-127.49-34.68-75.29-20.83-144.44-32.23-207.07-32.23m-299.31 193.06c-2.6 0-.96-1.26-.96-1.26s106.71-131.98 341.98-138.8c15.51-.45 29.9-.66 43.2-.66 90.82 0 131.43 9.76 141.81 19.51 10.39 9.75-9.45 19.51-39.55 19.51-2.24 0-4.53-.06-6.87-.17 0 0-246.37 24.8-370.68 68.23-82.37 28.78-103.83 33.64-108.93 33.64"></path>
        </clipPath>
        <linearGradient
          id="linearGradient30759"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="rotate(169.648 2745.248 2734.995) scale(928.308)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f05b1a" stopOpacity="1"></stop>
          <stop offset="0.552" stopColor="#f8c608" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#eaec0d" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath30771" clipPathUnits="userSpaceOnUse">
          <path d="M5704.91 5034.2c-28.22 6.35-64.66 14.4-111.64 24.56-183.48 39.7-310.36 111.22-362.83 236.05-52.5 124.86-26.33 174.28-26.33 174.28s147.21-98.7 286.02-191.31c37.17-51.29 93.91-99.09 170.87-144.26 11.71-6.88 22.47-13.22 32.36-19.05-.32-4.53-.49-9.11-.49-13.71 0-23.41 4.26-45.84 12.04-66.56m-493.3 404.04c-3.33-191.67 300-321.67 370-336.67 30.58-6.55 66.89-13.42 84.97-13.42 23.31 0 16.35 11.42-72.19 49.65-157.23 67.89-382.78 300.44-382.78 300.44"></path>
        </clipPath>
        <linearGradient
          id="linearGradient30779"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-928.316) rotate(-38.025 -10.782 6.57)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f05b1a" stopOpacity="1"></stop>
          <stop offset="0.552" stopColor="#f8c608" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#eaec0d" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath30791" clipPathUnits="userSpaceOnUse">
          <path d="M5696.13 5135.89c-7.89 4.65-16.31 9.61-25.28 14.87-127.77 75-205.25 159.9-213.8 266.44-8.56 106.54 23.24 137.12 23.24 137.12s170.98-219.21 258.44-329.96c-5.35-6.22-10.3-12.79-14.82-19.67-68.06 74.46-242.18 320.22-242.18 320.22s-6.79-46.67 41.93-158.34c32.31-74.03 138.83-146.6 192.44-174.88a188.465 188.465 0 01-19.97-55.8"></path>
        </clipPath>
        <linearGradient
          id="linearGradient30799"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-928.301) rotate(-38.025 -11.076 6.668)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f05b1a" stopOpacity="1"></stop>
          <stop offset="0.552" stopColor="#f8c608" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#eaec0d" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath30809" clipPathUnits="userSpaceOnUse">
          <path d="M5716.1 5191.69c-53.61 28.28-160.13 100.85-192.44 174.88-48.72 111.67-41.93 158.34-41.93 158.34s174.12-245.76 242.18-320.22c-2.77-4.22-5.38-8.56-7.81-13"></path>
        </clipPath>
        <linearGradient
          id="linearGradient30817"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-928.301) rotate(-38.025 -11.076 6.668)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f89d1a" stopOpacity="1"></stop>
          <stop offset="0.552" stopColor="#f5e005" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#eaec0d" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath30827" clipPathUnits="userSpaceOnUse">
          <path d="M5666.58 5088.15c-18.08 0-54.39 6.87-84.97 13.42-70 15-373.33 145-370 336.67 0 0 225.55-232.55 382.78-300.44 88.54-38.23 95.5-49.65 72.19-49.65"></path>
        </clipPath>
        <linearGradient
          id="linearGradient30835"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-928.316) rotate(-38.025 -10.782 6.57)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f89d1a" stopOpacity="1"></stop>
          <stop offset="0.552" stopColor="#f5e005" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#eaec0d" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath30845" clipPathUnits="userSpaceOnUse">
          <path d="M5472.88 4984.39c-13.3 0-27.69.21-43.2.66-235.27 6.82-341.98 138.8-341.98 138.8s-1.64 1.26.96 1.26c5.1 0 26.56-4.86 108.93-33.64 124.31-43.43 370.68-68.23 370.68-68.23 2.34.11 4.63.17 6.87.17 30.1 0 49.94-9.76 39.55-19.51-10.38-9.75-50.99-19.51-141.81-19.51"></path>
        </clipPath>
        <linearGradient
          id="linearGradient30853"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="rotate(169.648 2745.248 2734.995) scale(928.308)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f89d1a" stopOpacity="1"></stop>
          <stop offset="0.552" stopColor="#f5e005" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#eaec0d" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath30867" clipPathUnits="userSpaceOnUse">
          <path d="M5880.22 4963.29c-36.03 0-69.01 13-94.52 34.56-1.43 1.31-2.82 2.65-4.19 4.02-25.32 25.32-40.97 60.25-40.97 98.89 0 38.63 15.65 73.56 40.97 98.89 23.66 23.65 55.69 38.85 91.3 40.76.1-.18.19-.35.29-.53-71.52-3.7-128.37-62.86-128.37-135.31v-.53-.15-.4-.14c0-.37.01-.72.01-1.08.01-.03.01-.06.01-.09 0-.17 0-.33.01-.49v-.06c1.04-48.68 27.75-91.04 67.15-114.08v-.01c.04-.02.09-.05.13-.07 8.3-4.85 17.16-8.83 26.47-11.84 13.05-4.23 26.96-6.54 41.43-6.54h.28c73.86 0 133.89 59.08 135.45 132.54v.08c.01.15.01.3.01.46v.12c.01.35.02.7.02 1.06V5104.57c0 47.7-24.63 89.63-61.86 113.77.19.37.39.74.58 1.1 9.04-5.64 17.38-12.29 24.89-19.79 25.32-25.33 40.96-60.26 40.96-98.89 0-38.62-15.63-73.55-40.94-98.87-26.08-23.97-60.87-38.6-99.11-38.6m70.07 257.87c-20.17 11.93-43.63 18.9-68.79 18.9h-1.28c-1.54 0-3.07-.02-4.6-.07l-.44.53c1.73.06 3.47.09 5.22.09 25.63 0 49.63-6.89 70.28-18.91l-.39-.54"></path>
        </clipPath>
        <linearGradient
          id="linearGradient30875"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(289.736 0 0 -289.736 5735.54 5100.76)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#2a2f7f" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#069be2" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#069be2" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath30889" clipPathUnits="userSpaceOnUse">
          <path d="M5880.4 4960.9c-36.54.01-69.78 14.01-94.7 36.95 25.51-21.56 58.49-34.56 94.52-34.56 38.24 0 73.03 14.63 99.11 38.6l-.02-.02c-25.33-25.32-60.27-40.96-98.91-40.97"></path>
        </clipPath>
        <linearGradient
          id="linearGradient30897"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(289.736 0 0 -289.736 5735.54 5100.76)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#242955" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#196195" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#196195" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath30911" clipPathUnits="userSpaceOnUse">
          <path d="M5880.22 4969.09h-.16c25.02.02 48.38 6.95 68.48 18.79l-15.89 27.88c-15.45-9.18-33.43-14.56-52.71-14.56-18.91 0-36.56 5.16-51.79 14.01l.07.12c-30.7 17.93-51.37 51.14-51.37 89.24l.08 1.87-32.11-.04-.09-1.83c0 72.45 56.85 131.61 128.37 135.31a.3.3 0 00.04-.08c-19.14-1.18-37.18-6.4-53.37-14.71l16.66-27.58c13.65 6.62 28.89 10.45 45.07 10.45 3.64 0 7.24-.19 10.78-.56 3.83-6.25 7.63-12.37 11.07-17.86a89.28 89.28 0 01-20.1 2.73h-.05c-.13 0-.27.01-.41.01h-.5c-.03 0-.05 0-.07.01h-.92c-48.96 0-88.75-39.33-89.47-88.12v-.02c-.01-.28-.01-.57-.01-.85v-.08-.41-.33-.09-.08-.17-.14-.2-.14c0-.06 0-.12.01-.18v-.05-.11-.31c0-.06.01-.12.01-.18v-.16c0-.06 0-.13.01-.19v-.12-.21c.01-.04.01-.08.01-.11.58-19.18 7.22-36.82 18.05-51.11 16.23-22.7 42.81-37.49 72.83-37.49 49.43 0 89.49 40.06 89.49 89.48 0 .95-.02 1.9-.05 2.85 2.48-2.87 4.09-4.7 4.42-5.03.03-.03.05-.05.06-.05.14 0-1.64 3-4.61 7.83-1.23 20.01-9.04 38.24-21.29 52.55a91.408 91.408 0 01-6.94 7.64v.06c-3.74 3.66-7.8 6.99-12.13 9.95 3.84 7.21 13.59 25.51 22.15 41.62 37.23-24.14 61.86-66.07 61.86-113.77l-.1 1.93-32.1.17.1-2.1c0-37.86-20.43-70.87-50.79-88.89l15.94-27.84c39.23 23.09 65.89 65.24 66.92 113.79-1.56-73.46-61.59-132.54-135.45-132.54m-41.71 6.54c-9.31 3.01-18.17 6.99-26.47 11.84 8.31-4.83 17.17-8.82 26.47-11.84m-26.6 11.92c-39.4 23.04-66.11 65.4-67.15 114.08 1.04-48.68 27.82-90.93 67.22-113.96l-.07-.13m-67.15 114.15c-.01.16-.01.32-.01.49 0-.16 0-.33.01-.49m270.91.02c.01.15.01.3.01.46 0-.16 0-.31-.01-.46m-270.93.56c0 .36-.01.71-.01 1.08 0-.36.01-.72.01-1.08m270.94.02c.01.35.02.7.02 1.06 0-.36-.01-.71-.02-1.06m-270.95 1.2v0m270.97.01v0m-270.97.54v0m270.97 0v0m-92.94 79.09l-18.46 22.27c9.6-2.19 18.68-5.72 27.08-10.37l-8.62-11.9m-47.1 56.81l-.04.05c1.53.05 3.06.07 4.6.07h.65c-1.75-.01-3.48-.05-5.21-.12"></path>
        </clipPath>
        <linearGradient
          id="linearGradient30919"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(289.736 0 0 -289.736 5735.54 5100.76)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#2748a3" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#0fb1dd" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#0fb1dd" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath30929" clipPathUnits="userSpaceOnUse">
          <path d="M5882.74 5011.44c-30.02 0-56.6 14.79-72.83 37.49a90.196 90.196 0 0122.72-21.14 90.82 90.82 0 00-12.22 11.46c3.46 19.27 12.1 46.28 33.02 70.79 10.16 11.92 24.06 21.03 39.04 27.96l-23.47-35.18c5.5 6.18 14.78 16.89 24.47 28.14l-27.27-116.26c4.92-.83 9.94-1.37 15.1-1.37 23.15 0 44.17 8.86 60.06 23.28l1.9 100.75c11.03-12.85 22.72-26.44 28.92-33.59.03-.95.05-1.9.05-2.85 0-49.42-40.06-89.48-89.49-89.48m89.31 95.08c-6.48 10.56-18.59 29.86-28.51 45.61l.04 2.06c3.3.68 6.5 1.28 9.56 1.81-.78 1.04-1.57 2.07-2.38 3.07 12.25-14.31 20.06-32.54 21.29-52.55"></path>
        </clipPath>
        <clipPath id="clipPath30941" clipPathUnits="userSpaceOnUse">
          <path d="M5949.99 5220.75c-20.2 12.15-43.85 19.19-69.12 19.31h.63c25.16 0 48.62-6.97 68.79-18.9l-.3-.41"></path>
        </clipPath>
        <linearGradient
          id="linearGradient30949"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(289.736 0 0 -289.736 5735.54 5100.76)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#1d5fae" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#07afe2" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#07afe2" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath30959" clipPathUnits="userSpaceOnUse">
          <path d="M5931.38 5195.03a103.31 103.31 0 01-27.08 10.37l-28.64 34.54c1.73.07 3.46.11 5.21.12 25.27-.12 48.92-7.16 69.12-19.31l-18.61-25.72m-94.95 2.48l-16.66 27.58c16.19 8.31 34.23 13.53 53.37 14.71 5.04-9.11 12.12-20.96 19.14-32.4-3.54.37-7.14.56-10.78.56-16.18 0-31.42-3.83-45.07-10.45"></path>
        </clipPath>
        <linearGradient
          id="linearGradient30967"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(289.736 0 0 -289.736 5735.54 5100.76)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#1576c5" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#17b3d6" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#17b3d6" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath30979" clipPathUnits="userSpaceOnUse">
          <path d="M5791.83 5101.43v0m-.01.88v0m0 .91v0m.01.93v0m89.9 88.14h-.04.04"></path>
        </clipPath>
        <clipPath id="clipPath30991" clipPathUnits="userSpaceOnUse">
          <path d="M5791.83 5101.42v0m-.01.94v0m89.92 89.93h-.01.01m-.44 0"></path>
        </clipPath>
        <clipPath id="clipPath31003" clipPathUnits="userSpaceOnUse">
          <path d="M5881.3 5013.33c-5.16 0-10.18.54-15.1 1.37l27.27 116.26c3.36 3.9 6.78 7.87 10.1 11.74 9.26 3.57 18.67 6.41 27.67 8.67l12.02-14.01-1.9-100.75c-15.89-14.42-36.91-23.28-60.06-23.28m62.24 138.8c-.39.61-.77 1.21-1.14 1.81.39.09.79.17 1.18.25l-.04-2.06"></path>
        </clipPath>
        <clipPath id="clipPath31015" clipPathUnits="userSpaceOnUse">
          <path d="M5943.82 5166.71a90.733 90.733 0 01-12.14 9.98c0 .01 0 .02.01.03 4.33-2.96 8.39-6.29 12.13-9.95v-.06"></path>
        </clipPath>
        <clipPath id="clipPath31027" clipPathUnits="userSpaceOnUse">
          <path d="M5791.86 5100.04c0 .03 0 .07-.01.11.01-.04.01-.07.01-.11m-.01.32v0m-.01.31v0m-.01.34v0m0 .47c-.01.06-.01.12-.01.18 0-.06 0-.11.01-.17v-.01m-.01.32v0m0 .34v0m0 .34v0m111.54 87.05a88.806 88.806 0 01-20.11 2.74 89.28 89.28 0 0020.1-2.73l.01-.01m-20.16 2.74c-.13 0-.27.01-.41.01.14 0 .28-.01.41-.01m-.47.01h-.44.44m-.51.01h-.37.37m-.53 0h-.39.39"></path>
        </clipPath>
        <clipPath id="clipPath31039" clipPathUnits="userSpaceOnUse">
          <path d="M5820.41 5039.25a88.852 88.852 0 00-10.06 13.81l94.08 133.2c.37-.07.74-.14 1.12-.22.2-.33.41-.66.61-.98l-9.6-40.92-4.09-6.14c-14.98-6.93-28.88-16.04-39.04-27.96-20.92-24.51-29.56-51.52-33.02-70.79m15.84 132.55c2.57 1.8 5.24 3.46 7.99 4.99l-7.99-4.99"></path>
        </clipPath>
        <clipPath id="clipPath31051" clipPathUnits="userSpaceOnUse">
          <path d="M5820.13 5037.64c-16.76 15.73-27.52 37.77-28.27 62.4 0 .04 0 .07-.01.11V5100.48c-.01.06-.01.13-.01.19v.16c0 .06-.01.12-.01.18V5101.42c.29-18.93 6.53-36.39 16.84-50.73l1.68 2.37c2.91-4.93 6.28-9.55 10.06-13.81-.1-.54-.19-1.08-.28-1.61m-28.3 63.85c-.01.06-.01.11-.01.17v.19c0-.12 0-.24.01-.36m-.01.47V5101.96m0 .45v0m0 .4v0m0 .49c0 .28 0 .57.01.85-.01-.28-.01-.56-.01-.85m.01.87c.72 48.79 40.51 88.12 89.47 88.12-4.82 0-9.51-.48-14.13-1.22l-22.93-14.28a91.257 91.257 0 01-7.99-4.99l-28.02-17.45c-10.06-14.24-16.12-31.5-16.4-50.18m113.72 81.87c-.38.08-.75.15-1.12.22l.52.73c.2-.32.4-.64.6-.95m-2.16 3.43a89.166 89.166 0 01-21.25 2.82h.08c.02-.01.04-.01.07-.01h.5c.14 0 .28-.01.41-.01h.05c6.93-.15 13.66-1.09 20.11-2.74l.03-.06m-21.41 2.82h-.24.24"></path>
        </clipPath>
        <clipPath id="clipPath31063" clipPathUnits="userSpaceOnUse">
          <path d="M5810.35 5053.06c-7.87 13.29-12.39 28.79-12.39 45.35 0 30.38 15.14 57.22 38.29 73.39l7.99 4.99c12.81 7.07 27.54 11.09 43.2 11.09 5.82 0 11.49-.55 16.99-1.62l-94.08-133.2"></path>
        </clipPath>
        <clipPath id="clipPath31075" clipPathUnits="userSpaceOnUse">
          <path d="M5791.83 5101.43V5101.43m-.01.42v0m0 .43v0m90.32 90.01h-.16.16m-.41 0h-.43.43"></path>
        </clipPath>
        <clipPath id="clipPath31087" clipPathUnits="userSpaceOnUse">
          <path d="M5808.67 5050.69c-10.31 14.34-16.55 31.8-16.84 50.73V5101.49c-.01.12-.01.24-.01.36V5103.3c0 .29 0 .57.01.85v.02c.28 18.68 6.34 35.94 16.4 50.18l28.02 17.45c-23.15-16.17-38.29-43.01-38.29-73.39 0-16.56 4.52-32.06 12.39-45.35l-1.68-2.37m35.57 126.1l22.93 14.28c4.62.74 9.31 1.22 14.13 1.22h.84c7.34-.08 14.43-1.07 21.25-2.82.53-.84 1.05-1.67 1.56-2.48l-.52-.73a88.825 88.825 0 01-16.99 1.62c-15.66 0-30.39-4.02-43.2-11.09"></path>
        </clipPath>
        <clipPath id="clipPath31099" clipPathUnits="userSpaceOnUse">
          <path d="M5950.76 5159.07c-2.18 2.55-4.5 4.97-6.95 7.26l.01.38c2.45-2.41 4.77-4.96 6.94-7.64"></path>
        </clipPath>
        <clipPath id="clipPath31111" clipPathUnits="userSpaceOnUse">
          <path d="M5943.58 5154.19l.23 12.14c2.45-2.29 4.77-4.71 6.95-7.26.81-1 1.6-2.03 2.38-3.07-3.06-.53-6.26-1.13-9.56-1.81"></path>
        </clipPath>
        <clipPath id="clipPath31123" clipPathUnits="userSpaceOnUse">
          <path d="M5903.57 5142.7c6.59 7.66 12.8 14.92 17.55 20.47 2.53-2.95 6.06-7.06 10.12-11.8-9-2.26-18.41-5.1-27.67-8.67m-7.01 1.44l9.6 40.92c3.65-5.8 6.7-10.59 8.62-13.61l-18.22-27.31"></path>
        </clipPath>
        <clipPath id="clipPath31135" clipPathUnits="userSpaceOnUse">
          <path d="M5943.81 5166.33a90.618 90.618 0 01-12.47 9.74c.04.06.07.13.11.2 1.59-.9 3.15-1.85 4.67-2.84a88.835 88.835 0 01-4.45 3.25c0 .01 0 .01.01.01 4.33-2.97 8.39-6.31 12.14-9.98l-.01-.38"></path>
        </clipPath>
        <clipPath id="clipPath31147" clipPathUnits="userSpaceOnUse">
          <path d="M5942.4 5153.94c-5.29 8.39-9.84 15.59-12.39 19.63.04.08.52.97 1.33 2.5 4.44-2.88 8.62-6.15 12.47-9.74l-.23-12.14c-.39-.08-.79-.16-1.18-.25"></path>
        </clipPath>
        <clipPath id="clipPath31159" clipPathUnits="userSpaceOnUse">
          <path d="M5936.12 5173.43c-1.52.99-3.08 1.94-4.67 2.84.07.13.14.27.22.41 1.52-1.04 3-2.12 4.45-3.25"></path>
        </clipPath>
        <clipPath id="clipPath31171" clipPathUnits="userSpaceOnUse">
          <path d="M5879.94 4969.09c-14.47 0-28.38 2.31-41.43 6.54 13.09-4.23 27.05-6.53 41.55-6.54h-.12m-67.9 18.38c-.04.02-.09.05-.13.07.04-.02.09-.05.13-.07"></path>
        </clipPath>
        <linearGradient
          id="linearGradient31179"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(289.736 0 0 -289.736 5735.54 5100.76)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#212964" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#1478b4" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#1478b4" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath31189" clipPathUnits="userSpaceOnUse">
          <path d="M5880.06 4969.09c-14.5.01-28.46 2.31-41.55 6.54-9.3 3.02-18.16 7.01-26.47 11.84-.04.02-.09.05-.13.08l.07.12c.07-.04.14-.08.22-.13l15.95 27.67c15.23-8.85 32.88-14.01 51.79-14.01 19.28 0 37.26 5.38 52.71 14.56l15.89-27.88c-20.1-11.84-43.46-18.77-68.48-18.79"></path>
        </clipPath>
        <linearGradient
          id="linearGradient31197"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(289.736 0 0 -289.736 5735.54 5100.76)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#2a3282" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#0995b9" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#0995b9" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath31207" clipPathUnits="userSpaceOnUse">
          <path d="M6015.67 5101.63v0m.01.54v0m.02 1.18v0m0 .54v0"></path>
        </clipPath>
        <linearGradient
          id="linearGradient31215"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(289.736 0 0 -289.736 5735.54 5100.76)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#26286e" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#0e88c9" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#0e88c9" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath31225" clipPathUnits="userSpaceOnUse">
          <path d="M5948.75 4987.84l-15.94 27.84c30.36 18.02 50.79 51.03 50.79 88.89l-.1 2.1 32.1-.17.1-1.93v-.53-.15-.39-.15c0-.36-.01-.71-.02-1.06v-.12c0-.16 0-.31-.01-.46v-.08c-1.03-48.55-27.69-90.7-66.92-113.79"></path>
        </clipPath>
        <linearGradient
          id="linearGradient31233"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(289.736 0 0 -289.736 5735.54 5100.76)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#2b3892" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#01a8ce" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#01a8ce" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath31243" clipPathUnits="userSpaceOnUse">
          <path d="M5744.76 5101.63v0m-.01.55c0 .03 0 .06-.01.09.01-.03.01-.06.01-.09m-.02 1.17v0m0 .54v0"></path>
        </clipPath>
        <linearGradient
          id="linearGradient31251"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(289.736 0 0 -289.736 5735.54 5100.76)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#282a73" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#0b8fd3" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#0b8fd3" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath31261" clipPathUnits="userSpaceOnUse">
          <path d="M5811.98 4987.67c-39.4 23.03-66.18 65.28-67.22 113.96v.06c-.01.16-.01.33-.01.49 0 .03 0 .06-.01.09 0 .36-.01.72-.01 1.08V5104.57l.09 1.83 32.11.04-.08-1.87c0-38.1 20.67-71.31 51.37-89.24l-.07-.12c-.09.05-.17.1-.26.15l-15.91-27.69"></path>
        </clipPath>
        <linearGradient
          id="linearGradient31269"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(289.736 0 0 -289.736 5735.54 5100.76)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#2a3b97" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#00acd5" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#00acd5" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath31279" clipPathUnits="userSpaceOnUse">
          <path d="M5812.2 4987.54c-.08.05-.15.09-.22.13l15.91 27.69c.09-.05.17-.1.26-.15l-15.95-27.67"></path>
        </clipPath>
        <linearGradient
          id="linearGradient31287"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(289.736 0 0 -289.736 5735.54 5100.76)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#282e77" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#0e88a8" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#0e88a8" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath31297" clipPathUnits="userSpaceOnUse">
          <path d="M5976.66 5098.69c-.01 0-.03.02-.06.05-.33.33-1.94 2.16-4.42 5.03-.03.92-.07 1.83-.13 2.75 2.97-4.83 4.75-7.83 4.61-7.83"></path>
        </clipPath>
        <linearGradient
          id="linearGradient31305"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(289.736 0 0 -289.736 5735.54 5100.76)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#b3c9eb" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#ace4ea" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#ace4ea" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath31315" clipPathUnits="userSpaceOnUse">
          <path d="M5972.18 5103.77c-6.2 7.15-17.89 20.74-28.92 33.59l.28 14.77c9.92-15.75 22.03-35.05 28.51-45.61.06-.92.1-1.83.13-2.75"></path>
        </clipPath>
        <clipPath id="clipPath31327" clipPathUnits="userSpaceOnUse">
          <path d="M5943.26 5137.36l-12.02 14.01c3.81.96 7.54 1.81 11.16 2.57.37-.6.75-1.2 1.14-1.81l-.28-14.77"></path>
        </clipPath>
        <clipPath id="clipPath31339" clipPathUnits="userSpaceOnUse">
          <path d="M5931.24 5151.37c-4.06 4.74-7.59 8.85-10.12 11.8 5.39 6.3 8.89 10.4 8.89 10.4 2.55-4.04 7.1-11.24 12.39-19.63-3.62-.76-7.35-1.61-11.16-2.57"></path>
        </clipPath>
        <clipPath id="clipPath31351" clipPathUnits="userSpaceOnUse">
          <path d="M5873.1 5239.88c-.1.18-.19.35-.29.53.79.04 1.58.08 2.37.11l.44-.53c-.84-.03-1.68-.07-2.52-.11"></path>
        </clipPath>
        <linearGradient
          id="linearGradient31359"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(289.736 0 0 -289.736 5735.54 5100.76)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#b4c3e2" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#ace4f5" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#ace4f5" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath31373" clipPathUnits="userSpaceOnUse">
          <path d="M5922.21 5182.37a89.051 89.051 0 01-18.86 7.17c-3.44 5.49-7.24 11.61-11.07 17.86 4.08-.43 8.09-1.11 12.02-2l18.46-22.27-.55-.76m-49.07 57.43a.3.3 0 01-.04.08c.84.04 1.68.08 2.52.11l.04-.05c-.84-.04-1.68-.08-2.52-.14"></path>
        </clipPath>
        <clipPath id="clipPath31391" clipPathUnits="userSpaceOnUse">
          <path d="M5904.3 5205.4c-3.93.89-7.94 1.57-12.02 2-7.02 11.44-14.1 23.29-19.14 32.4.84.06 1.68.1 2.52.14l28.64-34.54"></path>
        </clipPath>
        <linearGradient
          id="linearGradient31399"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(289.736 0 0 -289.736 5735.54 5100.76)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#afddf4" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#abe3e7" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#abe3e7" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath31409" clipPathUnits="userSpaceOnUse">
          <path d="M5922.21 5182.36c-1.18.61-2.36 1.19-3.56 1.75a90.1 90.1 0 003.56-1.74v-.01"></path>
        </clipPath>
        <clipPath id="clipPath31421" clipPathUnits="userSpaceOnUse">
          <path d="M5918.65 5184.11c-2.16.99-4.36 1.9-6.61 2.72a90.959 90.959 0 01-8.68 2.7l-.01.01c5.3-1.35 10.42-3.18 15.3-5.43"></path>
        </clipPath>
        <clipPath id="clipPath31433" clipPathUnits="userSpaceOnUse">
          <path d="M5906.16 5185.06c-.2.32-.41.65-.61.98.26-.06.53-.11.8-.17l-.19-.81"></path>
        </clipPath>
        <clipPath id="clipPath31445" clipPathUnits="userSpaceOnUse">
          <path d="M5906.35 5185.87c-.27.06-.54.11-.8.17-.2.31-.4.63-.6.95l1.21 1.72c-.92.27-1.84.52-2.77.76l-.03.06c2.95-.76 5.85-1.66 8.68-2.7-1.67.61-3.36 1.17-5.07 1.68l-.62-2.64"></path>
        </clipPath>
        <clipPath id="clipPath31457" clipPathUnits="userSpaceOnUse">
          <path d="M5904.95 5186.99c-.51.81-1.03 1.64-1.56 2.48a87.1 87.1 0 002.77-.76l-1.21-1.72"></path>
        </clipPath>
        <clipPath id="clipPath31469" clipPathUnits="userSpaceOnUse">
          <path d="M5922.2 5182.35a91.267 91.267 0 01-10.16 4.48c2.25-.82 4.45-1.73 6.61-2.72 1.2-.56 2.38-1.14 3.56-1.75l-.01-.01"></path>
        </clipPath>
        <clipPath id="clipPath31481" clipPathUnits="userSpaceOnUse">
          <path d="M5914.78 5171.45c-1.92 3.02-4.97 7.81-8.62 13.61l.19.81c5.19-1.12 10.2-2.7 15.01-4.68l-1.01-1.39-5.57-8.35"></path>
        </clipPath>
        <clipPath id="clipPath31493" clipPathUnits="userSpaceOnUse">
          <path d="M5921.36 5181.19a88.384 88.384 0 01-15.01 4.68l.62 2.64c1.71-.51 3.4-1.07 5.07-1.68 3.49-1.29 6.88-2.79 10.16-4.48l-.84-1.16"></path>
        </clipPath>
        <clipPath id="clipPath31505" clipPathUnits="userSpaceOnUse">
          <path d="M5869 5102.82l23.47 35.18c.99.46 1.97.91 2.97 1.34l-1.97-8.38c-9.69-11.25-18.97-21.96-24.47-28.14"></path>
        </clipPath>
        <clipPath id="clipPath31517" clipPathUnits="userSpaceOnUse">
          <path d="M5893.47 5130.96l1.97 8.38c2.69 1.19 5.4 2.3 8.13 3.36-3.32-3.87-6.74-7.84-10.1-11.74"></path>
        </clipPath>
        <clipPath id="clipPath31529" clipPathUnits="userSpaceOnUse">
          <path d="M5892.47 5138l4.09 6.14-1.12-4.8c-1-.43-1.98-.88-2.97-1.34"></path>
        </clipPath>
        <clipPath id="clipPath31541" clipPathUnits="userSpaceOnUse">
          <path d="M5895.44 5139.34l1.12 4.8 18.22 27.31c1.41-2.21 2.22-3.47 2.22-3.47s1.54-1.79 4.12-4.81c-4.75-5.55-10.96-12.81-17.55-20.47-2.73-1.06-5.44-2.17-8.13-3.36"></path>
        </clipPath>
        <clipPath id="clipPath31555" clipPathUnits="userSpaceOnUse">
          <path d="M5953.84 5218.34c-1.2.78-2.41 1.53-3.63 2.27l.27.43c-.06.04-.13.08-.19.12l.39.54c1.26-.73 2.51-1.49 3.74-2.26-.19-.36-.39-.73-.58-1.1"></path>
        </clipPath>
        <clipPath id="clipPath31577" clipPathUnits="userSpaceOnUse">
          <path d="M5931.69 5176.72a88.95 88.95 0 01-7.36 4.52l-1.57 1.89 8.62 11.9c.61-.34 1.22-.68 1.83-1.04h.79l16.21 26.62c1.22-.74 2.43-1.49 3.63-2.27-8.56-16.11-18.31-34.41-22.15-41.62"></path>
        </clipPath>
        <clipPath id="clipPath31595" clipPathUnits="userSpaceOnUse">
          <path d="M5950.21 5220.61c-.07.05-.14.09-.22.14l.3.41c.06-.04.13-.08.19-.12l-.27-.43"></path>
        </clipPath>
        <linearGradient
          id="linearGradient31603"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(289.736 0 0 -289.736 5735.54 5100.76)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#b0d6eb" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#ace4ed" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#ace4ed" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath31613" clipPathUnits="userSpaceOnUse">
          <path d="M5934 5193.99h-.79c-.61.36-1.22.7-1.83 1.04l18.61 25.72c.08-.05.15-.09.22-.14l-16.21-26.62"></path>
        </clipPath>
        <clipPath id="clipPath31631" clipPathUnits="userSpaceOnUse">
          <path d="M5931.68 5176.69a91.678 91.678 0 01-7.32 4.52l-.03.03a88.95 88.95 0 007.36-4.52c-.01-.01-.01-.02-.01-.03"></path>
        </clipPath>
        <clipPath id="clipPath31643" clipPathUnits="userSpaceOnUse">
          <path d="M5931.34 5176.07c-1.11.72-2.23 1.41-3.37 2.08 1.17-.6 2.33-1.23 3.48-1.88-.04-.07-.07-.14-.11-.2m.33.61a91.838 91.838 0 01-7.28 4.5l-.03.03c2.51-1.39 4.95-2.9 7.32-4.52-.01 0-.01 0-.01-.01"></path>
        </clipPath>
        <clipPath id="clipPath31655" clipPathUnits="userSpaceOnUse">
          <path d="M5930.01 5173.57c-1.39 2.2-2.19 3.47-2.19 3.47l-1.67 2.01c.61-.29 1.21-.59 1.82-.9 1.14-.67 2.26-1.36 3.37-2.08-.81-1.53-1.29-2.42-1.33-2.5"></path>
        </clipPath>
        <clipPath id="clipPath31667" clipPathUnits="userSpaceOnUse">
          <path d="M5931.45 5176.27a97.49 97.49 0 01-3.48 1.88c-.61.31-1.21.61-1.82.9l-1.76 2.13c2.5-1.39 4.93-2.89 7.28-4.5-.08-.14-.15-.28-.22-.41"></path>
        </clipPath>
        <clipPath id="clipPath31679" clipPathUnits="userSpaceOnUse">
          <path d="M5924.33 5181.24c-.7.39-1.41.76-2.12 1.13l.55.76 1.57-1.89"></path>
        </clipPath>
        <linearGradient
          id="linearGradient31687"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(289.736 0 0 -289.736 5735.54 5100.76)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ebf1fa" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#e6f7fa" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e6f7fa" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath31697" clipPathUnits="userSpaceOnUse">
          <path d="M5924.36 5181.21c-.71.4-1.43.78-2.15 1.15v.01c.71-.37 1.42-.74 2.12-1.13l.03-.03"></path>
        </clipPath>
        <clipPath id="clipPath31709" clipPathUnits="userSpaceOnUse">
          <path d="M5924.39 5181.18c-.73.4-1.46.79-2.19 1.17l.01.01c.72-.37 1.44-.75 2.15-1.15l.03-.03"></path>
        </clipPath>
        <clipPath id="clipPath31721" clipPathUnits="userSpaceOnUse">
          <path d="M5921.12 5163.17c-2.58 3.02-4.12 4.81-4.12 4.81s-.81 1.26-2.22 3.47l5.57 8.35 1.01 1.39c1.62-.67 3.22-1.38 4.79-2.14l1.67-2.01s.8-1.27 2.19-3.47c0 0-3.5-4.1-8.89-10.4"></path>
        </clipPath>
        <clipPath id="clipPath31733" clipPathUnits="userSpaceOnUse">
          <path d="M5926.15 5179.05c-1.57.76-3.17 1.47-4.79 2.14l.84 1.16c.73-.38 1.46-.77 2.19-1.17l1.76-2.13"></path>
        </clipPath>
        <clipPath id="clipPath31795" clipPathUnits="userSpaceOnUse">
          <path d="M7614.11 5925.79c27.99 91.76 33.54 158.05 31.54 202.57 1.93 3.62 3.98 7.46 6.11 11.47 3.53-44.72-.45-114.23-30.51-213.43-2.36-.24-4.75-.45-7.14-.61"></path>
        </clipPath>
        <clipPath id="clipPath31807" clipPathUnits="userSpaceOnUse">
          <path d="M7621.25 5926.4c30.06 99.2 34.04 168.71 30.51 213.43 5.45 10.23 11.5 21.59 17.84 33.5 2.74-14.92 4.9-34.03 5.13-57.65.43-44.84-6.12-105.89-28.95-185.1-7.98-1.9-16.16-3.3-24.53-4.18"></path>
        </clipPath>
        <clipPath id="clipPath31819" clipPathUnits="userSpaceOnUse">
          <path d="M7600.95 5925.35c-35.28 0-68.2 9.44-96 25.76 41.05 47.55 86.18 100.27 108.28 126.11 3.83-32.79 3.82-82.53-10.76-151.86-.51-.01-1.01-.01-1.52-.01m9.61.24c26.85 87.84 33.17 152.41 31.96 196.9 1.01 1.89 2.05 3.84 3.13 5.87 2-44.52-3.55-110.81-31.54-202.57a140.7 140.7 0 00-3.55-.2"></path>
        </clipPath>
        <clipPath id="clipPath31831" clipPathUnits="userSpaceOnUse">
          <path d="M7602.47 5925.36c14.58 69.33 14.59 119.07 10.76 151.86 8.62 10.08 13.73 16.07 13.73 16.07s6.1 11.44 15.56 29.2c1.21-44.49-5.11-109.06-31.96-196.9-2.68-.14-5.38-.21-8.09-.23"></path>
        </clipPath>
        <clipPath id="clipPath31867" clipPathUnits="userSpaceOnUse">
          <path d="M7423.28 6064.36c-.29 1.59-.57 3.21-.82 4.82 119.89 80.25 202.29 135.5 205.32 137.53l6.08 4.06 3.41-6.46c.61-1.15 4.5-8.85 8.24-24.01-1.77-2.45-3.51-4.86-5.24-7.25-4.06 19.23-8.79 28.17-8.79 28.17l-2.38-1.59c-.58 1.33-.93 1.98-.93 1.98s-82.99-55.65-204.89-137.25"></path>
        </clipPath>
        <clipPath id="clipPath31879" clipPathUnits="userSpaceOnUse">
          <path d="M7422.46 6069.18c-1.22 7.88-1.85 15.92-1.85 24.11 0 .56.01 1.12.01 1.68a311425.473 311425.473 0 01194.64 130.41l26.78 17.99 15.12-28.55c.43-.81 2.38-4.65 4.83-11.72-5.61-7.77-11.15-15.43-16.48-22.8-3.74 15.16-7.63 22.86-8.24 24.01l-3.41 6.46-6.08-4.06c-3.03-2.03-85.43-57.28-205.32-137.53"></path>
        </clipPath>
        <clipPath id="clipPath31891" clipPathUnits="userSpaceOnUse">
          <path d="M7493.64 5958.31c-22.98 15.88-41.78 36.73-54.54 60.84 97.9 65.56 161.77 108.38 161.77 108.38s.97-1.85 2.42-5.66c-4.13-5.72-6.48-8.98-6.48-8.98l-103.17-154.58m144.09 211.23c-3.13 16.36-6.91 26.17-8.63 30.09l2.38 1.59s4.73-8.94 8.79-28.17c-.85-1.18-1.7-2.35-2.54-3.51"></path>
        </clipPath>
        <clipPath id="clipPath31903" clipPathUnits="userSpaceOnUse">
          <path d="M7423.73 6062.06c-.16.76-.3 1.53-.45 2.3 121.9 81.6 204.89 137.25 204.89 137.25s.35-.65.93-1.98c-14.47-9.7-93.99-63.01-205.37-137.57"></path>
        </clipPath>
        <clipPath id="clipPath31915" clipPathUnits="userSpaceOnUse">
          <path d="M7439.1 6019.15c-7.09 13.39-12.32 27.79-15.37 42.91 111.38 74.56 190.9 127.87 205.37 137.57 1.72-3.92 5.5-13.73 8.63-30.09-14.76-20.44-27.27-37.75-34.44-47.67-1.45 3.81-2.42 5.66-2.42 5.66s-63.87-42.82-161.77-108.38"></path>
        </clipPath>
        <clipPath id="clipPath31927" clipPathUnits="userSpaceOnUse">
          <path d="M7436.2 5872.25l57.44 86.06c3.67-2.53 7.43-4.93 11.31-7.2-27.43-31.77-53.03-61.24-68.75-78.86"></path>
        </clipPath>
        <linearGradient
          id="linearGradient31935"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1342.22 0 0 -1342.22 6303.8 5691.24)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#b4c3e2" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#ace4f5" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#ace4f5" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath31947" clipPathUnits="userSpaceOnUse">
          <path d="M7701.31 6232.91c-4.08 2.55-8.26 4.94-12.56 7.17 9.81 13.56 19.24 26.58 27.62 38.13l4.08-9.27c-5.92-11.15-12.41-23.37-19.14-36.03"></path>
        </clipPath>
        <radialGradient
          id="radialGradient31957"
          cx="0"
          cy="0"
          r="1"
          fx="0"
          fy="0"
          gradientTransform="matrix(1917.94 0 0 -1676.18 5887.39 5852.53)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#afcbce" stopOpacity="1"></stop>
          <stop offset="0.242" stopColor="#afcbce" stopOpacity="1"></stop>
          <stop offset="0.945" stopColor="#b5b5b1" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#b5b5b1" stopOpacity="1"></stop>
        </radialGradient>
        <clipPath id="clipPath31967" clipPathUnits="userSpaceOnUse">
          <path d="M7669.6 6173.33c-1.86 10.13-3.98 18.34-5.95 24.7l21.59 4.68c-5.29-9.94-10.56-19.84-15.64-29.38"></path>
        </clipPath>
        <clipPath id="clipPath31979" clipPathUnits="userSpaceOnUse">
          <path d="M7663.65 6198.03c-.57 1.84-1.12 3.53-1.66 5.07 8.89 12.28 17.98 24.84 26.76 36.98 4.3-2.23 8.48-4.62 12.56-7.17-5.27-9.91-10.69-20.08-16.07-30.2l-21.59-4.68"></path>
        </clipPath>
        <clipPath id="clipPath31991" clipPathUnits="userSpaceOnUse">
          <path d="M7645.65 6128.36c-.84 18.61-2.99 33.42-5.38 44.69 1.73 2.39 3.47 4.8 5.24 7.25 2.49-10.1 4.91-23.49 6.25-40.47-2.13-4.01-4.18-7.85-6.11-11.47"></path>
        </clipPath>
        <clipPath id="clipPath32003" clipPathUnits="userSpaceOnUse">
          <path d="M7651.76 6139.83c-1.34 16.98-3.76 30.37-6.25 40.47 5.33 7.37 10.87 15.03 16.48 22.8.54-1.54 1.09-3.23 1.66-5.07 1.97-6.36 4.09-14.57 5.95-24.7-6.34-11.91-12.39-23.27-17.84-33.5"></path>
        </clipPath>
        <clipPath id="clipPath32015" clipPathUnits="userSpaceOnUse">
          <path d="M7504.95 5951.11c-3.88 2.27-7.64 4.67-11.31 7.2l103.17 154.58s2.35 3.26 6.48 8.98c2.77-7.33 7.28-21.92 9.94-44.65-22.1-25.84-67.23-78.56-108.28-126.11m137.57 171.38c-.52 19.42-2.48 35.01-4.79 47.05.84 1.16 1.69 2.33 2.54 3.51 2.39-11.27 4.54-26.08 5.38-44.69-1.08-2.03-2.12-3.98-3.13-5.87"></path>
        </clipPath>
        <clipPath id="clipPath32027" clipPathUnits="userSpaceOnUse">
          <path d="M7613.23 6077.22c-2.66 22.73-7.17 37.32-9.94 44.65 7.17 9.92 19.68 27.23 34.44 47.67 2.31-12.04 4.27-27.63 4.79-47.05-9.46-17.76-15.56-29.2-15.56-29.2s-5.11-5.99-13.73-16.07"></path>
        </clipPath>
        <linearGradient
          id="linearGradient100526"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-1651.53 1651.53) rotate(-90 .3 3.865)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient12171"
        ></linearGradient>
        <linearGradient
          id="linearGradient100528"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(1254.052 -1254.052) rotate(76.211 5.516 .426)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient12189"
        ></linearGradient>
        <linearGradient
          id="linearGradient100530"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-1651.53 1651.53) rotate(-90 .3 3.865)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient12171"
        ></linearGradient>
        <linearGradient
          id="linearGradient100532"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(1254.052 -1254.052) rotate(76.211 5.516 .426)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient12189"
        ></linearGradient>
        <linearGradient
          id="linearGradient100534"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-1651.53 1651.53) rotate(-90 .3 3.865)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient12171"
        ></linearGradient>
        <linearGradient
          id="linearGradient100536"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1211.8 0 0 -1211.8 5277.63 5883.07)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient27635"
        ></linearGradient>
        <linearGradient
          id="linearGradient100538"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1211.8 0 0 -1211.8 5277.63 5883.07)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient27689"
        ></linearGradient>
        <linearGradient
          id="linearGradient100540"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1211.8 0 0 -1211.8 5277.63 5883.07)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient27635"
        ></linearGradient>
        <linearGradient
          id="linearGradient100542"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1211.8 0 0 -1211.8 5277.63 5883.07)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient27729"
        ></linearGradient>
        <linearGradient
          id="linearGradient100544"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1211.8 0 0 -1211.8 5277.63 5883.07)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient27689"
        ></linearGradient>
        <linearGradient
          id="linearGradient100546"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1211.8 0 0 -1211.8 5277.63 5883.07)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient27635"
        ></linearGradient>
        <linearGradient
          id="linearGradient100548"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1211.8 0 0 -1211.8 5277.63 5883.07)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient27729"
        ></linearGradient>
        <linearGradient
          id="linearGradient100550"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(289.736 0 0 -289.736 5735.54 5100.76)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient31305"
        ></linearGradient>
        <linearGradient
          id="linearGradient100552"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(289.736 0 0 -289.736 5735.54 5100.76)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient31359"
        ></linearGradient>
        <linearGradient
          id="linearGradient100554"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(289.736 0 0 -289.736 5735.54 5100.76)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient31305"
        ></linearGradient>
        <linearGradient
          id="linearGradient100556"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(289.736 0 0 -289.736 5735.54 5100.76)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient31399"
        ></linearGradient>
        <linearGradient
          id="linearGradient100558"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(289.736 0 0 -289.736 5735.54 5100.76)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient31359"
        ></linearGradient>
        <linearGradient
          id="linearGradient100560"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(289.736 0 0 -289.736 5735.54 5100.76)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient31305"
        ></linearGradient>
        <linearGradient
          id="linearGradient100562"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(289.736 0 0 -289.736 5735.54 5100.76)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient31399"
        ></linearGradient>
      </defs>
      <g transform="translate(-28.108 -20.442)">
        <path
          fill="#242a55"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M83.536 29.83c1.042 1.988 2.86 5.063 4.62 7.867a250.084 250.084 0 0112.941-1.764l.139-.016.14.016c1.527.164 6.817.76 12.94 1.764 1.76-2.804 3.578-5.878 4.619-7.866-.57.244-1.173.509-1.73.752-3.865 1.695-5.65 2.437-6.526 2.438-.25 0-.48-.051-.685-.15-.369-.18-.724-.53-2.552-2.417-1.521-1.57-4.958-5.116-6.207-5.847-1.245.73-4.683 4.276-6.205 5.847-1.827 1.886-2.183 2.236-2.552 2.416-.205.1-.435.15-.684.15-.828 0-2.356-.608-6.528-2.437-.556-.243-1.16-.508-1.73-.753m32.039 10.583l-.843-.142a248.043 248.043 0 00-13.496-1.869c-1.75.19-7.263.822-13.495 1.87l-.843.14-.45-.708c-6.988-11.003-6.511-11.838-6.127-12.51.303-.53.93-.797 1.562-.651.682.156 2.125.781 4.422 1.789 1.604.703 4.158 1.821 5.2 2.138a99 99 0 001.682-1.71c3.822-3.946 6.041-6.072 7.372-6.57.2-.09.42-.135.647-.135h.046c.215-.002.457.044.662.135 1.33.498 3.549 2.624 7.372 6.57.612.631 1.285 1.326 1.682 1.71 1.042-.317 3.595-1.435 5.199-2.138 2.298-1.008 3.74-1.633 4.423-1.79.63-.144 1.258.122 1.561.653.384.67.86 1.504-6.127 12.51l-.45.708"
          display="inline"
        ></path>
        <g
          display="inline"
          transform="matrix(.03528 0 0 -.03528 -106.294 277.83)"
        >
          <g clipPath="url(#clipPath11437)">
            <path
              fill="url(#linearGradient11445)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5485 6782.92c-14.18 22.61-42.99 68.93-72.59 118.86 25.28 4.54 48.68 14 69.02 27.27 26.21-1.78 53.03-2.71 80.34-2.71 18.87 0 37.54.44 55.92 1.29 3.68-.84 6.7-1.29 8.95-1.29 1.43 0 2.54.18 3.32.56.57.28 1.33.78 2.28 1.5 171.46 10.08 317.85 56.5 400.81 121.71 59.95-58.94 116.75-118.9 125.59-123.21.78-.38 1.9-.56 3.33-.56 29.61 0 193.45 78.32 263.59 105.77 16.66 33.92 24.74 57.14 15.63 57.14 29.37 0-119.71-240.97-159.98-305.21-77.85 33.92-160.7 57.89-246.85 70.92l-10.19 1.51c-12.58 1.78-25.17 3.37-37.57 4.63-4.82.53-9.7.94-14.57 1.31l-5.68.48c-10.14.84-20.22 1.7-30.35 2.22-13.09.69-26.29.95-39.7 1.16l-3.07.08c-2.83.13-5.66.22-8.53.22h-1.94c-17.77 0-36.15-.55-55.72-1.68l-3.16-.19c-17.74-1.05-36.29-2.66-53.36-4.65l-3.38-.4c-99.59-11.55-194.4-37.95-282.14-76.73m665.41 191.58c-1.44 0-2.55.19-3.33.57-16.9 8.23-204.07 219.8-258.41 238.92 54.34-19.12 241.51-230.69 258.41-238.92.78-.38 1.89-.57 3.33-.57m-535.35 0c-10.51 0-37.98 9.89-72.16 23.87l.01.01c34.18-13.99 61.63-23.87 72.16-23.88h-.01m272.87 239.74c-.05.02-.11.04-.17.06-1.15.69-2.54 1.04-4.19 1.04h.01c1.64 0 3.03-.35 4.18-1.04.06-.02.12-.04.17-.06m-5.21 1.07a11.718 11.718 0 00.01 0h-.01"
            ></path>
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M82 29.444c1.462.335 9.63 4.356 10.318 4.021.6-.292 7.451-7.839 9.326-8.44v-.024c-.016-.01-.044-.014 0-.01.044-.004.017 0 0 .01v.025c1.874.6 8.726 8.147 9.325 8.44.597.29 6.823-2.697 9.416-3.712.62-1.26.903-2.103.495-2.01-1.462.336-9.631 4.357-10.319 4.022-.599-.292-7.273-7.839-9.148-8.44a.298.298 0 00-.178-.035.294.294 0 00-.176.035c-1.875.601-8.548 8.148-9.149 8.44-.687.335-8.857-3.686-10.318-4.021-.373-.086-.166.614.347 1.7l.061-.001"
          display="inline"
        ></path>
        <path
          fill="#282c75"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M101.42099999999999 23.329000000000004"
          display="inline"
        ></path>
        <g
          display="inline"
          transform="matrix(.03528 0 0 -.03528 -106.294 277.83)"
        >
          <g clipPath="url(#clipPath11459)">
            <path
              fill="url(#linearGradient11467)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5561.77 6926.34c-27.31 0-54.13.93-80.34 2.71 15.02 9.8 28.37 21.68 39.56 35.18 41-17.51 77.73-32.26 96.7-36.6-18.38-.85-37.05-1.29-55.92-1.29m70.47 2.06c27.52 20.82 210.7 221.26 262.07 237.73v.7c-.37.22-.93.34-.55.34.1 0 .28-.01.55-.03.27.02.44.03.54.03.39 0-.17-.12-.54-.34v-.7c25.49-8.17 83.45-61.66 138.74-116.02-82.96-65.21-229.35-111.63-400.81-121.71"
            ></path>
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M91.886 33.44c-.67-.154-1.965-.674-3.412-1.292.306-.37.567-.773.773-1.204 1.206.493 2.175.842 2.546.842.05 0 .09-.007.117-.02.6-.292 7.274-7.839 9.149-8.44a.28.28 0 01.176-.035l.03-.001c.058 0 .107.012.148.036l.006.002h.001c.001.002.003.002.005.003h.001l.005.001.001.001.005.002h.001l.006.002c1.087.382 3.677 2.944 5.828 5.146-.226.217-.471.429-.734.636-1.95-1.918-3.995-3.805-4.894-4.093V25c.013-.008.033-.012.019-.012l-.02.001a.35.35 0 00-.019 0c-.013 0 .006.003.02.011v.025c-1.812.58-8.275 7.652-9.246 8.386-.17.01-.341.02-.513.028"
          display="inline"
        ></path>
        <path
          fill="#242a55"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M105.121 99.758c1.235.607 4.254 2.145 11.362 5.949 5.81 3.108 10.855 4.883 15.423 5.423 4.358.515 8.183-.098 11.696-1.877 5.381-2.722 7.299-5.222 7.943-6.377-3.66-.42-18.41-2.109-28.79-3.337-10.56-1.248-10.854-1.339-10.996-1.382a7.324 7.324 0 00-1.274-.27c-2.644-.314-4.502 1.049-5.364 1.871m26.638 12.623c-4.727-.56-9.918-2.379-15.87-5.563-10.41-5.572-11.988-6.249-12.05-6.276l-.745-.312.485-.648c.106-.14 2.666-3.465 7.055-2.946.492.058.994.165 1.493.317.188.044 1.869.283 10.777 1.335 11.867 1.404 29.453 3.412 29.628 3.433l.695.079-.15.682c-.035.156-.935 3.86-8.905 7.895-3.69 1.867-7.866 2.54-12.413 2.004"
        ></path>
        <path
          fill="#242a55"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M105.828 99.666c1.444.724 4.533 2.314 10.842 5.69 5.766 3.086 10.765 4.845 15.283 5.38 4.29.506 8.016-.089 11.471-1.837 4.55-2.302 6.57-4.41 7.453-5.701a8597.88 8597.88 0 01-28.167-3.265c-10.603-1.253-10.883-1.34-11.068-1.397a6.921 6.921 0 00-1.203-.256 6.09 6.09 0 00-.723-.043c-1.75 0-3.081.779-3.888 1.43m28.97 12.035c-.947 0-1.936-.06-2.938-.178-4.619-.546-9.71-2.334-15.564-5.467-7.217-3.862-10.209-5.38-11.35-5.943l-.51-.25.412-.392c.792-.757 2.48-2.028 4.868-2.028.27 0 .544.016.816.048.443.052.895.15 1.343.285.17.054 1.488.253 10.927 1.369 9.725 1.15 23.372 2.715 28.788 3.335l.591.068-.29.52c-.706 1.266-2.698 3.8-8.11 6.538-2.785 1.41-5.725 2.095-8.983 2.095m-31.08-11.641l.275.116c.175.075 1.967.877 12.083 6.29 5.907 3.16 11.051 4.966 15.73 5.52 4.455.526 8.58-.138 12.186-1.964 7.815-3.955 8.689-7.59 8.697-7.626l.055-.253-.749-.085c-6.866-.786-19.782-2.27-29.138-3.376-6.607-.782-10.45-1.259-10.819-1.343a8.362 8.362 0 00-1.451-.31 7.505 7.505 0 00-.877-.053c-3.642 0-5.727 2.727-5.813 2.844l-.18.24m31.018 12.895c-.985 0-2.002-.06-3.023-.181-4.778-.566-10.015-2.4-16.01-5.607-10.26-5.492-11.952-6.232-12.019-6.26l-1.212-.51.79-1.053c.097-.13 2.414-3.161 6.45-3.161.319 0 .645.019.969.058.515.06 1.04.172 1.563.332.097.021 1.24.201 10.707 1.32 9.355 1.107 22.27 2.59 29.136 3.376l1.623.186-.245 1.111c-.035.162-.966 4.04-9.113 8.164-2.917 1.477-6.153 2.225-9.616 2.225"
        ></path>
        <g
          display="inline"
          transform="matrix(.03528 0 0 -.03528 -106.294 277.83)"
        >
          <g clipPath="url(#clipPath11483)">
            <path
              fill="url(#linearGradient11491)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6833.32 4702.62c-159.12 0-334.63 57.92-526.77 160.75-67.91 36.33-122.6 65.34-166.61 88.5 7.94-2.19 16.23-4.48 24.88-6.87 80.14-22.17 149.61-32.95 212.41-32.95 59.06 0 111.06 9.55 157 28.98 26.83-3.41 54.84-7.01 83.98-10.79 9.59-1.23 19.05-2.4 28.58-3.53 83-9.81 162.17-14.8 235.27-14.8h.02c71.09 0 138.19 4.73 200.97 14.15 95.66-11 169.95-19.51 202.74-23.26 38.91 42.95 45.56 71.23 45.72 71.94 2.17-.25 3.28-.37 3.28-.37s-22.04-99.89-243.04-211.7c-80.72-40.86-166.88-60.05-258.43-60.05"
            ></path>
          </g>
        </g>
        <path
          fill="#a7b4c8"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M152.345 102.333l-1.51-.173h.002l1.508.172v.001"
          display="inline"
        ></path>
        <g
          display="inline"
          transform="matrix(.03528 0 0 -.03528 -106.294 277.83)"
        >
          <g clipPath="url(#clipPath11503)">
            <path
              fill="url(#linearGradient11511)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M7285.79 4902.8c-32.79 3.75-107.08 12.26-202.74 23.26 74.91 11.23 143.65 29.12 205.67 53.58 21.77-2.5 36.58-4.19 42.79-4.9-.16-.71-6.81-28.99-45.72-71.94"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath11521)">
            <g transform="matrix(107.2 0 0 25.2002 7208.9 4997.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAFCAYAAABB9hwOAAAABHNCSVQICAgIfAhkiAAAAExJREFUGJVjVNG0/f///38GRgZU8J/hPxLnP1wUXRVCDln+PwMTQUMxNCELYTMUApgIGvofmyXoBmGymYgzFF8QYLcAxWDSDUUTRwIAx/wvaIYhMs0AAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <path
          fill="#242a55"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M150.837 102.16l-6.05-.694c.298-.041.595-.085.888-.132l5.612.644-.061.025c-.13.053-.259.106-.39.157"
        ></path>
        <path
          fill="#242a55"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M151.287 101.978l-5.612-.644a36.411 36.411 0 002.569-.504l3.33.382-.157.712-.13.054"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath11537)">
            <path
              fill="url(#linearGradient11545)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6882.08 4911.91h-.02c-73.1 0-152.27 4.99-235.27 14.8a3008.2 3008.2 0 00-28.58 3.53c-29.14 3.78-57.15 7.38-83.98 10.79 24.99 10.57 48.17 24.06 69.74 40.53 164.41-19.24 343.3-39.89 479.08-55.5-62.78-9.42-129.88-14.15-200.97-14.15"
            ></path>
          </g>
        </g>
        <path
          fill="#28508c"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M150.836 102.16c-1.357-.155-3.48-.398-6.052-.694h.002l6.051.694"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath11557)">
            <path
              fill="url(#linearGradient11565)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M7083.05 4926.06c-135.78 15.61-314.67 36.26-479.08 55.5 3.33 2.54 6.63 5.16 9.88 7.84 8.21 6.78 15.82 13.39 22.87 19.84 9.28-1.2 18.67-2.41 28.17-3.64 9.59-1.22 19.04-2.41 28.54-3.52 83.14-9.83 162.4-14.82 235.56-14.82 66.7 0 129.4 4 188.19 12.06 72.89-8.39 133.08-15.28 171.54-19.68-62.02-24.46-130.76-42.35-205.67-53.58"
            ></path>
          </g>
        </g>
        <path
          fill="#242a55"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M118.797 98.32c2.716.323 6.163.753 10.243 1.281.332.043.66.084.989.123 14.258 1.686 24.194-.788 30.375-7.562 4.964-5.438 5.938-9.07 6.118-10.537-9.153 2.326-44.785 11.365-45.812 11.432-4.27.282-6.134 3.299-6.784 4.73.79.073 2.247.224 4.87.534m-6.589.629l.224-.777c.018-.06 1.803-5.95 8.197-6.371 1.21-.155 33.9-8.429 46.394-11.603l.677-.173.101.692c.026.183.576 4.578-6.465 12.292-6.475 7.096-16.764 9.702-31.454 7.965-.333-.04-.666-.082-1.003-.124a956.998 956.998 0 00-10.23-1.28c-4.711-.556-5.596-.592-5.632-.592l-.809-.03"
        ></path>
        <path
          fill="#242a55"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M114.538 97.448c.835.083 2.18.228 4.305.479 2.692.319 6.14.749 10.248 1.28.33.043.658.084.985.123 2.852.337 5.566.508 8.066.508 9.905 0 17.091-2.598 21.97-7.944 4.343-4.759 5.574-8.109 5.917-9.735-13.76 3.496-44.285 11.228-45.292 11.295-3.624.238-5.431 2.58-6.199 3.994m23.605 3.184c-2.532 0-5.277-.173-8.16-.514-.331-.038-.66-.08-.994-.123-4.104-.531-7.55-.961-10.24-1.28-2.697-.319-4.13-.466-4.859-.532l-.555-.052.23-.508c.632-1.393 2.59-4.663 7.12-4.962.928-.089 24.237-5.957 45.74-11.42l.561-.143-.07.576c-.209 1.7-1.293 5.36-6.218 10.755-5.038 5.52-12.416 8.203-22.555 8.203M112.73 98.57l.301.012c.035 0 .912.034 5.665.595 2.77.329 6.212.76 10.234 1.28.334.043.666.084.998.123 2.903.343 5.669.518 8.218.518 10.278 0 17.768-2.734 22.897-8.355 6.908-7.569 6.391-11.792 6.366-11.969l-.038-.255-.25.065c-.45.113-44.967 11.423-46.442 11.61-6.107.404-7.849 6.033-7.866 6.09l-.083.286m25.416 3.321c-2.58 0-5.377-.176-8.31-.522a99.1 99.1 0 01-1.006-.125c-4.02-.52-7.461-.951-10.228-1.278-4.703-.556-5.59-.591-5.598-.591l-1.318-.046.365-1.266c.017-.062 1.853-6.217 8.552-6.658 1.036-.132 28.273-7.004 46.322-11.59l1.104-.282.165 1.128c.027.191.593 4.774-6.565 12.617-5.288 5.795-12.97 8.613-23.483 8.613"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath11579)">
            <path
              fill="url(#linearGradient11587)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6931.77 5016.11c-82.64 0-170.41 6.36-263.17 18.37-1.83.24-3.67.48-5.48.71 60.33 64.27 62.27 106.36 62.25 111.84l-.1 22.18-22.05-2.38c-29.06-3.15-59.91-6.47-91.77-9.9 52.65 11.69 115.46 25.46 190.38 41.67 236.25 51.11 421.64 124.2 561.64 221.88 203.31 51.44 357.87 90.72 357.87 90.72s2.66-18.59-6.13-54.24c36.09 75.82 34.23 119.52 33.56 127.11l3.15.8s17.43-118.88-178.77-333.82c-150.68-165.12-367.61-234.94-641.38-234.94"
            ></path>
          </g>
        </g>
        <path
          fill="#a7b4c8"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M157.497 83.264l.058-.058c5.576-1.412 9.506-2.41 9.506-2.41l.005.041c-.684.174-4.45 1.13-9.568 2.427"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath11599)">
            <path
              fill="url(#linearGradient11607)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M7363.47 5420.48c42.08 29.36 80.05 60.94 114.08 94.81 145.06 36.74 251.83 63.86 271.22 68.78.67-7.59 2.53-51.29-33.56-127.11 8.79 35.65 6.13 54.24 6.13 54.24s-154.56-39.28-357.87-90.72"
            ></path>
          </g>
        </g>
        <path
          fill="#242a55"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M152.332 84.527c.147-.102.291-.204.435-.307l5.047-1.277-.022.023-.237.24c-1.62.41-3.38.856-5.223 1.321"
        ></path>
        <path
          fill="#242a55"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M152.767 84.22c.502-.36.985-.73 1.452-1.108l3.192-.808 1.362-.345-.958.984-5.048 1.277"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath11621)">
            <path
              fill="url(#linearGradient11629)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6426.73 5137.19c19.95 13.55 37.92 28.16 53.94 43.84a980.81 980.81 0 0122.93 18.13c64.94 14.67 151.42 33.81 266.27 58.66 115.09 24.9 218.58 55.25 310.72 91.23 97.7 24.62 194.86 49.17 282.88 71.43-140-97.68-325.39-170.77-561.64-221.88-74.92-16.21-137.73-29.98-190.38-41.67-59.91-6.44-123.32-13.22-184.72-19.74"
            ></path>
          </g>
        </g>
        <path
          fill="#28508c"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M152.234 84.595l.098-.068c1.842-.465 3.603-.91 5.223-1.321l-.058.058-5.263 1.331"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath11641)">
            <path
              fill="url(#linearGradient11649)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M7080.59 5349.05c94.41 36.86 176.88 79.62 247.76 128.5 52.55 13.28 102.86 26.01 149.2 37.74-34.03-33.87-72-65.45-114.08-94.81-88.02-22.26-185.18-46.81-282.88-71.43"
            ></path>
          </g>
        </g>
        <path
          fill="#242a55"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M162.586 60.052c-6.458 4.33-39.85 26.704-40.838 27.13-4.117 1.778-4.875 5.424-5.005 7.037 1.485-.38 5.422-1.324 15.439-3.49 15.133-3.274 24.324-9.228 28.096-18.199 2.983-7.1 2.647-11.001 2.308-12.478m-47.071 35.84l-.05-.808c-.003-.064-.306-6.428 5.783-9.058 1.12-.563 30.214-20.03 41.328-27.483l.58-.389.327.617c.09.17 2.15 4.265-2.045 14.247-3.943 9.378-13.426 15.574-28.99 18.941-14.104 3.051-16.084 3.662-16.161 3.688l-.772.244"
        ></path>
        <path
          fill="#242a55"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M162.305 60.719c-7.664 5.137-39.394 26.394-40.4 26.828-3.513 1.516-4.454 4.489-4.702 6.148 1.797-.446 5.887-1.406 14.895-3.355 14.997-3.244 24.095-9.12 27.814-17.963 2.623-6.243 2.634-9.96 2.393-11.658m-46.002 34.023l.045-.555c.127-1.59.893-5.492 5.243-7.37.94-.438 26.072-17.237 40.774-27.094l.478-.32.13.56c.398 1.732.626 5.688-2.33 12.721-3.826 9.1-13.108 15.13-28.377 18.432-10.088 2.183-13.995 3.122-15.424 3.488l-.539.138m46.709-36.013l-.215.143c-.4.268-40.006 26.82-41.37 27.508-5.82 2.515-5.569 8.62-5.566 8.682l.019.298.287-.091c.067-.023 1.888-.602 16.196-3.697 15.43-3.338 24.82-9.457 28.71-18.708 4.123-9.809 2.145-13.744 2.059-13.907l-.12-.228M115.15 96.424l-.08-1.315c-.005-.068-.329-6.705 6.021-9.447.969-.49 25.828-17.098 41.264-27.449l.945-.634.534 1.007c.093.176 2.237 4.433-2.03 14.586-3.997 9.506-13.572 15.778-29.272 19.175-14.209 3.074-16.104 3.671-16.122 3.677l-1.26.4"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath11663)">
            <path
              fill="url(#linearGradient11671)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6549.82 5239.35c53.91 49.95 101.93 105.86 142.95 166.66 194.35 118.25 325.42 243.37 397.67 379.93 130.07 86.89 254.94 170.45 348.66 233.21 12.76-24.11 31.56-44.96 54.54-60.84l-57.44-86.06c15.72 17.62 41.32 47.09 68.75 78.86 27.8-16.32 60.72-25.76 96-25.76.51 0 1.01 0 1.52.01-5.98-28.42-14.4-60.12-26.02-95.31 13.97 34.51 25.17 66.31 34.11 95.54 1.18.05 2.37.12 3.55.2-10.42-34.13-23.93-71.79-41.33-113.16-117.01-278.38-399.9-437.85-809.06-526.37-86.27-18.67-156.62-34.13-213.9-46.91"
            ></path>
          </g>
        </g>
        <path
          fill="#a7b4c8"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M145.027 71.045l.043-.12c3.82-2.552 7.503-5.016 10.513-7.031l.016.08c-3.034 2.032-6.737 4.509-10.572 7.07"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath11683)">
            <path
              fill="url(#linearGradient11691)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M7090.44 5785.94c13.14 24.85 24.34 50.08 33.61 75.71 108.72 72.62 213.69 142.84 299.68 200.41 3.05-15.12 8.28-29.52 15.37-42.91-93.72-62.76-218.59-146.32-348.66-233.21m486.01 44.11c11.62 35.19 20.04 66.89 26.02 95.31 2.71.02 5.41.09 8.09.23-8.94-29.23-20.14-61.03-34.11-95.54"
            ></path>
          </g>
        </g>
        <path
          fill="#242a55"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M140.438 74.017a32.2 32.2 0 00.245-.352l4.473-2.987a19.79 19.79 0 01-.086.247 7498.683 7498.683 0 01-4.632 3.092"
        ></path>
        <path
          fill="#242a55"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M140.683 73.665c.332-.49.642-.983.928-1.48l2.95-1.97.972-.649-.376 1.108-.001.004-4.473 2.987"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath11705)">
            <path
              fill="url(#linearGradient11713)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6692.77 5406.01c33.01 48.91 61.47 100.98 84.81 155.63 34.27 25.83 65.83 52.07 94.65 78.71 71.28 47.49 145.58 97.08 218.21 145.59-72.25-136.56-203.32-261.68-397.67-379.93"
            ></path>
          </g>
        </g>
        <path
          fill="#28508c"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M140.315 74.19c.041-.057.083-.115.123-.173l4.632-3.092-.043.12-4.712 3.146"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath11725)">
            <path
              fill="url(#linearGradient11733)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6872.23 5640.35c46.45 42.93 85.82 86.92 118.26 132.13 44.45 29.65 89.32 59.61 133.56 89.17-9.27-25.63-20.47-50.86-33.61-75.71-72.63-48.51-146.93-98.1-218.21-145.59"
            ></path>
          </g>
        </g>
        <path
          fill="#242a55"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M141.41 53.92c-4.917 6.304-23.189 29.71-23.822 30.27-2.472 2.193-2.293 4.898-2.018 6.198 1.137-.72 3.927-2.432 10.56-6.326 10.497-6.162 15.898-12.857 16.51-20.466.46-5.725-.606-8.55-1.23-9.676m-26.494 38.45l-.3-.757c-.019-.048-1.85-4.832 2.137-8.364.74-.755 17.713-22.473 24.19-30.776l.429-.551.503.483c.11.107 2.709 2.713 2.02 11.291-.647 8.05-6.25 15.067-17.128 21.451-9.907 5.818-11.183 6.733-11.194 6.743l-.657.48"
        ></path>
        <path
          fill="#242a55"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M141.334 54.663c-5.842 7.489-22.834 29.25-23.483 29.824-1.99 1.765-2.159 3.873-1.988 5.249 1.314-.819 4.151-2.543 10.066-6.017 10.378-6.091 15.715-12.684 16.315-20.155.388-4.817-.306-7.521-.91-8.901M115.3 91.029l-.119-.559c-.311-1.47-.448-4.278 2.143-6.576.594-.57 13.177-16.634 23.772-30.218l.368-.473.292.525c.676 1.219 1.742 4.125 1.279 9.9-.623 7.747-6.087 14.543-16.705 20.775-6.817 4.003-9.535 5.678-10.547 6.32l-.483.306m26.113-38.517l-.158.204c-.234.3-23.312 29.884-24.22 30.81-3.765 3.339-2.122 7.757-2.05 7.944l.109.277.244-.178s1.163-.854 11.227-6.764c10.759-6.314 16.297-13.229 16.933-21.14.673-8.378-1.795-10.873-1.9-10.975l-.185-.178m-26.677 40.482l-.49-1.234c-.082-.21-1.918-5.12 2.243-8.808.626-.64 15.142-19.188 24.14-30.724l.7-.897.82.788c.292.284 2.831 3.01 2.14 11.61-.658 8.188-6.324 15.306-17.322 21.76-9.838 5.778-11.147 6.71-11.158 6.719l-1.073.786"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath11747)">
            <path
              fill="url(#linearGradient11755)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6798.17 5614.26c34.48 96.78 53.23 200.66 53.23 308.73 0 4.61-.14 9.13-.28 13.67l-.21 6.24c-1.15 53.72-6.81 106.66-16.94 158.52 91.46 117.03 157.76 202.05 157.76 202.05s70.94-68.21 51.85-305.76c-2.87-35.53-9.24-69.95-18.8-103.4 25.39 56.15 41.09 115.15 46.09 177.46 17.21 214.04-38.66 290.58-49.89 303.63.9 1.15 1.35 1.74 1.35 1.74s70.94-68.2 51.82-305.76c-14.05-175.1-111.58-323.97-275.98-457.12"
            ></path>
          </g>
        </g>
        <path
          fill="#a7b4c8"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M134.591 61.627l-.028-.124c3.826-4.896 6.76-8.657 6.76-8.657s.024.024.068.075c-.397.508-3.216 4.121-6.8 8.706"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath11767)">
            <path
              fill="url(#linearGradient11775)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M7024.78 5894.31c9.56 33.45 15.93 67.87 18.8 103.4 19.09 237.55-51.85 305.76-51.85 305.76s-66.3-85.02-157.76-202.05a891.8 891.8 0 01-5.73 27.18c101.6 129.97 181.51 232.4 192.74 246.8 11.23-13.05 67.1-89.59 49.89-303.63-5-62.31-20.7-121.31-46.09-177.46"
            ></path>
          </g>
        </g>
        <path
          fill="#242a55"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M91.988 97.886c-.419.05-.848.14-1.274.271-.142.043-.437.134-10.997 1.382a9162.467 9162.467 0 01-28.79 3.337c.645 1.155 2.563 3.655 7.943 6.377 3.514 1.779 7.339 2.392 11.696 1.877 4.568-.54 9.614-2.315 15.424-5.423 7.107-3.804 10.128-5.342 11.36-5.949-.86-.822-2.719-2.185-5.362-1.872M58.3 110.376c-7.97-4.033-8.87-7.738-8.904-7.894l-.15-.682.694-.08c.176-.02 17.762-2.028 29.628-3.432 8.908-1.052 10.589-1.291 10.777-1.335.5-.152 1-.26 1.494-.317 4.389-.52 6.948 2.805 7.055 2.946l.485.648-.746.312c-.061.027-1.638.704-12.05 6.276-5.95 3.184-11.142 5.003-15.869 5.563-4.548.537-8.724-.137-12.414-2.004"
        ></path>
        <path
          fill="#242a55"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M51.595 103.198c.883 1.29 2.904 3.399 7.454 5.701 2.673 1.353 5.494 2.01 8.625 2.01h.002c.914 0 1.872-.059 2.843-.173 4.519-.535 9.518-2.294 15.283-5.38 6.31-3.376 9.398-4.966 10.843-5.69-.807-.65-2.138-1.429-3.889-1.429-.238 0-.48.014-.723.043-.396.047-.8.133-1.203.256-.184.057-.465.144-11.067 1.397a8629.205 8629.205 0 01-28.168 3.265m16.08 8.504c-3.26 0-6.198-.685-8.984-2.095-5.412-2.737-7.404-5.272-8.11-6.538l-.29-.52.592-.068c5.415-.62 19.063-2.186 28.788-3.335 9.438-1.116 10.756-1.315 10.926-1.368a7.72 7.72 0 011.344-.286c.272-.032.547-.048.815-.048 2.39 0 4.077 1.27 4.869 2.028l.41.392-.51.25c-1.14.562-4.131 2.08-11.348 5.943-5.855 3.133-10.946 4.92-15.565 5.467-1.002.119-1.99.179-2.936.179m-17.948-9.559l.056.252c.008.037.882 3.672 8.696 7.627 3.608 1.826 7.733 2.49 12.187 1.964 4.678-.554 9.823-2.36 15.73-5.519 10.115-5.414 11.907-6.216 12.078-6.29l.28-.117-.18-.24c-.087-.116-2.17-2.843-5.813-2.843-.289 0-.583.017-.877.052a8.182 8.182 0 00-1.423.302c-.397.093-4.24.57-10.847 1.35a9010.393 9010.393 0 01-29.138 3.377l-.749.085m18.01 10.812c-3.463 0-6.699-.748-9.616-2.225-8.147-4.124-9.078-8.002-9.113-8.165l-.246-1.11 1.624-.186c6.866-.785 19.78-2.269 29.136-3.376 9.467-1.119 10.61-1.299 10.734-1.328a8.766 8.766 0 011.535-.324c.324-.04.65-.058.97-.058 4.036 0 6.352 3.032 6.45 3.161l.789 1.053-1.215.51c-.064.028-1.755.769-12.016 6.26-5.994 3.207-11.231 5.04-16.01 5.607-1.02.12-2.037.181-3.022.181"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath11789)">
            <path
              fill="url(#linearGradient11797)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M4932.17 4702.62c-91.55.01-177.71 19.19-258.43 60.05-221 111.81-243.03 211.7-243.03 211.7s1.12.12 3.27.37c.17-.77 6.85-29.04 45.72-71.94 32.79 3.75 107.09 12.26 202.75 23.26 62.78-9.42 129.89-14.15 201-14.15 73.08 0 152.24 4.98 235.27 14.8 9.51 1.13 18.97 2.3 28.55 3.53 29.14 3.78 57.15 7.38 83.98 10.79 45.94-19.43 97.93-28.98 157-28.98 62.79 0 132.26 10.78 212.39 32.95 8.68 2.4 16.99 4.69 24.95 6.88-44.01-23.15-98.73-52.18-166.64-88.51-192.14-102.83-367.65-160.76-526.78-160.75"
            ></path>
          </g>
        </g>
        <path
          fill="#a7b4c8"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M50.127 102.333l1.509-.173-1.509.173"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath11809)">
            <path
              fill="url(#linearGradient11817)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M4479.7 4902.8c-38.87 42.9-45.55 71.17-45.72 71.94 6.19.71 21.01 2.4 42.8 4.9 62.01-24.46 130.76-42.35 205.67-53.58-95.66-11-169.96-19.51-202.75-23.26"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath11827)">
            <path
              fill="url(#radialGradient11837)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M4455.84 5006.53l-.05.22 33.83 3.88c8.9 1.02 29.83 3.41 60 6.86.2-.04.41-.09.62-.14-34.21-3.93-65.93-7.56-94.4-10.82"
            ></path>
          </g>
        </g>
        <path
          fill="#242a55"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M51.636 102.16l-.389-.157-.061-.025 5.611-.644c.294.047.59.091.89.132l-6.051.694"
        ></path>
        <path
          fill="#242a55"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M51.186 101.978l-.131-.054-.157-.712 3.33-.382c.831.195 1.688.363 2.57.504l-5.612.644"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath11851)">
            <path
              fill="url(#linearGradient11859)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M4883.45 4911.91c-71.11 0-138.22 4.73-201 14.15 135.78 15.61 314.65 36.26 479.06 55.49 21.57-16.46 44.76-29.95 69.74-40.52-26.83-3.41-54.84-7.01-83.98-10.79-9.58-1.23-19.04-2.4-28.55-3.53-83.03-9.82-162.19-14.8-235.27-14.8"
            ></path>
          </g>
        </g>
        <path
          fill="#28508c"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M51.637 102.16h-.001"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath11871)">
            <path
              fill="url(#linearGradient11879)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M4682.45 4926.06c-74.91 11.23-143.66 29.12-205.67 53.58 38.47 4.4 98.65 11.29 171.53 19.67 58.8-8.05 121.48-12.05 188.18-12.05 73.19 0 152.44 4.99 235.57 14.82 9.49 1.11 18.97 2.3 28.6 3.54 9.47 1.22 18.84 2.43 28.08 3.62 7.06-6.44 14.67-13.06 22.89-19.84 3.26-2.69 6.55-5.3 9.88-7.85-164.41-19.23-343.28-39.88-479.06-55.49"
            ></path>
          </g>
        </g>
        <path
          fill="#242a55"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M88.547 97.787c-.65-1.431-2.515-4.448-6.785-4.73-1.026-.067-36.658-9.106-45.812-11.432.18 1.467 1.155 5.1 6.118 10.537 6.182 6.774 16.118 9.248 30.375 7.562.33-.039.657-.08.99-.123 4.08-.528 7.526-.958 10.243-1.28 2.624-.31 4.081-.46 4.87-.534m.91 1.192c-.036 0-.92.036-5.632.593a958.32 958.32 0 00-10.23 1.279c-.337.042-.67.084-1.003.124-14.69 1.737-24.979-.869-31.454-7.965-7.04-7.714-6.491-12.109-6.465-12.292l.102-.692.677.173c12.493 3.174 45.183 11.448 46.394 11.603 6.393.42 8.18 6.31 8.196 6.37l.224.778-.809.029"
        ></path>
        <path
          fill="#242a55"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M36.443 82.16c.344 1.625 1.574 4.975 5.918 9.734 4.878 5.346 12.065 7.944 21.97 7.944 2.499 0 5.212-.17 8.066-.508.327-.039.653-.08.985-.123 4.107-.531 7.555-.961 10.248-1.28 2.124-.251 3.47-.396 4.304-.479-.767-1.413-2.575-3.756-6.198-3.994-1.007-.067-31.533-7.8-45.293-11.295m27.889 18.473h-.002c-10.14 0-17.518-2.684-22.555-8.203-4.925-5.396-6.01-9.055-6.218-10.755l-.071-.576.562.142c21.503 5.464 44.812 11.332 45.743 11.422 4.526.298 6.485 3.568 7.116 4.961l.23.508-.554.052c-.729.066-2.163.213-4.86.532-2.69.319-6.135.749-10.24 1.28-.333.043-.663.085-.993.123-2.884.341-5.629.514-8.158.514m-29.23-20.113l-.037.257c-.026.175-.542 4.398 6.365 11.967 5.13 5.621 12.62 8.355 22.897 8.355 2.55 0 5.315-.175 8.217-.518.334-.039.665-.08 1.001-.123 4.02-.52 7.463-.951 10.233-1.28 4.753-.561 5.63-.595 5.666-.595l.299-.012-.083-.287c-.017-.056-1.759-5.685-7.841-6.086-1.5-.19-46.016-11.5-46.466-11.613l-.25-.065m29.224 21.372c-10.513 0-18.195-2.818-23.483-8.613-7.157-7.843-6.592-12.426-6.565-12.616l.166-1.129 1.104.282C53.598 84.4 80.835 91.273 81.895 91.408c6.675.438 8.51 6.593 8.528 6.656l.364 1.265-1.317.046c-.01 0-.895.035-5.6.59-2.766.328-6.206.759-10.224 1.279-.34.043-.674.085-1.009.125-2.933.346-5.728.522-8.31.522"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath11893)">
            <path
              fill="url(#linearGradient11901)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M4833.72 5016.11c-273.77.01-490.7 69.82-641.38 234.94-52.5 57.51-89.7 108.15-116.03 151.47 35.12 17.78 63.2 46.09 79.33 80.38 63.34-16.07 149.28-37.85 246.37-62.41 140.01-97.69 325.39-170.78 561.65-221.89 74.92-16.21 137.75-29.98 190.41-41.67-31.86 3.42-62.75 6.75-91.81 9.9l-22.06 2.38-.09-22.18c-.03-5.48 1.91-47.57 62.25-111.84-1.82-.23-3.64-.47-5.47-.71-92.76-12.01-180.53-18.37-263.17-18.37"
            ></path>
          </g>
        </g>
        <path
          fill="#a7b4c8"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M44.975 83.263c-1.513-.382-2.907-.736-4.139-1.048l.002-.043 4.08 1.034.057.057"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath11913)">
            <path
              fill="url(#linearGradient11921)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M4402.01 5420.49c-97.09 24.56-183.03 46.34-246.37 62.41 8.99 19.11 14.27 40.09 14.98 62.12 34.92-8.85 74.44-18.87 117.31-29.72 34.03-33.87 72.01-65.46 114.08-94.81"
            ></path>
          </g>
        </g>
        <path
          fill="#242a55"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M50.14 84.527c-1.841-.465-3.603-.91-5.223-1.321l-.237-.24-.023-.023 5.048 1.276c.144.104.289.206.435.308"
        ></path>
        <path
          fill="#242a55"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M49.705 84.22l-5.048-1.277-.958-.984 1.362.345 3.193.808c.466.378.95.747 1.45 1.107"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath11935)">
            <path
              fill="url(#linearGradient11943)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5338.74 5137.19c-61.39 6.52-124.77 13.3-184.67 19.74-52.66 11.69-115.49 25.46-190.41 41.67-236.26 51.11-421.64 124.2-561.65 221.89 88.03-22.27 185.2-46.82 282.9-71.44 92.14-35.98 195.63-66.33 310.72-91.23 114.85-24.85 201.33-43.99 266.28-58.66 7.5-6.12 15.1-12.13 22.79-18.03 16.05-15.71 34.06-30.36 54.04-43.94"
            ></path>
          </g>
        </g>
        <path
          fill="#28508c"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M50.238 84.595l-5.263-1.332-.058-.057 5.223 1.321.098.068"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath11955)">
            <path
              fill="url(#linearGradient11963)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M4684.91 5349.05c-97.7 24.62-194.87 49.17-282.9 71.44-42.07 29.35-80.05 60.94-114.08 94.81 46.37-11.74 96.62-24.46 149.21-37.75 70.88-48.88 153.35-91.64 247.77-128.5"
            ></path>
          </g>
        </g>
        <path
          fill="#242a55"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M42.195 72.53c3.772 8.971 12.962 14.925 28.096 18.198 10.017 2.167 13.954 3.112 15.438 3.491-.13-1.613-.887-5.259-5.004-7.037-.989-.426-34.38-22.8-40.838-27.13-.34 1.477-.676 5.379 2.308 12.478m43.99 23.117c-.076-.026-2.057-.637-16.16-3.688-15.565-3.367-25.048-9.563-28.99-18.94C36.84 63.035 38.9 58.94 38.99 58.77l.328-.617.58.389c11.114 7.453 40.209 26.92 41.327 27.483 6.09 2.63 5.787 8.994 5.783 9.058l-.05.807-.771-.244"
        ></path>
        <path
          fill="#242a55"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M40.168 60.719c-.242 1.697-.23 5.415 2.393 11.658 3.718 8.843 12.816 14.72 27.813 17.963 9.008 1.95 13.098 2.909 14.896 3.355-.248-1.66-1.189-4.632-4.702-6.148-1.006-.434-32.737-21.691-40.4-26.828m46 34.023l-.537-.138c-1.43-.366-5.336-1.305-15.424-3.488-15.27-3.303-24.552-9.332-28.377-18.432-2.956-7.033-2.729-10.99-2.33-12.72l.13-.562.478.32C54.809 69.58 79.94 86.38 80.885 86.82c4.347 1.876 5.112 5.778 5.24 7.368l.044.555M39.46 58.729l-.12.228c-.086.163-2.064 4.098 2.06 13.907 3.889 9.25 13.279 15.37 28.707 18.708 14.31 3.095 16.131 3.674 16.201 3.698l.284.09.018-.3c.003-.06.255-6.165-5.544-8.67-1.386-.697-40.992-27.25-41.391-27.518l-.215-.143m47.862 37.695l-1.258-.399c-.02-.007-1.916-.604-16.124-3.678-15.7-3.397-25.275-9.669-29.272-19.175-4.268-10.153-2.123-14.41-2.03-14.586l.533-1.007.946.634c15.436 10.351 40.295 26.96 41.285 27.46 6.329 2.731 6.004 9.369 6 9.435l-.08 1.316"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath11977)">
            <path
              fill="url(#linearGradient11985)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5215.68 5239.35c-57.29 12.78-127.64 28.24-213.91 46.91-409.16 88.52-692.03 247.99-809.07 526.37-117.03 278.4-58.67 388.59-58.67 388.59l2.38-1.59c-6.84-15.62-46.49-124.66 52.62-369.58-69.8 211.56-24.39 297.48-24.39 297.48s244.48-163.94 510.43-341.59c72.24-136.56 203.32-261.68 397.65-379.93 41.02-60.8 89.04-116.71 142.96-166.66"
            ></path>
          </g>
        </g>
        <path
          fill="#a7b4c8"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M57.446 71.045c-8.802-5.88-16.912-11.317-17.817-11.923.02-.047.033-.07.033-.07s8.463 5.675 17.741 11.873l.043.12"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath11997)">
            <path
              fill="url(#linearGradient12005)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M4675.07 5785.94c-265.95 177.65-510.43 341.59-510.43 341.59s-45.41-85.92 24.39-297.48c-99.11 244.92-59.46 353.96-52.62 369.58 25.63-17.19 255.52-171.3 505.04-337.99 9.28-25.63 20.47-50.85 33.62-75.7"
            ></path>
          </g>
        </g>
        <path
          fill="#242a55"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M62.034 74.017l-4.63-3.092c-.03-.082-.059-.165-.087-.248 1.48.989 2.98 1.991 4.472 2.986.08.118.162.236.245.354"
        ></path>
        <path
          fill="#242a55"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M61.79 73.663l-4.473-2.986-.001-.003-.376-1.108.972.65 2.949 1.97c.287.496.596.989.928 1.477"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12019)">
            <path
              fill="url(#linearGradient12027)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5072.72 5406.01c-194.33 118.25-325.41 243.37-397.65 379.93 72.62-48.51 146.89-98.07 218.17-145.57 28.83-26.65 60.38-52.88 94.67-78.73 23.34-54.65 51.8-106.72 84.81-155.63"
            ></path>
          </g>
        </g>
        <path
          fill="#28508c"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M62.157 74.19l-4.711-3.145-.043-.12 4.63 3.092.124.173"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12039)">
            <path
              fill="url(#linearGradient12047)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M4893.24 5640.37c-71.28 47.5-145.55 97.06-218.17 145.57-13.15 24.85-24.34 50.07-33.62 75.7 44.25-29.56 89.1-59.5 133.55-89.15 32.42-45.2 71.8-89.2 118.24-132.12"
            ></path>
          </g>
        </g>
        <path
          fill="#242a55"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M59.833 63.596c.611 7.61 6.012 14.304 16.51 20.466 6.633 3.894 9.422 5.606 10.559 6.326.275-1.3.455-4.005-2.018-6.197-.633-.561-18.904-23.967-23.821-30.271-.625 1.125-1.69 3.95-1.23 9.676M86.9 91.89c-.011-.01-1.287-.925-11.195-6.743-10.878-6.384-16.48-13.4-17.127-21.45-.69-8.58 1.909-11.185 2.02-11.292l.503-.483.43.55c6.476 8.304 23.449 30.022 24.19 30.777 3.984 3.532 2.155 8.316 2.137 8.364l-.302.758-.656-.481"
        ></path>
        <path
          fill="#242a55"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M61.14 54.663c-.606 1.38-1.299 4.084-.912 8.901.6 7.47 5.937 14.064 16.315 20.155 5.916 3.474 8.752 5.198 10.066 6.017.17-1.376.002-3.484-1.988-5.249-.648-.574-17.64-22.335-23.482-29.824m26.032 36.366l-.481-.306c-1.014-.642-3.731-2.317-10.548-6.32-10.618-6.232-16.082-13.028-16.705-20.775-.464-5.775.602-8.681 1.28-9.9l.29-.525.369.473C71.97 67.26 84.553 83.325 85.15 83.897c2.588 2.295 2.45 5.103 2.139 6.573l-.119.559M61.06 52.512l-.186.179c-.104.101-2.573 2.596-1.9 10.974.636 7.911 6.175 14.826 16.934 21.14 10.142 5.956 11.244 6.778 11.25 6.783l.22.16.111-.281c.071-.184 1.714-4.602-2.031-7.922-.929-.945-24.007-30.53-24.24-30.829l-.158-.204m26.677 40.482l-1.071-.785c-.014-.01-1.323-.942-11.16-6.72-10.998-6.454-16.665-13.572-17.323-21.76-.691-8.6 1.848-11.326 2.14-11.61l.82-.788.701.897c8.998 11.536 23.514 30.084 24.16 30.743 4.14 3.668 2.304 8.578 2.224 8.785l-.49 1.238"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12061)">
            <path
              fill="url(#linearGradient12069)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M4967.31 5614.28c-164.38 133.14-261.92 282.02-275.97 457.1-19.1 237.56 51.81 305.76 51.81 305.76l1.36-1.74c-11.23-13.05-67.1-89.59-49.87-303.63 4.98-62.31 20.68-121.31 46.09-177.46-9.59 33.45-15.95 67.87-18.81 103.4-19.1 237.55 51.84 305.76 51.84 305.76s66.46-85.22 158.08-202.47a910.903 910.903 0 01-17.25-158.18l39.32-.81-39.35.18-.16-6.74c-.19-4.17-.31-8.26-.31-12.46 0-108.07 18.73-211.93 53.22-308.71"
            ></path>
          </g>
        </g>
        <path
          fill="#a7b4c8"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M67.895 61.645c-3.59-4.593-6.417-8.216-6.813-8.724.043-.05.068-.075.068-.075s2.94 3.77 6.774 8.675l-.029.124"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12081)">
            <path
              fill="url(#linearGradient12089)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M4740.73 5894.31c-25.41 56.15-41.11 115.15-46.09 177.46-17.23 214.04 38.64 290.58 49.87 303.63 11.24-14.41 91.35-117.11 193.14-247.31-2.07-8.98-4.01-18.03-5.81-27.09-91.62 117.25-158.08 202.47-158.08 202.47s-70.94-68.21-51.84-305.76c2.86-35.53 9.22-69.95 18.81-103.4"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12099)">
            <path
              fill="url(#linearGradient12107)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6480.67 5181.03c31.76 31.09 55.87 66.38 72.53 106.03 11.25 26.75 19.08 50.34 24.39 71.01 132.25 152.63 211.91 349.72 211.91 564.92 0 24.61-1.04 48.98-3.08 73.07-14.51 170.99-79.43 328.06-180.31 457.15.39.24.76.46 1.15.7-164.81 210.44-425.14 346.39-718.21 346.39H5887.08c-498.34 0-902.38-392.78-902.38-877.31 0-208.55 74.82-400.08 199.79-550.64 5.17-23.87 13.86-52.17 27.78-85.29 16.65-39.61 40.72-74.87 72.43-105.93-7.69 5.9-15.29 11.91-22.79 18.03a961.366 961.366 0 00-36.45 31.25 828.5 828.5 0 00-9.78 8.94c-53.92 49.95-101.94 105.86-142.96 166.66-33.01 48.91-61.47 100.98-84.81 155.63a914.187 914.187 0 00-20.6 52.64c-34.49 96.78-53.22 200.64-53.22 308.71 0 4.2.12 8.29.31 12.46l.16 6.74 39.35-.18-39.32.81a910.903 910.903 0 0023.88 188.79c.37 1.57.74 3.16 1.12 4.72a877.64 877.64 0 007.06 27.48c.27.99.54 2 .82 2.98a919.92 919.92 0 0039.15 112.46c26.23 62.11 59.1 121.04 97.77 175.91a957.824 957.824 0 0081.66 100.63 958.73 958.73 0 0020.71 21.6 971.691 971.691 0 00132.96 112.23 972.554 972.554 0 00132.62 78.13c10.78 5.26 21.65 10.3 32.66 15.17 87.74 38.78 182.55 65.18 282.14 76.73l3.38.4c17.07 1.99 35.62 3.6 53.36 4.65l3.16.19c19.57 1.13 37.95 1.68 55.72 1.68h1.94c2.87 0 5.7-.09 8.53-.22l3.07-.08c13.41-.21 26.61-.47 39.7-1.16 10.13-.52 20.21-1.38 30.35-2.22l5.68-.48c4.87-.37 9.75-.78 14.57-1.31 12.4-1.26 24.99-2.85 37.57-4.63l10.19-1.51c86.15-13.03 169-37 246.85-70.92 11.02-4.8 21.93-9.8 32.75-15a968.267 968.267 0 0094.33-51.98 960.765 960.765 0 00148.15-114.28c35.36-33.23 68.35-69.29 98.67-107.99l10.08-14.62 1.01-1.46 31.31-45.38c23.97-36.15 45.31-73.75 63.85-112.53 4.73-9.88 9.27-19.84 13.63-29.88a914.903 914.903 0 0044.35-126.49c2.47-9.16 4.8-18.34 6.98-27.57.38-1.57.75-3.16 1.11-4.73l.81-3.53a891.8 891.8 0 005.73-27.18c10.13-51.86 15.79-104.8 16.94-158.52l.21-6.24c.14-4.54.28-9.06.28-13.67 0-108.07-18.75-211.95-53.23-308.73a857.03 857.03 0 00-4.15-11.4 925.62 925.62 0 00-16.44-41.22c-23.34-54.65-51.8-106.72-84.81-155.63-41.02-60.8-89.04-116.71-142.95-166.66-3.25-3.01-6.49-5.97-9.78-8.94a978.31 978.31 0 00-36.44-31.25 980.81 980.81 0 00-22.93-18.13"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12117)">
            <path
              fill="url(#linearGradient12123)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5886.88 6743.04c-465.41 0-844.19-367.85-844.19-820.05 0-452.24 378.73-820.17 844.39-820.17 463.91 0 842.75 366.48 844.45 817.09l.06 2.6c0 180.94-59.26 352.22-171.35 495.63l-29.18 37.39c-151.01 171.74-367.2 275.46-600.22 286.47l-2.3.11c-6.18.28-12.33.51-18.44.65-2.58.07-5.04.1-7.45.1l-8.11.13c-1.78.05-3.59.05-5.49.05h-2.17"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12133)">
            <path
              fill="url(#linearGradient12139)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5464.92 5318.82c-84.01 56.1-174.01 116.33-249.39 166.88l-18.44 12.36-10.38-19.61c-1.76-3.31-10.65-22.21-8.55-61-106.89 131.94-175.69 294.42-190.27 471.79 55.89-48.51 116.85-92.49 182.14-131.29 40.73-170.16 143.85-316.99 284.67-416.48 3.02-7.63 6.43-15.17 10.22-22.65m835.63 0c2.39 4.71 4.62 9.45 6.71 14.22 149.32 101.08 258.3 254.57 298.76 433.1 65.04 39.74 125.66 84.67 181.09 134.12-12.95-186.92-86.09-357.81-200.72-494.48 4.78 46.71-5.7 69.04-7.62 72.67l-10.39 19.61-18.44-12.36c-75.39-50.55-165.38-110.78-249.39-166.88"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12149)">
            <path
              fill="url(#linearGradient12155)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5170.03 5757.95c-65.29 38.8-126.25 82.78-182.14 131.29-.73 8.84-1.32 17.77-1.78 26.68 9.81 196.46 86.04 375.97 207.33 517.73 38.89-22.13 79.23-42.43 120.88-60.79-102.26-122.93-163.53-279.47-163.53-449.87 0-9.33.19-18.62.55-27.87 1.71-47.01 8.09-92.89 18.69-137.17m1435.99 8.19c11.29 49.84 17.25 101.64 17.25 154.78v2.07c0 171.56-62.1 329.06-165.62 452.37 41.54 18.54 81.76 39.02 120.52 61.32 122.71-142.12 199.93-322.67 209.9-520.37-.27-5.36-.6-10.71-.96-16.05-55.43-49.45-116.05-94.38-181.09-134.12M4984.7 5922.99c0 484.53 404.04 877.31 902.38 877.31-496.68 0-899.66-390.23-902.31-872.56-.04-1.58-.07-3.16-.07-4.75"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12165)">
            <path
              fill="url(#linearGradient100526)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5314.32 6372.86c-41.65 18.36-81.99 38.66-120.88 60.79 165.45 193.36 414.74 316.45 693.7 316.45 277.47 0 525.59-121.81 691.03-313.42-38.76-22.3-78.98-42.78-120.52-61.32-134.81 160.58-339.88 263.18-569.61 263.47h-1.06c-231.32 0-437.7-103.73-572.66-265.97"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12181)">
            <path
              fill="url(#linearGradient100528)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6606.11 6453.21c-164.66 210.7-425.04 346.83-718.12 347.09h1.06c293.07 0 553.4-135.95 718.21-346.39-.39-.24-.76-.46-1.15-.7"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12217)">
            <path
              fill="url(#linearGradient100530)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M4986.11 5915.92c-.43 8.51-.74 17.02-.92 25.59-.05-4.61-.3-9.18-.42-13.77 2.65 482.33 405.63 872.56 902.37 872.56h.83c-294.89-.34-556.64-138.22-721.03-351.17 8.76-5.25 17.59-10.42 26.5-15.48-121.29-141.76-197.52-321.27-207.33-517.73"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12233)">
            <path
              fill="url(#linearGradient100532)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6786.42 5996.06c-14.51 170.99-79.43 328.06-180.32 457.15h.01c100.88-129.09 165.8-286.16 180.31-457.15"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12251)">
            <path
              fill="url(#linearGradient100534)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6788.07 5916.31c-9.97 197.7-87.19 378.25-209.9 520.37a1289 1289 0 0127.93 16.53c100.89-129.09 165.81-286.16 180.32-457.15 2.04-24.09 3.08-48.46 3.08-73.07 0 6.19-.37 12.33-.53 18.52-.18-8.43-.48-16.83-.9-25.2"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12267)">
            <path
              fill="url(#linearGradient12275)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6606.1 6453.21c-164.64 210.68-425.05 346.81-718.13 347.09h.02c293.08-.26 553.46-136.39 718.12-347.09h-.01"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12285)">
            <path
              fill="url(#linearGradient12291)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5193.44 6433.65c-8.91 5.06-17.74 10.23-26.5 15.48 164.39 212.95 426.14 350.83 721.03 351.17 293.08-.28 553.49-136.41 718.13-347.09a1289 1289 0 00-27.93-16.53c-165.44 191.61-413.56 313.42-691.03 313.42-278.96 0-528.25-123.09-693.7-316.45"
            ></path>
          </g>
        </g>
        <path
          fill="#f7ef43"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M101.39 98.525c-17.355 0-31.457-13.507-31.818-30.297-.002.218-.017.435-.017.653 0 17.096 14.254 30.953 31.834 30.953 17.582 0 31.835-13.857 31.835-30.953 0-.218-.013-.435-.018-.653-.36 16.79-14.463 30.297-31.817 30.297"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12303)">
            <path
              fill="url(#linearGradient12309)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5994.94 5253.83a190.308 190.308 0 01-23.16 14.58c26.02 3.7 51.54 9.02 76.41 15.84-6.79-8.64-13.32-16.94-19.53-24.83a745.12 745.12 0 00-33.72-5.59m-222.94 1.06a752.927 752.927 0 00-36.77 6.56c-5.87 7.45-12 15.25-18.38 23.36a617.084 617.084 0 0177.17-16.23c-7.66-4.06-15.02-8.64-22.02-13.69m551.95 130.98c1.95 9.79 3.33 19.7 4.14 29.73 1.03 12.82 1.5 24.66 1.51 35.58 108.23 111.75 174.82 264.02 174.83 431.88-.01 101.44-24.33 197.18-67.47 281.74a741.332 741.332 0 00101.4-48.39c26.64-74.02 41.12-153.6 41.12-236.46 0-101.8-21.85-198.63-61.22-286.29-50.14-81.1-116.34-151.76-194.31-207.79m-883.78 7.38c-1.33.99-2.65 1.98-3.98 2.98a704.453 704.453 0 00-6.49 63.11c2.05-2.2 4.1-4.36 6.18-6.53-.03-11.36.43-23.75 1.51-37.21.61-7.52 1.53-14.97 2.78-22.35m1183.1 528.56v0m-735.52 717.02H5887.03 5887.75"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12319)">
            <path
              fill="url(#linearGradient12325)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6518.26 5593.66c39.37 87.66 61.22 184.49 61.22 286.29 0 82.86-14.48 162.44-41.12 236.46a740.396 740.396 0 0068.9-44.8c-70.29 323.68-365.46 566.75-719.22 567.22 406.15-.51 735.23-320.88 735.23-715.84v-1.18-.1c-.02 6.67-.26 13.22-.47 19.8-3.71-127-41.39-245.7-104.54-347.85m-630.51 1045.17h-.71H5887.75"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12335)">
            <path
              fill="url(#linearGradient12341)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5151.34 5895.12c-.36 9.25-.55 18.54-.55 27.87 0 170.4 61.27 326.94 163.53 449.87.02-.01.05-.02.06-.03-102.27-122.93-163.51-279.44-163.51-449.84v-1.34-.73c0-8.64.16-17.23.47-25.8"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12351)">
            <path
              fill="url(#linearGradient12357)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5314.38 6372.83c-.01.01-.04.02-.06.03 134.96 162.24 341.34 265.97 572.66 265.97h.05-2.84c-.28-.01-.54-.01-.81-.01h-1.23c-.16-.01-.32-.01-.47-.01h-.76c-.17 0-.32-.01-.5-.01h-.73c-.17-.01-.33-.01-.5-.01-.24 0-.49 0-.73-.01h-.51c-.25-.01-.49-.01-.74-.01-.15 0-.31-.01-.46-.01-.27 0-.51 0-.78-.01-.15 0-.32 0-.46-.01-.25 0-.53 0-.78-.01h-.44c-.27-.01-.55-.01-.82-.02-.14 0-.27 0-.41-.01-.27 0-.59-.01-.86-.01-.12 0-.24-.01-.36-.01-.32-.01-.62-.01-.94-.02h-.28l-1.12-.03h-.09c-2.1-.05-4.17-.1-6.26-.17h-.04c-.42-.01-.8-.03-1.22-.04h-.04c-.39-.01-.79-.03-1.18-.04h-.12c-.37-.02-.76-.03-1.13-.04-.04-.01-.08-.01-.12-.01-.37-.01-.75-.03-1.12-.04-.05 0-.08 0-.13-.01-.4-.01-.78-.02-1.17-.04h-.02c-.4-.02-.83-.03-1.22-.05h-.04c-218.52-8.94-412.41-110.52-541.22-265.36m573.66 266h-.29.29"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12367)">
            <path
              fill="url(#linearGradient12373)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5436.19 5396.23c-168.24 127.06-278.28 323.57-284.7 545.28-.26-6.6-.6-13.17-.62-19.86v1.34c0 170.4 61.24 326.91 163.51 449.84 128.81 154.84 322.7 256.42 541.22 265.36-203.24-8.31-385.21-96.78-513.28-233.78 131.4 118.72 307.38 191.34 500.97 191.34 147.63 0 285.13-42.27 400.37-115.01-9.87-13.54-26.2-36.05-45.28-62.43-3.01 1.77-6 3.5-9.04 5.22-90.21 52.12-194.92 81.95-306.58 81.95-151.63 0-290.43-54.99-397.53-146.1-136.06-113.9-222.6-285-222.6-476.32 0-163.8 63.44-312.78 167.07-423.72 1.22-21.3 3.41-42.35 6.49-63.11m1102.17 720.18a741.332 741.332 0 01-101.4 48.39c-51.76 101.46-130.6 186.81-226.98 246.5 15.2 28.65 28.16 53.14 35.96 67.99 134.5-85.6 238.44-212.83 292.42-362.88m-682.72 521.78c.39.02.82.03 1.22.05-.41-.02-.82-.03-1.22-.05m1.24.05c.39.02.77.03 1.17.04-.39-.01-.78-.02-1.17-.04m1.3.05c.37.01.75.03 1.12.04-.37-.01-.75-.03-1.12-.04m1.24.05c.37.01.76.02 1.13.04-.38-.02-.75-.03-1.13-.04m1.25.04c.39.01.79.03 1.18.04-.39-.01-.79-.03-1.18-.04m1.22.04c.42.01.8.03 1.22.04-.41-.01-.81-.03-1.22-.04M5869.5 6638.63l1.12.03-1.12-.03m1.4.03c.32.01.62.01.94.02-.31 0-.62-.01-.94-.02m1.3.03c.27 0 .59.01.86.01-.28 0-.58-.01-.86-.01m1.27.02c.27.01.55.01.82.02-.28-.01-.54-.01-.82-.02m1.26.02c.25.01.53.01.78.01-.27 0-.52 0-.78-.01m1.24.02c.27.01.51.01.78.01-.27 0-.52 0-.78-.01m1.24.02c.25 0 .49 0 .74.01-.25-.01-.49-.01-.74-.01m1.25.01c.24.01.49.01.73.01-.23 0-.5 0-.73-.01m1.23.02h.73-.73m1.23.01h.76-.76m1.23.01h.76-.76m1.23 0c.27 0 .53 0 .81.01-.28-.01-.53-.01-.81-.01m1.23.01h.89-.89m1.24 0h1.19-1.19"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12383)">
            <path
              fill="url(#linearGradient12389)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6607.26 6071.61a740.396 740.396 0 01-68.9 44.8c-53.98 150.05-157.92 277.28-292.42 362.88 4.54 8.64 7.34 14.02 7.81 15.06v.02c-.1 0-3.78-4.99-10.09-13.63-115.24 72.74-252.74 115.01-400.37 115.01-193.59 0-369.57-72.62-500.97-191.34 128.07 137 310.04 225.47 513.28 233.78h.04c.4.02.81.03 1.22.05h.02c.39.02.78.03 1.17.04.05.01.08.01.13.01.37.01.75.03 1.12.04.04 0 .08 0 .12.01.38.01.75.02 1.13.04h.12c.39.01.79.03 1.18.04h.04c.41.01.81.03 1.22.04h.04c2.09.07 4.16.12 6.26.17h.09l1.12.03h.28c.32.01.63.02.94.02.12 0 .24.01.36.01.28 0 .58.01.86.01.14.01.27.01.41.01.28.01.54.01.82.02h.44c.26.01.51.01.78.01.14.01.31.01.46.01.26.01.51.01.78.01.15 0 .31.01.46.01.25 0 .49 0 .74.01h.51c.23.01.5.01.73.01.17 0 .33 0 .5.01h.73c.18 0 .33.01.5.01h.76c.15 0 .31 0 .47.01h1.23c.28 0 .53 0 .81.01h3.85c353.76-.47 648.93-243.54 719.22-567.22"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12399)">
            <path
              fill="url(#linearGradient12405)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6012.64 5239.1a193.52 193.52 0 01-17.7 14.73 745.12 745.12 0 0133.72 5.59c-5.61-7.12-10.97-13.91-16.02-20.32m-259.8.01c-5.53 7.01-11.42 14.48-17.61 22.34 12.14-2.48 24.42-4.67 36.77-6.56a190.717 190.717 0 01-19.16-15.78m554.42 93.93c7.53 17.22 13.08 34.81 16.69 52.83 77.97 56.03 144.17 126.69 194.31 207.79 63.15 102.15 100.83 220.85 104.54 347.85.21-6.58.45-13.13.47-19.8v-.79c0-53.14-5.96-104.94-17.25-154.78-40.46-178.53-149.44-332.02-298.76-433.1m-852.56 8.43c-140.82 99.49-243.94 246.32-284.67 416.48-10.6 44.28-16.98 90.16-18.69 137.17-.31 8.57-.47 17.16-.47 25.8v.73c.02 6.69.36 13.26.62 19.86 6.42-221.71 116.46-418.22 284.7-545.28 1.33-1 2.65-1.99 3.98-2.98 2.99-17.65 7.82-34.9 14.53-51.78"
            ></path>
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M97.115 39.965c1.483-.112 3.009.452 2.268 1.096-.741.644-5.749 3.534-7.937 1.748-2.187-1.788 3.924-2.71 5.67-2.844"
        ></path>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M79.89 47.835c-4.638 3.902-8.384 11.112-8.29 15.325.093 4.212 2.345-2.397 3.506-4.793 1.162-2.397 6.973-9.708 11.185-11.922 4.211-2.214.853-4.711-6.4 1.39"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12443)">
            <g transform="matrix(246.2 0 0 207.2 5317.9 6888.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAArCAYAAADVJLDcAAAABHNCSVQICAgIfAhkiAAABSVJREFUaIG9mdu64yYMhZfcPE2v+5R95hr1Ah2WBHacyexhPk8SjIV+dEB4y9///KuQA4AAIvMTgtkH6r9pqgAU0OEd9pv6dUS/6ml9857qADDv6zgBzD7FgOI/qN/DiWFjD53jIC4XOKbyqCDRNiBy0dcXoDzLCwVI3Pehfd4inO4JxMaqy9YceVRBDsaW6hCkaL8fzzZlhGQvcJJ3tA4jBKy9QF/UI+/vVpu/b6y2WO7h93duW0a7BWReXV+SdSyT9ZW9dYGm3GKdneL3v1crPAfvPnEx4SftV57dWf3zdgHzE+3OArvRnwP9QRh9P+TLdgHzzcTPntUyTttz2u4/a8eiQGx8/rtPtKo1x3BX2zz7+Ftpd5D37Uj5XaEnSjSQ5Zmd7A7/UFnRefXnSNZRV94HjDqpUmnC1wLSSxpX/gpIK47UYVb8rNYK0XUhXrHtqm42T3swSoeLVVxcscNuXNFll0XaCkdZGPsUl0fqHqsybB2fdFy4kFti88wWYsrRMpem5YtH+CUBPT8YoltGR9Zi8R35G7C+3eq6Tpw0BvV11yNAbS4GD36NT7ZKumK3Skp45QQGEu7mVZ9gyXB7ohTs45VB2CqbWJRch5Rm4+XCjVt7ZVygAb2rqVgwTaAMVF1XMchlCUznWcWBq1Wu5NMiFBgfG0CSMkp9zh27DMMTNt8vcce/q1W0Q6hhy4wXwbw6yIThOAmFqJjWBiEEX750qzDcKFbwYN5aRXQOwTxpFheT5pY9ASgUsgt8ofMDxIRKe54t0oAoEWixhGcsOkrH+iiN8VsKFbWjtQf/jWVUDgJipX1FjqZ0az1bUSKoIGYJWl0//7uy899YA9+zmLQ5KsxcCbXtV+K1wDfZTC3YewwNAzHF9QTvOw6SMqpVwqIbq0yYks1moInSC4eyAl1CW52IDaCkZ0/LbB2cDTaz3y5WRK8DP2F0IE96M60oEK6Vh6RWODWgPYTmypfdfYTbVvc6I1Go9ljJ11FX7v5SixXxvUU9EQxS9eYlRK/LSjp2kOxji/Q4Kc9LKi4lfi7iFmEZWMwAgpMyGaVjvYChbMTxMReeShtBxMjOItEnWScrBsSu3Sa5wrgLGEBCuYbSPq9gYudYIIABHZlytyBwkBl3Jeh7ZruCUZtQ8BdyjzjIvdwqehP+bb+hTVN7Wg53ayBYQcIqlBxuYTwY1TKa4EAGqAEZxrU4zYWwDKghg60xfysDuGv1gMeY3hGp+AGMTyKWrGbAioEJZmnjK96eLqaytDx8oDYIt8qIYM8YGRuQ8RHIhMGAQJBQfnYxx9qc6KIVNyYAthTYtUa9v4mRCjIegwDmZmquxFCwHmzetm8bnyCF9550qTksM1bEzg7kQcAvMJHfw6U8m0m63KPGKdlR2q6uoPjgWBpW2jPIkxKqw0Q2O2hyaVe23WmmwjR380wnFDOcJJZgf5a59jAtZvINjV8OdwUBGqMLAEOpZKkSEG6JD4N9DyNuziMcbE7ou3/8d9FapmsAEwIFolgDDPHrIBPGd38Ztr654zPcuxbBXwB2ELpa40uIgJkHIyv31bOXmI+zTe5faNQ8YQCSlcF0KbbA77FGgTn0nH/stLoswExDBeyPor1Wo2Im9iJ2uTzixjlkuX5vewGnlTBiZZgfmbPoVGWI3lIpoeNAACwvIPQ+BL9or0lwxuYo5Gp80NSL88z6zncDUD5/rr3qZF6+9F1f3mRMT8VALzh/GoDba1GKzRFpWa9dnC1Sfv/59j9NVfbf+3Y1WAAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12455)">
            <g transform="matrix(202.2 0 0 174.2 5346.9 6893.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAkCAYAAAD/yagrAAAABHNCSVQICAgIfAhkiAAABTtJREFUWIWtWG2yA7cNAxRdp0fLFXuyiOgPfkq203YmO/PG+7SyBIIExDX/9ee/BRIgIeLnJRIQIACQIAgwQBBMPmYSYP0pCSfHzMBjoAQeA0x1Twn864BmgB3QBOj4uB3g/IVtJEgCfED9BAwAhACIAkUEfICEMUDnGupnWARO3Mc8EBDiGZavrFNLigDXwm5QN9hafIL0JZ3NmG9xbwScWsDWAsyfOChnvwIlQcoJIUGp5okE1gJlFaQIbAQfIkDyA6tvzIieRVB9khAEyUtHVLFhUU6KjWV0xgIg2ACbnPzz7xIEDdg2AUoO6k19RoYARQeen8WUYoNnjiLFXMvnHBuogoBFQGzMzIw64KWoN4/+qavEScJiHuBZ1PJ0iykwX8NID4gs4QEA1orMJfNj/SqRZjLrMO+3F/7K2GoCR/pyIMQNBliDZ8I8HY5J8gCCXcvSN4taxJV6ZY1mhlJnOSXqflmmSGiG6PcFgAks2Y2MhbqLRbRjZDBvZjBAqQC3qKgRSGQGi9ga6CHgfBG/YgGNNJXyY2OLYK55GGvlBgnqZTgmK7UlDfsDtsFFkmJLU7+8VCp2VH9tVBnMknDQorsCTgtK9yjAAmTuFtN1qhZ9t62xpM2JpeY4teCpzjr1iN06Pc0tHg1QxVCuqbbCaU1MUMXYzcz2jRRK/UyZyppmSgNwHIOHhGQRWNhjlMR1BYgUSI9zpBy1zsoIGKlHsFWnx2pmryUDVArF656QWTGVpZueyqR8eC4QYOv/afiqPkAjw3sKhDVX5a1TvcxnffjgyE+P3KBiStvJoreOwJUcDJoeNho4M0trdeoPgBW1uAaDU8FXfSaDc+1Q8/yCCzU3/lUOAk0FrBxiXDubihSBrfWxFhC2NcfTbebkmdpjn6DUgGkfLttzNJ6F+2yNOUaXsdbrpEMAH8esBtXo+xHIBapqNQDpBZxg/TOx7PAdXJ6QoL4AxstELJgm/YvFOzBFECOQBD8dm92k7DiUvU7euvvBIqeavly3ojHmRi2ae4YoEPe8ti4NLMTu4yoWWsTb4WfqPjr/yeQX8mlWG3Mymt+1Oda1WY30uDbeQYso37RP4fB5kN+bYro8Mw5qS/f1PyZYqa1srglAdA/aNIP++KNqoeiedTrTfDHRY02MqtnweQHKmskbWNasjXZv4b02APCcaqf4YMBRBJB96qPuh0HGxnkiTbBQvIlO8SToWfejcW6gpSW1U/y3tI9gLmE9npqdUS5SoOXmXqWQbAJ3GY7bXewkG8FiNbUXYN/sYjfTDVUrRWQarcAmi3cnNa3pg8TelsTmOd695IvXZAptuDPllaow70o3DDAvpbHNA8rP8E73LcJfvynsbEB4joN96C9PfBppDgCp4Cm0YiqAJPuVcpvi+eZtD1BIjSFPncVqpqscrhOnN80u3EsCXZMjrRVEHpk5lvv9SDmG+jdlwPH3akreOllohtluP6YtIF+O5ilUvyvhHkv2JsuQ3QC/WFLRQmDzmIO0+NbBZ12+Sv/S9N6pxqPwwW6x+B3YPDbntV2RPai1wPOaaT7j1QlV71nd0m1BbjvodD8NzS9QAD4scvsibUXtAp/nPfOXhQDlu4XlWJ7TaJApmAA/fwH5O1B3MNHmrSNo9cb53lMsX118gMnYNMbST836vecqEf7PoL5dG3bqJV91hM6i1Kin3ngZbnarkzIvHclB/dj870B9C2a3lwE8cFDvPAsDr5Sz6w/A1Z7lvAHk/wUVX7p6480PL3Nzn5OuRqUs7LGsfxDUjQcAif8Af0XQa+NWyoUAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12467)">
            <g transform="matrix(183.2 0 0 111.2 5346.9 6922.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAXCAYAAABnGz2mAAAABHNCSVQICAgIfAhkiAAAA1hJREFUSIltV1tyxDYMA2j3/kfo5XqMiOgHn3LimUy00loEARLS8p9//5MIgAY9AASAxH78ISjFByHGEuiCCNBjDAE8Du614/HnHt87nt/VvfZzYDmGhFcdXoATem9QQASOQfwXY9igBMhyDgQ89os1AaxkBZAQBFOsyQiKgBGSdcIvDBCZLwMoZja+3LPYkhEyLSAemDtL5XhYhsd7gEARQoI4wZ5IcDaAwfeOs1BAZMGMLACKAORFXqIFlMhCMgR4Ev4kG1UOWjE+qtQ7MMJaKkVNVKD6o5eUQmi0kkipxJAITEAPPiCmBGIQ+wWQlNcYDOY7l5Q1qVVPSRHoW1ZljwhKaWJOLYeqOtxjvJIFQ9qu3e8j4f0lXxY2BPgTAFn1kqQxa2Ien27lamwLhNVpf0qoZDAbRCRI4qXnZg9WsJjjyY+GC391XGVf7HWDfOu2+sk9miAZFNVM8kR91mMyBSuehbv8qrM6Ghqp6WJhLOFqILVnTePMe8HgyDaxGEm58Ea6SlrDY6IlNj9bQkQdlXS15kgLKfDJxDbfJScV7E38SjzWV41lhxTq71PgC6BxCp+6QeAG0dIvias5WuqqtepKejaeTZHrcldk+08QMbu0sq1Ni0mfI+mSuGqp5auxWtKxCyUgMerhuSw8sj/rCAovmY18giTxLWWdj/gEr2OH5xNHnvE8pSxHT6k6QA9GRgiA+Zrea7vmvK0gOu422/HJYG3KrKWsg1Qbw5LxM5FylOcF/Z5+pWFon7sF/viA8SWpCzynA8gSWAWp8/DCkd9vRpfS9Ng0uvgLYtmGxqN4HHbGrzZ5XW+8ulKgh0/oYxf1ctVZv6MCgU8Be7KyWFoAGngxXP5ZTAN44enafUNYLD1feOvMxCr8AiGPjm4/rvrzZNfHNroBTnQwAFjJRbxW7vzYdR8CAP4s9i66M2jfr/4AIa2uDFB2vL0s9lknQFH1NVge/1vCYqiyKYYE4GcMsa7TxURdiQo4+3uI29NZ878vzXjhDjIMqiU0u4sdsdFtqFOszWJ14porv+K6rfa5nBYi+43sLRnU9/KUI3Id5vYRs7Lc0m6/mh8cC4TXOeu/AX1+AL38SbO0ZWK33LPBV440WGYNUbjlhG6Ji7U/gHTOGet/r6hI7ciG6gUAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12479)">
            <g transform="matrix(183.2 0 0 112.2 5365.9 6955.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAXCAYAAABnGz2mAAAABHNCSVQICAgIfAhkiAAAADdJREFUSIntzjEBADAMw7Cu/DlnCHb4Wg4LgU6STKH9HXgxRhmjjFHGKGOUMcoYZYwyRhmjamMXCD4EKmWwzxMAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12515)">
            <g transform="matrix(126.2 0 0 140.2 5269.9 6989.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAdCAYAAAC0T3x2AAAABHNCSVQICAgIfAhkiAAAAehJREFUSInNlk2S3SAMhLsZzpJNbjf3D50FkhACMplNKlS5MLLoD/3Y7/HHz0+RDUDDnAmwAWwgCaABnDb6M2DafYSN2xRDQCdo4tgheEGYBA1AFvVCotDdifwIEfpmf/aEuA/KfR1Ej2iUxEMUaZ3F0lxhj9z1M5q0mQ1ErUmG5dq8ovGIjmhWvRiiXot2gdya4hzWDC6cTlcLnGsUqfpT59ksTdAqanJybI4mNuerAG7NYLYGlSgKcI+mwtaxDgh3W0+uZVNNXV6/Whw4OpAFVHH3NBSf6ne8uMu/rUWpTwUfBykddoWs0d5v898IfLF3A/2j8R+B7IV7PPwGKITWJh0Cpw80Lgd6g9tT6LbWzfbFHrO15+N6wm1ts8a8d5iU/NIloe0dquKMXfB2gLwvHypfiBrtxlmlG/AVlcPGvXkkdGGAIkBh/dSaKF2YU8S/bXGPtQbMpiusQ7CWmFFQJsy05jAnLYhkHwY/YAJeRttCroWsqYo0j33ervvoEYmdThKIGlVKVWR4zO+ga0dTVYP9wq50WXpcHANQAzAgthO2cm7gAqAyB92LLsl0PCUTOh0vsGgKAsr/7bx5cuKEPsVmwSXYXy9YCr3wN1gWNNXwvXadp4qY979AfFiUOGH2ChDtW133G5MzDbY6B2tcAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12527)">
            <g transform="matrix(54.2002 0 0 29.2002 5317.9 7066.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAGCAYAAAAVMmT4AAAABHNCSVQICAgIfAhkiAAAAGJJREFUGJVVj9ENQyEMxOxrxulOXfLNR/oRqGgkFCHZ3OH787TKOSj9uu7XVCskoBBmb7AFEQSVOnbnQCPcYEdAainJQC1wJP4lhSLSO/oHASthh4wE1KnQu8K6PjbxzGPAF8ANE7yArWGuAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12539)">
            <g transform="matrix(40.2002 0 0 68.2002 5307.9 7027.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAOCAYAAAASVl2WAAAABHNCSVQICAgIfAhkiAAAAINJREFUGJVdj9sNAzEMw0jjxuk6HbMrnvrhxPcwEMh2CCnx8/3FKlQsKYWt3QragJJaCqhUpMtLhHZodZb7ZEipbcCy7zimipU13HXXUbwWrc70ADKa2T2AO7SxCpAEEjxbc1HtkIf9rQlUNp432NNBgunRgCek+ichHXEuIDeXrLf8AWJSPmScdqenAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12551)">
            <g transform="matrix(39.2002 0 0 68.2002 5312.9 7027.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAOCAYAAAASVl2WAAAABHNCSVQICAgIfAhkiAAAAKJJREFUGJVdkMFxAzEMAxcgnQLSbyp0SR4f8qCkc6KfSAgLSN8/z5QgElggIYlXGUm0BG+beBbRLUKiY4OEgVcXANhcW/AuL3sDg4o0jha9l1n8jQC4qmjWSZmNGxFE0OmaAYBvh2iynJDxEgWuR51Zx/8yrLDb8c7gu8lxDDSemgok4fp6rIACFuIPJgF0Ag9CPh80dyBBQKN5pUBc5KMqFr+cST5OM2S5igAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12563)">
            <g transform="matrix(59.2002 0 0 63.2002 5312.9 7032.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAANCAYAAACdKY9CAAAABHNCSVQICAgIfAhkiAAAABlJREFUKJFj/P///38GEgATKYpHNYxqwAMAA4IEFqSpB/UAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12575)">
            <path
              fill="url(#radialGradient12585)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5213.29 6845.63l5.1 7.65.7-1.12c-2.06-2.32-3.99-4.5-5.8-6.53"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12595)">
            <g transform="matrix(78.2002 0 0 92.2002 5211.9 6845.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAATCAYAAACZZ43PAAAABHNCSVQICAgIfAhkiAAAAI5JREFUOI2d0csRgCAMBNBdJv33Yg2OdcUDIAIBAnvD4eWDvO5HYYXDQxUZozmsCxzAnNCP6sUE+K2wgQCACiA+nfjwH9aR7ksLf92shDG0Oy4mWHds+4r1MB5YCjjGbKHmoy4fcQzLBIfQKNDvpyGhyZZyCo0J9iAAECEWOIHKeF2UPsi0aoY5i99YQysvdlUnoahHycIAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12607)">
            <path
              fill="url(#radialGradient12617)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5478.4 7206.3a184.26 184.26 0 01-12.56 7.16c31.88 44.05 59.83 82.59 60.05 82.59v-.01c-1.22-2.63-22.81-43.34-47.49-89.74"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12627)">
            <g transform="matrix(107.2 0 0 140.2 5379.9 7080.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAdCAYAAACuc5z4AAAABHNCSVQICAgIfAhkiAAAAUlJREFUSIm1lUuSBCEIRBPC+59mJmJOB7NQSwTErkWz6lbiJb9C+vn7VXzB+BtQAGigi4fN5+Sb5NzikU1CzjBr08cItLoaTiT1FSPAgPZgkog/ESnOiQFIOEWde79XBrRsO6PtDnsXSLqIsqb3ygAJUitLsYCVzx7EFG8hp1MIO+UaRIy4Lt7yqQJIwZ9aFoARq8F+QG4lN2IRfJs2K1AI33dFJZCdD3jZKWWG8ssFOERDKTLQPCOpJ8HC25uIlBnkG6iSTt9l3OI+VF9f4iGKLqoywdZTkXfmxYYfq9NFbAA+5xDq9N+zIe3wBX5As+YOTFrAH/Tj0rtBNIC2kf4/hp8To/xRvDxNNgMLdyOwZUMT7C15GVMx+wbKElgRW5j9SYN9EvCZqBGc41Z++15UXNoTuNthCZkxCvfspyy1WIoA9x/QzXr0/zbmY9RiKJKoAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12639)">
            <g transform="matrix(68.2002 0 0 87.2002 5264.9 6917.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAASCAYAAABrXO8xAAAABHNCSVQICAgIfAhkiAAAAMBJREFUOI2NUskRAzEIk+i/mFSRSVUoD9tr5CMTPosRIAHL1/sjMAACQOAxNl9EiRE9ETESoJoAANl9ldjEY8QNqE1WrOPxSNkYAYUKRsMDSkueFmCyDWmYGuNeMBjSGeX6w5NdKvMw3CikYpdqTVTcyRMaa+/y3NJYxYkH/jGu99FSqItfY31JsTe8yKV3jfbJpaDOXd6c54mD/KMxacx2x6PkSyOb0U5TziPo8Qfr4RzrcgCK1ojJUvjjn93fiS+IfF4zV3BMAwAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12651)">
            <g transform="matrix(116.2 0 0 140.2 5307.9 6970.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAdCAYAAACwuqxLAAAABHNCSVQICAgIfAhkiAAAAXpJREFUSIntltltxDAMRB8F999MWkgn6UOTD0paHaS9CfIZAgbWPGY41OG1j88vGYaKAcZiNr9vsdQ0/RQFaOCbDfCA+NamXDOKYWHg8B2Nmj8piceuYzSyHDcCnH2mI1xyzwa2gxfz57YB2wiUjGYu3IH3942kLGCnnhM8syQWQf4IIMyZmnqf4Jf2T/CHBPU8RO/klOVyqkFRcDofwaeaVcEIbKDdXxUrScABrjP5oH0V9v2djetQK4pVrR1nKnosGlnmJ1IAILUrW4RX61vr4jlFiEMFTAsexB6BNRr1L1pEYnIlUeETcAMHKH0CqRJp275KnmaVpTFfgzZuJwGV7pzVdPzm7zutTjlbGcBlVf7RD0mCig6kOLwqbQoyErghSs2BrQ4CP1lOwvhHIfXEnejeOrCGAgPUSUCl7f1JDQBV2IMKvbKH4GmRa+ugeOqkpivXvsNCCSvlRRuNmbXxBURd0Vu2jvbChNU2j/HRPongeR1sOS/+8g0ATMGGSGpY5wAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12663)">
            <g transform="matrix(73.2002 0 0 82.2002 5331.9 6999.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAARCAYAAAACCvahAAAABHNCSVQICAgIfAhkiAAAAKtJREFUOI2NUkESxCAISxz//5h9yr5kX2D2oLRA1ZoZD6WEEICf708ggEJAiCjECgJQ4f+vkidhAqiZIABcCwbUTuBKYApzV30f2bJPnCprojcl5Hk0DeXMJ989FKKgpOqm0HYNd9zKfsSP79SGeuFb15Rmu5YughUTacrOY9P2soC8KrqII765Dns+Pq2RX0NAugrooM7ztq3XA3LxxhQGN96WjLiFS9XeBn+6/inT2HQcyQAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12675)">
            <g transform="matrix(16.2002 0 0 20.2002 5331.9 7023.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAECAYAAABLLYUHAAAABHNCSVQICAgIfAhkiAAAAB9JREFUCJlj3Hz27X8GBgYGBkZGBiYGJIDg/P+PKgMAyRgFdGGzcW0AAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12687)">
            <g transform="matrix(49.2002 0 0 48.2002 5331.9 6999.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAABHNCSVQICAgIfAhkiAAAAGhJREFUGJWFj8sNwDAMQh9V9p+kY3WD3kMPcZyPqhYpEjIEY53XbTocVGKfHaEME4Dr4BJgSgrqZkdQjQgBoqQ4J04wy+p1GGUivb3s2E0O5rRrTnR0GdlM9taR927rJ9rV/jVvx3zhAd9ALoHv8iRuAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12699)">
            <g transform="matrix(68.2002 0 0 63.2002 5336.9 7018.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAANCAYAAACZ3F9/AAAABHNCSVQICAgIfAhkiAAAABpJREFUKJFj/P///38GMgATOZpGNY5qHACNAKehBBY9nHUaAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M84.817 27.125c-1.549-1.21-1.266-4.612-1.28-5.573v.922c0-.15-.012-.307-.012-.342v-.58a10.77 10.77 0 01-.085 1.217s-.452 3.413-1.27 4.12c-1.845 1.615-6.485 1.305-4.706 1.347 6.01.128 6.01 5.992 6.061 7.916v-.969c.005.07.011.128.011.163v.806c.127-4.554.114-7.434 5.356-7.819 1.735-.133-2.265.201-4.075-1.208"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12737)">
            <g transform="matrix(173.2 0 0 202.2 4002.9 5391.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAqCAYAAADbCvnoAAAABHNCSVQICAgIfAhkiAAAA6dJREFUWIW9WFl22zAQw+j5ND1Az9kLm+gHZ8GQlO00bZmnSOIKApgRE/vx8xeRhXVR7hzePgAOEF7nF+MZBPkEMQASxADxBPGcbRjz4oDhCeNzzmkF4YJdgF3+anWZPkt7PqO325VjDJat834BtHnBvMHXMIOWK4edQEEGJMC5ZAIwy4VBQZE9dQPRr6Cu5ZqTXjsTypKAuWUJAe6qMda76Sth5RBpqZlz8RXUuhNhKdlVvCIbrTc6m2bLfOLiq2mY8qwMxBaX+vTAujAOZZXJQNs7Xs0n22wK5q7PUsO93sTo2/jd1EvDhtrOOz7s7m3JSMMNiwno0HqU7dP3T8tOwiEm/3b5Gtj/AIjvu0i5B5Sfi9OkX1vkvvg8rPke2cC9sdpOc7H3+aRYZsLbIVcDs/Vk3d8AyBrb6+k/x/ELAVerSJYG9sJdRsqp4IjuVPiyU3kojxtDBpwWpP9e6GfvT1Ak6nPQN24xRlh9tAU3I59AneSrfsQ49PEqUPKiA2Ft0hlawRDAKNaa2RXUEDYQqyzlICeAOpBxG/N4z8oiY5wY811PlZ2ZZmiVj+hrNMnWnXAB1Y6vlOOrshO/4xg7jnPS6P6h+wcHhqC7X0A1GZddKWCOObGQTYifZAaYg7GFiAR0Z1hlxt9z5x5VKZ0B9AN7Z8dBWfhS5Iq1jgyp05unBMzCCpukA907wU5gmNHV5drBdIZOoRzaN8PGc0nFsfTb2AkmQy6RfQd0ijJ0FhQMZWGRCr4QeWKnxpiCPjLUnFiB2s2rAGtC8pnMEp1BcvEO6Mnwnp0uWZt0jTa+ABO7H+mdkGo+q3deswMAD6YhNdLiHgtKGgiZFn8VGJ6lan46s+MMPaV9SWQAWga+BTPQv2EDsPDZZMZyQ/dgumRM0WRiJCvA8GjqZlcw4ZvIUMG+RWp4ww4APBhRdkqQnk0pn4rqV57pYLz+i1IJQ5Xek5VghMpEgCxPzX+z4CUYQ+Sr92AmIHSGCHqVRJ98RibmIQbmCzA9Mj8CxPH0R/a7fqvEFSlRfnJCuhtmMvd8VpKhMqoXi/wTrdFPsjIIWOSaadzOzOdSFUMhhykb6BIGkKSemWeUte+CmYCahwLQKXujDK2sOJPfkWkB9MzFo9RRAxmys8fwQ7qwEnnG+G0wDkjD3mtN2EH4xWviu5QyeWZOIH8OBljCvqZyViyaggEkGEsWvxbWbwFlGK9/Ajez1ymvATH8FVY2QNzCHbW4Pv9DIFF+A6M5GRFiNaDHAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12749)">
            <g transform="matrix(192.2 0 0 231.2 3983.9 5381.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAwCAYAAABjezibAAAABHNCSVQICAgIfAhkiAAABH9JREFUWIXFmN2S5KgOhFOOepq9P0+5z1zkXiChlMCu6p3TsZ6osQ0CPlI/ttv++t/fBAzzIEDkNQBwII+x2sjh9pz3mOdpn/3kADFAvOu9hc3AhTfAN2CEAAAAXsAlt+ZGfk0CdgnoNSHtggFzAQOAC8YBmiHnc3gAhtlOvOcSIYgZSANhs42i1QK01hIWy1hAbyE5MWiuJGC4wMngSln+ODcF8w3SXIiPCiINCpw3d0iYE8QmrSpuOl2qS7yzKxQkcj6B7HSy0ysHlN+VQ81dY9fqtzKTzLHmjcs51ryP4ckqIF65YBcy3CLcKzyv7LdrBrhubs05AE4QgukIXOl2M3GztYWAa+7ef2WXV110LZ4BHra3KrLucVoeBNEQaUe1Lm60HdLaOfqsVQKxL26u/i+3jOSJWCyAJsoo7BGy71RULDFW55llpMeij7I2n8ThVQK4gy53doVCgl5De0JYHVIV2M7sImGmYhvU1TxdP9m0Fu7tFoqexjfImxQWw1MhPyly2P3Hg5YJcjP8BvBgfXTzt/ffHrso9wr+2vEz+P8AkJ9N5PgesLx29UV+tujDIn7K+V63htyNs+80hNXmm0Pf/26GNAVZ4baRzPMHoNViezv933F8E+T11JkqDuwHd7czwPs8h+Fb59notbtQ4RRC1d13T33ZpI5PzWA6PudgvHlHn6i+x6ACbIlxgjy5O+2IcbDxJlDqtLwYC/zr7D6FU+CePAo5RC3Eqs1zB/cDrqz3t5i9BywTNtcofHzRrfv47cqVBDGdD3WNRxf3nbJBLrjhLjypF//np+dpTho9/ujxh4OCuFPw4M7i9rZr3UB8MA2dTeJRZoA5nDVhFuAxiw8JoMr5fX68I9V0Fcg39AM+HRyfqTJWN7gr2AF1kII1uKYaSwgM1NgL9WL6mb3VvTucK3hXhA+lI2KnJEBcp2s5mt2mXigd7pUw+Q6wgalqpQB7ogSIuBa+MHlSL8eYbuKoILpSepuFoSaDAucC5HspT91EqKmxB3pxvlfvQcG+SM9mPsCFOmPFXrh2XmvsPasHAC+eysz2lIhzAEjZCbe2+Ew4nl1b4vGs3o2CFPtWWAGUJ8QtnKumbraI06mcrQ3ew90AVtVWWdV6aAAwPFtr8ihcxF1USHryWJSiD+ptgMX09Mbi1Z7yaEu7jLkK5+0/dO0C5EOSLNVCMapSAZ0xOf/Mi0c4Q9TLz3BAd3H5a46AjIBmAiCg/ayuvoWrmf8VYOx6CdcTRNTU16qIquVSDDcNV98oB36tHvDwJMnA98Oi/kXv8Ct5aoCARa2biVCV+961C/Acg5CJoryIywNsSc5V51TVP4WbgHfvg9zduXBX8niCqGqu9J+4tQG+D81sd1FSsErEtBj+0SOqRZ0z/jGcAz6VGb81UQ8Rb94Sz9XlVn9yLLB/Dwc8vfKTMrWrZtEVCmHB2VL5Z2XkI+Cdgux/sohkclVsKSdghv+Lah8BuZUXJIxe/yJYAp7eZoJNgfTLS78hfglsAVrL4v379PzCkJ+Jv3v8A6Jfj0mBJHm1AAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12761)">
            <g transform="matrix(154.2 0 0 164.2 4007.9 5395.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAiCAYAAAA+stv/AAAABHNCSVQICAgIfAhkiAAAAzlJREFUWIWtV1GSnTAMk185U2/UQ/ZuxepHLFsB3s5ut5nZBQKxZFkOvPj56zdJAgASQJBIAEkAdQ4SSYJJ0M5PEjwTrOvIBEhEEnHqPNc8CGQiWNc8ASZeBBARAID1f8b1+umO1v7reD2G/2bQCfSPBFSSb49PhHl9BPh+/X8iCODlKpXv7nBkQ+o+7V58hg/pq3r6UPYkEUYiyG3ukZ3WguucRNQRqHMb4TFWm00Jgnt22x8xRMDC0sNXUtgUuZK4jhca3JTgsGkVNnbrvk/dgPzyRoLdIQcrIAuEJLLakAIxwOxnZ92S00j48XpOVhJro1oeqCI3zyIiogJVjbsk17oPM0Ra1q0AK3EzoUtNBEJEtBUr+yICLqrMnOfs+TCze1ncnEg9l94Fuwoqh5szyPVE3v0SDa7zkd6fQSz55K3D5dx9w+1lJEJ6ITEfWk8ZWik2H7QXstccCrxSjAUgTXNqv4GXEsFSg7goYWQUi9kxfT84BMJa0F4CRxXVXpkDBVyAGwkzHblev66QyQ8ARwckwYhpyUut04Ko9SZwoly6AmvOyFc7ATBCARxJIuDuFgGM+2vbZBKZK3DYcVOgJA+1IxfoO08cTDE16c2EyvYEgMwGUhtFcs/cs3bAaylEQDscqwQ053c50rKRiTLtmp0EsEgFlXVWOeroHQHg4Jm9lsZuAWfPh+ouFUwNrYly+g5+adMbAbWhlSBVyXJ9SE4RAGar5cxtdfaM34CPBy4lIDDyCsTltkD6EnYF2nSUGvYXrwuBczYihqsx/Q16ewlszyy2zLl9is9GdB9H5rnAk0DtA5P1Eyisp2czGhDtCwRwGonncfDU4lXnWzut6d4rtOkMqAgOgaWcwM+34ABw7AaasX3htNRV51JqCAhYsc5t/qMfCEec7XnURj2lcEMG9mwze67bjpe64730dwWSwI9XBY6uW3NvQqYEH0rgW+8nfhkd8cdqZC+Jvq4s2QYV4V0BYo5P/f6WQDscBDkf3/ZptO67vBHwXpcCfNNqHyuQ5oGIqXfNMWJlVvNxMd4mOVDkvkDAFxtuZxWSXr3fZZHRXJWvjwOugGQPO98+LGigOv/e+AsP1apIf1pF/AAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12773)">
            <g transform="matrix(149.2 0 0 53.2002 4026.9 5535.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAALCAYAAACH6Va0AAAABHNCSVQICAgIfAhkiAAAATVJREFUOI2tlNmKxUAIRE/5/787MAPRmgftpHO3pys06Wi0FiH6+f2zy2BTNlWmXP0sqCqqilz5hKzEkzsyu5Yms8jq96OSPIpMSBd5FEceVJoVEQiFkK4TElIgMWfuCGQUAUwtAkHnxeS7H+LMefVvEYog+gbSHWzuC7DfhWykwEDYF1ho8q1OcZGKIXUDhzW4ea0PxFLvdgKfpNgcsmIG06TChCAYJ1vaWAKKi0CcYJ7Cqb6HwSITgJsUwhiNYdY5DQg8rmyYQ+TR9rWnYXSqGK9O69l2JjObxlx3We2UPVt0q9qJbPixJyStbW1qV5dHWVcdl/VXx3PoQy10ljU2PzbfVb+CcjyP9834mJXe5wffDD2T/xTfBfc7g9+Atz19rFf21Tx9y+6herWufVbRf9H7/H92r5VhJ9sDfQAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12785)">
            <g transform="matrix(164.2 0 0 140.2 4011.9 5448.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAdCAYAAADPa766AAAABHNCSVQICAgIfAhkiAAAA6pJREFUSImdV9Fy4zgMA7T9//+9mwq4B5ASnaQ70/NMU0eWSAgAKYf//LstGDAhAJYAAYKxbWgbNnIvwyK2BCHPes63jC3nmVDfhb2R/wb2d+J8b+NbgmT0tcj6ILAAcC2ABEgsLPxhHhA1vAwQYMWgDdP1nCBWxuszoWqMgJGF62IoIIsggEUMMABBkE5wE4sESRgHJ7gIct1EwFnTiXHuCdMVx+DiE8jqgCfIDdgZKw8WiMWVRMxuEzwxQGOBIFybqb8VBlcHqosDy0Kxkd3xUkwOVl5oZcsScB2IINzZMf6fTJmzsLLRhzQAfPTODptSFuzlSla0tjyuYLkfa8Cw1xtxvNRXhcPkZ7EoPrtE+cC+jkQY89zhGe+gPMmIDxML8OcnBYpAkg8DcQjoIUXP7+Qfsz0H3rInDeEx97LTm/8J8m+vX8ZZbyP+MOv/XL+Ms84aAh6dzsNcLUlL9Ncc/vD0ZShp/DDwstPCe8zwZXW403p4NwFhWOO+NPcj89zcz5tYXYqdl+ZZ4Fot5pts2KmJFBVPgkxpCA4wAHaqbRqzN6QJpKmyDNs5+Jx7I4knYz3/hbCsgwtQM+DnhGaLiftg5IAo9Gg2TDQCK0kzriQYknaMnOAR1xqsyjABlY4qgBPnahC96jBy2MjpGsauFK5Fto7pjhQzkct1ipQtr17c8qVKCF9JQmN01vCLLVhpfybgHe0Po/KbUQNaaILLYW/FtYozqCnTqAYVI+WfSC2o5LFTTVt1jymXr1E9pMrb16N045EC4f0EsZE3rC7GThqZEzhsFjseUjp+8fRXARVU0jyvLx1T1WeB0A7ibUBK6arl6/IUTjK0BM0IdGUxIPZ8nrE3j2AayKx3SWM7jlfJgCrvI4Uzxxa2eZLIgJw3sshyZYT14qMC4l39g9cL6sbUslV57t697gv1Kd8CMFl4yKdisYC9Hopf6sTdcIzjlTZvdu4TWCYkAfsCbdnkyGmg3vrH8VHrbLwD2SVDS9PdtVol9ApiA6qfB4IfYHZ35MNM+6Xk1Eu3fQBx2nKbSyMQ2qBN8fmNEzAaDVDFymFGtYmW5uVwfQMi9bmCBwC7kxMa+ktt3NCsXY1P6Z6RY5xZ9UPLCrifrq/WULgAjr72rQKlMqQ0hm8pJV3VtdtrZn3XMDrORn4EsnVr2mcXrO55K6JB6MiSn6Da1YMESC2Lz5GR+O8t/aNHcIw1tFQOK41e4X2PggYRWZqR2/y2XQa9jfBvL7L/AfhYnM0AqXjzAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12821)">
            <g transform="matrix(54.2002 0 0 68.2002 3973.9 5559.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAOCAYAAAD5YeaVAAAABHNCSVQICAgIfAhkiAAAAIRJREFUKJGFkUEOAyEMA8eI1/TaP/bZ6x4gEHVJl0uEcJxx0Ov9MU/HBkyH9qQEAYiOxLydhWa9D+el1V2kSemrck4iNJjV6Khi1g63mKmYnXqGe6/DKdXh/gcjBlykbUSgNMERbgSLhrOzEoJ3Q7uJpEOj5up+nXK2wFFso/qUKN6f8wVy0Cc8VUcRlQAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <path
          fill="#b5b5b1"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M28.662 89.832l2.027-3.037c.129.09.262.174.399.255-.968 1.12-1.871 2.16-2.426 2.782"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12835)">
            <path
              fill="url(#radialGradient12845)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M4090.64 5689.78c-4.07 2.54-8.26 4.93-12.56 7.17 31.88 44.04 59.84 82.58 60.05 82.58v-.01c-1.22-2.63-22.81-43.34-47.49-89.74"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12855)">
            <g transform="matrix(183.2 0 0 217.2 3872.9 5400.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAtCAYAAADC+hltAAAABHNCSVQICAgIfAhkiAAAAE5JREFUWIXtzjEBgCAAAEGgfxgHzKcJHG6S4S/BzXtfzzjQ+jvwpZgqpoqpYqqYKqaKqWKqmCqmiqliqpgqpoqpYqqYKqaKqWKqmDo29gIGnQNyqWNIrQAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12867)">
            <g transform="matrix(88.2002 0 0 101.2 4011.9 5602.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAVCAYAAABLy77vAAAABHNCSVQICAgIfAhkiAAAAFJJREFUOI1j3Lplw38GkgATAwMTVlEywD9qGYQFkGEQFueQZxB2MGoQFoAW5gPtIswkMNAuGv4GIYU5mQYxMaDHHPkuYkLVSlk6QtI9SAIbCQAAHMAKQAP9Hf8AAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12879)">
            <g transform="matrix(44.2002 0 0 63.2002 3997.9 5535.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAANCAYAAAB7AEQGAAAABHNCSVQICAgIfAhkiAAAAFtJREFUGJW9j8ENgEAIBGeJ/TdjEbZiFeJDL+5h8CnJBQLDkNO67QnJFAegpxdXkr27K1XIQ1aqgwqYYiF9MwuYENXkC2YMQhD6AN0U7+GwzecGWGzN77pzv0AnqOENlcLBVrkAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12891)">
            <g transform="matrix(73.2002 0 0 107.2 3978.9 5515.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAWCAYAAAAfD8YZAAAABHNCSVQICAgIfAhkiAAAAMdJREFUOI3dlMENAyEMBGct+m8mPaSTtGHnYRAXwJe8g4QEwjtrY4Qez1dQDHkeBZcQjUXQLrtthAkIQMgjITEAopXKxSqMCYnMpBEHZ50qySzChDxLaVjthq+gmYWcquYu6KmeIGGcfRM4ZodoNVElPpTADkhxaM5vgEuMbYISdCmhn820TTlXUAUA2iYY+/40CRV9L2+bPYvVPb7dts3Ak+0Prbph/6N4tOvUKr8Te/U7TaBtQR6fwuKBAP0bqlw2Yd87IHgDzD5IokLjdTMAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12903)">
            <g transform="matrix(25.2002 0 0 54.2002 4002.9 5539.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAALCAYAAAC3ZUeVAAAABHNCSVQICAgIfAhkiAAAADlJREFUCJlj3Hzu3X8GGGCEUCwMyAAqzcSABTAxMDIwMDAxIokwQlX+/w83D1M7I14ziRL8/58E7QBV2AiL94aZbAAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12915)">
            <g transform="matrix(34.2002 0 0 20.2002 4007.9 5573.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAECAYAAABCxiV9AAAABHNCSVQICAgIfAhkiAAAADJJREFUCJltyrENgEAMADFf9l8ZQvGiQXQu3HVfCzZyuGuXSaah5TSVYt75DWQqf6F4AM4KFg5qOlJ3AAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath12927)">
            <g transform="matrix(34.2002 0 0 49.2002 4007.9 5544.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAKCAYAAAB4zEQNAAAABHNCSVQICAgIfAhkiAAAAEZJREFUGJV9jEEKwDAMw+Sy//+4dQ8LJcnKfDJYsuZaBrABgaIbeEQkigHpLaNtKAFDOm4BIMwb4HLbACmNt5Qx25/x1+zZvKsOIFBdyS4AAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M35.86 80.625c-1.55-1.21-1.266-4.613-1.281-5.574v.922c0-.149-.01-.307-.01-.341v-.58a10.7 10.7 0 01-.086 1.217s-.453 3.413-1.271 4.12c-1.844 1.615-6.484 1.305-4.705 1.347 6.01.127 6.01 5.991 6.061 7.915v-.968c.005.07.011.128.011.162v.806c.127-4.554.114-7.433 5.356-7.818 1.735-.134-2.265.2-4.075-1.208"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27169)">
            <path
              fill="url(#linearGradient27177)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5882.76 5308.08c-75.44 0-147.71 13.63-214.43 38.54-10.88 13.88-22.05 28.14-33.38 42.61a563.77 563.77 0 0165.64-26.99c56.81-19.34 117.62-29.93 180.98-29.93.17 0 .35.01.52.01.23 0 .47-.01.7-.01 88.82 0 172.89 20.45 247.71 56.89a55930.76 55930.76 0 00-33.37-42.6c-66.71-24.91-138.92-38.52-214.37-38.52m443.67 190.07c-2.25 15.22-5.49 27.51-8.96 37.32 81.15 96.94 130.47 221.43 131.92 357.39v.17c.01.33.01.64.01.97v.23c.01.75.02 1.49.02 2.23V5899.02c0 199.49-103.04 374.89-258.77 475.88 1.76 3.31 3.5 6.58 5.23 9.84 38.3-23.9 73.68-52.08 105.47-83.86 106.95-106.98 173.07-254.61 173.07-417.82 0-117.8-34.44-227.47-93.82-319.61a616.006 616.006 0 00-54.17-65.3m-887.38.02a617.45 617.45 0 00-38.99 45.08c-67.69 96.12-107.43 213.28-107.43 339.81 0 163.21 66.12 310.84 173.07 417.82 99.31 99.28 233.63 163.36 382.93 172.05 1.4-2.58 2.85-5.24 4.35-7.94-299.18-15.49-536.93-262.92-536.93-565.97v-1.11-.31-.84-.3c.01-.74.01-1.51.02-2.25v-.22c0-.32 0-.67.01-.99v-.15c1.45-135.95 50.79-260.44 131.93-357.37-3.47-9.8-6.7-22.1-8.96-37.31m736.54 888.63c-84.37 49.83-182.39 78.96-287.47 78.96-.88 0-1.76-.01-2.63-.01-.9 0-1.8.01-2.7.01-6.45 0-12.88-.11-19.29-.33l-6.57 7.93c8.82.39 17.68.59 26.6.59 108.38 0 209.88-29.15 297.18-80.06-1.7-2.35-3.41-4.71-5.12-7.09"
            ></path>
          </g>
        </g>
        <path
          fill="#262a49"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M122.638 70.29h-.529a20.777 20.777 0 01-6.105 14.74 20.779 20.779 0 01-14.74 6.104 20.779 20.779 0 01-14.74-6.105 20.777 20.777 0 01-6.106-14.74 20.778 20.778 0 016.106-14.74 20.78 20.78 0 0114.74-6.105 20.78 20.78 0 0114.74 6.106 20.778 20.778 0 016.105 14.74H123.168c0-12.098-9.807-21.904-21.904-21.904S79.36 58.192 79.36 70.29c0 12.097 9.807 21.902 21.904 21.903 12.097 0 21.903-9.806 21.904-21.903h-.53"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27189)">
            <path
              fill="url(#linearGradient27195)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5485.23 6359.38c107.1 91.11 245.9 146.1 397.53 146.1 111.66 0 216.37-29.83 306.58-81.95-90.27 51.19-194.64 80.42-305.81 80.42-151.59 0-290.49-54.33-398.3-144.57"
            ></path>
          </g>
        </g>
        <path
          fill="#21437e"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M122.842 70.015c-.367-7.447-4.487-13.905-10.511-17.514l.446-.84c6.076 3.835 10.112 10.609 10.112 18.325 0-.179-.022-.354-.027-.533a24.84 24.84 0 01-.02.562m-43.211-.008c-.01-.184-.016-.37-.02-.554-.006.18-.029.354-.029.533 0-6.61 2.962-12.528 7.63-16.5a21.816 21.816 0 0114.052-5.1c3.922 0 7.604 1.031 10.788 2.837.107.061.211.123.317.187l-.567.784a21.517 21.517 0 00-11.48-2.734l-.8-.963c.138.283.31.612.507.977-11.034.607-19.849 9.481-20.398 20.533"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27207)">
            <path
              fill="url(#linearGradient27215)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5883.53 5292.18c-70.06 0-137.26 12.19-199.6 34.55-5.11 6.52-10.33 13.17-15.6 19.89 66.72-24.91 138.99-38.54 214.43-38.54 75.45 0 147.66 13.61 214.37 38.52-5.48-6.99-10.87-13.87-16.19-20.65-61.72-21.87-128.17-33.77-197.41-33.77m443.64 200.58c-.23 1.83-.48 3.64-.74 5.39a616.006 616.006 0 0154.17 65.3 593.183 593.183 0 00-53.43-70.69m-888.66 1.56a595.972 595.972 0 00-38.45 48.93 617.45 617.45 0 0138.99-45.08c-.19-1.27-.37-2.54-.54-3.85"
            ></path>
          </g>
        </g>
        <path
          fill="#21232c"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M103.365 91.537a6.677 6.677 0 00-2.13-.347c-.743 0-1.459.122-2.128.347a21.588 21.588 0 01-4.29-.865l-.595-.756c2.2.788 4.57 1.218 7.042 1.218 2.443 0 4.787-.42 6.964-1.19l-.573.729c-1.376.426-2.811.72-4.29.864m13.619-6.689a10.427 10.427 0 00-.07-.79 20.926 20.926 0 001.885-2.493 21.574 21.574 0 004.042-11.55c.008.175.016.35.02.526.005-.187.028-.369.028-.555a21.58 21.58 0 01-5.905 14.862m-31.496 0a21.58 21.58 0 01-5.906-14.862c0 .186.025.368.029.555a22.4 22.4 0 01.02-.534 21.579 21.579 0 004.577 12.27c.422.6.875 1.175 1.357 1.726-.035.259-.061.54-.077.845"
        ></path>
        <path
          fill="#1f3151"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M122.86 70.541a20.36 20.36 0 00-.018-.526c.009-.187.016-.374.02-.562.005.18.028.354.028.533 0 .186-.024.368-.03.555m-43.25 0c-.003-.187-.028-.369-.028-.555 0-.179.023-.354.028-.533.005.185.012.37.02.554-.008.177-.015.356-.02.534"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27229)">
            <path
              fill="url(#linearGradient27237)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5882.79 5332.31c-.23 0-.47.01-.7.01 89.87.08 174.59 21.47 249.97 58.86l-1.56-1.98c-74.82-36.44-158.89-56.89-247.71-56.89m-182.2 29.93a563.77 563.77 0 00-65.64 26.99c-.02.02-.04.05-.05.07 21.2-10.32 43.13-19.39 65.69-27.06m459.05 64.19l-57.63 101.1c-64.62-38.4-139.79-60.89-220.44-60.89-79.05 0-152.87 21.58-216.61 58.59l.3.53c-128.4 74.97-214.91 213.9-214.91 373.26 0 2.67.33 5.21.39 7.82l-134.31-.19c0-2.58-.38-5.05-.38-7.63 0 303.05 237.75 550.48 536.93 565.97.05-.11.11-.21.17-.31-80.08-4.96-155.51-26.8-223.24-61.56l69.72-115.35c57.05 27.71 120.81 43.71 188.49 43.71 15.22 0 30.25-.8 45.04-2.36 16.02-26.13 31.94-51.74 46.32-74.69-28.21 7.18-57.72 11.15-88.1 11.48h-.11c-.29 0-.57 0-.85.01h-1.22c-.26 0-.5.01-.75.01H5886.8c-206.14-.27-373.24-167.15-373.79-373.25v-.18-.84-.71-.17-.17-.38-.25-.46c.01-.08.01-.19.01-.28v-.38-.1-.22c0-.22.01-.45.01-.66v-.4-.29c.01-.14.01-.29.01-.44v-.22c.01-.16.01-.31.01-.47v-.19c1.25-82.16 29.04-157.84 75.15-218.95 67.85-95.3 179.23-157.46 305.11-157.46 206.7 0 374.26 167.59 374.26 374.3 0 3.98-.06 7.93-.19 11.88 10.37-11.96 17.08-19.61 18.46-21.02.12-.13.2-.19.25-.19.59-.01-6.86 12.54-19.24 32.7-5.16 83.75-37.85 160.03-89.14 219.93a379.616 379.616 0 01-28.97 31.83l.01.31a375.96 375.96 0 01-50.73 41.61c16.06 30.15 56.82 106.7 92.63 174.09 155.73-100.99 258.77-276.39 258.77-475.88 0 2.74-.34 5.39-.38 8.09l-134.33.68c.02-2.93.43-5.78.43-8.77 0-158.35-85.43-296.46-212.46-371.79l57.39-100.24c-.14-.19-.28-.37-.43-.56m157.83 109.04c-.06.16-.12.32-.17.48 81.2 96.77 130.64 220.99 132.09 356.91-1.45-135.96-50.77-260.45-131.92-357.39m-869.46.01c-81.14 96.93-130.48 221.42-131.93 357.37 1.45-135.93 50.88-260.15 132.09-356.93-.05-.15-.1-.3-.16-.44M5316.08 5893c-.01.32-.01.67-.01.99 0-.33 0-.66.01-.99m1133.31.03c.01.32.01.65.01.97 0-.33 0-.64-.01-.97m-1133.32 1.18c-.01.74-.01 1.51-.02 2.25.01-.75.01-1.5.02-2.25m1133.33.02c.01.75.02 1.48.02 2.23 0-.74-.01-1.48-.02-2.23m-1133.35 2.53v0m1133.37.02v0m-1133.37 1.13v0m1133.37.01v0m-388.76 329.73l-77.21 93.12c40.1-9.15 78.08-23.92 113.15-43.32-15.04-20.83-27.72-38.41-35.94-49.8m-196.99 237.58l-.17.2c6.41.22 12.84.33 19.29.33.9 0 1.8-.01 2.7-.01-7.31-.03-14.58-.21-21.82-.52"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27247)">
            <g transform="matrix(692.2 0 0 634.2 5581.9 5501.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJAAAACECAYAAAB/AaI1AAAABHNCSVQICAgIfAhkiAAAAb5JREFUeJzt0sltwzAUQMFPJ/3XkMJSS5hDHHiBvADvOnOhKIqUILz1+fW9Z2b2x5qZmVkzs2f26W8653Gfl2ddXZ/+L34uG2/cz++9Wq/PH+0/+M69Z9a6Ha+teWgdnHf5Pfvg7tPjnr52vdi43j75ct7ea9Z69F/X3WzPnjVr9pzOa6ejbfAuAZEIiERAJAIiERCJgEgERCIgEgGRCIhEQCQCIhEQiYBIBEQiIBIBkQiIREAkAiIREImASAREIiASAZEIiERAJAIiERCJgEgERCIgEgGRCIhEQCQCIhEQiYBIBEQiIBIBkQiIREAkAiIREImASAREIiASAZEIiERAJAIiERCJgEgERCIgEgGRCIhEQCQCIhEQiYBIBEQiIBIBkQiIREAkAiIREImASAREIiASAZEIiERAJAIiERCJgEgERCIgEgGRCIhEQCQCIhEQiYBIBEQiIBIBkQiIREAkAiIREImASAREIiASAZEIiERAJAIiERCJgEgERCIgEgGRCIhEQCQCIhEQiYBIBEQiIBIBkQiIREAkAiIREImASAREIiASAZEIiERAJAIiERCJgEgERCIgEgGRCIjkF3JcHZvsVmEXAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27259)">
            <path
              fill="url(#linearGradient27267)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6174.35 6385.09c-84.46 50.78-183.25 80.17-288.86 80.66.87 0 1.75.01 2.63.01 105.08 0 203.1-29.13 287.47-78.96-.42-.57-.83-1.14-1.24-1.71"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27277)">
            <path
              fill="url(#linearGradient27285)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6096.6 6277.45c-35.07 19.4-73.05 34.17-113.15 43.32l-119.78 144.46c7.24.31 14.51.49 21.82.52 105.61-.49 204.4-29.88 288.86-80.66-26.35-36.44-54.79-75.82-77.75-107.64m-396.97 10.32l-69.72 115.35c67.73 34.76 143.16 56.6 223.24 61.56 21.04-38.14 50.68-87.71 80.01-135.56a429.333 429.333 0 01-45.04 2.36c-67.68 0-131.44-16-188.49-43.71"
            ></path>
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M89.098 70.635c0-7.292 5.913-13.202 13.204-13.202 2.65 0 5.114.788 7.182 2.133a13.118 13.118 0 00-8.087-2.783c-7.293 0-13.204 5.91-13.204 13.203 0 4.64 2.4 8.716 6.021 11.07-3.108-2.415-5.116-6.18-5.116-10.42"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27297)">
            <g transform="matrix(390.2 0 0 395.2 5504.9 5880.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFEAAABSCAYAAAAsGziYAAAABHNCSVQICAgIfAhkiAAAA5NJREFUeJztnc1y3CAQhGcUVeX9T3m5vIp3chC/wwBS3JVs4u4qW0KgEfq2B1gfsH7/8dNERERFRETs23Vih3THUn+kk8NS+6uBlXrr2pejvNLRZK9dmzsxajsdyteVQ+M4teupvcb1WYdQnxYhAkSIABEiQIQIECECRIgAESJAhAgQIQJEiAARIkCECBAhAkSIABEiQIQIECECRIgAESJAhAgQIQJEiAARIkCECBAhAkSIABEiQIQIECECRIgAESJAhAgQIQJEiAARIkCECBAhAkSIABEiQIQIECECRIgAESJAhAgQIQJEiAARIkCECBAhAkSIABEiQIQIECECRIgAESJAhAgQIQJEiAARIkCECND5tzvwruq38nO722l3IMRIzzYW/CIQ88uq2/nwlTZ9NDFR0WE/xVpyOyZav6/ifwIxv6T3UHtdxRYeM1F5pepoc0qTcfNJERUz+5cgqrSeen5v1RgldmiGaeVD6NtfhtR3heid9RRavmflzD5679IL2kfZ2VXl0L62jfbmSxyVEcYKqDb16spRu+tnTN7xnuzOVpZ+/qATVy+/mw/9Lr8+VuS4/Irqrs3j+zFTm+sq0jjzUnbn5yD6DPDX2ieGg793mMn6ZWcdmEGdQZ9p7OPVo8itVbcgqtUtoLvozdFvo+zXp5PIm/O7Dp1dX4+Ju7jjbN5fzyk+hajeWRlWomOaflnaP1u1ZlB6nkoDs3Nk9BKrF7v78m2sdjy8c998IjJ7dS5RB/MsUMrzJ5bSGrRtl2HbypnDImvmoJlzdmOgl2//u7N96rhGE1yNc5bVdzuIBulbYKVfeZSo8B29XOE3evd533Y2vO6Pdx32ZGxdxRjL2YHT785DGosrm7myipiKHv0NQxrfMkH/DSP+5P2i2ySGGgG8Ez+qjztdvjtXh+UT7W/rLtsY15zz3PfKfnUvEptuln5RGs/A+nYr7YaJJ4t7bdM5hfEWcmsjcUYcx9S4Xz7LpxkcVj6B5AfjlXaL+N0sf+n08IszdfKpDE7sx9TOuVbru/Vv29avh7uT1QTh020YfINOez2JP49Tx0RvpXbMC56jFlcPS6JcXP0nkfUH7Rq26bsb43ywuxNNBG0+oY0Qh/TN6TpxpGs3XfpoPVj4l2Kf71K5bB0aderp2jLSvRinJovYcS2Wq8OCxbPVtY8N8d2DSjHFzYya89J0thLw5e147123s/gTwPP0/gWt3UY4heShowAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27309)">
            <g transform="matrix(390.2 0 0 395.2 5504.9 5880.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFEAAABSCAYAAAAsGziYAAAABHNCSVQICAgIfAhkiAAAAM5JREFUeJzt0IEJACEQwLD399/5HMKCIMkEpWtm5uPIfzvgBSYGTAyYGDAxYGLAxICJARMDJgZMDJgYMDFgYsDEgIkBEwMmBkwMmBgwMWBiwMSAiQETAyYGTAyYGDAxYGLAxICJARMDJgZMDJgYMDFgYsDEgIkBEwMmBkwMmBgwMWBiwMSAiQETAyYGTAyYGDAxYGLAxICJARMDJgZMDJgYMDFgYsDEgIkBEwMmBkwMmBgwMWBiwMSAiQETAyYGTAyYGDAxYGLAxICJARMDG5hQBKDSw9CoAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27321)">
            <g transform="matrix(337.2 0 0 600.2 5816.9 5511.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAB9CAYAAAAfkxXqAAAABHNCSVQICAgIfAhkiAAABP5JREFUeJztnG26nCAMhYOPC+j+d9GtdD81/aGMiBxIMKJ3mrd3OvfOqMAxJuFDw6/ff5gEBGJiChSotnkQfNLifPwp6I8ioXbU6ZYSvwAXBuDCAFwYgAsDcGEALgzAhQG4MAAXBuDCAFwYgAsDcGEALgzAhQG4MAAXBuDCAFwYgAsDcGEALgzAhQG4MAAXBuDCAFwYgAsDcGEALgzAhQG4MAAXBuDCAFwYgAsDcGEALgzAhQG4MAAXBuDCAFwYgAsDcGEALgzAhQG4MAAXBjA/XYEz8YY80R2Jl0hLyG8DNBGmfa9kuTKlCkm+uRumIBeGt4pyVuGWIC255EJhlkIhk/JAebsuW0x+wLsoNf5OzJyvlUBMZysaLQrRA8635vAk+43yPLcIY3GCe46R7pNbmdznrBuaCjPC4i3KKDtrY+f7U9D6qdX58nM5w72E5KVjZt52y8UJD4QCU8pilJ3/eduvvZRY5I3K4i3MFWFKFsThaEnx7/zzDnQPX7Fn4WMN5BYThTL0R2++WLszX97+rT+8pazf4cSbnUjJdfrms96i1o2Z9/6xURO/JLqZRSUmoZP8IcIlwuTNKlU4gM8rGPgdPmQcY4SsWIxEKAMMLei4p25ALWe+1p2PFqSzpOjUg8nD4PREC6yVrvAxIXtvFd7ZhGhBB8u5LkctAsUn/KXM+5dH5Ody39I0upUwyLAPh6vUdWZmCoUnE5aEEkceC3qd9sfirvnIee+W909/rIKhS+0GCzLNsMvHEodru+aF7PdR4V+3n7CvhB1v20WG7CUp53lmIiLmwiU5rJLvESNF3SXgk1msHoZpdeKa6IaceR4tevKdq+zhuthgyWdt8F7omw7foyE2tvKc4E2YK5WoO9PHuojnM61i3tNj6ybolnOUuyYlp/9QJ7JfKF2XYS+vdbyeOuhKOm6VzUTeu2pBXuF2p9aqnuFQNGf+ppnHMAW4Nua0bfGkvCUca/KpSrjWWFC6oioXJ54ILqi29tHkXYiRfbV5IaZJUJxsRdW5Ub3BodfF1hKA+o6980oCNGvxYl1wxq3LfqyTwpk50BL6J5hGLTVby+oe/oIj2IiTxSzb+5U1aJrBa+STkk+SI9ycESd8hFlqWwmQRi45z0azqo9JxZq2vy0vOdT0su+pYS8iFEZqQUti2qXoprWgdhQbY0kiA2BeBYjvf5k+r/X7tyRxfZTOxcFiamcrNn6kCHtSmDhzw+Jrxjl/ugy9iVgiVI8POg9srbM8PZnhYZd8glN5rEeXmpUTtZ7+mA1p2bswg6aqn0Y6zFEZDFcWyIFCOEez2qVVu/SOSeJ1tOd5hqZZsqCOxPNq4ngXLWOAUQnuZCCYYCzahCv+qDJLkNHRCGnF8gzbgqtOehOmfsqj2bXMr6cyb73U8AietJEXp6LfinIN3vZN5os+9yMYYDHsYYHoUiLaxRBZ0vhpoAPSsWE+mfvOfF5kVSJdNpRNd0TBtv/uiDSlga+79Ras2uSkGkbViTMHlTHio1NOhzbGsGa+hcqZTdkOHJE4hv3abEabZicynbKVzAK0x3CvMyLEm0y47ejjNZqnQln4qLxn+LMdiNJG88mi7hxW0ACXs+Z0P9uhd9HEwwJN0kluObrJ85S3WAuR+UMvOnzMi8RI6eoS/A9MTOG1Z+1JBIlk6it+9vyRBsWNXP8XT/fuX4sLA3BhAC4MwIUB/APnQJeyH90dCAAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27333)">
            <g transform="matrix(63.2002 0 0 58.2002 6090.9 6149.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAMCAYAAAC5tzfZAAAABHNCSVQICAgIfAhkiAAAACVJREFUKJFjFNhw+T8DIyMDdvAfhcfIAFHHhEM1XjCqaVQTKgAA38EDrYdsR3IAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27345)">
            <g transform="matrix(49.2002 0 0 34.2002 5691.9 6173.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAHCAYAAAAxrNxjAAAABHNCSVQICAgIfAhkiAAAAB5JREFUGJVjZFxz/T8DEmCE0kyM/1HEmBiIBMNKIQDaPQOVxr+AOQAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27357)">
            <g transform="matrix(481.2 0 0 400.2 5504.9 5875.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABTCAYAAABpnaJBAAAABHNCSVQICAgIfAhkiAAAAT1JREFUeJzt0TFygzAUQEEJnyEXzRVzr5BCIrYpXL9it4EvEGLmza/vn3OMMcYc45xzjGOONa/r73Gs+z2fj33d8ziONe995xqf82MvXGcc8//Z9c3/s+e6v1xrz7PWy+fLJ9+ez2vfHuZ4X7/92/vzuffdv/M89+XPPtzP29r9nc/vHYMUQWIEiREkRpAYQWIEiREkRpAYQWIEiREkRpAYQWIEiREkRpAYQWIEiREkRpAYQWIEiREkRpAYQWIEiREkRpAYQWIEiREkRpAYQWIEiREkRpAYQWIEiREkRpAYQWIEiREkRpAYQWIEiREkRpAYQWIEiREkRpAYQWIEiREkRpAYQWIEiREkRpAYQWIEiREkRpAYQWIEiREkRpAYQWIEiREkRpAYQWIEiREkRpAYQWIEiREkRpAYQWL+AFElHykjVxcqAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27369)">
            <g transform="matrix(418.2 0 0 630.2 5581.9 5616.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFcAAACDCAYAAAD4Z4dVAAAABHNCSVQICAgIfAhkiAAAAXtJREFUeJzt0MFtwzAQAMGj+y/FRaUS048kSCTbgRFgfzMv6UDygF1z/dgzMzO3OfoaP53v0+g2s9bDfJ1ufv9f1n565uH8eXDee7j7e/9+cf/vZ9baM7Pm8nLLeefn+eMbP9/vvsM/iBsSNyRuSNyQuCFxQ+KGxA2JGxI3JG5I3JC4IXFD4obEDYkbEjckbkjckLghcUPihsQNiRsSNyRuSNyQuCFxQ+KGxA2JGxI3JG5I3JC4IXFD4obEDYkbEjckbkjckLghcUPihsQNiRsSNyRuSNyQuCFxQ+KGxA2JGxI3JG5I3JC4IXFD4obEDYkbEjckbkjckLghcUPihsQNiRsSNyRuSNyQuCFxQ+KGxA2JGxI3JG5I3JC4IXFD4obEDYkbEjckbkjckLghcUPihsQNiRsSNyRuSNyQuCFxQ+KGxA2JGxI3JG5I3JC4IXFD4obEDYkbEjckbkjckLghcUPihsQNiRsSNyRuSNyQuCFxQ+KGxA2JG7oDT3sSlzFIdscAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27381)">
            <g transform="matrix(491.2 0 0 664.2 5504.9 5611.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGYAAACKCAYAAABYWT+bAAAABHNCSVQICAgIfAhkiAAAAVVJREFUeJzt0UENACAQwDDAv+fDAH/2aBUs2Z6ZWeSc3wG8GRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEXVzaBRAn/+zEAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27393)">
            <g transform="matrix(462.2 0 0 581.2 5528.9 5674.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,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"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27405)">
            <g transform="matrix(390.2 0 0 395.2 5504.9 5880.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFEAAABSCAYAAAAsGziYAAAABHNCSVQICAgIfAhkiAAAA+RJREFUeJztnVF23CAMRSVn9r+JLqwridUPDEhCeCbNO23Svtczxx7AIO5IAueD6tuPnyZdKmJHuzFtRfYmUUe/sXQ903cpy1VM3lRK6bjGPlRj/U6qeey6v+PqKZev/fU7E3Wjzzu7+qM+LUIEiBABIkSACBEgQgSIEAEiRIAIESBCBIgQASJEgAgRIEIEiBABIkSACBEgQgSIEAEiRIAIESBCBIgQASJEgAgRIEIEiBABIkSACBEgQgSIEAEiRIAIESBCBIgQASJEgAgRIEIEiBABIkSACBEgQgSIEAEiRIAIESBCBIgQASJEgAgRIEIEiBABIkSACBEgQgSIEAEiRIAIESBCBIgQASJEgB5/24DvrXb0GiHeyK5D7VTj+XY2TqsjxE+rg/0vcqJtTl400evzUcX+/ilPNHMHRaYDKdsxkq3sXA6ljPV13/5QSt+vfSdPbFN87jWvtfI6n9TblRzNZp6c54Dq1/REW44rfXYQatGHaemNsd8p752HNLDTwzRYMBecdv1SED2y/iur2PCEKpxWzad7eHeYlmc/nohQn3nmsPd67A9CnIafyRGOxWP8/cxVLS/p2GKsPecSExENIViF+s5DO8xjtKtH+WRO1HSvsk5pLbPxaf/eTeS03Qo6V9FQbrlNlQ01XYv+7fVMu9MnPLGC1Yfzv7iGMgslsY/TNHhl9zhzME5zz40w92PP0Vb7umd+fFNzpy3EMRcTCU6yzfW16bPxrLdisr3k3fxTrfZQ38aP2MPw+r7ZhkQ71p76c9nb55YoKof3Iyw13bNDXyY6QFYWvpLtfchET/XTyZ7ZYfdQ716af0fvWRPInWVrTesie/bz/aOIyKN7nHnTzOI4v7XTyOG9q59t1gWjp4AOc3ql7zkvDHkBinFQTaSGtHvTyQvO85zYHfW6N81Ec4jUIfOa6tXz3jyPx3mQ9wOXDmos995xt3ofIvLoHagNl/SXNCdbK7SCabHNqM+LziuT8KHVcmb0LF1y5rSk7zNf3WPeqwrtU0JOHC2j6bdQJa5As1CqZaNetaOZ7dJmbWn2PWfmsM+6W53vc2UfPm7SY98ryEeRpa/v9X89sQbrzqRubl7bqvBLRvRFbCxmMWfO4NrD9PlyfX3cPZf3onuYXnOzvTiFXZ9Wp+Kcrre/7fsj8ZM35Bnybk/arqfp88265bIXpnC1yPvKvPl3q/M0y3yk5TQ2HHWuhFdBbHDrbZXp+qR+Jz+hPNl5NZlOcARbs4dXNsntHzQeYWATEVW3L2wDWz2Cs9SSm+YJ5VxYdiJ78BLKd+/O2Rurd3IVcQtN3pfuLRSpQYqI/AK+b40aTlCvHwAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27417)">
            <g transform="matrix(491.2 0 0 611.2 5504.9 5664.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGYAAAB/CAYAAAAdBrcxAAAABHNCSVQICAgIfAhkiAAAAT1JREFUeJzt0UENACAQwDDAv+fDAH/2aBUs2Z6ZWeSc3wG8GRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRNlTJQxUcZEGRN1AQ9ABPrkUSn+AAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27429)">
            <g transform="matrix(49.2002 0 0 44.2002 6138.9 6120.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAJCAYAAAALpr0TAAAABHNCSVQICAgIfAhkiAAAAB9JREFUGJVj5N1w7T8Dw38GZMCIwWdkYGIgEowqxAsAgHkEpaya60gAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27441)">
            <g transform="matrix(58.2002 0 0 68.2002 6138.9 6096.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAYAAAAbvf3sAAAABHNCSVQICAgIfAhkiAAAACBJREFUKJFjFNx45T8DkYCZkYGBiVjFMDCqYVQDtTQAABX5ArXBpwTSAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27453)">
            <g transform="matrix(164.2 0 0 193.2 5941.9 6048.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAoCAYAAACb3CikAAAABHNCSVQICAgIfAhkiAAAAEVJREFUWIXtzjEBgCAAAEEkBP0z2MREMrFcAR3+Ety17ucdPzC/DhxFVERFVERFVERFVERFVERFVERFVERFVERFVERFtAHu5QLoXXYkkgAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27465)">
            <g transform="matrix(63.2002 0 0 58.2002 6090.9 6149.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAMCAYAAAC5tzfZAAAABHNCSVQICAgIfAhkiAAAACVJREFUKJFjFNt06T8DVoApzMjIyMDAwMDAhF0DfjCqaVQTKgAA8n0Ds/AVrVsAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27477)">
            <g transform="matrix(73.2002 0 0 107.2 6080.9 6096.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAWCAYAAAAfD8YZAAAABHNCSVQICAgIfAhkiAAAACVJREFUOI1jFNt08T8DHsDIyIhTjgmfRkJgVPOo5lHNo5qHsmYAGZ8CxwPgT7wAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27489)">
            <g transform="matrix(34.2002 0 0 29.2002 6090.9 6178.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAGCAYAAAAPDoR2AAAABHNCSVQICAgIfAhkiAAAABZJREFUCJlj/P///38GHIAJl8RASQIAsDIECPousAUAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27501)">
            <path
              fill="url(#linearGradient27509)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5881.57 5332.31c-63.36 0-124.17 10.59-180.98 29.93 56.97-19.33 118.01-29.85 181.5-29.92-.17 0-.35-.01-.52-.01"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27519)">
            <path
              fill="url(#linearGradient27527)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5882.09 5332.32c-63.49.07-124.53 10.59-181.5 29.92-22.56 7.67-44.49 16.74-65.69 27.06-9.2 11.75-18.51 23.64-27.83 35.56l57.89 100.37c63.74-37.01 137.56-58.59 216.61-58.59 80.65 0 155.82 22.49 220.44 60.89l57.63-101.1c-9.23-11.8-18.46-23.59-27.58-35.25-75.38-37.39-160.1-58.78-249.97-58.86"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27537)">
            <path
              fill="url(#linearGradient27545)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6449.39 5892.86v0m.01 1.14v0m.02 2.46v0m0 1.13v0"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27555)">
            <path
              fill="url(#linearGradient27563)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6160.07 5426.99l-57.39 100.24c127.03 75.33 212.46 213.44 212.46 371.79 0 2.99-.41 5.84-.43 8.77l134.33-.68c.04-2.7.38-5.35.38-8.09v-1.1-.33-.81-.32c0-.75-.01-1.48-.02-2.23v-.23c0-.32 0-.65-.01-.97v-.17c-1.45-135.92-50.89-260.14-132.09-356.91-7.75 21.62-16.63 30.97-18.53 32.79l-16 15.38-13.63-17.5c-33.18-42.54-71.26-91.31-109.07-139.63"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27573)">
            <path
              fill="url(#linearGradient27581)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5316.08 5892.85v0m-.01 1.14v0m-.02 2.47v0m0 1.14v0"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27591)">
            <path
              fill="url(#linearGradient27599)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5606.36 5425.76c-38.11 48.73-76.56 97.96-110.02 140.86l-13.65 17.5-15.99-15.38c-1.9-1.82-10.78-11.17-18.53-32.82-81.21 96.78-130.64 221-132.09 356.93v.15c-.01.33-.01.66-.01.99v.22c-.01.75-.01 1.5-.02 2.25v2.56c0 2.58.38 5.05.38 7.63l134.31.19c-.06-2.61-.39-5.15-.39-7.82 0-159.36 86.51-298.29 214.91-373.26l-.3-.53c-.37.21-.73.42-1.09.63l-57.51-100.1"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27609)">
            <path
              fill="url(#linearGradient27617)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5607.07 5424.86c-.24.31-.46.59-.71.9l57.51 100.1c.36-.21.72-.42 1.09-.63l-57.89-100.37"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27627)">
            <path
              fill="url(#linearGradient100536)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6286.09 5874.43c-.05 0-.13.06-.25.19-1.38 1.41-8.09 9.06-18.46 21.02-.12 3.84-.3 7.68-.53 11.49 12.38-20.16 19.83-32.71 19.24-32.7"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27645)">
            <g transform="matrix(135.2 0 0 222.2 6138.9 5885.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAuCAYAAAA7v3kyAAAABHNCSVQICAgIfAhkiAAAAD1JREFUWIXtzaEBACAMwLCN/z/hLBRXgACJZC41lck+5oqyVkTk/anVYe+AQCAQCAQCgUAgEAgEAoFA4J82v9IF0UryapAAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27657)">
            <g transform="matrix(63.2002 0 0 82.2002 6090.9 6029.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAARCAYAAAAG/yacAAAABHNCSVQICAgIfAhkiAAAACNJREFUKJFjXP3oyX8GrIARuzADAwMTThk8YFTTqKZRTVgBAFORA5PKIgqaAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27669)">
            <g transform="matrix(101.2 0 0 106.2 6047.9 6087.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAWCAYAAAAvg9c4AAAABHNCSVQICAgIfAhkiAAAACRJREFUOI1jXP3oyX8GKgMmahs4auiooaOGjho6auiooYPZUAC8ggOc93GcbAAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27681)">
            <path
              fill="url(#linearGradient100538)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5852.98 6464.99c-1.5 2.7-2.95 5.36-4.35 7.94 2.76.17 5.53.31 8.3.43l6.57-7.93c-3.51-.11-7.03-.26-10.52-.44"
            ></path>
          </g>
        </g>
        <path
          fill="#b7bdca"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M100.033 49.48l-.003-.006a25.7 25.7 0 01.291-.014l.004.005-.292.015"
        ></path>
        <path
          fill="#b8ccdb"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M100.03 49.474c-.198-.365-.37-.694-.507-.977l.798.963a25.22 25.22 0 00-.291.014"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27703)">
            <path
              fill="url(#linearGradient100540)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6058.35 6224.45a367.9 367.9 0 01-16.36 7.92 369.685 369.685 0 01-62.51 22.06c-14.38 22.95-30.3 48.56-46.32 74.69 17.09-1.8 33.86-4.6 50.29-8.35l77.21-93.12c-.82-1.13-1.59-2.2-2.31-3.2m-205.2 240.23c-.06.1-.12.2-.17.31 3.49.18 7.01.33 10.52.44l.17-.2c-3.51-.15-7.03-.34-10.52-.55"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27721)">
            <path
              fill="url(#linearGradient100542)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5983.45 6320.77c-16.43 3.75-33.2 6.55-50.29 8.35-29.33 47.85-58.97 97.42-80.01 135.56 3.49.21 7.01.4 10.52.55l119.78-144.46"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27739)">
            <g transform="matrix(35.2002 0 0 25.2002 6032.9 6216.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAFCAYAAACJmvbYAAAABHNCSVQICAgIfAhkiAAAABVJREFUCJljXP342X8GHIAJlwQNJQHueQN9foZ5zgAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27751)">
            <g transform="matrix(77.2002 0 0 34.2002 5970.9 6226.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAHCAYAAAABIM1CAAAABHNCSVQICAgIfAhkiAAAACBJREFUGJVjXP34xX8GOGBkYGBA4hIBmEhSPWoAbQwAAN5zBIMrHSC7AAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27763)">
            <g transform="matrix(21.2002 0 0 20.2002 5979.9 6226.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAABHNCSVQICAgIfAhkiAAAABZJREFUCJljXP34+X8GJMDEgAYICwAA4wIDfOXVQ8oAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27775)">
            <g transform="matrix(53.2002 0 0 29.2002 5970.9 6231.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAGCAYAAAAVMmT4AAAABHNCSVQICAgIfAhkiAAAABZJREFUGJVj/P///38GIgETsQqHqmIAMXAECHAUd5UAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27787)">
            <g transform="matrix(29.2002 0 0 25.2002 5970.9 6235.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAFCAYAAABmWJ3mAAAABHNCSVQICAgIfAhkiAAAABVJREFUCJlj/P///38GLIAJmyCVJQDrEwQGmj+dQQAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27799)">
            <g transform="matrix(59.2002 0 0 35.2002 6008.9 6216.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAHCAYAAAA8sqwkAAAABHNCSVQICAgIfAhkiAAAABZJREFUGJVjXP3oyX8GEgATKYpHrAYAnO0DfkIUhYUAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27811)">
            <g transform="translate(5984.9 6168.9) scale(78.2002)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAACFJREFUOI1jXP3o6X8GggC3EibCmvGDUQNGDRg1YLAYAAAdKwSQD99jagAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27823)">
            <g transform="matrix(83.2002 0 0 45.2002 5984.9 6211.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAJCAYAAADU6McMAAAABHNCSVQICAgIfAhkiAAAABlJREFUKJFj/P///38GCgETpQaMGjIiDAEAuR8EDkNmu4AAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27835)">
            <g transform="matrix(125.2 0 0 164.2 5826.9 5885.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAiCAYAAABBY8kOAAAABHNCSVQICAgIfAhkiAAAADhJREFUSIntzaERACAMALGW/TdhLBRTgADPUZ03L5N9zBWlVkTk/btWQ/4DgUAgEAgEAoFAINBpA39KBbl/6zYwAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27847)">
            <g transform="matrix(54.2002 0 0 63.2002 5931.9 6000.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAANCAYAAAB/9ZQ7AAAABHNCSVQICAgIfAhkiAAAABhJREFUKJFjXP3o6X8GIgETsQpHFY84xQD0hgOLMxkOOgAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27859)">
            <g transform="matrix(29.2002 0 0 44.2002 5927.9 6029.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAJCAYAAAARml2dAAAABHNCSVQICAgIfAhkiAAAABZJREFUCJljXP342X8GLIAJm+AQlAAAB+sDhelE5JAAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27871)">
            <g transform="matrix(126.2 0 0 149.2 5936.9 6034.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAfCAYAAAD5h919AAAABHNCSVQICAgIfAhkiAAAADRJREFUSIljXP3o6X8GqgHcRjFRzxL8YNSiUYtGLRq1aNSiUYtGLRq1aNSiUYtGLRpmFgEArnwErik9skUAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27883)">
            <path
              fill="url(#linearGradient27889)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6209.98 6411.3c-3.83 2.37-7.72 4.72-11.6 7.01 19.08 26.38 35.41 48.89 45.28 62.43.78-.49 1.51-.96 2.28-1.45-7.8-14.85-20.76-39.34-35.96-67.99"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27899)">
            <path
              fill="url(#linearGradient27905)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6245.94 6479.29c-.77.49-1.5.96-2.28 1.45 6.31 8.64 9.99 13.63 10.09 13.63v-.02c-.47-1.04-3.27-6.42-7.81-15.06"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27915)">
            <path
              fill="url(#linearGradient100544)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6190.65 6374.9c-5 3.24-10.04 6.4-15.14 9.49l1.1 1.81-1.02.6c1.71 2.38 3.42 4.74 5.12 7.09 5.1-2.98 10.16-6.03 15.17-9.15-1.73-3.26-3.47-6.53-5.23-9.84"
            ></path>
          </g>
        </g>
        <path
          fill="#b7bdca"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M112.283 52.591c-.177-.11-.355-.217-.535-.322l.054-.075c.178.1.354.202.529.307l-.048.09m.494-.93c-.135-.085-.272-.17-.408-.251l.002-.003c.137.08.274.164.41.247l-.004.007"
        ></path>
        <path
          fill="#b8ccdb"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M112.33 52.5a21.277 21.277 0 00-.528-.306c.194-.27.384-.532.567-.784.136.081.273.166.408.25l-.446.84"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27937)">
            <path
              fill="url(#linearGradient100546)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6098.02 6200.81a373.23 373.23 0 01-30.79 18.91l-6.57 7.93c8.22 11.39 20.9 28.97 35.94 49.8 2.61-1.44 5.19-2.9 7.76-4.39h3.31l67.84 111.33c5.1-3.09 10.14-6.25 15.14-9.49-35.81-67.39-76.57-143.94-92.63-174.09"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27955)">
            <path
              fill="url(#linearGradient27963)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6175.51 6384.39c-.4.24-.77.46-1.16.7.41.57.82 1.14 1.24 1.71l1.02-.6-1.1-1.81"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27973)">
            <path
              fill="url(#linearGradient100548)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6107.67 6273.06h-3.31c-2.57 1.49-5.15 2.95-7.76 4.39 22.96 31.82 51.4 71.2 77.75 107.64.39-.24.76-.46 1.16-.7l-67.84-111.33"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath27991)">
            <g transform="matrix(44.2002 0 0 35.2002 6061.9 6192.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAHCAYAAADam2dgAAAABHNCSVQICAgIfAhkiAAAABtJREFUGJVjXP342X8GdPAfVYgJQwEWMGQVAQBTxAV/UBb/bAAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath28003)">
            <g transform="matrix(44.2002 0 0 40.2002 6061.9 6187.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAICAYAAAArzdW1AAAABHNCSVQICAgIfAhkiAAAABlJREFUGJVjXP3oyX8GOGBkwAaYsIqOKEUA/BcDgcjbQscAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath28015)">
            <g transform="translate(6066.9 6178.9) scale(39.2002)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAABHNCSVQICAgIfAhkiAAAABZJREFUGJVjXP3oyX8GPIAJn+TwUQAAi94DgI5+HGkAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath28027)">
            <g transform="matrix(44.2002 0 0 35.2002 6061.9 6192.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAHCAYAAADam2dgAAAABHNCSVQICAgIfAhkiAAAABZJREFUGJVj/P///38GAoCJkIIhrQgABlIECsZzs4UAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath28039)">
            <path
              fill="url(#linearGradient28047)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6067.23 6219.72c-2.94 1.62-5.9 3.19-8.88 4.73.72 1 1.49 2.07 2.31 3.2l6.57-7.93"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath28057)">
            <g transform="matrix(25.2002 0 0 21.2002 6051.9 6211.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAECAYAAABGM/VAAAAABHNCSVQICAgIfAhkiAAAABVJREFUCJljfPbt+38GNMCELkCaIAA46APaSHfHkgAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath28069)">
            <g transform="matrix(25.2002 0 0 21.2002 6051.9 6211.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAECAYAAABGM/VAAAAABHNCSVQICAgIfAhkiAAAABVJREFUCJljfPbt+38GNMCELkCaIAA46APaSHfHkgAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath28081)">
            <g transform="matrix(77.2002 0 0 92.2002 6018.9 6135.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAATCAYAAACZZ43PAAAABHNCSVQICAgIfAhkiAAAAB9JREFUOI1jfPbt+38GCgATJZpHDRg1YNSAUQOoagAAxe0D+E6YGgEAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath28093)">
            <g transform="matrix(34.2002 0 0 29.2002 6047.9 6202.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAGCAYAAAAPDoR2AAAABHNCSVQICAgIfAhkiAAAABZJREFUCJlj/P///38GHIAJl8RASQIAsDIECPousAUAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M109.21 57.66c-2.078-1.616-1.695-6.168-1.717-7.452v1.23c-.006-.2-.014-.408-.014-.454v-.776c-.005.369-.032.95-.109 1.626 0 0-.614 4.565-1.707 5.518-2.466 2.152-8.674 1.744-6.29 1.795 8.034.172 8.034 8.023 8.106 10.594v-1.3l.014.224v1.076c.171-6.095.148-9.947 7.164-10.465 2.318-.174-3.03.27-5.447-1.617"
        ></path>
        <path
          fill="#ef391f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M105.319 100.345c.97.244 2.81.727 6.245 1.677 2.703.748 5.03 1.112 7.117 1.112 3.05 0 5.487-.788 7.448-2.406 1.954-1.612 2.794-2.884 3.154-3.655-4.617.498-20.45 2.2-21.201 2.2l-.07-.003c-1.326-.1-2.201.528-2.693 1.075m13.362 4.2c-2.216 0-4.667-.38-7.494-1.163-6.15-1.701-7.111-1.885-7.149-1.892l-.885-.164.366-.821c.051-.113 1.333-2.872 4.575-2.644.802-.026 13.62-1.389 22.087-2.304l.778-.084.004.782c0 .236-.102 2.399-3.935 5.56-2.225 1.837-4.955 2.73-8.347 2.73"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath30637)">
            <path
              fill="url(#linearGradient30645)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6377.5 4932.05c-62.63 0-131.78 11.4-207.07 32.23-56.47 15.62-97.61 26.76-127.49 34.69 2.59 4.05 5.02 8.21 7.3 12.46 29.74 6.75 70.43 15.78 125.91 27.78 83.42 18.05 153.42 42.47 210.5 73.59 158.77 16.82 318.99 34.14 318.99 34.14s.24-55.92-104.25-142.11c-60.98-50.33-136.01-72.78-223.89-72.78m-187.17 91.36c-30.1 0-49.93-9.76-39.55-19.51 10.38-9.75 50.99-19.51 141.81-19.51 13.3 0 27.69.21 43.21.66 235.25 6.82 341.97 138.8 341.97 138.8s1.65 1.26-.95 1.26c-5.11 0-26.57-4.86-108.93-33.64-124.32-43.43-370.68-68.23-370.68-68.23-2.35.11-4.64.17-6.88.17"
            ></path>
          </g>
        </g>
        <path
          fill="#ef391f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M124.685 86.065c-5.84 3.916-17.38 11.637-17.82 11.827-1.228.53-1.703 1.491-1.885 2.202.973-.235 2.827-.661 6.309-1.414 6.734-1.458 10.642-3.972 12.299-7.912.984-2.34 1.136-3.857 1.097-4.703m-21.169 15.904l-.056-.897c-.007-.129-.152-3.164 2.823-4.466.715-.406 11.422-7.56 18.49-12.298l.65-.437.367.692c.11.21 1.024 2.171-.902 6.752-1.825 4.342-6.175 7.202-13.301 8.744-6.236 1.35-7.174 1.632-7.21 1.644l-.86.266"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath30657)">
            <path
              fill="url(#linearGradient30665)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6060.56 5034.2c7.78 20.72 12.04 43.15 12.04 66.56 0 4.6-.17 9.18-.49 13.71 9.88 5.83 20.64 12.17 32.36 19.05 76.95 45.16 133.69 92.97 170.86 144.25 138.81 92.61 286.04 191.32 286.04 191.32s26.17-49.42-26.33-174.28c-52.48-124.83-179.36-196.35-362.83-236.05-46.99-10.17-83.43-18.21-111.65-24.56m493.31 404.04s-225.55-232.55-382.78-300.44c-88.53-38.23-95.5-49.65-72.19-49.65 18.08 0 54.38 6.87 84.97 13.42 70 15 373.32 145 370 336.67"
            ></path>
          </g>
        </g>
        <path
          fill="#ef391f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M115.299 83.193c-4.01 5.14-10.011 12.813-10.29 13.061a2.36 2.36 0 00-.828 1.743c.72-.443 1.978-1.2 4.163-2.482 4.644-2.726 6.93-5.537 7.196-8.847.14-1.726-.04-2.822-.241-3.475m-11.964 17.062l-.334-.833c-.039-.098-.929-2.427 1.049-4.203.482-.542 6.712-8.503 10.817-13.766l.481-.618.565.543c.14.134 1.354 1.426 1.034 5.403-.302 3.757-2.882 7.012-7.889 9.95-4.319 2.536-4.964 2.987-4.99 3.005l-.733.519"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath30677)">
            <path
              fill="url(#linearGradient30685)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6069.34 5135.88a188.364 188.364 0 01-19.97 55.8c53.61 28.28 160.14 100.86 192.45 174.89 48.71 111.67 41.93 158.34 41.93 158.34s-174.13-245.77-242.19-320.22c-4.52 6.87-9.47 13.45-14.82 19.67 87.45 110.73 258.43 329.96 258.43 329.96s31.82-30.58 23.25-137.12c-8.56-106.54-86.02-191.44-213.79-266.44-8.98-5.27-17.39-10.22-25.29-14.88"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath30695)">
            <path
              fill="url(#linearGradient30703)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6049.37 5191.68c-2.43 4.45-5.04 8.78-7.81 13.01 68.06 74.45 242.19 320.22 242.19 320.22s6.78-46.67-41.93-158.34c-32.31-74.03-138.84-146.61-192.45-174.89"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath30713)">
            <path
              fill="url(#linearGradient30721)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6098.9 5088.15c-23.31 0-16.34 11.42 72.19 49.65 157.23 67.89 382.78 300.44 382.78 300.44 3.32-191.67-300-321.67-370-336.67-30.59-6.55-66.89-13.42-84.97-13.42"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath30731)">
            <path
              fill="url(#linearGradient30739)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6292.59 4984.39c-90.82 0-131.43 9.76-141.81 19.51-10.38 9.75 9.45 19.51 39.55 19.51 2.24 0 4.53-.06 6.88-.17 0 0 246.36 24.8 370.68 68.23 82.36 28.78 103.82 33.64 108.93 33.64 2.6 0 .95-1.26.95-1.26s-106.72-131.98-341.97-138.8c-15.52-.45-29.91-.66-43.21-.66"
            ></path>
          </g>
        </g>
        <path
          fill="#ef391f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M94.459 99.27l-.069.003c-.752 0-16.585-1.702-21.201-2.2.36.771 1.2 2.043 3.153 3.655 1.962 1.619 4.399 2.406 7.45 2.406 2.085 0 4.413-.364 7.116-1.112 3.434-.95 5.274-1.433 6.246-1.677-.492-.547-1.368-1.175-2.695-1.075m-19.015 2.546c-3.833-3.162-3.935-5.325-3.934-5.56l.003-.783.778.084c8.467.915 21.284 2.279 22.087 2.304 3.242-.228 4.524 2.531 4.576 2.644l.366.821-.886.164c-.037.007-1 .19-7.15 1.892-2.827.782-5.277 1.163-7.492 1.163-3.392 0-6.123-.893-8.348-2.73"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath30751)">
            <path
              fill="url(#linearGradient30759)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5387.97 4932.05c-87.87.01-162.91 22.45-223.89 72.78-104.48 86.19-104.25 142.11-104.25 142.11s160.25-17.32 318.99-34.14c57.08-31.12 127.08-55.54 210.5-73.59 55.48-12 96.16-21.03 125.91-27.78 2.27-4.25 4.72-8.42 7.3-12.47-29.88-7.92-71.02-19.06-127.49-34.68-75.29-20.83-144.44-32.23-207.07-32.23m-299.31 193.06c-2.6 0-.96-1.26-.96-1.26s106.71-131.98 341.98-138.8c15.51-.45 29.9-.66 43.2-.66 90.82 0 131.43 9.76 141.81 19.51 10.39 9.75-9.45 19.51-39.55 19.51-2.24 0-4.53-.06-6.87-.17 0 0-246.37 24.8-370.68 68.23-82.37 28.78-103.83 33.64-108.93 33.64"
            ></path>
          </g>
        </g>
        <path
          fill="#ef391f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M78.884 90.768c1.656 3.94 5.565 6.454 12.299 7.912 3.481.753 5.336 1.18 6.31 1.414-.183-.71-.658-1.672-1.887-2.202-.44-.19-11.98-7.911-17.82-11.827-.038.846.114 2.363 1.098 4.703m19.212 10.935c-.037-.012-.975-.295-7.211-1.644-7.126-1.542-11.477-4.402-13.302-8.744-1.926-4.58-1.012-6.543-.901-6.752l.366-.692.65.437C84.766 89.047 95.474 96.2 96.19 96.606c2.975 1.302 2.831 4.337 2.824 4.466l-.057.897-.86-.266"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath30771)">
            <path
              fill="url(#linearGradient30779)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5704.91 5034.2c-28.22 6.35-64.66 14.4-111.64 24.56-183.48 39.7-310.36 111.22-362.83 236.05-52.5 124.86-26.33 174.28-26.33 174.28s147.21-98.7 286.02-191.31c37.17-51.29 93.91-99.09 170.87-144.26 11.71-6.88 22.47-13.22 32.36-19.05-.32-4.53-.49-9.11-.49-13.71 0-23.41 4.26-45.84 12.04-66.56m-493.3 404.04c-3.33-191.67 300-321.67 370-336.67 30.58-6.55 66.89-13.42 84.97-13.42 23.31 0 16.35 11.42-72.19 49.65-157.23 67.89-382.78 300.44-382.78 300.44"
            ></path>
          </g>
        </g>
        <path
          fill="#ef391f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M86.932 86.668c.265 3.31 2.552 6.121 7.196 8.847a260.805 260.805 0 014.164 2.482 2.36 2.36 0 00-.829-1.743c-.278-.248-6.28-7.92-10.29-13.06-.201.652-.38 1.748-.241 3.474m11.472 13.068c-.026-.018-.67-.469-4.99-3.004-5.007-2.939-7.587-6.194-7.889-9.951-.32-3.977.894-5.269 1.034-5.403l.564-.543.482.618c4.105 5.263 10.335 13.224 10.818 13.766 1.977 1.776 1.087 4.105 1.048 4.203l-.334.832-.733-.518"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath30791)">
            <path
              fill="url(#linearGradient30799)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5696.13 5135.89c-7.89 4.65-16.31 9.61-25.28 14.87-127.77 75-205.25 159.9-213.8 266.44-8.56 106.54 23.24 137.12 23.24 137.12s170.98-219.21 258.44-329.96c-5.35-6.22-10.3-12.79-14.82-19.67-68.06 74.46-242.18 320.22-242.18 320.22s-6.79-46.67 41.93-158.34c32.31-74.03 138.83-146.6 192.44-174.88a188.465 188.465 0 01-19.97-55.8"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath30809)">
            <path
              fill="url(#linearGradient30817)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5716.1 5191.69c-53.61 28.28-160.13 100.85-192.44 174.88-48.72 111.67-41.93 158.34-41.93 158.34s174.12-245.76 242.18-320.22c-2.77-4.22-5.38-8.56-7.81-13"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath30827)">
            <path
              fill="url(#linearGradient30835)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5666.58 5088.15c-18.08 0-54.39 6.87-84.97 13.42-70 15-373.33 145-370 336.67 0 0 225.55-232.55 382.78-300.44 88.54-38.23 95.5-49.65 72.19-49.65"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath30845)">
            <path
              fill="url(#linearGradient30853)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5472.88 4984.39c-13.3 0-27.69.21-43.2.66-235.27 6.82-341.98 138.8-341.98 138.8s-1.64 1.26.96 1.26c5.1 0 26.56-4.86 108.93-33.64 124.31-43.43 370.68-68.23 370.68-68.23 2.34.11 4.63.17 6.87.17 30.1 0 49.94-9.76 39.55-19.51-10.38-9.75-50.99-19.51-141.81-19.51"
            ></path>
          </g>
        </g>
        <path
          fill="#ef391f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M101.236 92.601a5.293 5.293 0 00-5.287 5.286 5.293 5.293 0 005.287 5.287 5.293 5.293 0 005.287-5.287 5.292 5.292 0 00-5.287-5.286"
        ></path>
        <path
          fill="#ef391f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M101.236 94.012a3.88 3.88 0 00-3.876 3.875 3.88 3.88 0 003.876 3.876 3.88 3.88 0 003.876-3.876 3.88 3.88 0 00-3.876-3.875m0 10.573a6.706 6.706 0 01-6.698-6.698 6.706 6.706 0 016.698-6.697 6.705 6.705 0 016.698 6.697 6.705 6.705 0 01-6.698 6.698"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath30867)">
            <path
              fill="url(#linearGradient30875)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5880.22 4963.29c-36.03 0-69.01 13-94.52 34.56-1.43 1.31-2.82 2.65-4.19 4.02-25.32 25.32-40.97 60.25-40.97 98.89 0 38.63 15.65 73.56 40.97 98.89 23.66 23.65 55.69 38.85 91.3 40.76.1-.18.19-.35.29-.53-71.52-3.7-128.37-62.86-128.37-135.31v-.53-.15-.4-.14c0-.37.01-.72.01-1.08.01-.03.01-.06.01-.09 0-.17 0-.33.01-.49v-.06c1.04-48.68 27.75-91.04 67.15-114.08v-.01c.04-.02.09-.05.13-.07 8.3-4.85 17.16-8.83 26.47-11.84 13.05-4.23 26.96-6.54 41.43-6.54h.28c73.86 0 133.89 59.08 135.45 132.54v.08c.01.15.01.3.01.46v.12c.01.35.02.7.02 1.06V5104.57c0 47.7-24.63 89.63-61.86 113.77.19.37.39.74.58 1.1 9.04-5.64 17.38-12.29 24.89-19.79 25.32-25.33 40.96-60.26 40.96-98.89 0-38.62-15.63-73.55-40.94-98.87-26.08-23.97-60.87-38.6-99.11-38.6m70.07 257.87c-20.17 11.93-43.63 18.9-68.79 18.9h-1.28c-1.54 0-3.07-.02-4.6-.07l-.44.53c1.73.06 3.47.09 5.22.09 25.63 0 49.63-6.89 70.28-18.91l-.39-.54"
            ></path>
          </g>
        </g>
        <path
          fill="#262a49"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M106.264 97.887h-.176a4.916 4.916 0 01-1.445 3.489 4.92 4.92 0 01-3.49 1.445 4.918 4.918 0 01-3.488-1.445 4.916 4.916 0 01-1.446-3.489c0-1.362.553-2.595 1.446-3.488a4.918 4.918 0 013.488-1.445 4.92 4.92 0 013.49 1.445 4.917 4.917 0 011.445 3.488h.353a5.287 5.287 0 10-10.574.001 5.287 5.287 0 0010.574 0h-.177"
        ></path>
        <path
          fill="#21437e"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M95.981 97.823a5.51 5.51 0 01-.005-.136c-.001.043-.006.085-.006.128a5.177 5.177 0 017.841-4.44l-.136.187a5.145 5.145 0 00-2.747-.654l-.19-.23c.032.067.073.146.12.233a5.174 5.174 0 00-4.877 4.912m10.331-.004a5.178 5.178 0 00-2.512-4.184c.036-.07.072-.137.107-.201a5.173 5.173 0 012.417 4.381c0-.043-.005-.085-.007-.128 0 .044-.003.088-.005.132"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath30889)">
            <path
              fill="url(#linearGradient30897)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5880.4 4960.9c-36.54.01-69.78 14.01-94.7 36.95 25.51-21.56 58.49-34.56 94.52-34.56 38.24 0 73.03 14.63 99.11 38.6l-.02-.02c-25.33-25.32-60.27-40.96-98.91-40.97"
            ></path>
          </g>
        </g>
        <path
          fill="#21232c"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M101.147 102.992a5.177 5.177 0 01-5.177-5.177c0 .044.005.088.006.133l.005-.125a5.172 5.172 0 001.832 3.695 4.917 4.917 0 003.34 1.303 4.92 4.92 0 003.49-1.445c.971-.893 1.6-2.151 1.67-3.557l.004.129c.001-.045.007-.089.007-.133a5.177 5.177 0 01-5.177 5.177"
        ></path>
        <path
          fill="#1f3151"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M106.317 97.948a5.464 5.464 0 00-.005-.13l.005-.13c.001.042.007.084.007.127 0 .044-.005.088-.007.133m-10.34 0c-.002-.045-.007-.089-.007-.133 0-.043.005-.085.006-.128l.005.136a7.31 7.31 0 00-.005.125"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath30911)">
            <path
              fill="url(#linearGradient30919)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5880.22 4969.09h-.16c25.02.02 48.38 6.95 68.48 18.79l-15.89 27.88c-15.45-9.18-33.43-14.56-52.71-14.56-18.91 0-36.56 5.16-51.79 14.01l.07.12c-30.7 17.93-51.37 51.14-51.37 89.24l.08 1.87-32.11-.04-.09-1.83c0 72.45 56.85 131.61 128.37 135.31a.3.3 0 00.04-.08c-19.14-1.18-37.18-6.4-53.37-14.71l16.66-27.58c13.65 6.62 28.89 10.45 45.07 10.45 3.64 0 7.24-.19 10.78-.56 3.83-6.25 7.63-12.37 11.07-17.86a89.28 89.28 0 01-20.1 2.73h-.05c-.13 0-.27.01-.41.01h-.5c-.03 0-.05 0-.07.01h-.92c-48.96 0-88.75-39.33-89.47-88.12v-.02c-.01-.28-.01-.57-.01-.85v-.08-.41-.33-.09-.08-.17-.14-.2-.14c0-.06 0-.12.01-.18v-.05-.11-.31c0-.06.01-.12.01-.18v-.16c0-.06 0-.13.01-.19v-.12-.21c.01-.04.01-.08.01-.11.58-19.18 7.22-36.82 18.05-51.11 16.23-22.7 42.81-37.49 72.83-37.49 49.43 0 89.49 40.06 89.49 89.48 0 .95-.02 1.9-.05 2.85 2.48-2.87 4.09-4.7 4.42-5.03.03-.03.05-.05.06-.05.14 0-1.64 3-4.61 7.83-1.23 20.01-9.04 38.24-21.29 52.55a91.408 91.408 0 01-6.94 7.64v.06c-3.74 3.66-7.8 6.99-12.13 9.95 3.84 7.21 13.59 25.51 22.15 41.62 37.23-24.14 61.86-66.07 61.86-113.77l-.1 1.93-32.1.17.1-2.1c0-37.86-20.43-70.87-50.79-88.89l15.94-27.84c39.23 23.09 65.89 65.24 66.92 113.79-1.56-73.46-61.59-132.54-135.45-132.54m-41.71 6.54c-9.31 3.01-18.17 6.99-26.47 11.84 8.31-4.83 17.17-8.82 26.47-11.84m-26.6 11.92c-39.4 23.04-66.11 65.4-67.15 114.08 1.04-48.68 27.82-90.93 67.22-113.96l-.07-.13m-67.15 114.15c-.01.16-.01.32-.01.49 0-.16 0-.33.01-.49m270.91.02c.01.15.01.3.01.46 0-.16 0-.31-.01-.46m-270.93.56c0 .36-.01.71-.01 1.08 0-.36.01-.72.01-1.08m270.94.02c.01.35.02.7.02 1.06 0-.36-.01-.71-.02-1.06m-270.95 1.2v0m270.97.01v0m-270.97.54v0m270.97 0v0m-92.94 79.09l-18.46 22.27c9.6-2.19 18.68-5.72 27.08-10.37l-8.62-11.9m-47.1 56.81l-.04.05c1.53.05 3.06.07 4.6.07h.65c-1.75-.01-3.48-.05-5.21-.12"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath30929)">
            <g transform="matrix(178.2 0 0 164.2 5802.9 5002.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAiCAYAAADYmxC7AAAABHNCSVQICAgIfAhkiAAAAHFJREFUWIXtzrENw0AMQ9FPK95/Am/mWcIUjnEuWbrgq3QSDvjaj9Me8Ed4wBt4BBj4cjHLc368bdA1ChgZ0L1CgLR+3Ze1E/OfNl6oUalGpRqValSqUalGpRqValSqUalGpRqValSqUalGpRqValTqB+LfD9fYW8Q6AAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath30941)">
            <path
              fill="url(#linearGradient30949)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5949.99 5220.75c-20.2 12.15-43.85 19.19-69.12 19.31h.63c25.16 0 48.62-6.97 68.79-18.9l-.3-.41"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath30959)">
            <path
              fill="url(#linearGradient30967)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5931.38 5195.03a103.31 103.31 0 01-27.08 10.37l-28.64 34.54c1.73.07 3.46.11 5.21.12 25.27-.12 48.92-7.16 69.12-19.31l-18.61-25.72m-94.95 2.48l-16.66 27.58c16.19 8.31 34.23 13.53 53.37 14.71 5.04-9.11 12.12-20.96 19.14-32.4-3.54.37-7.14.56-10.78.56-16.18 0-31.42-3.83-45.07-10.45"
            ></path>
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M98.245 97.97a3.157 3.157 0 014.874-2.646 3.136 3.136 0 00-1.934-.666 3.156 3.156 0 00-1.717 5.804 3.147 3.147 0 01-1.223-2.492"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath30979)">
            <g transform="translate(5783.9 5093.9) scale(106.2)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAABHNCSVQICAgIfAhkiAAAALRJREFUOI3tlUFuAyEQBKtgrUj+fL6XzzCdA9i760SWcshtR0KA6C4GkAbvn1/JrVObjA9Jl9ygOtAABntktRkSBJrnnof1P+ICX+ALfIEv8NsIkOzVevs7wudolv2QNCQgmHfg00fhr5Ip8CCXTDbNsAmkCqthLe2AphRAP95W/YAeNwquE8jmKLTBKBx9T9VpDYBrYnuB5gD2uRbCxih0mh0y3zNL6pQ5fQHor5k+gDnBvwFMb0a7ugRCFQAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath30991)">
            <g transform="translate(5783.9 5093.9) scale(106.2)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAABHNCSVQICAgIfAhkiAAAACRJREFUOI1j/P///38GGgAmWhg6avCowaMGjxo8avCowSPJYAAhLQQoiAqs0AAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31003)">
            <g transform="matrix(93.2002 0 0 154.2 5859.9 5007.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAgCAYAAADwvkPPAAAABHNCSVQICAgIfAhkiAAAAT5JREFUSIntVlGShSAMS3kcYO9/i73Ku49kP9pKivp2Z9ZPO6MglJCmWLWv7zchZuDeM50A0ayOuNds22H2H/aAPWAP2C3GO8EAoB938DpgsVta1pARg80mo/S/ZEa58nnj7A/ZadBJdFIql5XSdrlJctlIYUx0SAmkYGkd1FDmGKOdsvTKRZTiUlWNcB4JY1KVJUzdcrqwjCU4LW5W/Qzm2SRtD4ugh2v6DbhiXNn3jLkIFo5TF/eyAho3EbdvBF42hZwiSJhWlUosD39iNwAYcRWsQ5ZdowFiHFQNZhrlJhPK1gAwMmXLt1OPTSeD8vL+jKCd7a7Y2aGLgZadBA2lnSm9XSXISNacdT+Iqk8IfcIUmC9zrlApWh4B1rXYD3MkLFlkstbsE4Y+CPkh4YnolcknazuLPy/5Bewu+wEGX5q5oUj4swAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31015)">
            <g transform="matrix(29.2002 0 0 25.2002 5922.9 5160.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAFCAYAAABmWJ3mAAAABHNCSVQICAgIfAhkiAAAACJJREFUCJljFNhw+T8DAwMDAyMjAwMDlMnAyMDEgANQUQIAq6cDn1GUCV0AAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31027)">
            <g transform="matrix(125.2 0 0 106.2 5783.9 5093.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAWCAYAAADeiIy1AAAABHNCSVQICAgIfAhkiAAAAFVJREFUSIntzbENw1AMA9ETqT9DpsyM2Ux04cpdKlc6gAC7V5/vL2kzFnOatEmb6WKOiYtYpIuomCOi+yOYLlARQVzcDZDHxEsttNBCCy200EIL/dMFl2sYrwzWQ8UAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31039)">
            <g transform="matrix(111.2 0 0 164.2 5802.9 5031.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAiCAYAAAC0nUK+AAAABHNCSVQICAgIfAhkiAAAAE1JREFUSIntzMENgEAUAtEZt/9CrMpKXDx8WzDxAAnhQp6eV7IENnADmWajsAzCVIAg89f3DixnJYBoOPgwxYsXL168ePHixYsX/w/+AOrID9Q1yBZ4AAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31051)">
            <g transform="matrix(130.2 0 0 168.2 5783.9 5031.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAjCAYAAABl/XGVAAAABHNCSVQICAgIfAhkiAAAACtJREFUSIntzUEBAAAEBDD073xa+NgKrJOkjsxVJJPJZDKZTCaTyWSyp9kCcn0EQlAlxzkAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31063)">
            <g transform="matrix(126.2 0 0 150.2 5787.9 5045.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAfCAYAAAD5h919AAAABHNCSVQICAgIfAhkiAAAAXNJREFUSIntlktywzAMQx+UrHr/e/Q4vUwtdEGJlD9ZdJruzEwyNq0AAsiE0sfnlx8yYIQRIOZH5PIW0wQad4xnFXOtOEY7Zf4pbqKb6Ca6iW6iN8bzvXDn8fAnoppC6+TxxVVR/5JI9N2sM01KSu+G5EpqniA2m4eUSQANQOs4Tb3oEN3F3JJBJ13PbpCCDOChdZHQyHsB8e5KOean2qbjSDfNCDu+YsRmsKH7cCLwudAeO4/XPG2UvS5/QlGTwA0pXN4YfW/Ttex+AEhHsr1ZWixtivxQNM47VhrSR2lnrt6h2H6lslSs8dwsEMixtzYXKcimMqeSqslqqbUzOtVtDsoWdVGe6vpU5fC6czrx5Y5f1dCsyiLafLBlQ5C/hwncx133tG1urAiNy9ILO1twaZA1qgu1gCjJnHUK4M5FTS7UNQ6WbIbvYVs1Q/mdTZJ2FuCKdYx26ijKlqrX8r/gUvebaIGwJyNJ3hdjHr0X9Cp+AHxM3H+VWpTJAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31075)">
            <g transform="translate(5783.9 5093.9) scale(106.2)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAABHNCSVQICAgIfAhkiAAAAL5JREFUOI3tlVsKQjEMRM+kV/e/AbfmSmzGj6T4QBAE/xooNDQ5ybTQ6HS52ofwgHkWBMAEEkhEMgQChAkBgOTyEcIARMeBC/MP2+AN3uAN3uCv5l6g38G2MCIxXt+7C5zA8TlNPGaGmIahBthINTUKbtyTI1bbBVaVkNGkkuMdDjf3TkLuE5Vou0JnRw/g0OwSAXLpqYmVbwro7kt4qOJD5dtCrWpiDmVW6QkKt6DEYwFfn6HbIBvqdQ8YnuB3lJ5YvaVWZaUAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31087)">
            <g transform="matrix(130.2 0 0 159.2 5783.9 5040.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAhCAYAAAAoNdCeAAAABHNCSVQICAgIfAhkiAAAACtJREFUSIntzTEBAAAIAyC1f+fZwNMLCtBJUk/mK5LJZDKZTCaTyWQy2WkB0ucEPsIG0XUAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31099)">
            <g transform="matrix(20.2002 0 0 24.2002 5936.9 5151.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAFCAYAAABirU3bAAAABHNCSVQICAgIfAhkiAAAAB9JREFUCJlj5N1w7T8Dw38GRob/DIwMjAxMDGiADAEAbN4EncO9uX0AAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31111)">
            <g transform="translate(5936.9 5146.9) scale(25.2002)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAABHNCSVQICAgIfAhkiAAAACNJREFUCJljFNh4+T8DAwMDIwMjAwMDAwMzIwMDEwMWQKEgAAsGAqNC6XeyAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31123)">
            <g transform="matrix(49.2002 0 0 54.2002 5888.9 5136.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAALCAYAAABGbhwYAAAABHNCSVQICAgIfAhkiAAAABhJREFUGJVjFNt08T8DEYCJGEWjCgdAIQCfPwKuLHN0jAAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31135)">
            <g transform="matrix(29.2002 0 0 30.2002 5922.9 5155.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAABHNCSVQICAgIfAhkiAAAACNJREFUCJljFN108T8jAyMDBPxnYGBgYGBkZGRgYsAB6CEBAAnjA6fcm6HlAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31147)">
            <g transform="matrix(29.2002 0 0 39.2002 5922.9 5146.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAABHNCSVQICAgIfAhkiAAAAB1JREFUCJljFNt08T8DFDAyMkJZ/xmYGHCAwSkBALh6A6qinzvKAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31159)">
            <g transform="translate(5922.9 5165.9) scale(20.2002)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAABHNCSVQICAgIfAhkiAAAABZJREFUCJlj/P///38GJMDEgAYICwAABl0EBLhJJOwAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31171)">
            <path
              fill="url(#linearGradient31179)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5879.94 4969.09c-14.47 0-28.38 2.31-41.43 6.54 13.09-4.23 27.05-6.53 41.55-6.54h-.12m-67.9 18.38c-.04.02-.09.05-.13.07.04-.02.09-.05.13-.07"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31189)">
            <path
              fill="url(#linearGradient31197)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5880.06 4969.09c-14.5.01-28.46 2.31-41.55 6.54-9.3 3.02-18.16 7.01-26.47 11.84-.04.02-.09.05-.13.08l.07.12c.07-.04.14-.08.22-.13l15.95 27.67c15.23-8.85 32.88-14.01 51.79-14.01 19.28 0 37.26 5.38 52.71 14.56l15.89-27.88c-20.1-11.84-43.46-18.77-68.48-18.79"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31207)">
            <path
              fill="url(#linearGradient31215)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6015.67 5101.63v0m.01.54v0m.02 1.18v0m0 .54v0"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31225)">
            <path
              fill="url(#linearGradient31233)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5948.75 4987.84l-15.94 27.84c30.36 18.02 50.79 51.03 50.79 88.89l-.1 2.1 32.1-.17.1-1.93v-.53-.15-.39-.15c0-.36-.01-.71-.02-1.06v-.12c0-.16 0-.31-.01-.46v-.08c-1.03-48.55-27.69-90.7-66.92-113.79"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31243)">
            <path
              fill="url(#linearGradient31251)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5744.76 5101.63v0m-.01.55c0 .03 0 .06-.01.09.01-.03.01-.06.01-.09m-.02 1.17v0m0 .54v0"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31261)">
            <path
              fill="url(#linearGradient31269)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5811.98 4987.67c-39.4 23.03-66.18 65.28-67.22 113.96v.06c-.01.16-.01.33-.01.49 0 .03 0 .06-.01.09 0 .36-.01.72-.01 1.08V5104.57l.09 1.83 32.11.04-.08-1.87c0-38.1 20.67-71.31 51.37-89.24l-.07-.12c-.09.05-.17.1-.26.15l-15.91-27.69"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31279)">
            <path
              fill="url(#linearGradient31287)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5812.2 4987.54c-.08.05-.15.09-.22.13l15.91 27.69c.09-.05.17-.1.26-.15l-15.95-27.67"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31297)">
            <path
              fill="url(#linearGradient100550)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5976.66 5098.69c-.01 0-.03.02-.06.05-.33.33-1.94 2.16-4.42 5.03-.03.92-.07 1.83-.13 2.75 2.97-4.83 4.75-7.83 4.61-7.83"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31315)">
            <g transform="matrix(44.2002 0 0 68.2002 5936.9 5093.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAOCAYAAAD9lDaoAAAABHNCSVQICAgIfAhkiAAAACJJREFUKJFjXP34xX8GBgYGBgZGBkwAkWLCIoMBRhUNXUUA+38EkaC2rKYAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31327)">
            <g transform="matrix(29.2002 0 0 34.2002 5922.9 5127.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAHCAYAAAArkDztAAAABHNCSVQICAgIfAhkiAAAABlJREFUCJljXP3oyX8GOGCEs5gYcIABlQAAVq8Dfxt7/HAAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31339)">
            <g transform="matrix(35.2002 0 0 39.2002 5912.9 5141.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAABHNCSVQICAgIfAhkiAAAABlJREFUCJljXP3o6X8Ghv8M2AATVtEhKQkA/cIEgFj3EOsAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31351)">
            <path
              fill="url(#linearGradient100552)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5873.1 5239.88c-.1.18-.19.35-.29.53.79.04 1.58.08 2.37.11l.44-.53c-.84-.03-1.68-.07-2.52-.11"
            ></path>
          </g>
        </g>
        <path
          fill="#b7bdca"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M100.886 92.96l-.028-.049.07-.003.041.049-.083.004"
        ></path>
        <path
          fill="#b8ccdb"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M100.859 92.911a6.37 6.37 0 01-.122-.233l.191.23-.07.003"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31373)">
            <path
              fill="url(#linearGradient100554)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5922.21 5182.37a89.051 89.051 0 01-18.86 7.17c-3.44 5.49-7.24 11.61-11.07 17.86 4.08-.43 8.09-1.11 12.02-2l18.46-22.27-.55-.76m-49.07 57.43a.3.3 0 01-.04.08c.84.04 1.68.08 2.52.11l.04-.05c-.84-.04-1.68-.08-2.52-.14"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31391)">
            <path
              fill="url(#linearGradient100556)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5904.3 5205.4c-3.93.89-7.94 1.57-12.02 2-7.02 11.44-14.1 23.29-19.14 32.4.84.06 1.68.1 2.52.14l28.64-34.54"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31409)">
            <g transform="translate(5912.9 5175.9) scale(15.2002)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAABHNCSVQICAgIfAhkiAAAABtJREFUCJljXP34+X8Ghv8MDAwMDEwMSACFAwCeBgR5xr/ftQAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31421)">
            <g transform="matrix(34.2002 0 0 20.2002 5893.9 5175.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAECAYAAABCxiV9AAAABHNCSVQICAgIfAhkiAAAAB5JREFUCJljXP345X8GBgYGBgYoBQf/GZgY8ADyJQFL8AV8GytSrgAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31433)">
            <g transform="matrix(15.2002 0 0 20.2002 5898.9 5175.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAECAYAAABLLYUHAAAABHNCSVQICAgIfAhkiAAAABtJREFUCJljXP342X8GBkYGBob/DEwMSAA3BwDURQR7PHjJMwAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31445)">
            <g transform="matrix(25.2002 0 0 16.2002 5893.9 5179.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAADCAYAAABbNsX4AAAABHNCSVQICAgIfAhkiAAAABVJREFUCJlj/P///38GNMCELoBTEADyCgQCP9eHHwAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31457)">
            <g transform="matrix(20.2002 0 0 16.2002 5893.9 5179.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAABHNCSVQICAgIfAhkiAAAABVJREFUCJlj/P///38GJMDEgAYwBADCCgQCxnVWNAAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31469)">
            <g transform="matrix(24.2002 0 0 20.2002 5903.9 5175.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAECAYAAABGM/VAAAAABHNCSVQICAgIfAhkiAAAAB5JREFUCJljXP3o6X8GBgYGBgYoxcDAwMSABRAvCABiZAR4T0KxTgAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31481)">
            <g transform="matrix(29.2002 0 0 30.2002 5898.9 5165.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAABHNCSVQICAgIfAhkiAAAABhJREFUCJljXP3o6X8GFADhMjHgAPSQAACB0QR86PaqHgAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31493)">
            <g transform="matrix(29.2002 0 0 20.2002 5898.9 5175.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAECAYAAACtBE5DAAAABHNCSVQICAgIfAhkiAAAABVJREFUCJlj/P///38GLIAJmyB5EgCGfQQEIkvO7wAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31505)">
            <g transform="matrix(45.2002 0 0 54.2002 5859.9 5093.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAALCAYAAACtWacbAAAABHNCSVQICAgIfAhkiAAAABtJREFUGJVjXP345X8GrAAhzIRdASoYVURFRQAFcwSLtNgKcgAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31517)">
            <g transform="matrix(25.2002 0 0 29.2002 5883.9 5122.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAGCAYAAAAL+1RLAAAABHNCSVQICAgIfAhkiAAAABVJREFUCJljXP3o6X8GNMCELkArQQCsBQN9qAYD0AAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31529)">
            <g transform="matrix(20.2002 0 0 21.2002 5883.9 5131.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAABHNCSVQICAgIfAhkiAAAABZJREFUCJljXP342X8GJMDEgAYICwAA4sEDe0fb4mgAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31541)">
            <g transform="matrix(39.2002 0 0 49.2002 5888.9 5131.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAKCAYAAACJxx+AAAAABHNCSVQICAgIfAhkiAAAABpJREFUGJVjXP3o6X8GrAAizIRdEgFGFUAAAKLaBISRbdWsAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <path
          fill="#fbc6ad"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M103.93 93.388a5.166 5.166 0 00-.09-.054l.436-.602c-.01.023-.154.296-.346.656"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31555)">
            <path
              fill="url(#linearGradient100558)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5953.84 5218.34c-1.2.78-2.41 1.53-3.63 2.27l.27.43c-.06.04-.13.08-.19.12l.39.54c1.26-.73 2.51-1.49 3.74-2.26-.19-.36-.39-.73-.58-1.1"
            ></path>
          </g>
        </g>
        <path
          fill="#b7bdca"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M103.765 93.7a4.563 4.563 0 00-.132-.08l.042-.058.125.073a4.122 4.122 0 01-.035.066m.142-.267a5.517 5.517 0 00-.096-.059l.03-.041.09.054-.024.046"
        ></path>
        <path
          fill="#b8ccdb"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M103.8 93.635a4.685 4.685 0 00-.125-.073l.136-.187.096.059-.107.2"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31577)">
            <path
              fill="url(#linearGradient100560)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5931.69 5176.72a88.95 88.95 0 01-7.36 4.52l-1.57 1.89 8.62 11.9c.61-.34 1.22-.68 1.83-1.04h.79l16.21 26.62c1.22-.74 2.43-1.49 3.63-2.27-8.56-16.11-18.31-34.41-22.15-41.62"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31595)">
            <path
              fill="url(#linearGradient31603)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5950.21 5220.61c-.07.05-.14.09-.22.14l.3.41c.06-.04.13-.08.19-.12l-.27-.43"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31613)">
            <path
              fill="url(#linearGradient100562)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5934 5193.99h-.79c-.61.36-1.22.7-1.83 1.04l18.61 25.72c.08-.05.15-.09.22-.14l-16.21-26.62"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31631)">
            <g transform="translate(5917.9 5170.9) scale(20.2002)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAABHNCSVQICAgIfAhkiAAAABlJREFUCJljXP342X8GGPj/n4GJAQ0QFgAATWUFeRxwPtEAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31643)">
            <g transform="translate(5917.9 5170.9) scale(20.2002)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAABHNCSVQICAgIfAhkiAAAAB9JREFUCJljXP3oyX8GBgYGBgZGBgYGBgYmBjRAWAAA4jYDeelfePoAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31655)">
            <g transform="translate(5917.9 5165.9) scale(20.2002)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAABHNCSVQICAgIfAhkiAAAABZJREFUCJljXP3oyX8GJMDEgAYICwAA4f0DeBBgpysAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31667)">
            <g transform="translate(5917.9 5170.9) scale(20.2002)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAABHNCSVQICAgIfAhkiAAAABZJREFUCJlj/P///38GJMDEgAYICwAABl0EBLhJJOwAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31679)">
            <path
              fill="url(#linearGradient31687)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M5924.33 5181.24c-.7.39-1.41.76-2.12 1.13l.55.76 1.57-1.89"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31697)">
            <g transform="matrix(20.2002 0 0 15.2002 5912.9 5175.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAABHNCSVQICAgIfAhkiAAAABVJREFUCJljfPbt+38GJMDEgAYwBAC57wPY2APSLQAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31709)">
            <g transform="matrix(20.2002 0 0 15.2002 5912.9 5175.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAABHNCSVQICAgIfAhkiAAAABVJREFUCJljfPbt+38GJMDEgAYwBAC57wPY2APSLQAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31721)">
            <g transform="matrix(30.2002 0 0 35.2002 5907.9 5155.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAHCAYAAAArkDztAAAABHNCSVQICAgIfAhkiAAAABZJREFUCJljfPbt+38GLIAJm+CASwAAmHED4BsDVFsAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31733)">
            <g transform="translate(5912.9 5170.9) scale(20.2002)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAABHNCSVQICAgIfAhkiAAAABZJREFUCJlj/P///38GJMDEgAYICwAABl0EBLhJJOwAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M103.054 94.868c-.497-.386-.406-1.474-.41-1.782v.295l-.004-.109v-.186a4.083 4.083 0 01-.026.39s-.147 1.09-.408 1.319c-.59.514-2.074.416-1.504.429 1.92.04 1.92 1.918 1.938 2.532v-.31l.003.053v.257c.041-1.457.036-2.378 1.713-2.502.554-.041-.725.065-1.302-.386"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31795)">
            <g transform="matrix(53.2002 0 0 226.2 7607.9 5919.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAvCAYAAAA1kTAGAAAABHNCSVQICAgIfAhkiAAAAYFJREFUSImtVEFuBCEMc1Be0wf0mf3x4h4IECeopyKtZpmxjWMC9vX9Q+RBAogf9enA2Kj1sDQ1AzjXOwJ+JQ0yzJaijUNw2LgAziCFlEEIY4FD1QYuOUhpPs6SlSTWDDDDgCWvZmjeAwgAI0+E8FAflX0JVf2G3AniXZRfo6rjL3Af/wVmezPkIwuAU8h+FDJQQFsI8K7GQuB5jg5kAV57SbkqJnAQXKoW4NTVQPizGFklbHDuY1WtlEMbgn6WE9C7WBdAI2gqS/lgX4nM806jkw3SC4YL/Mp1TyeoN1KJbivl60t7g6Fbo8upEE5+tLjjP9dBkC0NNEX1TCalZKbmbYAzB8+kvBUNAGbYELDe0cQnwnhGt3NFWuX6ds5PAvc+OXFi9q6jRLOV1/9boCmIAo4zSDk+kI+ysySc+CSf1gB31QMWoWTp2qGVG4mFxVQHOa8y23W8mgd2d9ZnvQq2WgAsds9YdtBKf9jpjShw7H4+NnKL5qqPciiK76y6vv0C9u5jb7zgZmEAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31807)">
            <g transform="matrix(69.2002 0 0 260.2 7611.9 5919.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAA2CAYAAAD3YagRAAAABHNCSVQICAgIfAhkiAAAAlJJREFUSImtlkGC3SAMQ58pl+m2V+y1+1EX2MYmmemmLOZPiGXJMgTs56/fQgJEjnwWSPuNVj7DYhoDbIOU4AXYDjJhEthA/oxgYraD4q8EZp7EE/j/FmJsMGEcicjRhkkoIg3QVmYstBkdqMhumcD4AazD7mzGcqk+kayiJBiYFrLRwFuqKeskDVhn7gXczMl6gF27Tpcu8MwADn7Lsc1qPMEYsyMiIHo4LrCXZMbARjHGXOJ+GSwn8QAzjL1sTkBLYP3Zar+NgVnP2sABqqUMl1rrumttoM46WjZ7kfjKGjU+wDcrjzHeM/Iw4042eB0vFBfBF8B/j/8N1Pt0fnMSeCZOzPomkRgPUANE0id4dJAusM6v+vPoIF2gqqYrm+1j/KjrBsP+dESND9DqKpqSnXS+s0QiZ8uY5UeCmM2AB8sFAsQCrQJstb4Z5Sq83i711aiTREXJbHZ/aZKDkjGl3pbXOaHrbHTGS1Jig0UPkCRmyik1NkAsN2dVSlXY/J27OjV6spn6a32xoLPG0h4D6fO2cr6Q7CeZ9HFz4rCsgu9+2m6N1q5PW2oxoO0/HYBud7MdpY9xxvJxHy7Z9mhH9I3CXusM9v07tT7FmP4ZqRcmpQfLpZZNqwpMxgqIbRV9tA5QA6oBdqyYOZGgvluqKbuPAltM8Ydj5xUMybDvcGtf05LxEBTZpb42FxekXMTVFEowpA8CC1fFx+nrULubgt9ZERa7Y9VFHix3cC6/s0Oyj3at1xZcd0mYM/QpJ3fdVtUxXb2GSSzmVmdlu9/t8RedFET6qypvWgAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31819)">
            <g transform="matrix(159.2 0 0 216.2 7496.9 5919.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAtCAYAAAAgJgIUAAAABHNCSVQICAgIfAhkiAAABA1JREFUWIW9mFsS3CoMRE8z/sn+F5IFZSkZ0/lAsgHjeSR1L1VTfvBQq9VIePTj5y9vMgUjGQHCFBnhuCeap2vfVu/6puU7SWyaumcAusydjb171vRew1gbCocxLxbop6z6Pd3fMTSPG1sp3UvN10sYXgF413ow49xtprsEIy0cd0Zfvb8Lx2pe6yuvF7hrdwL9RLCLcAhu9XBO+pTuT/vG54GJead8bvRvQfoK4gTzjVf/3pYg/k8AfwHi82D9M4h5c/7XQAqArTD+DeG6uf9mfOSJa75cTf7WyDd9UDy4/inVc4Lv388er8aMcy+aqM5i3m/UzxZ7bfxuLJQ61MlTGwB+K5BXQF4BGO+3IzU50rdEFpcm1IQ2nwv6Bc33oTxbuVR7t5Cs2XhF8zsQ65BKaprYnQbDuE6ajaiXsLzbSavfdZwkMJQ4XdJro85sDKeLu+unLYIbAABK8r07jEXiQgogV+GuPXyXJ07vewBGbXckG8+O9uoRyJlVV3kgFy/chWIw7p5dsTUdtF2ROs+dUg1FoQmZcrA0wzk90/V4ni4vnTCw7QAWD8AyT8d3QOzWao9AaAI+GXWA12FsPo9cC+I4YqsusbiBgqhUi6Izyj0QBQs4ae63+Orb4t54hrglK5sd8cBUFaCGkWY8gehYJAN3gklAa8/HNutry4eKkUVZAGmH4Qbg6fZZWA7RdemuY2dl9HjuykOlsLUaVmlhaYZnIFJLrbl4NVRmMLlsf7kykkxmXrIjHCMQtyyGsQo7JkuKHZsuabdaf+qEloLXdS/C2hnP99uYdCo19vAWw5vw1DShKFSOq2JxpxGzc79N5zqUrGzU4Lo7WpjKjiI0FakJNzWjtJ8MrTlfMtGfUZwOy8YDkAqUYMRslCOnWsYUZB9gMi+keG8xdGGYtbJpNzwiLWsEYsxvVwrwoFCosZ6CmfMLSikarse1tUDPCr1h0B5GpVjhAS26wIPqGlIoIWMnlqOVvgoPvo9A8tqYznDsCb1CCWKLAojpw1MjBJtzektflaZ6ZbG6+J1AOkBHWMSmWlucu1HHwUZ9Qmo9tvlNo/9x1IkTUD/6QHTJG21WtajApgq4nSRV3KIQ0mjhmYHoAPOMZ8lRBMf/uMSRdiIEmSvO+8bE7jHhFbVhJv5Mis7Skzz66xDkEy40tH9+RqPjOlE75GAgE5HBD9Du4yBtBCrd3P6IPKXtrq2N53MHYgCSe9/Cx15LMPEpUEIvmpO0p+vV6ysInSDa3FYnmH9LZ1oYfaTPvj9vepDToGBc9gQihxlcO0Dqrt29RdSTWDd1M4A9Dhmxdm6Vc94SxLmqUSbJPL9k0dVZglxWVHeWF04mE+9BDIBiMj68cClhMqgNwFYXggWe+c/CP2PSNFZh5TYOAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31831)">
            <g transform="matrix(59.2002 0 0 212.2 7592.9 5919.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAsCAYAAABR2VnRAAAABHNCSVQICAgIfAhkiAAAAcJJREFUSImNldGWhDAIQ4OH///gPcrdB0qL1dmdvjhjEyCEVvu5Am0L5SswISnId4HJD9vAIFMCZUiYDpMCkxlyk2QzsmQ2wJA7g2SGDMkA9gxFDhCyWQ5Cx16/WeYzSYeZsgKbVTwInZS/65naXglFKn1Ft08Z/lpfE0rF14Qy818C2++PBGCCO+mVUGCUhiPGXKGjGw28gFcWMDla46Db5ni26EjyYLlZvBU1wdFITgNqA9bgdZI/j4/EMCmndAW4QB6izeLztJXYi1QxMjxF61YKM5vX0auotRYwawApJPnVm90yVRsri9Q0vK2MmMCgGbd3qf5GO9vlQSD5yRqomBCbelZrVV1iAO95UigTWEb6xf1eWpQYmdQc1yenleDZnZhE38upya3u0S4zYPiwERiXS5UhW+Pu517SBLS2RrodQn6CjiE7hAykmaVGZDnvIF2tP9c8RN04DbIyg3T/SPST151HSh+6A9GaUGdllWTyM7jd1rWZYewWhBJtrVO0bOv0Zf3Au9NlJkMfjewnd8l9c5W4uvV0egPXu/r8bk7fyXVBVJCoDB1mbbOHqCvVT7QRnoIXYWrYnV5j0XUF0i+11eLNJv4AQwAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31867)">
            <g transform="matrix(236.2 0 0 159.2 7415.9 6058.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAhCAYAAABwSkOHAAAABHNCSVQICAgIfAhkiAAAA5tJREFUWIXlWEuSGzsMAzQ5SZbvSLn/OYwsmpQgSnK3J1mk6mlq3D99AAKk2ubP/34J32oNEAE2CA0CATSQDQBANZCMPgDRYhzjnHGVn3y4ruJT/frH3yFwgSIbiAs4yX6vgmcBTRDgQxISBMUc3yWhAHAgMKLMHv0teNKA+P3TutlVIIZ5pNeHJHRZxglckeYgoBF9psUMpCsTPgslmq1T1nXh9LqspKsj2T4gcVAA4PB/t89FKEnM4NvIEdIAP1ADiqDEtBKEx0o4Ac4WcgLdNl8j+t02AZ5fBrwFYI7jhoOWszy+QHx9QOKUA28IePRToSR2Tdum9HYiNYSAopgI6FlBPEvstFEuzmGVOQd2BKJ/Rt/vdeDVRneZfZ0nDYF3JHIRS+TwJFVzoBIw+0wBcOC1tL4ptVKoEP3imrdK6BogMjaz+FeCHFaqBMhM6pFPEwGzFJCVLABu41k3uVcn84bEWHxYwPMgC2slkN5ufSw5FJ3zYafGjoj6PQKhAoPQu+qUKsR/vj7AbDQ2tjZFmPgqBEYgPCADvG8Ep4AasMgdShBxo8RRhbH4SFFL4q5MIdAtVTa8vqRteLuml41RiH4qsVmRBMhe4oYKpzzIKuQWOhGIYwnKvkLJqptd412JjYkVkq8qDAux7+QYC7HYbCLgJdVzqCR2XiZYjrzolSqU2ZBgj+Y+F/I9Ke711w2zUQaiV69CgOW4VSDJaL6WrFs7KGEJfWEJ09R63qm4CsM6Iy/agUC1U1GiksnS6pcksH2LnXbQ3QIevZ0Kngc7cE7gkODbVp6TocrxLbZMurOSd51UGNYYm5uBnja5P69Om82OXTWvSqx9LOJOiR4A7gAWK00JbrPUzU8K0K2QwUaJXrbiOS1JHeDi7RX0okKfJ/tsLHV6b8pxTqYTOZRYnby8TO4ns5W2IBYiNt4JbJWI+/GNzseuJuyeNTDKXOBKpRSNrZWWElryYiGwKyDluSk4k2BZJAg8bzswJyJ1zd0YH3tW6qYc7EAOorevz8eaj7USHQnY2GqzmONDEjndIVrH509JfoYi27dI/Gvt/0vi+kZVf+FSeb5/9uz+MxTZPiQxg/cfde8WWsbrFUfZ8R0pjb791jXHTEIbUPRfGe6a9VtA6YBxN6aMqwQyANFWJXpk5gXU/8r8tO7TgjsCJUhVjTx3MqoEytj4OW+03EgnEH58YxvJujjdQqpGWy/r41Me7kETAUD4DcKNNm3wfF8jAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31879)">
            <g transform="matrix(260.2 0 0 188.2 7410.9 6063.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAAnCAYAAABEz7vjAAAABHNCSVQICAgIfAhkiAAABJ5JREFUaIHtmUmS2zAMRfHpnCTLHCn3P4eQBWYQtOxupyqLMOUWLXHA4wdAysHPX7+Z/nZhEAFETESkdQIxQRvkuraZB0ot2L+DWbrwJfdA9OPDCM2OgDAgpgyFYGCpABNgADGzNmd/xGABBQSS+C+BdSAFYVoBw1AIOEMgdcUCEAAVFwMTMwtogvw8GJuxS4EWcYJ0GAeBQBLpYtwXMKtXs47F9sAhPwiWXW6JQlgaWyBgeSuHcZCTQlMRGHg9g16+OJ8B4wBylVQxaGzhCJNdkm+gFAbSlj2BIC0YE31EMVa3ayohg/V4ogqIrHYqe+pIcPnjoJeO9W0wSwZLVRJIgSICrwJk7igwK+7731mt/S5vV4FaIhpd3wFbmv1WdT2sTaUJCA3EXPalwuKGKJqaKwvs18BSTE1QoYbVaQay2NMWOfXP81pT3becM1zQgN8HKzElHyCMhioZWdDcc3bJSP2WfBoE1aby7JLEwdLQxsuA74EdlCJCiacAXQ5WgZbC2HYwWH/0SiZZKB2WJb48hyjgG2Btj8rul6Hc5R6hkrucAuGRYJZCIK4DF281u14EekjIpyT5Htgppp5AZZVMSYOVYVdJIRmuzU56ZiI7cbA/ESLQgwiyu70G5sckNQjhZjWmJihtbyrlew7TXfAue5CCsNdsYya+CHi8AmYTp2ShPg7uMdWhkuuVRckwPc0/SftmvLXT7wVQa/dg+g7F6ZVDBjXDww07FGCJI+KzQCV3JLIMqkaPa2wAEV8FkFnChW/BwqBwnxxXluQ7lMXK8r5AKF/ja1JtgotzJIgUBgqpgFoH3cWYqaUfCVzymJPkYYqEerIAjwYVi5MXKYDyRnVa5GSYxiKYxRx/i170wiH4mVphUKSBlChcwQbl7tg2aZ8ybdJTYVMHDgh6ENEV6vEzxSwTMsmL4qbWKa4s+2X3O0HptS3UnBk5ZdX03QEXgS95u3h6CPYfXOI1pKoV7gc/kVBMjuaiBSqn9xyTLXlEktM26X0tpfc8lsEdwOCrPseWnQup/L5RXNAWx7Nmg0K7jkqZwVy/WzwRkZ6r0gFZ4GawlDTEPnW47RekdFp3tcLtIs7WAaq7YlOsA5r1+SsgqoEK3AxWTgLTpHmVJ7VyXE0GZ6hDEpkN2+3UvavCPc2KbaLJDXPTola4VWzICaRszN/PigVOT/8DGFzSnA3R2yRlMibyomAyurlhSSJplL5h+9F9NUBKUPD6vjyeQrUPciJIRvdY2dyOdrVsHG8zuGNWNJcSt63PsBhHV+RTbGwT5graAjTDtrhtA2WgUTG9r3FU+1obWYDZoT0GkoFssYUdryWr0Q23dN7ibIOaklR7/kS1HWz6dZbvslUZYDAwPTuqeeqT+z5RtCWCmxQ0leqit68axz2J9gx4hEp9O1BPOlq+AGZDHFb1+PxV8PesON3/Mti/Xv6D9RL/01Hv1ufzs9fuv2bF6f4XwCpQALxqeOrPl145XZ+BcrT1W9c413DyGAxF/nXorqR2m6F8sHvq0/p1qAKUx5Y2s2K+gnVS9n9tTqTmxYgJqi1cV83qGZA7VOubx9Q5/gCsNLcVE3+0GgAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31891)">
            <g transform="matrix(217.2 0 0 260.2 7429.9 5947.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,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"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31903)">
            <g transform="matrix(221.2 0 0 154.2 7415.9 6053.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAgCAYAAABts0pHAAAABHNCSVQICAgIfAhkiAAABRpJREFUWIW1WFly5TYQA9C+/1nynTPkTEQ+eiEpyzNvKhW5XJYoWkSj0QvJv/7+x/iDS0FIQkhQCCIgEWJAQXwJAIlgQCIo5l8CIkESBPIvAYGwCNmgNOsYCStn19haWMznr/8KOhQ1DgRVRqBAA2UHJIEAosEToATDCAqF54DJa20nAMj59DFwihAFPpku0GIkUAKKZFsgGMlqkEAIsgEleJHJKPPbzbIeoBecXgKxvAD/AeNSsi3ylkeBTsaZHmCzXOBKJiAQEQmrmBdyHCSEkgpv9YZVrBthweRnwBXJyDDMkskXEMX0gBagUDEqKIpttkwElEwStEGkrIDWNL9hSG8QXoQ/kUpLZAKNKnCBGFZxgRYzIKMwNPNoeZSm0wYdHjjBv4A2ABnGB4wniEPX3JkipVOa5hM055kUGAlQA/gOUtoJ/oXtAW/DFLzWr4F3FtnpLF3/xQQEVWDWe16gyxhFzgOh2IBb+ykdjxeSfF047FWMp0yg+DVwFjgqA4eq/KvSbDlaSMBfBai9Q5UkiAriE/R+RwbIlINA+BGcdGDBybsF+xeMdxDGuNOQKs11rg5s2XS660yiLRupgnXkstk+wSdZBqEHGkOdWbxg62fg7EJRbKtYY/2kPErDyIwxjCp2OjxAp2eegOseHZz5jVsqBgjYSI3/lMepI3CKbSpACiEmK11gilVMLJS8uL/zBB3HHHFrems8DWi2bZYBOf6jVKaPCFXJ7h6j2K5qyApESgh1HeGA1AP0BPG5hjhrNnKhSjyqWrZB3jp/Ba4qHuNKCIFiejJAZQHu/qMl0q4XS9OHPDK7nB5lpcG+34Y1za34rPYE3wpQZ4z+x3Q1Uy4DWFMtJ3OgF9TW9mSSKloDOp9Rho00Xevf7i/QhoOwDa8XjR8eS0uH5UiQR87uxqfZxhSXAoMjTqiR3AlaM48j60dswu7vVYDqDXg6uZhPmcjVfrqMsA6dVq/RbFcmInykzp0aU14FOnSx3GQ8iyfZgVmd5VvJv7JJrgFXr33KRMwNQGRVys3ASKaMZwYm4R2MHYDTvxxrggO0pWob1Q1MwNoPjbe+byM67Tl1Xl8xehwThKxdwyk3tAfOYBQPkBu0VOjoMXBVOILAWvkOLyVqNz+nxpCJH9AsSnoYNlouLYUDPKsaNqPMRc92IDNQfqmJ6Kuzm7rANVlPLW0DesEEqNF351reOxbuPWJ+XOOpdqMnAAvkUYWvIH2Sycwm0068MY6qiqdNxqPpAUrTuZB70aRojHD1HbuAlTQmSJssw/Yr6Cd4lPcewL/b0s1N2rRB9fyUpLdFOILslZf2wGZYlSp/d83c1y9vTGi7Ts11W/o+fxtB+srLVzU8Pehqoj68eu7PwP+36/fMfnL9v8Bfifyj86cfrwdwP24XAORZRg/bWG+urSFP4eDxP5VS7Xp/p69P9D3TS3ffGDfW9bx4gKYB85rNAesNvm6M9S0jYVpTwzDWyt9PdG7vud+lYsLLQO3ygJ0lNtw6x3OlseXaEeY4nM1+5vwC6XOOtw25AIxfg29DUX2L7pc3uARALKfr7Xsj2wYtpCc2055xF3ggM46Xx2lt0Fp1bnIYeQFu0GAy/r0fP9nZLGexSyaxAKt222vBCtB7E5tKcBma48vZBZp9sFONk/Z54Vp35R7J9rbtYP1bk+WFywfDSO2yc7OajRBpLCpPT5kHNWijD9BtTN8TuRFYArRWbo/GUztseWAYL7olBfwLMukgNat3KtgAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31915)">
            <g transform="matrix(231.2 0 0 197.2 7415.9 6010.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,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"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31927)">
            <path
              fill="url(#linearGradient31935)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M7436.2 5872.25l57.44 86.06c3.67-2.53 7.43-4.93 11.31-7.2-27.43-31.77-53.03-61.24-68.75-78.86"
            ></path>
          </g>
        </g>
        <path
          fill="#b5b5b1"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M166.066 56.677l-.144-.327a132.05 132.05 0 011.144-1.569c-.03.068-.443.846-1 1.896"
        ></path>
        <g
          display="inline"
          transform="matrix(.03528 0 0 -.03528 -106.294 277.83)"
        >
          <g clipPath="url(#clipPath31947)">
            <path
              fill="url(#radialGradient31957)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M7701.31 6232.91c-4.08 2.55-8.26 4.94-12.56 7.17 9.81 13.56 19.24 26.58 27.62 38.13l4.08-9.27c-5.92-11.15-12.41-23.37-19.14-36.03"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31967)">
            <g transform="matrix(39.2002 0 0 44.2002 7655.9 6163.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAJCAYAAAAPU20uAAAABHNCSVQICAgIfAhkiAAAABZJREFUGJVj3Lplw38GPIAJn+QIUgAAmnYDKgfmD10AAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31979)">
            <g transform="matrix(53.2002 0 0 59.2002 7655.9 6187.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAMCAYAAAC0qUeeAAAABHNCSVQICAgIfAhkiAAAABhJREFUKJFj3Lplw38GIgETsQpHFQ8HxQCaPQMwdL4LaAAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath31991)">
            <g transform="matrix(29.2002 0 0 68.2002 7631.9 6120.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAOCAYAAAAMn20lAAAABHNCSVQICAgIfAhkiAAAAGhJREFUGJVtkNEVgCAMAy957j+NG7iIk1A/2irwDH9c0hR0XncAIAAIAg0wuG8gQAgsHIaEq8EgwmI3uB27wfpaSwkdFn3m9NEOAI1ct8r7EdnRo82iDxqJP5gJCUIL9PtJ29CpvJKlB8J5H6XqUIvtAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath32003)">
            <g transform="matrix(40.2002 0 0 77.2002 7635.9 6130.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAQCAYAAAArij59AAAABHNCSVQICAgIfAhkiAAAAIhJREFUKJF1j8ERxCAMA1ca+q/mOrg6rpXoHjYJZBLzYGTWstDn+wtACABqVRUGqB5mSwHUIAyiHnsGBxYcXKXtYhDAYubQsTsOlkySwFyOCq6OOcF2jIEIZ4obKAQWLnuxg9dar6LAxS1gUefc325zvjM0tLhNyPXfN+hMxAukFXiGjATRK/QHbMM2wBscqRsAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath32015)">
            <g transform="matrix(164.2 0 0 236.2 7487.9 5943.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAxCAYAAAC/BXv3AAAABHNCSVQICAgIfAhkiAAAAl5JREFUWIXtWEGS3DAIBJf+/5E8K+e8QXuYtYWgG5Czp1S4jI0kaLcaPLL++v1nikz52JR1LcaHrrUY75g+V2MP0gVh70+ToxgqYwGY3whRAnStkoNgYwp80zLCFiMQLEmHHbS9ItfOSJbQ+vxToW3t2Fo38GC2UN19Nv17XNF27HEHfxrPRiZkl7jjd+AMIx2hEl9IlDGla41u5XsiMFApswKdxDJbd8UE2ZYwEG/EaubPeQMpJopIqJSJgJ/aWguqhoHZnyAHcdbMRFQuvi1VAGZV+WPxF4yA4JSNmdz5R4lNkWjkbafEIJivAeQ01aQjfNV+9xJIJ9HZnB8F8jf2H4i3fxNIp+2xOS+B+HBKR/iqVkPTImSexq+O0WLsJiNm4fNnBgGN6eIs/IDX3vcZC64NlWBO/J+x5KXnT3LVOYat7807EOsJK13TJ5b5P4ICF6LdwJwAMvP1iBEPzoFpA3Lj+7/42+zZ1+oBaQP47qATnQT98jg+8OcFnwzNIeItT3XYwNbwEovJ3zQ+HHfgQGiLLEhPP2O1ArBsxIFKD0r8MXjUGWfv2unNyhglPKmSfN5lb/jTs6Rv+0iMOTAbWXWgAxmj3lcdAiIeiAeDAuF7FQUyZZrwb+iHET+YfRXiW6fmehbCVDA2MK0dmnmpokSVme8j968Vbab6n2hmy8inK9a4xPjXOnvgPGdj08jujEnZtqGGxvSV5RAZH8UjQfoekgnQc1KV7Zr7ALmllYM5o3u+0M5TvhgMuv6kwv67p/RefrozsrtjECRiDwo3qZ4RsS4Zdl7/NagumC+fFNU2OerVdwAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 -106.294 277.83)">
          <g clipPath="url(#clipPath32027)">
            <g transform="matrix(54.2002 0 0 107.2 7597.9 6067.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAWCAYAAAAW5GZjAAAABHNCSVQICAgIfAhkiAAAAJVJREFUKJHNkUEOwzAIBGcr//+/PUSbQ2MbbBJV6qVcjJNZWIPex2Gu8MgANLL+uaXfijcPsS5hE4mI6BDbBkSrUIdqU+RsY3c7b8Y0FaXjQxU6JRudmV5zpzyN1fcienhgFtnwKlgU4HEKZDts0JvQ4UyVJSFVg/tEbaOYp+7gVdCzW7jq8Ah/baOKP4C3pfxUeV3/CW8zLzvh1+AUAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M163.236 61.464c-1.549-1.21-1.265-4.612-1.28-5.573v.921c0-.148-.011-.307-.011-.341v-.58c-.002.275-.022.712-.086 1.217 0 0-.452 3.413-1.27 4.12-1.845 1.615-6.484 1.305-4.705 1.347 6.009.128 6.009 5.992 6.06 7.916v-.969c.006.07.011.128.011.163v.806c.128-4.554.114-7.434 5.356-7.819 1.736-.133-2.265.201-4.075-1.208"
        ></path>
      </g>
    </svg>
  );
};

export const MasterTrainerBadge = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="374.361"
      height="335.572"
      version="1.1"
      viewBox="0 0 99.05 88.787"
    >
      <defs>
        <clipPath id="clipPath17883" clipPathUnits="userSpaceOnUse">
          <path d="M1581.46 855.969a5485 5485 0 01-76.89 19.332c-7.71 1.89-15.42 3.75-23.14 5.59a2861.261 2861.261 0 00-47.02 40.621c4.2 14.519 7.79 31.129 10.1 49.898 49.53-44.558 95.24-82.769 136.95-115.441m725.98.722c5.12 14.418 9.62 27.95 13.59 40.661 36.77 30.468 76.15 64.867 118.13 103.708.84-19.912 3.14-37.861 6.31-53.88-29.48-26.7-57.66-51.2-84.59-73.75a1895.98 1895.98 0 00-5.48-4.571 6035.19 6035.19 0 01-47.96-12.168M1198.92 1156c-21.47 27.55-41.19 56.86-59.27 87.58 7.86 14.49 15.39 30.9 22.27 49.45 13.2-24.24 27.38-47.63 42.6-70.03-2.66-21.04-4.7-43.58-5.6-67m1485.24 44.06c-2.38 24.3-5.73 47.03-9.39 67.36 12.84 21.82 24.86 44.45 36.05 67.68 5.78-21.49 12.41-40.7 19.59-57.87-14.27-26.72-29.66-52.51-46.25-77.17m-1670.74 365.96c-2.65 10.59-5.17 21.16-7.61 31.82-.82 3.58-1.63 7.13-2.42 10.71 3.01 3.97 6.02 8.09 9.03 12.38 9.22 13.14 17.16 26.71 23.99 40.48 3.11-15.79 6.41-31.46 9.94-47.14-10.58-14.26-21.8-30.43-32.93-48.25m1833.51 38.41a739.456 739.456 0 01-34.63 44.59c5.06 24.79 9.6 49.68 13.68 74.63 6.99-24.92 16.78-50.36 30.35-74.91-2.23-11.17-4.56-22.33-6.99-33.44-.79-3.63-1.59-7.24-2.41-10.87M962.199 1876.99c-.054.62-.121 1.29-.176 1.9a2704.495 2704.495 0 00-5.753 72.85c13.289 6.62 27.296 15.18 41.839 26.18 1.426-25.46 3.231-51.33 5.431-77.33a546.249 546.249 0 01-41.341-23.6m1928.581 19.3c-16.97 9.09-31.51 15.72-41.84 20.1 2.4 30.54 4.25 60.82 5.62 90.5 1.68-1.67 3.4-3.33 5.14-4.97 12.5-11.78 24.71-21.68 36.52-30a2751.092 2751.092 0 00-5.44-75.63M950.785 2232.94c.445 19.15 1.035 37.71 1.738 55.63 3.5 6.6 7.071 13.14 10.711 19.61 7.969 14.12 15.727 27.16 23.399 39.27 4.035.26 8.269.69 12.676 1.32-1.707-29.2-3.18-60.8-4.227-94.41-14.48-6.03-29.402-13.11-44.297-21.42m1949.195 17.57c-15.34 6.78-30.29 12.37-44.32 16.96-.75 21.51-1.67 42.13-2.71 61.79.2.58.41 1.21.6 1.78-.48 8.99-.98 17.77-1.5 26.33 16.17-5.67 30.91-8.51 43.82-9.64 1.69-30.07 3.13-62.64 4.11-97.22M978.352 2588.62l1.503 10.92 17.344 125.77 96.501-23.34 55.39-13.4c-21.88-6.38-46.93-15.28-72.64-27.6l-41.54 10.06-.02-.17-.68.17-5.12-37.13a281.087 281.087 0 01-50.738-45.28m352.988 37.21c-37.86.02-71.47 2.15-99.1 4.91 3.07 18.62 4.49 33.86 5.14 43.72 26.17-2.57 57.96-4.55 93.74-4.55 23.05 0 45.93.81 68.55 2.41 37.94 2.69 75.16 7.62 111.25 14.75 22.32 4.41 43.92 10.47 64.61 17.69 59.27 20.7 111.07 50.89 151.12 78.86 4.15 2.89 8.17 5.76 12.06 8.59 46.85 34.14 74.74 62.91 75.33 63.53l99.13 107.23 12.43 13.44 111.89-121.04c.38-.4 18.54-19.08 50.05-44.14 36.03-28.65 89.54-65.63 153.92-93.16.85-.36 1.69-.72 2.53-1.07 29.99-12.65 62.3-23.22 96.28-29.93 18.66-3.69 37.61-6.78 56.81-9.29 40.11-5.23 81.27-7.87 122.99-7.87 4.69 0 9.31.04 13.87.1a157.31 157.31 0 01-4.75-38.47c0-1.89.03-3.79.1-5.67-2.89-.02-5.8-.04-8.74-.04-64.32.01-127.62 6.07-188.12 18.01-189.46 37.39-325.49 180.48-326.6 181.64l-79.54 86-.35-.38-.34.38-79.53-86c-1.31-1.46-137.8-144.39-326.61-181.64-60.48-11.94-123.8-18-188.12-18.01"></path>
        </clipPath>
        <linearGradient
          id="linearGradient17891"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1951.52 0 0 -1951.52 949.854 1794.94)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#e64120" stopOpacity="1"></stop>
          <stop offset="0.952" stopColor="#e61d25" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e61d25" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath17901" clipPathUnits="userSpaceOnUse">
          <path d="M1591.98 853.23c-3.5.918-7 1.829-10.52 2.739-41.71 32.672-87.42 70.883-136.95 115.441 4.62 37.43 4.18 83.4-6.6 138.26a391.882 391.882 0 01-7.25 30.37c42.42-41.2 82.2-77.71 119.3-110.05 1.17-32.439 10.41-88.381 42.02-176.76m729.05 44.122c34.07 108.978 28.54 156.378 23.78 167.378-.43.98-.89 1.93-1.38 2.84 40.98 37.22 84.91 79.26 131.69 126.66-11.4-25.39-20.83-53.57-26.92-84.56-8.1-41.16-10.37-77.31-9.04-108.61-41.98-38.841-81.36-73.24-118.13-103.708M1204.52 1223c-15.22 22.4-29.4 45.79-42.6 70.03 6 16.18 11.51 33.99 16.32 53.59 10.79 43.98 13.14 86.72 10.6 126.1 6.41-1.79 12.84-3.54 19.3-5.24 11.19-30.16 23.58-59.39 37.33-87.51l-4.56 2.69-6.6-19.97c-1.06-3.24-19.82-60.92-29.79-139.69m1470.25 44.42c-9.94 55.23-22.13 92.68-22.98 95.27l-6.58 19.97-16.35-9.64c-2.04-1.22-19.9-12-43.88-32.71 118.19 211.54 150.67 502.49 153.68 739.93 12.31 20.7 24.05 41.75 35.21 63.15 15-45.68 39.78-95.88 80.69-136.5a2811.72 2811.72 0 00-5.62-90.5c-9.62 4.07-15.59 6.19-16.46 6.5l-15.43 5.36-3.05-18.51c-.8-4.94-14.42-91.88 11.98-186.09-4.08-24.95-8.62-49.84-13.68-74.63-17.53 20.86-29.8 33-31.04 34.2l-14.02 13.72-10.31-17.67c-3.75-6.49-91.41-159.96-49.07-332.65.96-3.91 1.95-7.75 2.96-11.52-11.19-23.23-23.21-45.86-36.05-67.68m-1628.42 346.85c-3.53 15.68-6.83 31.35-9.94 47.14.17.36.35.72.53 1.08 3.12-15.88 6.44-31.68 9.99-47.45-.19-.25-.39-.51-.58-.77m-42.81 286.32c-2.2 26-4.005 51.87-5.431 77.33.231.17.469.35.7.53a2687.87 2687.87 0 015.441-77.5c-.24-.12-.47-.24-.71-.36m-8.458 353.77c1.047 33.61 2.52 65.21 4.227 94.41.238.04.476.07.711.11a3506.78 3506.78 0 01-4.215-94.22c-.239-.1-.485-.2-.723-.3m1860.578 13.11c-7.84 2.57-15.39 4.83-22.55 6.81 7.02 18.14 13.64 36.47 19.84 54.98 1.04-19.66 1.96-40.28 2.71-61.79m-334.89 358.36h-.22c2.94 0 5.85.02 8.74.04-2.81-.03-5.66-.04-8.52-.04m-1188.95 0h-.48c64.32.01 127.64 6.07 188.12 18.01 188.81 37.25 325.3 180.18 326.61 181.64l79.53 86 .34-.38-79.18-85.62c-1.31-1.46-137.79-144.39-326.6-181.64-60.54-11.96-123.94-18.01-188.34-18.01m-302.73 8.07l5.12 37.13.68-.17-5.03-36.42c-.26-.18-.51-.36-.77-.54"></path>
        </clipPath>
        <linearGradient
          id="linearGradient17907"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-2817.33 2817.33) rotate(90 -.385 -.299)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#e64120" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#f6e604" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath17917" clipPathUnits="userSpaceOnUse">
          <path d="M2852.95 2329.26c-.51 9.68-1.05 19.17-1.61 28.35.24-.08.47-.16.71-.24.52-8.56 1.02-17.34 1.5-26.33-.19-.57-.4-1.2-.6-1.78m-332.88 296.57c-64.39 0-127.78 6.05-188.34 18.01-189.45 37.39-325.49 180.48-326.6 181.64l-79.19 85.62.35.38 79.54-86c1.11-1.16 137.14-144.25 326.6-181.64 60.5-11.94 123.8-18 188.12-18.01h-.48m-1188.95 0c-37.73 0-71.27 2.11-98.89 4.84 0 .03 0 .04.01.07 27.63-2.76 61.24-4.89 99.1-4.91h-.22m-254.9 35.03l-41.33 10 .02.17 41.54-10.06c-.07-.03-.16-.07-.23-.11"></path>
        </clipPath>
        <linearGradient
          id="linearGradient17925"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1951.52 0 0 -1951.52 949.854 1794.94)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f58113" stopOpacity="1"></stop>
          <stop offset="0.952" stopColor="#ee2622" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#ee2622" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath17935" clipPathUnits="userSpaceOnUse">
          <path d="M1208.14 1467.48c-6.46 1.7-12.89 3.45-19.3 5.24-7.46 115.23-56.87 201.71-59.67 206.55l-10.33 17.67-14-13.72c-1.8-1.76-27.09-26.78-57.91-68.18-3.55 15.77-6.87 31.57-9.99 47.45 56.04 114.08 36.17 241.25 35.18 247.25l-3.04 18.51-15.41-5.36c-1.67-.58-21.34-7.56-49.42-21.94-2.22 26.1-4.01 51.95-5.441 77.5 9.011 6.85 18.211 14.63 27.591 23.47 44.14 41.56 70.39 94.23 86 141.9-1.71-204.53 16.41-462.61 95.74-676.34m1530.52 612.76c2.17 170.99-10.94 314.22-18.32 380.06 10.6-14.84 22.76-29.09 36.71-42.22 34.3-32.31 66.41-50.58 94.29-60.47.56-9.18 1.1-18.67 1.61-28.35-6.2-18.51-12.82-36.84-19.84-54.98-37.65 10.43-64.51 13.22-66.48 13.43l-16.03 1.57.23-18.86c.06-3.99 1.26-60.74 23.04-127.03-11.16-21.4-22.9-42.45-35.21-63.15M995.805 2254.66a3506.78 3506.78 0 004.215 94.22c33.65 4.96 77.65 21.76 126.21 66.56-3.23-34.28-6.71-77.76-9.38-128.03-12.11-1.46-62.89-8.64-121.045-32.75m1495.565 248.83c-66.14 0-131.27 6.22-193.64 18.56-205.45 40.54-349.7 193.8-351.1 195.32l-21.02 22.7-21.04-22.67c-1.44-1.55-145.66-154.81-351.1-195.35-62.35-12.32-127.52-18.56-193.65-18.56-72.25 0-129.85 7.55-161.77 12.95 9.96 21.68 17.43 43.33 23.03 63.56 31.4-5.51 68.25-10.01 111.25-12.78 14.1-.91 28.02-1.35 41.7-1.35 229.63-.01 398.35 121.86 443.79 155.96 36.33 27.23 74.94 88.74 58.78 88.74-5.25 0-16.31-6.51-35.13-22.83-76.64-66.46-230.29-164.23-426.24-182.56-25.68-2.4-50.55-3.45-74.36-3.45-41.04 0-78.96 3.1-112.63 7.68a505.63 505.63 0 013.99 21.26c27.62-2.73 61.16-4.84 98.89-4.84h.7c64.4 0 127.8 6.05 188.34 18.01 188.81 37.25 325.29 180.18 326.6 181.64l79.18 85.62 79.19-85.62c1.11-1.16 137.15-144.25 326.6-181.64 60.56-11.96 123.95-18.01 188.34-18.01h.7c2.86 0 5.71.01 8.52.04 1.66-46.61 23.74-88.42 58.15-117.92-27.43-2.57-59.92-4.46-96.07-4.46m-1461.51 130.95l5.03 36.42 41.33-10c-8.1-3.89-16.26-8.11-24.41-12.71-7.62-4.29-14.94-8.87-21.95-13.71"></path>
        </clipPath>
        <linearGradient
          id="linearGradient17941"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-2817.33 2817.33) rotate(90 -.385 -.299)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f58113" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#f3ee04" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath17955" clipPathUnits="userSpaceOnUse">
          <path d="M1549.96 1029.99c-37.1 32.34-76.88 68.85-119.3 110.05a389.365 389.365 0 01-24.47 64.46c52.97-53.28 102.13-99.49 147.33-139.49-.04-.1-.08-.2-.13-.3-1.99-4.6-4.11-15.56-3.43-34.72m793.47 37.58c-4.91 9.11-12.98 14.43-21.69 14.43-1.97 0-3.97-.27-5.97-.83 45.63 41.11 95.07 88.34 148.24 142.59 208.14 212.43 247.56 622.56 245.42 919.43.01 0 .02 0 .03-.01-1.06 148.23-12.49 268.24-18.45 321.3a194.964 194.964 0 0126.88-.7c.81-1.16 1.63-2.32 2.45-3.48 7.38-65.84 20.49-209.07 18.32-380.06-3.01-237.44-35.49-528.39-153.68-739.93-33.51-28.95-78.97-77.31-109.86-146.08-46.78-47.4-90.71-89.44-131.69-126.66m-1045.91 275.82c-22.15 18.71-38.33 28.48-40.26 29.63l-11.79 6.95c-13.75 28.12-26.14 57.35-37.33 87.51-79.33 213.73-97.45 471.81-95.74 676.34 21.65 66.11 22.83 122.62 22.89 126.6l.25 18.86-16.07-1.57c-.3-.04-1.19-.13-2.62-.3 2.67 50.27 6.15 93.75 9.38 128.03.94.87 1.89 1.75 2.83 2.64 10.96 10.32 20.81 21.33 29.68 32.77-17.45-164.18-63.39-758.79 138.78-1107.46m62.32 1131.46c-81.59 0-144.65 9.28-175.38 14.9 4.98 8.83 9.5 17.77 13.59 26.69 31.92-5.4 89.52-12.95 161.77-12.95 66.13 0 131.3 6.24 193.65 18.56 205.44 40.54 349.66 193.8 351.1 195.35l21.04 22.67 21.02-22.7c1.4-1.52 145.65-154.78 351.1-195.32 62.37-12.34 127.5-18.56 193.64-18.56 36.15 0 68.64 1.89 96.07 4.46a178.9 178.9 0 0114.78-11.38l-11.41-17.09c-28.32-2.67-61.92-4.62-99.41-4.63-58.55 0-126.63 4.78-199.18 19.1-217.65 42.93-366.58 204-366.58 204l-.02-.02c-.02.01-.02.02-.02.02s-148.92-161.07-366.59-204c-72.53-14.32-140.63-19.09-199.17-19.1m1246.52 6.21c2.37 2.75 4.76 5.51 7.16 8.3 3.67-2.15 7.44-4.19 11.28-6.1-5.8-.75-11.95-1.49-18.44-2.2"></path>
        </clipPath>
        <linearGradient
          id="linearGradient17961"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1626.6 0 0 -1626.6 1112.29 1761.91)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f6e604" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e64120" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath17971" clipPathUnits="userSpaceOnUse">
          <path d="M2133.23 982.781c-7.51 9.629-20.24 27.019-31.83 42.799-40.28 54.95-71.14 95.79-94.94 123.35h301.2l380.89 657.56-.87 5.3-14.8-2.44 14.8 2.44-.55 3.36-.44 2.71-218.03 376.18c83.67-7.49 164.34-24.87 240.77-50.85 2.14-296.87-37.28-707-245.42-919.43-53.17-54.25-102.61-101.48-148.24-142.59-.16-.05-.32-.09-.49-.14-12.9-3.92-40.21-19.56-83.7-44.74-30.34-17.59-78.63-45.571-98.35-53.509m-368.25 0c-19.72 7.938-68.02 35.919-98.37 53.509-43.47 25.18-70.77 40.82-83.67 44.74-2.18.66-4.35.98-6.48.98-9.5 0-18.22-6.33-22.94-17-45.2 40-94.36 86.21-147.33 139.49-10.47 21.64-22.35 41.15-34.71 58.54a929.388 929.388 0 0017.4 153.55l156.78-270.52 9.57 2.86h221.21l-15.56-23.31c5.68 6.37 12.65 14.29 20.54 23.31h110.33c-23.8-27.56-54.66-68.4-94.94-123.35-11.58-15.8-24.33-33.17-31.83-42.799m-467.37 360.539a.55.55 0 00-.09.07c-202.17 348.67-156.23 943.28-138.78 1107.46.01.02.03.05.05.07-17.44-164.08-63.42-758.88 138.82-1107.6m1193.81 1131.53h-.02c37.49.01 71.09 1.96 99.41 4.63v-.01c-28.33-2.66-61.9-4.62-99.39-4.62m-1131.56 0h-.02c58.54.01 126.64 4.78 199.17 19.1 217.67 42.93 366.59 204 366.59 204s0-.01.02-.02c-2.06-2.22-150.41-161.34-366.56-203.98-72.55-14.32-140.65-19.1-199.2-19.1m1246.49 6.2l.01.01c6.49.71 12.64 1.45 18.44 2.2h.01c-5.81-.75-11.96-1.49-18.46-2.21"></path>
        </clipPath>
        <linearGradient
          id="linearGradient17977"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(1405.668 -1405.668) rotate(74.316 1.794 -.004)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#e61d25" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#fcd405" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath17987" clipPathUnits="userSpaceOnUse">
          <path d="M2709.46 2143.18c-.01.01-.02.01-.03.01-1.07 148.22-12.5 268.23-18.47 321.29h.05c5.96-53.06 17.39-173.07 18.45-321.3m-218.09 331.67c-58.55 0-126.63 4.78-199.19 19.1-216.14 42.64-364.51 201.76-366.56 203.98l.02.02s148.93-161.07 366.58-204c72.55-14.32 140.63-19.1 199.18-19.1h-.03m-1131.55 0c-81.58 0-144.62 9.27-175.37 14.89l.01.01c30.73-5.62 93.79-14.9 175.38-14.9h-.02"></path>
        </clipPath>
        <linearGradient
          id="linearGradient17993"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1626.6 0 0 -1626.6 1112.29 1761.91)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f8a50d" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#da1e26" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath18003" clipPathUnits="userSpaceOnUse">
          <path d="M1371.48 1263.04c-25.15 35.4-52.32 62.06-73.87 80.28-202.24 348.72-156.26 943.52-138.82 1107.6 9.69 12.52 18.2 25.57 25.66 38.82 30.75-5.62 93.79-14.89 175.37-14.89h.04c58.55 0 126.65 4.78 199.2 19.1 216.15 42.64 364.5 201.76 366.56 203.98 2.05-2.22 150.42-161.34 366.56-203.98 72.56-14.32 140.64-19.1 199.19-19.1h.05c37.49 0 71.06 1.96 99.39 4.62l-46.03-68.97c14.33 16.08 36.9 42.01 61.57 70.55 6.5.72 12.65 1.46 18.46 2.21 20.08-9.98 42.44-16.52 66.15-18.78 5.97-53.06 17.4-173.07 18.47-321.29-76.43 25.98-157.1 43.36-240.77 50.85l-161.24 278.22-34.7.87h-693.24l-35.04-.17-379.68-655.21-.95-6.25-.79-5.21 225.86-389.7a929.388 929.388 0 01-17.4-153.55"></path>
        </clipPath>
        <linearGradient
          id="linearGradient18009"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(1405.668 -1405.668) rotate(74.316 1.794 -.004)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#d71f26" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#f7980f" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath18019" clipPathUnits="userSpaceOnUse">
          <path d="M1760.88 1125.62l15.56 23.31h4.98c-7.89-9.02-14.86-16.94-20.54-23.31"></path>
        </clipPath>
        <linearGradient
          id="linearGradient18025"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(1405.668 -1405.668) rotate(74.316 1.794 -.004)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#fabbaf" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#fcf3a5" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath23159" clipPathUnits="userSpaceOnUse">
          <path d="M1561.42 1178.93h-.12l-.06.1 58.06 100.18-57.88-100.28m-366.1 631.45l-.08.14 1.21 2.08 29.91-.15-31.04-2.07m1189.07 8.02l-1.23.01-40.6 70.31 14.11-22.52-.12.22 27.84-48.02"></path>
        </clipPath>
        <linearGradient
          id="linearGradient23167"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1494.24 0 0 -1494.24 1178.64 1810.98)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ee2b25" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#a71d2f" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#a71d2f" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath23179" clipPathUnits="userSpaceOnUse">
          <path d="M1694.47 1409.43l-30.49 52.61-73.53 135.18 19.52 28.38c13.51-15.65 22.76-26.3 24.13-27.71.09-.09.14-.13.17-.13.51 0-7.63 13.49-20.19 33.81l14.98 21.78c60.45 65.33 137.36 137.32 226.84 191.31 29.24 17.63 59.49 32.39 89.96 44.7l-101.07-478.13h303.54l2.86 4.99 3.57-6.19h-459.95l-.34-.6m458.87 13.73l11.61 519.93c44.24 5.04 83.88 6.55 115.48 6.55 8.69 0 16.76-.11 24.16-.3l37.97-60.62 40.6-70.31h-.8l-229.02-395.25"></path>
        </clipPath>
        <clipPath id="clipPath23191" clipPathUnits="userSpaceOnUse">
          <path d="M2148.47 2223.18h-453.84l-132.76 219.86 17.68.08h8.77l121.88-201.51h430.07l122.83 201.51h9.25l16.7-.41-15.56-26.85-125.02-192.68"></path>
        </clipPath>
        <clipPath id="clipPath23203" clipPathUnits="userSpaceOnUse">
          <path d="M2289.05 2442.71l-16.7.41h-9.25l9.15 15h-693l9.07-15h-8.77l-17.68-.08-6.26 10.36-2.71 4.72-.07-.11-.07.11h745.97l-.37-.64-.38.64-8.93-15.41"></path>
        </clipPath>
        <clipPath id="clipPath23215" clipPathUnits="userSpaceOnUse">
          <path d="M2148.33 1411.23h-303.54l101.07 478.13c75.55 30.54 152.51 46.14 219.09 53.73l-11.61-519.93-3.08-5.32.93-1.62-2.86-4.99"></path>
        </clipPath>
        <clipPath id="clipPath23227" clipPathUnits="userSpaceOnUse">
          <path d="M1590.45 1597.22l-4.31 7.93c6.67 7.77 13.63 15.75 20.87 23.89 1.01-1.17 2-2.32 2.96-3.44l-19.52-28.38m23.63 34.35c-.65 1.04-1.3 2.1-1.97 3.18 5.5 6.12 11.15 12.33 16.95 18.6l-14.98-21.78"></path>
        </clipPath>
        <clipPath id="clipPath23239" clipPathUnits="userSpaceOnUse">
          <path d="M2140.27 2241.61H1710.2l-121.88 201.51h674.78l-122.83-201.51"></path>
        </clipPath>
        <clipPath id="clipPath23251" clipPathUnits="userSpaceOnUse">
          <path d="M2263.1 2443.12h-674.78l-9.07 15h693l-9.15-15"></path>
        </clipPath>
        <clipPath id="clipPath23263" clipPathUnits="userSpaceOnUse">
          <path d="M2287.71 1178.93h-310.19c-1.44 1.25-2.85 2.41-4.21 3.49h277.77l-122.97 206.83h-403.78l-123.91-206.83h324.48c-1.36-1.08-2.76-2.24-4.21-3.49h-359.27l57.88 100.28 75.08 129.52h461.12l132.21-229.8"></path>
        </clipPath>
        <linearGradient
          id="linearGradient23271"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1494.24 0 0 -1494.24 1178.64 1810.98)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#d21f27" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#81182e" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#81182e" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath23283" clipPathUnits="userSpaceOnUse">
          <path d="M2155.5 1408.73h-461.12l.25.42-.16.28.34.6h459.95l.74-1.3"></path>
        </clipPath>
        <clipPath id="clipPath23295" clipPathUnits="userSpaceOnUse">
          <path d="M2251.08 1182.42h-277.77c-4.14 3.27-7.92 5.76-11.39 7.47-3.8 2.24-8.27 3.38-12.28 3.38h-1.1c-4.3 0-8.47-1.15-12.25-3.38-3.47-1.71-7.25-4.2-11.39-7.47h-324.48l123.91 206.83h403.78l122.97-206.83"></path>
        </clipPath>
        <clipPath id="clipPath23307" clipPathUnits="userSpaceOnUse">
          <path d="M1226.36 1812.45l-29.91.15 21.53 37.14 212.95-1.1c4.9-7.81 9.49-15.1 13.64-21.65l-218.21-14.54m441.43 391.64l-121.8 211.71 14.86 25.65 111.39-229.49-4.45-7.87"></path>
        </clipPath>
        <clipPath id="clipPath23319" clipPathUnits="userSpaceOnUse">
          <path d="M1196.45 1812.6l-17.54.09L1552.82 2458l8.03-16.55-14.86-25.65-2.93 5.1-330.98-571.13 5.9-.03-21.53-37.14"></path>
        </clipPath>
        <clipPath id="clipPath23331" clipPathUnits="userSpaceOnUse">
          <path d="M1468.98 1851.96l-2.29 2.76 151.9 262.21-149.61-264.97"></path>
        </clipPath>
        <clipPath id="clipPath23343" clipPathUnits="userSpaceOnUse">
          <path d="M1555.61 2453.4l-2.78 4.61.07.11 2.71-4.72"></path>
        </clipPath>
        <clipPath id="clipPath23355" clipPathUnits="userSpaceOnUse">
          <path d="M2290.37 1178.93h-.23l-132.36 231.1h-.34l230.76 399.65-5.04 8.73 1.23-.01 3.58-6.18 267.04.46 1.23-2.12-22.16-38.25-242.94 1.19-205.37-354.47 121.42-211.07-16.82-29.03"></path>
        </clipPath>
        <linearGradient
          id="linearGradient23363"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1494.24 0 0 -1494.24 1178.64 1810.98)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#d51f26" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#82182e" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#82182e" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath23375" clipPathUnits="userSpaceOnUse">
          <path d="M2157.44 1410.03h-2.68l-3.57 6.19 2.08 3.62.07 3.32 229.02 395.25h.8l5.04-8.73-230.76-399.65"></path>
        </clipPath>
        <clipPath id="clipPath23387" clipPathUnits="userSpaceOnUse">
          <path d="M2151.19 1416.22l-.93 1.62 3.08 5.32-.07-3.32-2.08-3.62"></path>
        </clipPath>
        <clipPath id="clipPath23399" clipPathUnits="userSpaceOnUse">
          <path d="M2290.14 1178.93h-2.43l-132.21 229.8h1.19l.75 1.3h.34l132.36-231.1"></path>
        </clipPath>
        <linearGradient
          id="linearGradient23407"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1494.24 0 0 -1494.24 1178.64 1810.98)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#a11d2a" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#641e2c" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#641e2c" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath23419" clipPathUnits="userSpaceOnUse">
          <path d="M2156.69 1408.73h-1.19l-.74 1.3h2.68l-.75-1.3"></path>
        </clipPath>
        <clipPath id="clipPath23431" clipPathUnits="userSpaceOnUse">
          <path d="M2311.14 1201.1l-1.03 1.79 329.92 569.39 2.1-.01-330.99-571.17"></path>
        </clipPath>
        <clipPath id="clipPath23443" clipPathUnits="userSpaceOnUse">
          <path d="M2307.19 1207.96l-121.42 211.07 205.37 354.47 242.94-1.19-326.89-564.35"></path>
        </clipPath>
        <clipPath id="clipPath23455" clipPathUnits="userSpaceOnUse">
          <path d="M2310.11 1202.89l-2.92 5.07 326.89 564.35 5.95-.03-329.92-569.39"></path>
        </clipPath>
        <clipPath id="clipPath23467" clipPathUnits="userSpaceOnUse">
          <path d="M1561.24 1179.03l-13.58 23.43 124.58 216.57-172.94 298.53 161.49-251.8 32.94-57.03h.33l-74.76-129.52-58.06-100.18m-343.83 593.24l-20.81 35.91 254.08-14.82 1.44-2.25-11.83-17.74-222.88-1.1"></path>
        </clipPath>
        <linearGradient
          id="linearGradient23475"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1494.24 0 0 -1494.24 1178.64 1810.98)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1c24" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#961a2f" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#961a2f" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath23487" clipPathUnits="userSpaceOnUse">
          <path d="M1694.06 1408.73h-.33l-32.94 57.03 7.64-11.91-4.45 8.19 30.49-52.61-.41-.7"></path>
        </clipPath>
        <clipPath id="clipPath23499" clipPathUnits="userSpaceOnUse">
          <path d="M1619.3 1279.21l74.76 129.52h.32l-75.08-129.52"></path>
        </clipPath>
        <linearGradient
          id="linearGradient23507"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1494.24 0 0 -1494.24 1178.64 1810.98)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#bc2027" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#751a2e" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#751a2e" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath23517" clipPathUnits="userSpaceOnUse">
          <path d="M1694.38 1408.73h-.32l.41.7.16-.28-.25-.42"></path>
        </clipPath>
        <clipPath id="clipPath23529" clipPathUnits="userSpaceOnUse">
          <path d="M1547.66 1202.46l-330.25 569.81 222.88 1.1-109.37-164c28.91 32.57 95.16 109.72 136.46 157.95l31.92-49.76 172.94-298.53-124.58-216.57"></path>
        </clipPath>
        <clipPath id="clipPath23541" clipPathUnits="userSpaceOnUse">
          <path d="M1546.88 1201.1l-330.97 571.17h1.5l330.25-569.81-.78-1.36"></path>
        </clipPath>
        <clipPath id="clipPath23553" clipPathUnits="userSpaceOnUse">
          <path d="M1430.93 1848.64l-212.95 1.1 328.01 566.06 121.8-211.71-49.2-87.16-151.9-262.21-136.92 165.12c18.17-37.38 67.14-116.98 101.16-171.2"></path>
        </clipPath>
        <clipPath id="clipPath23565" clipPathUnits="userSpaceOnUse">
          <path d="M1217.98 1849.74l-5.9.03 330.98 571.13 2.93-5.1-328.01-566.06"></path>
        </clipPath>
        <clipPath id="clipPath23577" clipPathUnits="userSpaceOnUse">
          <path d="M2652.47 1817.07l-268.08 1.33-27.84 48.02-186.42 345.54 121.03 228.52 13.77-23.75-122.95-213.75 205.33-354.51 246.22 1.28 18.94-32.68m-371.34 610.57l8.69 15.05h.06l.48-.83-9.23-14.22"></path>
        </clipPath>
        <clipPath id="clipPath23589" clipPathUnits="userSpaceOnUse">
          <path d="M2663.45 1812.7l2.49 4.3-13.47.07-18.94 32.68 4.75.02-330.95 571.13-2.4-4.17-13.77 23.75 7.57 14.29-8.37-12.91-.48.83h-.06l8.54 14.79 373.7-644.77-8.61-.01"></path>
        </clipPath>
        <clipPath id="clipPath23601" clipPathUnits="userSpaceOnUse">
          <path d="M2273.49 2415.86l15.56 26.85.77-.02-8.69-15.05-7.64-11.78"></path>
        </clipPath>
        <clipPath id="clipPath23613" clipPathUnits="userSpaceOnUse">
          <path d="M2289.82 2442.69l-.77.02 8.93 15.41.38-.64-8.54-14.79"></path>
        </clipPath>
        <clipPath id="clipPath23625" clipPathUnits="userSpaceOnUse">
          <path d="M2387.97 1812.22l-3.58 6.18 268.08-1.33 2.54-4.39-267.04-.46"></path>
        </clipPath>
        <clipPath id="clipPath23637" clipPathUnits="userSpaceOnUse">
          <path d="M2655.01 1812.68l-2.54 4.39 13.47-.07-2.49-4.3-8.44-.02"></path>
        </clipPath>
        <clipPath id="clipPath23649" clipPathUnits="userSpaceOnUse">
          <path d="M2387.31 1848.47l-205.33 354.51 122.95 213.75 328.6-566.98-246.22-1.28"></path>
        </clipPath>
        <clipPath id="clipPath23661" clipPathUnits="userSpaceOnUse">
          <path d="M2633.53 1849.75l-328.6 566.98 2.4 4.17 330.95-571.13-4.75-.02"></path>
        </clipPath>
        <clipPath id="clipPath23673" clipPathUnits="userSpaceOnUse">
          <path d="M1586.14 1605.15l-71.35 131.19c29.99-34.95 67.34-78.45 92.22-107.3-7.24-8.14-14.2-16.12-20.87-23.89"></path>
        </clipPath>
        <clipPath id="clipPath23685" clipPathUnits="userSpaceOnUse">
          <path d="M1629.06 1653.35l374.66 544.7 7.4.03-65.26-308.72c-30.47-12.31-60.72-27.07-89.96-44.7-89.48-53.99-166.39-125.98-226.84-191.31m-89.15 262.06L1694.63 2197l47.43.16-136.02-194.1c3.76 7.15 6.1 11.63 6.46 12.42v.01c-.24 0-37.17-51.03-72.59-100.08m625.04 27.68l4.93 221.27 134.71-215.02c-7.4.19-15.47.3-24.16.3-31.6 0-71.24-1.51-115.48-6.55"></path>
        </clipPath>
        <clipPath id="clipPath23697" clipPathUnits="userSpaceOnUse">
          <path d="M1945.86 1889.36l65.26 308.72 137.35.46 21.41-34.18-4.93-221.27c-66.58-7.59-143.54-23.19-219.09-53.73"></path>
        </clipPath>
        <clipPath id="clipPath23709" clipPathUnits="userSpaceOnUse">
          <path d="M1612.11 1634.75c-32.25 52.09-90.31 144.05-109.26 174.04h.01s79.59 149.47 103.18 194.27l136.02 194.1 261.66.89-374.66-544.7c-5.8-6.27-11.45-12.48-16.95-18.6"></path>
        </clipPath>
        <clipPath id="clipPath23723" clipPathUnits="userSpaceOnUse">
          <path d="M1634.27 1597.76c-.03 0-.08.04-.17.13-1.37 1.41-10.62 12.06-24.13 27.71l4.11 5.97c12.56-20.32 20.7-33.81 20.19-33.81"></path>
        </clipPath>
        <clipPath id="clipPath23735" clipPathUnits="userSpaceOnUse">
          <path d="M1609.97 1625.6c-.96 1.12-1.95 2.27-2.96 3.44 1.69 1.9 3.38 3.79 5.1 5.71.67-1.08 1.32-2.14 1.97-3.18l-4.11-5.97"></path>
        </clipPath>
        <clipPath id="clipPath23747" clipPathUnits="userSpaceOnUse">
          <path d="M1607.01 1629.04c-24.88 28.85-62.23 72.35-92.22 107.3l-28.72 52.81c10.34 12.09 16.7 19.54 16.78 19.64 18.95-29.99 77.01-121.95 109.26-174.04-1.72-1.92-3.41-3.81-5.1-5.71"></path>
        </clipPath>
        <clipPath id="clipPath23761" clipPathUnits="userSpaceOnUse">
          <path d="M1444.57 1826.99c-4.15 6.55-8.74 13.84-13.64 21.65l32.14-.17 3.62 6.25 2.29-2.76-13.7-24.25-10.71-.72"></path>
        </clipPath>
        <clipPath id="clipPath23773" clipPathUnits="userSpaceOnUse">
          <path d="M1463.07 1848.47l-32.14.17c-34.02 54.22-82.99 133.82-101.16 171.2l136.92-165.12-3.62-6.25"></path>
        </clipPath>
        <clipPath id="clipPath23787" clipPathUnits="userSpaceOnUse">
          <path d="M1440.29 1773.37l11.83 17.74 11.31-17.63-23.14-.11"></path>
        </clipPath>
        <linearGradient
          id="linearGradient23795"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1494.24 0 0 -1494.24 1178.64 1810.98)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#fabbb0" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#e8b0b6" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e8b0b6" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath23805" clipPathUnits="userSpaceOnUse">
          <path d="M1330.92 1609.37l109.37 164 23.14.11 3.95-6.16c-41.3-48.23-107.55-125.38-136.46-157.95"></path>
        </clipPath>
        <clipPath id="clipPath23819" clipPathUnits="userSpaceOnUse">
          <path d="M1522.83 1884.33l17.08 31.08c35.42 49.05 72.35 100.08 72.59 100.08v-.01c-.36-.79-2.7-5.27-6.46-12.42l-83.21-118.73"></path>
        </clipPath>
        <clipPath id="clipPath23831" clipPathUnits="userSpaceOnUse">
          <path d="M1502.85 1808.79c-3.91 6.2-6.16 9.74-6.16 9.74l-6.02 7.27 32.16 58.53 83.21 118.73c-23.59-44.8-103.18-194.27-103.18-194.27h-.01"></path>
        </clipPath>
        <clipPath id="clipPath23845" clipPathUnits="userSpaceOnUse">
          <path d="M1486.07 1789.15l-7.73 14.21 12.33 22.44 6.02-7.27s2.25-3.54 6.16-9.74c-.08-.1-6.44-7.55-16.78-19.64"></path>
        </clipPath>
        <clipPath id="clipPath28109" clipPathUnits="userSpaceOnUse">
          <path d="M3115.25 1527.32h-.1c-3.85.01-7.64.26-11.35.79 7.13 32.45 12.67 65.34 16.62 98.54 13.07-20.79 35.1-31.5 57.57-31.5 19.64 0 39.62 8.18 54.23 24.99 48.3 55.54 84.53 261.76 70.92 266.74 0 0-123.44-41.5-174.46-139.76.18 7.46.29 14.91.34 22.34 32.73 48.8 75.25 78.96 111.53 97.31 20.95 10.6 39.8 17.24 53.36 21.22 6.77 1.98 12.22 3.3 15.97 4.12v-1.92c.02-25.1-2.06-106.77-26.07-188.77-15.91-54.38-42.92-98.08-73.59-128.04-30.64-29.96-64.87-46.05-94.97-46.06"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28117"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-316.0664 316.0664) rotate(-80.836 -1.612 8.931)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1b28" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#a71d2f" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#a71d2f" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28129" clipPathUnits="userSpaceOnUse">
          <path d="M3177.99 1595.15c-22.47 0-44.5 10.71-57.57 31.5 1.6 13.47 2.94 27 4.01 40.57 2.22 26.75 3.64 53.4 4.25 79.9 51.02 98.26 174.46 139.76 174.46 139.76 13.61-4.98-22.62-211.2-70.92-266.74-14.61-16.81-34.59-24.99-54.23-24.99m118.26 276.89s-119.24-41.96-134.2-98.38c-11.91-44.86 17.56-84.84 49.74-84.84 8.31 0 16.8 2.66 24.81 8.6 39 28.95 59.65 174.62 59.65 174.62"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28137"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-316.0664 316.0664) rotate(-80.836 -1.612 8.931)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1e27" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#e51d25" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e51d25" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28147" clipPathUnits="userSpaceOnUse">
          <path d="M3211.79 1688.82c-32.18 0-61.65 39.98-49.74 84.84 14.96 56.42 134.2 98.38 134.2 98.38s-20.65-145.67-59.65-174.62c-8.01-5.94-16.5-8.6-24.81-8.6"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28155"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-316.0664 316.0664) rotate(-80.836 -1.612 8.931)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f04031" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#ed212e" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#ed212e" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28167" clipPathUnits="userSpaceOnUse">
          <path d="M1627.32 763.629c-9.37 1.25-19.29 2.012-29.79 2.16-50.94 12.531-96.08 23.602-111.83 27.481l.19-.04-.18.04c-19.61 4.851-39.28 9.601-58.93 14.128l-29.55 6.622h-.01c-10.45 2.199-20.72 5.781-30.46 9.652-13.4 5.488-26.44 11.609-39.23 18.219-2.12 4.73-4.61 9.851-7.52 15.25 17.67-10.672 36.02-16.821 54.1-17.852 1.89-.098 3.79-.148 5.68-.148 2.17 0 4.33.07 6.47.218l6.12.422 4.39 5c.96 1.071 8.54 9.828 17.54 26.629l28.3-6.34-.01.012c19.19-4.352 38.3-8.891 57.37-13.57h.01c14.45-3.532 54.96-13.41 101.84-24.891 7.44-19.539 15.91-40.531 25.5-62.992m-385.71 181.582c-21.14 15.211-46.73 29.301-77.69 40.691a260.063 260.063 0 01-51.49 13.188c-34.35 32.49-67.02 67.44-97.6 104.76l-.07 4.29c-.03 1.73-.5 16.83-6.47 39.57.72-.55 1.46-1.1 2.19-1.63 3.48-2.51 7.07-4.78 10.71-6.82l5.5-3.08 5.92 1.88c.92.28 6.42 2.09 14.89 6.61 42.15-50.54 88.39-96.49 137.46-137.67h.01a1028.167 1028.167 0 0143.7-34.629c4-9.48 8.33-18.551 12.94-27.16M944.488 1264.04c-17.894 20.08-40.34 40.18-68.496 58.98-.312.2-.613.41-.926.61a978.137 978.137 0 00-30.277 71.29l-.004.02h-.004c-23.086 60.43-40.281 124.03-51.125 188.94a237.158 237.158 0 012.551 21.8c1.004-29.94 8.063-57.04 20.801-78.36 2.012-3.38 4.238-6.73 6.539-9.84l3.558-4.77 5.313-.89c.742-.13 4.793-.76 11.488-.76 2.477 0 5.317.09 8.485.32 9.398-33.96 20.664-67.22 33.754-99.51l-.004.01c15.398-38.22 33.226-75.01 53.043-110.29 1.062-12.98 2.847-25.53 5.304-37.55m-147.726 366.99c-.66 25.83-5.114 56.93-16.989 92.08-.765 18.19-1.156 36.4-1.156 54.61 0 58.54 4.016 117.04 12.36 174.7.175 1.19.347 2.37.527 3.56 4.32 4.43 12.051 13.24 20.539 26.99 1.457-9.11 3.68-17.82 6.684-26.04 1.402-3.79 3.007-7.6 4.726-11.19l.75-1.56-.363-3.08v.01c-5.524-46.27-8.207-92.93-8.207-139.57 0-27.73.949-55.45 2.816-83.08-12.418-29.35-19.558-59.21-21.687-87.43m-5.785 321.39v.01-.01m59.906 187.22c.004 12.29-.528 25.27-1.692 38.95-.015.2-.031.39-.05.59 5.25 13.93 10.785 27.7 16.605 41.31l-.019-.04.015.03c18.035 42.05 38.789 82.5 62.094 120.67l-.035-.05.035.06c2.535 4.15 5.105 8.27 7.711 12.36 3.601-1.33 12.305-4.12 25.105-5.53a979.72 979.72 0 01-15.593-26.68l-.008-.01c-21.422-38.16-40.371-78.14-56.586-119.54a991.184 991.184 0 01-9.75-25.91 279.087 279.087 0 01-27.832-36.21"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28175"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(1255.384) rotate(-84.408 1.387 .286)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1b28" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#a71d2f" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#a71d2f" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28189" clipPathUnits="userSpaceOnUse">
          <path d="M2270.55 762.852c10.13 23.699 19 45.726 26.75 66.199 29.6 7.75 59.15 15.219 88.82 22.461 19.11 4.679 38.2 9.218 57.36 13.57l.05.008 28.26 6.32c9-16.789 16.58-25.558 17.54-26.629l4.4-5 6.11-.422c2.15-.148 4.32-.218 6.49-.218 1.89 0 3.79.05 5.68.148 18.08 1.031 36.42 7.18 54.09 17.852a231.67 231.67 0 01-7.53-15.262c-12.78-6.609-25.81-12.731-39.21-18.207-9.73-3.871-20.05-7.453-30.47-9.652h-.04l-29.51-6.622c-19.68-4.527-39.3-9.277-58.92-14.128-36.52-8.989-72.95-18.469-109.36-28.098a241.66 241.66 0 01-20.51-2.32m373.94 182.359c4.61 8.609 8.94 17.68 12.94 27.168a1015.131 1015.131 0 0143.69 34.621c49.07 41.18 95.33 87.13 137.49 137.67 8.48-4.51 13.99-6.33 14.9-6.61l5.9-1.88 5.55 3.08c3.61 2.04 7.16 4.31 10.66 6.82.74.54 1.47 1.08 2.2 1.64-5.97-22.74-6.44-37.85-6.48-39.58l-.08-4.32c-30.56-37.31-63.22-72.24-97.57-104.73a260.418 260.418 0 01-51.51-13.188c-30.96-11.39-56.55-25.48-77.69-40.691m297.15 318.839c2.45 12.01 4.23 24.55 5.3 37.52 19.82 35.29 37.64 72.08 53.03 110.31l-.01-.01c13.1 32.29 24.37 65.54 33.77 99.51 3.16-.23 5.99-.32 8.47-.32 6.69 0 10.74.63 11.49.76l5.31.89 3.55 4.77c2.35 3.11 4.56 6.46 6.59 9.84 27.72 46.43 28.52 120.29-1.49 191.18 1.87 27.64 2.82 55.37 2.82 83.11 0 46.62-2.69 93.25-8.21 139.5l-.01.09.01-.1c-.11 1.01-.24 2.03-.36 3.04l.77 1.6c1.74 3.59 3.32 7.4 4.75 11.19 2.99 8.21 5.21 16.93 6.66 26.02 8.5-13.77 16.25-22.58 20.56-27 .18-1.17.35-2.35.52-3.52 8.33-57.61 12.33-116.06 12.33-174.55 0-36.17-1.53-72.36-4.51-108.38v-.02c-7.46-94.37-28.49-187.73-61.62-274.54l-.01-.02c-9.19-24.29-19.33-48.07-30.3-71.3l-.9-.6c-28.17-18.8-50.62-38.89-68.51-58.97m153.53 688.37l-.01.01c.01-.01.01 0 .01-.01m-59.97 187.25a279.914 279.914 0 01-27.79 36.16c-3.13 8.7-6.38 17.34-9.75 25.93-16.22 41.4-35.14 81.38-56.59 119.54l-.01.02c0-.01.01-.01.01-.02l-.04.07.03-.05a971.334 971.334 0 01-15.59 26.67c12.78 1.41 21.48 4.2 25.08 5.53 2.6-4.09 5.17-8.21 7.69-12.36l.06-.09c23.28-38.15 44.04-78.57 62.06-120.59 5.82-13.58 11.34-27.32 16.59-41.22l-.06-.67c-1.16-13.67-1.69-26.64-1.69-38.92"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28197"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-1247.285 1247.285) rotate(-84.408 -.165 2.01)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1b28" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#a71d2f" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#a71d2f" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28211" clipPathUnits="userSpaceOnUse">
          <path d="M2994.84 1062.52h-.05c-43.02.03-79.78 16.26-101.81 46.64.43 6.84 3.18 34.97 19.89 71.01 17.16 36.97 48.94 82.28 108.26 121.86 50.53 33.7 103.8 43.79 149.68 43.79 34.15.01 64.14-5.62 85.55-11.24 10.7-2.8 19.26-5.61 25.11-7.71 1.64-.58 3.06-1.11 4.27-1.57-9.26-20.6-49.74-105.6-114.44-175.71-54.85-59.47-120.7-87.07-176.46-87.07m190.97 271.36c-54.9 0-123.78-11.49-172.79-59.29-84.74-82.73-21.36-176.57 45.95-176.57 7.63 0 15.32 1.21 22.84 3.78 73.83 25.15 205.02 208.68 193.71 222.22 0 0-38.87 9.86-89.71 9.86"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28219"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-333.242 333.242) rotate(-52.559 -.665 11.705)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1b28" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#a71d2f" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#a71d2f" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28231" clipPathUnits="userSpaceOnUse">
          <path d="M3058.97 1098.02c-67.31 0-130.69 93.84-45.95 176.57 49.01 47.8 117.89 59.29 172.79 59.29 50.84 0 89.71-9.86 89.71-9.86 11.31-13.54-119.88-197.07-193.71-222.22a70.436 70.436 0 00-22.84-3.78m108.1 226.78c-33.83 0-67.79-5.72-84.83-25.3-39.84-45.8-14.25-123.29 35.36-123.29 1.36 0 2.75.06 4.15.18 52.33 4.4 140.04 137.15 140.04 137.15s-47.24 11.26-94.72 11.26"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28239"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-333.242 333.242) rotate(-52.559 -.665 11.705)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1e27" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#e51d25" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e51d25" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28249" clipPathUnits="userSpaceOnUse">
          <path d="M3117.6 1176.21c-49.61 0-75.2 77.49-35.36 123.29 17.04 19.58 51 25.3 84.83 25.3 47.48 0 94.72-11.26 94.72-11.26s-87.71-132.75-140.04-137.15c-1.4-.12-2.79-.18-4.15-.18"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28257"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-333.242 333.242) rotate(-52.559 -.665 11.705)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f04031" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#ed212e" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#ed212e" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28269" clipPathUnits="userSpaceOnUse">
          <path d="M3108.63 1971.45c-4.75 4.76-19.98 21.47-33.03 53-1.8 23.93-7.98 49.09-18.44 73.82-1.48 12.8-2.32 26.66-2.33 41.63 0 11.52.5 23.69 1.59 36.55 6.31 74.45 37.42 133.89 67.02 174.75 14.79 20.42 29.19 36.19 39.87 46.82 5.18 5.15 9.48 9.09 12.52 11.78 9.1-21.33 38.91-96.4 48.67-183.57 1.53-13.65 2.26-27.09 2.26-40.22.01-58.97-14.73-111.79-37.28-150.22-11.26-19.22-24.47-34.82-38.64-45.85-13.48-10.5-27.78-16.84-42.21-18.49m63.16 430.35c-.09 0-.18 0-.27-.02 0 0-111.82-119.33-103.4-245.48 4.32-64.53 35.38-90.56 67.65-90.57 30.78 0 62.66 23.69 73.48 60.23 22.05 74.33-23.03 275.84-37.46 275.84"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28277"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(322.642 -322.642) rotate(72.819 9.71 2.856)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1b28" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#a71d2f" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#a71d2f" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28289" clipPathUnits="userSpaceOnUse">
          <path d="M3135.77 2065.73c-32.27.01-63.33 26.04-67.65 90.57-8.42 126.15 103.4 245.48 103.4 245.48.09.02.18.02.27.02 14.43 0 59.51-201.51 37.46-275.84-10.82-36.54-42.7-60.23-73.48-60.23m35.24 319.19s-90.94-99.45-82.91-157.79c4.88-35.61 30.52-55.98 55.21-55.98 15.78 0 31.18 8.33 40.51 26.32 23.97 46.19-12.81 187.45-12.81 187.45"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28297"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(322.642 -322.642) rotate(72.819 9.71 2.856)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1e27" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#e51d25" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e51d25" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28307" clipPathUnits="userSpaceOnUse">
          <path d="M3143.31 2171.15c-24.69 0-50.33 20.37-55.21 55.98-8.03 58.34 82.91 157.79 82.91 157.79s36.78-141.26 12.81-187.45c-9.33-17.99-24.73-26.32-40.51-26.32"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28315"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(322.642 -322.642) rotate(72.819 9.71 2.856)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f04031" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#ed212e" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#ed212e" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28327" clipPathUnits="userSpaceOnUse">
          <path d="M2707.03 729.43h-.01c-63.53.031-116.44 29.148-138.08 76.8 1.59 6.29 8.88 31.52 29.98 61.219 23.13 32.551 62.73 70.543 129.97 95.332 28.77 10.59 57.09 14.778 83.98 14.778 51.03.011 96.9-15.149 129.97-30.368 16.54-7.609 29.87-15.222 39.04-20.91 4.34-2.691 7.75-4.949 10.12-6.582-12.72-17.758-67.67-90.777-143.6-143.258-47.03-32.539-96.72-47.011-141.37-47.011m109.49 234.269c-34.15 0-69.17-6.801-100.29-25.84-106.25-65.019-44.07-186.109 30.31-186.129 1.86 0 3.72.083 5.6.231 76.78 6.32 238.21 153.219 229.59 169.281 0 0-79.88 42.457-165.21 42.457"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28335"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-321.874 321.874) rotate(-40.334 -.387 13.764)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1b28" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#a71d2f" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#a71d2f" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28347" clipPathUnits="userSpaceOnUse">
          <path d="M2746.54 751.73c-74.38.02-136.56 121.11-30.31 186.129 31.12 19.039 66.14 25.84 100.29 25.84 85.33 0 165.21-42.457 165.21-42.457 8.62-16.062-152.81-162.961-229.59-169.281a71.235 71.235 0 00-5.6-.231m81.62 203.969c-15.55 0-29.48-2.988-39.77-10.578-48.55-35.851-35.64-121.543 16.27-130.172 1.99-.328 4.07-.488 6.22-.488 54 0 155.5 99.891 155.5 99.891s-80.39 41.347-138.22 41.347"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28355"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-321.874 321.874) rotate(-40.334 -.387 13.764)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1e27" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#e51d25" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e51d25" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28365" clipPathUnits="userSpaceOnUse">
          <path d="M2810.88 814.461c-2.15 0-4.23.16-6.22.488-51.91 8.629-64.82 94.321-16.27 130.172 10.29 7.59 24.22 10.578 39.77 10.578 57.83 0 138.22-41.347 138.22-41.347s-101.5-99.891-155.5-99.891"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28373"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-321.874 321.874) rotate(-40.334 -.387 13.764)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f04031" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#ed212e" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#ed212e" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28385" clipPathUnits="userSpaceOnUse">
          <path d="M2506.46 863.531c-1.06 0-2.12.02-3.17.059-7.23 9.199-42.85 59.211-42.86 154.65 0 25.44 2.53 54.11 8.83 86.13 16.31 82.94 58.73 144.74 97.15 185.85 19.21 20.55 37.39 35.9 50.75 46.09 6.68 5.1 12.14 8.91 15.93 11.43.14.1.28.19.42.29 7.23-24.01 32.36-114.97 32.6-216.45v-1.09c.01-76.14-20.77-143.271-51.27-191.092-15.24-23.898-32.9-42.957-51.47-55.949-18.58-13.008-37.97-19.918-56.91-19.918m120.98 474.989h-.06s-140.73-115.62-146.74-259.15c-3.39-80.44 35.03-114.241 75.49-114.241 31.75-.008 64.75 20.812 79.78 56.231 34.18 80.49 7.74 317.16-8.47 317.16"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28393"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(366.7443 -366.7443) rotate(80.101 5.533 2.349)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1b28" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#a71d2f" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#a71d2f" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28405" clipPathUnits="userSpaceOnUse">
          <path d="M2556.13 965.129c-40.46 0-78.88 33.801-75.49 114.241 6.01 143.53 146.74 259.15 146.74 259.15h.06c16.21 0 42.65-236.67 8.47-317.16-15.03-35.419-48.03-56.239-79.78-56.231m68.57 354.491s-114.69-96.77-112.85-163.87c1.22-44.53 32.35-72.89 62.71-72.89 15.38 0 30.56 7.27 41.55 23.41 32.67 48 8.59 213.35 8.59 213.35"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28413"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(366.7443 -366.7443) rotate(80.101 5.533 2.349)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1e27" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#e51d25" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e51d25" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28423" clipPathUnits="userSpaceOnUse">
          <path d="M2574.56 1082.86c-30.36 0-61.49 28.36-62.71 72.89-1.84 67.1 112.85 163.87 112.85 163.87s24.08-165.35-8.59-213.35c-10.99-16.14-26.17-23.41-41.55-23.41"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28431"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(366.7443 -366.7443) rotate(80.101 5.533 2.349)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f04031" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#ed212e" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#ed212e" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28443" clipPathUnits="userSpaceOnUse">
          <path d="M2857.32 1162.23c-6.27 2.48-26.68 11.82-50.38 36.06-27.17 27.81-58.77 75.23-78.3 154.84-7.56 30.86-10.64 61.19-10.64 90.11 0 62.25 14.26 117.99 28.54 158.13 7.14 20.07 14.28 36.23 19.62 47.35 2.25 4.69 4.18 8.47 5.66 11.29 16.83-17.57 75.72-82.46 117.53-170.27 25.43-53.36 36.79-109.3 36.78-160 .01-39.47-6.89-75.75-19.24-105.07-11.96-28.44-29.01-50.22-49.57-62.44m-86.2 486.36c-.46 0-.86-.11-1.2-.35 0 0-75.3-180.81-21.14-309.81 20.72-49.36 49.49-68.68 76.92-68.68 44.28-.01 85.08 50.31 82.99 105.81-3.32 87.62-118.97 273.03-137.57 273.03"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28451"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(355.547 -355.547) rotate(51.161 8.332 5.747)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1b28" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#a71d2f" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#a71d2f" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28463" clipPathUnits="userSpaceOnUse">
          <path d="M2825.7 1269.75c-27.43 0-56.2 19.32-76.92 68.68-54.16 129 21.14 309.81 21.14 309.81.34.24.74.35 1.2.35 18.6 0 134.25-185.41 137.57-273.03 2.09-55.5-38.71-105.82-82.99-105.81m-50.32 360.41s-60.29-149.55-30.91-207.23c12.94-25.4 34.45-37.11 55.22-37.11 26.4 0 51.61 18.94 56.52 52.8 8.71 60.45-80.83 191.54-80.83 191.54"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28471"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(355.547 -355.547) rotate(51.161 8.332 5.747)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1e27" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#e51d25" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e51d25" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28481" clipPathUnits="userSpaceOnUse">
          <path d="M2799.69 1385.82c-20.77 0-42.28 11.71-55.22 37.11-29.38 57.68 30.91 207.23 30.91 207.23s89.54-131.09 80.83-191.54c-4.91-33.86-30.12-52.8-56.52-52.8"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28489"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(355.547 -355.547) rotate(51.161 8.332 5.747)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f04031" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#ed212e" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#ed212e" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28501" clipPathUnits="userSpaceOnUse">
          <path d="M3012.37 1953.1h-.02c-31.73.04-81.95 11.03-140.08 65.72-49.59 46.69-75.19 109.67-88.25 161.1-6.53 25.69-9.94 48.46-11.71 64.78-.89 8.16-1.36 14.7-1.62 19.19l-.06 1.1c20.12-2.74 90.05-14.64 157.52-52.7 82.07-46.1 128.58-132.88 128.48-202.46 0-18.95-3.42-36.58-10.34-51.78-4.24-1.46-16.21-4.95-33.92-4.95m-232.53 304.87c-3.47 0-5.62-.7-6.19-2.19 0 0 24.18-174.74 119.08-235.56 18.31-11.72 34.79-16.73 49.15-16.74 60.08-.01 83.27 87.65 49.83 138.23-37.36 56.5-179.99 116.26-211.87 116.26"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28509"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(283.4984 -283.4984) rotate(16.01 31.765 30.952)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1b28" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#a71d2f" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#a71d2f" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28521" clipPathUnits="userSpaceOnUse">
          <path d="M2941.88 2003.48c-14.36.01-30.84 5.02-49.15 16.74-94.9 60.82-119.08 235.56-119.08 235.56.57 1.49 2.72 2.19 6.19 2.19 31.88 0 174.51-59.76 211.87-116.26 33.44-50.58 10.25-138.24-49.83-138.23m-156.47 242.55s21.4-143.38 67.59-167.51c7.95-4.15 15.93-6.02 23.6-6.02 36.87 0 66.49 43.17 50.02 83.51-19.95 48.68-141.21 90.02-141.21 90.02"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28529"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(283.4984 -283.4984) rotate(16.01 31.765 30.952)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1e27" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#e51d25" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e51d25" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28539" clipPathUnits="userSpaceOnUse">
          <path d="M2876.6 2072.5c-7.67 0-15.65 1.87-23.6 6.02-46.19 24.13-67.59 167.51-67.59 167.51s121.26-41.34 141.21-90.02c16.47-40.34-13.15-83.51-50.02-83.51"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28547"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(283.4984 -283.4984) rotate(16.01 31.765 30.952)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f04031" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#ed212e" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#ed212e" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28559" clipPathUnits="userSpaceOnUse">
          <path d="M2909.8 2369.23h-.02c-31.73.04-81.97 11.03-140.11 65.75-10.4 9.79-19.75 20.3-28.15 31.26 4.06.68 8.06 1.48 12.02 2.4 10.82-12.52 22.95-23.55 36.53-32.25 18.31-11.72 34.79-16.73 49.16-16.74 60.08-.01 83.26 87.62 49.83 138.2-3.01 4.56-6.7 9.14-10.97 13.71 1.75 4.26 3.32 8.6 4.7 13.02 46.06-46.79 71.27-107.37 71.2-158.63 0-18.95-3.42-36.58-10.33-51.78-4.24-1.46-16.2-4.94-33.86-4.94"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28567"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(283.4984 -283.4984) rotate(16.01 36.803 28.931)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1b28" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#a71d2f" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#a71d2f" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28579" clipPathUnits="userSpaceOnUse">
          <path d="M2839.23 2419.65c-14.37.01-30.85 5.02-49.16 16.74-13.58 8.7-25.71 19.73-36.53 32.25 57.27 13.38 103.71 52.26 124.55 102.92 4.27-4.57 7.96-9.15 10.97-13.71 33.43-50.58 10.25-138.21-49.83-138.2"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28587"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(283.4984 -283.4984) rotate(16.01 36.803 28.931)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1e27" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#e51d25" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e51d25" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28599" clipPathUnits="userSpaceOnUse">
          <path d="M3042.37 1533.13c-22.71.11-87.94 8.45-153.32 101.45-49.82 70.92-59.6 157.31-59.57 213.29 0 17.5.94 32.01 1.89 42.12.36 3.89.72 7.13 1.03 9.64 19.57-7.65 85.65-35.97 144.84-89.12 61.96-55.54 93.23-133.99 93.18-198.18.02-31.17-7.34-58.83-21.62-78.93a70.93 70.93 0 00-6.43-.27m-205.67 358.05c-1.45 0-2.44-.38-2.94-1.17 0 0-6.83-176.86 75.43-259 21.19-21.16 41.26-29.84 58.88-29.84 50.83 0 81.25 72.19 59.25 125.09-27.85 67.04-167.38 164.92-190.62 164.92"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28607"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(293.29 -293.29) rotate(27.792 17.042 16.307)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1b28" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#a71d2f" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#a71d2f" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28619" clipPathUnits="userSpaceOnUse">
          <path d="M2968.07 1601.17c-17.62 0-37.69 8.68-58.88 29.84-82.26 82.14-75.43 259-75.43 259 .5.79 1.49 1.17 2.94 1.17 23.24 0 162.77-97.88 190.62-164.92 22-52.9-8.42-125.09-59.25-125.09m-124.5 276.47s-4.06-145.51 36.89-180.11c10.61-8.95 22.18-12.88 33.34-12.88 31.97 0 60.44 32.27 52.29 71.13-11 52.44-122.52 121.86-122.52 121.86"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28627"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(293.29 -293.29) rotate(27.792 17.042 16.307)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1e27" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#e51d25" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e51d25" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28637" clipPathUnits="userSpaceOnUse">
          <path d="M2913.8 1684.65c-11.16 0-22.73 3.93-33.34 12.88-40.95 34.6-36.89 180.11-36.89 180.11s111.52-69.42 122.52-121.86c8.15-38.86-20.32-71.13-52.29-71.13"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28645"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(293.29 -293.29) rotate(27.792 17.042 16.307)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f04031" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#ed212e" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#ed212e" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28657" clipPathUnits="userSpaceOnUse">
          <path d="M1179.1 729.43c-44.66 0-94.36 14.461-141.4 47.011-43.544 30.118-80.223 66.989-105.946 96.309-12.863 14.672-22.996 27.43-29.902 36.531a490.687 490.687 0 00-7.715 10.43c17.406 11.961 90.383 57.848 178.883 57.848h.22c26.89 0 55.21-4.188 83.97-14.778 69.42-25.59 109.38-65.242 132.17-98.468 11.38-16.614 18.44-31.614 22.64-42.422 2.1-5.403 3.49-9.75 4.34-12.719.36-1.223.62-2.211.8-2.953-21.62-47.641-74.53-76.758-138.06-76.789m-109.51 234.269c-85.317 0-165.184-42.457-165.184-42.457-8.633-16.062 152.814-162.961 229.554-169.281 1.88-.148 3.74-.231 5.61-.231 74.38 0 136.59 121.11 30.31 186.129-31.13 19.039-66.14 25.84-100.29 25.84"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28665"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(321.844) rotate(-40.334 5.65 -2.673)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1b28" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#a71d2f" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#a71d2f" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28677" clipPathUnits="userSpaceOnUse">
          <path d="M1139.57 751.73c-1.87 0-3.73.083-5.61.231-76.74 6.32-238.187 153.219-229.554 169.281 0 0 79.867 42.457 165.184 42.457 34.15 0 69.16-6.801 100.29-25.84 106.28-65.019 44.07-186.129-30.31-186.129m-81.63 203.969c-57.84 0-138.237-41.347-138.237-41.347s101.517-99.883 155.517-99.891c2.16 0 4.23.16 6.22.488 51.94 8.629 64.81 94.321 16.27 130.172-10.29 7.59-24.21 10.578-39.77 10.578"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28685"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(321.844) rotate(-40.334 5.65 -2.673)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1e27" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#e51d25" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e51d25" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28695" clipPathUnits="userSpaceOnUse">
          <path d="M1075.22 814.461c-54 .008-155.517 99.891-155.517 99.891s80.397 41.347 138.237 41.347c15.56 0 29.48-2.988 39.77-10.578 48.54-35.851 35.67-121.543-16.27-130.172a38.183 38.183 0 00-6.22-.488"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28703"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(321.844) rotate(-40.334 5.65 -2.673)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f04031" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#ed212e" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#ed212e" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28715" clipPathUnits="userSpaceOnUse">
          <path d="M891.305 1062.52c-55.766-.02-121.641 27.58-176.5 87.07-37.137 40.26-66.325 85.42-86.168 120.48-9.926 17.53-17.524 32.54-22.629 43.14a534.085 534.085 0 00-5.645 12.09c14.117 5.38 58.907 20.52 114.875 20.52h.082c45.879 0 99.16-10.1 149.696-43.79 63.269-42.21 95.203-90.96 111.468-129.13 8.121-19.09 12.305-35.53 14.457-47.15 1.075-5.81 1.641-10.41 1.938-13.54.117-1.26.195-2.29.242-3.05-22.031-30.38-58.793-46.61-101.816-46.64m-190.992 271.36c-50.84 0-89.711-9.86-89.711-9.86-11.332-13.54 119.843-197.07 193.711-222.22a70.477 70.477 0 0122.847-3.78c67.32 0 130.703 93.84 45.942 176.57-49.004 47.8-117.879 59.29-172.789 59.29"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28723"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(333.242) rotate(-52.559 5.166 -.103)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1b28" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#a71d2f" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#a71d2f" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28735" clipPathUnits="userSpaceOnUse">
          <path d="M827.16 1098.02c-7.637 0-15.32 1.21-22.847 3.78-73.868 25.15-205.043 208.68-193.711 222.22 0 0 38.871 9.86 89.711 9.86 54.91 0 123.785-11.49 172.789-59.29 84.761-82.73 21.378-176.57-45.942-176.57M719.047 1324.8c-47.484 0-94.734-11.26-94.734-11.26s87.71-132.75 140.054-137.15c1.403-.12 2.789-.18 4.156-.18 49.633 0 75.219 77.49 35.36 123.29-17.039 19.58-51.004 25.3-84.836 25.3"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28743"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(333.242) rotate(-52.559 5.166 -.103)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1e27" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#e51d25" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e51d25" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28753" clipPathUnits="userSpaceOnUse">
          <path d="M768.523 1176.21c-1.367 0-2.753.06-4.156.18-52.344 4.4-140.054 137.15-140.054 137.15s47.25 11.26 94.734 11.26c33.832 0 67.797-5.72 84.836-25.3 39.859-45.8 14.273-123.29-35.36-123.29"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28761"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(333.242) rotate(-52.559 5.166 -.103)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f04031" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#ed212e" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#ed212e" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28773" clipPathUnits="userSpaceOnUse">
          <path d="M735.977 1554.04c-30.086 0-64.305 16.09-94.946 46.05-30.679 29.96-57.699 73.65-73.621 128.05-23.996 81.99-26.066 163.66-26.055 188.78 0 .69 0 1.33.004 1.93 12.184-2.68 42.469-10.65 77.266-29.51 40.195-21.78 86.336-57.98 118.074-117.33 32.106-60.03 40.485-110.96 40.492-148 0-20.76-2.64-37.15-5.261-48.31-1.309-5.57-2.614-9.84-3.578-12.68-.336-.99-.629-1.81-.872-2.45-9.765-4.39-20.304-6.53-31.39-6.53h-.113m-187.856 359.58c-13.613-5.03 22.578-211.23 70.875-266.75 14.617-16.81 34.602-25 54.254-25 45.297 0 88.82 43.53 60.711 125.42-40.316 117.4-185.84 166.33-185.84 166.33"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28781"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="rotate(-80.836 1431.823 575.062) scale(316.0816)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1b28" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#a71d2f" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#a71d2f" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28793" clipPathUnits="userSpaceOnUse">
          <path d="M673.25 1621.87c-19.652 0-39.637 8.19-54.254 25-48.297 55.52-84.488 261.72-70.875 266.75 0 0 145.524-48.93 185.84-166.33 28.109-81.89-15.414-125.42-60.711-125.42m-118.254 276.89s20.645-145.67 59.629-174.6c8.004-5.95 16.496-8.62 24.809-8.62 32.171 0 61.652 40 49.761 84.83-14.961 56.45-134.199 98.39-134.199 98.39"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28801"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="rotate(-80.836 1431.823 575.062) scale(316.0816)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1e27" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#e51d25" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e51d25" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28811" clipPathUnits="userSpaceOnUse">
          <path d="M639.434 1715.54c-8.313 0-16.805 2.67-24.809 8.62-38.984 28.93-59.629 174.6-59.629 174.6s119.238-41.94 134.199-98.39c11.891-44.83-17.59-84.83-49.761-84.83"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28819"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="rotate(-80.836 1431.823 575.062) scale(316.0816)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f04031" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#ed212e" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#ed212e" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28831" clipPathUnits="userSpaceOnUse">
          <path d="M777.469 1971.45c-14.434 1.65-28.727 7.99-42.211 18.49-42.606 33.01-75.985 107.57-75.899 196.02 0 13.14.731 26.6 2.266 40.27 5.785 51.73 18.637 99.22 30.047 133.73 5.703 17.25 11.043 31.26 14.949 40.94a504.63 504.63 0 003.692 8.91c21.89-19.32 108.484-103.68 119.406-233.36 1.094-12.85 1.59-25.02 1.59-36.53-.004-14.94-.84-28.76-2.309-41.53-10.492-24.77-16.68-49.96-18.48-73.93a215.062 215.062 0 00-7.184-15.6c-6.957-13.62-13.891-23.41-19.035-29.76-2.571-3.18-4.699-5.49-6.16-6.99l-.672-.66m-63.172 430.35c-14.371 0-59.492-201.51-37.426-275.84 10.813-36.54 42.692-60.23 73.477-60.23 32.265 0 63.328 26.04 67.636 90.57 8.457 126.15-103.418 245.48-103.418 245.48-.089.02-.179.02-.269.02"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28839"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-322.6568) rotate(72.819 3.687 -5.31)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1b28" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#a71d2f" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#a71d2f" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28851" clipPathUnits="userSpaceOnUse">
          <path d="M750.348 2065.73c-30.785 0-62.664 23.69-73.477 60.23-22.066 74.33 23.055 275.84 37.426 275.84.09 0 .18 0 .269-.02 0 0 111.875-119.33 103.418-245.48-4.308-64.53-35.371-90.57-67.636-90.57m-35.235 319.19s-36.797-141.26-12.832-187.45c9.336-17.99 24.742-26.32 40.532-26.32 24.699-.01 50.343 20.37 55.23 55.98 8.027 58.34-82.93 157.79-82.93 157.79"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28859"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-322.6568) rotate(72.819 3.687 -5.31)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1e27" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#e51d25" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e51d25" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28869" clipPathUnits="userSpaceOnUse">
          <path d="M742.813 2171.15c-15.79 0-31.196 8.33-40.532 26.32-23.965 46.19 12.832 187.45 12.832 187.45s90.957-99.45 82.93-157.79c-4.887-35.61-30.531-55.99-55.23-55.98"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28877"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-322.6568) rotate(72.819 3.687 -5.31)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f04031" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#ed212e" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#ed212e" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28889" clipPathUnits="userSpaceOnUse">
          <path d="M1379.63 863.531c-18.94 0-38.34 6.91-56.91 19.918-55.82 38.93-102.84 132.851-102.75 247.101l.01 1.03c.15 59.32 8.79 115.06 17.4 155.91 4.3 20.43 8.6 37.14 11.81 48.73 1.35 4.88 2.51 8.85 3.4 11.81 12.01-7.97 42.45-29.84 74.34-65.76 36.38-40.97 74.61-100.14 89.9-177.9 6.3-32.03 8.84-60.71 8.84-86.15-.01-53.47-11.19-92.63-22.3-118.4-5.54-12.871-11.08-22.398-15.19-28.672-2.05-3.128-3.75-5.449-4.92-6.968l-.47-.59a85.399 85.399 0 00-3.16-.059m-120.96 474.989c-16.2 0-42.66-236.67-8.48-317.16 15.04-35.419 48.04-56.231 79.79-56.231 40.46 0 78.88 33.801 75.5 114.241-6.01 143.53-146.75 259.15-146.75 259.15h-.06"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28897"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="rotate(-99.899 1219.015 72.534) scale(366.7514)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1b28" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#a71d2f" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#a71d2f" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28909" clipPathUnits="userSpaceOnUse">
          <path d="M1329.98 965.129c-31.75 0-64.75 20.812-79.79 56.231-34.18 80.49-7.72 317.16 8.48 317.16h.06s140.74-115.62 146.75-259.15c3.38-80.44-35.04-114.241-75.5-114.241m-68.54 354.491s-24.12-165.35 8.59-213.35c10.98-16.14 26.16-23.41 41.53-23.41 30.35-.01 61.48 28.36 62.71 72.89 1.86 67.1-112.83 163.87-112.83 163.87"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28917"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="rotate(-99.899 1219.015 72.534) scale(366.7514)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1e27" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#e51d25" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e51d25" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28927" clipPathUnits="userSpaceOnUse">
          <path d="M1311.56 1082.86c-15.37 0-30.55 7.27-41.53 23.41-32.71 48-8.59 213.35-8.59 213.35s114.69-96.77 112.83-163.87c-1.23-44.53-32.36-72.9-62.71-72.89"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28935"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="rotate(-99.899 1219.015 72.534) scale(366.7514)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f04031" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#ed212e" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#ed212e" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28947" clipPathUnits="userSpaceOnUse">
          <path d="M1028.79 1162.23c-20.56 12.22-37.61 34-49.575 62.44-12.348 29.32-19.242 65.59-19.238 105.06-.004 50.71 11.351 106.65 36.777 160 24.686 51.8 55.286 95.63 79.706 126.46 12.21 15.42 22.87 27.59 30.46 35.89 2.97 3.25 5.47 5.9 7.41 7.93 11.99-22.82 53.81-110.27 53.77-216.74 0-28.93-3.07-59.27-10.64-90.14-20.15-82.18-53.16-130.06-80.91-157.47-13.87-13.7-26.45-22.28-35.49-27.42-4.52-2.57-8.15-4.28-10.62-5.33-.63-.27-1.18-.5-1.65-.68m86.19 486.36c-18.6 0-134.21-185.41-137.542-273.03-2.114-55.5 38.692-105.81 82.982-105.81 27.43 0 56.2 19.32 76.92 68.68 54.14 129-21.15 309.81-21.15 309.81-.34.24-.75.35-1.21.35"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28955"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="rotate(-128.839 964.916 488.035) scale(355.563)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1b28" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#a71d2f" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#a71d2f" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28967" clipPathUnits="userSpaceOnUse">
          <path d="M1060.42 1269.75c-44.29 0-85.096 50.31-82.982 105.81 3.332 87.62 118.942 273.03 137.542 273.03.46 0 .87-.11 1.21-.35 0 0 75.29-180.81 21.15-309.81-20.72-49.36-49.49-68.68-76.92-68.68m50.28 360.41s-89.51-131.09-80.76-191.54c4.88-33.86 30.08-52.8 56.48-52.8 20.77-.01 42.28 11.71 55.23 37.11 29.36 57.68-30.95 207.23-30.95 207.23"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28975"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="rotate(-128.839 964.916 488.035) scale(355.563)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1e27" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#e51d25" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e51d25" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath28985" clipPathUnits="userSpaceOnUse">
          <path d="M1086.42 1385.82c-26.4 0-51.6 18.94-56.48 52.8-8.75 60.45 80.76 191.54 80.76 191.54s60.31-149.55 30.95-207.23c-12.95-25.4-34.46-37.12-55.23-37.11"></path>
        </clipPath>
        <linearGradient
          id="linearGradient28993"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="rotate(-128.839 964.916 488.035) scale(355.563)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f04031" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#ed212e" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#ed212e" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath29005" clipPathUnits="userSpaceOnUse">
          <path d="M873.746 1953.1c-11.398 0-20.414 1.44-26.531 2.86a77.82 77.82 0 00-6.93 1.93l-.476.17c-6.918 15.2-10.336 32.81-10.336 51.75-.094 69.58 46.433 156.38 128.484 202.48 40.055 22.58 80.953 35.96 111.793 43.67 15.42 3.86 28.33 6.3 37.36 7.77 3.34.55 6.15.96 8.36 1.26-.72-13.78-3.74-50.86-15.98-94.84-13.75-49.47-39.16-107.55-85.68-151.33-58.115-54.69-108.33-65.68-140.064-65.72m232.554 304.87c-31.9 0-174.542-59.76-211.909-116.26-33.418-50.58-10.246-138.23 49.851-138.23 14.367 0 30.856 5.02 49.172 16.74 94.866 60.82 119.086 235.56 119.086 235.56-.58 1.49-2.73 2.19-6.2 2.19"></path>
        </clipPath>
        <linearGradient
          id="linearGradient29013"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-283.5016) rotate(16.01 24.91 -17.785)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1b28" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#a71d2f" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#a71d2f" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath29025" clipPathUnits="userSpaceOnUse">
          <path d="M944.242 2003.48c-60.097 0-83.269 87.65-49.851 138.23 37.367 56.5 180.009 116.26 211.909 116.26 3.47 0 5.62-.7 6.2-2.19 0 0-24.22-174.74-119.086-235.56-18.316-11.72-34.805-16.74-49.172-16.74m156.478 242.55s-121.251-41.34-141.197-90.02c-16.507-40.34 13.114-83.51 50.007-83.51 7.67 0 15.66 1.87 23.61 6.02 46.17 24.13 67.58 167.51 67.58 167.51"></path>
        </clipPath>
        <linearGradient
          id="linearGradient29033"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-283.5016) rotate(16.01 24.91 -17.785)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1e27" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#e51d25" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e51d25" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath29043" clipPathUnits="userSpaceOnUse">
          <path d="M1009.53 2072.5c-36.893 0-66.514 43.17-50.007 83.51 19.946 48.68 141.197 90.02 141.197 90.02s-21.41-143.38-67.58-167.51c-7.95-4.15-15.94-6.02-23.61-6.02"></path>
        </clipPath>
        <linearGradient
          id="linearGradient29051"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-283.5016) rotate(16.01 24.91 -17.785)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f04031" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#ed212e" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#ed212e" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath29063" clipPathUnits="userSpaceOnUse">
          <path d="M976.328 2369.23c-11.383 0-20.387 1.44-26.496 2.86-3.051.7-5.383 1.4-6.922 1.92l-.465.16c-6.902 15.2-10.312 32.82-10.312 51.76-.098 69.61 46.398 156.4 128.457 202.53h.01c40.03 22.58 80.93 35.97 111.78 43.67 15.42 3.86 28.33 6.29 37.36 7.76 3.34.55 6.16.96 8.37 1.26-.72-13.78-3.74-50.86-15.98-94.84-13.75-49.47-39.18-107.55-85.7-151.33l-.01-.01c-58.12-54.71-108.36-65.7-140.092-65.74m232.642 304.91c-31.92 0-174.58-59.76-211.943-116.29-33.418-50.58-10.234-138.2 49.863-138.2 14.36 0 30.85 5.02 49.16 16.74 94.88 60.8 119.12 235.55 119.12 235.55-.58 1.5-2.73 2.2-6.2 2.2"></path>
        </clipPath>
        <linearGradient
          id="linearGradient29071"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-283.4943) rotate(16.01 29.95 -19.807)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1b28" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#a71d2f" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#a71d2f" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath29083" clipPathUnits="userSpaceOnUse">
          <path d="M1046.89 2419.65c-60.097 0-83.281 87.62-49.863 138.2 37.363 56.53 180.023 116.29 211.943 116.29 3.47 0 5.62-.7 6.2-2.2 0 0-24.24-174.75-119.12-235.55-18.31-11.72-34.8-16.74-49.16-16.74m156.48 242.53s-121.28-41.33-141.23-90.05c-16.49-40.3 13.17-83.44 50.05-83.45 7.67 0 15.64 1.87 23.59 6.02 46.15 24.07 67.59 167.48 67.59 167.48"></path>
        </clipPath>
        <linearGradient
          id="linearGradient29091"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-283.4943) rotate(16.01 29.95 -19.807)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1e27" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#e51d25" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e51d25" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath29101" clipPathUnits="userSpaceOnUse">
          <path d="M1112.19 2488.68c-36.88.01-66.54 43.15-50.05 83.45 19.95 48.72 141.23 90.05 141.23 90.05s-21.44-143.41-67.59-167.48c-7.95-4.15-15.92-6.02-23.59-6.02"></path>
        </clipPath>
        <linearGradient
          id="linearGradient29109"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-283.4943) rotate(16.01 29.95 -19.807)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ee2626" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#ed1b26" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#ed1b26" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath29121" clipPathUnits="userSpaceOnUse">
          <path d="M843.734 1533.13c-2.793 0-4.941.13-6.359.26l-.07.01c-14.27 20.09-21.621 47.75-21.614 78.91-.043 64.19 31.231 142.66 93.172 198.2 35.293 31.67 73.02 54.55 101.887 69.46 14.44 7.46 26.65 12.93 35.24 16.53 3.05 1.28 5.64 2.32 7.71 3.13 1.11-9.02 2.92-27.5 2.92-51.73.02-55.97-9.75-142.38-59.565-213.32-65.383-93-130.61-101.34-153.321-101.45m205.686 358.05c-23.26 0-162.783-97.88-190.635-164.92-21.976-52.9 8.434-125.09 59.254-125.09 17.613 0 37.688 8.68 58.867 29.84 82.284 82.14 75.454 259 75.454 259-.49.79-1.49 1.17-2.94 1.17"></path>
        </clipPath>
        <linearGradient
          id="linearGradient29129"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-293.283) rotate(27.792 10.417 -10.472)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1b28" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#a71d2f" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#a71d2f" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath29141" clipPathUnits="userSpaceOnUse">
          <path d="M918.039 1601.17c-50.82 0-81.23 72.19-59.254 125.09 27.852 67.04 167.375 164.92 190.635 164.92 1.45 0 2.45-.38 2.94-1.17 0 0 6.83-176.86-75.454-259-21.179-21.16-41.254-29.84-58.867-29.84m124.491 276.47s-111.479-69.42-122.495-121.86c-8.152-38.86 20.309-71.12 52.27-71.13 11.156 0 22.734 3.93 33.335 12.88 40.96 34.6 36.89 180.11 36.89 180.11"></path>
        </clipPath>
        <linearGradient
          id="linearGradient29149"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-293.283) rotate(27.792 10.417 -10.472)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1e27" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#e51d25" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e51d25" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath29159" clipPathUnits="userSpaceOnUse">
          <path d="M972.305 1684.65c-31.961.01-60.422 32.27-52.27 71.13 11.016 52.44 122.495 121.86 122.495 121.86s4.07-145.51-36.89-180.11c-10.601-8.95-22.179-12.88-33.335-12.88"></path>
        </clipPath>
        <linearGradient
          id="linearGradient29167"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-293.283) rotate(27.792 10.417 -10.472)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f04031" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#ed212e" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#ed212e" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath29177" clipPathUnits="userSpaceOnUse">
          <path d="M2232.86 753.551c34.36 94.359 92.8 260.039 91.5 292.099.13 3.55-.65 5.48-2.52 5.48-.33 0-.69-.05-1.08-.17-26.55-8.04-170.06-101.062-193.01-101.069-.95 0-1.69.168-2.21.5-4.48 2.879-26.84 34-54.45 71.549 2.62 2.97 5.12 5.97 7.52 9.02-41.08 55.61-90.67 120.41-110.85 128.97-.77.61-1.69.92-2.79.92-.18 0-.37-.01-.56-.03-.19.02-.38.03-.56.03-1.09 0-2.01-.31-2.78-.92-.97-.41-2.02-.96-3.13-1.62-2.01 1.4-3.84 2.47-5.48 3.16-.77.61-1.69.92-2.77.92h-.01c-.19 0-.38-.01-.58-.03-.2.02-.39.03-.58.03h-.01c-1.08 0-1.99-.31-2.75-.92-34.4-14.58-154.2-192.54-171.76-209.931-41.57 16.391-157.65 90.721-181.24 97.871-.39.12-.75.18-1.08.18-1.52 0-2.32-1.28-2.5-3.66-4.99 2.46-8.98 4.2-11.73 5.03-.07.02-.13.04-.2.05-.31.08-.61.12-.88.12-1.86 0-2.64-1.93-2.52-5.46-1.32-31.78 56.36-195.549 90.82-290.229-11.29 3.52-23.74 6.379-37.35 8.188-9.59 22.461-18.06 43.453-25.5 62.992-1.46 3.84-2.88 7.609-4.27 11.34-1.93 5.187-3.78 10.289-5.57 15.269-31.61 88.379-40.85 144.321-42.02 176.76-.68 19.16 1.44 30.12 3.43 34.72.05.1.09.2.13.3 4.72 10.67 13.44 17 22.94 17 2.13 0 4.3-.32 6.48-.98 12.9-3.92 40.2-19.56 83.67-44.74 30.35-17.59 78.65-45.571 98.37-53.509 7.5 9.629 20.25 26.999 31.83 42.799 40.28 54.95 71.14 95.79 94.94 123.35 4.77 5.53 9.27 10.53 13.49 15 5.61 5.92 10.74 10.92 15.45 15 1.45 1.25 2.85 2.41 4.21 3.49 4.14 3.27 7.92 5.76 11.39 7.47 3.78 2.23 7.95 3.38 12.25 3.38h1.1c4.01 0 8.48-1.14 12.28-3.38 3.47-1.71 7.25-4.2 11.39-7.47 1.36-1.08 2.77-2.24 4.21-3.49 4.71-4.08 9.85-9.08 15.45-15 4.22-4.47 8.72-9.47 13.49-15 23.8-27.56 54.66-68.4 94.94-123.35 11.59-15.78 24.32-33.17 31.83-42.799 19.72 7.938 68.01 35.919 98.35 53.509 43.49 25.18 70.8 40.82 83.7 44.74.17.05.33.09.49.14 2 .56 4 .83 5.97.83 8.71 0 16.78-5.32 21.69-14.43.49-.91.95-1.86 1.38-2.84 4.76-11 10.29-58.4-23.78-167.378a1113.534 1113.534 0 00-13.59-40.661c-1.86-5.269-3.82-10.679-5.85-16.191-1.39-3.758-2.82-7.578-4.29-11.449-7.75-20.473-16.62-42.5-26.75-66.199-13.82-2.172-26.37-5.411-37.69-9.301"></path>
        </clipPath>
        <linearGradient
          id="linearGradient29185"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(798.535 0 0 -798.535 1549.83 923.44)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#e64120" stopOpacity="1"></stop>
          <stop offset="0.952" stopColor="#e61d25" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e61d25" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath29195" clipPathUnits="userSpaceOnUse">
          <path d="M1724.19 725.609c-14.17 10.422-33.89 21.832-59.52 29.832-34.46 94.68-92.14 258.449-90.82 290.229.26-6.98 4.07-20.22 10.15-37.25l1.17.05c3.52-1.07 9.11-3.64 16.2-7.29 8.74-23.719 21.27-53.711 34.61-84.25 35.93-7.149 74.29-11.09 114.19-11.09 128.9 0 242.07 40.39 306.54 101.27 37.23-48.77 71-95.649 76.55-99.219.52-.332 1.26-.493 2.22-.493 19.76 0 129.12 69.102 175.92 93.322 7.71 20.73 12.66 36.93 12.96 44.93 1.3-32.06-57.14-197.74-91.5-292.099-22.3-7.649-39.83-17.813-52.82-27.242-17.35 110.14-112.93 194.652-227.88 194.652-115.18 0-210.92-84.871-227.97-195.352m403.56 224.282c-.95 0-1.7.16-2.22.5-4.47 2.879-26.83 34-54.45 71.549h.01c27.61-37.549 49.97-68.67 54.45-71.549.52-.332 1.26-.5 2.21-.5m-538.57 96.039c-4.99 2.46-8.99 4.2-11.73 5.03-.07.02-.13.03-.2.05.07-.01.13-.03.2-.05 2.75-.83 6.74-2.57 11.73-5.03m368.76 112.37c-2.01 1.41-3.85 2.48-5.49 3.17-.76.61-1.68.92-2.76.92 1.08 0 2-.31 2.77-.92 1.64-.69 3.47-1.76 5.48-3.16v-.01m-8.84 4.06c-.2.02-.4.03-.59.03h.01c.19 0 .38-.01.58-.03"></path>
        </clipPath>
        <linearGradient
          id="linearGradient29201"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(822.012 -822.012) rotate(78.69 2.042 .711)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f6e604" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e64120" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath29211" clipPathUnits="userSpaceOnUse">
          <path d="M2127.76 949.891h-.01c22.95.007 166.46 93.029 193.01 101.069.39.12.75.17 1.08.17 1.87 0 2.65-1.93 2.52-5.48-.14 3.54-1.02 5.45-2.73 5.45-.27 0-.55-.05-.86-.14-26.55-8.04-170.07-101.062-193.01-101.069m-353.75 1.648h-.01c17.56 17.391 137.36 195.351 171.76 209.931.76.61 1.67.92 2.75.92-1.08 0-1.99-.31-2.75-.92-34.39-14.58-154.2-192.54-171.75-209.931m-200.16 94.131c-.12 3.53.66 5.46 2.52 5.46.27 0 .57-.04.88-.12-.23.06-.45.09-.66.09-1.71 0-2.59-1.9-2.74-5.43m375.25 116.69c.2.02.39.03.58.03h.01c-.19 0-.39-.01-.59-.03"></path>
        </clipPath>
        <linearGradient
          id="linearGradient29219"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(798.535 0 0 -798.535 1549.83 923.44)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f5b384" stopOpacity="1"></stop>
          <stop offset="0.952" stopColor="#f79788" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#f79788" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath29229" clipPathUnits="userSpaceOnUse">
          <path d="M2135.48 907.398c-.96 0-1.7.161-2.22.493-5.55 3.57-39.32 50.449-76.55 99.219 5.1 4.81 9.9 9.76 14.37 14.83 27.62-37.549 49.98-68.67 54.45-71.549.52-.34 1.27-.5 2.22-.5h.01c22.94.007 166.46 93.029 193.01 101.069.31.09.59.14.86.14 1.71 0 2.59-1.91 2.73-5.45-.3-8-5.25-24.2-12.96-44.93-46.8-24.22-156.16-93.322-175.92-93.322m-349.72 40.954c-2.55 0-6.57 1.136-11.75 3.187 17.55 17.391 137.36 195.351 171.75 209.931.76.61 1.67.92 2.75.92.19 0 .39-.01.59-.03.2.02.4.03.59.03 1.08 0 2-.31 2.76-.92 1.64-.69 3.48-1.76 5.49-3.17-39.2-23.66-158.93-202.359-169.96-209.448-.52-.34-1.27-.5-2.22-.5m-184.39 52.828c-7.09 3.65-12.68 6.22-16.2 7.29l-1.17-.05c-6.08 17.03-9.89 30.27-10.15 37.25.15 3.53 1.03 5.43 2.74 5.43.21 0 .43-.03.66-.09.07-.02.13-.03.2-.05 2.74-.83 6.74-2.57 11.73-5.03-.52-6.94 4.28-23.27 12.19-44.75"></path>
        </clipPath>
        <linearGradient
          id="linearGradient29235"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(822.012 -822.012) rotate(78.69 2.042 .711)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f8f479" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#f5b384" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath29245" clipPathUnits="userSpaceOnUse">
          <path d="M1770.45 949.891c-20.57 0-138.06 74.779-181.27 96.039.18 2.38.98 3.66 2.5 3.66.33 0 .69-.06 1.08-.18 23.59-7.15 139.67-81.48 181.24-97.871-.54-.539-.99-.93-1.33-1.148-.52-.332-1.27-.493-2.22-.5m300.64 72.049c-39.15 53.23-88.86 119.39-113.15 136.37 1.11.66 2.16 1.21 3.13 1.62.77.61 1.69.92 2.78.92.18 0 .37-.01.56-.03.19.02.38.03.56.03 1.1 0 2.02-.31 2.79-.92 20.18-8.56 69.77-73.36 110.85-128.97-2.4-3.05-4.9-6.05-7.52-9.02"></path>
        </clipPath>
        <linearGradient
          id="linearGradient29253"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(798.535 0 0 -798.535 1549.83 923.44)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f68712" stopOpacity="1"></stop>
          <stop offset="0.952" stopColor="#ee2b21" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#ee2b21" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath29263" clipPathUnits="userSpaceOnUse">
          <path d="M1750.17 905.84c-39.9 0-78.26 3.941-114.19 11.09-13.34 30.539-25.87 60.531-34.61 84.25 46.32-23.821 156.88-93.789 176.79-93.789.96 0 1.7.16 2.22.5 11.35 7.32 140.98 196.049 176.44 211.069v.9-.9c18.14-7.68 60.91-60.81 99.89-111.85-64.47-60.88-177.64-101.27-306.54-101.27m20.28 44.051c-20.56 0-138.05 74.769-181.27 96.039 43.21-21.26 160.7-96.039 181.27-96.039m300.63 72.049c-39.14 53.23-88.85 119.38-113.14 136.36v.01c24.29-16.98 74-83.14 113.15-136.37h-.01"></path>
        </clipPath>
        <linearGradient
          id="linearGradient29269"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(822.012 -822.012) rotate(78.69 2.042 .711)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f2ee04" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#f68712" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath29279" clipPathUnits="userSpaceOnUse">
          <path d="M1770.45 949.891c.95.007 1.7.168 2.22.5.34.218.79.609 1.33 1.148h.01c-.55-.539-1-.93-1.34-1.148-.52-.332-1.27-.5-2.22-.5"></path>
        </clipPath>
        <linearGradient
          id="linearGradient29287"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(798.535 0 0 -798.535 1549.83 923.44)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#fcdecc" stopOpacity="1"></stop>
          <stop offset="0.952" stopColor="#fcd3cd" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#fcd3cd" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath29297" clipPathUnits="userSpaceOnUse">
          <path d="M1778.16 907.391c-19.91 0-130.47 69.968-176.79 93.789-7.91 21.48-12.71 37.81-12.19 44.75 43.22-21.27 160.71-96.039 181.27-96.039.95 0 1.7.168 2.22.5.34.218.79.609 1.34 1.148 5.18-2.051 9.2-3.187 11.75-3.187.95 0 1.7.16 2.22.5 11.03 7.089 130.76 185.788 169.96 209.448 24.29-16.98 74-83.13 113.14-136.36-4.47-5.07-9.27-10.02-14.37-14.83-38.98 51.04-81.75 104.17-99.89 111.85v.9-.9c-35.46-15.02-165.09-203.749-176.44-211.069-.52-.34-1.26-.5-2.22-.5"></path>
        </clipPath>
        <linearGradient
          id="linearGradient29303"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(822.012 -822.012) rotate(78.69 2.042 .711)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#fbfbc7" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#fcdecc" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath29315" clipPathUnits="userSpaceOnUse">
          <path d="M2390.48 503.359c-62.75-.007-118.33 22.93-158.14 57.141-25.98 22.32-45.18 49.371-55.38 77.871a230.731 230.731 0 015.73 60.348c20.33 17.082 61.7 42.703 127.06 42.703 18.73 0 39.45-2.102 62.26-7.133 70.98-15.641 125.41-62.59 162.06-105.887 18.32-21.632 32.18-42.3 41.43-57.531 4.63-7.621 8.11-13.883 10.42-18.211.44-.82.83-1.57 1.18-2.25-19.09-8.922-96.4-42.43-183.7-46.738-4.34-.211-8.65-.313-12.92-.313m-40.68 215.75c-121.16 0-111.65-147.05-41.74-183.687 20.61-10.801 52.53-14.953 87.32-14.953 83.78 0 184.22 24.082 183.44 37.453 0 0-104.43 159.816-227.34 161.18-.56.007-1.12.007-1.68.007"></path>
        </clipPath>
        <linearGradient
          id="linearGradient29323"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-308.9104 308.9104) rotate(-12.156 5.927 39.473)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1b28" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#a71d2f" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#a71d2f" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath29335" clipPathUnits="userSpaceOnUse">
          <path d="M2395.38 520.469c-34.79 0-66.71 4.152-87.32 14.953-69.91 36.637-79.42 183.687 41.74 183.687.56 0 1.12 0 1.68-.007 122.91-1.364 227.34-161.18 227.34-161.18.78-13.371-99.66-37.453-183.44-37.453m25.79 165.332c-1.06 0-2.1-.039-3.14-.129-57.28-4.793-80.5-87.442-38.23-123.711 14.56-12.481 40.7-16.57 68.74-16.57 53.52 0 113.96 14.91 113.96 14.91s-84.09 125.5-141.33 125.5"></path>
        </clipPath>
        <linearGradient
          id="linearGradient29343"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-308.9104 308.9104) rotate(-12.156 5.927 39.473)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1e27" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#e51d25" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e51d25" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath29353" clipPathUnits="userSpaceOnUse">
          <path d="M2448.54 545.391c-28.04 0-54.18 4.089-68.74 16.57-42.27 36.269-19.05 118.918 38.23 123.711 1.04.09 2.08.129 3.14.129 57.24 0 141.33-125.5 141.33-125.5s-60.44-14.91-113.96-14.91"></path>
        </clipPath>
        <linearGradient
          id="linearGradient29361"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-308.9104 308.9104) rotate(-12.156 5.927 39.473)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f04031" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#ed212e" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#ed212e" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath29373" clipPathUnits="userSpaceOnUse">
          <path d="M1512.81 503.359h-.02c-4.28 0-8.58.102-12.92.313-50.48 2.5-97.64 14.738-132.11 26.367-17.23 5.813-31.3 11.461-41.04 15.66a395.974 395.974 0 00-10.56 4.723c6.45 12.348 26.71 48.648 60.11 86.129 36.45 40.898 88.44 83.07 154.99 97.738 22.81 5.031 43.53 7.133 62.26 7.133 49.33-.012 84.86-14.563 108.15-29.043 8.14-5.059 14.77-10.109 19.94-14.539-.08-2.508-.12-5.02-.12-7.559 0-17.179 1.89-33.929 5.47-50.062-10.03-29.168-29.49-56.918-56.03-79.719-39.81-34.199-95.39-57.141-158.12-57.141m40.65 215.75c-.55 0-1.11 0-1.68-.007-122.91-1.364-227.33-161.18-227.33-161.18-.78-13.371 99.65-37.453 183.44-37.453 34.79 0 66.71 4.152 87.32 14.953 69.91 36.637 79.41 183.687-41.75 183.687"></path>
        </clipPath>
        <linearGradient
          id="linearGradient29381"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="rotate(-12.156 3782.603 -6135.003) scale(308.9176)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1b28" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#a71d2f" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#a71d2f" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath29393" clipPathUnits="userSpaceOnUse">
          <path d="M1507.89 520.469c-83.79 0-184.22 24.082-183.44 37.453 0 0 104.42 159.816 227.33 161.18.57.007 1.13.007 1.68.007 121.16 0 111.66-147.05 41.75-183.687-20.61-10.801-52.53-14.953-87.32-14.953m-25.79 165.332c-57.24 0-141.33-125.5-141.33-125.5s60.44-14.91 113.96-14.91c28.04 0 54.18 4.089 68.74 16.57 42.27 36.269 19.05 118.918-38.24 123.711-1.03.09-2.08.129-3.13.129"></path>
        </clipPath>
        <linearGradient
          id="linearGradient29401"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="rotate(-12.156 3782.603 -6135.003) scale(308.9176)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1e27" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#e51d25" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e51d25" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath29411" clipPathUnits="userSpaceOnUse">
          <path d="M1454.73 545.391c-53.52 0-113.96 14.91-113.96 14.91s84.09 125.5 141.33 125.5c1.05 0 2.1-.039 3.13-.129 57.29-4.793 80.51-87.442 38.24-123.711-14.56-12.481-40.7-16.57-68.74-16.57"></path>
        </clipPath>
        <linearGradient
          id="linearGradient29419"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="rotate(-12.156 3782.603 -6135.003) scale(308.9176)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f04031" stopOpacity="1"></stop>
          <stop offset="0.764" stopColor="#ed212e" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#ed212e" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath29433" clipPathUnits="userSpaceOnUse">
          <path d="M1949.11 523.27c-52.3 0-99.29 22.531-131.86 58.41-24.32 29.539-38.92 67.351-38.92 108.601 0 47.239 19.14 89.957 50.09 120.918 28.81 28.793 67.79 47.36 111.11 49.801.3-.551.61-1.109.93-1.68-86.9-4.5-155.97-76.371-155.97-164.41v-.461-.129c0-.308 0-.621.01-.929v-.153-.398-.11c.01-.128.01-.25.01-.378v-.2c.01-.101.01-.191.01-.293v-.277c.01-.094.01-.172.01-.273 0-.079 0-.161.01-.25v-.18c0-.16.01-.316.01-.481v-.117c.01-.109.01-.222.01-.332v-.008c2.12-71.402 49.72-131.39 114.83-151.992a162.825 162.825 0 0149.39-7.648h.33c89.6 0 162.46 71.59 164.55 160.66 0 .031 0 .059.01.09v.281c0 .07 0 .129.01.188v.371c0 .089.01.168.01.269v.199c0 .102 0 .211.01.321V693.391c0 .14.01.289.01.429V694.91c0 57.949-29.93 108.899-75.16 138.238.4.762.81 1.532 1.21 2.293a172.184 172.184 0 0030.49-24.242c30.95-30.961 50.08-73.679 50.09-120.918-.01-38.691-12.84-74.351-34.5-103-32.65-39.121-81.75-64.011-136.73-64.011m85.13 313.3a166.323 166.323 0 01-33.61 15.141v1.738a169.875 169.875 0 0034.72-15.34l-1.11-1.539m-33.64 15.149c-.03.011-.05.023-.08.031v1.742a.663.663 0 01.11-.031v-.07l-.03-1.672m-.21.07c-15.67 5.024-32.37 7.75-49.72 7.75h-1.56c-1.87 0-3.74-.027-5.6-.09l-1.39 1.68c2.39.101 4.79.152 7.21.152 17.82 0 34.99-2.722 51.13-7.769-.02-.543-.04-1.121-.07-1.723"></path>
        </clipPath>
        <linearGradient
          id="linearGradient29441"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(110 -396.668 -396.668 -110 1885.21 921.52)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1b28" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#451a2a" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#451a2a" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath29455" clipPathUnits="userSpaceOnUse">
          <path d="M1949.33 519.289c-47.23 0-89.95 19.133-120.91 50.082a170.384 170.384 0 00-11.17 12.309c32.57-35.879 79.56-58.41 131.86-58.41 54.98 0 104.08 24.89 136.73 64.011a172.225 172.225 0 00-15.59-17.91c-30.96-30.949-73.68-50.082-120.92-50.082"></path>
        </clipPath>
        <linearGradient
          id="linearGradient29463"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(110 -396.668 -396.668 -110 1885.21 921.52)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#a41d2e" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#241b1d" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#241b1d" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath29477" clipPathUnits="userSpaceOnUse">
          <path d="M1949.11 530.301h-.13c30.36.039 58.72 8.461 83.14 22.828l-19.32 33.883c-18.78-11.153-40.61-17.68-64.02-17.68-22.98 0-44.43 6.25-62.94 17.008l.09.148c-37.3 21.782-62.42 62.141-62.42 108.422l.11 2.281-39.02-.05-.11-2.231c0 88.039 69.07 159.91 155.97 164.41.01-.031.03-.058.05-.09-23.26-1.441-45.17-7.789-64.85-17.878l20.25-33.512c16.58 8.051 35.1 12.699 54.76 12.699 4.42 0 8.78-.23 13.08-.687 4.65-7.59 9.28-15.032 13.46-21.704a108.604 108.604 0 01-23.26 3.293h-.02c-.09 0-.18 0-.27.008h-.05c-.16 0-.3.012-.46.012h-.12c-.07 0-.14.008-.21.008h-.34c-.12.011-.23.011-.34.011h-.12c-.09 0-.18 0-.27.008h-1.61c-59.36-.136-107.56-47.859-108.43-107.066 0-.34-.01-.692-.01-1.043v-.109-.489-.41-.101-.09-.219-.148c0-.094 0-.184.01-.274v-.16-.231-.046-.133c.01-.129.01-.258.01-.387v-.203c.01-.059.01-.129.01-.188v-.242c.01-.051.01-.097.01-.148 0-.09 0-.172.01-.262v-.129c.71-23.308 8.78-44.75 21.95-62.121 19.72-27.559 52.01-45.527 88.48-45.527 60.04 0 108.7 48.679 108.7 108.73 0 1.149-.01 2.297-.05 3.449 3.02-3.48 4.97-5.711 5.37-6.121.04-.031.06-.05.07-.05.18 0-1.99 3.652-5.59 9.511-1.5 24.289-10.97 46.418-25.83 63.797a109.824 109.824 0 01-8.48 9.332v.09c-.51.5-1.02.988-1.54 1.48 8.27 4.809 19.5 7.86 34.78 8.989 18.4 1.371-21.85-1.969-42.6 11.703 5.77 10.828 14.03 26.348 21.54 40.476 45.23-29.339 75.16-80.289 75.16-138.238l-.11 2.36-39.02.199.13-2.559c0-46-24.82-86.101-61.71-107.988l19.36-33.84c47.56 27.996 79.91 79.047 81.3 137.879-2.09-89.07-74.95-160.66-164.55-160.66m-49.72 7.648c-65.11 20.602-112.71 80.59-114.83 151.992 1.75-58.539 34.15-109.293 81.64-137.05l-.09-.161a166.385 166.385 0 0133.28-14.781m-114.83 152c0 .11 0 .223-.01.332.01-.109.01-.222.01-.332m-.01.449c0 .165-.01.321-.01.481 0-.16.01-.316.01-.481m329.12.653v0m-329.13.008c-.01.089-.01.171-.01.25 0-.079 0-.168.01-.25m329.14.461v0m-329.16.062v0m-.01.57v0m329.18.008v0m.01.52v0m-329.2.05v0m329.2.508v0m-329.2 0v0m329.21.582v0m-329.22.5v0m329.22 0v0m-105.06 106.91c-1.26 2.04-2.33 4.27-3.24 6.641 1.98-.973 3.93-1.98 5.85-3.043l-2.61-3.598m-18.68 2.192l-11.62 14.008c5.17-1.18 10.21-2.68 15.12-4.481-1.04-3.469-2.21-6.758-3.5-9.527m-46.41 55.969l-.05.058c1.86.063 3.73.09 5.6.09h.79c-2.13-.008-4.24-.059-6.34-.148"></path>
        </clipPath>
        <linearGradient
          id="linearGradient29485"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(110 -396.668 -396.668 -110 1885.21 921.52)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1d27" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#6d1136" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#6d1136" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath29495" clipPathUnits="userSpaceOnUse">
          <path d="M1952.18 581.762c-36.47 0-68.76 17.968-88.48 45.527a109.777 109.777 0 0127.58-25.66 109.867 109.867 0 00-14.84 13.922c4.2 23.398 14.71 56.23 40.12 86.008 12.35 14.492 29.23 25.55 47.43 33.98l-28.51-42.75c6.68 7.512 17.95 20.52 29.72 34.18l-33.12-141.239c5.98-1.011 12.08-1.671 18.34-1.671 28.12 0 53.66 10.769 72.96 28.293l2.31 122.41c13.4-15.614 27.6-32.133 35.14-40.821.04-1.152.05-2.3.05-3.449 0-60.051-48.66-108.73-108.7-108.73m108.5 115.519c-7.88 12.828-22.6 36.278-34.65 55.41l.05 2.52c4.01.82 7.9 1.551 11.61 2.199-.92 1.25-1.87 2.469-2.84 3.668 14.86-17.379 24.33-39.508 25.83-63.797"></path>
        </clipPath>
        <clipPath id="clipPath29507" clipPathUnits="userSpaceOnUse">
          <path d="M2033.87 836.07a164.194 164.194 0 01-33.24 15.25v.391a166.323 166.323 0 0033.61-15.141l-.37-.5m-33.27 15.262c-.03.008-.06.02-.08.027v.391c.03-.008.05-.02.08-.031v-.387m-.23.07c-15.89 5.207-32.86 8.059-50.47 8.137h.77c17.35 0 34.05-2.726 49.72-7.75-.01-.129-.01-.258-.02-.387"></path>
        </clipPath>
        <linearGradient
          id="linearGradient29515"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(110 -396.668 -396.668 -110 1885.21 921.52)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ee2227" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#6c113d" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#6c113d" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath29525" clipPathUnits="userSpaceOnUse">
          <path d="M2011.26 804.828c-1.92 1.063-3.87 2.07-5.85 3.043-4.96 12.899-5.03 29.711-4.87 40.32.02-.73.06-1.722.09-2.691v5.82c11.71-3.859 22.85-9 33.24-15.25l-22.61-31.242m-115.35 3.012l-20.25 33.512c19.68 10.089 41.59 16.437 64.85 17.878 6.11-11.082 14.72-25.48 23.24-39.378-4.3.457-8.66.687-13.08.687-19.66 0-38.18-4.648-54.76-12.699m97.56 5.109a123.985 123.985 0 01-15.12 4.481l-34.79 41.961c2.1.089 4.21.14 6.34.148 17.61-.078 34.58-2.93 50.47-8.137-.13-2.601-.37-5.73-.76-9.16 0 0-2.15-15.992-6.14-29.293m7.07 35.242c-.01.52-.02.899-.02 1.059v2.109c.02-.007.05-.019.08-.027-.02-.973-.04-2.019-.06-3.141"></path>
        </clipPath>
        <linearGradient
          id="linearGradient29533"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(110 -396.668 -396.668 -110 1885.21 921.52)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ee2b25" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#8c1550" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#8c1550" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath29543" clipPathUnits="userSpaceOnUse">
          <path d="M1863.7 627.289c-13.17 17.371-21.24 38.813-21.95 62.121.7-22.73 8.4-43.64 20.99-60.762.32-.457.64-.91.96-1.359"></path>
        </clipPath>
        <linearGradient
          id="linearGradient29551"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(110 -396.668 -396.668 -110 1885.21 921.52)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f78e8d" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#c583a4" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#c583a4" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath29561" clipPathUnits="userSpaceOnUse">
          <path d="M1891.28 601.629a109.777 109.777 0 00-27.58 25.66c-.32.449-.64.902-.96 1.359a110.684 110.684 0 0113.36-15.058c.11.652.22 1.301.34 1.961 4.5-5.082 9.47-9.75 14.84-13.922"></path>
        </clipPath>
        <clipPath id="clipPath29573" clipPathUnits="userSpaceOnUse">
          <path d="M1841.75 689.539c-.01.09-.01.172-.01.262 0-.09 0-.172.01-.262m-.02.41v0m-.01.43v0m-.01.59v0m0 .41v0m-.01.434v0m0 .457V692.281v-.011m112.25 109.171h-.02.02m-.29.008h-.05.05m-.51.012h-.12.12m-.33.008h-.17.17m-.34 0c-.12.011-.23.011-.34.011.11 0 .22 0 .34-.011m-.46.011c-.09 0-.18 0-.27.008.09-.008.18-.008.27-.008m-.38.008h-.36.36m-.44 0h-.28.28m-.41 0h-.37.37"></path>
        </clipPath>
        <clipPath id="clipPath29591" clipPathUnits="userSpaceOnUse">
          <path d="M1841.71 691.102V691.102m-.01 1.078V692.18m0 1.09v0m109.22 108.218h-.02-.01.03m-.78 0h.28-.28"></path>
        </clipPath>
        <clipPath id="clipPath29603" clipPathUnits="userSpaceOnUse">
          <path d="M1841.71 691.102v.007-.007m-.01 1.148v0m109.25 109.238h-.05.05m-.81 0h.28-.28"></path>
        </clipPath>
        <clipPath id="clipPath29615" clipPathUnits="userSpaceOnUse">
          <path d="M1950.42 584.059c-6.26 0-12.36.66-18.34 1.671l33.12 141.239c4.09 4.75 8.24 9.57 12.28 14.273 4.67 1.809 9.38 3.457 14.07 4.969 8.51-19.082 8.66-40.762 8.97-51.422V705.5l.11-1.84v-8.871c.63 22.711.94 41.641 6.45 55.961 1.34.352 2.68.699 4.01 1.031l14.6-17.019-2.31-122.41c-19.3-17.524-44.84-28.293-72.96-28.293m75.61 168.632c-.47.75-.93 1.481-1.39 2.207.48.114.96.211 1.44.313l-.05-2.52"></path>
        </clipPath>
        <clipPath id="clipPath29627" clipPathUnits="userSpaceOnUse">
          <path d="M2026.37 770.41c-.53.52-1.06 1.031-1.6 1.539.02.012.04.02.06.031.52-.492 1.03-.98 1.54-1.48v-.09"></path>
        </clipPath>
        <clipPath id="clipPath29639" clipPathUnits="userSpaceOnUse">
          <path d="M1876.44 615.551a109.346 109.346 0 00-12.23 16.777L1964.97 775a54.585 54.585 0 009.98-6.449l-5.99-25.571-4.97-7.441c-18.2-8.43-35.08-19.488-47.43-33.98-25.41-29.778-35.92-62.61-40.12-86.008"></path>
        </clipPath>
        <clipPath id="clipPath29651" clipPathUnits="userSpaceOnUse">
          <path d="M1841.75 689.41v0m-.01.391c0 .051 0 .097-.01.148.01-.051.01-.097.01-.148m-.01.39c0 .059 0 .129-.01.188.01-.059.01-.129.01-.188m-.01.391c0 .129 0 .258-.01.387.01-.129.01-.258.01-.387m-.01.566V691.148m0 .391c-.01.09-.01.18-.01.274v-.071-.133c.01-.019.01-.05.01-.07m-.01.422v0m0 .41v0"></path>
        </clipPath>
        <clipPath id="clipPath29663" clipPathUnits="userSpaceOnUse">
          <path d="M1895.72 776.629c3.11 2.172 6.33 4.172 9.66 6.012l-9.66-6.012m80.45 14.223l2.34 3.32c.46-.082.91-.184 1.36-.27.17-.273.34-.543.51-.812a48.295 48.295 0 00-4.21-2.238"></path>
        </clipPath>
        <clipPath id="clipPath29675" clipPathUnits="userSpaceOnUse">
          <path d="M1977.21 798.141a107.99 107.99 0 01-23.26 3.3c8-.261 15.78-1.39 23.26-3.293v-.007m-23.28 3.3c-.09 0-.18 0-.27.008.09-.008.18-.008.27-.008m-.32.008c-.16 0-.3.012-.46.012.16 0 .3-.012.46-.012m-.58.012c-.07 0-.14.008-.21.008.07 0 .14-.008.21-.008m-.38.008h-.17.17m-.51.011h-.12.12m-.39.008h-.11.11m-.47 0h-.08.08m-.39 0h-.1.1"></path>
        </clipPath>
        <clipPath id="clipPath29687" clipPathUnits="userSpaceOnUse">
          <path d="M1862.74 628.648c-12.59 17.122-20.29 38.032-20.99 60.762v.129c-.01.09-.01.172-.01.262 0 .051 0 .097-.01.148v.242c0 .059 0 .129-.01.188v.203c0 .129 0 .258-.01.387v.133c.35-23 7.94-44.223 20.47-61.653l.01.012c.18-.27.37-.539.55-.813"></path>
        </clipPath>
        <clipPath id="clipPath29699" clipPathUnits="userSpaceOnUse">
          <path d="M1876.1 613.59c-4.9 4.601-9.37 9.64-13.36 15.058-.18.274-.37.543-.55.813l2.02 2.867a109.346 109.346 0 0112.23-16.777c-.12-.66-.23-1.309-.34-1.961"></path>
        </clipPath>
        <clipPath id="clipPath29711" clipPathUnits="userSpaceOnUse">
          <path d="M1841.71 691.172v.367c0 .02 0 .051-.01.07.01-.148.01-.289.01-.437m-.01.57v0m0 .539v0m0 .5v0m0 .598c0 .351.01.703.01 1.043 0-.352-.01-.692-.01-1.043m.01 1.043c.87 59.207 49.07 106.93 108.43 107.066-5.75-.008-11.37-.597-16.89-1.476l-5.88-3.66c-23.64-5.52-44.33-18.762-59.25-36.922l-6.47-4.032c-12.23-17.296-19.6-38.269-19.94-60.976"></path>
        </clipPath>
        <clipPath id="clipPath29723" clipPathUnits="userSpaceOnUse">
          <path d="M1868.12 759.43c14.92 18.16 35.61 31.402 59.25 36.922l-21.99-13.711c-3.33-1.84-6.55-3.84-9.66-6.012l-27.6-17.199m111.75 34.472c-.45.086-.9.188-1.36.27l.63.898c.25-.398.49-.781.73-1.168"></path>
        </clipPath>
        <clipPath id="clipPath29735" clipPathUnits="userSpaceOnUse">
          <path d="M1977.26 798.07c-8.44 2.16-17.22 3.379-26.31 3.418H1951.75c.09-.008.18-.008.27-.008h.12c.11 0 .22 0 .34-.011h.34c.07 0 .14-.008.21-.008h.12c.16 0 .3-.012.46-.012h.05c.09-.008.18-.008.27-.008h.02a107.99 107.99 0 0023.26-3.3c.02-.02.03-.039.05-.071m-26.37 3.418h-.47.47"></path>
        </clipPath>
        <clipPath id="clipPath29747" clipPathUnits="userSpaceOnUse">
          <path d="M1864.21 632.328c-9.55 16.152-15.05 34.981-15.05 55.102 0 36.929 18.42 69.55 46.56 89.199l9.66 6.012c15.56 8.609 33.46 13.5 52.5 13.5 7.06 0 13.96-.68 20.63-1.969l-2.34-3.32c-15.25-7.204-36.2-8.582-43.86-8.793-.73.011-1.32.011-1.77.011-.77 0-1.14-.011-1.18-.019-.04-.012.27-.02.86-.02.5 0 1.21 0 2.09.028.44-.008.92-.02 1.45-.028 12.68-.269 22.93-2.859 31.21-7.031l-100.76-142.672"></path>
        </clipPath>
        <clipPath id="clipPath29759" clipPathUnits="userSpaceOnUse">
          <path d="M1841.71 691.109v0m-.01.5v0m0 .52v0m109.2 109.359h-.01.01"></path>
        </clipPath>
        <clipPath id="clipPath29771" clipPathUnits="userSpaceOnUse">
          <path d="M1862.18 629.449c-12.53 17.43-20.12 38.653-20.47 61.653v.07c0 .148 0 .289-.01.437v1.77c0 .351.01.691.01 1.043.34 22.707 7.71 43.68 19.94 60.976l6.47 4.032c-15.41-18.758-24.66-42.77-24.66-68.938 0-22.621 6.91-43.633 18.73-61.031l-.01-.012"></path>
        </clipPath>
        <clipPath id="clipPath29783" clipPathUnits="userSpaceOnUse">
          <path d="M1862.19 629.461c-11.82 17.398-18.73 38.41-18.73 61.031 0 26.168 9.25 50.18 24.66 68.938l27.6 17.199c-28.14-19.649-46.56-52.27-46.56-89.199 0-20.121 5.5-38.95 15.05-55.102l-2.02-2.867"></path>
        </clipPath>
        <clipPath id="clipPath29795" clipPathUnits="userSpaceOnUse">
          <path d="M1978.58 795.961a108.94 108.94 0 01-26.4 3.23c-8.54 0-16.84-.98-24.81-2.839l5.88 3.66c5.52.879 11.14 1.468 16.89 1.476h.81c9.09-.039 17.87-1.258 26.31-3.418.44-.711.88-1.41 1.32-2.109"></path>
        </clipPath>
        <clipPath id="clipPath29807" clipPathUnits="userSpaceOnUse">
          <path d="M1905.38 782.641l21.99 13.711a109.077 109.077 0 0024.81 2.839c9.1 0 17.95-1.121 26.4-3.23.19-.301.38-.602.56-.891l-.63-.898a108.672 108.672 0 01-20.63 1.969c-19.04 0-36.94-4.891-52.5-13.5"></path>
        </clipPath>
        <clipPath id="clipPath29819" clipPathUnits="userSpaceOnUse">
          <path d="M2034.85 761.078a108.77 108.77 0 01-8.49 8.871l.01.461c3-2.941 5.83-6.058 8.48-9.332"></path>
        </clipPath>
        <clipPath id="clipPath29831" clipPathUnits="userSpaceOnUse">
          <path d="M2026.08 755.211l.28 14.738a108.77 108.77 0 008.49-8.871c.97-1.199 1.92-2.418 2.84-3.668a411.12 411.12 0 01-11.61-2.199"></path>
        </clipPath>
        <clipPath id="clipPath29843" clipPathUnits="userSpaceOnUse">
          <path d="M1977.48 741.242c3.59 4.188 7.09 8.27 10.39 12.11a72.044 72.044 0 003.68-7.141c-4.69-1.512-9.4-3.16-14.07-4.969m-8.52 1.738l5.99 25.571a54.547 54.547 0 006.7-6.531l-12.69-19.04m38.12 7.77c.5 1.301 1.04 2.57 1.63 3.801.78-.903 1.57-1.821 2.38-2.77a338.53 338.53 0 01-4.01-1.031"></path>
        </clipPath>
        <clipPath id="clipPath29855" clipPathUnits="userSpaceOnUse">
          <path d="M2026.36 769.949c-.64.602-1.3 1.199-1.95 1.781.12.071.24.141.36.219.54-.508 1.07-1.019 1.6-1.539l-.01-.461"></path>
        </clipPath>
        <clipPath id="clipPath29867" clipPathUnits="userSpaceOnUse">
          <path d="M2024.64 754.898c-2.61 4.153-5.07 8.051-7.29 11.563 2.07 1.941 4.41 3.699 7.06 5.269.65-.582 1.31-1.179 1.95-1.781l-.28-14.738c-.48-.102-.96-.199-1.44-.313"></path>
        </clipPath>
        <clipPath id="clipPath29879" clipPathUnits="userSpaceOnUse">
          <path d="M1948.78 530.301c-17.23 0-33.81 2.699-49.39 7.648 15.64-4.949 32.3-7.629 49.59-7.648h-.2"></path>
        </clipPath>
        <linearGradient
          id="linearGradient29887"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(110 -396.668 -396.668 -110 1885.21 921.52)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#cd2027" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#301c22" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#301c22" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath29897" clipPathUnits="userSpaceOnUse">
          <path d="M1948.98 530.301c-17.29.019-33.95 2.699-49.59 7.648a166.385 166.385 0 00-33.28 14.781l.09.161c.09-.051.18-.102.27-.161l19.37 33.61c18.51-10.758 39.96-17.008 62.94-17.008 23.41 0 45.24 6.527 64.02 17.68l19.32-33.883c-24.42-14.367-52.78-22.789-83.14-22.828"></path>
        </clipPath>
        <linearGradient
          id="linearGradient29905"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(110 -396.668 -396.668 -110 1885.21 921.52)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#cd2027" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#50182d" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#50182d" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath29915" clipPathUnits="userSpaceOnUse">
          <path d="M2113.66 690.961c0 .031.01.059.01.09-.01-.031-.01-.059-.01-.09m.01.371c0 .059 0 .129.01.188-.01-.059-.01-.118-.01-.188m.01.559c0 .078.01.179.01.269 0-.101-.01-.18-.01-.269m.01.468c0 .11 0 .211.01.321-.01-.11-.01-.219-.01-.321m.01.512v0m0 .52c0 .14.01.289.01.429 0-.14-.01-.289-.01-.429m.01.48v0m0 .57v0"></path>
        </clipPath>
        <linearGradient
          id="linearGradient29923"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(110 -396.668 -396.668 -110 1885.21 921.52)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#e91d24" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#381c25" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#381c25" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath29933" clipPathUnits="userSpaceOnUse">
          <path d="M2032.36 553.082l-19.36 33.84c36.89 21.887 61.71 61.988 61.71 107.988l-.13 2.559 39.02-.199.11-2.36v-.469-.121-.449-.051c0-.14-.01-.289-.01-.429v-.153-.367-.191c-.01-.11-.01-.211-.01-.321v-.199c0-.09-.01-.191-.01-.269v-.371c-.01-.059-.01-.129-.01-.188v-.281c0-.031-.01-.059-.01-.09-1.39-58.832-33.74-109.883-81.3-137.879"></path>
        </clipPath>
        <linearGradient
          id="linearGradient29941"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(110 -396.668 -396.668 -110 1885.21 921.52)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ea1c24" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#5d1331" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#5d1331" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath29951" clipPathUnits="userSpaceOnUse">
          <path d="M1784.56 689.941v.008-.008m-.01.34v0m-.01.598v0m-.01.43c0 .101 0 .179-.01.273.01-.094.01-.18.01-.273m-.01.55c0 .102 0 .192-.01.293.01-.101.01-.191.01-.293m-.01.493c0 .128 0 .25-.01.378.01-.128.01-.25.01-.378m-.01.488v0m0 .551c-.01.308-.01.621-.01.929 0-.308 0-.621.01-.929m-.01 1.058v0"></path>
        </clipPath>
        <linearGradient
          id="linearGradient29959"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(110 -396.668 -396.668 -110 1885.21 921.52)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1c24" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#3c1c27" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#3c1c27" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath29969" clipPathUnits="userSpaceOnUse">
          <path d="M1866.2 552.891c-47.49 27.757-79.89 78.511-81.64 137.05v.008c0 .11 0 .223-.01.332v.117c0 .165-.01.321-.01.481v.18c-.01.082-.01.171-.01.25 0 .093 0 .179-.01.273v.277c0 .102 0 .192-.01.293v.2c0 .128 0 .25-.01.378v.661c-.01.308-.01.621-.01.929V694.91l.11 2.231 39.02.05-.11-2.281c0-46.281 25.12-86.64 62.42-108.422l-.09-.148c-.1.062-.2.121-.31.18l-19.33-33.629"></path>
        </clipPath>
        <linearGradient
          id="linearGradient29977"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(110 -396.668 -396.668 -110 1885.21 921.52)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#ed1c24" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#621032" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#621032" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath29987" clipPathUnits="userSpaceOnUse">
          <path d="M1866.47 552.73c-.09.059-.18.11-.27.161l19.33 33.629c.11-.059.21-.118.31-.18l-19.37-33.61"></path>
        </clipPath>
        <linearGradient
          id="linearGradient29995"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(110 -396.668 -396.668 -110 1885.21 921.52)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#b91f29" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#471a2a" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#471a2a" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath30005" clipPathUnits="userSpaceOnUse">
          <path d="M2066.27 687.77c-.01 0-.03.019-.07.05-.4.41-2.35 2.641-5.37 6.121-.03 1.118-.09 2.231-.15 3.34 3.6-5.859 5.77-9.511 5.59-9.511"></path>
        </clipPath>
        <linearGradient
          id="linearGradient30013"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(110 -396.668 -396.668 -110 1885.21 921.52)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f36360" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#ae3876" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#ae3876" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath30023" clipPathUnits="userSpaceOnUse">
          <path d="M2060.83 693.941c-7.54 8.688-21.74 25.207-35.14 40.821l.34 17.929c12.05-19.132 26.77-42.582 34.65-55.41.06-1.109.12-2.222.15-3.34"></path>
        </clipPath>
        <clipPath id="clipPath30035" clipPathUnits="userSpaceOnUse">
          <path d="M2025.69 734.762l-14.6 17.019c4.63 1.168 9.16 2.199 13.55 3.117.46-.726.92-1.457 1.39-2.207l-.34-17.929"></path>
        </clipPath>
        <clipPath id="clipPath30047" clipPathUnits="userSpaceOnUse">
          <path d="M2011.09 751.781c-.81.949-1.6 1.867-2.38 2.77 2.18 4.508 4.99 8.488 8.64 11.91 2.22-3.512 4.68-7.41 7.29-11.563-4.39-.918-8.92-1.949-13.55-3.117"></path>
        </clipPath>
        <clipPath id="clipPath30059" clipPathUnits="userSpaceOnUse">
          <path d="M1940.46 859.32c-.32.571-.63 1.129-.93 1.68.86.051 1.72.09 2.59.129l1.39-1.68c-1.02-.039-2.04-.078-3.05-.129"></path>
        </clipPath>
        <linearGradient
          id="linearGradient30067"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(110 -396.668 -396.668 -110 1885.21 921.52)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f25a61" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#99456f" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#99456f" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath30081" clipPathUnits="userSpaceOnUse">
          <path d="M1984.58 795.992a101.68 101.68 0 01-7.37 2.156c-4.18 6.672-8.81 14.114-13.46 21.704 4.96-.52 9.84-1.332 14.6-2.422l11.62-14.008c-1.35-2.891-2.82-5.223-4.42-6.609-.32-.282-.64-.551-.97-.821m-44.07 63.238c-.02.032-.04.059-.05.09 1.01.051 2.03.09 3.05.129l.05-.058c-1.02-.051-2.04-.102-3.05-.161"></path>
        </clipPath>
        <clipPath id="clipPath30099" clipPathUnits="userSpaceOnUse">
          <path d="M1978.35 817.43c-4.76 1.09-9.64 1.902-14.6 2.422-8.52 13.898-17.13 28.296-23.24 39.378 1.01.059 2.03.11 3.05.161l34.79-41.961"></path>
        </clipPath>
        <linearGradient
          id="linearGradient30107"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(110 -396.668 -396.668 -110 1885.21 921.52)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f5785d" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#bf308a" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#bf308a" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath30117" clipPathUnits="userSpaceOnUse">
          <path d="M1980.38 793.09c-.17.269-.34.539-.51.812.33-.07.65-.14.98-.211l-.09-.371c-.12-.082-.25-.148-.38-.23"></path>
        </clipPath>
        <clipPath id="clipPath30129" clipPathUnits="userSpaceOnUse">
          <path d="M1984.56 795.98c-2.41.809-4.86 1.532-7.35 2.161v.007a101.68 101.68 0 007.37-2.156c-.01 0-.01 0-.02-.012"></path>
        </clipPath>
        <clipPath id="clipPath30141" clipPathUnits="userSpaceOnUse">
          <path d="M1981.22 795.27c-.54.152-1.08.293-1.63.429l1.03 1.461c-1.12.32-2.24.629-3.36.91-.02.032-.03.051-.05.071 2.49-.629 4.94-1.352 7.35-2.161-.98.321-1.97.629-2.96.93l-.38-1.64"></path>
        </clipPath>
        <clipPath id="clipPath30153" clipPathUnits="userSpaceOnUse">
          <path d="M1980.85 793.691c-.33.071-.65.141-.98.211-.24.387-.48.77-.73 1.168l.45.629a52.56 52.56 0 001.63-.429l-.37-1.579"></path>
        </clipPath>
        <clipPath id="clipPath30165" clipPathUnits="userSpaceOnUse">
          <path d="M1979.59 795.699c-.33.09-.68.18-1.01.262-.44.699-.88 1.398-1.32 2.109 1.12-.281 2.24-.59 3.36-.91l-1.03-1.461"></path>
        </clipPath>
        <clipPath id="clipPath30177" clipPathUnits="userSpaceOnUse">
          <path d="M1979.14 795.07c-.18.289-.37.59-.56.891.33-.082.68-.172 1.01-.262l-.45-.629"></path>
        </clipPath>
        <clipPath id="clipPath30189" clipPathUnits="userSpaceOnUse">
          <path d="M1980.76 793.32l.09.371c.13-.019.25-.05.38-.082-.16-.097-.31-.187-.47-.289"></path>
        </clipPath>
        <clipPath id="clipPath30201" clipPathUnits="userSpaceOnUse">
          <path d="M1982.96 794.77c-.58.171-1.16.339-1.74.5l.38 1.64c.99-.301 1.98-.609 2.96-.93-.52-.417-1.05-.82-1.6-1.21"></path>
        </clipPath>
        <clipPath id="clipPath30213" clipPathUnits="userSpaceOnUse">
          <path d="M1981.23 793.609c-.13.032-.25.063-.38.082l.37 1.579c.58-.161 1.16-.329 1.74-.5-.56-.399-1.14-.782-1.73-1.161"></path>
        </clipPath>
        <clipPath id="clipPath30225" clipPathUnits="userSpaceOnUse">
          <path d="M1935.48 692.789l28.51 42.75c1.2.551 2.4 1.09 3.6 1.633l-2.39-10.203c-11.77-13.66-23.04-26.668-29.72-34.18"></path>
        </clipPath>
        <clipPath id="clipPath30237" clipPathUnits="userSpaceOnUse">
          <path d="M1965.2 726.969l2.39 10.203c3.27 1.43 6.57 2.789 9.89 4.07-4.04-4.703-8.19-9.523-12.28-14.273"></path>
        </clipPath>
        <clipPath id="clipPath30249" clipPathUnits="userSpaceOnUse">
          <path d="M1963.99 735.539l4.97 7.441-1.37-5.808c-1.2-.543-2.4-1.082-3.6-1.633"></path>
        </clipPath>
        <clipPath id="clipPath30261" clipPathUnits="userSpaceOnUse">
          <path d="M1967.59 737.172l1.37 5.808 12.69 19.04a60.574 60.574 0 006.22-8.668c-3.3-3.84-6.8-7.922-10.39-12.11-3.32-1.281-6.62-2.64-9.89-4.07"></path>
        </clipPath>
        <clipPath id="clipPath30275" clipPathUnits="userSpaceOnUse">
          <path d="M2038.55 833.148a169.62 169.62 0 01-4.41 2.762l.32.531c-.07.039-.15.09-.22.129l1.11 1.539c1.49-.867 2.95-1.757 4.41-2.668-.4-.761-.81-1.531-1.21-2.293"></path>
        </clipPath>
        <clipPath id="clipPath30297" clipPathUnits="userSpaceOnUse">
          <path d="M2017.01 792.672a32.37 32.37 0 00-2.25 1.609c-2.42 1.879-4.43 4.239-6.11 6.949l2.61 3.598c.74-.418 1.49-.84 2.23-1.269h.95l19.7 32.351c1.49-.898 2.95-1.82 4.41-2.762-7.51-14.128-15.77-29.648-21.54-40.476"></path>
        </clipPath>
        <clipPath id="clipPath30315" clipPathUnits="userSpaceOnUse">
          <path d="M2034.14 835.91c-.09.051-.18.11-.27.16l.37.5c.07-.039.15-.09.22-.129l-.32-.531"></path>
        </clipPath>
        <linearGradient
          id="linearGradient30323"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(110 -396.668 -396.668 -110 1885.21 921.52)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f46c5e" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#ad347d" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#ad347d" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath30333" clipPathUnits="userSpaceOnUse">
          <path d="M2014.44 803.559h-.95c-.74.429-1.49.851-2.23 1.269l22.61 31.242c.09-.05.18-.109.27-.16l-19.7-32.351"></path>
        </clipPath>
        <clipPath id="clipPath30351" clipPathUnits="userSpaceOnUse">
          <path d="M2000.52 851.75c-.04.012-.09.031-.13.039.03.602.05 1.18.07 1.723.02-.012.04-.02.06-.02v-1.742"></path>
        </clipPath>
        <linearGradient
          id="linearGradient30359"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(110 -396.668 -396.668 -110 1885.21 921.52)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f6898e" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#b4869b" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#b4869b" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath30373" clipPathUnits="userSpaceOnUse">
          <path d="M2024.83 771.98a108.562 108.562 0 01-30.34 20.161c-3.22 1.437-6.53 2.73-9.91 3.851.33.27.65.539.97.821 1.6 1.386 3.07 3.718 4.42 6.609 1.29 2.769 2.46 6.058 3.5 9.527a125.03 125.03 0 0011.94-5.078c.91-2.371 1.98-4.601 3.24-6.641 1.68-2.71 3.69-5.07 6.11-6.949a32.37 32.37 0 012.25-1.609c20.75-13.672 61-10.332 42.6-11.703-15.28-1.129-26.51-4.18-34.78-8.989"></path>
        </clipPath>
        <clipPath id="clipPath30391" clipPathUnits="userSpaceOnUse">
          <path d="M2000.52 851.359c-.05.012-.1.032-.15.043.01.129.01.258.02.387.04-.008.09-.027.13-.039v-.391"></path>
        </clipPath>
        <linearGradient
          id="linearGradient30399"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(110 -396.668 -396.668 -110 1885.21 921.52)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f7958d" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#c582ab" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#c582ab" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath30409" clipPathUnits="userSpaceOnUse">
          <path d="M2005.41 807.871a125.03 125.03 0 01-11.94 5.078c3.99 13.301 6.14 29.293 6.14 29.293.39 3.43.63 6.559.76 9.16.05-.011.1-.031.15-.043v-2.109c0-.16.01-.539.02-1.059-.16-10.609-.09-27.421 4.87-40.32"></path>
        </clipPath>
        <linearGradient
          id="linearGradient30417"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(110 -396.668 -396.668 -110 1885.21 921.52)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f89e8c" stopOpacity="1"></stop>
          <stop offset="0.976" stopColor="#d47fb5" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#d47fb5" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath30427" clipPathUnits="userSpaceOnUse">
          <path d="M2000.63 694.789v8.871l-.11 1.84v-10.711c-.31 10.66-.46 32.34-8.97 51.422 5.22 1.68 10.42 3.187 15.53 4.539-5.51-14.32-5.82-33.25-6.45-55.961"></path>
        </clipPath>
        <clipPath id="clipPath30439" clipPathUnits="userSpaceOnUse">
          <path d="M2024.77 771.949a109.009 109.009 0 01-30.28 20.192 108.562 108.562 0 0030.34-20.161c-.02-.011-.04-.019-.06-.031"></path>
        </clipPath>
        <clipPath id="clipPath30451" clipPathUnits="userSpaceOnUse">
          <path d="M1974.95 768.551a54.585 54.585 0 01-9.98 6.449l11.2 15.852c1.46.687 2.87 1.437 4.21 2.238.13.082.26.148.38.23l-5.81-24.769"></path>
        </clipPath>
        <clipPath id="clipPath30463" clipPathUnits="userSpaceOnUse">
          <path d="M1964.97 775c-8.28 4.172-18.53 6.762-31.21 7.031-.53.008-1.01.02-1.45.028 7.66.211 28.61 1.589 43.86 8.793L1964.97 775"></path>
        </clipPath>
        <clipPath id="clipPath30475" clipPathUnits="userSpaceOnUse">
          <path d="M1994.49 792.141c-2.12.941-4.28 1.82-6.47 2.621-1.14.429-2.29.84-3.46 1.218.01.012.01.012.02.012 3.38-1.121 6.69-2.414 9.91-3.851"></path>
        </clipPath>
        <clipPath id="clipPath30487" clipPathUnits="userSpaceOnUse">
          <path d="M1988.02 794.762c-1.14.429-2.3.828-3.46 1.218 1.17-.378 2.32-.789 3.46-1.218"></path>
        </clipPath>
        <clipPath id="clipPath30499" clipPathUnits="userSpaceOnUse">
          <path d="M2024.41 771.73a109.738 109.738 0 01-17.36 12.622c3.43-1.75 6.76-3.68 9.97-5.774-8.71 6.781-18.47 12.281-29 16.184 2.19-.801 4.35-1.68 6.47-2.621a109.009 109.009 0 0030.28-20.192c-.12-.078-.24-.148-.36-.219"></path>
        </clipPath>
        <clipPath id="clipPath30511" clipPathUnits="userSpaceOnUse">
          <path d="M1991.55 746.211a72.044 72.044 0 01-3.68 7.141 60.574 60.574 0 01-6.22 8.668 54.547 54.547 0 01-6.7 6.531l5.81 24.769c.16.102.31.192.47.289 9.08-2 17.74-5.14 25.82-9.257 6.2-3.641 12.02-7.872 17.36-12.622-2.65-1.57-4.99-3.328-7.06-5.269-3.65-3.422-6.46-7.402-8.64-11.91-.59-1.231-1.13-2.5-1.63-3.801a307.318 307.318 0 01-15.53-4.539"></path>
        </clipPath>
        <clipPath id="clipPath30523" clipPathUnits="userSpaceOnUse">
          <path d="M2017.02 778.578a108.54 108.54 0 01-9.97 5.774c-7.5 4.39-15.58 7.91-24.09 10.418.55.39 1.08.793 1.6 1.21 1.16-.39 2.32-.789 3.46-1.218 10.53-3.903 20.29-9.403 29-16.184"></path>
        </clipPath>
        <clipPath id="clipPath30535" clipPathUnits="userSpaceOnUse">
          <path d="M2007.05 784.352a108.054 108.054 0 01-25.82 9.257c.59.379 1.17.762 1.73 1.161a108.286 108.286 0 0024.09-10.418"></path>
        </clipPath>
        <clipPath id="clipPath30547" clipPathUnits="userSpaceOnUse">
          <path d="M1930.22 782.031c-.59 0-.9.008-.86.02.04.008.41.019 1.18.019.45 0 1.04 0 1.77-.011-.88-.028-1.59-.028-2.09-.028"></path>
        </clipPath>
        <clipPath id="clipPath30559" clipPathUnits="userSpaceOnUse">
          <path d="M2000.63 851.711c-.01.008-.02.008-.03.008l.03 1.672v-1.68"></path>
        </clipPath>
        <clipPath id="clipPath30577" clipPathUnits="userSpaceOnUse">
          <path d="M2000.63 851.32c-.01 0-.02.012-.03.012v.387c.01 0 .02 0 .03-.008v-.391"></path>
        </clipPath>
        <clipPath id="clipPath30595" clipPathUnits="userSpaceOnUse">
          <path d="M2000.63 845.5c-.03.969-.07 1.961-.09 2.691.02 1.122.04 2.168.06 3.141.01 0 .02-.012.03-.012v-5.82"></path>
        </clipPath>
        <clipPath id="clipPath30613" clipPathUnits="userSpaceOnUse">
          <path d="M2000.63 853.391v.07c0-.012-.01 0 0-.012v-.058"></path>
        </clipPath>
        <clipPath id="clipPath32041" clipPathUnits="userSpaceOnUse">
          <path d="M2634.34 2513.5c12.85 14.93 25.66 29.84 37.63 43.79 3.77-11.29 8.14-22.83 13.21-34.43l-4.53-1.08c-.34-.09-17.16-4.06-46.31-8.28"></path>
        </clipPath>
        <clipPath id="clipPath32053" clipPathUnits="userSpaceOnUse">
          <path d="M2709.52 2463.6c-6.25 0-12.43.3-18.51.88-2.14 19.05-3.58 29.47-3.58 29.47s-.01-.01-.04-.01v.01s-23.01-5.57-62.59-10.69c-3.84 1.91-7.61 3.95-11.28 6.1 6.87 7.95 13.85 16.05 20.82 24.14 29.15 4.22 45.97 8.19 46.31 8.28l4.53 1.08c8.7-19.9 19.44-39.95 32.71-59.08-2.77-.12-5.56-.18-8.37-.18"></path>
        </clipPath>
        <clipPath id="clipPath32065" clipPathUnits="userSpaceOnUse">
          <path d="M2624.81 2483.26h-.01c39.58 5.12 62.59 10.69 62.59 10.69v-.01c-1.15-.28-23.99-5.69-62.58-10.68"></path>
        </clipPath>
        <clipPath id="clipPath32077" clipPathUnits="userSpaceOnUse">
          <path d="M2691.01 2464.48h-.05c-2.1 18.71-3.52 29.08-3.57 29.46.03 0 .04.01.04.01s1.44-10.42 3.58-29.47"></path>
        </clipPath>
        <clipPath id="clipPath32089" clipPathUnits="userSpaceOnUse">
          <path d="M2690.96 2464.48c-23.71 2.26-46.07 8.8-66.15 18.78 38.59 4.99 61.43 10.4 62.58 10.68.05-.38 1.47-10.75 3.57-29.46"></path>
        </clipPath>
        <clipPath id="clipPath32101" clipPathUnits="userSpaceOnUse">
          <path d="M2866.51 2632.8l-3.62 25.68 20.53 18c2.67-8.97 4.56-18.23 5.6-27.74l-22.51-15.94"></path>
        </clipPath>
        <clipPath id="clipPath32113" clipPathUnits="userSpaceOnUse">
          <path d="M2862.89 2658.48l-9.26 65.64-78.62-18.48c11.12 20.88 23.33 43.83 34.87 65.52 35.36-22.08 61.89-55.51 73.54-94.68l-20.53-18"></path>
        </clipPath>
        <clipPath id="clipPath32125" clipPathUnits="userSpaceOnUse">
          <path d="M2888.29 2608.67a282.59 282.59 0 01-20.87 17.64l-.91 6.49 22.51 15.94c.61-5.65.93-11.39.93-17.2 0-7.75-.57-15.39-1.66-22.87"></path>
        </clipPath>
        <clipPath id="clipPath32137" clipPathUnits="userSpaceOnUse">
          <path d="M2867.42 2626.31a282.773 282.773 0 01-33.13 21.84c-4.96 2.8-9.93 5.47-14.89 8l-1.97 14.02-.68-.16-.02.16-17.87-4.21a470.884 470.884 0 01-37.15 14.71c4.16 7.8 8.63 16.2 13.3 24.97l78.62 18.48 9.26-65.64 3.62-25.68.91-6.49"></path>
        </clipPath>
        <clipPath id="clipPath32149" clipPathUnits="userSpaceOnUse">
          <path d="M2799.1 2665.86c-.08.03-.16.07-.24.1l17.87 4.21.02-.16-17.65-4.15"></path>
        </clipPath>
        <clipPath id="clipPath32161" clipPathUnits="userSpaceOnUse">
          <path d="M2819.4 2656.15c-.25.13-.5.25-.75.38l-1.9 13.48.68.16 1.97-14.02"></path>
        </clipPath>
        <clipPath id="clipPath32173" clipPathUnits="userSpaceOnUse">
          <path d="M2818.65 2656.53c-6.56 3.33-13.08 6.43-19.55 9.33l17.65 4.15 1.9-13.48"></path>
        </clipPath>
        <clipPath id="clipPath32185" clipPathUnits="userSpaceOnUse">
          <path d="M2717.89 2463.78c-13.27 19.13-24.01 39.18-32.71 59.08-5.07 11.6-9.44 23.14-13.21 34.43 2.58 3.01 5.13 5.98 7.62 8.89 10.71-33.17 26.69-68.98 50.6-101.49-4.06-.43-8.16-.73-12.3-.91m167.93 131.87c-16.17 15.73-34.68 29.83-55.36 41.52-25.43 14.31-51.07 24.99-74.38 32.92 1.8 3.38 3.68 6.91 5.63 10.58 11.92-4.15 24.41-9.02 37.15-14.71.08-.03.16-.07.24-.1 6.47-2.9 12.99-6 19.55-9.33.25-.13.5-.25.75-.38 4.96-2.53 9.93-5.2 14.89-8a282.773 282.773 0 0033.13-21.84 282.59 282.59 0 0020.87-17.64c-.64-4.39-1.47-8.74-2.47-13.02"></path>
        </clipPath>
        <clipPath id="clipPath32197" clipPathUnits="userSpaceOnUse">
          <path d="M2741.52 2466.24c-26.35 34.42-43.35 73.35-54.26 108.88 2.02 2.35 3.99 4.66 5.93 6.92 12.8-37.9 32.11-80.72 60.35-113.4-3.96-.92-7.96-1.72-12.02-2.4m136.57 105.32c-29.11 31.16-84.84 61.77-131.18 81.32l4.4 8.26c23.25-7.81 48.91-18.4 74.24-32.68 21.61-12.16 40.76-27.13 57.24-43.88a158.82 158.82 0 00-4.7-13.02"></path>
        </clipPath>
        <clipPath id="clipPath32209" clipPathUnits="userSpaceOnUse">
          <path d="M2730.19 2464.69c-23.91 32.51-39.89 68.32-50.6 101.49 2.61 3.04 5.17 6.02 7.67 8.94 10.91-35.53 27.91-74.46 54.26-108.88-3.74-.62-7.52-1.14-11.33-1.55m152.6 119.89c-16.48 16.75-35.63 31.72-57.24 43.88-25.33 14.28-50.99 24.87-74.24 32.68 1.51 2.84 3.1 5.82 4.77 8.95 23.31-7.93 48.95-18.61 74.38-32.92 20.68-11.69 39.19-25.79 55.36-41.52-.88-3.74-1.89-7.43-3.03-11.07"></path>
        </clipPath>
        <clipPath id="clipPath32221" clipPathUnits="userSpaceOnUse">
          <path d="M2753.54 2468.64c-28.24 32.68-47.55 75.5-60.35 113.4 1.94 2.27 3.84 4.48 5.68 6.64 11.13-39.2 28.14-81.82 51.46-93.98 7.94-4.15 15.92-6.02 23.59-6.02 36.88 0 66.53 43.15 50.04 83.45-10.64 25.99-50.12 49.88-84.64 66.51 1.91 3.59 4.49 8.42 7.59 14.24 46.34-19.55 102.07-50.16 131.18-81.32-20.84-50.66-67.28-89.54-124.55-102.92"></path>
        </clipPath>
        <clipPath id="clipPath32233" clipPathUnits="userSpaceOnUse">
          <path d="M2773.92 2488.68c-7.67 0-15.65 1.87-23.59 6.02-23.32 12.16-40.33 54.78-51.46 93.98 21.78 25.43 36.67 42.86 36.67 42.86s1.35 2.55 3.78 7.1c34.52-16.63 74-40.52 84.64-66.51 16.49-40.3-13.16-83.45-50.04-83.45"></path>
        </clipPath>
        <clipPath id="clipPath32245" clipPathUnits="userSpaceOnUse">
          <path d="M2625.26 2675.66l22.71 26.53.23-15.63c.01-.77.06-3.55.3-8-6.99-.97-14.76-1.96-23.24-2.9m95.76 17.29c-32.63 8.37-55.22 10.71-57.02 10.87l-13.49 1.34 79.85 93.27c24.08-2.58 46.72-9.58 66.96-20.1-20-27.64-41.55-57.45-58.76-81.26l-17.54-4.12"></path>
        </clipPath>
        <clipPath id="clipPath32257" clipPathUnits="userSpaceOnUse">
          <path d="M2533.94 2670.01c18.67 74.25 90.2 129.53 175.58 129.53 7.04 0 14-.38 20.84-1.11l-79.85-93.27-2.59.26.05-3.23-22.71-26.53c-24.9-2.77-55.92-5.14-91.32-5.65"></path>
        </clipPath>
        <clipPath id="clipPath32269" clipPathUnits="userSpaceOnUse">
          <path d="M2529.29 2625.87c-.07 1.88-.1 3.78-.1 5.67 0 13.24 1.64 26.12 4.75 38.47 35.4.51 66.42 2.88 91.32 5.65 8.48.94 16.25 1.93 23.24 2.9.48-8.84 1.69-24.28 4.75-43.85-30.09-4.13-72.91-8.37-123.96-8.84m203.92 63.79c-4.19 1.19-8.27 2.28-12.19 3.29l17.54 4.12c-1.83-2.54-3.62-5.02-5.35-7.41"></path>
        </clipPath>
        <clipPath id="clipPath32281" clipPathUnits="userSpaceOnUse">
          <path d="M2529.29 2625.87c51.05.47 93.87 4.71 123.96 8.84.01-.02.01-.06.02-.09-30.2-4.13-73-8.33-123.98-8.75"></path>
        </clipPath>
        <clipPath id="clipPath32293" clipPathUnits="userSpaceOnUse">
          <path d="M2587.44 2507.95c-34.41 29.5-56.49 71.31-58.15 117.92 50.98.42 93.78 4.62 123.98 8.75 2.17-13.89 5.28-29.84 9.72-46.99l-51.47-77.13a991.64 991.64 0 00-24.08-2.55"></path>
        </clipPath>
        <clipPath id="clipPath32305" clipPathUnits="userSpaceOnUse">
          <path d="M2602.22 2496.57a178.9 178.9 0 00-14.78 11.38c8.53.8 16.57 1.66 24.08 2.55l-9.3-13.93"></path>
        </clipPath>
        <clipPath id="clipPath32317" clipPathUnits="userSpaceOnUse">
          <path d="M2662.99 2587.63c-4.44 17.15-7.55 33.1-9.72 46.99-.01.03-.01.07-.02.09-3.06 19.57-4.27 35.01-4.75 43.85-.24 4.45-.29 7.23-.3 8l-.23 15.63-.05 3.23 2.59-.26 13.49-1.34c1.8-.16 24.39-2.5 57.02-10.87 3.92-1.01 8-2.1 12.19-3.29-2.63-3.63-5.12-7.08-7.46-10.32-36.68 9.93-62.29 12.44-62.49 12.47l-5.57.55.08-5.59c.01-.26.54-38.03 12.65-88.02l-7.43-11.12"></path>
        </clipPath>
        <clipPath id="clipPath32329" clipPathUnits="userSpaceOnUse">
          <path d="M2678.03 2610.17c-4.4 19.9-6.92 37.43-8.36 50.69-.89 8.16-1.36 14.7-1.62 19.19l-.06 1.1c8.91-1.21 27.58-4.22 51.49-10.49-1.46-2.03-2.83-3.92-4.09-5.66-17.01 5.82-30.7 9.14-38.22 9.14-3.47 0-5.63-.7-6.2-2.2 0 0 3.16-22.83 11.68-54.86l-4.62-6.91"></path>
        </clipPath>
        <clipPath id="clipPath32341" clipPathUnits="userSpaceOnUse">
          <path d="M2670.42 2598.75c-12.11 49.99-12.64 87.76-12.65 88.02l-.08 5.59 5.57-.55c.2-.03 25.81-2.54 62.49-12.47-2.24-3.1-4.34-6.01-6.27-8.68-23.91 6.27-42.58 9.28-51.49 10.49l.06-1.1c.26-4.49.73-11.03 1.62-19.19 1.44-13.26 3.96-30.79 8.36-50.69l-7.61-11.42"></path>
        </clipPath>
        <clipPath id="clipPath32353" clipPathUnits="userSpaceOnUse">
          <path d="M2682.65 2617.08c-8.52 32.03-11.68 54.86-11.68 54.86.57 1.5 2.73 2.2 6.2 2.2 7.52 0 21.21-3.32 38.22-9.14-4.04-5.59-7.02-9.72-8.63-11.95-14.35 5.83-24.03 9.13-24.03 9.13s2.17-14.51 6.61-35.07l-6.69-10.03"></path>
        </clipPath>
        <clipPath id="clipPath32365" clipPathUnits="userSpaceOnUse">
          <path d="M2689.34 2627.11c-4.44 20.56-6.61 35.07-6.61 35.07s9.68-3.3 24.03-9.13c-.9-1.25-1.38-1.91-1.38-1.91l-16.04-24.03"></path>
        </clipPath>
        <clipPath id="clipPath32377" clipPathUnits="userSpaceOnUse">
          <path d="M2590.81 2479.48l11.41 17.09c3.67-2.54 7.43-4.94 11.3-7.21-2.4-2.79-4.79-5.55-7.16-8.3-4.99-.55-10.18-1.08-15.55-1.58"></path>
        </clipPath>
        <linearGradient
          id="linearGradient32383"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(1626.6 0 0 -1626.6 1112.29 1761.91)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#faf8a4" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#f8cbac" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath32393" clipPathUnits="userSpaceOnUse">
          <path d="M2590.81 2479.47v.01c5.37.5 10.56 1.03 15.55 1.58l-.01-.01c-4.98-.54-10.17-1.07-15.54-1.58"></path>
        </clipPath>
        <clipPath id="clipPath32409" clipPathUnits="userSpaceOnUse">
          <path d="M2544.78 2410.5l46.03 68.97c5.37.51 10.56 1.04 15.54 1.58-24.67-28.54-47.24-54.47-61.57-70.55"></path>
        </clipPath>
        <linearGradient
          id="linearGradient32415"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(1405.668 -1405.668) rotate(74.316 1.794 -.004)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#f7b9af" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#fce0a9" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="clipPath32425" clipPathUnits="userSpaceOnUse">
          <path d="M2809.88 2771.16c-4.07 2.55-8.26 4.94-12.56 7.17 31.88 44.05 59.84 82.59 60.06 82.59l-.01-.01c-1.22-2.63-22.81-43.34-47.49-89.75"></path>
        </clipPath>
        <radialGradient
          id="radialGradient32433"
          cx="0"
          cy="0"
          r="1"
          fx="0"
          fy="0"
          gradientTransform="matrix(1933.25 0 0 -1689.55 1930.26 1895.11)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" stopColor="#d9b0b6" stopOpacity="1"></stop>
          <stop offset="0.661" stopColor="#d9b0b6" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#b5b5b1" stopOpacity="1"></stop>
        </radialGradient>
        <clipPath id="clipPath32443" clipPathUnits="userSpaceOnUse">
          <path d="M2611.52 2510.5l51.47 77.13c2.53-9.78 5.5-19.96 8.98-30.34-11.97-13.95-24.78-28.86-37.63-43.79-6.93-1-14.55-2.02-22.82-3"></path>
        </clipPath>
        <clipPath id="clipPath32455" clipPathUnits="userSpaceOnUse">
          <path d="M2613.52 2489.36a178.74 178.74 0 00-11.3 7.21l9.3 13.93c8.27.98 15.89 2 22.82 3-6.97-8.09-13.95-16.19-20.82-24.14"></path>
        </clipPath>
        <clipPath id="clipPath32467" clipPathUnits="userSpaceOnUse">
          <path d="M2738.56 2697.07c17.21 23.81 38.76 53.62 58.76 81.26 4.3-2.23 8.49-4.62 12.56-7.17-11.54-21.69-23.75-44.64-34.87-65.52l-36.45-8.57"></path>
        </clipPath>
        <clipPath id="clipPath32479" clipPathUnits="userSpaceOnUse">
          <path d="M2761.71 2680.67c-9.96 3.47-19.52 6.45-28.5 8.99 1.73 2.39 3.52 4.87 5.35 7.41l36.45 8.57c-4.67-8.77-9.14-17.17-13.3-24.97"></path>
        </clipPath>
        <clipPath id="clipPath32491" clipPathUnits="userSpaceOnUse">
          <path d="M2671.97 2557.29a450.533 450.533 0 00-8.98 30.34l7.43 11.12c.41-1.7.83-3.41 1.27-5.14 2.25-8.84 4.87-18.03 7.9-27.43-2.49-2.91-5.04-5.88-7.62-8.89m84.11 112.8a503.758 503.758 0 01-30.33 9.25c2.34 3.24 4.83 6.69 7.46 10.32 8.98-2.54 18.54-5.52 28.5-8.99-1.95-3.67-3.83-7.2-5.63-10.58"></path>
        </clipPath>
        <clipPath id="clipPath32503" clipPathUnits="userSpaceOnUse">
          <path d="M2687.26 2575.12a434.66 434.66 0 00-5.88 20.96c-1.22 4.8-2.33 9.51-3.35 14.09l4.62 6.91c2.88-10.8 6.36-22.66 10.54-35.04-1.94-2.26-3.91-4.57-5.93-6.92m59.65 77.76c-11.23 4.74-21.91 8.83-31.52 12.12 1.26 1.74 2.63 3.63 4.09 5.66 9.83-2.59 20.54-5.72 31.83-9.52l-4.4-8.26"></path>
        </clipPath>
        <clipPath id="clipPath32515" clipPathUnits="userSpaceOnUse">
          <path d="M2679.59 2566.18c-3.03 9.4-5.65 18.59-7.9 27.43-.44 1.73-.86 3.44-1.27 5.14l7.61 11.42c1.02-4.58 2.13-9.29 3.35-14.09a434.66 434.66 0 015.88-20.96c-2.5-2.92-5.06-5.9-7.67-8.94m71.72 94.96c-11.29 3.8-22 6.93-31.83 9.52 1.93 2.67 4.03 5.58 6.27 8.68 9.45-2.56 19.65-5.62 30.33-9.25-1.67-3.13-3.26-6.11-4.77-8.95"></path>
        </clipPath>
        <clipPath id="clipPath32527" clipPathUnits="userSpaceOnUse">
          <path d="M2693.19 2582.04c-4.18 12.38-7.66 24.24-10.54 35.04l6.69 10.03c2.47-11.43 5.64-24.72 9.53-38.43-1.84-2.16-3.74-4.37-5.68-6.64m46.13 56.6c-11.91 5.74-23.22 10.61-32.56 14.41 1.61 2.23 4.59 6.36 8.63 11.95 9.61-3.29 20.29-7.38 31.52-12.12-3.1-5.82-5.68-10.65-7.59-14.24"></path>
        </clipPath>
        <clipPath id="clipPath32539" clipPathUnits="userSpaceOnUse">
          <path d="M2698.87 2588.68c-3.89 13.71-7.06 27-9.53 38.43l16.04 24.03s.48.66 1.38 1.91c9.34-3.8 20.65-8.67 32.56-14.41-2.43-4.55-3.78-7.1-3.78-7.1s-14.89-17.43-36.67-42.86"></path>
        </clipPath>
        <linearGradient
          id="linearGradient119688"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(1405.668 -1405.668) rotate(74.316 1.794 -.004)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient18025"
        ></linearGradient>
        <linearGradient
          id="linearGradient119690"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(110 -396.668 -396.668 -110 1885.21 921.52)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient29551"
        ></linearGradient>
        <linearGradient
          id="linearGradient119692"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(110 -396.668 -396.668 -110 1885.21 921.52)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient29551"
        ></linearGradient>
        <linearGradient
          id="linearGradient119694"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(110 -396.668 -396.668 -110 1885.21 921.52)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient30013"
        ></linearGradient>
        <linearGradient
          id="linearGradient119696"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(110 -396.668 -396.668 -110 1885.21 921.52)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient30067"
        ></linearGradient>
        <linearGradient
          id="linearGradient119698"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(110 -396.668 -396.668 -110 1885.21 921.52)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient30013"
        ></linearGradient>
        <linearGradient
          id="linearGradient119700"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(110 -396.668 -396.668 -110 1885.21 921.52)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient30107"
        ></linearGradient>
        <linearGradient
          id="linearGradient119702"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(110 -396.668 -396.668 -110 1885.21 921.52)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient30067"
        ></linearGradient>
        <linearGradient
          id="linearGradient119704"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(110 -396.668 -396.668 -110 1885.21 921.52)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient30013"
        ></linearGradient>
        <linearGradient
          id="linearGradient119706"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(110 -396.668 -396.668 -110 1885.21 921.52)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient30107"
        ></linearGradient>
        <linearGradient
          id="linearGradient119708"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(110 -396.668 -396.668 -110 1885.21 921.52)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient30359"
        ></linearGradient>
        <linearGradient
          id="linearGradient119710"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(110 -396.668 -396.668 -110 1885.21 921.52)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient29551"
        ></linearGradient>
        <linearGradient
          id="linearGradient119712"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(110 -396.668 -396.668 -110 1885.21 921.52)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient30399"
        ></linearGradient>
        <linearGradient
          id="linearGradient119714"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(110 -396.668 -396.668 -110 1885.21 921.52)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient30417"
        ></linearGradient>
        <linearGradient
          id="linearGradient119716"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(110 -396.668 -396.668 -110 1885.21 921.52)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient30359"
        ></linearGradient>
        <linearGradient
          id="linearGradient119718"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(110 -396.668 -396.668 -110 1885.21 921.52)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient30399"
        ></linearGradient>
        <linearGradient
          id="linearGradient119720"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(110 -396.668 -396.668 -110 1885.21 921.52)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient30417"
        ></linearGradient>
        <linearGradient
          id="linearGradient119722"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(110 -396.668 -396.668 -110 1885.21 921.52)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient30359"
        ></linearGradient>
        <linearGradient
          id="linearGradient119724"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(1405.668 -1405.668) rotate(74.316 1.794 -.004)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          xlinkHref="#linearGradient18025"
        ></linearGradient>
      </defs>
      <g transform="translate(-56.187 -101.59)">
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath17883)">
            <path
              fill="url(#linearGradient17891)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1581.46 855.969a5485 5485 0 01-76.89 19.332c-7.71 1.89-15.42 3.75-23.14 5.59a2861.261 2861.261 0 00-47.02 40.621c4.2 14.519 7.79 31.129 10.1 49.898 49.53-44.558 95.24-82.769 136.95-115.441m725.98.722c5.12 14.418 9.62 27.95 13.59 40.661 36.77 30.468 76.15 64.867 118.13 103.708.84-19.912 3.14-37.861 6.31-53.88-29.48-26.7-57.66-51.2-84.59-73.75a1895.98 1895.98 0 00-5.48-4.571 6035.19 6035.19 0 01-47.96-12.168M1198.92 1156c-21.47 27.55-41.19 56.86-59.27 87.58 7.86 14.49 15.39 30.9 22.27 49.45 13.2-24.24 27.38-47.63 42.6-70.03-2.66-21.04-4.7-43.58-5.6-67m1485.24 44.06c-2.38 24.3-5.73 47.03-9.39 67.36 12.84 21.82 24.86 44.45 36.05 67.68 5.78-21.49 12.41-40.7 19.59-57.87-14.27-26.72-29.66-52.51-46.25-77.17m-1670.74 365.96c-2.65 10.59-5.17 21.16-7.61 31.82-.82 3.58-1.63 7.13-2.42 10.71 3.01 3.97 6.02 8.09 9.03 12.38 9.22 13.14 17.16 26.71 23.99 40.48 3.11-15.79 6.41-31.46 9.94-47.14-10.58-14.26-21.8-30.43-32.93-48.25m1833.51 38.41a739.456 739.456 0 01-34.63 44.59c5.06 24.79 9.6 49.68 13.68 74.63 6.99-24.92 16.78-50.36 30.35-74.91-2.23-11.17-4.56-22.33-6.99-33.44-.79-3.63-1.59-7.24-2.41-10.87M962.199 1876.99c-.054.62-.121 1.29-.176 1.9a2704.495 2704.495 0 00-5.753 72.85c13.289 6.62 27.296 15.18 41.839 26.18 1.426-25.46 3.231-51.33 5.431-77.33a546.249 546.249 0 01-41.341-23.6m1928.581 19.3c-16.97 9.09-31.51 15.72-41.84 20.1 2.4 30.54 4.25 60.82 5.62 90.5 1.68-1.67 3.4-3.33 5.14-4.97 12.5-11.78 24.71-21.68 36.52-30a2751.092 2751.092 0 00-5.44-75.63M950.785 2232.94c.445 19.15 1.035 37.71 1.738 55.63 3.5 6.6 7.071 13.14 10.711 19.61 7.969 14.12 15.727 27.16 23.399 39.27 4.035.26 8.269.69 12.676 1.32-1.707-29.2-3.18-60.8-4.227-94.41-14.48-6.03-29.402-13.11-44.297-21.42m1949.195 17.57c-15.34 6.78-30.29 12.37-44.32 16.96-.75 21.51-1.67 42.13-2.71 61.79.2.58.41 1.21.6 1.78-.48 8.99-.98 17.77-1.5 26.33 16.17-5.67 30.91-8.51 43.82-9.64 1.69-30.07 3.13-62.64 4.11-97.22M978.352 2588.62l1.503 10.92 17.344 125.77 96.501-23.34 55.39-13.4c-21.88-6.38-46.93-15.28-72.64-27.6l-41.54 10.06-.02-.17-.68.17-5.12-37.13a281.087 281.087 0 01-50.738-45.28m352.988 37.21c-37.86.02-71.47 2.15-99.1 4.91 3.07 18.62 4.49 33.86 5.14 43.72 26.17-2.57 57.96-4.55 93.74-4.55 23.05 0 45.93.81 68.55 2.41 37.94 2.69 75.16 7.62 111.25 14.75 22.32 4.41 43.92 10.47 64.61 17.69 59.27 20.7 111.07 50.89 151.12 78.86 4.15 2.89 8.17 5.76 12.06 8.59 46.85 34.14 74.74 62.91 75.33 63.53l99.13 107.23 12.43 13.44 111.89-121.04c.38-.4 18.54-19.08 50.05-44.14 36.03-28.65 89.54-65.63 153.92-93.16.85-.36 1.69-.72 2.53-1.07 29.99-12.65 62.3-23.22 96.28-29.93 18.66-3.69 37.61-6.78 56.81-9.29 40.11-5.23 81.27-7.87 122.99-7.87 4.69 0 9.31.04 13.87.1a157.31 157.31 0 01-4.75-38.47c0-1.89.03-3.79.1-5.67-2.89-.02-5.8-.04-8.74-.04-64.32.01-127.62 6.07-188.12 18.01-189.46 37.39-325.49 180.48-326.6 181.64l-79.54 86-.35-.38-.34.38-79.53-86c-1.31-1.46-137.8-144.39-326.61-181.64-60.48-11.94-123.8-18-188.12-18.01"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath17901)">
            <path
              fill="url(#linearGradient17907)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1591.98 853.23c-3.5.918-7 1.829-10.52 2.739-41.71 32.672-87.42 70.883-136.95 115.441 4.62 37.43 4.18 83.4-6.6 138.26a391.882 391.882 0 01-7.25 30.37c42.42-41.2 82.2-77.71 119.3-110.05 1.17-32.439 10.41-88.381 42.02-176.76m729.05 44.122c34.07 108.978 28.54 156.378 23.78 167.378-.43.98-.89 1.93-1.38 2.84 40.98 37.22 84.91 79.26 131.69 126.66-11.4-25.39-20.83-53.57-26.92-84.56-8.1-41.16-10.37-77.31-9.04-108.61-41.98-38.841-81.36-73.24-118.13-103.708M1204.52 1223c-15.22 22.4-29.4 45.79-42.6 70.03 6 16.18 11.51 33.99 16.32 53.59 10.79 43.98 13.14 86.72 10.6 126.1 6.41-1.79 12.84-3.54 19.3-5.24 11.19-30.16 23.58-59.39 37.33-87.51l-4.56 2.69-6.6-19.97c-1.06-3.24-19.82-60.92-29.79-139.69m1470.25 44.42c-9.94 55.23-22.13 92.68-22.98 95.27l-6.58 19.97-16.35-9.64c-2.04-1.22-19.9-12-43.88-32.71 118.19 211.54 150.67 502.49 153.68 739.93 12.31 20.7 24.05 41.75 35.21 63.15 15-45.68 39.78-95.88 80.69-136.5a2811.72 2811.72 0 00-5.62-90.5c-9.62 4.07-15.59 6.19-16.46 6.5l-15.43 5.36-3.05-18.51c-.8-4.94-14.42-91.88 11.98-186.09-4.08-24.95-8.62-49.84-13.68-74.63-17.53 20.86-29.8 33-31.04 34.2l-14.02 13.72-10.31-17.67c-3.75-6.49-91.41-159.96-49.07-332.65.96-3.91 1.95-7.75 2.96-11.52-11.19-23.23-23.21-45.86-36.05-67.68m-1628.42 346.85c-3.53 15.68-6.83 31.35-9.94 47.14.17.36.35.72.53 1.08 3.12-15.88 6.44-31.68 9.99-47.45-.19-.25-.39-.51-.58-.77m-42.81 286.32c-2.2 26-4.005 51.87-5.431 77.33.231.17.469.35.7.53a2687.87 2687.87 0 015.441-77.5c-.24-.12-.47-.24-.71-.36m-8.458 353.77c1.047 33.61 2.52 65.21 4.227 94.41.238.04.476.07.711.11a3506.78 3506.78 0 01-4.215-94.22c-.239-.1-.485-.2-.723-.3m1860.578 13.11c-7.84 2.57-15.39 4.83-22.55 6.81 7.02 18.14 13.64 36.47 19.84 54.98 1.04-19.66 1.96-40.28 2.71-61.79m-334.89 358.36h-.22c2.94 0 5.85.02 8.74.04-2.81-.03-5.66-.04-8.52-.04m-1188.95 0h-.48c64.32.01 127.64 6.07 188.12 18.01 188.81 37.25 325.3 180.18 326.61 181.64l79.53 86 .34-.38-79.18-85.62c-1.31-1.46-137.79-144.39-326.6-181.64-60.54-11.96-123.94-18.01-188.34-18.01m-302.73 8.07l5.12 37.13.68-.17-5.03-36.42c-.26-.18-.51-.36-.77-.54"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath17917)">
            <path
              fill="url(#linearGradient17925)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2852.95 2329.26c-.51 9.68-1.05 19.17-1.61 28.35.24-.08.47-.16.71-.24.52-8.56 1.02-17.34 1.5-26.33-.19-.57-.4-1.2-.6-1.78m-332.88 296.57c-64.39 0-127.78 6.05-188.34 18.01-189.45 37.39-325.49 180.48-326.6 181.64l-79.19 85.62.35.38 79.54-86c1.11-1.16 137.14-144.25 326.6-181.64 60.5-11.94 123.8-18 188.12-18.01h-.48m-1188.95 0c-37.73 0-71.27 2.11-98.89 4.84 0 .03 0 .04.01.07 27.63-2.76 61.24-4.89 99.1-4.91h-.22m-254.9 35.03l-41.33 10 .02.17 41.54-10.06c-.07-.03-.16-.07-.23-.11"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath17935)">
            <path
              fill="url(#linearGradient17941)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1208.14 1467.48c-6.46 1.7-12.89 3.45-19.3 5.24-7.46 115.23-56.87 201.71-59.67 206.55l-10.33 17.67-14-13.72c-1.8-1.76-27.09-26.78-57.91-68.18-3.55 15.77-6.87 31.57-9.99 47.45 56.04 114.08 36.17 241.25 35.18 247.25l-3.04 18.51-15.41-5.36c-1.67-.58-21.34-7.56-49.42-21.94-2.22 26.1-4.01 51.95-5.441 77.5 9.011 6.85 18.211 14.63 27.591 23.47 44.14 41.56 70.39 94.23 86 141.9-1.71-204.53 16.41-462.61 95.74-676.34m1530.52 612.76c2.17 170.99-10.94 314.22-18.32 380.06 10.6-14.84 22.76-29.09 36.71-42.22 34.3-32.31 66.41-50.58 94.29-60.47.56-9.18 1.1-18.67 1.61-28.35-6.2-18.51-12.82-36.84-19.84-54.98-37.65 10.43-64.51 13.22-66.48 13.43l-16.03 1.57.23-18.86c.06-3.99 1.26-60.74 23.04-127.03-11.16-21.4-22.9-42.45-35.21-63.15M995.805 2254.66a3506.78 3506.78 0 004.215 94.22c33.65 4.96 77.65 21.76 126.21 66.56-3.23-34.28-6.71-77.76-9.38-128.03-12.11-1.46-62.89-8.64-121.045-32.75m1495.565 248.83c-66.14 0-131.27 6.22-193.64 18.56-205.45 40.54-349.7 193.8-351.1 195.32l-21.02 22.7-21.04-22.67c-1.44-1.55-145.66-154.81-351.1-195.35-62.35-12.32-127.52-18.56-193.65-18.56-72.25 0-129.85 7.55-161.77 12.95 9.96 21.68 17.43 43.33 23.03 63.56 31.4-5.51 68.25-10.01 111.25-12.78 14.1-.91 28.02-1.35 41.7-1.35 229.63-.01 398.35 121.86 443.79 155.96 36.33 27.23 74.94 88.74 58.78 88.74-5.25 0-16.31-6.51-35.13-22.83-76.64-66.46-230.29-164.23-426.24-182.56-25.68-2.4-50.55-3.45-74.36-3.45-41.04 0-78.96 3.1-112.63 7.68a505.63 505.63 0 013.99 21.26c27.62-2.73 61.16-4.84 98.89-4.84h.7c64.4 0 127.8 6.05 188.34 18.01 188.81 37.25 325.29 180.18 326.6 181.64l79.18 85.62 79.19-85.62c1.11-1.16 137.15-144.25 326.6-181.64 60.56-11.96 123.95-18.01 188.34-18.01h.7c2.86 0 5.71.01 8.52.04 1.66-46.61 23.74-88.42 58.15-117.92-27.43-2.57-59.92-4.46-96.07-4.46m-1461.51 130.95l5.03 36.42 41.33-10c-8.1-3.89-16.26-8.11-24.41-12.71-7.62-4.29-14.94-8.87-21.95-13.71"
            ></path>
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M102.743 108.246c-2.703 2.344-8.124 5.793-15.036 6.44-6.913.646-12.143-1.496-12.143-1.496-1.098-.379.372 2.264 9.218 2.835 8.847.57 15.429-4.18 17.127-5.454 1.699-1.273 3.54-4.67.834-2.325"
        ></path>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M105.711 104.916c-.315-.617-.901 2.046-.546 2.258.353.213 1.164-1.05.546-2.258"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath17955)">
            <path
              fill="url(#linearGradient17961)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1549.96 1029.99c-37.1 32.34-76.88 68.85-119.3 110.05a389.365 389.365 0 01-24.47 64.46c52.97-53.28 102.13-99.49 147.33-139.49-.04-.1-.08-.2-.13-.3-1.99-4.6-4.11-15.56-3.43-34.72m793.47 37.58c-4.91 9.11-12.98 14.43-21.69 14.43-1.97 0-3.97-.27-5.97-.83 45.63 41.11 95.07 88.34 148.24 142.59 208.14 212.43 247.56 622.56 245.42 919.43.01 0 .02 0 .03-.01-1.06 148.23-12.49 268.24-18.45 321.3a194.964 194.964 0 0126.88-.7c.81-1.16 1.63-2.32 2.45-3.48 7.38-65.84 20.49-209.07 18.32-380.06-3.01-237.44-35.49-528.39-153.68-739.93-33.51-28.95-78.97-77.31-109.86-146.08-46.78-47.4-90.71-89.44-131.69-126.66m-1045.91 275.82c-22.15 18.71-38.33 28.48-40.26 29.63l-11.79 6.95c-13.75 28.12-26.14 57.35-37.33 87.51-79.33 213.73-97.45 471.81-95.74 676.34 21.65 66.11 22.83 122.62 22.89 126.6l.25 18.86-16.07-1.57c-.3-.04-1.19-.13-2.62-.3 2.67 50.27 6.15 93.75 9.38 128.03.94.87 1.89 1.75 2.83 2.64 10.96 10.32 20.81 21.33 29.68 32.77-17.45-164.18-63.39-758.79 138.78-1107.46m62.32 1131.46c-81.59 0-144.65 9.28-175.38 14.9 4.98 8.83 9.5 17.77 13.59 26.69 31.92-5.4 89.52-12.95 161.77-12.95 66.13 0 131.3 6.24 193.65 18.56 205.44 40.54 349.66 193.8 351.1 195.35l21.04 22.67 21.02-22.7c1.4-1.52 145.65-154.78 351.1-195.32 62.37-12.34 127.5-18.56 193.64-18.56 36.15 0 68.64 1.89 96.07 4.46a178.9 178.9 0 0114.78-11.38l-11.41-17.09c-28.32-2.67-61.92-4.62-99.41-4.63-58.55 0-126.63 4.78-199.18 19.1-217.65 42.93-366.58 204-366.58 204l-.02-.02c-.02.01-.02.02-.02.02s-148.92-161.07-366.59-204c-72.53-14.32-140.63-19.09-199.17-19.1m1246.52 6.21c2.37 2.75 4.76 5.51 7.16 8.3 3.67-2.15 7.44-4.19 11.28-6.1-5.8-.75-11.95-1.49-18.44-2.2"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath17971)">
            <path
              fill="url(#linearGradient17977)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2133.23 982.781c-7.51 9.629-20.24 27.019-31.83 42.799-40.28 54.95-71.14 95.79-94.94 123.35h301.2l380.89 657.56-.87 5.3-14.8-2.44 14.8 2.44-.55 3.36-.44 2.71-218.03 376.18c83.67-7.49 164.34-24.87 240.77-50.85 2.14-296.87-37.28-707-245.42-919.43-53.17-54.25-102.61-101.48-148.24-142.59-.16-.05-.32-.09-.49-.14-12.9-3.92-40.21-19.56-83.7-44.74-30.34-17.59-78.63-45.571-98.35-53.509m-368.25 0c-19.72 7.938-68.02 35.919-98.37 53.509-43.47 25.18-70.77 40.82-83.67 44.74-2.18.66-4.35.98-6.48.98-9.5 0-18.22-6.33-22.94-17-45.2 40-94.36 86.21-147.33 139.49-10.47 21.64-22.35 41.15-34.71 58.54a929.388 929.388 0 0017.4 153.55l156.78-270.52 9.57 2.86h221.21l-15.56-23.31c5.68 6.37 12.65 14.29 20.54 23.31h110.33c-23.8-27.56-54.66-68.4-94.94-123.35-11.58-15.8-24.33-33.17-31.83-42.799m-467.37 360.539a.55.55 0 00-.09.07c-202.17 348.67-156.23 943.28-138.78 1107.46.01.02.03.05.05.07-17.44-164.08-63.42-758.88 138.82-1107.6m1193.81 1131.53h-.02c37.49.01 71.09 1.96 99.41 4.63v-.01c-28.33-2.66-61.9-4.62-99.39-4.62m-1131.56 0h-.02c58.54.01 126.64 4.78 199.17 19.1 217.67 42.93 366.59 204 366.59 204s0-.01.02-.02c-2.06-2.22-150.41-161.34-366.56-203.98-72.55-14.32-140.65-19.1-199.2-19.1m1246.49 6.2l.01.01c6.49.71 12.64 1.45 18.44 2.2h.01c-5.81-.75-11.96-1.49-18.46-2.21"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath17987)">
            <path
              fill="url(#linearGradient17993)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2709.46 2143.18c-.01.01-.02.01-.03.01-1.07 148.22-12.5 268.23-18.47 321.29h.05c5.96-53.06 17.39-173.07 18.45-321.3m-218.09 331.67c-58.55 0-126.63 4.78-199.19 19.1-216.14 42.64-364.51 201.76-366.56 203.98l.02.02s148.93-161.07 366.58-204c72.55-14.32 140.63-19.1 199.18-19.1h-.03m-1131.55 0c-81.58 0-144.62 9.27-175.37 14.89l.01.01c30.73-5.62 93.79-14.9 175.38-14.9h-.02"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath18003)">
            <path
              fill="url(#linearGradient18009)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1371.48 1263.04c-25.15 35.4-52.32 62.06-73.87 80.28-202.24 348.72-156.26 943.52-138.82 1107.6 9.69 12.52 18.2 25.57 25.66 38.82 30.75-5.62 93.79-14.89 175.37-14.89h.04c58.55 0 126.65 4.78 199.2 19.1 216.15 42.64 364.5 201.76 366.56 203.98 2.05-2.22 150.42-161.34 366.56-203.98 72.56-14.32 140.64-19.1 199.19-19.1h.05c37.49 0 71.06 1.96 99.39 4.62l-46.03-68.97c14.33 16.08 36.9 42.01 61.57 70.55 6.5.72 12.65 1.46 18.46 2.21 20.08-9.98 42.44-16.52 66.15-18.78 5.97-53.06 17.4-173.07 18.47-321.29-76.43 25.98-157.1 43.36-240.77 50.85l-161.24 278.22-34.7.87h-693.24l-35.04-.17-379.68-655.21-.95-6.25-.79-5.21 225.86-389.7a929.388 929.388 0 01-17.4-153.55"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath18019)">
            <path
              fill="url(#linearGradient119688)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1760.88 1125.62l15.56 23.31h4.98c-7.89-9.02-14.86-16.94-20.54-23.31"
            ></path>
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M107.098 157.675c-1.549-1.21-1.266-4.613-1.281-5.574v.922c0-.149-.01-.307-.01-.341v-.58c-.002.275-.022.712-.086 1.217 0 0-.452 3.413-1.271 4.12-1.559 1.365-5.116 1.354-5.104 1.344.003-.002.124-.004.4.002 6.008.128 6.008 5.992 6.06 7.916v-.969c.006.07.01.128.01.163v.806c.128-4.554.115-7.434 5.357-7.819 1.735-.133-2.265.201-4.075-1.207"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23159)">
            <path
              fill="url(#linearGradient23167)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1561.42 1178.93h-.12l-.06.1 58.06 100.18-57.88-100.28m-366.1 631.45l-.08.14 1.21 2.08 29.91-.15-31.04-2.07m1189.07 8.02l-1.23.01-40.6 70.31 14.11-22.52-.12.22 27.84-48.02"
            ></path>
          </g>
        </g>
        <path
          fill="#422027"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M132.074 142.761l.522-.086-.02-.119-.015-.095-13.38-23.086-1.224-.03H93.5l-1.236.005-13.394 23.115-.034.22-.028.184 13.499 23.291.337-.1h26.544l13.437-23.198-.03-.187-.523.086-.458-.265-13.189 22.769.458.265V165H92.491l-.086.027.152.507.457-.266L79.818 142.5l-.458.266.523.08.004-.023 12.99-22.416.626-.003h24.44l.62.015 12.985 22.406.004.023.522-.086-.458-.265.458.265"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23179)">
            <g transform="matrix(807.2 0 0 553.2 1583.9 1402.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKgAAABzCAYAAAAMsklYAAAABHNCSVQICAgIfAhkiAAAAblJREFUeJzt0ktOwzAAQEGHoyDufzOuELNIP6JxCxvEW8wsWtV2Esd92+fH+xxjjHF8HvZtnOyX77kYu07NxXV/7fLIuZh6NTZ/ue72e/GcObbTuocjOca273OrPezjfHa39dt57HGfq79l9Y7zydrTva97vi7e7pvYLxs67nUff/Y+3/bxQyOP5/n2cjX8M4GSJlDSBEqaQEkTKGkCJU2gpAmUNIGSJlDSBEqaQEkTKGkCJU2gpAmUNIGSJlDSBEqaQEkTKGkCJU2gpAmUNIGSJlDSBEqaQEkTKGkCJU2gpAmUNIGSJlDSBEqaQEkTKGkCJU2gpAmUNIGSJlDSBEqaQEkTKGkCJU2gpAmUNIGSJlDSBEqaQEkTKGkCJU2gpAmUNIGSJlDSBEqaQEkTKGkCJU2gpAmUNIGSJlDSBEqaQEkTKGkCJU2gpAmUNIGSJlDSBEqaQEkTKGkCJU2gpAmUNIGSJlDSBEqaQEkTKGkCJU2gpAmUNIGSJlDSBEqaQEkTKGkCJU2gpAmUNIGSJlDSBEqaQEkTKGkCJU2gpAmUNIGSJlDSBEqaQEkTKGkCJU2gpAmUNIGS9gXiojHpUOBw1wAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23191)">
            <g transform="matrix(740.2 0 0 236.2 1554.9 2213.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,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"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23203)">
            <g transform="matrix(759.2 0 0 29.2002 1544.9 2434.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJ4AAAAGCAYAAAAysCdVAAAABHNCSVQICAgIfAhkiAAAADpJREFUSInt1UERADAIA0HCoKMGKqr+VVAX5MGtgntkJnrndgDDSu4CrFQKpod5lRwtDNIdgJ0YHiw+tB8CvWieU8wAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23215)">
            <g transform="matrix(337.2 0 0 548.2 1837.9 1402.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAByCAYAAADuxac/AAAABHNCSVQICAgIfAhkiAAAAPtJREFUeJzt0DERgDAAwMBSG13xrwwPVEAvMwz/CnK5nnW/g8P8OuCvjAnGBGOCMcGYYEwwJhgTjAnGBGOCMcGYYEwwJhgTjAnGBGOCMcGYYEwwJhgTjAnGBGOCMcGYYEwwJhgTjAnGBGOCMcGYYEwwJhgTjAnGBGOCMcGYYEwwJhgTjAnGBGOCMcGYYEwwJhgTjAnGBGOCMcGYYEwwJhgTjAnGBGOCMcGYYEwwJhgTjAnGBGOCMcGYYEwwJhgTjAnGBGOCMcGYYEwwJhgTjAnGBGOCMcGYYEwwJhgTjAnGBGOCMcGYYEwwJhgTjAnGBGOCMcGYYEwwJhgTNg95Aw7Ajlc4AAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23227)">
            <g transform="matrix(58.2 0 0 73.2 1578.9 1589.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAPCAYAAADQ4S5JAAAABHNCSVQICAgIfAhkiAAAAClJREFUKJFjfG8h/5/hLwMEMDLAwf+/SBwY+MfAwIQpih+MahjVMGAaAK7lBlzxkuyEAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23239)">
            <g transform="matrix(692.2 0 0 217.2 1578.9 2232.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJAAAAAtCAYAAABBEuITAAAABHNCSVQICAgIfAhkiAAADBFJREFUeJzVXNt27DoKLNT9EfOL8/3zdk7azIOFVCDwJZ2dnbBWVtq2LkggKJBs+d9//6PYBNjgSP8VQP29tNw/WOklAARQauAjtKf9cezjo43ng/4Vd0MVnQ8uJL6cPYr8qgAvHpP9l3UczJ81+5KVvy3Usfbi2BQ5P7+YnuWTZqOnAW5rMXms9/S13oP4pgAAH0W5OPHlA2uw338oYAIx5U14dtW6vqbl3qE4Xu3XX93PX6YnHpqvvowEQFSYTFlMKLy6Pui3kCJc6Xr0KcCmkAboVUE0fymq0Gy8LSinyhQ6MHXX9LjiO5bPnlfPfiHtFqgpIGFGMsX4Dmrwrg/IFbzFG9016ZkEv4DeUYIG5xpFCoX+JbRboNc6AIkrEoBmyy4KMsCSce9xZ8bvKoHsitOUlK+3sSVuj3kusNJowp5HV5e5wdjmCcuXy/5g2i3QQ/OJjpQoVV2O7itSiyaPdSmnrsn6VUx3dtVCDndqnRYue7Fo6t2uVc8WVlJuV2ZXc/LBw5bdCrn2fhGwfkorQO8jrGQgB70PwM3UJrlwHXY6wF2iq06eKd+GHvSFyG8vOfv8Csqa+0wXB25QRH+NEk0LFFdg4tacEtgAX0CUuDx8CKtarXouNGr7Mmx12DptsrorAGj9t2w9bM6sCDXex+FwiLWbRY5VhBmvYzmzMow1EyX6LYpjVEdhLYyuWl3RRTyw4AkRgbKCbtiV51C4vVlFV+bAgOgEpPYsU/pZITBq95J8jZWVzKKF5u7SCQD/TdYH6BZIhiAmpWjHgc+9hGZCY8xidChcfC6yOYy42uTFQbI1GTqKR4N2xdpUlMzpaDO2cTXV8APpWU7Iw2JNwhlnSnCXYjQkWuSVurXiSC7FRdScap24G1aT0hcjBcA5KsNjDIh/h2C/iygK++TEMC7aaldiwh2CBRLhSrIaD0D+sEACoPV+e6P6mdj6Bun03cJs9Hv6kjUTDfgkqsrEWcGzWmT2093ZEw/k0VVGbAF4z2cp15/z4DuOEQjUKjsLxKA8kHDfN5U9YrQstLZfBOo1lpMuZacsZJ0Xhm9SokT7v5+tSPVemAlMSdj/HOdF1Ca1UioA2KbXSC3LKR1MpOWfVCGd/5GjGZ1qUCpT3IsWKsNqGdh2mX1SvCzVYHiJq/ytnYCb9Ny3Mdoaxn+IN7dAHnaXIFp8ctIp1QFiji5RYt1efYkSlXj5DCJvcKbE+hhRnv1Jbi2GwsQEYiRZFe4Cqz81OistkLDLAIBN8nE+5nPpFiiNzNYeLrtEaZjKvO0C3DPWR4oSXI5RE1rdhKMeANB2warVjuAmA9NF4pKVJIsWxTBSETiEYfxUqkF0NqgnrVArvwh82RPot/sKZtOeRkjmajCz3JvMhJ+VYwBtymXjIDCbWsgMx3wkgs8qtrCwqrTAu8RuVno/P9CtPcujEeZKLLQVvQe2Naz+1LLIHpUBUwmuThJbr76VsVLz2GflACvKtnqd/7j3taUgKFzrjg3J5ahN8pgHUsDR5A82NQXRcY4QXmYCp1tqAjTweaIsM6HHuZyLro7yNkMfFkyV2/oB8kmB0iQdy9Xmo+RPnHIsSUPp1qKI+NK+JZR5dWYYfP9ABXtG7DhomPnOeDwKumABComTU35VxCUw10TR3mcjEpH12MhQlpOjh5WlYkWx7ZN434TtG3T3xjizLaKLyiFt5bH0tt9E6VaG6tHqCzRANN27Wpfgkhmm49CezARDLeka95JZZjRoCmp1H0BjzSZXMv4XUvmyKCi0o8S3WR22SLagBqtHbvmor6/Xtme1qekTd9gF8iArY/Kp8NOGNSSPAmBlsUlZMAfxojShab/BDauOpCbHkGmUSPplF8uREQAqxAPXjSc6t3BvwThs2QJwZwt85AZTXT9Skipy/Dx1DBS62aJiHKxKy/mw4JOEY12X6OoKF5lucqxOxXJiMgrVaAQIALRfbD1KnJXJMgTFtOejkZzH/GxSUi8qoFK6wCyR5ruzcYi6pAxWgP+V9MyOX5SUHQUtXU4wnSPvwfXj4AowPHDRXQDOfZxMnAqWxCm30ZV0nuuhx0tkVXctzfSKHl6Vaeq6Khf1rru9Nm8zCnNRLFkUS/0LbihaXM0RFde0WxYru+0LPjsyulQsysQo7A6OWY7D4vocVG+exFSIJFZJ5LifMuudeYqoYIJVFrHOFQXdqTxUnxKf8zGs+pDlPPXiStQ0MLEsrpzeyAMh5H8IoxlmA6Z1GKu3cMeEfeqcDE8+JdBS5aV+UhxTtZ9YOKOlylpIUOwYHPZ9VcnW+j0THdrcdIaMo/zVLQrsisb4Zttxlet8kwubqW0v3hKQmc6wzH+8CexIIUOpdJRbc0OSuoyxSbupV8oyUen71gVD2U+r39aqlpQVITlV2KsPaxQ7CBiIr+Wh9mRqqVB7vae0G4phWwtO2WRt+zQU7w3EqAlIjsMCejEDLk13oyCYCnx49KPAXOOx8Wk8oh7bxdB6Bb0soCNAzovDfiC34sq2Imk35rZGw67Tjgu3ovxehjAQFwo+2Oq8s+cTz/7cPcQWo5TYZswDKd33N5JVKbQHR7Mfxys4AdvEFFuV0Z2sY64A8VCYzV+7tjOsRIA/a3d2QO1yX5G/4+s9E31rk8463Pwl8xXDc9mAV3wn+gT0onfRkLSP/KD9UXtK1mQRIkgQF9pV2V8UYEUeC5kt3xHeuci3c8tcoFp8BMQBVOF/vrDY1B6DZ6ODjytQZeOpmf8/bjSluPkJOJw1hHFbmYmXByDBhUxsU0x4FIpzD8HqqbrTAtKFtL5YeARSwxN+YyUGrr4gDfdo7vsYgqtZFPyQt6pMFoW1DgxZETcFXjYqVn3urLl/3PfyxumGC4C5XvnCC4N5HO3HFXOfRn6GDeUh9kqsmLMWxQoe+txhg6BYNAfjie+WOT7MBe8PbJHq1ROX1mgK9jMFqmhMJCmXi1q7NXrnTQ0SlvSPBY0MOG+FnGEvy6VkIXqWhGTLskWhHwFZwKcDkJdXyV/CdJFkJqBQxjNQ98dkm+OZBVuqB5wV+Sl5mA3tGCh8EUME1z+fklFT73s5220YBki2PN6zIuv76H+ALEZuwapE1tOXA0LBCPTPQvSGFdQuUxaAe2UJXZUWlCht2Ffvj2sLlNEApDQRfNzUnn31Cb3sY1evMJr41QzgNpCNH04Y2GRsJqP4KFY22ZIIJTLI1dXr1sKuJK46s37tIFKUuro74Rn5LKwsgOd+xkVCY6AjD20+e8Nd2eanmxhOHwz+STGNss/KsWLcPWYxdvcxlfPqBvC7JMnv5fsCZ26Mrl212kWmOu5c9tF8HoHoN0koulJbqS0R+Bef550Z4d4nmh94PwYyF2Kb5T/jKjUIiy4kiaKUF0f8LgDW8it9gkc7ARAjMNdXdIFS8EFMu+a8pXnOlwDd/akYOltQ+8jmp3bFr5E81eVplME085ieTf5iMhj3CPeMFyeUT/Ai8cdBGwIP/q38K1iuJnP+ODKM9c6YqgLbkNB82wKlNN6m4Ht7StwNNx7vBG7iJ+mL7qbwnHXvGkGH5Y6TitWCCSu5AreXGCOXz9VPm7iqyBmQj9dCLrEYs5oCRcAl4j9AYHTyLcURKX7gOCT+CqKz09KFp3y+exz699XkcTfCLMbBK/ESBjOsF/ydwr8kaVajt3lsm2L4NyZk5S1l8Uw+5+O6t5n6DjWsn9GLB+DtkqKheQCL6MoeWpy4t3SZ+mvZPfvNZ62xzr9TtAKoCrIQrEdXRWTlftPm58mYJUHWyhboAp1vZRAGSldv9oEE6UCOB7zxptZf+FiyYCqeC9c72OUcUsc8cW/RnyTMqACeo7GrvCZ9SHE/KyisjKZM2Uo6iPzi102WtMC+Qp5okpwHio3/GeIPVo1TDXHPNUt9NPXW28rEjVeoB5Td4klwP+srzH9AwU0g63mO3EuGPVDWBUfLvRhVRUtcQQta/EiKFKH9/lpPcKVq+zSAP+8jsuxLqQOf3W9ne1cv+A93Kn7kq7o75a9n71MflS0pvtk8rUcxNG4zNMn1dVk4kgs3U8hTOjIO9wzH/lrPH8NAF3z+cp2d3I/txNm9yX8oLqL76zouo44JbpkNi4bcsZNvwJDfTguAS0v9H68qTocrjs/HAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23251)">
            <g transform="matrix(706.2 0 0 29.2002 1573.9 2434.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJMAAAAGCAYAAADHTqzlAAAABHNCSVQICAgIfAhkiAAAAZZJREFUSIntVsGihCAIZKr/2Pv+/+l9XLzDig4IVnteLpnACDqN4e/1VmnWBzRWxTQXx2cfIbwTDs8VmJy3rOnLOtf59+JKf5J/F4tzsz14UhPX8qT+k9/aXuZragxr+SLHxk6X1ABR+BX9fe8+jjBLCFZgIjQR89B81oMbJ5iqyGO5FvPBx6kW61Q4SPwBw+IRx5S7U67ZSZi3agJha7FmmNtlnKfgQ66+Jp2L7aiKCHSQa5dAplHSYGpKMBEB1PuIpnA5a4K5JhvmOAwQUaXn5OuMZ98sqJszzGxjJxwkcwnBsgPqfhD2A3JGcjPBrH/uveon+0gM5yqXyXW2fYRI35jR7+DEYYV+Jq4O3hNMqaWVgg2USsGYxJSLObpSr+zLtac/4Jmw1cFORHmoXl45kzi9Vgz/seWE4P7ZVjh3PhCzTLUMk8m1JTX87Gdf2bFhaIG/qkwBVmp18b8l/qqZ17B4bXjM7ntqVV2FUalcToFXXYX1f1qCrWuFidfgKrdaO16hu8xKZXalOoyTqW2Wm12BIiL/tT84uvUuxbIAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23263)">
            <path
              fill="url(#linearGradient23271)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2287.71 1178.93h-310.19c-1.44 1.25-2.85 2.41-4.21 3.49h277.77l-122.97 206.83h-403.78l-123.91-206.83h324.48c-1.36-1.08-2.76-2.24-4.21-3.49h-359.27l57.88 100.28 75.08 129.52h461.12l132.21-229.8"
            ></path>
          </g>
        </g>
        <path
          fill="#2e1e21"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M118.874 165.53h-10.786a7.758 7.758 0 00-.545-.53h10.943l.15.261.042-.074.196.343m-13.881 0H92.558l.306-.53h12.674c-.166.145-.347.321-.545.53"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23283)">
            <g transform="matrix(481.2 0 0 15.2 1683.9 1402.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAADCAYAAABlE6q2AAAABHNCSVQICAgIfAhkiAAAAFtJREFUOI1j3Kug9v8/AwTAaGwAWe4fXIARpxoEmxHO/oemHhv49x+hBpt7/kPN+IfDXgRgRHXPf3xuRNWHbj6mG4kz6z+afzHM/I/QB6OZ8Ng7CgYAjEbIIAMAAvAf68xDq+YAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23295)">
            <g transform="matrix(663.2 0 0 222.2 1592.9 1176.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIoAAAAuCAYAAAD3CoGcAAAABHNCSVQICAgIfAhkiAAAAPpJREFUeJzt0slxw0AMRUHAkfjk/ANwbIQvVJnDRfoBdF9UpIaz1evf75+pqaqqmq6LOfy+/p594BzG9WX8dbI5Pff+bqqXdY7zLd8dNniea13n5iA387+fY93p9mbs03ezP3Tv9zVT3V0z/7f5dIef9ndnq6qv5U3Xdnvi9X6OZ5up6q7aTouv88IDoRARChGhEBEKEaEQEQoRoRARChGhEBEKEaEQEQoRoRARChGhEBEKEaEQEQoRoRARChGhEBEKEaEQEQoRoRARChGhEBEKEaEQEQoRoRARChGhEBEKEaEQEQoRoRARChGhEBEKEaEQEQoRoRARCpE/5kItSa4ANDQAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23307)">
            <g transform="matrix(490.2 0 0 644.2 1189.9 1805.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGYAAACGCAYAAAAvm//gAAAABHNCSVQICAgIfAhkiAAADXJJREFUeJzVXVuS66oOxa6exJ3amf8Izv8O96PtBLAea0miex9VdXWCQcII9EKQ499//tebBK/l+9la+/Os1l/H94fDaKuWDY2O/ixb246P/jzrdelNJHx/zpmmSlco60JZa60L/XHf2ah3ilQkkIiMILMXB+WFHzRMOgAOimZf/v8c4IxBwBo45N36gbV3mUMwqB8Og36HORRjej9aR2a2trrcGa/U60t5Vx5MsoxkEAqv/v23GXTGGIMIMcgSfQyDtEe9XX3o0oPPnyTTSVoibGbO6Q6SOTiG6Gntmzkegzxw6vgruF/9qNBhC2xcPV/vTzd+qf8e7a60uwFhTkLqQOL1ZhCEkOzAq19jUCc6n6IsKoLY2bYDN1xv1EfGC0MMX/AWgaxjXs4sjIg+1/oBYAeDWmvfzFGsL7bfE9PjYFplppKPmsbeiyLipsB4kPuzmn9rPQDfu35PSZCv90AYLMJk+Nro+q81RZjjGfOebkPr3P05VmYM3y/9cY/Fsda16DewDwN8Xt2zoDRAIgJR3VG1euAVZonvWUTRk5VcPc85GRFRUaYiND19N+IoqYNGAgiHe2wK6h8+JBP1W9IOJeLUFvoqpk4ZkXTfn3s09w2EkOcfNo2LHEqTQa+jmEHIwzskBOCbmusMOt1ZGBFtljio1AlWhxgGIXWg/tyhIKTuALeUGeicrYFiIrRCHAa57Z1n4vO+PAQIoe/GMoiBxZWaRBmtzC4k/gpQcKJWV/h5v2hLzCIYJ9GkHFget6hjVOZURIwlnBmLDqE9vU8XPvdYQBJlTucH5yw3jSPRAA9vWOeMOMDQysQgYFUxRgQRrjlNutWmMfAS4TCQRXeqgzOot3G/Jzszbjggf+YjyrSXzpjGSQaZuCN0p3oYg3pbxaDCKDpsdZjMwT1/yzS2IDHRQsbISBdlkIvqEBi0ErnMZKq/1+q5425Hf3+uScbwZp+1EqOMQ42GIuZ8o1IjsvNneqtgwXF0kjGU9VOJ13hWuU2AAOrHRHyZobpulYV3Mg1TO5ObZtFkVk8Fgxg8bCTgwv31/tLac8/A2xexlLu2eKSsSgaQFYvulWRBGzerLthoHnJtJkScwKh4+gmfRXwfgSizEmkn2X5ReS2wSy9IP2wSI89bM5hzNX61K8NltbIWkxiNCoTEqTxApPJPRIw1lLsdSnWwBuQiHsFfQZmTYpBnLlvKvTpBozmrx2zo4y6Jxz0ILqts1WupHLbuZGJGrC+vE8YghoKnI24PrBSy1/E5UmLi0AKibXIQKRAmDpaMoUYDgqZxROxlze0Rj4UCZY5V733WZ9RNwOwa3pHLxGRhR6Azk5UDArV6tHrToaiBOYjT+Rpzl5cHIkgmOGKWM/iQZ1WiDcGBSGxWBAr5aiucZT5KZqaG/J2ClFsEdvuq0ybah9gc9p8aAC8u6h2NvhMpjjJ2Y3R7wlHhV5n1ZivP9/wjMzNieXn4vFBM0Fl99wc1HCyrC51cQD1ZxzAWmEW8NVFG23lhzY7NZWNsx4f+nX/8YI5HQ2LO6/i0S68e2vMXyjKmsfYsuv9PGgVmxMFqH7UoCYilyLIMioZVIjir/J2MTunL3wjjbqUBX2qo3BMbmVmr4WLFlNVHlDkZww7FcZvHd72VOcLKHawyQYEWLs2UZbPDmkPaFyrzdz2puLdHZtNT+UuDQCpd83BPeHUcvkXE9gWmTdZLrMKbObiOsWaVSiSx3yK2iTuVkB9VBVHjYQAu7K8pVoNY6HCPWye+L7TFydVwJZ7ryRhW452prBV4KtprgB7vQOkotE6vQsg81vCwODxTOkLTw6uZuQ/6t1NaELMT6GHJGM0oZ+pW+0CV5z6l7x68Dn5l9uH/2nYow0MyLFiWXERENgUfevRcA09stdba6SmuBE2pbS8IyaSSKcQ2Qctpp95D9ApIAzWE+PMxjr9A4VLrxxI+tltcCHMAGoilamdikuWhY4Jm2IdXqq5DmWUO4mwTq0fr56xjNEZkzu6vOFbhGY4E2G3C6VAo7WbTh1Ep/cxnYrLtK8P5UfFUlXDi0U/klslWGQOsGGwtNjDeBpoG2spCrDl0ZSDMQSL1Qx36slITuWL60T6QtXIy2wpRnFXug/d8yisjnb4fCwZWO5boBKmaYBpuBF7InZjKUixRrt55lojjFhU7r6UvUacRoQ8MnXw41iIcBVMPxM1ikU4qgJmMfWVW5QB7zscEtgciAxJ2KKHBCyRqILTBekWnlpXyCIMY/A3zokW6qVWVaA+2O9Vfd9C2mK1ZyPohDHhxxMjJg7TYs9uriem9uW2v/RidOSEGocCIQY+uB+O1U0g/JHqBd3ZPDriizBiQUGIcCpFVFlm1XlsLCk6kwUc7LpDPxyj+C94LqSwQMc4kEVadYGBoVvlwrUL50weTKrcH2lPUjN+joZ+xXdSfiT6/4Oyv1jpqObEzW/WiOdOYvrfTHRxAb2Yi6t7qAXC8Vwyl6CMMQkELAmRuYhIRJp3ICofbwPGILlOKPts5LWJshC22MCeapYmGYRAcC9T+RlmgA2VOqEXDbZdPPxonzHTeJtinPYyJmNcVYvCuHxmMjCd/tRWZg+AWnp+6zBDKpMFjFXyVWYm8LKob0edA3arrV+5f6uSQVTEIBVYMRumMbTQjREvyKzYIMFHGeOfJzsHGx2raepECpr4D5bl0Ao78MYxkB8TiSIwuAtkwy8ad3C8zyaESNBM4YhpTYlAwiW+0XugGGJtwLt343uP7XM/OdwdQpI8y0imtMo1ZkPqJjGlG7I3vJUUmjPjcx8Fc03mYBD3rgO1Y9/5ekUAYce4s5ni0sycLEBoDKNHlY/5uEZvKNm0PoGbmOkPRuNZvgzBuWMJfBXNQ0FaClaBnWWwMzQykj4PMUiefiZkAK6naZVAGsoO4E/fFIPsMZhQIB2x7AqEXBrLgaHLqL9Kn5Pb4cAZzzegTEDCXNJDlrtOGgBcGIj32yF49DE775QwmOPBMiIUtrwAtgGj5LQZz9iUX6u2Ja7HW7wXMQUHTN5bJzER3pXpMSrD33gF7aK/yD/kaRn2PQRWwU+cS4/AzG2VdmXHaUs6c/49C1ORmxJm1spZnp3oiNxOqN/LTShlkAetojm0sqDqNZtHvXsIfwhxrUDWFWhKcJOsQs9WFe6xSil/QgYP16F+IDVtqSkcN87gcvEFmmeCJtwhTx/HUmNM0HSNGgEHR9lOxJ9ZfkepBdFrtLuljdcgT9OeyZCRgRKAWl8syCIWI6HoZ/pTTB/vXMFbIOlNaOSoCVRzkoScBt2iYRN93bKcxx4HA78cs39mrsbIRAka/If1Zi6LMsXKeX/xpOdvBRD1uJaKqXh+ivexOU1QDgcm9H/HsSutcP8Ec5QwmEagUOrWKha3Xh1j9ucuKVtO29oLPVa/8d8x60QFuHCM8g4A2e8n6XrvFINizH4PCbelAzmLgyGF2sKv9Io2OAJ/9GOjHaRKEozN5qms4uztFz2rewtaig9N4PouyybRTLAk0fhUVNVL5oyyns8KHfnesDtWPWeHV2nSXeQWDmPJqMOhsPfS74iNxGsp/wbb7Go+dsA7M+FraaWJaPwHjQ0xSwCr7hVFFlG4koX3EmxFNVRGIFe8AxmWlI5EC7YoaDlIIgw3bVBkEFpgTJ8ighx/jzQILV3Tjy3sxsVxpt5sJGlSY5Eqdkp+Np5UoZDQYs26HaZzBGWGO06bspnI6LobS2BXOuekfTpnUhqFhJa2bfkyxCNgWFwuKK/ryhiZ8hwgR+D0cHdExKOz0vtErRJQ+hC5v0Lz9nem8Aw5BxxzD56UN4mhmGRQNbwB1y1azFxrKJmo0JOwvMAeyxJCOqalTSnsvZALUpZjj7vUbjikRipGc3HDYH7LE0LBNhEErrV3gzX72F5g0EdnmMU3tx8CzD45KB52yv7WN1t7AdUukL/jHa34LdnVLM40tk5kV1VJ7zyS/6g2ZmHNN6mbWvwQg4+TRiCxngL3f8xGSeSM6HjIPuqwGUfxoWXK/RzVOrLRW1JLsR4xhgYkBef4P5vTm3zOmDsAxi01taVvZJhpNrc9rfQsXAtU6SniHuPLPXGPF7H8g5RXOrUjjePosiClfwLiz73ghBDKbUz/d596e/d1syp+ttQYz5zcS8rLAMJtwCmn8d3Xw/uXhstKFQVpHVwX6SyuOssAYURcRSYEx8Jjz0DHfDCItMckqW9tJHvIdV/KAjX1RN3k4ddFBPxqdVmutHvwiOcicbD6DtFXogXGDenr1TH0ObgtLVmTCKPnCrx9KQBVzjHqpsL74vIg5Iy0C5bBilrX4X1T0fwsURBOEn8JamFO51/KgVYgrCxW5ZdG2Ql3sp7CsQzmaogeI/xqoFqcQctnlvK6wGFPxmzE0vfE+zHQ8I9ZK+MTE0z6m5ZToIYWGWFmu1Y9Ybx4pMlOz/hjGiE8zkRkLb+SFZIExYaEC2b8drne2f528CiTRljjSUcqcjafd3is9sNf1TMZ4f1YSDv4WqAy1MDBmkmoRkFWCa7pr/LwGMUXCk6I/TKI7Z1wpVDNH00NWxIAwLGI3lT9mixAa9zqlkUETG3bqRqbN1W49DJw9e/N/uIWLnV3wxpQAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23319)">
            <g transform="matrix(399.2 0 0 658.2 1170.9 1805.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,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"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23331)">
            <g transform="matrix(169.2 0 0 280.2 1458.9 1843.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAA6CAYAAAA6AOAKAAAABHNCSVQICAgIfAhkiAAAAoFJREFUWIW1WduNAyEMNCh1XCPXfz1XQdb3kbDBMH4BGSlKtIA9ix8Yp/z9/jCNuMrru3RDzzJNo3mlfNYvucDUS8qsQFw3u7w+q2DChBXYZG6hG4SIiJiIOxn374FsjExbuEikrYWEOtmPlMI2HtkoRRZru8xEdemNDV/gq+iO7eh63BN7NM+PG1Hqfb99KUC7sbu2OhCOK6Tw4PzocUdK/xZNBjuELnJ3zyQ04CMKLYrIuWh9B3s/4imaDEKeo++Y9C3bd9HV/LKAYAY+oClgTkxmxw88GLLtpOcRKjQ7efRwBLKrEJDMnGMJMK1LQu6MlVcMQtZ5kyGFjwMNWuFE+WwrnpeeTAbfCPVwntFIZHYzOLem7LoYJVF8zMSEz6IVszRCyWpVminp/a7pjhTkWdN5pgn7zAEhRPQilDXpJYvy8M4wg+S2c2MAhNI7s0xoPCBHQlwCSQ84JXNJR4ogRaQU5NkI6khtAayvYtAillW+dGrvKPB29SsXf0REG0MEgrsNycAw1hRFxiyILoQhwCyaTuL9IrK46u9IrYWilZZphy7y1gqgt0R2syusAMBVWiVzElpJQoRvrrTc9AjiWAkReRbFdgmh5Ytovolg8NHq9k8ySSyqWJFfiYwkFxUu+izrt0xhpjQhVSloZvcHsVIVTj6TIuTWvkaLH/b0duFdS6zmwIB4aHs4UGzpO6OldTPdK7+DqG6X6lTlhzDortNAsmEk5ymt+ggpQj5zIsMu+txeNPWh28qCiK8pJ/qZU5tpDmHNtEaeif/FE/GbzdNedjuzpA770NyfiQrKEkI9Y5NME26VDKv/6KJjY9DlZ2B1/BChTtd3a2ANyov+A8gIPtbUgAEwAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23343)">
            <g transform="matrix(20.2 0 0 20.2002 1544.9 2443.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAABHNCSVQICAgIfAhkiAAAABtJREFUCJlj3CWv9Z8BCbAwMaDwsQpAACOUBgDUtQQVXu5pXQAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23355)">
            <path
              fill="url(#linearGradient23363)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2290.37 1178.93h-.23l-132.36 231.1h-.34l230.76 399.65-5.04 8.73 1.23-.01 3.58-6.18 267.04.46 1.23-2.12-22.16-38.25-242.94 1.19-205.37-354.47 121.42-211.07-16.82-29.03"
            ></path>
          </g>
        </g>
        <path
          fill="#2e1e21"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M118.678 165.187l-.107-.186h.008l.594-1.024.103.179-.598 1.031m12.237-21.118l-.21-.001.782-1.35-.044-.074.298-.001-.826 1.426"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23375)">
            <g transform="matrix(251.2 0 0 423.2 2144.9 1402.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAABYCAYAAAC6TtTKAAAABHNCSVQICAgIfAhkiAAAAJ9JREFUeJztz7sNwkAUAEGgDfdAy+7U54TgZFsCZ4s0kzzdV9rnurzH42BM83T4sU0H4zB/+mtabNfbX13dfd14/xcE1QmqE1QnqE5QnaA6QXWC6gTVCaoTVCeoTlCdoDpBdYLqBNUJqhNUJ6hOUJ2gOkF1guoE1QmqE1QnqE5QnaA6QXWC6gTVCaoTVCeoTlCdoDpBdYLqBNUJqhNUtwNgmRCH8jcm9AAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23387)">
            <g transform="matrix(20.2002 0 0 24.2 2139.9 1407.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAFCAYAAABirU3bAAAABHNCSVQICAgIfAhkiAAAABdJREFUCJlj3Cmv9Z8BDhgZmBjQABkCAKcoAgwmKNNsAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23399)">
            <path
              fill="url(#linearGradient23407)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2290.14 1178.93h-2.43l-132.21 229.8h1.19l.75 1.3h.34l132.36-231.1"
            ></path>
          </g>
        </g>
        <path
          fill="#221b1c"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M118.635 165.261l-.15-.26h.086l.107.186-.043.074"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23419)">
            <g transform="matrix(20.2002 0 0 15.2 2144.9 1402.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAABHNCSVQICAgIfAhkiAAAABVJREFUCJljrJbU/c+ABJgY0ACGAABU3AHGjnnkZwAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23431)">
            <g transform="matrix(346.2 0 0 586.2 2303.9 1191.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAAB6CAYAAAAcXxXhAAAABHNCSVQICAgIfAhkiAAAArZJREFUeJzt3FGSgyAQBFBMcYq9wx5vr6/7kVLjBNPAgJGZ7k+zo+aVyAKa6e/ndwmFmUoL1rriIzU4prImLomNKPJ75tYu4g9LwKqPWVH3WhO1J6CpHQEsnn1AsGfikrkzr2CxdmdewJJNjGB7Tu9BNTvT1mhre4BlAeXurHWNtrYFWHytqf1nzDLY4QrSnLR2P3cF+9jECBZCnKcQHplt0yNYDCGEWVQQbE+yiRFsT1Y37xmsarrDE1iT6Q7LYF2mOyyBxTAlPm100DUjg8VkBcG2pJsYwbbkjeYdg9WN5h2BtRnNGwbrM5o3BFY0o+gRLM5i46PgRDyAvV1BBDsGNjHvYMWjeW9g6tG8dbDmo3lrYNndvFew+LrUccXDAKOBHYcaHda2Ue4O9nmoQbCybt4jmKqb9wDWtJu3CNa1m7cAFmex+ZF5Kl7AEqN5gr0mYzTvGyyG3JXDbYe+wGK6nGBrTpoYwdZkdvN+wQ7dfO7JewI7XEG1J28Z7GMTI1jhwqFHsKp3NdZ4AFMByVgEawokYwFsW5svGeXWZkSw7QrSTAvUZgSw0yZGsGey70Fewapv0l7AmvViVsG6dfNWwOL6LEzuY2m1GRVs7+ZFLcGeOe/mCRZCKOnmnYLFRWycMtupF7C3K4hgx8Am5h2s+G0fb2Dqt32sgzV/28caWPe3fUYHU/1+kAewpr8fZBGs6+8HWQC75o1DRf23wVTzQR7Amk6YWQTrunBoAawrkMyIYJcCyYwA9lUgmTuC3QpI5g5gtwaS+QbYUEAyV4ANDSTTA8wUkEwLMNNAMu7uQdq4uwdpkwK7Yv1t2CyBQDAEAiEQCIFACARCIBACgRAIhEAgBAIhEAiBQAgEQiAQAoEQCIRAIAQCIRAIgUAIBEIgEAKBEAiEQCAEAiEQCIFACARCIJB/tOkIbM9e9rQAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23443)">
            <g transform="matrix(461.2 0 0 582.2 2178.9 1200.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAAB5CAYAAADGQSRrAAAABHNCSVQICAgIfAhkiAAABylJREFUeJztnVuahCgMhYMfy5jH2f+2ZhUN82AhIZxErL5QGs5LdQmGyI9AEKvDf//8m0lRCuxvql82yvTFviciCuzzi51XlJW/NQETw3k2owDLrpb2zjlIG7jyiDKm0F9EZoUlCs33kl4+ZRpPL6Bax3pJV9GFanmSyMyvxbKrpb1zDlISqRtlitxZ7mgK/QmysCw+uS2tEaLjnoE0d4B0lIu34DOhvKlJrykBIPEEBHZB8mStqykqXZZ2h+x/B1jZWbjkDUgs3QwfIFDXw08M1PfzKdRjibRKCgMO+gJy3AG80ktFosGUG0T9+TEegDSZZ6zFPBtIlC1bniw/kVOy0kul8cqyYFkO9n49C0gzBmiVbjllSVbWcZwdDgPOPxmIegdIyUJQYFUGWlSoOi0Vdr0BGb4DUOBVA7N6EdkI0ojlbxzkeZ0BiZZhGRFb08xE+K44vr8MB3AreAYSUWuVc3xuTGv1TcFGZcsKRfIEJKIE7QR5zJpqErWVdZbX0pOBwLUgtCQhC+VTTTlmlLzIsZH0Mz0JCFwLwoOwvpRwBG6hveCzVj/i+IjuDMQchPuT2mgZGdT6+JFW7xGIOQifLSccDobz/JozV/I+EYg5CHNdiYrPKi4ZaZaeCAQ/EVNO5uJTTW31k9vT8nynUp8AJJqFMwPakgXvfkZAnDnoDUiUK5d7RCsCK2EgAyeLRvp4GdR5BnJ0QXKGI1u9Fd1KoRnPyBjiEYj5PEDO61EByKGz41aZ0kHrOCrjbkDM1VBuYHSKuRGusNHlDm9ALgViViH8+Nly9DuVbqXdGUiUfXvpetCJZwWYy9GvzyvLtu+m3QlIHYTFyqUWPI0UqvXxJU1bV0LnSxtPAxJHAyTrOBo7ztJGQnZpo+b9XtonAYnoRGnQAiSnmnzAlRFgqWT+1Di8cnkFYu6M0wzJNK3v11t9ZsfaXN6AqGtBZwtodndTXZatPlAw7yxvQNS1IG1tJxPRF/VTTU2y1fMKHntw8Wwg3R0gDWgLaPxY39X0lZbaA70RULYHIENjAC9EFloG3f0zvArNTWH9Vi3FW26YfACJqD8eafXye6Z+H5HW6pOIxze+QOIMCNsd3RriLVsa6dOqyWQt/CjyDKR7JixPvtL3W17ISrbkCcjwxixtTh8o1+0sOfelAuzyjcszPRkIfB5wpQfJFCjnTCGEo29Kh4Hd4mY8xUFvDp7pSUAu7I5ugyvpaM55Lym8isw1/VL34wyI+TxArt/wwhPlPlrmc9MQYLezgUmphefpQE53R/NINlOmHMKR8XD4Qt+1v+TdLkd7BnIyCLNu5DAk/uB9/gtONwaAVm856AlIlItsqKCmADnTYfP+lIm2wGdIxV7f6nvHfQJpd0dLx7hh0U8lbpd3S7nJJlwJ4LgWh/gAMvw8oLTuwwlwHaiCZbQcSIAFpjwBMfeGDrV6Esd1f7rvmoOegMRERCHswRSaVjatXhisZbQtH1VOEkeQhx6B7LOg18CKppXN3J4IzHSAQ8WRw4x1ybqHHoBEi1ALIjSG8DtirTGt1dsV4AtILC2ZdzV9q6cDglSzFE2lUqzVD6L8shNChjk8AanPA2TLFxUumeBoGcUQeOpJVEEcOR0CiWpjVaeavyePQNpp6Ctvafm81VsvbWgBnAwb0N1jOe8BSF2KeF0sWrvP1FbgVR2DNBxDWnkD0m9LydWU3ep7s9avLKJIuMh6k+bpQGJ3EcK18h39ttw7QneTZyARrc1bb8SPtXwQCQtD1kV4AhJRYi3wWqsvMGVsgX7EqT+3lRcgxyNJK3SyWr2E08QESqsfc1DP8yQg7DXVKrw7up6m/cZofSDTF4amtPV5s+4g8k/muTMQc3e0JqvPP+vrtQiayCeQKEPexIygrgepVLrVxaDFO+muRyDxvFjFmYE0FPme/QyCNyDKEzEcsQaQp+x4aO+jcg6eztqVbqU9D0is3UY/q5GVno/T+0GYB1hXly08A+k2ZmnLCbXF78WynYewdZ8Nvr+z2fV+QMyNWXj+bxRwfJYB18qrh+qa3Zp3NO3zgcAxAFVFzjgP6vuRHX6nJZayHV2YTyDD74hpavv+0d1vfAxp83sD8jYArY/Poqpqq99T9wq25sa+gHz7DrCcQMcSnCP5BfKjAFABRP1OCb5csSHvHQH5FQBS5rqS8MwbkD8BoBVe1NyezoBMASDlGchHAJDyBOQjAUg9GcgtAEg9CcgtAUjdGcgjAEjdCcgjAUh9MhAXAKQ+CYhLAFIzgSwAQH8JZAEY0G8CWQDe0E8CWQB+QN8BsgD8gq4AWQD+QO4i4U8XB/LuP4FY+iEtAJO1AEzWAjBZC8BkLQCTtQBM1gIwWQvAZC0Ak7UATNYCMFkLwGQtAJO1AEzWAjBZC8BkLQCTtQBM1gIwWQvAZC0Ak7UATNYCMFkLwGQtAJO1AEzWAjBZC8Bk/Q/cdBqnQD5h9wAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23455)">
            <g transform="matrix(351.2 0 0 582.2 2298.9 1195.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEkAAAB5CAYAAAB1CQxxAAAABHNCSVQICAgIfAhkiAAAArBJREFUeJzt3VFuwyAQRVG7Yh3dQDfU/S+k9IMkhomdvIwBw8y7f1El4h7FiIKjrr/fP3G5tS7t+mo4Npr2GkL+Ioof1kT7E6+vQNNeQ3j1Q6KlXiLJvKKFePtNVykA5AXt8UmK4jck2tbh7Ua0LXhO8oz20cSd5wkt1LpQy2hPnySiPff2diOaYk7yiBbi7a1W5Vt4QNsWk+ItiLZ1vJgk2iN8MekYTb+YdIQW7rP42WW8ZbTHJ6n23z6W0A5vN6JtwXOSZzT1xO0JrdougGW0ZrsAltC67QLMjHbZLsBMaMWcpBnWA1r1Y26LaM2PuS2gdT/mnhFNvZhMA5dZRTuF9DxwmRW0aivuvaygNVtx7zUrWrcVd6uxe6BdtuJuNXYLtJDP4ppVqQc0seI+v5S3iPZmxU20Zfl4xe0TLUTlYGlAH2ih1mBpHJtou7cb0cqgOck7muoPXG9oIa66c/K9we5ZQ0sTd4WHC/Ksoe1P3EQrwiZu52i6idsZWsi3BLRbnNbRik9SrX1ha2gvbzeipT6ak7yihbhE9Tm5F7SQv9gGJVrewS4A0fLAXQDfaMpdAF9oVZ4FsI5WZcUts4bWZMUtmx2ty4pbNhvaJStu2ehop87dvKBVPXezitb03M0KWtdzt1nRLj13mwXt9ENc6aLKrKFVf4grjVM2O1rzh7jSOGWzoXV/iCuNUzY62smvTfhAq/y1CZtoVZFkVtCaIslmReuKJJsF7VIk2ahoQyHJRkEbGkl2FdpUSLJeaFMjyVqhmUKS1UIzjSRr8hCX9Zo8xGW9w4e4rriYWbqjjfA/V4aPSEBEAiISEJGAiAREJCAiAREJiEhARAIiEhCRgIgERCQgIgERCYhIQEQCIhIQkYCIBEQkICIBEQmISEBEAiISEJGAiAREJCAiAf0DKkmyPTVJv6EAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23467)">
            <path
              fill="url(#linearGradient23475)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1561.24 1179.03l-13.58 23.43 124.58 216.57-172.94 298.53 161.49-251.8 32.94-57.03h.33l-74.76-129.52-58.06-100.18m-343.83 593.24l-20.81 35.91 254.08-14.82 1.44-2.25-11.83-17.74-222.88-1.1"
            ></path>
          </g>
        </g>
        <path
          fill="#3a2025"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M92.546 165.533L79.35 142.765l.644.037.734 1.267h-.053l11.676 20.15.027-.048.48.826-.312.536"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23487)">
            <g transform="matrix(53.2 0 0 73.2 1650.9 1402.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAPCAYAAAAyPTUwAAAABHNCSVQICAgIfAhkiAAAAB5JREFUKJFjfCSr+p8BD/iHxGbCpxAdjCoeVUwVxQBEZgM/hBdrzAAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23499)">
            <path
              fill="url(#linearGradient23507)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1619.3 1279.21l74.76 129.52h.32l-75.08-129.52"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23517)">
            <g transform="matrix(20.2 0 0 15.2 1683.9 1402.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAABHNCSVQICAgIfAhkiAAAABpJREFUCJljXCmn+f8/AwT8/8/AwMSABjAEANaUBPKhQe43AAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23529)">
            <g transform="matrix(471.2 0 0 587.2 1208.9 1195.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGIAAAB6CAYAAABEIIb4AAAABHNCSVQICAgIfAhkiAAAByNJREFUeJztXVu2KykIxVpnJP3R859YD6FP9cdNJcaggIBgqvda95HEUnSLIqhV/vn7rxMAAP78jeMEgPL4/y/y+2/5/O5s/sXKOD+/O08kLy2Y4o1ANY8kPZbmIFMXeK9I+5kLh/a1gqRKs9WncDxzp0rkSlDOP3/qEnp0JyDHkwBJ+p+P1D1SyFIbZaSeKcAfF5LjquqJfMfFq69qdK4lYZgWPjWt/ijJSwphX1kJeo6wxEj7vAZfANQoyELCJcdaIjAgBLhqhUwU0/TY8xfiiWiRpasSsBYzHxE3RAEtEZ7juiccR75Zq3+eCO3gGEWgMwmzWG81JdQgTKzVYuqJ4C4AWYtCpSwTmBWVekba535YuWPqbFUDzXNJIDV5seY8ABC7naKz1aOkQ04mkE36RgKnQSWDWdDCjAVktR2Jd1+TJYxIiFple6Nt7jVWE9aYhPaVcj5JWEmGdtLlrCOw/OyI6ElLzT9RjkAEWhN23Tqi29iTz/ca/RDk+SXgE+HVMJSG3AQ8Im7aOBjWx6xvDu2kLcWxCwnuIdRmOWUBisx2WrQtzQOeZTjxK7XADq7O1Xb9M2eRgU3U+OZuElIjPgjgYKUBvgE4/tGu93VqTB416Mw+ppH3dyF6onPE45BQACFCRUC9R3YkiSTPlbiqXmgRrMV7EmFilWgXZkk0IALjwJAXLtJPRterH3s857JjPBhrieh5YW+CVuHrz/J1xM3NzB6oJrGMt/0P4McXpMCJ0EZD2M8xZuUoDRSG8du00jQ/w1+xp1dZNFi3e5TtPmlP1lETlnl5XymjWaohs3hJ9ZlfsvnJUpzPE0M1rgZpp3loPvd+t0StjSvXG526WVeVN0c0n0s55wbC3bCAaNwNztA19grcw7T4MtRN4revqc5X42/ahECOc28Ev3WE1gDISgDzPJ5UfDURU7EKrVUVAectmtO+Jvt4ReMIZD7/LY7AGO9rDYX7fZd9sdQ6GFs6+UlyU3Cr7k/EDUmYqfJrZU1peVSDZo7aCUKrFOg5IpoATRaeE7lxx+gTEeXCKMgOhMvkZfqaynEOf49Eb+L+JILTuEcnt/p5j0Zg5P0kYTWa/iP1h76IUE7v5Th9bXlMI5ryw2BQtInVRDbCKMagLtwwLydg/s9xhM5bAup7q/wTIX4d0fOEtXEOTySJd3MQs4vDuoGyaIbCMZjvUhSJ63yD+YHCJb5ujrA0VTdv0BngETpNLhp8Qa9G0RmmelV1GZp2cU+vBNXffp6psNtjhY7A6WBRd5XOCBYx880cQCrQ7mviymg5LKFHcRiEHgDwbyfP9qsNNPSx04+5TwkgZjxvD1FiA+pGcw0m6pH6TqUasw29CTnzV8lRz0QjixwA+NnCBrbXBI18SysbhtqtuNJTO3LZg9WCrs4R+9rbNU7JgXzOOnG7uThYrnErdwV1v1OmibzTLLYawelsFvsTL+x08IwYomLfHzGb5guRp0+tcI1beAIsgPihZEPTAfjrzzSw1gDm0Jdt0saPbrVjfh696WPzIW18YiiLtZFBBi88Ojt+Yqh9l5wUVhqUpSN4oWri5py1cty0ImC0gQ1A5x5PikojFCRoei61Gn77TampgzKiJ+8lB1XKcQKcyqDMTENd3ayOW2QxYRu4bzALqehuI9bpSURIACmgTCPkWiFwNon2ntuYBACKCKvJEcv6qMKzWEN6EZCUNNnd4AYBlXKcYxe5VyNh79VORMj4dpoLbcONtsDUaQDezjSEnWHobTZIBGJoAnrIyDXLzCO4HrjVxNISW0HCkKQesqvkuGl2QLJ6+F8TpIVHwChhXZMoJgLMJf/FWEeEpCEtzczJddDU6xoU8Hf6tRc0VijFcd/TLAEPB+Vq7OlrGm3f0Vw7FHhWO/6+JgmoWMXG4BMRPVlqzlJsANrX5GnuUflSZc+SoC3XAX1f04oxXppm5piAtNwgfJqv3howyPvNNb6w3Ax4X1lPnciZPMDYxo4jb5dJgHmracbexnZP3JyAC/KV9XHi8Ym6ka39/1l3IBrC9u29WBRsF4THIyxI2Ll3jgjgRCIXiOGPyB13ybQ3kSj3RqyvSTuBe2L5yjqgUFV57U5x7Wq7RdB8ZzNZS6DZNS7dhCYlKdDoWPyu0kXlDIJRWcG7G3yXCjmYHqvueeqL3p7m761mrSs/5e8SyOG4n1eDT43guies3Qwzw4mkfMlr26jbK44Tzl9bDXkRwe5RpuXPaZRkEi4gI2H0s6OD0n6yflY6gd/DSoQFJ58M72tyPkvhkrFRGgMY3U4zuOC0vr1AeH2Ea6wC20UYOIev22AmgJgAjYmdYAQFsL5Krv08a4pK0kbtMLmSGQ3HMo3o7i0ykcUfXM1h1Md68v5hrRx3aegeNpB/rBEb+mzekGAS5mJ8X9OusOxAi8iUH93iIMpRyDE9uA17GQLWN7Z18B8T3Bbo3WKz9wAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23541)">
            <g transform="matrix(347.2 0 0 586.2 1208.9 1191.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAAB6CAYAAAAcXxXhAAAABHNCSVQICAgIfAhkiAAAAzdJREFUeJzt20ty2zAQRVEqxX1knM1k/7tJBta1ixLFD7obeGjgTjISrDpVdsgn8fH3959/S0AP8+utJxydfb215Q/ff70GDLkBZYMhM1BWGF5bDJQV5vX1t4FGgaHLQKPB0CnQqDD0EWh0GNoFsv31zwFDG6AJ895qPSArDK2lh2SHoaILxSgcJRi6BTQSDF0CUv11ioS5dC82Mgx9uA6aMPRyHTRhXnteB2nCeLzeeu462v9Md88V3KRjKj1XaJOOq/NNOi7L2b+e/zbcpOPygKEGm3RcnjBUcZOOy3r2J5xlqbJJxxUJQ4GbdFw1YOgNaMJsc9yk42oBQw6bdFwtYciwScelAEPVr4Miz/aEoZubdEyKMHRxk45JGYYZ6GSTjvrhtmrAkPtn8+dvoLyaMOR2HXT+BsprAUPm66DzN1BeSxgqvg46fwPlKcCQ3CYdhVP64YTMJq0GQ803aaVfp+1rv2q2SavDUPV7sV5gqNom3RsMhW/SqjBfrz8vbJPuHYbcN+ksMPQNNGH2M99qZIWh4uug7DB0G2gUGLoMNBoMnQKNCvN4Pix/CKR6h10DhnaBJsxPGyDVX6cWMLQuy4Q5alX8dVKAoYBNOgcMOW7Smn+AS2HIYZPOCeOwSWvCLIsNx2GTHgOGbmzSY8HQhU16TBg62KTHhqGdTTonzLKYN+kJs5f5kcysMNTss/nDswVgSOt70kIwVO2z+cOzBWEo/LP5w7OFYU6fWR0dhqp+T7onGKryPekeYSj+e9IVbwvudHVqjvuedOcw5L9JJ4Ehv006GQzZN+mkMFR+Lyb6P5P353z378UGgaHr92KiMMvS+JnVUWHo873Y4DD0vklPmE0/m/SE2W2dMMdJbtIKMCS1SSvBkMQmrQhDTTdpZZimm3QPMOT+vNidH67U6SY9YfYL3aR7hqGQTToDDLlv0qo4zTfpbDBkBsoKY/6edHYYknpm1ZI3DEk8s2opCoaaPrNqzfLezN+THh2G3oAmzLZvoAmzX9gjmR5F/wG+kvuthkcKMJwjBaQEQxJAijDUFEgZhpoA9QBDVYF6gqEqQCowJWeFAvUMQyFAGWDIFSgTDP0HJmgqnax4EQYAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23553)">
            <g transform="matrix(467.2 0 0 581.2 1208.9 1839.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,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"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23565)">
            <g transform="matrix(352.2 0 0 587.2 1203.9 1843.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,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"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23577)">
            <g transform="matrix(496.2 0 0 639.2 2163.9 1810.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,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"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23589)">
            <g transform="matrix(395.2 0 0 658.2 2283.9 1805.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,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"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23601)">
            <g transform="matrix(35.2002 0 0 44.2002 2264.9 2405.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAJCAYAAAD+WDajAAAABHNCSVQICAgIfAhkiAAAABxJREFUGJVjfCOj8p8BB2BhwCnFwMCEW2qoSQIAIZQDPlL1B4IAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23613)">
            <g transform="matrix(24.2002 0 0 29.2002 2279.9 2434.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAGCAYAAAAL+1RLAAAABHNCSVQICAgIfAhkiAAAADBJREFUCJllzMERACAMAsEjUoRNWKSV4zuG5w5zuvuEb16DwEINBLjmkWkKRqFaQjxxywTkdqu8YwAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23625)">
            <g transform="matrix(288.2 0 0 20.2 2375.9 1805.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAECAYAAADS1VyyAAAABHNCSVQICAgIfAhkiAAAABtJREFUKJFjfCOt8p9hBAGmgXYAvcGoh4c7AAAz6gIyKKpqBwAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23637)">
            <g transform="matrix(30.2002 0 0 20.2 2643.9 1805.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAECAYAAACtBE5DAAAABHNCSVQICAgIfAhkiAAAACBJREFUCJljzJDV/c+ABTBhE2RkYGBgQReAARZ0ARgAAKb4AcCvnPUYAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23649)">
            <g transform="matrix(466.2 0 0 586.2 2173.9 1839.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,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"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23661)">
            <g transform="matrix(346.2 0 0 587.2 2298.9 1843.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAAB6CAYAAAAcXxXhAAAABHNCSVQICAgIfAhkiAAACuVJREFUeJy9XVmW5KgOFTi20Ut4S+8tBv2BcXjgDoEiH+fUqcoUCAxoupJd5d9//tfe8Wnt9Hfd/24TWjn/3Aqny/FXGpr73L8UPLbMxux9I/rY8e/7s9/H15i0ggiCNhqjZ8fXiKiF0BRvMDZivrZ6/4GMNyZvcLy1MQX3YQ9fC1/3MZ5sLGovp9OgNUQvDdLGeEovhHdirDVe0GotLTbSyTkZRlM3cvXGqrHqxpby0WOzsYM05WHJMulTSota2LmJjSEic148WxubF42fjXv8jt2mMYDqCbEx7ORL4FMdY1kriY3dlH6q2VOnI/8P4rS4sZWIWkREdU+dLo4ugG88vVGGdVIbx8RJHeroB9tGOnhmm28M5S12hvpqBY//1g+bK2lD3NQE2GdplkuxxDvWRS1i31g1ZvXUIzxxWx+rxWmVt2XZ1Kk71o0tAG1ONjxQHrYjqoz3azB/zzoID9mZ4BwwPng3vvoaEaiL8pBd5T7jUUrXv62Rw8vqAnrlE75SGLSUd38jTh1FpUdWQxO1uOmCLnNjn8XhvbKxp2D1jISgBa45kkocVJ/V23TwLlc8aDYvDJYrJX+YoM1RN06eagIicRQwOzR5mwn8EhG5h1exD7NsIeZV4UF2Y8+bt6SkmSOZdd/ZxqbRSGNj7+TXs9vwdJ+cGHC2Edp9AXPT2kVtZvqVnpC8ybj7HLPfH/+oYAk1OAziKO9ViMTSE5nwgsxR4uQo4gmwdRsPxuDSmQN6plMYt5VlZ1Abh/3GgQkMHYQvtVLeow/mLYJZw5HMoAzf+GoPHcS9UM9XKiA+cJzEVQCe+Trn+b/VU4+sBhYJcaoJcXPiKvRgg07XFljJK1GrERGbhDjWEUcFumklvIZGOnRnbM3AEBuZRGU2nLgJBbXexnLerg6bI4pi8u4r4cWvesjH+AXawT8R0M42tV47tJS4qeusLFsGInFQQzqWbKo89aMjoaGHzyYR02sjUK2FZjoKGHvBWNRc7CezeCWOWeyoxjQW25mI2EgxZ22LHFzKvGzlEkiXYp98mP3Hs6ZgiDDA/VRmo1FdpBTwCjxzVdJkbzeSz7JAN/Jwv4BIqOUzgDXUXhERW+DsheMhs8YgkhGWrIcXWNRciASvbS/BywDwrClxy0AkzIkcdMXb9bCBo0isk/CVxng2eTZ8YDRpQAR2dB9/sWI9dJiLmzq1MUFEmwalW/RgdbUcjivgXQ2QRGQhTJgYv3oHDWOw9iuIZMlsm/WRK7z38cRyEVGL6JaNhyZaz6hbiXnrG/dt3DXjMZ2DRemfCdarQELQuff+A97m5kx48RtzHzydXIxlm5+ts2ZJSGdts3lOWQ1tmZS48cYhEiZq2cyE64hOPWkPgM+Zbbaxq2jkmDvjq0WErIOEwep5gmntULR4/8DyobqkCMNsIxoJtK/zcJy7BNigz4k/J2BhydFnDwHQxiLeNSKaWbQFw4sfF309HMU0DEEmpmNN+mpmJILHXmf6dF1cT2gYYz08yPN2rRPkwXDsWt4EFXRqh/4OImFwrZPZUP2s7Aga6JzqX2U2WMDqWN2xBoY/uWt49HP8ob+DSNYTfec+q0FvRDyq9D+8SotSWC2G1lPwRiUhErfyX0X8KyFIraEDxn6tcaUHciT9lM16ZmTMw8KXTNpJOIotChiehUg6D/57fp97v9X6ozOdFTXMlXR5U3GjlsuI2TR+xJsyIo4eWoZcmbhtZGGMdkyWrCKJ0Fi0zt3z8feNO0RsPNzs3pTy3hG/NXHLBpSDRwGeuiOSHXLFujIChC89rz5/hCIsm4JA8hCJBu8cf+3njqKa2AkPGETiZEbGPKg59UcO0K/GP6zYBvMaXdTg+0lj4v1vdO8cu1dBZmTwVxG7VMBCF54tWz0TqOa3HD3kK3lQ7mVBDx4JcYh1LLsqxmphWdc+Im/6vzHbc/7E0axg7hIFKu8P4xxEEuEEtULPJKtFvq42sfCV0gKVHDgwxpg8G9gyWqaG6Tz+wgeFFaNtoR1J1bRroMbzuCvzaY3ZoXUd1Pof1LYoUkdYukaYbZWlVRE/a9QfYq93qVtDT9SASAaPv/wET7ZIlPHGNYoR0B/aIuJtZA94BqPTWOpIbUwfz/sofwwVNYz22KDS9pwSWDdzJD998ORjAYzDELV5ASne9LhR2MO7mY3LITE91JWj1jRKAUuYIpuCXqw8Q2NrJ2JHrQgFffQjGJKVwSC0TEGEGq9cgoosi7Jsl8URGMEJahmWnfKHiNl34FyMKBqitEUR4qL1VM6y4VvpeMisnc3+VQcRUbv248wz2ZGIvNlntG9dhhrhRcpqAi/axuLkRPyrKezM531e1sa0HSNZNP0jO7IKl/L3RjB2pLCfow+iGTowZfpLeQtdpBd/v/Ll9Cejw1SfQYMbxPRRbYZPIoLaDJatTHoWvzrTH33Z4mvrnjZrNNo2gloV0PJvhoi1LWDY1sduB11lKQvQRf02NYpnz3TRCElUeGAVfq2+RqU7aPyG6ZkMlv2hA96hU0KrLsEQNfi2j4qbIjSGpJSookPU0vp8hUg7wXEqmg8nKCzwUwVOUNsFkWdp5wWgzqe+NIbtRvJjzqNpZyr3FU0GsGVEbczN6gYy3rdVeED1VOO3RpleXanBxWU5knc8bMd6UShE3Pl76uhSWiIKSLPVIuhGKtxojJ+mns9M0BR1N+bctJ4N9JVnoWmjiHcimHUcQaXHLod4Jypxcywb9MBnE37Bu/yhh430VIU/TDpSupE6Qk09eO9D5qavnP8AzUx/44dOzi2f40iurM1BM63U9appjOBetgpoPeOAb0UmO8v01F1Spv2cxVPTTAJalQRQ1ku9i88tm7jN0zG3HxwgG/1cgpUNGxsvyv3gJ3gc3sqXAhvbXwtv0f/HJDLBeO/9vrBBawDZG4qbFabp1zEB78Pd4ElEFO1b7/KrUkFm9mUJi+FEYl3APWRpOBIe9qDTW5/5ErCTPaChCc2KaJyY30hdJUIdRfjLE40Xk69nJiLwwzGrdowNbva1DgSp5+OHhh/eyauz1osi5r1U/ZGTTmLY0XIGdfy+BNYX+QyojvQhjQSzY2zmEzxMXMfG0o+8qc/6pYrJ4xdQLePNxkZQ7Ok091wHkbjK8ZWYgme8lah9eK952BEaCeD1QdFEwMkbU5I1uNnXpYD8uxwOdsRcCqqD+gJ50Kbcfw4l8NBDiZoy+6ypoiwlavvbPiTgNBxJujg0ucGbNdfso+YiGMAP8iotmM+Badjcj8Z0EX5r7dqHfYONidr9wCeIIt8YZvY1aqc3XZl9NZ4e2oKo1fM/qLPWcpmJzH+/VUOHD+qdDtRkSsgCxoRlS6GRPzD7qDFR8xKkog+r+sqC+7yy1inexLqIfik9PCd0O/497SCu3eKNGnRl9lljZv8XL8rcRfUxZjVz4YiqzM4SqDYjao5VZobn6IBhjLwsY5o2+7TMb1HUzmuj3n9tERvZ3FVRi9AfItAbS/SU8LClH0dzaRFD1OAaVeZBFXem8B1RDEHHRoSqEvkmHfV0FAlothFg6tMHN9fsY955D/vbtX0cRREbOXom810PJk7sRupglnvY/D+Ta9pRzObkHeyIBcuraGRvPG3tiBrOahBR+zBZR/VC0DPv0OqMjL9uiCiyxuBSBvx/Fsho2Oy7HjZqzOwjUXuknvnkOXyHnaw+9XUPW+XSJH4tCwbErXC81NWANuth84Irbfn+A1aKL1FRp4g5AAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23673)">
            <g transform="matrix(106.2 0 0 144.2 1506.9 1599.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAeCAYAAAAo5+5WAAAABHNCSVQICAgIfAhkiAAAAERJREFUSIntzLEJgEAUBNFZbeMasv9GzIX7lyh8zA2E2WiC5eU8RtEXoIB597PZem99BVKvb9j4aMLCwsLCwsLCwv+BF7zJCIxeDfW/AAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23685)">
            <g transform="matrix(783.2 0 0 557.2 1530.9 1647.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKMAAAB0CAYAAADpV4IXAAAABHNCSVQICAgIfAhkiAAAAbdJREFUeJzt0sFNxDAUQMEfGqEJ+m+JCog5sCtFwUJwQHqHmUu8lpN4nXe8v72utY6ZNTMzc7ysWR/H48fXZdZjfM53z7XPddfr1f3eNbPO4/u6tRmvmTmPmeMxsY79e87L3HXvz+HufVW3re6OdDe3c193PaKfPtmvn7fZ6+b457z/qdualz/sAf6VGMkQIxliJEOMZIiRDDGSIUYyxEiGGMkQIxliJEOMZIiRDDGSIUYyxEiGGMkQIxliJEOMZIiRDDGSIUYyxEiGGMkQIxliJEOMZIiRDDGSIUYyxEiGGMkQIxliJEOMZIiRDDGSIUYyxEiGGMkQIxliJEOMZIiRDDGSIUYyxEiGGMkQIxliJEOMZIiRDDGSIUYyxEiGGMkQIxliJEOMZIiRDDGSIUYyxEiGGMkQIxliJEOMZIiRDDGSIUYyxEiGGMkQIxliJEOMZIiRDDGSIUYyxEiGGMkQIxliJEOMZIiRDDGSIUYyxEiGGMkQIxliJEOMZIiRDDGSIUYyxEiGGMkQIxliJEOMZIiRDDGSIUYyxEiGGMkQIxliJEOMZIiRDDGSIUYyxEiGGMkQIxmfGWMqCrZz4ygAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23697)">
            <g transform="matrix(241.2 0 0 322.2 1938.9 1882.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAABDCAYAAADeQVbVAAAABHNCSVQICAgIfAhkiAAAAIVJREFUaIHtz0EKAkEMAMEZfyL+/2l+wXhRlD0LW0jXZSATCL3v19usx/rYr/c9m6+/Oewddmf2OsvltMs/VoimEE0hmkI0hWgK0RSiKURTiKYQTSGaQjSFaArRFKIpRFOIphBNIZpCNIVoCtEUoilEU4imEE0hmkI0hWgK0RSiKUTzNyFP1NYJsD47i8sAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23709)">
            <g transform="matrix(515.2 0 0 577.2 1496.9 1627.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGsAAAB4CAYAAAD1/Qw5AAAABHNCSVQICAgIfAhkiAAAAZhJREFUeJzt0cFx2zAUQMGPuAyXlP4LyVk24UMoj0ypAL+Z3RMIggCGb/37+75nZvax5oc1M3tmjnN8dzyM3x7GtzWz9mXtw8M+9/mcZ/d393OP8z7n3Fr7/7LbObcu317vuF+c8bme5/bz+Pof1tqzP+4XedxvZv5c9ru9OOOV43nq+9z9Yt356nocv5hYIWKFiBUiVohYIWKFiBUiVohYIWKFiBUiVohYIWKFiBUiVohYIWKFiBUiVohYIWKFiBUiVohYIWKFiBUiVohYIWKFiBUiVohYIWKFiBUiVohYIWKFiBUiVohYIWKFiBUiVohYIWKFiBUiVohYIWKFiBUiVohYIWKFiBUiVohYIWKFiBUiVohYIWKFiBUiVohYIWKFiBUiVohYIWKFiBUiVohYIWKFiBUiVohYIWKFiBUiVohYIWKFiBUiVohYIWKFiBUiVohYIWKFiBUiVohYIWKFiBUiVohYIWKFiBUiVohYIWKFiBUiVohYIWKFiBUiVohYIWKFiBUiVohYIWKFiBUiVohYIWKFfAGcsiYjrpsTpAAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M92.558 119.874l4.215 8.684-7.654 13.555-9.77.652 9.608.56 7.682 11.977-6.706-12.33 7.63-13.886 16.01-.055 7.345 11.724-6.58-12.197 4.536-8.566-5.3 8.17h-16.01l-5.006-8.288"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23723)">
            <g transform="matrix(39.2 0 0 49.2 1602.9 1589.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAKCAYAAACJxx+AAAAABHNCSVQICAgIfAhkiAAAAB9JREFUGJVj/LV3038GbOAfIwMDAwMDE1ZJJDCqAAIAmNIEeyUyyQoAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23735)">
            <g transform="matrix(25.2 0 0 25.2 1597.9 1618.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAABHNCSVQICAgIfAhkiAAAAB1JREFUCJlj/HVo838GBgYGhv+MDDDAxIAFUCgIAMEPBHikxaXbAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23747)">
            <g transform="matrix(140.2 0 0 192.2 1477.9 1623.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAoCAYAAAACJPERAAAABHNCSVQICAgIfAhkiAAAAExJREFUWIXtzbENACEMQ1Gb/ZdhCoai8BUnFEokKL9LJ/LzHD2SdZoo8vq3ldTN20z1Ue3/ZTvWHgYUFBQUFBQUFBQUFBQUFBQU9CYfwbkLwprqif8AAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M91.219 145.337l-1.305-1.522.292-.341 1.013 1.863"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23761)">
            <g transform="matrix(54.2 0 0 44.2 1424.9 1819.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAJCAYAAADkZNYtAAAABHNCSVQICAgIfAhkiAAAACpJREFUGJVj/HVw438GXOA/IwqXCadCLGBoK/7PiOF7wibj0cCCVRSHBgA8Wwh/1VW0QQAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23773)">
            <g transform="matrix(150.2 0 0 188.2 1323.9 1839.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAnCAYAAAD3h5P5AAAABHNCSVQICAgIfAhkiAAAAS1JREFUWIXdllsSwjAIRSG6/624GJfjTPCjrzwgEkLaqXfGj2LlEHqh4uf9IhgVEgAhADyOa4AlhkV6wv2eMAy2itAbHtdPDpE06eRFEUIBOZx7+kOOaBfwFGFyt34rA20F1E0OYyfjYJJqPywn9yhAraMT140aRCPcyZg6ODHJLY+q8EbfyT0KSFSPmlNijc43XNL6uXBCfgessXNOrtrt7A87Iaptt8HT5KbxEYpQwcsE3ExbClDDexI4juCFu90Kl3Z7zwYc+g/n0H55vXKg0sTExPbvsH0NrbZrWzugdtsnv1xu6PYRJY8uh0fGPRHrOHefAlbGA5u4JzkHU8bDDvSEKafiaPuM06rhF8gPzpr1LLgCZodrp6JVQOEN+cUizTwXCzbH/YnhDPoCU29ohxgNBlsAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M89.283 142.992c-.132-.208-.319-.5-.541-.853l.377-.026.484-.855.474.571-.24.332-.554.83"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23787)">
            <path
              fill="url(#linearGradient23795)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1440.29 1773.37l11.83 17.74 11.31-17.63-23.14-.11"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23805)">
            <g transform="matrix(150.2 0 0 183.2 1323.9 1599.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAmCAYAAAA820BcAAAABHNCSVQICAgIfAhkiAAAAMxJREFUWIXtmE0SgCAIhc3p/mfpAl2sRbbqZ0z0QYSVvVU14Fcg4NRN4xAcpY54PlP2lENaPnFlpr4GdFVFNAKnd8S+gvAT8m4IOLYv+RzU46YZqFAPz/kPbxvOKCM9OLN+Nx8VOFfgi74o52bwCwMD1bm3G8bCZ+5oIRsKWIs/1SRj1rnkeVA2UhHoEcxwMVO7cL2ccxRqwKMNeC3snGmXsJPDFWY7D67c77Gc31QT5WVvLMZ2m8xHOlxw9G+UWF4TjtZ8FGeb9kokdwGgbRnezJr/CQAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M89.546 144.244l-.14-.218-.398-.622.275-.412.22.344.41.479-.367.429"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23819)">
            <g transform="matrix(102.2 0 0 145.2 1515.9 1877.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAeCAYAAADD0FVVAAAABHNCSVQICAgIfAhkiAAAADRJREFUSIlj/HVo438GGECwoIAJlwR28J8RRRdVwaiho4aOGjpq6Kiho4aOGjpq6Kih5AMApLsGqAOLoP4AAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23831)">
            <g transform="matrix(130.2 0 0 208.2 1482.9 1800.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAArCAYAAACJrvP4AAAABHNCSVQICAgIfAhkiAAAAEpJREFUWIXtzbENACAAAkFw/2lcwqEssDBGSwvtno4Ecu6tRpeJIsuz2MrxtI9d9kNrr6jcQi8CBgYGBgYGBgYGBgYGBgYGBvYhA2nyC8jBFU4uAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M90.368 142.18l-.291-.35c.388-.54 1.196-1.66 2.028-2.81l-.603 1.096-1.134 2.065"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath23845)">
            <g transform="matrix(44.2 0 0 54.2 1467.9 1781.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAALCAYAAACtWacbAAAABHNCSVQICAgIfAhkiAAAABhJREFUGJVj/Pv+5X8GAoCJkIJRRVRWBAAf6APqjNCFGAAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M89.914 143.815c-.258-.3-.41-.48-.41-.48l-.22-.343.553-.831.24-.332.29.352-.434.791.273.502-.292.34"
        ></path>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M91.22 141.511c-1.4-1.089-1.143-4.157-1.157-5.022v.828l-.01-.305v-.523c-.003.248-.02.64-.074 1.097 0 0-.414 3.076-1.15 3.715-1.66 1.452-5.843 1.177-4.237 1.21 5.413.117 5.413 5.409 5.46 7.14v-.877l.011.15v.726c.115-4.106.1-6.702 4.826-7.051 1.563-.118-2.04.182-3.67-1.088"
        ></path>
        <path
          fill="#61182d"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M146.816 152.135l.061.023c2.044.697 5.188-1.486 6.432-5.735.713-2.438.864-4.888.893-6.06-1.309.365-4.487 1.564-6.268 4.893-1.916 3.582-1.348 6.152-1.119 6.879m-.226 1.175a3.037 3.037 0 01-.356-.145l-.176-.085-.086-.198c-.063-.14-1.464-3.486 1.092-8.264 2.528-4.73 7.381-5.554 7.587-5.587l.563-.09.02.664c.004.148.095 3.629-.95 7.208-1.454 4.962-5.152 7.367-7.694 6.497"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28109)">
            <path
              fill="url(#linearGradient28117)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M3115.25 1527.32h-.1c-3.85.01-7.64.26-11.35.79 7.13 32.45 12.67 65.34 16.62 98.54 13.07-20.79 35.1-31.5 57.57-31.5 19.64 0 39.62 8.18 54.23 24.99 48.3 55.54 84.53 261.76 70.92 266.74 0 0-123.44-41.5-174.46-139.76.18 7.46.29 14.91.34 22.34 32.73 48.8 75.25 78.96 111.53 97.31 20.95 10.6 39.8 17.24 53.36 21.22 6.77 1.98 12.22 3.3 15.97 4.12v-1.92c.02-25.1-2.06-106.77-26.07-188.77-15.91-54.38-42.92-98.08-73.59-128.04-30.64-29.96-64.87-46.05-94.97-46.06"
            ></path>
          </g>
        </g>
        <path
          fill="#971a2f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M146.43 152.61l.161-.07-.003-.008c-.035-.085-.363-.918-.363-2.291 0-1.307.296-3.104 1.429-5.221 1.194-2.233 2.967-3.536 4.446-4.285.739-.374 1.404-.608 1.882-.748a8.668 8.668 0 01.765-.186l-.028-.174-.176.005s.003.096.003.277c0 .886-.073 3.767-.92 6.66-.561 1.918-1.514 3.46-2.596 4.516-1.083 1.059-2.292 1.626-3.354 1.625a2.67 2.67 0 01-1.17-.26l-.077.16.162-.07-.162.07-.076.158c.412.2.86.295 1.323.295 1.189-.001 2.47-.622 3.6-1.725 1.13-1.105 2.111-2.698 2.688-4.67.863-2.948.934-5.854.934-6.759 0-.184-.003-.286-.003-.287l-.006-.2-.198.03c-.012.003-1.226.197-2.75.968-1.524.77-3.362 2.121-4.599 4.434-1.16 2.167-1.47 4.026-1.47 5.386 0 1.526.388 2.423.396 2.44l.026.06.059.028.076-.159"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28129)">
            <path
              fill="url(#linearGradient28137)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M3177.99 1595.15c-22.47 0-44.5 10.71-57.57 31.5 1.6 13.47 2.94 27 4.01 40.57 2.22 26.75 3.64 53.4 4.25 79.9 51.02 98.26 174.46 139.76 174.46 139.76 13.61-4.98-22.62-211.2-70.92-266.74-14.61-16.81-34.59-24.99-54.23-24.99m118.26 276.89s-119.24-41.96-134.2-98.38c-11.91-44.86 17.56-84.84 49.74-84.84 8.31 0 16.8 2.66 24.81 8.6 39 28.95 59.65 174.62 59.65 174.62"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28147)">
            <path
              fill="url(#linearGradient28155)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M3211.79 1688.82c-32.18 0-61.65 39.98-49.74 84.84 14.96 56.42 134.2 98.38 134.2 98.38s-20.65-145.67-59.65-174.62c-8.01-5.94-16.5-8.6-24.81-8.6"
            ></path>
          </g>
        </g>
        <path
          fill="#61182d"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M66.085 137.802a37.434 37.434 0 012.598-9.31 33.216 33.216 0 012.155-4.187l.119-.192-.171.299a34.622 34.622 0 00-2.03 4.284 37.582 37.582 0 00-2.316 9.346 43.33 43.33 0 00-.043 9.686 33.682 33.682 0 002.28 9.281c1.119 2.777 2.651 5.477 4.56 8.028a38.927 38.927 0 006.119 6.448c1.098.922 2.27 1.79 3.48 2.58.619.404 1.235.773 1.836 1.1.732.397 1.34.683 1.91.9.203.074.36.127.5.164.09.025.208.051.33.076l.171.038 1.019.228c.672.154 1.345.313 2.017.478 1.364.334 2.718.68 4.022 1.026l-.218 1.102a272.333 272.333 0 00-4.152-1.069c-.74-.183-1.423-.346-2.084-.498l-1.042-.236a6.095 6.095 0 01-1.027-.324c-1.484-.608-2.834-1.449-3.845-2.114a37.796 37.796 0 01-3.564-2.7 39.395 39.395 0 01-6.222-6.733c-1.91-2.625-3.436-5.43-4.535-8.336a34.272 34.272 0 01-2.138-9.522c-.28-3.362-.187-6.673.271-9.843m-1.434 9.973a35.77 35.77 0 002.233 9.947c1.145 3.024 2.732 5.94 4.714 8.665a40.679 40.679 0 006.42 6.954 38.931 38.931 0 003.679 2.783c1.055.695 2.464 1.573 4.039 2.217.295.116.732.28 1.195.376l1.032.233c.654.15 1.33.312 2.068.495 1.413.348 2.822.717 4.135 1.065l1.134.3.742-3.762-1.135-.303a194.512 194.512 0 00-6.083-1.515l-1.02-.227a6.504 6.504 0 00-.184-.04 4.932 4.932 0 01-.268-.062 4.684 4.684 0 01-.413-.138 14.204 14.204 0 01-1.775-.837 26.086 26.086 0 01-1.759-1.053 35.53 35.53 0 01-3.367-2.497 37.604 37.604 0 01-5.923-6.238c-1.834-2.455-3.309-5.05-4.382-7.713a32.2 32.2 0 01-2.176-8.861 41.648 41.648 0 01.04-9.336 36.036 36.036 0 012.222-8.963 32.73 32.73 0 011.942-4.102c.842-1.49 1.617-2.639 2.44-3.605l.496-.39-1.456-2.002-.463.485c-.481.498-.957 1.068-1.537 1.847a27.076 27.076 0 00-1.355 2.015 34.606 34.606 0 00-2.249 4.369c-1.295 3.028-2.205 6.289-2.704 9.69-.475 3.291-.571 6.723-.282 10.203"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28167)">
            <path
              fill="url(#linearGradient28175)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1627.32 763.629c-9.37 1.25-19.29 2.012-29.79 2.16-50.94 12.531-96.08 23.602-111.83 27.481l.19-.04-.18.04c-19.61 4.851-39.28 9.601-58.93 14.128l-29.55 6.622h-.01c-10.45 2.199-20.72 5.781-30.46 9.652-13.4 5.488-26.44 11.609-39.23 18.219-2.12 4.73-4.61 9.851-7.52 15.25 17.67-10.672 36.02-16.821 54.1-17.852 1.89-.098 3.79-.148 5.68-.148 2.17 0 4.33.07 6.47.218l6.12.422 4.39 5c.96 1.071 8.54 9.828 17.54 26.629l28.3-6.34-.01.012c19.19-4.352 38.3-8.891 57.37-13.57h.01c14.45-3.532 54.96-13.41 101.84-24.891 7.44-19.539 15.91-40.531 25.5-62.992m-385.71 181.582c-21.14 15.211-46.73 29.301-77.69 40.691a260.063 260.063 0 01-51.49 13.188c-34.35 32.49-67.02 67.44-97.6 104.76l-.07 4.29c-.03 1.73-.5 16.83-6.47 39.57.72-.55 1.46-1.1 2.19-1.63 3.48-2.51 7.07-4.78 10.71-6.82l5.5-3.08 5.92 1.88c.92.28 6.42 2.09 14.89 6.61 42.15-50.54 88.39-96.49 137.46-137.67h.01a1028.167 1028.167 0 0143.7-34.629c4-9.48 8.33-18.551 12.94-27.16M944.488 1264.04c-17.894 20.08-40.34 40.18-68.496 58.98-.312.2-.613.41-.926.61a978.137 978.137 0 00-30.277 71.29l-.004.02h-.004c-23.086 60.43-40.281 124.03-51.125 188.94a237.158 237.158 0 012.551 21.8c1.004-29.94 8.063-57.04 20.801-78.36 2.012-3.38 4.238-6.73 6.539-9.84l3.558-4.77 5.313-.89c.742-.13 4.793-.76 11.488-.76 2.477 0 5.317.09 8.485.32 9.398-33.96 20.664-67.22 33.754-99.51l-.004.01c15.398-38.22 33.226-75.01 53.043-110.29 1.062-12.98 2.847-25.53 5.304-37.55m-147.726 366.99c-.66 25.83-5.114 56.93-16.989 92.08-.765 18.19-1.156 36.4-1.156 54.61 0 58.54 4.016 117.04 12.36 174.7.175 1.19.347 2.37.527 3.56 4.32 4.43 12.051 13.24 20.539 26.99 1.457-9.11 3.68-17.82 6.684-26.04 1.402-3.79 3.007-7.6 4.726-11.19l.75-1.56-.363-3.08v.01c-5.524-46.27-8.207-92.93-8.207-139.57 0-27.73.949-55.45 2.816-83.08-12.418-29.35-19.558-59.21-21.687-87.43m-5.785 321.39v.01-.01m59.906 187.22c.004 12.29-.528 25.27-1.692 38.95-.015.2-.031.39-.05.59 5.25 13.93 10.785 27.7 16.605 41.31l-.019-.04.015.03c18.035 42.05 38.789 82.5 62.094 120.67l-.035-.05.035.06c2.535 4.15 5.105 8.27 7.711 12.36 3.601-1.33 12.305-4.12 25.105-5.53a979.72 979.72 0 01-15.593-26.68l-.008-.01c-21.422-38.16-40.371-78.14-56.586-119.54a991.184 991.184 0 01-9.75-25.91 279.087 279.087 0 01-27.832-36.21"
            ></path>
          </g>
        </g>
        <path
          fill="#971a2f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M65.51 137.688l.174.026c.48-3.286 1.368-6.487 2.638-9.457a33.559 33.559 0 012.19-4.257v.002V124c.411-.674.85-1.324 1.312-1.949.464-.623.946-1.226 1.47-1.769l.015-.015-.126-.124-.142.104.013.018v.001l.632.866.142-.104-.124-.125-.005.005-.002.002-.002.002c-.018.02-.073.08-.163.182l.263.234.162-.18-.129-.12-.134-.114c-.983 1.148-1.818 2.446-2.574 3.787v-.001a33.8 33.8 0 00-1.997 4.218 37.075 37.075 0 00-2.28 9.195 41.556 41.556 0 00-.289 4.924c0 1.546.084 3.091.247 4.625a33.309 33.309 0 002.24 9.121c1.159 2.875 2.707 5.52 4.493 7.91v.001a38.454 38.454 0 006.05 6.372 36.276 36.276 0 003.44 2.552l-.001-.001h.002c.593.386 1.196.75 1.81 1.084a15.35 15.35 0 001.865.878h.001c.156.058.313.114.468.155l.045-.17-.048.17c.144.04.325.074.49.112l1.016.227c.677.153 1.351.313 2.024.479 1.348.329 9.133 2.227 10.475 2.585l.003.001.402.107-.099.502-.219 1.108-.094.477-.386-.103c-1.383-.367-9.202-2.282-10.586-2.623l.007.001h-.006c-.692-.172-1.386-.34-2.08-.5l-1.042-.233a6.618 6.618 0 01-1.075-.341h.001c-1.384-.566-2.66-1.325-3.913-2.15l.001.001a37.768 37.768 0 01-3.606-2.73h-.001l.001.001a39.803 39.803 0 01-6.293-6.814h-.001c-1.856-2.552-3.44-5.39-4.602-8.46a35.024 35.024 0 01-2.176-9.686 46.258 46.258 0 01-.159-3.818c0-2.065.142-4.13.436-6.164l-.174-.025-.175-.025a43.415 43.415 0 00-.44 6.214c0 1.284.055 2.568.16 3.847v-.001a35.377 35.377 0 002.198 9.783c1.174 3.102 2.774 5.967 4.647 8.543v-.001a40.169 40.169 0 006.35 6.875 38.114 38.114 0 003.64 2.754v.001c1.262.83 2.557 1.603 3.973 2.182h.002c.354.141.735.275 1.134.359l.036-.173-.039.173 1.04.232c.69.16 1.382.327 2.072.497 1.383.34 9.206 2.257 10.58 2.622l.75.199.166-.845.22-1.108.162-.827-.724-.193c-1.354-.361-9.132-2.258-10.482-2.587l-.004-.001h.004c-.674-.165-1.35-.326-2.03-.48l-1.017-.227h.002c-.174-.04-.354-.073-.472-.107h-.002a5.363 5.363 0 01-.438-.146h.002a15.006 15.006 0 01-1.822-.858 26.23 26.23 0 01-1.786-1.068h.002-.002a35.944 35.944 0 01-3.407-2.526l-.004-.004.004.004a38.085 38.085 0 01-5.993-6.314c-1.77-2.37-3.303-4.988-4.448-7.831a32.954 32.954 0 01-2.218-9.026 43.456 43.456 0 01-.244-4.589c0-1.632.094-3.264.287-4.881a36.74 36.74 0 012.258-9.109 33.409 33.409 0 011.975-4.173c.75-1.328 1.574-2.608 2.535-3.73l-.262-.236c-.06.064-.114.126-.167.184l.131.119.133.117c.087-.1.142-.16.155-.174l-.128-.12.124.124.005-.005.107-.106-.721-.989-.013-.018-.123-.168-.162.165c-.54.56-1.031 1.175-1.5 1.805h-.001a26.78 26.78 0 00-1.329 1.975l.001-.002v.002a33.94 33.94 0 00-2.214 4.302c-1.284 3-2.178 6.23-2.663 9.545l.175.025"
        ></path>
        <path
          fill="#61182d"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M146.84 147.646a34.254 34.254 0 01-2.138 9.521c-1.099 2.905-2.626 5.71-4.536 8.336a39.362 39.362 0 01-6.22 6.734 37.85 37.85 0 01-3.566 2.699c-1.01.665-2.36 1.506-3.843 2.114a6.101 6.101 0 01-1.028.324l-1.042.236c-.66.152-1.343.315-2.084.499-1.422.351-2.835.72-4.152 1.069l-.219-1.103c1.305-.347 2.658-.692 4.024-1.025a117.63 117.63 0 012.015-.478l1.02-.23c.057-.011.114-.024.172-.037.123-.025.238-.05.329-.076.14-.037.298-.09.5-.164a15.82 15.82 0 001.911-.9c.6-.327 1.216-.696 1.836-1.1 1.21-.79 2.38-1.658 3.48-2.58 2.3-1.93 4.359-4.1 6.12-6.447 1.906-2.552 3.44-5.252 4.558-8.029a33.74 33.74 0 002.28-9.281c.348-3.27.333-6.528-.043-9.686a37.575 37.575 0 00-2.316-9.346 34.39 34.39 0 00-2.2-4.583l.118.192c.8 1.309 1.525 2.719 2.156 4.188 1.245 2.909 2.119 6.041 2.597 9.309.459 3.17.55 6.48.272 9.844m.88-10.073c-.5-3.402-1.408-6.662-2.705-9.691a34.389 34.389 0 00-2.249-4.37 26.669 26.669 0 00-1.354-2.014c-.58-.779-1.056-1.349-1.536-1.847l-.464-.484-1.456 2 .496.391c.823.967 1.598 2.114 2.44 3.605a32.796 32.796 0 011.942 4.102 36.052 36.052 0 012.221 8.963c.364 3.041.377 6.18.042 9.336a32.212 32.212 0 01-2.177 8.861c-1.073 2.663-2.548 5.258-4.383 7.713a37.573 37.573 0 01-5.922 6.238 35.522 35.522 0 01-3.366 2.497 26.37 26.37 0 01-1.76 1.053c-.689.374-1.253.641-1.774.837-.17.064-.3.107-.415.138-.074.02-.168.041-.267.062-.061.012-.125.026-.185.04l-1.019.227a195.128 195.128 0 00-6.083 1.515l-6.718 1.498 1.117 3.598 6.343-1.33c1.312-.348 2.721-.717 4.136-1.066.735-.182 1.412-.344 2.065-.495l1.032-.232c.463-.096.902-.26 1.195-.376 1.575-.645 2.984-1.522 4.04-2.218a38.988 38.988 0 003.68-2.783 40.713 40.713 0 006.42-6.954 37.074 37.074 0 004.714-8.665 35.774 35.774 0 002.232-9.947c.289-3.48.193-6.912-.282-10.202"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28189)">
            <path
              fill="url(#linearGradient28197)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2270.55 762.852c10.13 23.699 19 45.726 26.75 66.199 29.6 7.75 59.15 15.219 88.82 22.461 19.11 4.679 38.2 9.218 57.36 13.57l.05.008 28.26 6.32c9-16.789 16.58-25.558 17.54-26.629l4.4-5 6.11-.422c2.15-.148 4.32-.218 6.49-.218 1.89 0 3.79.05 5.68.148 18.08 1.031 36.42 7.18 54.09 17.852a231.67 231.67 0 01-7.53-15.262c-12.78-6.609-25.81-12.731-39.21-18.207-9.73-3.871-20.05-7.453-30.47-9.652h-.04l-29.51-6.622c-19.68-4.527-39.3-9.277-58.92-14.128-36.52-8.989-72.95-18.469-109.36-28.098a241.66 241.66 0 01-20.51-2.32m373.94 182.359c4.61 8.609 8.94 17.68 12.94 27.168a1015.131 1015.131 0 0143.69 34.621c49.07 41.18 95.33 87.13 137.49 137.67 8.48-4.51 13.99-6.33 14.9-6.61l5.9-1.88 5.55 3.08c3.61 2.04 7.16 4.31 10.66 6.82.74.54 1.47 1.08 2.2 1.64-5.97-22.74-6.44-37.85-6.48-39.58l-.08-4.32c-30.56-37.31-63.22-72.24-97.57-104.73a260.418 260.418 0 01-51.51-13.188c-30.96-11.39-56.55-25.48-77.69-40.691m297.15 318.839c2.45 12.01 4.23 24.55 5.3 37.52 19.82 35.29 37.64 72.08 53.03 110.31l-.01-.01c13.1 32.29 24.37 65.54 33.77 99.51 3.16-.23 5.99-.32 8.47-.32 6.69 0 10.74.63 11.49.76l5.31.89 3.55 4.77c2.35 3.11 4.56 6.46 6.59 9.84 27.72 46.43 28.52 120.29-1.49 191.18 1.87 27.64 2.82 55.37 2.82 83.11 0 46.62-2.69 93.25-8.21 139.5l-.01.09.01-.1c-.11 1.01-.24 2.03-.36 3.04l.77 1.6c1.74 3.59 3.32 7.4 4.75 11.19 2.99 8.21 5.21 16.93 6.66 26.02 8.5-13.77 16.25-22.58 20.56-27 .18-1.17.35-2.35.52-3.52 8.33-57.61 12.33-116.06 12.33-174.55 0-36.17-1.53-72.36-4.51-108.38v-.02c-7.46-94.37-28.49-187.73-61.62-274.54l-.01-.02c-9.19-24.29-19.33-48.07-30.3-71.3l-.9-.6c-28.17-18.8-50.62-38.89-68.51-58.97m153.53 688.37l-.01.01c.01-.01.01 0 .01-.01m-59.97 187.25a279.914 279.914 0 01-27.79 36.16c-3.13 8.7-6.38 17.34-9.75 25.93-16.22 41.4-35.14 81.38-56.59 119.54l-.01.02c0-.01.01-.01.01-.02l-.04.07.03-.05a971.334 971.334 0 01-15.59 26.67c12.78 1.41 21.48 4.2 25.08 5.53 2.6-4.09 5.17-8.21 7.69-12.36l.06-.09c23.28-38.15 44.04-78.57 62.06-120.59 5.82-13.58 11.34-27.32 16.59-41.22l-.06-.67c-1.16-13.67-1.69-26.64-1.69-38.92"
            ></path>
          </g>
        </g>
        <path
          fill="#971a2f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M147.145 137.688l.175-.025c-.486-3.315-1.38-6.546-2.664-9.545l-.004-.008.004.008a33.906 33.906 0 00-2.214-4.302 26.333 26.333 0 00-1.328-1.975h-.001c-.469-.63-.958-1.245-1.5-1.804v-.002l-.019-.017-.145-.143-.133.182-.713.98.095.11v.002l.002.002c.016.018.07.076.157.176l.132-.117.131-.118-.163-.183-.265.234c.962 1.123 1.786 2.402 2.535 3.73a33.306 33.306 0 011.975 4.173 36.749 36.749 0 012.257 9.108v.003-.002c.193 1.617.288 3.249.288 4.88 0 1.534-.084 3.068-.246 4.59v.001a32.856 32.856 0 01-2.216 9.025c-1.144 2.844-2.677 5.462-4.448 7.832l-.004.006.005-.006a38.105 38.105 0 01-5.995 6.314 35.801 35.801 0 01-3.406 2.526c-.585.381-1.181.74-1.785 1.068-.603.327-1.217.63-1.823.859h.001a5.405 5.405 0 01-.437.144h-.001v.001c-.117.034-.299.068-.472.107l-1.018.228h.001c-.678.153-1.354.314-2.03.48-1.35.33-2.693.672-4.041 1.032l.045.17-.037-.171-6.4 1.403.164.836.22 1.106.163.837 6.414-1.406.004-.001c1.38-.366 2.76-.726 4.142-1.066.69-.172 1.381-.339 2.073-.498l1.038-.232-.038-.172.036.172c.398-.084.78-.218 1.134-.358l.001-.001c1.416-.58 2.712-1.352 3.974-2.182a38.105 38.105 0 003.64-2.755l-.005.003.004-.003a40.112 40.112 0 006.35-6.874c1.873-2.575 3.474-5.44 4.649-8.543l-.002.004v-.004a35.409 35.409 0 002.197-9.783c.105-1.28.16-2.566.16-3.852 0-2.08-.142-4.159-.439-6.209v.003-.003l-.174.026-.175.025c.294 2.033.435 4.095.435 6.158 0 1.276-.054 2.553-.16 3.823v.001a35.04 35.04 0 01-2.173 9.685v.001c-1.163 3.07-2.748 5.908-4.604 8.46a39.762 39.762 0 01-6.294 6.814l.004-.003-.004.003a37.67 37.67 0 01-3.605 2.73v-.001c-1.253.824-2.528 1.584-3.913 2.15h.002a6.645 6.645 0 01-1.076.34h-.001l-1.041.234c-.695.16-1.387.327-2.079.498-1.385.341-2.767.702-4.147 1.068l.045.17-.038-.172-6.058 1.329-.095-.485-.22-1.107-.096-.495 6.066-1.33.004-.001c1.346-.36 2.687-.702 4.035-1.031.674-.165 1.347-.326 2.023-.48h.002l1.016-.227c.164-.037.346-.07.49-.111l-.05-.17.047.17c.154-.041.31-.097.466-.154h.002a15.355 15.355 0 001.867-.88 26.426 26.426 0 001.809-1.082 36.113 36.113 0 003.44-2.552 38.457 38.457 0 006.05-6.372c1.788-2.391 3.336-5.036 4.493-7.91a33.22 33.22 0 002.24-9.123v.001c.164-1.534.248-3.08.248-4.628 0-1.644-.095-3.29-.29-4.92v-.004.004a37.106 37.106 0 00-2.28-9.197 33.686 33.686 0 00-1.996-4.217v-.002.002c-.756-1.34-1.59-2.64-2.574-3.788l-.134.115-.13.119.162.181.263-.235c-.089-.1-.145-.163-.16-.178l-.13.118.134-.115-.004-.005-.134.115.142.103.63-.866.014-.018-.143-.104-.123.126.017.016.123-.126-.127.123c.525.542 1.005 1.145 1.47 1.77v-.002c.463.626.9 1.276 1.31 1.95l.002.004-.002-.003a33.515 33.515 0 012.191 4.257c1.272 2.969 2.158 6.17 2.64 9.456l.174-.025"
        ></path>
        <path
          fill="#61182d"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M140.265 167.283l.051.06c1.723 1.984 5.873 1.78 9.073-1.689 1.838-1.991 3.114-4.347 3.683-5.502-1.477-.458-5.208-1.256-8.523.953-3.564 2.378-4.18 5.307-4.284 6.178m-.77 1.034a5.185 5.185 0 01-.288-.37l-.137-.196.005-.253c.004-.178.14-4.406 4.897-7.58 4.708-3.14 9.942-.913 10.162-.816l.606.264-.286.678c-.064.15-1.576 3.69-4.27 6.612-3.737 4.05-8.543 4.128-10.688 1.66"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28211)">
            <path
              fill="url(#linearGradient28219)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2994.84 1062.52h-.05c-43.02.03-79.78 16.26-101.81 46.64.43 6.84 3.18 34.97 19.89 71.01 17.16 36.97 48.94 82.28 108.26 121.86 50.53 33.7 103.8 43.79 149.68 43.79 34.15.01 64.14-5.62 85.55-11.24 10.7-2.8 19.26-5.61 25.11-7.71 1.64-.58 3.06-1.11 4.27-1.57-9.26-20.6-49.74-105.6-114.44-175.71-54.85-59.47-120.7-87.07-176.46-87.07m190.97 271.36c-54.9 0-123.78-11.49-172.79-59.29-84.74-82.73-21.36-176.57 45.95-176.57 7.63 0 15.32 1.21 22.84 3.78 73.83 25.15 205.02 208.68 193.71 222.22 0 0-38.87 9.86-89.71 9.86"
            ></path>
          </g>
        </g>
        <path
          fill="#971a2f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M139.66 167.515l.175.004.002-.04c.012-.207.099-1.218.703-2.522.606-1.304 1.727-2.902 3.82-4.298 1.782-1.19 3.661-1.545 5.28-1.545a12.01 12.01 0 013.904.668c.103.037.182.068.236.09l.06.023.018.008.071-.161-.162-.069-.068.155c-.318.708-1.749 3.723-4.042 6.209-1.936 2.098-4.26 3.072-6.227 3.071-1.54 0-2.853-.59-3.626-1.694l-.144.101.176.004-.176-.004-.145.102c.85 1.213 2.287 1.845 3.915 1.844 2.083 0 4.492-1.024 6.486-3.185 2.672-2.898 4.17-6.456 4.175-6.465l.068-.16-.16-.07c-.013-.006-1.873-.82-4.36-.82-1.668 0-3.623.369-5.475 1.604-2.292 1.528-3.466 3.31-4.062 4.711-.597 1.401-.618 2.42-.619 2.436v.058l.032.047.145-.102"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28231)">
            <path
              fill="url(#linearGradient28239)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M3058.97 1098.02c-67.31 0-130.69 93.84-45.95 176.57 49.01 47.8 117.89 59.29 172.79 59.29 50.84 0 89.71-9.86 89.71-9.86 11.31-13.54-119.88-197.07-193.71-222.22a70.436 70.436 0 00-22.84-3.78m108.1 226.78c-33.83 0-67.79-5.72-84.83-25.3-39.84-45.8-14.25-123.29 35.36-123.29 1.36 0 2.75.06 4.15.18 52.33 4.4 140.04 137.15 140.04 137.15s-47.24 11.26-94.72 11.26"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28249)">
            <path
              fill="url(#linearGradient28257)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M3117.6 1176.21c-49.61 0-75.2 77.49-35.36 123.29 17.04 19.58 51 25.3 84.83 25.3 47.48 0 94.72-11.26 94.72-11.26s-87.71-132.75-140.04-137.15c-1.4-.12-2.79-.18-4.15-.18"
            ></path>
          </g>
        </g>
        <path
          fill="#61182d"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M147.548 136.6l.063-.012c2.098-.435 4.086-4.023 3.587-8.474-.286-2.557-1.08-4.83-1.499-5.896-1.036 1.006-3.427 3.729-3.76 7.636-.357 4.204 1.128 6.213 1.609 6.746m.243 1.171c-.123.025-.25.044-.374.054l-.19.015-.152-.133c-.108-.093-2.635-2.362-2.16-7.972.472-5.551 4.508-8.807 4.68-8.942l.47-.373.27.586c.06.128 1.464 3.2 1.884 6.952.582 5.2-1.819 9.273-4.428 9.813"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28269)">
            <path
              fill="url(#linearGradient28277)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M3108.63 1971.45c-4.75 4.76-19.98 21.47-33.03 53-1.8 23.93-7.98 49.09-18.44 73.82-1.48 12.8-2.32 26.66-2.33 41.63 0 11.52.5 23.69 1.59 36.55 6.31 74.45 37.42 133.89 67.02 174.75 14.79 20.42 29.19 36.19 39.87 46.82 5.18 5.15 9.48 9.09 12.52 11.78 9.1-21.33 38.91-96.4 48.67-183.57 1.53-13.65 2.26-27.09 2.26-40.22.01-58.97-14.73-111.79-37.28-150.22-11.26-19.22-24.47-34.82-38.64-45.85-13.48-10.5-27.78-16.84-42.21-18.49m63.16 430.35c-.09 0-.18 0-.27-.02 0 0-111.82-119.33-103.4-245.48 4.32-64.53 35.38-90.56 67.65-90.57 30.78 0 62.66 23.69 73.48 60.23 22.05 74.33-23.03 275.84-37.46 275.84"
            ></path>
          </g>
        </g>
        <path
          fill="#971a2f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M147.382 137.226l.116-.133-.002-.003c-.091-.085-1.946-1.808-1.948-5.99 0-.407.018-.836.056-1.29.223-2.626 1.32-4.723 2.365-6.164a13.63 13.63 0 011.406-1.652 10.403 10.403 0 01.576-.531l.041-.034-.109-.139-.16.074.06.135c.272.627 1.393 3.361 1.75 6.555.055.482.08.956.08 1.42 0 2.08-.52 3.943-1.315 5.299-.397.678-.863 1.228-1.363 1.617-.5.39-1.031.617-1.567.66l.015.176.116-.133-.116.133.014.175c.617-.05 1.213-.31 1.755-.733 1.624-1.27 2.811-3.987 2.814-7.195 0-.476-.026-.963-.082-1.458-.417-3.716-1.837-6.789-1.84-6.799l-.095-.203-.175.14c-.01.006-1.02.808-2.091 2.285-1.07 1.478-2.2 3.633-2.43 6.342-.04.464-.058.903-.058 1.32 0 4.43 2.044 6.238 2.072 6.259l.056.048.074-.006-.014-.175"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28289)">
            <path
              fill="url(#linearGradient28297)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M3135.77 2065.73c-32.27.01-63.33 26.04-67.65 90.57-8.42 126.15 103.4 245.48 103.4 245.48.09.02.18.02.27.02 14.43 0 59.51-201.51 37.46-275.84-10.82-36.54-42.7-60.23-73.48-60.23m35.24 319.19s-90.94-99.45-82.91-157.79c4.88-35.61 30.52-55.98 55.21-55.98 15.78 0 31.18 8.33 40.51 26.32 23.97 46.19-12.81 187.45-12.81 187.45"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28307)">
            <path
              fill="url(#linearGradient28315)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M3143.31 2171.15c-24.69 0-50.33 20.37-55.21 55.98-8.03 58.34 82.91 157.79 82.91 157.79s36.78-141.26 12.81-187.45c-9.33-17.99-24.73-26.32-40.51-26.32"
            ></path>
          </g>
        </g>
        <path
          fill="#61182d"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M128.855 178.09l.04.073c1.325 2.365 5.417 3.192 9.173.594 2.156-1.49 3.832-3.476 4.597-4.465-1.36-.814-4.863-2.519-8.5-1.178-3.916 1.441-5.048 4.152-5.31 4.976m-.939.82a5.104 5.104 0 01-.214-.433l-.098-.225.049-.245c.037-.174.936-4.274 6.16-6.197 5.17-1.903 9.883 1.57 10.08 1.719l.544.408-.404.591c-.087.13-2.206 3.217-5.37 5.405-4.386 3.034-9.098 1.921-10.747-1.023"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28327)">
            <path
              fill="url(#linearGradient28335)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2707.03 729.43h-.01c-63.53.031-116.44 29.148-138.08 76.8 1.59 6.29 8.88 31.52 29.98 61.219 23.13 32.551 62.73 70.543 129.97 95.332 28.77 10.59 57.09 14.778 83.98 14.778 51.03.011 96.9-15.149 129.97-30.368 16.54-7.609 29.87-15.222 39.04-20.91 4.34-2.691 7.75-4.949 10.12-6.582-12.72-17.758-67.67-90.777-143.6-143.258-47.03-32.539-96.72-47.011-141.37-47.011m109.49 234.269c-34.15 0-69.17-6.801-100.29-25.84-106.25-65.019-44.07-186.109 30.31-186.129 1.86 0 3.72.083 5.6.231 76.78 6.32 238.21 153.219 229.59 169.281 0 0-79.88 42.457-165.21 42.457"
            ></path>
          </g>
        </g>
        <path
          fill="#971a2f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M128.222 178.166l.172.036.002-.008c.022-.098.253-1.056 1.069-2.205.816-1.148 2.213-2.488 4.585-3.363a8.52 8.52 0 012.962-.521c1.8 0 3.419.534 4.585 1.071a12.72 12.72 0 011.378.738 9.23 9.23 0 01.466.309l.03.022.106-.141-.145-.1s-.032.047-.095.134c-.438.613-2.381 3.203-5.071 5.062-1.66 1.148-3.413 1.658-4.988 1.658-2.264 0-4.147-1.05-4.895-2.762l-.161.07.172.036-.172-.035-.162.07c.82 1.87 2.85 2.975 5.218 2.974 1.651 0 3.473-.534 5.189-1.72 3.14-2.174 5.249-5.28 5.256-5.288l.095-.14-.135-.1c-.015-.01-2.93-2.207-6.67-2.21a8.87 8.87 0 00-3.085.542c-2.52.928-3.994 2.382-4.832 3.605-.838 1.224-1.043 2.215-1.047 2.23l-.011.056.022.051.162-.07"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28347)">
            <path
              fill="url(#linearGradient28355)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2746.54 751.73c-74.38.02-136.56 121.11-30.31 186.129 31.12 19.039 66.14 25.84 100.29 25.84 85.33 0 165.21-42.457 165.21-42.457 8.62-16.062-152.81-162.961-229.59-169.281a71.235 71.235 0 00-5.6-.231m81.62 203.969c-15.55 0-29.48-2.988-39.77-10.578-48.55-35.851-35.64-121.543 16.27-130.172 1.99-.328 4.07-.488 6.22-.488 54 0 155.5 99.891 155.5 99.891s-80.39 41.347-138.22 41.347"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28365)">
            <path
              fill="url(#linearGradient28373)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2810.88 814.461c-2.15 0-4.23.16-6.22.488-51.91 8.629-64.82 94.321-16.27 130.172 10.29 7.59 24.22 10.578 39.77 10.578 57.83 0 138.22-41.347 138.22-41.347s-101.5-99.891-155.5-99.891"
            ></path>
          </g>
        </g>
        <path
          fill="#61182d"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M126.27 175.621l.071-.003c2.417-.136 5.1-3.843 5.086-8.945-.007-2.928-.623-5.623-.966-6.895-1.288.96-4.32 3.625-5.175 7.973-.92 4.676.505 7.19.984 7.87m.128 1.362a3.841 3.841 0 01-.429-.002l-.215-.015-.156-.177c-.11-.122-2.678-3.105-1.45-9.344 1.214-6.176 6.163-9.166 6.373-9.29l.576-.34.233.704c.05.155 1.254 3.854 1.266 8.15.015 5.96-3.192 10.143-6.198 10.314"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28385)">
            <path
              fill="url(#linearGradient28393)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2506.46 863.531c-1.06 0-2.12.02-3.17.059-7.23 9.199-42.85 59.211-42.86 154.65 0 25.44 2.53 54.11 8.83 86.13 16.31 82.94 58.73 144.74 97.15 185.85 19.21 20.55 37.39 35.9 50.75 46.09 6.68 5.1 12.14 8.91 15.93 11.43.14.1.28.19.42.29 7.23-24.01 32.36-114.97 32.6-216.45v-1.09c.01-76.14-20.77-143.271-51.27-191.092-15.24-23.898-32.9-42.957-51.47-55.949-18.58-13.008-37.97-19.918-56.91-19.918m120.98 474.989h-.06s-140.73-115.62-146.74-259.15c-3.39-80.44 35.03-114.241 75.49-114.241 31.75-.008 64.75 20.812 79.78 56.231 34.18 80.49 7.74 317.16-8.47 317.16"
            ></path>
          </g>
        </g>
        <path
          fill="#971a2f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M126.003 176.297l.132-.117-.002-.003c-.074-.087-1.553-1.854-1.554-5.507 0-.898.09-1.91.312-3.039.575-2.926 2.072-5.106 3.427-6.556a14.592 14.592 0 011.79-1.626 10.749 10.749 0 01.716-.503c.034-.022.051-.031.051-.031l-.09-.152-.168.055s.019.055.052.163c.23.754 1.158 4.028 1.166 7.69v.039c0 2.686-.732 5.054-1.808 6.741-.538.843-1.161 1.516-1.816 1.974-.656.459-1.34.702-2.008.702-.062 0-.125-.002-.187-.006l-.012.177.132-.118-.132.118-.012.176c.07.005.14.007.211.007.756 0 1.51-.276 2.21-.767 2.1-1.475 3.772-4.879 3.775-9.004v-.04c-.011-4.251-1.233-7.952-1.235-7.962l-.069-.208-.188.111c-.01.006-1.249.74-2.635 2.223-1.387 1.484-2.924 3.72-3.517 6.73a16.113 16.113 0 00-.318 3.106c0 3.873 1.626 5.723 1.646 5.745l.048.054.072.005.012-.176"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28405)">
            <path
              fill="url(#linearGradient28413)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2556.13 965.129c-40.46 0-78.88 33.801-75.49 114.241 6.01 143.53 146.74 259.15 146.74 259.15h.06c16.21 0 42.65-236.67 8.47-317.16-15.03-35.419-48.03-56.239-79.78-56.231m68.57 354.491s-114.69-96.77-112.85-163.87c1.22-44.53 32.35-72.89 62.71-72.89 15.38 0 30.56 7.27 41.55 23.41 32.67 48 8.59 213.35 8.59 213.35"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28423)">
            <path
              fill="url(#linearGradient28431)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2574.56 1082.86c-30.36 0-61.49 28.36-62.71 72.89-1.84 67.1 112.85 163.87 112.85 163.87s24.08-165.35-8.59-213.35c-10.99-16.14-26.17-23.41-41.55-23.41"
            ></path>
          </g>
        </g>
        <path
          fill="#61182d"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M138.549 165.041l.062-.044c2.058-1.485 2.87-6.248.748-10.705-1.219-2.558-2.874-4.568-3.698-5.488-.732 1.57-2.28 5.617-1.23 9.905 1.13 4.613 3.419 6.005 4.118 6.332m.677 1.119a4.13 4.13 0 01-.376.24l-.196.109-.208-.066c-.147-.046-3.63-1.203-5.138-7.358-1.494-6.092 1.598-11.506 1.73-11.735l.364-.623.495.484c.11.107 2.693 2.663 4.483 6.417 2.48 5.206 1.406 10.683-1.154 12.532"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28443)">
            <path
              fill="url(#linearGradient28451)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2857.32 1162.23c-6.27 2.48-26.68 11.82-50.38 36.06-27.17 27.81-58.77 75.23-78.3 154.84-7.56 30.86-10.64 61.19-10.64 90.11 0 62.25 14.26 117.99 28.54 158.13 7.14 20.07 14.28 36.23 19.62 47.35 2.25 4.69 4.18 8.47 5.66 11.29 16.83-17.57 75.72-82.46 117.53-170.27 25.43-53.36 36.79-109.3 36.78-160 .01-39.47-6.89-75.75-19.24-105.07-11.96-28.44-29.01-50.22-49.57-62.44m-86.2 486.36c-.46 0-.86-.11-1.2-.35 0 0-75.3-180.81-21.14-309.81 20.72-49.36 49.49-68.68 76.92-68.68 44.28-.01 85.08 50.31 82.99 105.81-3.32 87.62-118.97 273.03-137.57 273.03"
            ></path>
          </g>
        </g>
        <path
          fill="#971a2f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M138.597 165.784l.052-.168-.005-.002c-.076-.026-.882-.316-1.84-1.296-.96-.982-2.074-2.654-2.763-5.463a13.339 13.339 0 01-.375-3.179c0-2.196.503-4.162 1.007-5.578a17.23 17.23 0 01.692-1.67 12.138 12.138 0 01.29-.566l.02-.038-.152-.088-.123.126s.038.037.111.113c.513.528 2.677 2.863 4.2 6.06a13.24 13.24 0 011.297 5.645c0 1.393-.243 2.673-.679 3.707-.435 1.035-1.062 1.82-1.818 2.243l.086.154.053-.169-.053.169.086.154c.847-.475 1.514-1.328 1.972-2.414.457-1.087.706-2.41.706-3.844 0-1.84-.411-3.864-1.332-5.796-1.772-3.718-4.374-6.266-4.382-6.274l-.162-.16-.114.197c-.007.015-2.056 3.53-2.058 8.03 0 1.045.111 2.143.386 3.262.723 2.955 1.923 4.71 2.949 5.722 1.026 1.014 1.875 1.285 1.896 1.291l.073.023.066-.038-.086-.153"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28463)">
            <path
              fill="url(#linearGradient28471)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2825.7 1269.75c-27.43 0-56.2 19.32-76.92 68.68-54.16 129 21.14 309.81 21.14 309.81.34.24.74.35 1.2.35 18.6 0 134.25-185.41 137.57-273.03 2.09-55.5-38.71-105.82-82.99-105.81m-50.32 360.41s-60.29-149.55-30.91-207.23c12.94-25.4 34.45-37.11 55.22-37.11 26.4 0 51.61 18.94 56.52 52.8 8.71 60.45-80.83 191.54-80.83 191.54"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28481)">
            <path
              fill="url(#linearGradient28489)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2799.69 1385.82c-20.77 0-42.28 11.71-55.22 37.11-29.38 57.68 30.91 207.23 30.91 207.23s89.54-131.09 80.83-191.54c-4.91-33.86-30.12-52.8-56.52-52.8"
            ></path>
          </g>
        </g>
        <path
          fill="#61182d"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M145.018 137.15l.028-.068c.836-2.29-.643-6.2-4.104-8.15-1.986-1.118-4.048-1.585-5.041-1.76.154 1.565.793 5.396 3.408 7.86 2.814 2.65 5.066 2.298 5.71 2.117m.973.406a4.8 4.8 0 01-.167.394l-.094.194-.178.077c-.127.055-3.134 1.284-6.889-2.253-3.715-3.499-3.837-9.23-3.84-9.472l-.008-.665.565.055c.125.014 3.094.322 6.008 1.964 4.042 2.278 5.642 6.857 4.603 9.706"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28501)">
            <path
              fill="url(#linearGradient28509)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M3012.37 1953.1h-.02c-31.73.04-81.95 11.03-140.08 65.72-49.59 46.69-75.19 109.67-88.25 161.1-6.53 25.69-9.94 48.46-11.71 64.78-.89 8.16-1.36 14.7-1.62 19.19l-.06 1.1c20.12-2.74 90.05-14.64 157.52-52.7 82.07-46.1 128.58-132.88 128.48-202.46 0-18.95-3.42-36.58-10.34-51.78-4.24-1.46-16.21-4.95-33.92-4.95m-232.53 304.87c-3.47 0-5.62-.7-6.19-2.19 0 0 24.18-174.74 119.08-235.56 18.31-11.72 34.79-16.73 49.15-16.74 60.08-.01 83.27 87.65 49.83 138.23-37.36 56.5-179.99 116.26-211.87 116.26"
            ></path>
          </g>
        </g>
        <path
          fill="#971a2f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M145.376 137.655l-.07-.162h-.002c-.041.018-.5.197-1.255.197-1.12-.001-2.89-.39-4.942-2.319-1.749-1.647-2.652-3.869-3.113-5.683-.23-.906-.35-1.71-.413-2.285a13.429 13.429 0 01-.067-.919l-.176.002-.017.176.127.015c.594.076 3.16.475 5.63 1.869 2.896 1.626 4.537 4.688 4.533 7.142 0 .696-.13 1.34-.394 1.89l.159.077-.07-.162.07.162.159.076c.29-.606.43-1.304.43-2.043-.004-2.604-1.706-5.752-4.713-7.45-2.9-1.633-5.884-1.925-5.897-1.927l-.196-.02.003.198c0 .009.02 1.434.49 3.286.472 1.852 1.393 4.137 3.214 5.853 2.106 1.985 3.98 2.416 5.184 2.414.864 0 1.38-.218 1.395-.225l.061-.026.03-.06-.16-.076"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28521)">
            <path
              fill="url(#linearGradient28529)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2941.88 2003.48c-14.36.01-30.84 5.02-49.15 16.74-94.9 60.82-119.08 235.56-119.08 235.56.57 1.49 2.72 2.19 6.19 2.19 31.88 0 174.51-59.76 211.87-116.26 33.44-50.58 10.25-138.24-49.83-138.23m-156.47 242.55s21.4-143.38 67.59-167.51c7.95-4.15 15.93-6.02 23.6-6.02 36.87 0 66.49 43.17 50.02 83.51-19.95 48.68-141.21 90.02-141.21 90.02"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28539)">
            <path
              fill="url(#linearGradient28547)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2876.6 2072.5c-7.67 0-15.65 1.87-23.6 6.02-46.19 24.13-67.59 167.51-67.59 167.51s121.26-41.34 141.21-90.02c16.47-40.34-13.15-83.51-50.02-83.51"
            ></path>
          </g>
        </g>
        <path
          fill="#61182d"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M141.398 122.47l.026-.07c.837-2.289-.643-6.198-4.102-8.148-1.987-1.118-4.049-1.586-5.043-1.76.155 1.564.795 5.395 3.409 7.86 2.814 2.648 5.065 2.296 5.71 2.118m.972.403a5.02 5.02 0 01-.166.396l-.095.193-.178.078c-.125.054-3.133 1.283-6.888-2.254-3.715-3.5-3.836-9.23-3.84-9.471l-.01-.665.567.056c.125.01 3.093.32 6.008 1.964 4.041 2.276 5.642 6.856 4.602 9.703"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28559)">
            <path
              fill="url(#linearGradient28567)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2909.8 2369.23h-.02c-31.73.04-81.97 11.03-140.11 65.75-10.4 9.79-19.75 20.3-28.15 31.26 4.06.68 8.06 1.48 12.02 2.4 10.82-12.52 22.95-23.55 36.53-32.25 18.31-11.72 34.79-16.73 49.16-16.74 60.08-.01 83.26 87.62 49.83 138.2-3.01 4.56-6.7 9.14-10.97 13.71 1.75 4.26 3.32 8.6 4.7 13.02 46.06-46.79 71.27-107.37 71.2-158.63 0-18.95-3.42-36.58-10.33-51.78-4.24-1.46-16.2-4.94-33.86-4.94"
            ></path>
          </g>
        </g>
        <path
          fill="#971a2f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M141.755 122.975l-.07-.161h-.001c-.041.017-.5.196-1.253.196-1.119-.001-2.891-.39-4.942-2.32-1.75-1.647-2.654-3.87-3.115-5.683-.23-.906-.35-1.71-.413-2.285a13.288 13.288 0 01-.066-.859l-.001-.06-.177.002-.017.176s.043.004.128.015c.594.075 3.159.474 5.632 1.868 2.893 1.628 4.534 4.69 4.531 7.145 0 .695-.13 1.34-.394 1.89l.159.076-.07-.162.07.162.159.077c.29-.607.428-1.304.429-2.043-.004-2.606-1.705-5.754-4.71-7.452-2.903-1.634-5.886-1.925-5.9-1.927l-.196-.02.003.197c0 .01.02 1.434.491 3.287.472 1.852 1.393 4.136 3.215 5.853 2.106 1.986 3.982 2.417 5.185 2.415.862 0 1.377-.217 1.393-.224l.061-.027.029-.06-.16-.076"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28579)">
            <path
              fill="url(#linearGradient28587)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2839.23 2419.65c-14.37.01-30.85 5.02-49.16 16.74-13.58 8.7-25.71 19.73-36.53 32.25 57.27 13.38 103.71 52.26 124.55 102.92 4.27-4.57 7.96-9.15 10.97-13.71 33.43-50.58 10.25-138.21-49.83-138.2"
            ></path>
          </g>
        </g>
        <path
          fill="#61182d"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M145.172 152.083l.037-.062c1.22-2.04.454-6.222-2.593-8.955-1.75-1.57-3.687-2.518-4.628-2.925-.122 1.566-.165 5.47 1.965 8.505 2.29 3.267 4.556 3.459 5.219 3.437m.88.627c-.07.12-.149.238-.232.347l-.125.169-.187.031c-.134.023-3.293.51-6.35-3.849-3.027-4.312-2.144-9.95-2.106-10.189l.108-.653.544.19c.12.042 2.973 1.053 5.538 3.356 3.56 3.193 4.327 8.059 2.81 10.598"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28599)">
            <path
              fill="url(#linearGradient28607)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M3042.37 1533.13c-22.71.11-87.94 8.45-153.32 101.45-49.82 70.92-59.6 157.31-59.57 213.29 0 17.5.94 32.01 1.89 42.12.36 3.89.72 7.13 1.03 9.64 19.57-7.65 85.65-35.97 144.84-89.12 61.96-55.54 93.23-133.99 93.18-198.18.02-31.17-7.34-58.83-21.62-78.93a70.93 70.93 0 00-6.43-.27m-205.67 358.05c-1.45 0-2.44-.38-2.94-1.17 0 0-6.83-176.86 75.43-259 21.19-21.16 41.26-29.84 58.88-29.84 50.83 0 81.25 72.19 59.25 125.09-27.85 67.04-167.38 164.92-190.62 164.92"
            ></path>
          </g>
        </g>
        <path
          fill="#971a2f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M145.433 152.662l-.03-.174h-.002c-.017.002-.12.017-.292.017-.802-.004-3.103-.298-5.41-3.579-1.757-2.501-2.102-5.55-2.1-7.524a16.061 16.061 0 01.111-1.898l.02-.142-.173-.029-.059.167s.042.014.123.045c.569.216 3.012 1.22 5.19 3.175 2.186 1.96 3.289 4.727 3.287 6.991 0 1.131-.274 2.132-.807 2.846l.142.105-.03-.174.03.174.141.105c.592-.795.877-1.87.877-3.056-.002-2.375-1.141-5.22-3.404-7.253-2.55-2.288-5.42-3.286-5.433-3.292l-.198-.068-.034.207c0 .007-.137.837-.137 2.097.001 2.013.345 5.13 2.166 7.727 2.36 3.37 4.806 3.733 5.698 3.73.219 0 .345-.022.353-.023l.07-.012.042-.057-.141-.105"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28619)">
            <path
              fill="url(#linearGradient28627)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2968.07 1601.17c-17.62 0-37.69 8.68-58.88 29.84-82.26 82.14-75.43 259-75.43 259 .5.79 1.49 1.17 2.94 1.17 23.24 0 162.77-97.88 190.62-164.92 22-52.9-8.42-125.09-59.25-125.09m-124.5 276.47s-4.06-145.51 36.89-180.11c10.61-8.95 22.18-12.88 33.34-12.88 31.97 0 60.44 32.27 52.29 71.13-11 52.44-122.52 121.86-122.52 121.86"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28637)">
            <path
              fill="url(#linearGradient28645)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2913.8 1684.65c-11.16 0-22.73 3.93-33.34 12.88-40.95 34.6-36.89 180.11-36.89 180.11s111.52-69.42 122.52-121.86c8.15-38.86-20.32-71.13-52.29-71.13"
            ></path>
          </g>
        </g>
        <path
          fill="#61182d"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M78.49 173.114c-3.639-1.34-7.14.364-8.502 1.178.767.99 2.442 2.974 4.598 4.465 3.755 2.598 7.849 1.771 9.173-.594l.04-.073c-.262-.824-1.393-3.535-5.308-4.976m-4.5 6.82c-3.163-2.189-5.281-5.276-5.37-5.406l-.403-.591.545-.408c.197-.149 4.908-3.622 10.078-1.719 5.224 1.923 6.123 6.023 6.159 6.197l.05.245-.098.225a4.909 4.909 0 01-.215.433c-1.648 2.944-6.36 4.057-10.746 1.023"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28657)">
            <path
              fill="url(#linearGradient28665)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1179.1 729.43c-44.66 0-94.36 14.461-141.4 47.011-43.544 30.118-80.223 66.989-105.946 96.309-12.863 14.672-22.996 27.43-29.902 36.531a490.687 490.687 0 00-7.715 10.43c17.406 11.961 90.383 57.848 178.883 57.848h.22c26.89 0 55.21-4.188 83.97-14.778 69.42-25.59 109.38-65.242 132.17-98.468 11.38-16.614 18.44-31.614 22.64-42.422 2.1-5.403 3.49-9.75 4.34-12.719.36-1.223.62-2.211.8-2.953-21.62-47.641-74.53-76.758-138.06-76.789m-109.51 234.269c-85.317 0-165.184-42.457-165.184-42.457-8.633-16.062 152.814-162.961 229.554-169.281 1.88-.148 3.74-.231 5.61-.231 74.38 0 136.59 121.11 30.31 186.129-31.13 19.039-66.14 25.84-100.29 25.84"
            ></path>
          </g>
        </g>
        <path
          fill="#971a2f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M84.432 178.166l.173-.035c-.003-.016-.21-1.007-1.047-2.23-.838-1.224-2.312-2.678-4.832-3.606a8.873 8.873 0 00-3.084-.543c-3.74.003-6.655 2.202-6.67 2.21l-.134.102.094.139c.008.009 2.116 3.114 5.255 5.287 1.716 1.186 3.538 1.72 5.19 1.72 2.368.002 4.399-1.103 5.217-2.973l.022-.051-.011-.055-.173.035-.161-.07c-.747 1.712-2.63 2.761-4.895 2.762-1.575 0-3.328-.51-4.988-1.658-1.536-1.063-2.83-2.364-3.737-3.398a23.85 23.85 0 01-1.333-1.664c-.063-.087-.094-.134-.094-.134l-.146.1.106.14.03-.022c.317-.23 3.053-2.12 6.428-2.117.949 0 1.948.147 2.962.521 2.45.903 3.859 2.302 4.663 3.474.401.586.65 1.115.799 1.496a5.232 5.232 0 01.185.568l.007.03.002.008.172-.035-.161-.07.161.07"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28677)">
            <path
              fill="url(#linearGradient28685)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1139.57 751.73c-1.87 0-3.73.083-5.61.231-76.74 6.32-238.187 153.219-229.554 169.281 0 0 79.867 42.457 165.184 42.457 34.15 0 69.16-6.801 100.29-25.84 106.28-65.019 44.07-186.129-30.31-186.129m-81.63 203.969c-57.84 0-138.237-41.347-138.237-41.347s101.517-99.883 155.517-99.891c2.16 0 4.23.16 6.22.488 51.94 8.629 64.81 94.321 16.27 130.172-10.29 7.59-24.21 10.578-39.77 10.578"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28695)">
            <path
              fill="url(#linearGradient28703)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1075.22 814.461c-54 .008-155.517 99.891-155.517 99.891s80.397 41.347 138.237 41.347c15.56 0 29.48-2.988 39.77-10.578 48.54-35.851 35.67-121.543-16.27-130.172a38.183 38.183 0 00-6.22-.488"
            ></path>
          </g>
        </g>
        <path
          fill="#61182d"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M68.105 161.105c-3.315-2.21-7.046-1.41-8.524-.953.57 1.155 1.847 3.511 3.684 5.502 3.2 3.469 7.35 3.673 9.074 1.69l.05-.061c-.104-.87-.72-3.8-4.284-6.178m-5.634 5.55c-2.696-2.92-4.207-6.461-4.27-6.611l-.286-.678.605-.264c.22-.097 5.454-2.325 10.163.816 4.756 3.174 4.893 7.402 4.896 7.58l.004.253-.136.196c-.09.128-.187.252-.288.37-2.145 2.467-6.951 2.39-10.688-1.661"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28715)">
            <path
              fill="url(#linearGradient28723)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M891.305 1062.52c-55.766-.02-121.641 27.58-176.5 87.07-37.137 40.26-66.325 85.42-86.168 120.48-9.926 17.53-17.524 32.54-22.629 43.14a534.085 534.085 0 00-5.645 12.09c14.117 5.38 58.907 20.52 114.875 20.52h.082c45.879 0 99.16-10.1 149.696-43.79 63.269-42.21 95.203-90.96 111.468-129.13 8.121-19.09 12.305-35.53 14.457-47.15 1.075-5.81 1.641-10.41 1.938-13.54.117-1.26.195-2.29.242-3.05-22.031-30.38-58.793-46.61-101.816-46.64m-190.992 271.36c-50.84 0-89.711-9.86-89.711-9.86-11.332-13.54 119.843-197.07 193.711-222.22a70.477 70.477 0 0122.847-3.78c67.32 0 130.703 93.84 45.942 176.57-49.004 47.8-117.879 59.29-172.789 59.29"
            ></path>
          </g>
        </g>
        <path
          fill="#971a2f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M72.994 167.515l.177-.003c0-.017-.022-1.035-.618-2.436-.595-1.4-1.77-3.183-4.061-4.711-1.852-1.236-3.808-1.605-5.477-1.604-2.487 0-4.347.814-4.36.819l-.16.07.067.16c.005.01 1.504 3.568 4.176 6.465 1.994 2.162 4.403 3.185 6.486 3.185 1.627.001 3.065-.63 3.915-1.844l.033-.047-.001-.057-.177.003-.144-.101c-.773 1.103-2.086 1.692-3.626 1.694-1.968 0-4.292-.973-6.227-3.072-1.31-1.42-2.34-3.014-3.04-4.25a26.14 26.14 0 01-1.002-1.959l-.068-.154-.162.068.07.162.02-.008c.197-.083 1.94-.783 4.2-.782 1.619 0 3.498.356 5.281 1.545 2.232 1.489 3.359 3.209 3.933 4.555.286.674.434 1.254.51 1.664a5.51 5.51 0 01.077.602l.002.039.176-.004-.144-.1.144.1"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28735)">
            <path
              fill="url(#linearGradient28743)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M827.16 1098.02c-7.637 0-15.32 1.21-22.847 3.78-73.868 25.15-205.043 208.68-193.711 222.22 0 0 38.871 9.86 89.711 9.86 54.91 0 123.785-11.49 172.789-59.29 84.761-82.73 21.378-176.57-45.942-176.57M719.047 1324.8c-47.484 0-94.734-11.26-94.734-11.26s87.71-132.75 140.054-137.15c1.403-.12 2.789-.18 4.156-.18 49.633 0 75.219 77.49 35.36 123.29-17.039 19.58-51.004 25.3-84.836 25.3"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28753)">
            <path
              fill="url(#linearGradient28761)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M768.523 1176.21c-1.367 0-2.753.06-4.156.18-52.344 4.4-140.054 137.15-140.054 137.15s47.25 11.26 94.734 11.26c33.832 0 67.797-5.72 84.836-25.3 39.859-45.8 14.273-123.29-35.36-123.29"
            ></path>
          </g>
        </g>
        <path
          fill="#61182d"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M63.488 144.314c-1.779-3.33-4.958-4.528-6.266-4.895.03 1.175.18 3.624.892 6.061 1.244 4.25 4.388 6.434 6.433 5.735l.062-.023c.228-.726.796-3.297-1.12-6.878m-6.347 1.556c-1.047-3.578-.956-7.06-.951-7.206l.02-.665.562.09c.206.033 5.058.857 7.588 5.587 2.556 4.778 1.153 8.125 1.092 8.263l-.086.198-.176.084a3.053 3.053 0 01-.356.146c-2.542.87-6.24-1.533-7.693-6.497"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28773)">
            <path
              fill="url(#linearGradient28781)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M735.977 1554.04c-30.086 0-64.305 16.09-94.946 46.05-30.679 29.96-57.699 73.65-73.621 128.05-23.996 81.99-26.066 163.66-26.055 188.78 0 .69 0 1.33.004 1.93 12.184-2.68 42.469-10.65 77.266-29.51 40.195-21.78 86.336-57.98 118.074-117.33 32.106-60.03 40.485-110.96 40.492-148 0-20.76-2.64-37.15-5.261-48.31-1.309-5.57-2.614-9.84-3.578-12.68-.336-.99-.629-1.81-.872-2.45-9.765-4.39-20.304-6.53-31.39-6.53h-.113m-187.856 359.58c-13.613-5.03 22.578-211.23 70.875-266.75 14.617-16.81 34.602-25 54.254-25 45.297 0 88.82 43.53 60.711 125.42-40.316 117.4-185.84 166.33-185.84 166.33"
            ></path>
          </g>
        </g>
        <path
          fill="#971a2f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M64.994 151.668l.161.07c.008-.017.396-.914.396-2.439 0-1.36-.31-3.219-1.47-5.387-1.237-2.313-3.074-3.664-4.598-4.435-1.524-.77-2.738-.965-2.75-.967l-.199-.032-.005.2c0 .002-.004.104-.004.288 0 .906.072 3.812.934 6.759v.003-.003c.578 1.973 1.559 3.566 2.689 4.67 1.13 1.104 2.411 1.724 3.6 1.725.463 0 .91-.095 1.322-.294l.06-.029.025-.06-.161-.07-.077-.159c-.362.175-.755.26-1.169.26-1.062 0-2.271-.567-3.353-1.625-1.083-1.057-2.036-2.598-2.598-4.517-.846-2.893-.92-5.774-.919-6.66 0-.18.003-.277.003-.277l-.176-.005-.028.174.05.009c.255.047 1.46.304 2.877 1.072 1.418.768 3.046 2.045 4.165 4.139 1.133 2.118 1.429 3.914 1.429 5.221 0 .732-.093 1.31-.186 1.704a4.87 4.87 0 01-.166.56l-.011.027-.003.007.162.07-.077-.159.077.16"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28793)">
            <path
              fill="url(#linearGradient28801)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M673.25 1621.87c-19.652 0-39.637 8.19-54.254 25-48.297 55.52-84.488 261.72-70.875 266.75 0 0 145.524-48.93 185.84-166.33 28.109-81.89-15.414-125.42-60.711-125.42m-118.254 276.89s20.645-145.67 59.629-174.6c8.004-5.95 16.496-8.62 24.809-8.62 32.171 0 61.652 40 49.761 84.83-14.961 56.45-134.199 98.39-134.199 98.39"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28811)">
            <path
              fill="url(#linearGradient28819)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M639.434 1715.54c-8.313 0-16.805 2.67-24.809 8.62-38.984 28.93-59.629 174.6-59.629 174.6s119.238-41.94 134.199-98.39c11.891-44.83-17.59-84.83-49.761-84.83"
            ></path>
          </g>
        </g>
        <path
          fill="#61182d"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M66.715 129.854c-.333-3.907-2.724-6.63-3.759-7.636-.42 1.066-1.214 3.34-1.5 5.896-.5 4.45 1.49 8.04 3.587 8.474l.062.012c.482-.533 1.967-2.542 1.61-6.746m-6.28-1.896c.421-3.752 1.825-6.824 1.884-6.953l.27-.585.47.373c.172.135 4.208 3.39 4.679 8.942.476 5.61-2.05 7.88-2.159 7.972l-.153.133-.189-.015a3.278 3.278 0 01-.374-.054c-2.608-.54-5.01-4.614-4.428-9.813"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28831)">
            <path
              fill="url(#linearGradient28839)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M777.469 1971.45c-14.434 1.65-28.727 7.99-42.211 18.49-42.606 33.01-75.985 107.57-75.899 196.02 0 13.14.731 26.6 2.266 40.27 5.785 51.73 18.637 99.22 30.047 133.73 5.703 17.25 11.043 31.26 14.949 40.94a504.63 504.63 0 003.692 8.91c21.89-19.32 108.484-103.68 119.406-233.36 1.094-12.85 1.59-25.02 1.59-36.53-.004-14.94-.84-28.76-2.309-41.53-10.492-24.77-16.68-49.96-18.48-73.93a215.062 215.062 0 00-7.184-15.6c-6.957-13.62-13.891-23.41-19.035-29.76-2.571-3.18-4.699-5.49-6.16-6.99l-.672-.66m-63.172 430.35c-14.371 0-59.492-201.51-37.426-275.84 10.813-36.54 42.692-60.23 73.477-60.23 32.265 0 63.328 26.04 67.636 90.57 8.457 126.15-103.418 245.48-103.418 245.48-.089.02-.179.02-.269.02"
            ></path>
          </g>
        </g>
        <path
          fill="#971a2f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M65.271 137.226l.116.133c.028-.02 2.075-1.829 2.073-6.26 0-.416-.018-.855-.057-1.318-.23-2.71-1.36-4.865-2.43-6.342-1.071-1.477-2.082-2.28-2.091-2.287l-.176-.139-.094.203c-.004.01-1.425 3.083-1.842 6.8-.055.495-.082.982-.082 1.459 0 2.139.532 4.058 1.363 5.477.417.709.908 1.294 1.45 1.716.543.423 1.14.684 1.756.734l.074.006.056-.05-.116-.132.015-.176c-.536-.043-1.067-.27-1.567-.66-1.503-1.164-2.68-3.795-2.678-6.915 0-.464.026-.938.08-1.42.204-1.826.658-3.5 1.06-4.718a24.16 24.16 0 01.692-1.838l.06-.134-.16-.074-.11.138.041.034c.427.353 3.932 3.425 4.347 8.347.039.454.056.883.056 1.29 0 2.16-.496 3.661-.987 4.623-.245.48-.49.825-.671 1.05-.09.112-.166.193-.218.246l-.058.058-.014.013-.004.003.116.133.015-.176-.015.176"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28851)">
            <path
              fill="url(#linearGradient28859)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M750.348 2065.73c-30.785 0-62.664 23.69-73.477 60.23-22.066 74.33 23.055 275.84 37.426 275.84.09 0 .18 0 .269-.02 0 0 111.875-119.33 103.418-245.48-4.308-64.53-35.371-90.57-67.636-90.57m-35.235 319.19s-36.797-141.26-12.832-187.45c9.336-17.99 24.742-26.32 40.532-26.32 24.699-.01 50.343 20.37 55.23 55.98 8.027 58.34-82.93 157.79-82.93 157.79"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28869)">
            <path
              fill="url(#linearGradient28877)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M742.813 2171.15c-15.79 0-31.196 8.33-40.532 26.32-23.965 46.19 12.832 187.45 12.832 187.45s90.957-99.45 82.93-157.79c-4.887-35.61-30.531-55.99-55.23-55.98"
            ></path>
          </g>
        </g>
        <path
          fill="#61182d"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M87.368 167.75c-.856-4.347-3.887-7.012-5.176-7.972-.343 1.271-.957 3.967-.966 6.895-.013 5.101 2.67 8.809 5.087 8.945l.073.003c.476-.68 1.901-3.194.982-7.87m-7.31-1.084c.012-4.295 1.215-7.994 1.266-8.149l.233-.705.577.34c.209.125 5.158 3.115 6.373 9.291 1.227 6.24-1.341 9.222-1.452 9.345l-.155.176-.215.015c-.142.01-.285.01-.43.002-3.005-.17-6.213-4.355-6.197-10.315"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28889)">
            <path
              fill="url(#linearGradient28897)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1379.63 863.531c-18.94 0-38.34 6.91-56.91 19.918-55.82 38.93-102.84 132.851-102.75 247.101l.01 1.03c.15 59.32 8.79 115.06 17.4 155.91 4.3 20.43 8.6 37.14 11.81 48.73 1.35 4.88 2.51 8.85 3.4 11.81 12.01-7.97 42.45-29.84 74.34-65.76 36.38-40.97 74.61-100.14 89.9-177.9 6.3-32.03 8.84-60.71 8.84-86.15-.01-53.47-11.19-92.63-22.3-118.4-5.54-12.871-11.08-22.398-15.19-28.672-2.05-3.128-3.75-5.449-4.92-6.968l-.47-.59a85.399 85.399 0 00-3.16-.059m-120.96 474.989c-16.2 0-42.66-236.67-8.48-317.16 15.04-35.419 48.04-56.231 79.79-56.231 40.46 0 78.88 33.801 75.5 114.241-6.01 143.53-146.75 259.15-146.75 259.15h-.06"
            ></path>
          </g>
        </g>
        <path
          fill="#971a2f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M86.65 176.297l.132.117c.02-.021 1.646-1.871 1.646-5.744 0-.92-.092-1.956-.319-3.107-.592-3.009-2.129-5.246-3.515-6.73-1.387-1.483-2.625-2.216-2.635-2.222l-.189-.112-.068.208c-.003.01-1.225 3.711-1.236 7.963v.038c0 2.75.747 5.18 1.864 6.932.558.876 1.21 1.583 1.91 2.074.701.49 1.455.766 2.21.766.07 0 .141-.002.212-.007l.072-.005.048-.054-.132-.117-.012-.176a2.918 2.918 0 01-.187.006c-.668 0-1.353-.244-2.008-.703-1.97-1.373-3.628-4.686-3.625-8.717v-.036c.006-2.093.31-4.06.614-5.5a28.406 28.406 0 01.554-2.19l.05-.164-.167-.055-.09.152.052.032c.261.163 1.477.964 2.76 2.409 1.284 1.445 2.633 3.533 3.172 6.276a15.74 15.74 0 01.312 3.039c0 1.886-.395 3.268-.787 4.177-.195.454-.39.79-.536 1.011-.072.11-.132.193-.173.246l-.047.059-.012.013-.002.003.132.118-.012-.177.012.177"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28909)">
            <path
              fill="url(#linearGradient28917)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1329.98 965.129c-31.75 0-64.75 20.812-79.79 56.231-34.18 80.49-7.72 317.16 8.48 317.16h.06s140.74-115.62 146.75-259.15c3.38-80.44-35.04-114.241-75.5-114.241m-68.54 354.491s-24.12-165.35 8.59-213.35c10.98-16.14 26.16-23.41 41.53-23.41 30.35-.01 61.48 28.36 62.71 72.89 1.86 67.1-112.83 163.87-112.83 163.87"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28927)">
            <path
              fill="url(#linearGradient28935)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1311.56 1082.86c-15.37 0-30.55 7.27-41.53 23.41-32.71 48-8.59 213.35-8.59 213.35s114.69-96.77 112.83-163.87c-1.23-44.53-32.36-72.9-62.71-72.89"
            ></path>
          </g>
        </g>
        <path
          fill="#61182d"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M78.223 158.71c1.051-4.289-.498-8.336-1.23-9.906-.824.92-2.479 2.93-3.697 5.488-2.125 4.457-1.31 9.22.748 10.705l.061.044c.7-.327 2.988-1.719 4.118-6.332m-5.948-5.081c1.788-3.754 4.372-6.31 4.482-6.417l.494-.485.364.624c.133.229 3.225 5.643 1.731 11.735-1.51 6.155-4.99 7.312-5.137 7.358l-.21.066-.193-.109a3.94 3.94 0 01-.378-.24c-2.558-1.85-3.634-7.327-1.153-12.532"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28947)">
            <path
              fill="url(#linearGradient28955)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1028.79 1162.23c-20.56 12.22-37.61 34-49.575 62.44-12.348 29.32-19.242 65.59-19.238 105.06-.004 50.71 11.351 106.65 36.777 160 24.686 51.8 55.286 95.63 79.706 126.46 12.21 15.42 22.87 27.59 30.46 35.89 2.97 3.25 5.47 5.9 7.41 7.93 11.99-22.82 53.81-110.27 53.77-216.74 0-28.93-3.07-59.27-10.64-90.14-20.15-82.18-53.16-130.06-80.91-157.47-13.87-13.7-26.45-22.28-35.49-27.42-4.52-2.57-8.15-4.28-10.62-5.33-.63-.27-1.18-.5-1.65-.68m86.19 486.36c-18.6 0-134.21-185.41-137.542-273.03-2.114-55.5 38.692-105.81 82.982-105.81 27.43 0 56.2 19.32 76.92 68.68 54.14 129-21.15 309.81-21.15 309.81-.34.24-.75.35-1.21.35"
            ></path>
          </g>
        </g>
        <path
          fill="#971a2f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M74.057 165.784l.053.168c.02-.006.87-.277 1.897-1.29 1.026-1.013 2.225-2.768 2.949-5.723.274-1.119.385-2.218.385-3.264-.002-4.499-2.05-8.013-2.056-8.028l-.115-.196-.161.159c-.008.008-2.611 2.556-4.384 6.274a13.598 13.598 0 00-1.332 5.797c0 1.433.25 2.757.707 3.843.457 1.086 1.124 1.94 1.97 2.414l.067.037.073-.023-.053-.168.086-.154c-.756-.422-1.383-1.208-1.818-2.243-.436-1.034-.679-2.314-.679-3.706 0-1.789.4-3.762 1.298-5.645.87-1.827 1.95-3.373 2.811-4.46.431-.545.807-.974 1.075-1.267a15.813 15.813 0 01.425-.447l-.123-.126-.152.088.02.038c.217.386 1.99 3.697 1.988 7.813 0 1.021-.108 2.091-.375 3.18-.71 2.9-1.875 4.589-2.854 5.556-.49.483-.933.786-1.252.967a3.682 3.682 0 01-.473.227l-.024.008-.006.002.053.169.086-.154-.086.154"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28967)">
            <path
              fill="url(#linearGradient28975)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1060.42 1269.75c-44.29 0-85.096 50.31-82.982 105.81 3.332 87.62 118.942 273.03 137.542 273.03.46 0 .87-.11 1.21-.35 0 0 75.29-180.81 21.15-309.81-20.72-49.36-49.49-68.68-76.92-68.68m50.28 360.41s-89.51-131.09-80.76-191.54c4.88-33.86 30.08-52.8 56.48-52.8 20.77-.01 42.28 11.71 55.23 37.11 29.36 57.68-30.95 207.23-30.95 207.23"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath28985)">
            <path
              fill="url(#linearGradient28993)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1086.42 1385.82c-26.4 0-51.6 18.94-56.48 52.8-8.75 60.45 80.76 191.54 80.76 191.54s60.31-149.55 30.95-207.23c-12.95-25.4-34.46-37.12-55.23-37.11"
            ></path>
          </g>
        </g>
        <path
          fill="#61182d"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M73.345 135.032c2.614-2.464 3.254-6.295 3.408-7.86-.993.175-3.055.642-5.041 1.76-3.46 1.95-4.94 5.86-4.103 8.15l.026.067c.645.181 2.895.533 5.71-2.117m-2.08-7.183c2.914-1.642 5.883-1.95 6.008-1.963l.567-.056-.01.665c-.003.242-.124 5.973-3.84 9.473-3.753 3.536-6.762 2.307-6.888 2.252l-.179-.077-.093-.194a4.693 4.693 0 01-.167-.394c-1.04-2.849.56-7.428 4.602-9.706"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29005)">
            <path
              fill="url(#linearGradient29013)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M873.746 1953.1c-11.398 0-20.414 1.44-26.531 2.86a77.82 77.82 0 00-6.93 1.93l-.476.17c-6.918 15.2-10.336 32.81-10.336 51.75-.094 69.58 46.433 156.38 128.484 202.48 40.055 22.58 80.953 35.96 111.793 43.67 15.42 3.86 28.33 6.3 37.36 7.77 3.34.55 6.15.96 8.36 1.26-.72-13.78-3.74-50.86-15.98-94.84-13.75-49.47-39.16-107.55-85.68-151.33-58.115-54.69-108.33-65.68-140.064-65.72m232.554 304.87c-31.9 0-174.542-59.76-211.909-116.26-33.418-50.58-10.246-138.23 49.851-138.23 14.367 0 30.856 5.02 49.172 16.74 94.866 60.82 119.086 235.56 119.086 235.56-.58 1.49-2.73 2.19-6.2 2.19"
            ></path>
          </g>
        </g>
        <path
          fill="#971a2f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M67.278 137.655l-.07.162c.017.007.532.226 1.396.226 1.203 0 3.078-.43 5.183-2.415 1.822-1.716 2.744-4.001 3.214-5.853.471-1.853.491-3.277.492-3.286l.002-.197-.196.019c-.014.002-2.996.295-5.897 1.928-3.007 1.697-4.709 4.846-4.712 7.45 0 .739.138 1.436.429 2.042l.028.06.061.026.07-.162.159-.076c-.264-.55-.395-1.195-.395-1.89-.003-2.454 1.638-5.517 4.533-7.143 1.413-.796 2.856-1.269 3.944-1.54a16.203 16.203 0 011.687-.329l.127-.015-.017-.176-.176-.002-.002.06c-.01.308-.085 1.744-.57 3.489-.485 1.745-1.382 3.794-3.023 5.338-2.05 1.93-3.821 2.317-4.94 2.319-.403 0-.721-.05-.937-.101a2.725 2.725 0 01-.244-.068l-.06-.022-.014-.005h-.003l-.07.162.16-.077-.16.077"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29025)">
            <path
              fill="url(#linearGradient29033)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M944.242 2003.48c-60.097 0-83.269 87.65-49.851 138.23 37.367 56.5 180.009 116.26 211.909 116.26 3.47 0 5.62-.7 6.2-2.19 0 0-24.22-174.74-119.086-235.56-18.316-11.72-34.805-16.74-49.172-16.74m156.478 242.55s-121.251-41.34-141.197-90.02c-16.507-40.34 13.114-83.51 50.007-83.51 7.67 0 15.66 1.87 23.61 6.02 46.17 24.13 67.58 167.51 67.58 167.51"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29043)">
            <path
              fill="url(#linearGradient29051)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1009.53 2072.5c-36.893 0-66.514 43.17-50.007 83.51 19.946 48.68 141.197 90.02 141.197 90.02s-21.41-143.38-67.58-167.51c-7.95-4.15-15.94-6.02-23.61-6.02"
            ></path>
          </g>
        </g>
        <path
          fill="#61182d"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M76.966 120.351c2.614-2.464 3.254-6.295 3.409-7.858-.993.173-3.055.64-5.042 1.759-3.46 1.95-4.94 5.86-4.103 8.148l.026.07c.645.178 2.895.53 5.71-2.119m-2.08-7.181c2.915-1.644 5.883-1.953 6.008-1.964l.567-.056-.01.665c-.002.242-.125 5.971-3.84 9.471-3.754 3.537-6.762 2.308-6.888 2.254l-.18-.078-.092-.193a4.42 4.42 0 01-.166-.396c-1.042-2.847.56-7.427 4.6-9.703"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29063)">
            <path
              fill="url(#linearGradient29071)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M976.328 2369.23c-11.383 0-20.387 1.44-26.496 2.86-3.051.7-5.383 1.4-6.922 1.92l-.465.16c-6.902 15.2-10.312 32.82-10.312 51.76-.098 69.61 46.398 156.4 128.457 202.53h.01c40.03 22.58 80.93 35.97 111.78 43.67 15.42 3.86 28.33 6.29 37.36 7.76 3.34.55 6.16.96 8.37 1.26-.72-13.78-3.74-50.86-15.98-94.84-13.75-49.47-39.18-107.55-85.7-151.33l-.01-.01c-58.12-54.71-108.36-65.7-140.092-65.74m232.642 304.91c-31.92 0-174.58-59.76-211.943-116.29-33.418-50.58-10.234-138.2 49.863-138.2 14.36 0 30.85 5.02 49.16 16.74 94.88 60.8 119.12 235.55 119.12 235.55-.58 1.5-2.73 2.2-6.2 2.2"
            ></path>
          </g>
        </g>
        <path
          fill="#971a2f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M70.899 122.975l-.07.163c.017.007.531.224 1.394.224 1.203.001 3.079-.429 5.185-2.415 1.821-1.716 2.743-4.001 3.214-5.853.471-1.853.491-3.277.491-3.286l.003-.198-.196.02c-.014.002-2.997.294-5.898 1.927-3.007 1.698-4.707 4.847-4.71 7.452 0 .74.137 1.436.427 2.043l.03.06.06.026.07-.163.159-.075c-.264-.551-.394-1.196-.394-1.89-.004-2.456 1.637-5.518 4.532-7.145 1.412-.797 2.855-1.27 3.943-1.54a16.17 16.17 0 011.687-.329l.128-.015-.017-.176-.176-.002-.002.06a15.87 15.87 0 01-.57 3.489c-.485 1.745-1.382 3.794-3.024 5.338l-.002.002.002-.002c-2.05 1.93-3.823 2.318-4.942 2.32-.402 0-.72-.051-.935-.101a2.584 2.584 0 01-.244-.068l-.06-.021-.014-.005-.002-.001-.07.162.16-.076-.16.076"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29083)">
            <path
              fill="url(#linearGradient29091)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1046.89 2419.65c-60.097 0-83.281 87.62-49.863 138.2 37.363 56.53 180.023 116.29 211.943 116.29 3.47 0 5.62-.7 6.2-2.2 0 0-24.24-174.75-119.12-235.55-18.31-11.72-34.8-16.74-49.16-16.74m156.48 242.53s-121.28-41.33-141.23-90.05c-16.49-40.3 13.17-83.44 50.05-83.45 7.67 0 15.64 1.87 23.59 6.02 46.15 24.07 67.59 167.48 67.59 167.48"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29101)">
            <path
              fill="url(#linearGradient29109)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1112.19 2488.68c-36.88.01-66.54 43.15-50.05 83.45 19.95 48.72 141.23 90.05 141.23 90.05s-21.44-143.41-67.59-167.48c-7.95-4.15-15.92-6.02-23.59-6.02"
            ></path>
          </g>
        </g>
        <path
          fill="#61182d"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M72.701 148.646c2.13-3.035 2.087-6.94 1.966-8.505-.943.407-2.88 1.356-4.629 2.925-3.047 2.733-3.812 6.915-2.593 8.955l.037.062c.663.022 2.927-.17 5.22-3.437m-3.29-6.534c2.566-2.303 5.417-3.314 5.54-3.356l.543-.19.107.653c.04.238.92 5.877-2.106 10.189-3.057 4.359-6.216 3.872-6.35 3.85l-.187-.032-.126-.168a4.21 4.21 0 01-.23-.348c-1.518-2.54-.75-7.405 2.809-10.598"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29121)">
            <path
              fill="url(#linearGradient29129)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M843.734 1533.13c-2.793 0-4.941.13-6.359.26l-.07.01c-14.27 20.09-21.621 47.75-21.614 78.91-.043 64.19 31.231 142.66 93.172 198.2 35.293 31.67 73.02 54.55 101.887 69.46 14.44 7.46 26.65 12.93 35.24 16.53 3.05 1.28 5.64 2.32 7.71 3.13 1.11-9.02 2.92-27.5 2.92-51.73.02-55.97-9.75-142.38-59.565-213.32-65.383-93-130.61-101.34-153.321-101.45m205.686 358.05c-23.26 0-162.783-97.88-190.635-164.92-21.976-52.9 8.434-125.09 59.254-125.09 17.613 0 37.688 8.68 58.867 29.84 82.284 82.14 75.454 259 75.454 259-.49.79-1.49 1.17-2.94 1.17"
            ></path>
          </g>
        </g>
        <path
          fill="#971a2f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M67.221 152.662l-.03.174c.01 0 .135.022.354.022.892.004 3.338-.358 5.698-3.73 1.821-2.597 2.164-5.714 2.165-7.727 0-1.26-.135-2.09-.137-2.096l-.033-.207-.199.068c-.012.006-2.88 1.004-5.432 3.292-2.262 2.033-3.402 4.879-3.404 7.254 0 1.186.286 2.26.877 3.055l.042.057.07.012.03-.174.14-.105c-.531-.714-.806-1.714-.806-2.845-.001-2.264 1.102-5.033 3.287-6.992 1.245-1.117 2.576-1.924 3.594-2.45a17.327 17.327 0 011.596-.725l.122-.045-.057-.167-.175.029s.008.048.02.142a15 15 0 01.113 1.897c0 1.975-.344 5.023-2.102 7.526-2.306 3.28-4.607 3.575-5.409 3.578-.098 0-.174-.005-.224-.009l-.055-.006-.013-.002h-.002l-.03.174.142-.105-.142.105"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29141)">
            <path
              fill="url(#linearGradient29149)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M918.039 1601.17c-50.82 0-81.23 72.19-59.254 125.09 27.852 67.04 167.375 164.92 190.635 164.92 1.45 0 2.45-.38 2.94-1.17 0 0 6.83-176.86-75.454-259-21.179-21.16-41.254-29.84-58.867-29.84m124.491 276.47s-111.479-69.42-122.495-121.86c-8.152-38.86 20.309-71.12 52.27-71.13 11.156 0 22.734 3.93 33.335 12.88 40.96 34.6 36.89 180.11 36.89 180.11"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29159)">
            <path
              fill="url(#linearGradient29167)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M972.305 1684.65c-31.961.01-60.422 32.27-52.27 71.13 11.016 52.44 122.495 121.86 122.495 121.86s4.07-145.51-36.89-180.11c-10.601-8.95-22.179-12.88-33.335-12.88"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29177)">
            <path
              fill="url(#linearGradient29185)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2232.86 753.551c34.36 94.359 92.8 260.039 91.5 292.099.13 3.55-.65 5.48-2.52 5.48-.33 0-.69-.05-1.08-.17-26.55-8.04-170.06-101.062-193.01-101.069-.95 0-1.69.168-2.21.5-4.48 2.879-26.84 34-54.45 71.549 2.62 2.97 5.12 5.97 7.52 9.02-41.08 55.61-90.67 120.41-110.85 128.97-.77.61-1.69.92-2.79.92-.18 0-.37-.01-.56-.03-.19.02-.38.03-.56.03-1.09 0-2.01-.31-2.78-.92-.97-.41-2.02-.96-3.13-1.62-2.01 1.4-3.84 2.47-5.48 3.16-.77.61-1.69.92-2.77.92h-.01c-.19 0-.38-.01-.58-.03-.2.02-.39.03-.58.03h-.01c-1.08 0-1.99-.31-2.75-.92-34.4-14.58-154.2-192.54-171.76-209.931-41.57 16.391-157.65 90.721-181.24 97.871-.39.12-.75.18-1.08.18-1.52 0-2.32-1.28-2.5-3.66-4.99 2.46-8.98 4.2-11.73 5.03-.07.02-.13.04-.2.05-.31.08-.61.12-.88.12-1.86 0-2.64-1.93-2.52-5.46-1.32-31.78 56.36-195.549 90.82-290.229-11.29 3.52-23.74 6.379-37.35 8.188-9.59 22.461-18.06 43.453-25.5 62.992-1.46 3.84-2.88 7.609-4.27 11.34-1.93 5.187-3.78 10.289-5.57 15.269-31.61 88.379-40.85 144.321-42.02 176.76-.68 19.16 1.44 30.12 3.43 34.72.05.1.09.2.13.3 4.72 10.67 13.44 17 22.94 17 2.13 0 4.3-.32 6.48-.98 12.9-3.92 40.2-19.56 83.67-44.74 30.35-17.59 78.65-45.571 98.37-53.509 7.5 9.629 20.25 26.999 31.83 42.799 40.28 54.95 71.14 95.79 94.94 123.35 4.77 5.53 9.27 10.53 13.49 15 5.61 5.92 10.74 10.92 15.45 15 1.45 1.25 2.85 2.41 4.21 3.49 4.14 3.27 7.92 5.76 11.39 7.47 3.78 2.23 7.95 3.38 12.25 3.38h1.1c4.01 0 8.48-1.14 12.28-3.38 3.47-1.71 7.25-4.2 11.39-7.47 1.36-1.08 2.77-2.24 4.21-3.49 4.71-4.08 9.85-9.08 15.45-15 4.22-4.47 8.72-9.47 13.49-15 23.8-27.56 54.66-68.4 94.94-123.35 11.59-15.78 24.32-33.17 31.83-42.799 19.72 7.938 68.01 35.919 98.35 53.509 43.49 25.18 70.8 40.82 83.7 44.74.17.05.33.09.49.14 2 .56 4 .83 5.97.83 8.71 0 16.78-5.32 21.69-14.43.49-.91.95-1.86 1.38-2.84 4.76-11 10.29-58.4-23.78-167.378a1113.534 1113.534 0 00-13.59-40.661c-1.86-5.269-3.82-10.679-5.85-16.191-1.39-3.758-2.82-7.578-4.29-11.449-7.75-20.473-16.62-42.5-26.75-66.199-13.82-2.172-26.37-5.411-37.69-9.301"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29195)">
            <path
              fill="url(#linearGradient29201)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1724.19 725.609c-14.17 10.422-33.89 21.832-59.52 29.832-34.46 94.68-92.14 258.449-90.82 290.229.26-6.98 4.07-20.22 10.15-37.25l1.17.05c3.52-1.07 9.11-3.64 16.2-7.29 8.74-23.719 21.27-53.711 34.61-84.25 35.93-7.149 74.29-11.09 114.19-11.09 128.9 0 242.07 40.39 306.54 101.27 37.23-48.77 71-95.649 76.55-99.219.52-.332 1.26-.493 2.22-.493 19.76 0 129.12 69.102 175.92 93.322 7.71 20.73 12.66 36.93 12.96 44.93 1.3-32.06-57.14-197.74-91.5-292.099-22.3-7.649-39.83-17.813-52.82-27.242-17.35 110.14-112.93 194.652-227.88 194.652-115.18 0-210.92-84.871-227.97-195.352m403.56 224.282c-.95 0-1.7.16-2.22.5-4.47 2.879-26.83 34-54.45 71.549h.01c27.61-37.549 49.97-68.67 54.45-71.549.52-.332 1.26-.5 2.21-.5m-538.57 96.039c-4.99 2.46-8.99 4.2-11.73 5.03-.07.02-.13.03-.2.05.07-.01.13-.03.2-.05 2.75-.83 6.74-2.57 11.73-5.03m368.76 112.37c-2.01 1.41-3.85 2.48-5.49 3.17-.76.61-1.68.92-2.76.92 1.08 0 2-.31 2.77-.92 1.64-.69 3.47-1.76 5.48-3.16v-.01m-8.84 4.06c-.2.02-.4.03-.59.03h.01c.19 0 .38-.01.58-.03"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29211)">
            <path
              fill="url(#linearGradient29219)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2127.76 949.891h-.01c22.95.007 166.46 93.029 193.01 101.069.39.12.75.17 1.08.17 1.87 0 2.65-1.93 2.52-5.48-.14 3.54-1.02 5.45-2.73 5.45-.27 0-.55-.05-.86-.14-26.55-8.04-170.07-101.062-193.01-101.069m-353.75 1.648h-.01c17.56 17.391 137.36 195.351 171.76 209.931.76.61 1.67.92 2.75.92-1.08 0-1.99-.31-2.75-.92-34.39-14.58-154.2-192.54-171.75-209.931m-200.16 94.131c-.12 3.53.66 5.46 2.52 5.46.27 0 .57-.04.88-.12-.23.06-.45.09-.66.09-1.71 0-2.59-1.9-2.74-5.43m375.25 116.69c.2.02.39.03.58.03h.01c-.19 0-.39-.01-.59-.03"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29229)">
            <path
              fill="url(#linearGradient29235)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2135.48 907.398c-.96 0-1.7.161-2.22.493-5.55 3.57-39.32 50.449-76.55 99.219 5.1 4.81 9.9 9.76 14.37 14.83 27.62-37.549 49.98-68.67 54.45-71.549.52-.34 1.27-.5 2.22-.5h.01c22.94.007 166.46 93.029 193.01 101.069.31.09.59.14.86.14 1.71 0 2.59-1.91 2.73-5.45-.3-8-5.25-24.2-12.96-44.93-46.8-24.22-156.16-93.322-175.92-93.322m-349.72 40.954c-2.55 0-6.57 1.136-11.75 3.187 17.55 17.391 137.36 195.351 171.75 209.931.76.61 1.67.92 2.75.92.19 0 .39-.01.59-.03.2.02.4.03.59.03 1.08 0 2-.31 2.76-.92 1.64-.69 3.48-1.76 5.49-3.17-39.2-23.66-158.93-202.359-169.96-209.448-.52-.34-1.27-.5-2.22-.5m-184.39 52.828c-7.09 3.65-12.68 6.22-16.2 7.29l-1.17-.05c-6.08 17.03-9.89 30.27-10.15 37.25.15 3.53 1.03 5.43 2.74 5.43.21 0 .43-.03.66-.09.07-.02.13-.03.2-.05 2.74-.83 6.74-2.57 11.73-5.03-.52-6.94 4.28-23.27 12.19-44.75"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29245)">
            <path
              fill="url(#linearGradient29253)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1770.45 949.891c-20.57 0-138.06 74.779-181.27 96.039.18 2.38.98 3.66 2.5 3.66.33 0 .69-.06 1.08-.18 23.59-7.15 139.67-81.48 181.24-97.871-.54-.539-.99-.93-1.33-1.148-.52-.332-1.27-.493-2.22-.5m300.64 72.049c-39.15 53.23-88.86 119.39-113.15 136.37 1.11.66 2.16 1.21 3.13 1.62.77.61 1.69.92 2.78.92.18 0 .37-.01.56-.03.19.02.38.03.56.03 1.1 0 2.02-.31 2.79-.92 20.18-8.56 69.77-73.36 110.85-128.97-2.4-3.05-4.9-6.05-7.52-9.02"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29263)">
            <path
              fill="url(#linearGradient29269)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1750.17 905.84c-39.9 0-78.26 3.941-114.19 11.09-13.34 30.539-25.87 60.531-34.61 84.25 46.32-23.821 156.88-93.789 176.79-93.789.96 0 1.7.16 2.22.5 11.35 7.32 140.98 196.049 176.44 211.069v.9-.9c18.14-7.68 60.91-60.81 99.89-111.85-64.47-60.88-177.64-101.27-306.54-101.27m20.28 44.051c-20.56 0-138.05 74.769-181.27 96.039 43.21-21.26 160.7-96.039 181.27-96.039m300.63 72.049c-39.14 53.23-88.85 119.38-113.14 136.36v.01c24.29-16.98 74-83.14 113.15-136.37h-.01"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29279)">
            <path
              fill="url(#linearGradient29287)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1770.45 949.891c.95.007 1.7.168 2.22.5.34.218.79.609 1.33 1.148h.01c-.55-.539-1-.93-1.34-1.148-.52-.332-1.27-.5-2.22-.5"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29297)">
            <path
              fill="url(#linearGradient29303)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1778.16 907.391c-19.91 0-130.47 69.968-176.79 93.789-7.91 21.48-12.71 37.81-12.19 44.75 43.22-21.27 160.71-96.039 181.27-96.039.95 0 1.7.168 2.22.5.34.218.79.609 1.34 1.148 5.18-2.051 9.2-3.187 11.75-3.187.95 0 1.7.16 2.22.5 11.03 7.089 130.76 185.788 169.96 209.448 24.29-16.98 74-83.13 113.14-136.36-4.47-5.07-9.27-10.02-14.37-14.83-38.98 51.04-81.75 104.17-99.89 111.85v.9-.9c-35.46-15.02-165.09-203.749-176.44-211.069-.52-.34-1.26-.5-2.22-.5"
            ></path>
          </g>
        </g>
        <path
          fill="#61182d"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M114.699 182.643l.006.086c.212 2.817 3.486 5.804 7.846 5.587 2.503-.124 4.782-.948 5.856-1.398-.87-1.468-3.27-4.904-7.018-5.731-4.034-.89-6.127.874-6.69 1.456m-1.159.205a5.665 5.665 0 01-.014-.5l.004-.253.143-.189c.103-.132 2.55-3.25 7.932-2.061 5.327 1.175 8.078 6.837 8.192 7.077l.315.66-.595.299c-.13.066-3.244 1.618-6.917 1.8-5.092.254-8.796-3.328-9.06-6.833"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29315)">
            <path
              fill="url(#linearGradient29323)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2390.48 503.359c-62.75-.007-118.33 22.93-158.14 57.141-25.98 22.32-45.18 49.371-55.38 77.871a230.731 230.731 0 015.73 60.348c20.33 17.082 61.7 42.703 127.06 42.703 18.73 0 39.45-2.102 62.26-7.133 70.98-15.641 125.41-62.59 162.06-105.887 18.32-21.632 32.18-42.3 41.43-57.531 4.63-7.621 8.11-13.883 10.42-18.211.44-.82.83-1.57 1.18-2.25-19.09-8.922-96.4-42.43-183.7-46.738-4.34-.211-8.65-.313-12.92-.313m-40.68 215.75c-121.16 0-111.65-147.05-41.74-183.687 20.61-10.801 52.53-14.953 87.32-14.953 83.78 0 184.22 24.082 183.44 37.453 0 0-104.43 159.816-227.34 161.18-.56.007-1.12.007-1.68.007"
            ></path>
          </g>
        </g>
        <path
          fill="#971a2f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M114.11 182.36l.14.108.003-.004c.08-.1 1.643-2.029 5.01-2.029.661 0 1.392.074 2.197.252 2.504.551 4.424 2.208 5.717 3.735a16.152 16.152 0 011.461 2.03 13.412 13.412 0 01.49.878l.159-.076-.08-.157-.136.066c-.631.297-3.387 1.505-6.504 1.66a9.987 9.987 0 01-.456.01c-2.213 0-4.174-.809-5.578-2.016-1.406-1.207-2.249-2.808-2.248-4.381v-.072l-.176-.003.14.107-.14-.107-.176-.003v.078c0 1.702.902 3.388 2.37 4.649 1.468 1.261 3.508 2.101 5.808 2.101.157 0 .315-.004.474-.012 3.652-.182 6.769-1.757 6.78-1.762l.155-.078-.074-.156c-.004-.009-.678-1.422-2-2.984-1.322-1.56-3.296-3.274-5.91-3.852a10.539 10.539 0 00-2.273-.26c-1.81 0-3.134.538-4.001 1.078-.869.54-1.283 1.081-1.293 1.094l-.035.046-.001.058.176.003"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29335)">
            <path
              fill="url(#linearGradient29343)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2395.38 520.469c-34.79 0-66.71 4.152-87.32 14.953-69.91 36.637-79.42 183.687 41.74 183.687.56 0 1.12 0 1.68-.007 122.91-1.364 227.34-161.18 227.34-161.18.78-13.371-99.66-37.453-183.44-37.453m25.79 165.332c-1.06 0-2.1-.039-3.14-.129-57.28-4.793-80.5-87.442-38.23-123.711 14.56-12.481 40.7-16.57 68.74-16.57 53.52 0 113.96 14.91 113.96 14.91s-84.09 125.5-141.33 125.5"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29353)">
            <path
              fill="url(#linearGradient29361)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2448.54 545.391c-28.04 0-54.18 4.089-68.74 16.57-42.27 36.269-19.05 118.918 38.23 123.711 1.04.09 2.08.129 3.14.129 57.24 0 141.33-125.5 141.33-125.5s-60.44-14.91-113.96-14.91"
            ></path>
          </g>
        </g>
        <path
          fill="#61182d"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M91.871 181.187c-3.749.827-6.147 4.263-7.018 5.73 1.074.45 3.353 1.275 5.855 1.4 4.36.216 7.634-2.771 7.847-5.588l.005-.086c-.563-.582-2.655-2.347-6.689-1.456m-1.212 8.494c-3.672-.182-6.787-1.734-6.916-1.8l-.595-.298.315-.661c.114-.24 2.865-5.902 8.19-7.077 5.383-1.19 7.831 1.929 7.934 2.061l.143.19.003.251c.004.166-.002.334-.013.5-.265 3.506-3.968 7.088-9.06 6.834"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29373)">
            <path
              fill="url(#linearGradient29381)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1512.81 503.359h-.02c-4.28 0-8.58.102-12.92.313-50.48 2.5-97.64 14.738-132.11 26.367-17.23 5.813-31.3 11.461-41.04 15.66a395.974 395.974 0 00-10.56 4.723c6.45 12.348 26.71 48.648 60.11 86.129 36.45 40.898 88.44 83.07 154.99 97.738 22.81 5.031 43.53 7.133 62.26 7.133 49.33-.012 84.86-14.563 108.15-29.043 8.14-5.059 14.77-10.109 19.94-14.539-.08-2.508-.12-5.02-.12-7.559 0-17.179 1.89-33.929 5.47-50.062-10.03-29.168-29.49-56.918-56.03-79.719-39.81-34.199-95.39-57.141-158.12-57.141m40.65 215.75c-.55 0-1.11 0-1.68-.007-122.91-1.364-227.33-161.18-227.33-161.18-.78-13.371 99.65-37.453 183.44-37.453 34.79 0 66.71 4.152 87.32 14.953 69.91 36.637 79.41 183.687-41.75 183.687"
            ></path>
          </g>
        </g>
        <path
          fill="#971a2f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M99.15 182.36l.14-.106c-.01-.013-.424-.554-1.292-1.094-.868-.54-2.191-1.078-4.002-1.078-.687 0-1.444.078-2.272.26-2.615.579-4.589 2.292-5.91 3.852-1.323 1.562-1.996 2.976-2 2.985l-.074.155.154.078c.011.005 3.129 1.58 6.78 1.763.16.008.318.012.474.012 2.3 0 4.34-.84 5.81-2.102 1.466-1.26 2.368-2.947 2.369-4.65v-.077l-.001-.058-.036-.046-.14.107-.176.003v.072c.001 1.574-.841 3.175-2.247 4.382-1.405 1.207-3.365 2.016-5.579 2.016-.15 0-.302-.004-.456-.011-1.78-.088-3.444-.52-4.66-.93a19.204 19.204 0 01-1.844-.73 6.444 6.444 0 01-.136-.066l-.079.158.16.076.029-.06a15.53 15.53 0 012.17-3.136c1.286-1.443 3.12-2.93 5.468-3.448a10.185 10.185 0 012.196-.251c1.74 0 2.994.513 3.816 1.024.41.255.712.51.91.7.1.095.172.173.22.228l.053.061.012.015.003.004.14-.107-.176.003.176-.003"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29393)">
            <path
              fill="url(#linearGradient29401)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1507.89 520.469c-83.79 0-184.22 24.082-183.44 37.453 0 0 104.42 159.816 227.33 161.18.57.007 1.13.007 1.68.007 121.16 0 111.66-147.05 41.75-183.687-20.61-10.801-52.53-14.953-87.32-14.953m-25.79 165.332c-57.24 0-141.33-125.5-141.33-125.5s60.44-14.91 113.96-14.91c28.04 0 54.18 4.089 68.74 16.57 42.27 36.269 19.05 118.918-38.24 123.711-1.03.09-2.08.129-3.13.129"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29411)">
            <path
              fill="url(#linearGradient29419)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1454.73 545.391c-53.52 0-113.96 14.91-113.96 14.91s84.09 125.5 141.33 125.5c1.05 0 2.1-.039 3.13-.129 57.29-4.793 80.51-87.442 38.24-123.711-14.56-12.481-40.7-16.57-68.74-16.57"
            ></path>
          </g>
        </g>
        <path
          fill="#ef391f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M106.648 175.816a6.43 6.43 0 00-6.423 6.423 6.43 6.43 0 006.423 6.423 6.43 6.43 0 006.424-6.423 6.43 6.43 0 00-6.424-6.423"
        ></path>
        <path
          fill="#ef391f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M106.648 177.53a4.714 4.714 0 00-4.708 4.71 4.714 4.714 0 004.708 4.708 4.714 4.714 0 004.71-4.709 4.714 4.714 0 00-4.71-4.709m0 12.846c-4.487 0-8.137-3.65-8.137-8.137s3.65-8.138 8.137-8.138c4.488 0 8.138 3.65 8.138 8.138 0 4.487-3.65 8.137-8.138 8.137"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29433)">
            <path
              fill="url(#linearGradient29441)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1949.11 523.27c-52.3 0-99.29 22.531-131.86 58.41-24.32 29.539-38.92 67.351-38.92 108.601 0 47.239 19.14 89.957 50.09 120.918 28.81 28.793 67.79 47.36 111.11 49.801.3-.551.61-1.109.93-1.68-86.9-4.5-155.97-76.371-155.97-164.41v-.461-.129c0-.308 0-.621.01-.929v-.153-.398-.11c.01-.128.01-.25.01-.378v-.2c.01-.101.01-.191.01-.293v-.277c.01-.094.01-.172.01-.273 0-.079 0-.161.01-.25v-.18c0-.16.01-.316.01-.481v-.117c.01-.109.01-.222.01-.332v-.008c2.12-71.402 49.72-131.39 114.83-151.992a162.825 162.825 0 0149.39-7.648h.33c89.6 0 162.46 71.59 164.55 160.66 0 .031 0 .059.01.09v.281c0 .07 0 .129.01.188v.371c0 .089.01.168.01.269v.199c0 .102 0 .211.01.321V693.391c0 .14.01.289.01.429V694.91c0 57.949-29.93 108.899-75.16 138.238.4.762.81 1.532 1.21 2.293a172.184 172.184 0 0030.49-24.242c30.95-30.961 50.08-73.679 50.09-120.918-.01-38.691-12.84-74.351-34.5-103-32.65-39.121-81.75-64.011-136.73-64.011m85.13 313.3a166.323 166.323 0 01-33.61 15.141v1.738a169.875 169.875 0 0034.72-15.34l-1.11-1.539m-33.64 15.149c-.03.011-.05.023-.08.031v1.742a.663.663 0 01.11-.031v-.07l-.03-1.672m-.21.07c-15.67 5.024-32.37 7.75-49.72 7.75h-1.56c-1.87 0-3.74-.027-5.6-.09l-1.39 1.68c2.39.101 4.79.152 7.21.152 17.82 0 34.99-2.722 51.13-7.769-.02-.543-.04-1.121-.07-1.723"
            ></path>
          </g>
        </g>
        <path
          fill="#971a2f"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M112.758 182.24h-.177a6.014 6.014 0 01-1.767 4.265 6.013 6.013 0 01-4.266 1.766 6.013 6.013 0 01-4.265-1.766 6.013 6.013 0 01-1.767-4.266c0-1.666.675-3.173 1.767-4.265a6.012 6.012 0 014.265-1.767c1.667 0 3.174.675 4.266 1.767a6.015 6.015 0 011.767 4.265h.353a6.385 6.385 0 10-12.771 0 6.385 6.385 0 0012.771 0h-.176"
        ></path>
        <path
          fill="#b11e2d"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M112.816 182.16a6.289 6.289 0 00-3.053-5.088l.13-.244a6.285 6.285 0 012.937 5.323c0-.052-.007-.103-.008-.155 0 .055-.004.11-.006.165m-12.552 0a4.496 4.496 0 01-.006-.165c0 .052-.008.103-.008.155a6.29 6.29 0 019.527-5.395l-.165.228a6.238 6.238 0 00-1.254-.534v-.044.044h-.004v-.044l-.001.043a6.284 6.284 0 00-2.079-.26l-.231-.28c.04.083.09.178.147.284a6.286 6.286 0 00-5.926 5.968"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29455)">
            <path
              fill="url(#linearGradient29463)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1949.33 519.289c-47.23 0-89.95 19.133-120.91 50.082a170.384 170.384 0 00-11.17 12.309c32.57-35.879 79.56-58.41 131.86-58.41 54.98 0 104.08 24.89 136.73 64.011a172.225 172.225 0 00-15.59-17.91c-30.96-30.949-73.68-50.082-120.92-50.082"
            ></path>
          </g>
        </g>
        <path
          fill="#5c1f2b"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M106.54 188.441a6.29 6.29 0 01-6.29-6.29c0 .054.008.107.009.161 0-.05.003-.101.006-.151a6.272 6.272 0 001.624 3.91 6.013 6.013 0 004.66 2.201 6.013 6.013 0 004.815-2.4 6.27 6.27 0 001.452-3.711c.003.05.005.1.006.151.002-.054.01-.107.01-.161a6.29 6.29 0 01-6.29 6.29"
        ></path>
        <path
          fill="#6d1d2d"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M112.822 182.312a3.799 3.799 0 00-.006-.151l.006-.165c0 .052.008.103.008.155 0 .054-.007.107-.008.161m-12.563 0c-.001-.054-.008-.107-.008-.161 0-.052.006-.103.008-.155 0 .055.003.11.006.165l-.006.151"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29477)">
            <path
              fill="url(#linearGradient29485)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1949.11 530.301h-.13c30.36.039 58.72 8.461 83.14 22.828l-19.32 33.883c-18.78-11.153-40.61-17.68-64.02-17.68-22.98 0-44.43 6.25-62.94 17.008l.09.148c-37.3 21.782-62.42 62.141-62.42 108.422l.11 2.281-39.02-.05-.11-2.231c0 88.039 69.07 159.91 155.97 164.41.01-.031.03-.058.05-.09-23.26-1.441-45.17-7.789-64.85-17.878l20.25-33.512c16.58 8.051 35.1 12.699 54.76 12.699 4.42 0 8.78-.23 13.08-.687 4.65-7.59 9.28-15.032 13.46-21.704a108.604 108.604 0 01-23.26 3.293h-.02c-.09 0-.18 0-.27.008h-.05c-.16 0-.3.012-.46.012h-.12c-.07 0-.14.008-.21.008h-.34c-.12.011-.23.011-.34.011h-.12c-.09 0-.18 0-.27.008h-1.61c-59.36-.136-107.56-47.859-108.43-107.066 0-.34-.01-.692-.01-1.043v-.109-.489-.41-.101-.09-.219-.148c0-.094 0-.184.01-.274v-.16-.231-.046-.133c.01-.129.01-.258.01-.387v-.203c.01-.059.01-.129.01-.188v-.242c.01-.051.01-.097.01-.148 0-.09 0-.172.01-.262v-.129c.71-23.308 8.78-44.75 21.95-62.121 19.72-27.559 52.01-45.527 88.48-45.527 60.04 0 108.7 48.679 108.7 108.73 0 1.149-.01 2.297-.05 3.449 3.02-3.48 4.97-5.711 5.37-6.121.04-.031.06-.05.07-.05.18 0-1.99 3.652-5.59 9.511-1.5 24.289-10.97 46.418-25.83 63.797a109.824 109.824 0 01-8.48 9.332v.09c-.51.5-1.02.988-1.54 1.48 8.27 4.809 19.5 7.86 34.78 8.989 18.4 1.371-21.85-1.969-42.6 11.703 5.77 10.828 14.03 26.348 21.54 40.476 45.23-29.339 75.16-80.289 75.16-138.238l-.11 2.36-39.02.199.13-2.559c0-46-24.82-86.101-61.71-107.988l19.36-33.84c47.56 27.996 79.91 79.047 81.3 137.879-2.09-89.07-74.95-160.66-164.55-160.66m-49.72 7.648c-65.11 20.602-112.71 80.59-114.83 151.992 1.75-58.539 34.15-109.293 81.64-137.05l-.09-.161a166.385 166.385 0 0133.28-14.781m-114.83 152c0 .11 0 .223-.01.332.01-.109.01-.222.01-.332m-.01.449c0 .165-.01.321-.01.481 0-.16.01-.316.01-.481m329.12.653v0m-329.13.008c-.01.089-.01.171-.01.25 0-.079 0-.168.01-.25m329.14.461v0m-329.16.062v0m-.01.57v0m329.18.008v0m.01.52v0m-329.2.05v0m329.2.508v0m-329.2 0v0m329.21.582v0m-329.22.5v0m329.22 0v0m-105.06 106.91c-1.26 2.04-2.33 4.27-3.24 6.641 1.98-.973 3.93-1.98 5.85-3.043l-2.61-3.598m-18.68 2.192l-11.62 14.008c5.17-1.18 10.21-2.68 15.12-4.481-1.04-3.469-2.21-6.758-3.5-9.527m-46.41 55.969l-.05.058c1.86.063 3.73.09 5.6.09h.79c-2.13-.008-4.24-.059-6.34-.148"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29495)">
            <g transform="matrix(212.2 0 0 198.2 1856.9 571.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAApCAYAAABOScuyAAAABHNCSVQICAgIfAhkiAAAA9hJREFUWIXNl1F6GyEMhEfr7Sn62vufrDfIoukDEpIwu3bSOAnf59pZWPgZjQSVv7//ED+1SfxU+96/BeRRS6C0j7efB2ywDplhiZ8GnGBnUG8/A3jhVW+z0t8PfKIqUGG/H/gisWZVv9cSUv9cWWAFr/be1wJ/UFVN730d8AOvXqma2+uBL1RdPTuDVZvotcAPDoGzPi1lTkr/64AnZeffz1rA+/3zGuALvwKPVQWqsq+rw++oAgVuATsfGp8P/I7j9coCDjuDevsc4Cm5clspTQB8h6qw8Z/j4ZPkWsG68u+BZRJD8b/AD66DunjGi5KlF6DePgb8wK/L+8ETJSvDzvN8/L9ITyTXHdBFyXJVxT5NTiLzoZNuAbvy6BnsDJqn1YWqoXxUjqeBKTbxNOEMXZ7LNSgSaLEEqrIZ/Cnglf/mBcrzkoxyB5RBgRqtM1BAMrDgXqcKewWYv+eLyxLUskqFp6CKLa0REdrPYTdQdAkVC2yg6cOimEzj+t/NHuZNhYqbjZHUl+cZSefLxI6uIH3iuQT5Aj4mS9CQlMwR4w00lQN0OkToG9mg3RK3tHyFg08KjInrBlwBAbkVeB/jZYsCgBvIOn9W1GHJbczdIGNMm5PuTimDnTdSQsUbAEAlrBUwKWE6caoSYn0KuChpbh0Wcej+zt5V3GMhabX8lLJzs3Hh7Q6aNsUbWvI+F372TaitnRVX6zuKsv25EtiziqX8iIWG1Xd3oNzKu+U+UKqEh5mpjMnYlNpmmsFm0INhnX1ACrvB2QuHEosqYRPzF0hARE9BwZuVLUnqrUCjOqiNCUVl/N3snX1c7ewoI2ohB3qY745iO/MraE9g8v4W5i95RJsFyEEJwQGaojJK42HAAHBQusLOW4/dDeQ23JpBI6nc0/4vx0LdozYyJZWWcBso+3qanh++BgVHEmb3UkTuxQIrRckdZBuFPyoIR5jdhzMoDNYzngaTVW6msoO2ZAua93dNFSKHMGAsKQkouKi1AtoYLT29z8Pp9ZSIE+9IoA6vMEUZCeseBlLSDVD69YKpanD0B8x9mKvSvZaOBALDixBTO6vs4LFO7neL7M1PICBK1LgWZlBLJN46lLA8D0V74jko7TcTqDJs435t6QScQd0+CmD3szqDNtNJuQPSDCbKkWZIrwgSZSnC2Df0xl6+PPyu3kH3tQuzodGjQAOtt75xNFNiV8TW7w7DFgEqdhLBFGkSUSh+4w3HUHoNOm51VgkA4A0AmctdTc69paQiOmT2oieVN11890m3lO3dKG+Igq8GlRNRiVGyDnp0K2C3lwzl/wErUDfAy9NzSwAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29507)">
            <path
              fill="url(#linearGradient29515)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2033.87 836.07a164.194 164.194 0 01-33.24 15.25v.391a166.323 166.323 0 0033.61-15.141l-.37-.5m-33.27 15.262c-.03.008-.06.02-.08.027v.391c.03-.008.05-.02.08-.031v-.387m-.23.07c-15.89 5.207-32.86 8.059-50.47 8.137h.77c17.35 0 34.05-2.726 49.72-7.75-.01-.129-.01-.258-.02-.387"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29525)">
            <path
              fill="url(#linearGradient29533)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2011.26 804.828c-1.92 1.063-3.87 2.07-5.85 3.043-4.96 12.899-5.03 29.711-4.87 40.32.02-.73.06-1.722.09-2.691v5.82c11.71-3.859 22.85-9 33.24-15.25l-22.61-31.242m-115.35 3.012l-20.25 33.512c19.68 10.089 41.59 16.437 64.85 17.878 6.11-11.082 14.72-25.48 23.24-39.378-4.3.457-8.66.687-13.08.687-19.66 0-38.18-4.648-54.76-12.699m97.56 5.109a123.985 123.985 0 01-15.12 4.481l-34.79 41.961c2.1.089 4.21.14 6.34.148 17.61-.078 34.58-2.93 50.47-8.137-.13-2.601-.37-5.73-.76-9.16 0 0-2.15-15.992-6.14-29.293m7.07 35.242c-.01.52-.02.899-.02 1.059v2.109c.02-.007.05-.019.08-.027-.02-.973-.04-2.019-.06-3.141"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29543)">
            <path
              fill="url(#linearGradient119690)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1863.7 627.289c-13.17 17.371-21.24 38.813-21.95 62.121.7-22.73 8.4-43.64 20.99-60.762.32-.457.64-.91.96-1.359"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29561)">
            <g transform="matrix(44.2 0 0 40.2 1856.9 595.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAICAYAAAArzdW1AAAABHNCSVQICAgIfAhkiAAAAEpJREFUGJV9jzEOwDAIA89RX9639IsdkTuUSChK8MAAZwN678cAiKPGPxRYR/LCalKUkNbmbBjCCa0xUQ0TChqNUsv+/eHd72n+AK36CzhBtaRnAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29573)">
            <path
              fill="url(#linearGradient119692)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1841.75 689.539c-.01.09-.01.172-.01.262 0-.09 0-.172.01-.262m-.02.41v0m-.01.43v0m-.01.59v0m0 .41v0m-.01.434v0m0 .457V692.281v-.011m112.25 109.171h-.02.02m-.29.008h-.05.05m-.51.012h-.12.12m-.33.008h-.17.17m-.34 0c-.12.011-.23.011-.34.011.11 0 .22 0 .34-.011m-.46.011c-.09 0-.18 0-.27.008.09-.008.18-.008.27-.008m-.38.008h-.36.36m-.44 0h-.28.28m-.41 0h-.37.37"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29591)">
            <g transform="translate(1832.9 682.9) scale(126.2)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAABHNCSVQICAgIfAhkiAAAADRJREFUSIljfCOt8p+BDoCJHpaMWjRq0ahFoxaNWjRq0ahFoxaNWkRzwEJT0xkh1H8GBgYANIkDYKqYqDkAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29603)">
            <g transform="translate(1832.9 682.9) scale(126.2)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAABHNCSVQICAgIfAhkiAAAAQtJREFUSIm1llsSgyAMRW8c9r+vznRHrUk/gJCglZfmA2diODcPFenzegtmjChehbrCwzA4w3vTk5bQLNjArXkh245F8FFoBj4x1dA7zBm4F3oIHBGxCCIyQjeDAcD2KqwKWPjVEPrfoxMwgEv4sJCAhsFdQrNZN4WeAHsTBND2CLi24YehF6x3mh/VG+DWBoTGwANCa+CG0L3wSuicsAqOWNGj3lU0DBddElAAECB8gIYmXM8rNrAqKyfI/poYoQ8mxs8lvoIBbPZtCRl9ASxpwx8YuIxRfTvAyZn5Gi4lRsT8Be3sYbYSPmkPUeUvMxI3B9YCY+v4axy6+Ha4inajIWVv3ko5SRMD4AfFUJ6CgyU6UQAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29615)">
            <g transform="matrix(112.2 0 0 188.2 1923.9 576.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAnCAYAAADkUNMNAAAABHNCSVQICAgIfAhkiAAAAwNJREFUSIl9Vm0SLCkIC+rsHfYOe/9TvSOMZH8Agh/zrJrqaZvGJERs+fPvf8QaAqDcbiPmO4C5P5JHHBtGPqH/ZA9Cz1t5LLzC5ZgAxiMqE1Y0ckxhAFDH8GZryTk8wRl03C90junFBG29O1bia/BBtZan/Gcv9zk/bnTtCnreU/CUb+cgWD+2vyS9RL+H/oOarxT0RFZr/X0sesRcbmIk5x54Z7kTihuAciUFP/hR0NPr4sHluTwKG4uU2IZrhGbArTP3ZHF9ocfyeam6KN76ttIdCMj8IUnKO9J6sWLVt+1klmIFLU875jjK3YrPNRPHcwkpmi8QTB/DGld4+9S5UOZZmh+d84gLXz2CWtE30J1Je8oiXwezbf94r2p39wkrViSKeX28kwwG1H25XMJChha4Ns68FwScZYlxpmNRjiujz9SX9bh6wk3OKl31eaFiD345IGQ5WFYmy776aFxRFP14wwLuXv1j8YhxQmMvXsttLXokDVt2rK4RiwNZo8Jy7P4+i6UrcDGoC56n0cauttyFoOh2na3HlR8HUF3GFTHsBB9JkcCtadyfuziclgnpzyw5RyI7T3N2bJ2ualw5cIC+B4iKPGwl3BNW+sJUQnIxbpEZG3PZW57bP4eKGFECAk1TVtb8gJx2fuD1aQEAoiA/vt0DYWLUpbF1U0JAdhB6FjRe6pmIYvSPhVUIRscM9LLrTI9RAUYgJJgfWCWpYoCYgIgnU0tWDgmCUPTlltls4UGho6zFEbeU+Z0FXeirHI50mjRCfBF+IRTAsD+27VkOhUVV8kQimztbUndPCrGvdouxb/ihQkPpGlul6ZJYSyC7yVEYzkgm/hzE9EUJYgoxNLwg9q1ort+9v0rrKCck59jxlQATgIDJgUHXVR2FUdWtBopmqCAg5pr/+teAAkuuiew2Y5amtD6i3CWAWrAUpFvStrqOJdUtbiydfVtRBETDFwREFgoAVjh0KLOgFWnGNZDAUHxAhqVgSQHoOkYHpu8DhRxInaVTnujLDBOC/wFbuQofFAbggwAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29627)">
            <g transform="matrix(20.2 0 0 16.2 2015.9 763.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAABHNCSVQICAgIfAhkiAAAABVJREFUCJljfCOt8p8BCTAxoAEMAQBpoAIwUr2JIQAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29639)">
            <g transform="matrix(126.2 0 0 179.2 1856.9 605.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAlCAYAAABcZvm2AAAABHNCSVQICAgIfAhkiAAAAi9JREFUSIntVkt25DAIBInOJWab+58sR0irZqFfgbCnk0VeFsN7fu22gCqgJFs//rxDfsDKT4D8B/rNQDqubwHpF3wxrm8B8W54FVQZ6CtMM1Cf2N9jAulN0KvGyXHcl5zZHuLrIHdE9W5GMfBunOxbh29163YfyJXdzYOrb5J1IwAxa4Rftnqxzs9UVlVQsZ28XQAw41hdBLmeraWBqCL6TBIz2PBbj5ukNnxsJx+Yin45phSkEEE511xylSgec+UuViTXydoRSBSJOALvt8Uwk6wAC5VFu1LjJAnh2fbWoY5qdLRGTxAY6YNZ88yKf67PRcTWbBa7CVZ3QFxzVsZMMtvtN/ewvRHjWTolXkIgMWgb4PAVoW5f/RTrf3RUkCQ/WiJhfbJ+hCWfw3ZeUhTsBMsM1avSCYD9jFvHuz+2i9ZQvPux2S3dvNYZ5drfSpv77DMBEBGpoQF8fE2gaGnbuCX/aC2rkmZrvS1TyqymDO/irbIIzHiaG9KvIGyQZrKPp4t9guGD4XN5khRu3X539E5dHZiTG4Fnp8jkLSrQp1gfpHp58uGJsw2ptccByP9sM8LJjt83h80OmAg0lQZUegdQ6FDtKOMgvLA5E9onh17wEEjrWqJF20fPAEpZ65FxfoKAlAhqLcKduQworl3QdqgcogK8LThOCNG92/AQUOVbDCEZ84HUkTD6xeGrAPubjmPcDmwqogO0Bz0cnIiG6sarQNuoBgL3ph4qRpG/GGQDKbj191wAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29651)">
            <g transform="matrix(15.2 0 0 15.2 1832.9 682.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAABHNCSVQICAgIfAhkiAAAAB5JREFUCJljfCGj8v8/AwQwwRgMDAwMTDDGfwYGBgCNxgUqyczF5wAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29663)">
            <g transform="matrix(102.2 0 0 35.1999 1885.9 768.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAHCAYAAADnCQYGAAAABHNCSVQICAgIfAhkiAAAABlJREFUKJFjfCOt8p+ByoCJ2gaOGjqEDAUAFPcCOPfJFCwAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29675)">
            <g transform="matrix(39.2 0 0 20.2 1943.9 787.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAABHNCSVQICAgIfAhkiAAAABVJREFUCJljfCOt8p8BD2DCJ0kdBQAawQIyQqBohAAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29687)">
            <g transform="matrix(39.2 0 0 78.2 1832.9 619.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAQCAYAAAArij59AAAABHNCSVQICAgIfAhkiAAAAIZJREFUKJFtkUESQyEIQ18Y77/vCXrE7kwXgqXMz4wOQkgU9Xm9TUECAqLiE/JPuAdAnRCjeLCmSMEabZabjS5rnUJcT1f7NqC02E32akbue3inSlku90vKTKzHJwBs8CT4CgiVRcv2+WAJ3OfQVkc8JZ0Z97+wckjpYwtj1tavryZpABkZvnZFM2psW3zhAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29699)">
            <g transform="matrix(30.2 0 0 35.1999 1851.9 605.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAHCAYAAAArkDztAAAABHNCSVQICAgIfAhkiAAAAD9JREFUCJl1jTEKACEQA2cW/1/fR3yblayFd4icpklgGGJ7ahKAAoBzB5eUNV0tB8OfsZMyT91Z/4wOxAszQRl8ngdljvOG3AAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29711)">
            <g transform="translate(1832.9 682.9) scale(126.2)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAABHNCSVQICAgIfAhkiAAAAbRJREFUSImNVkuSJSEIzCTq/ieYXR+yd9ILQcCCN48IwxIRUn4Wf//9KJxIQGifNJ4cHg4PAMTWtHMAlIBIyFLPvqAQrxmAAlga3zAjHZE932AhhtECVH2tprgBEZZ70pDd0FRjFPSc0ReFG9wGeRvfIAWqiZHnD7QMkPLDpdxLW+B5K44AFi2OWDDEQs7RjmzXR0V94qS4ZJq4Qkcjji8Qu64JMcQC3AA79nrXyzbAXvlJiEQvset2jRoSeKoBSQb6QxVUK9DwSibM7ijcKQ4vj0RW6iKeOT+/SPMXIuaMLsgkFmkQIU2fhzj63sr16CPoGX0xueh2wJHr6jEEnkHdW78VLI++po5e6KxMIU0gso+VZkDS5hfprnzVU13l5nj1PlL7ECmB5Ukw9D4W13mnzs/D5pPXaZUq9qH1JNidry84EOi6W9AXRJxMnZMh+VjXKGUKO+N2VZvMUG4QQ7vPtVX6Wuc3N5xfWGW8riPieeu//xFf7Y5GnNkd905S/zO+bGg5YaY6clcllQs7fnpDKoXSvaKdAacdW1Xdd1pZkDnrss3xLYjhF1iIH8wkd0KnW/APGB+L5Rhb0ZAAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29723)">
            <g transform="matrix(126.2 0 0 54.2 1861.9 749.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAALCAYAAABhwJ3wAAAABHNCSVQICAgIfAhkiAAAANpJREFUOI2FU0kSwyAMk5z8/xO99YW9FPUQQU1wEs9kAG+SieDn9RYIW2DsgwDj2NNOOqcvJIAY4REjj+SQz4EdZ+PiqU0B6OgtIYGdctwzjXCHYIbyN5Ey6z7NRa99+JW8Mn5LweBcz0TgytKoiYaLmlm3qjLm3MX65FWlCHyjDK5NCmsAGiHd/9xVDCXGFQgfxBPjigOCp4k1j0wg/UcWnZk3kVYcE6ufKsbagFaAV2Qerg0gdpBQ62/MbG77E49qm56MVaeWgpw07iX88Ahg+4eyKiupn3j8AFz7MLulo//JAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29735)">
            <g transform="matrix(39.2 0 0 20.2 1943.9 787.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAABHNCSVQICAgIfAhkiAAAADdJREFUCJlly7ENgEAUw9CXE/tPQsV0dKH4BSdw51jJfV4lJJIQdFxZNtpOHAPrHb7M99jlR+IBYXILaZOfRmgAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29747)">
            <g transform="matrix(145.2 0 0 179.2 1842.9 624.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAlCAYAAABVjVnMAAAABHNCSVQICAgIfAhkiAAAA4dJREFUWIV9V1uSGzEIbGbw5iqp3P9cOUDsgXwIUIvRWFW73pV40zwsf//8dtiJOuKAC/xCO7L9E5esNH6M90sAB8avoJEQ6i8ofCodykiQncBhC+/tFL8DlkQy74ruACyMEkD9LcPLfCzCJ00A7AWIAe/m7WKQDEX1tFqvIzxflACA6/j8RPhcgGPDw4aXPeS1YURIAK1o3OSEkM9xN0wccAf8xZczh6UoI3lOmji6WuvAdXSa1SMjw3Y0F4ArDbK9LHcoTAFPabvwEXhub/kzaPw6IF+y5lE9Ag51HktrI3QFDJYglM+9JndMbAgmtqJIdFW2cwkDVKbz7isWZSit2sUEpM+ca4GIj4WCxaCHYq5gDMR78nMp2xkGzMsJLktmsvQuHW665lGu0Xi8kdqxCmldTPFPRzN4DJ9jaal5+4k/MmBOqej87ElgQ5f3VG6vASzKlVsky7msj9mdnox2NrrXcSEwGmlY6csA8InkW6dr+U9l0r2fRwfaonN+UggAkRCwY05F+cY9/ikC6VQodscYYeVs5oIFd70vQD43YbdjPyHjAOS9POlobzZr7OlUKr6cWz94Mlyhz48n1pw/KH1sPnwE8PReAFyE6rBk5Mv4kj7DEGdBKTu7Up/RvpUXqHoCURgjFzYjZjUo69hB47F1FVdSvFsCXPsFlnBLr09gzMMEKdG7Yo7HC1kBUcfR3jJc4hQA3pt4RLYIFc9JFeHToOIb/49lryxkr6hv95ksPcy8PjVFt6pMj6VZ7+fMUX8bl5QrbzM7DY3ahdKkyrynxzWR+kpKn7ehn17VKELt1NODQZejLAEaRuveM8Nc5CzeaZCX4HOmodBM7VSC316A/yIDQA1ksfaYhgjVYKE532niC9EmWGu2B/AkUuNHlJP4qqBy1fJZCjnU3Fiy26UsmsViEaEX4IDuO2Fn2OU9lWze0gn7iWHCWBhsuoKHPc8FPReA9Dy8k1xBWCkGHfcFMfCulZEJcD305lQmUrmZ7dAAHGtnYq/S+Kpl2sHEstCSKPM0aZYtYgFPRolSsQyKxIkS79ybFDixgCFLJ4nF5rfDxQAelR6guSK8GbllQVt4tPK6QD9C7Aflvy/LIIBtolO6qM5pE9EZqlSW/zvJjEhYn1p3T4aNSl53OqRihFc7gGEK/Po1JxtGp+m1mjSCuws1i2XN640uwtzb5G3N3X8T/Q9Z69MZjP7XBwAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29759)">
            <g transform="translate(1832.9 682.9) scale(126.2)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAABHNCSVQICAgIfAhkiAAAAaJJREFUSImdVUuWIzEIEw7XmNXc/2h9hC71okxZYDvOi1cpwJL4mNjPv//EN+e5ZbPP5g8/AZHjllmgL8DruV5JzyASDF47oGwn1fNa2EeAg1k13hSSk2/c4+4y202USI7nXWwlybH7Hm3BV4BnsQciWwADQDsC35pG3w5ESvJBiQX4i9KdwBtG5nX8x/cXRA2gAfGmjIvqErV3HxK9kNCehxtkeMZ4GC4h2mZUm83F766YtUxKhqdvnoxLMEKVTXEGIQNA7+WchmE1TUV1si/iAxyQsubjGVjBazZALof4NuAqdFG61b4qwzDFxKqPUZ8A4Pst2geCu+2AMmm7Q4CuU/fhWol39BY7NsQor+8JIovwF/D6UOmyGucKlHfUFbBhLaD7jWWvtUVretz1Aix6lC6p+isrnvxB/is2HzEEYPeG8JkkLhOIv2fdbTrWNBEpG0LHnUGfjDX/rnRaCI4nW4udVvpSJtKPE2RXLhtjYdZ3JRUIm43F2jOSXiTVoUzKZsR4Y3VjR6+sk6CX1uC3E0UNJLBm3HKM+p+RbyLi7ukfpD+d2T2ApP8AAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29771)">
            <g transform="matrix(44.2 0 0 145.2 1832.9 619.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAeCAYAAAD+QjQzAAAABHNCSVQICAgIfAhkiAAAAPtJREFUOI3Nk0FyxTAIQ58Y7n+2bnqaxqgL49j/t7/tssxk4gxYEoLo4+3drFDcR0L7yB8if07rLGpA6SjwUaTfGf+k6T8WvfbJrxx3P/WM5ONLfBuPdF43DKWGhcS1kxbIPEdytQgLwi2451aGgKTGTeFLSEt1CxyQrrMdTea9AE1XoymqEzGr/EW4WnyAjkYAFCSjDnfHI4/AVaSv9kWFHHi5G6Ax36kH4WPjVOAouIKsGqgAFVYgCduTuubF1Kh7EnhgYiLHnn368hxFdfdMc+29CkldNxBDt9da3SmW47daQHMB0Ky0yWWcefo3UZshcuMsj+LcXMB8Aqxegp/8Im7PAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29783)">
            <g transform="matrix(63.2 0 0 165.2 1837.9 619.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAiCAYAAACEEVOfAAAABHNCSVQICAgIfAhkiAAAAWVJREFUOI29lVGO5iAMgz+z3P9yI81l9ifeB0LTVrQazcNaQiAakuA4VH+/vg0AAonCba1aN3Zwjgf0aaT07FuEPdo8cIdu8y7SyccjnE4E/TWdk+HZ7hrpnKp2TMw798Nwa3Q/MNN/uYRO44qXQ89o2+XPD/0q0v8/tGdsYpblXREX31Wn/myoFIAgVssFBPTqG4PTowyRmnPUfjrrOOZGNNCoNQYiU4o5JLDoxJh7l1YdYGf7jw0RH89gGDVdPuJzJ9e6e5SB36hWOek4w1sw7u0haJHpr0CNXoarDuspUm0baM7rDfpRA5LFRYB9FccnXyuJzieN1WbxfGZSFVxZL7nu5BCSsYU0ZqptwPiDMxspkr1Ynj443wuPVMM4KcRgHXUKSmeueaE1GDHn/JZEuGg9ZJYMRGTUcex1RpzurcmSFpuaVDu9aUbsK4Lt/NNU31wFUrV7aPf6Ze3QnXrSk+w2+Admfa60Y140sgAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29795)">
            <g transform="matrix(68.2 0 0 20.2 1919.9 787.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAECAYAAAC+0w63AAAABHNCSVQICAgIfAhkiAAAAEdJREFUCJl1jcENgDAMxOyo+4/Hg1kQx4NSilT8inI5x2PbA0AVL4KZZiEBC7j3jT/i6JFHkhF/i2cP5ue49LZEtMtcH624ALBgEMFCEr2zAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29807)">
            <g transform="matrix(92.2 0 0 34.1999 1895.9 773.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAHCAYAAADqF3ZBAAAABHNCSVQICAgIfAhkiAAAAF1JREFUKJGVkVEKgDAMQ1/K7n87vzyKYPyQsarb1AeDQtY0W7UtqyXTCFCtBZE0C0JNywiCv+w+T4fy3pwSDEJNzAx1sJ5PmVEA7Hbr3v/VaJDsv0llvoBs1P/zCwe7ohDKjO0hSQAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29819)">
            <g transform="matrix(20.2 0 0 25.2 2019.9 754.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAFCAYAAABirU3bAAAABHNCSVQICAgIfAhkiAAAABVJREFUCJljfCOt8p8BCTAxoAEyBAC0ZgI0vF2JMgAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29831)">
            <g transform="matrix(25.2 0 0 30.2 2019.9 749.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAGCAYAAAAL+1RLAAAABHNCSVQICAgIfAhkiAAAACdJREFUCJljfCOt8p8BDTChCxAjyAjFDAwsMAYWlTC7/jMwMDAxAAAjcgQ7wIC84gAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29843)">
            <g transform="matrix(54.2 0 0 39.2 1962.9 735.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAICAYAAAAvOAWIAAAABHNCSVQICAgIfAhkiAAAAGZJREFUGJV1jsERgCAMBDeSsQj7sP+KLMGcj4DAiPcKybJzdh2nABQOgJGRgGivjCscVKnIEY1QnzdUj9GUhW+UZqLk59emBZwS7/fWpR13sHuq5BOkra8X8d7RlkBKHEw/ihEaajweSSJmcUk3AgAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29855)">
            <g transform="matrix(20.2 0 0 16.2 2015.9 763.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAABHNCSVQICAgIfAhkiAAAAB5JREFUCJljfCOp+58BDhgZWBj+szAgAyYGhn8oAgCZlgQ7jlFkUQAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29867)">
            <g transform="matrix(25.2 0 0 35.1999 2010.9 744.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAHCAYAAADAp4fuAAAABHNCSVQICAgIfAhkiAAAAEBJREFUCJlty7ERgEAMA8G1MSXQDP2XQwtgAp7gGZToZnSKY9sb5AlEqEFc68CWhCndrwk9qpRefO30k5r2fh43LuwLW3GgGxYAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29879)">
            <path
              fill="url(#linearGradient29887)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1948.78 530.301c-17.23 0-33.81 2.699-49.39 7.648 15.64-4.949 32.3-7.629 49.59-7.648h-.2"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29897)">
            <path
              fill="url(#linearGradient29905)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1948.98 530.301c-17.29.019-33.95 2.699-49.59 7.648a166.385 166.385 0 00-33.28 14.781l.09.161c.09-.051.18-.102.27-.161l19.37 33.61c18.51-10.758 39.96-17.008 62.94-17.008 23.41 0 45.24 6.527 64.02 17.68l19.32-33.883c-24.42-14.367-52.78-22.789-83.14-22.828"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29915)">
            <path
              fill="url(#linearGradient29923)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2113.66 690.961c0 .031.01.059.01.09-.01-.031-.01-.059-.01-.09m.01.371c0 .059 0 .129.01.188-.01-.059-.01-.118-.01-.188m.01.559c0 .078.01.179.01.269 0-.101-.01-.18-.01-.269m.01.468c0 .11 0 .211.01.321-.01-.11-.01-.219-.01-.321m.01.512v0m0 .52c0 .14.01.289.01.429 0-.14-.01-.289-.01-.429m.01.48v0m0 .57v0"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29933)">
            <path
              fill="url(#linearGradient29941)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2032.36 553.082l-19.36 33.84c36.89 21.887 61.71 61.988 61.71 107.988l-.13 2.559 39.02-.199.11-2.36v-.469-.121-.449-.051c0-.14-.01-.289-.01-.429v-.153-.367-.191c-.01-.11-.01-.211-.01-.321v-.199c0-.09-.01-.191-.01-.269v-.371c-.01-.059-.01-.129-.01-.188v-.281c0-.031-.01-.059-.01-.09-1.39-58.832-33.74-109.883-81.3-137.879"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29951)">
            <path
              fill="url(#linearGradient29959)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1784.56 689.941v.008-.008m-.01.34v0m-.01.598v0m-.01.43c0 .101 0 .179-.01.273.01-.094.01-.18.01-.273m-.01.55c0 .102 0 .192-.01.293.01-.101.01-.191.01-.293m-.01.493c0 .128 0 .25-.01.378.01-.128.01-.25.01-.378m-.01.488v0m0 .551c-.01.308-.01.621-.01.929 0-.308 0-.621.01-.929m-.01 1.058v0"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29969)">
            <path
              fill="url(#linearGradient29977)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1866.2 552.891c-47.49 27.757-79.89 78.511-81.64 137.05v.008c0 .11 0 .223-.01.332v.117c0 .165-.01.321-.01.481v.18c-.01.082-.01.171-.01.25 0 .093 0 .179-.01.273v.277c0 .102 0 .192-.01.293v.2c0 .128 0 .25-.01.378v.661c-.01.308-.01.621-.01.929V694.91l.11 2.231 39.02.05-.11-2.281c0-46.281 25.12-86.64 62.42-108.422l-.09-.148c-.1.062-.2.121-.31.18l-19.33-33.629"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath29987)">
            <path
              fill="url(#linearGradient29995)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1866.47 552.73c-.09.059-.18.11-.27.161l19.33 33.629c.11-.059.21-.118.31-.18l-19.37-33.61"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30005)">
            <path
              fill="url(#linearGradient119694)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2066.27 687.77c-.01 0-.03.019-.07.05-.4.41-2.35 2.641-5.37 6.121-.03 1.118-.09 2.231-.15 3.34 3.6-5.859 5.77-9.511 5.59-9.511"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30023)">
            <g transform="matrix(49.2001 0 0 73.2 2019.9 687.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAPCAYAAADd/14OAAAABHNCSVQICAgIfAhkiAAAAJ5JREFUKJFtkdsZwyAIhQ+GNTpM95+lGzT+fUBBTX3hCzk3wD6vN9oeVbHsus7XW1TrW9ulwcr+YfCdQNZ/FIEmKGIA+0COTKyiTMVbmvacY4EY5FbNFWECJUhIDpFHRmxECHjM5CJEuf/MTMtvF5ElQCiJEzzcnd4WlX3Jskm+5EeUhdQkUnA/IbWEh4cXqKo9Q+zWcbFL3STFJVLgBzfRV0BNPdfaAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30035)">
            <g transform="matrix(35.2 0 0 35.1999 2000.9 725.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAABHNCSVQICAgIfAhkiAAAAE1JREFUCJl1jkEKgEAMA6du/+Nf/P8fPKtl42HLVlADgdImQ21fNwGoNwAIplxX40/Le2XDAq+MxigV9rMc8wicSesOFo/mkQ8pkVaAGzZdE3LdiGvnAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30047)">
            <g transform="matrix(30.2 0 0 30.2 2000.9 744.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAABHNCSVQICAgIfAhkiAAAADxJREFUCJltjDESgDAMw2SST/Ea/j8xw+IOaTtAPOmkO+s+L4MAwAIXJj7oNq1/Ibd01NW7whNFaq++EwOLwQuRMa9CzQAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30059)">
            <path
              fill="url(#linearGradient119696)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1940.46 859.32c-.32.571-.63 1.129-.93 1.68.86.051 1.72.09 2.59.129l1.39-1.68c-1.02-.039-2.04-.078-3.05-.129"
            ></path>
          </g>
        </g>
        <path
          fill="#cb3e52"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M106.203 176.217a.363.363 0 00-.013-.024l.085-.004.02.023-.092.005"
        ></path>
        <path
          fill="#d93e52"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M106.19 176.193a7.326 7.326 0 01-.147-.284l.232.28a2.41 2.41 0 00-.085.004"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30081)">
            <path
              fill="url(#linearGradient119698)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1984.58 795.992a101.68 101.68 0 01-7.37 2.156c-4.18 6.672-8.81 14.114-13.46 21.704 4.96-.52 9.84-1.332 14.6-2.422l11.62-14.008c-1.35-2.891-2.82-5.223-4.42-6.609-.32-.282-.64-.551-.97-.821m-44.07 63.238c-.02.032-.04.059-.05.09 1.01.051 2.03.09 3.05.129l.05-.058c-1.02-.051-2.04-.102-3.05-.161"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30099)">
            <path
              fill="url(#linearGradient119700)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1978.35 817.43c-4.76 1.09-9.64 1.902-14.6 2.422-8.52 13.898-17.13 28.296-23.24 39.378 1.01.059 2.03.11 3.05.161l34.79-41.961"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30117)">
            <g transform="matrix(16.2 0 0 20.2 1971.9 783.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAECAYAAABLLYUHAAAABHNCSVQICAgIfAhkiAAAACxJREFUCJlNwUENACAMBMG9tpaQgH8pNUB6vEiYUa9tACYpJnmCT3GEHUjmAuORCHQMzduFAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30129)">
            <g transform="matrix(24.2 0 0 16.2 1967.9 787.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAADCAYAAABbNsX4AAAABHNCSVQICAgIfAhkiAAAACBJREFUCJljfKdj/58BDhgZGBgYGFhgDGTAhCHCwMAAAI9QAmK1qMAHAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30141)">
            <g transform="matrix(24.2 0 0 16.2 1967.9 787.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAADCAYAAABbNsX4AAAABHNCSVQICAgIfAhkiAAAACJJREFUCJlj/HXw+H8GRgYGBgjBwMDIyMAEZTEgAyYGLAAA1dcDjMeET5IAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30153)">
            <g transform="matrix(16.2 0 0 16.2 1971.9 787.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAABHNCSVQICAgIfAhkiAAAAB9JREFUCJlj/HXoxH8GBgYGBkYmBhYGBkYGGGBiQAIAgV8Dj55aUrwAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30165)">
            <g transform="matrix(20.2 0 0 16.2 1967.9 787.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAABHNCSVQICAgIfAhkiAAAABdJREFUCJlj/PPwyX8GRiYGGECwcAkAALcrA8njIvlxAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30177)">
            <g transform="matrix(16.2 0 0 16.2 1971.9 787.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAABHNCSVQICAgIfAhkiAAAABtJREFUCJlj/PPo2X8GBgYGBkZGBiYGJIDCAQCKHAPL/hv58QAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30189)">
            <g transform="matrix(16.2 0 0 20.2 1971.9 783.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAECAYAAABLLYUHAAAABHNCSVQICAgIfAhkiAAAACtJREFUCJlNxrkVABAUALD4jslsYP8dDOCh0EiVNPs4QFPs+h6ET7FwMsEFtrYFnYl+A6QAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30201)">
            <g transform="matrix(20.2 0 0 16.2 1971.9 787.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAABHNCSVQICAgIfAhkiAAAABhJREFUCJlj/PPo2X8GGGBkYGBiQAMYAgC3XAPKVJ6msgAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30213)">
            <g transform="matrix(20.2 0 0 16.2 1971.9 787.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAABHNCSVQICAgIfAhkiAAAAB9JREFUCJlj/PPo2X8GBgYGBkZGBgYGBgYmBjSAIQAAt4gDy4x1pXwAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30225)">
            <g transform="matrix(44.2 0 0 63.2 1928.9 682.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAANCAYAAAB7AEQGAAAABHNCSVQICAgIfAhkiAAAAINJREFUGJV1kNEBAjEIQx+VUVzF/TdxAS3xg3Jy9eSnpYQkjT3vDwFggrwhCbBsJjhVAjD05qccQGG5KW1jQRiuuBoOiJIUTtcv2W3JLwGFkYG68VkM1ti0mF63L43FPzkdmDyrH+cIDkBF0S3k79p2NI31JoEzt4xiNFz69F3/BFj1AdoMTEHtG0w5AAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30237)">
            <g transform="matrix(25.2 0 0 30.2 1957.9 720.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAGCAYAAAAL+1RLAAAABHNCSVQICAgIfAhkiAAAAD9JREFUCJlNy8kNgDAQQ9E3YhqiGfrvgDtSMhyygC/W9xL3eZWlBiEJUM8squSGGUB+ENYr9WOsou1D+qsPewH5qBB17PzpYwAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30249)">
            <g transform="matrix(20.2 0 0 25.2 1957.9 725.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAFCAYAAABirU3bAAAABHNCSVQICAgIfAhkiAAAADVJREFUCJk9ysERgEAMw8DNkXKohf6roAIG8wjgl6xRnfsRoLijpeZfI3vgXegPmHLJItsfPVxJC3C+AAKiAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30261)">
            <g transform="matrix(39.2 0 0 39.1999 1957.9 730.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAABHNCSVQICAgIfAhkiAAAAF5JREFUGJVtzDEOwzAMQ9EnR+ilepfef+zaoLEyOHAGhxNJkD++708JU/VHFBpIqKOIRq+x6kkbPqvXVQT9wkRNYtPzYlt1vORS1sY+g2Qb/ldUW/Zpf2Lfui8PbzgBhlQekj6yo/EAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <path
          fill="#f78d51"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M109.904 176.806a6.152 6.152 0 00-.113-.069l.551-.762c-.013.029-.196.376-.438.831"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30275)">
            <path
              fill="url(#linearGradient119702)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2038.55 833.148a169.62 169.62 0 01-4.41 2.762l.32.531c-.07.039-.15.09-.22.129l1.11 1.539c1.49-.867 2.95-1.757 4.41-2.668-.4-.761-.81-1.531-1.21-2.293"
            ></path>
          </g>
        </g>
        <path
          fill="#cb3e52"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M109.739 177.118a6.015 6.015 0 00-.156-.094l.029-.04.151.088-.024.046m.154-.29a6.486 6.486 0 00-.116-.072l.014-.019.113.07-.01.02"
        ></path>
        <path
          fill="#d93e52"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M109.763 177.072c-.05-.03-.1-.06-.151-.088l.165-.228.116.072-.13.244"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30297)">
            <path
              fill="url(#linearGradient119704)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2017.01 792.672a32.37 32.37 0 00-2.25 1.609c-2.42 1.879-4.43 4.239-6.11 6.949l2.61 3.598c.74-.418 1.49-.84 2.23-1.269h.95l19.7 32.351c1.49-.898 2.95-1.82 4.41-2.762-7.51-14.128-15.77-29.648-21.54-40.476"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30315)">
            <path
              fill="url(#linearGradient30323)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2034.14 835.91c-.09.051-.18.11-.27.16l.37.5c.07-.039.15-.09.22-.129l-.32-.531"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30333)">
            <path
              fill="url(#linearGradient119706)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2014.44 803.559h-.95c-.74.429-1.49.851-2.23 1.269l22.61 31.242c.09-.05.18-.109.27-.16l-19.7-32.351"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30351)">
            <path
              fill="url(#linearGradient119708)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2000.52 851.75c-.04.012-.09.031-.13.039.03.602.05 1.18.07 1.723.02-.012.04-.02.06-.02v-1.742"
            ></path>
          </g>
        </g>
        <path
          fill="#da828a"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M108.354 176.482l-.002-.001.001-.032h.001v.033"
        ></path>
        <path
          fill="#e58089"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M108.354 176.45v-.001-.043.043"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30373)">
            <path
              fill="url(#linearGradient119710)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2024.83 771.98a108.562 108.562 0 01-30.34 20.161c-3.22 1.437-6.53 2.73-9.91 3.851.33.27.65.539.97.821 1.6 1.386 3.07 3.718 4.42 6.609 1.29 2.769 2.46 6.058 3.5 9.527a125.03 125.03 0 0011.94-5.078c.91-2.371 1.98-4.601 3.24-6.641 1.68-2.71 3.69-5.07 6.11-6.949a32.37 32.37 0 012.25-1.609c20.75-13.672 61-10.332 42.6-11.703-15.28-1.129-26.51-4.18-34.78-8.989"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30391)">
            <path
              fill="url(#linearGradient119712)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2000.52 851.359c-.05.012-.1.032-.15.043.01.129.01.258.02.387.04-.008.09-.027.13-.039v-.391"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30409)">
            <path
              fill="url(#linearGradient119714)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2005.41 807.871a125.03 125.03 0 01-11.94 5.078c3.99 13.301 6.14 29.293 6.14 29.293.39 3.43.63 6.559.76 9.16.05-.011.1-.031.15-.043v-2.109c0-.16.01-.539.02-1.059-.16-10.609-.09-27.421 4.87-40.32"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30427)">
            <g transform="matrix(34.1999 0 0 73.2 1981.9 687.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAPCAYAAAAoAdW+AAAABHNCSVQICAgIfAhkiAAAAGJJREFUGJV9kEESgDAIAxeG9/sJ/+hFLR7sWAodcyMhEJBj2x0aFYqNwoAGLoFpCuhbiUxeY4XuthX577yz6IDrKlBZCiNmFapYT+mEgJ8+i37lcTHQR0hqAo2dGekJMV/jAaWfGFU5eDmmAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30439)">
            <g transform="matrix(44.2 0 0 35.2 1986.9 763.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAHCAYAAADam2dgAAAABHNCSVQICAgIfAhkiAAAADtJREFUGJVj/NY78z8DMvjPwMDAwIwixIJLAlXRf2yS/9EUYRHENAmbgn+M2EzClGBgYERShCKJrhACAATmDDdFm5UcAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30451)">
            <g transform="matrix(30.2 0 0 39.2 1957.9 759.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAABHNCSVQICAgIfAhkiAAAAEJJREFUCJlljjEOwCAMAy+B/3fnod2KWUgVghcrvliyvc8QADhZvQYJJE0AA4f+H3ejhgqg3dAeYAHa+S3gq5MU7izASQ0+jBvg/wAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30463)">
            <g transform="matrix(59.2 0 0 30.2 1923.9 768.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAGCAYAAAD37n+BAAAABHNCSVQICAgIfAhkiAAAAE5JREFUGJV9jjsSwCAIRB/q/Q+QzlNaCSn8kIyMWy3MW1hpTzUAFDAhVtquoHdgyACZgb3LQdDcKoBQYtCBddkrHVD+Dof8Qw+q/9oN7gWhbBFLCZVE2gAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30475)">
            <g transform="matrix(25.2 0 0 20.2 1976.9 783.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAECAYAAABGM/VAAAAABHNCSVQICAgIfAhkiAAAABpJREFUCJlj/NY9/T8DGmBCF8AhyMTAgk0OAP3XAyVvhvdLAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30487)">
            <g transform="matrix(20.2 0 0 16.2 1976.9 787.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAABHNCSVQICAgIfAhkiAAAAB9JREFUCJlj/HP34X8GBgYGBkYGBgYGBgYmBjSAIQAAtXsDwCbWu44AAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30499)">
            <g transform="matrix(49.1999 0 0 40.2 1981.9 763.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAICAYAAADA+m62AAAABHNCSVQICAgIfAhkiAAAAE9JREFUGJWFjjEOgDAMA88l/x94AM9kgpoF0RIU4cmSL7G1r5sBQMxSG94dgkLuAhpgQBlUxh8XeLkZU8tVdf782pjCQxX4Defj4PyvBbgAN+oPQENj3W0AAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30511)">
            <g transform="matrix(63.2 0 0 64.2 1967.9 739.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAABHNCSVQICAgIfAhkiAAAAJNJREFUKJGFkTsCwjAMQ5/dcP+RvZdkIRFD88WhaHSk+Nm21/MUVgBAiSAplBI4yKOZapaB2XdIwFqk1CcA8q5TM80/WjAOGYmyQ5spH9Mfeeq0yPs4rN5OcIV0RKq4tG5PLaACFoz72VILXDqoW7nVdae/csBRniG3AAXlimdivucIyVExRudftzKS3n5jaGjrnB9oGiluEgRxgQAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30523)">
            <g transform="matrix(49.1999 0 0 35.1999 1976.9 768.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAHCAYAAAAxrNxjAAAABHNCSVQICAgIfAhkiAAAABxJREFUGJVj/Pvh038GIgALfmlGOIuJGNOGikIAWCoD75Wrfs0AAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30535)">
            <g transform="matrix(44.2 0 0 25.2 1971.9 778.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAFCAYAAACXU8ZrAAAABHNCSVQICAgIfAhkiAAAACFJREFUCJlj/Pvh038GPICRkZGBCZ8CGKCbIkYGBgYGBgDH/gPs6TRkiAAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30547)">
            <g transform="matrix(20.2 0 0 15.2 1919.9 773.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAABHNCSVQICAgIfAhkiAAAAB1JREFUCJlj/D5j4X8GGPjPzMDC8J+ZARkwMaABAODrBTurNVVPAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30559)">
            <path
              fill="url(#linearGradient119716)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2000.63 851.711c-.01.008-.02.008-.03.008l.03 1.672v-1.68"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30577)">
            <path
              fill="url(#linearGradient119718)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2000.63 851.32c-.01 0-.02.012-.03.012v.387c.01 0 .02 0 .03-.008v-.391"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30595)">
            <path
              fill="url(#linearGradient119720)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2000.63 845.5c-.03.969-.07 1.961-.09 2.691.02 1.122.04 2.168.06 3.141.01 0 .02-.012.03-.012v-5.82"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath30613)">
            <path
              fill="url(#linearGradient119722)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2000.63 853.391v.07c0-.012-.01 0 0-.012v-.058"
            ></path>
          </g>
        </g>
        <path
          fill="#da828a"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M108.358 176.483v-.033.033"
        ></path>
        <path
          fill="#e58089"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M108.358 176.45v-.044.044"
        ></path>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32041)">
            <g transform="matrix(68.2002 0 0 58.2002 2624.9 2506.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAMCAYAAABSgIzaAAAABHNCSVQICAgIfAhkiAAAAJJJREFUKJGNkFEOwyAMQ58Zu/9Jp51g9T4oaRqYtEgIBfwcg96vpwFskAAEgHmM3Y17jfsmPFoNmNnzOc8PpCOBBkwfIhM0K5wGRd1yhEFxnybZqCuuLtjVPhQKuM8UFR7yXwYpqtZnILyJP0FX8Vo7gx4JlIU12GUQoF2m/GEA0OTz051Um/h5RVQlyNq8U2v7BVLvNf1bya6nAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32053)">
            <g transform="matrix(121.2 0 0 78.2002 2605.9 2453.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAQCAYAAADj5tSrAAAABHNCSVQICAgIfAhkiAAAAapJREFUOI2VlEGSHSEMQ5/cnRPkwnPmbOeDsrANdObXTIVNAw2WLNnoz8dvEyABt0HAZWTQBQAK5yRy7qm9J6CmnmKN2mPC7SFk4wsYQjJYddlY5BryXAXyVAaKDPRlNIjF7ZfWQf0yRmgCYRwdEEStI/FpMvYiwSxQgLHxbl7gELqNP1OGldVMOr5KF4Omk6RUSuV3jQrusXdvj7xsQPFM31exXgru7JYXlcySqGMfEt68BGGYgiuDKIpty3C1yeXD6UXfDaNib5GSN8h8gUIokpEEXOBI2U8Tp+o/VWUGDeXvLoS+MmsP0ngHxJ3qmgKrDHJduouF7MgC8Snvt3IJ5qy+kJEF8g4+SoIwbsOXXEfAI5NzfmPwAFnMlqsPVDOutlEScTXq/Lc/DuueJdz/Rx1SgZUybpnww/gkRhrfoxv1SybnmKk/wxDKQICvatLoxmTJuVM8mhLQu0yeaQs+S3d2IVgguXpK5Ul90QYpAt0/70GazXyWIsCMMr6q7LRwvXECurR/AtmRYTbL8WzsfL66+GsPJbH5PyBvQI32O1WB1caHc14gfwHPEgabaEilkwAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32065)">
            <g transform="matrix(77.2002 0 0 25.2002 2615.9 2477.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAFCAYAAABM6GxJAAAABHNCSVQICAgIfAhkiAAAAHxJREFUGJVVj8ERAjEMA1dO+qAJ+m+JAo5YPKwb4JMZxfJK1uv5MAsQsAwbJI+u/APIo1fmzHwDEE0LLuMlKJCzVIAFPWBXqAd2v4UKVB6QNGmAJXTTlecYzrfZpmfBHXOlUY/JCDoBSgBzCpjtDnkZbsilMZT/Qfq5P20/+7wyaBfNX1EAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32077)">
            <g transform="matrix(20.2002 0 0 44.2002 2677.9 2458.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAJCAYAAAAVb42gAAAABHNCSVQICAgIfAhkiAAAAEpJREFUCJlVyrERAjAMBMF9j8ugIfrvgwawLAJEwIU7l9fz0UEvYN93ZKEGVHS3X/tWqLB64CAG50jmL3ZXtLmw68QKt7+47/k/Pp/fHk8NAb2xAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32089)">
            <g transform="matrix(82.2002 0 0 44.2002 2615.9 2458.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAJCAYAAADU6McMAAAABHNCSVQICAgIfAhkiAAAAK5JREFUKJF1kcthwCAMQ99LGKPH7r9WpwD1YCCkHx+CQLIig18fnxGQKgUNXIUBvFICgWvpsvctszmTTyh1BwzckCEavIBRdOqDCS2FMcUzsVNoD96zaSzyiI6VRCBWnLmQlD6KveJHULeBhiG0YCWZDivVrkzDe8Yn+2dcddYe7dts3dNKn/6MCHWB6QUbP+o0O8fcrgv29XJ/mHgo8xy+9q9xB7Sz6b/6pfDNfQMn4FFSmLRdWgAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32101)">
            <g transform="matrix(39.2002 0 0 58.2002 2855.9 2626.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAMCAYAAABfnvydAAAABHNCSVQICAgIfAhkiAAAABdJREFUGJVjFBYU/M+ABzDhkxxVQE0FAOw3AUzvx5CKAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32113)">
            <g transform="matrix(121.2 0 0 125.2 2768.9 2650.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAaCAYAAABCfffNAAAABHNCSVQICAgIfAhkiAAAApxJREFUSImFlVuS5SgMRE8C1UuYZcwKZ+fXkP0hCWNXTfeNqLBdyErlA6z//vnXs4ENC5iCKbOApfzj/vlxb6z7eb1qDCAYHdCK5hI0gxBLMG12jwTT0UQopgMsaDxrRCyPAUyi+XKAfQFzgSQmATSB9j9Axsjfgeo3hhQLNhOQn0VysJLN9QegoOMNVPKJlKsDU0KGiWmGSzByurmyu8OrUzreYL59Klbjl+DKSgk64mMzktEFdEW1JK5qqee0f/JpKCdeCt1tsBT+pNafAsq4FND8weyffBq/EJdAL5mmoviy+XIMcOsTQCaG+xvQGIrFmWxIIAGXg+q0IeXrB5CzpV+BqP9VIIbSeCRahluYaYEc8ip1zpjTootzgCtKN1CRLlaj5/tKozBcxFvN8BF8JZDs8Gcd0WnCdsibQO9AtJ4S9JRoCL4EDaHcmJE6aBIj+/cV1+a8FoMcfz8Xk3W7VekDwbS4FHG+zyMxCEbVvHvbFF68dn+cXbonWLpfKg0/mC/Bx8VYLIdfIwst6CnbG2gI09DDqZWgNQC1QY+akRFdGRxnOh/pqtpOHiUvoJAr5RCs1LJlTTF2Rr45Tgvj2ApnutreEz8DXQk0Ds9cAIhOxTz3EWJxfCKA1lL6Tu56IoYqU3O9pb5N3Ak76sgAyMGqLAVo/Wh8AtXOVjYS0CVGvlqD9PxU9NxrddUBNNptU8pRdBUnQa7Wlw7uADjlqyjvYSws75r2Lmg5QjtZHGxa3pXEPZ+KTT/YkIxaPZVsT3+8p9yD6PsAb2+KzTdPosi7ATnhvn808rNhMqz1c61Cs5MjnrIoo3jGkZdkO1l6+3IAK6WBm83pjf4i2Ru8HXtsH5Zbqi3Rke8Q7CEZe/0erKTkGKaS2S1+AyFwXlXPbqzSAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32125)">
            <g transform="matrix(40.2002 0 0 54.2002 2859.9 2602.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAABHNCSVQICAgIfAhkiAAAAFRJREFUGJWFjMERgDAMw5TMwCysyNJNzYNLC7QUvXK2Yju2XQEUiQKERCAABLhjdK4iMwM8jzcpeQvMmqjbkg+vg7RAaC38LjyEKn0LWc0Ur9O4cwI6MhrSonQ+kgAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32137)">
            <g transform="matrix(121.2 0 0 116.2 2754.9 2616.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAYCAYAAAAPtVbGAAAABHNCSVQICAgIfAhkiAAAAU5JREFUSImtVEuywzAIE7QXeeve/1q9QUMXjoPA2E36ykxmEvOVFCzPx5/B0GwDzAQwtOcFgL83wDbBYAJs+6uNXii0BUEAKCBiEDU6s+jXoswesvcb7A4x4AagT3jrSdZQ9SrdL20Q98XiayRqyKjcR4jUG1Vo+hObcFGxQI8kqiCx0WDUl906TMw6IGnAxE/0KZEcQjNVTB9nMm0d7YQ2nulAImJRB48YadOFAKlBK8HFJCUr+bgwV9IaTaArakGIMmUasoJuFZooXxcvLaTr4WNdQkNhekwc8UXqMm1n0Fhukq8PHkXg+5HP88gT05A0LF9RNGsjjmxGmYakKqI6zgu6oMznCneWjYn5T6sKLijT8uo+mfxJix6i4S1tsajVhbIuH5oqUAg2+5vyzhxVfNcq8Vey/8yuNflSn+tIToj9/yZf2PUmsz9+sQlvwa9ccuX9OQYAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32149)">
            <g transform="matrix(30.2002 0 0 16.2002 2792.9 2659.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAADCAYAAACwAX77AAAABHNCSVQICAgIfAhkiAAAAC5JREFUCJlNyLENwDAQw8CTkf0nTeMFLBdfJGxIMPt9qgQ9pCjLn9BMLpnhE+ECIIYI525BKkcAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32161)">
            <g transform="matrix(20.2002 0 0 25.2002 2807.9 2650.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAFCAYAAABirU3bAAAABHNCSVQICAgIfAhkiAAAADFJREFUCJldyDERhAAAA7C0NjCFfxcv4CkDdwxkTH7nMcOfXVEZUJKpIl4VZE+G+rgBfj4JaJ/wkCQAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32173)">
            <g transform="matrix(35.2002 0 0 25.2002 2792.9 2650.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAFCAYAAACJmvbYAAAABHNCSVQICAgIfAhkiAAAADlJREFUCJldy8ENgDAQA8FxkOi/UUQJx4NEHNmXrbVzX2cBJd4YFIZGSa9GOWZMG01pY72z5Pf+8wBeswrvtrNR0QAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32185)">
            <g transform="matrix(231.2 0 0 236.2 2663.9 2453.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,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"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32197)">
            <g transform="translate(2677.9 2458.9) scale(212.2)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAABHNCSVQICAgIfAhkiAAAA4lJREFUWIW9WVGWpCAMrPTzIPu197/YXmBGqP2AkBDQ7lGcvOFpt4JFUSlij/z785c4CgoAdzl3F8sf0d9zIbIAqR6/Ifh2xx3AlwDfFGQIXu+HE3cqpbnvRcYeV0LC8ej6MWD6ru9QLUIdRmzgaGt4DFhYWusUmGb/cVXQHb0C3zMcYwrqGWZnI+sEzgEzdFuPbxiW4Rjv/Jzhoa/UR92fhQc3Y9bHzwEHp1sVp8wKQHxsawcj+68WTSBDDPjBwn1oaw/G5DG5toSabCwMA1ckcZ4Vl4KuTUPKBIgrgB+OLMZm+dwvwTbtdSSHgQKCPOXmbTR2Zc50JpHqBMakO9MtD85vRhxWWw7XMgTkTBIRtJ8y4SzhHrPxEXmSfRlolqZxoOEKJuIJYG+XltI9rTGbarkJFIdIEKRqeQa41b60UaZg/cV7DLelr8Cz9EwnkcH2NlBKVXbk/vQTWLvFeVGp9+p5UV9JONWvMTzD0el1vIl3tzfHnO5wGYXl9jSnX53cNgdMN2IEOu3w41BGs9ix1AtFv0kEGWz61dg6FttpNUUxOdht62Sh7tDYhZMDgFzFrXIogBuGwKo7XcVqAxo2CZ98qYEmMl6D3b1srjW616IHCgcPVMzGcpUDULbjIg2zs9IEW1O3gg3Jdju5IliBk4CBaVpGvx3Hib66jwSYWYGuq3NbSL/8tklYstlkXoXdbv8aagn6w/LoNWsgfbIVdzB5eDm4l9CHEPo4YJeQthXvIkhkBSzT+mIDuVyns/C+mzq/7a0MAiRKSyVLe6mAfyFiomUAu/Sy2AEkEvvEyqB9CbweZ/cs0Ry7OplWpQU703j2FUnmUvBN2VXAs7dST+mjgCN7KoVUE60HL9UxRv3iNxhW3ervvrajWdtRnEHZ7/qjt7O6PTwDmEG3CYK9/jit575m2Kkw7GXzKNYDDsz2ui1S2KG+C+ycMDuxs0cA0y253832iSukWuD4ai0yG+UArPRhJwOtvvzGoMxq47C7mhz8q1OMNQyHZFJJJKfbpN8p0ywFelxywMthjPsMB7C61OYIlnA7ZGB2KDUZBl8JuN9y9b0MDaCC9UtMqT8nyLwqPLKz+4AnYL0jsIL1de4Irv+Pxpmd3QI8YzY7gHvVqQeZqxzKy+XMEc7tTOPSvwxmzOpGYL80WvIN7DqZfGpnlwAzJJgya+Vir1cDoP1nrH1mZxr/ASrij3+iN13QAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32209)">
            <g transform="matrix(222.2 0 0 217.2 2672.9 2458.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAtCAYAAADRLVmZAAAABHNCSVQICAgIfAhkiAAABF1JREFUaIHFmVuW3CAMRKuId5Hf7H9l2YEB5QMJCWy6e+zxRDmOh8aPS3UhHs2/v/8IngoCFUABUAhUEDuBDKCQ2AHsWp8JZCEKEnYQWYgdxC5s9Xq2SI9BA4AAbPxI0tvSDq1LAAgGENfR69sR41nwCAogQZBk/KwdDZYUv+5wzQj/OLipbo1IMBVlUpT4FSEp7Rp6OcYCPL7CX3U1oj1i2V6eAFBU9aC2lc/iBDyASmrH0JAb4PYG8YY4YPu3guNUnkgMWA+LXp5v/zACYJoUjMq6uscOOkf4jA65BIhuvR9nT5m9HK990Tk/AboHfQp74TnPZ5XFS9+9eLbU2TP+S9S39a+/h2s97Wa8g/4kAri0Y9E5AIS66/By8vfw2YvkEK/bTquIY3ahNuwKNNd3OTynJOj19eStJ+DSbuTc8ovQ4c4GQVQe1RZ774tnRItt68vig+75uoPzvFz7dQJB6gq383lj3nTO6yr3iAOwwhhQidBkBxY0rwsIES9/Afx+RI9aihMc7SNqlm4njHaaJVxY5ZuCR1sUetkbJV3duWOuUsKjike1i6rYjqNNCmRQ2uwUyz8DzmCRoHZFUzvaRyCowt7Ad/5+DpzeCasukjOPanu9ZY8G6B34J60SVvbRIgZ7prbVFQBVONjEPp/je8E5qmVqlqB2VpCi9RlA1VVW7bBEFb1Hzhdv35ZVLEuY0maRSlO72WWwCVzhqHYNaq9Gkfvgw1fv0Fmhs4KUySKVgtJHyrXaq5nkVql++eoAOQFDgbunT5SOFnEwtntEz5PaS8Xtq7U51dmukUV8UAQerBGgiyodoYvm7Kyg9v4Ma8x7tQFVPDbrU3AobByi6+DhI7QpmYXBHkSxsnDIMK9MsJkqyTJpmJLP0EAcqkPODR1z7JCj0hVAhqDq2wrYlR/y+yKTDOCZbYOmQjceP1hyj54eJ0vWCT2Pj9BFGvSuCrdriawWKdOu7BJ8B5AUNm59panJNmwPnRG+cin0utEugqqeNqUNOit0naA/yRNbYbuRAKrewv7fGPMyy0ZBn0iNmaZSdIDx7FEm6CLjFODT5LbtgO+Iql1W6+U4XLs9juca7FIlhTkKVfkRuuBzi3Rwu9j26IoWVp0TGJWZgVunk66yrXQclIMtrkADpjgI268G1hOYmLfFVi201YsBA7ZuNJWlw7F7+g40oB7vvwiAoAj8W7ClluttoAiwbc4M7XxH4N6ImKfDHOVKbLsul+wXAMsw4141O3ztoNaopN+Ee9fqM8w6IXMAvXPeWYZvBak9XkFWvwSIGigO+Qbrc2tXss+nQ4orU/lObLvmExs5AfP4MR8Oc5Nuo6Zu3HaIo18cDe9Y4wCeVemkdrF4lVUM1Bpjeb2irRPH0fT7VB7Ad3VznKe8iz4A2d+yyOkPADu4MAz1HLYMzedxG0x/HDtMaztwsMgTwB087m8cVT/6fJ6Tm8fnkfTp2LIwZBI9LzzjKRD9HFX/yfgHuXdIHifENm4AAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32221)">
            <g transform="matrix(197.2 0 0 202.2 2687.9 2458.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAqCAYAAAAu9HJYAAAABHNCSVQICAgIfAhkiAAAAnRJREFUWIXNWFtyhCAQbCyOkt/c/1Y5QaTzoUgzDGqSMZuuslae08wTN328vxEJDUUbtQ8A93duDynjn2iDBLAmIBEoPNaRzr43scCuTfujBCF9u9A0k2nXp98R3EiebD4cwCO0JjnA78jMsBzCAN/UltTV+Lr07QCM5laUk7EO8014dfAbWK6nqMQ08klAiyo8YvpzkjwdBVZtPOOPgJL8kVnMmgDTephr0vpjNZ81o9V2TaCJYSZfpib1+sljgKvNV2Ytr3zlPjZNrgEn9jJBBNGk5tb9ZgJdmZN+fi9xnCF3fkPzW1H6Pg4vtU3TjPLJKzQ3bFhrXw0Oe4LiLPoZCGAZTFtk1JGzdTmpx/pfeOBYQhP/ZDeX0iHYU0+IqfctckeBmCbkQzFrEoJm8CAdm9QX2d1hBpAEB1PKe01fxK5FgLcvJueoYnLnO8PmdawSUQ1WjWmFYcitxzLInXW6IHVManMPDdG4WOk8Jvebp0ZQ+Qw+h5FwiWTYnzd3H0qe79moV82XvVPTVgSMx0hZNBJKMkKlHNVcrS7AuApjJTafHLQgBBI30gXj5EnSj0RuCTodEbp9hwpBJon86oONYKgGrQFxXNWqfKfsnPnqgxrUu07uS5zkQzt9ktCjteghH6a20pWYy/mZ7xnPOLmrMh6p2lbuETd5C2fLPrq1S51BKxHNygdhReRToUR8ov4mJHDg1m8bxU/5IeQi5SEPPV4pxIMEHfH6Cxwk2ZtWZv0VOQ9O4GDQ4J8QvDA1AOSuRl/NfhizBNI0qR9cLzSxh87c/4nccOl9Gbkb/ggAy3/R3llBi/tXKRD+ffIVuGlqAPgCEXZWqkEJaH8AAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32233)">
            <g transform="matrix(155.2 0 0 164.2 2691.9 2482.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAiCAYAAAA+stv/AAAABHNCSVQICAgIfAhkiAAABEJJREFUWIV1V1uOAzkOo6rdc7e95F5zgJRNzocpWZWkDQQuP/UiZSX+/f//FBEQf7Bb9gDmABSABAjAErQEaABLwB0Qtb8ZwEt7TACLAAm9AiCBO4BF6CZAQa+9fkUEgAsfjQAigJB7z8eve+FMuj2uCWD9nO9aUzv/VfIfbeFTYF4e7RvX7r5sVT8Ve9PfCui3XfqlzX702l56b+9WPycBeiTm4Rb/o8kfGr7pzi9bcq7wpbceuP6M/5exNL4rqLdvCljxse0xlDEgfQvW7zmk2Bd25V9xBrqOkrwKXB+O45thugABF5Y2zd7dL31eIvmW2LJznfFFYmpx7Z7Y52DK+q7xcF9qKh3+p6EaZ74rWD12DhAMUDonZIjZxBzjrrqEXmRTAgBmaeB99FDnorKuGVKNOym9L/n4AAVc3dp/zkbKxqq+cV/HagYeBkAHL90ghT1OQITmMXCHYBk87IoEEIRWNMsD0HUUUpSHVMrkmKbf8l61+LOUG/hw5XGd7rTqpzChDEULm1bih8BsrKHzfnM5QMuhFaBXLkH6hXPuAWFzs6YFL9Ove6JYkw9SwxAtVHx6QMIQN2KhKNmFEp5LK1TlSgF3eiSsFDfqZfQrgWChhI3Y+JKEgXRfuvUZBUA/DXRNuC/Ib0jAfT2tp7Gw0vrca0+AyYKMv57CAYDLKLYl9f6nWz1HQrxMORkbKFeDMFB1wiFhFLr52xRQ5XLlBbfKjaAV6gKyB7YS6yoQFlamyhMylkZtUBNegvNyAmsY0bY4uezzWo4/l3u5KspQtDAmkF9Oxeral/v1iL+Y3E2PJfpNw9ksXk+BcnlWbGpGDy1s666mwEoW7IdEdwokoLEvc5iUSWo1pFPA5FZkJiBjzzXgisQAl+nV0e+8Th6FKiTLxWkYoDgKQNA0/VayQcBcwN2sp98HASMXnm+1ILr4EF1cnvT55LwrXjgUYjHkVMx4GxO6NyhHZbeAaZbxzyRiVIcBxPBjknhQs8xhe+Hwf7ElL3sm8wKEsR8MHWFVH1rzGTbehUgXBNf+00XHPLHFagrODkQeFlAYuAVczf/rWUBo+kVL99eruI5bS5CVavQDuRNSKrB0/pzMzITqMglgbEClwASTopSQUyleP7bKc/LzO/e6lo7wqYYDZQiO+/VAvw61Kk9oxz9fNMhMMN3Ik6CkB+iO8HUS0yKGTIdE/25WJMuxrIxWMsaeUCYdFx9cB6hJtdu4SGrexoMfwYGpU0ovYFfHjn/W9kW/pijT6hzTKTlTbaOjaIDyeMVtJyJc5wkVgDAoZ2NI1gsyNsRTH2QGzAcrPTVToXXyx1rof/fGLrt6GGymQVQVL3lSQwlNSpr3nX5MvDTa6SkcCocgLVeU+5HczoKz6r4GzOXY5is4USEp9FdF7fT99k9s7Fh5MteoA7jCQPi3gPADlRlupYt3jpCRXin7r3/YAv4Do6sfPjwnu7UAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32245)">
            <g transform="matrix(188.2 0 0 135.2 2615.9 2669.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAcCAYAAADiHqZbAAAABHNCSVQICAgIfAhkiAAAA7pJREFUWIWVmGty5DYQgwFKyRlyipwut1+T2B/dYDc1sivLKhdHL+oboB8c879//hX+cDwfEOvzyqu+Z7Vres70M+9r338CNfwkcxXP/TPijdNQCojZoBfzkVxvsAD3Mv8HbuSLhwAyF1Rd299ax4SrXVsALhAz374kLAT0SsjRVDTgK9wb0Mg3M+dhiPZct2Qxrq0GegGQgElCECZincU4L5SKfMIZ6mJJfqlgCJv2NvOItwMITcX80pPEtcJ+IWw3pBfdcAMFZZChAqo/gkk+NppVrOMpg2mH5UKFwvHkAkhuSAKYAO6RMP4zVFfKQIYhuG39blxpj5wgDXYCWLZRwBwJrYA04G21rgfUaEA+BjIGm9p9tAS1IKGaTtiBSooFgGkvHecgFoH7UoM7oMomAw2cdux4O93dw6VHO64ClABGPvSlTIxUbhL4C8BcCbdtJT6grg6R50ZD+9HeVr+mtDNzIUD8Eis5EULtbL1Sraur06CeQDFrQ32n2lO9qGOR0VOlJtK1SYKKhBgCvpgxF2qVfRuMAd6B4h5+lJLvhlvUADMBuGvZlPA3ga+EDFGIXxJuAfcAI97YkqFBPYGeUN8pqFTMtvZ+GjZG3H0hQBYrJkViybY2Gy86M4Ur46EDGbaDvY68x13CwM7gQWwlvwiw25mJcd98qqWMv6pltvxQCmdMvg23pN3MWxmSstDmuZnqIQGZ1zAI3C9qWUlDdeVKTbUIfMBRuwi73hl0MdqTizPI3T4JYYq4DRalhB8QPnY2G4ZHm6/u4bEOrCi+yqKuhLKaG9rKITrDXWAnSIcc7FBVVgg1S7XxhLI/rGUCe/snMIPeULbWNv8ScZ/Ft9Sq8ydUxJiOmPtpRD3T3lx6A6C9DltBriwHEbY+wT5Ki+cXqNEU+wADsHrMJWiHdEJ5i7aY2zQglOtd4ARTQutIEgN1qGdZWe3e2jIxFcuYdEdwGjdApsW4fgA7YrGptGH4Xu9GAu4XNtCZYeLS8QYIPtpXB9v1r0HtZGj3MVc6s9dbI6WV9MncHSvv5q59X/oEvCueHlY2MCvT79nn8vhzqG3PlVmZWevfIlmivZ3vCi7lNv3iu5UGe5aT2rHs73/MavPYKkZHIITBlqHuIQ+LL2Zv9YsGiLE3mp9gZfGZEE/IgrM+2m1sIpJhkO3nWgFKzAJO3LVXO0vFO1h9NmAlw9PakKIKb7zUG9kn4M5uKnYsAG6XhWecef0OViVE+Xs1FXvJ2AVBqm5iu0rD/NdFAl55Xqj4+w0cNN4vMHnohQAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32257)">
            <g transform="matrix(212.2 0 0 145.2 2523.9 2659.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAeCAYAAABXNvynAAAABHNCSVQICAgIfAhkiAAAA3VJREFUWIW1l2uS2jAQhHtG3CL3yNVzurjzY556GNjdoCoKGxv0udXTGuTPr9/EJ8abv0rI7dfor8vPLxCP/4B2HoKn0CoAKBDxm9oxKdNXLwguEIB8EBhAiseCFP9YAUAI9ZtECELsTOprpB2F0p8F9rlFDNBeAnEjOJ7B+zEpk0lC6cvV/xhwKDlQimoei1vAMSkOfT8uCmgeJrAY/6dDF9ARkPkg4tCYlL6joP8Oy8Mh/M/ABUy4DhpQwlA5PiszdCOsFJEWwGaJ74M/vGTUoUcDVZYVSum6DgreUZk78NfBS9UO3TzLAu2Qwl50VobCWPzTuEB5GWvPwcWD3JZfJguoK6v+CAYvE2RMoe1RDHzZTIQABsC3U2IvTFt6s8AjVa33wSoucVgN9QiM8C9XK8g2F9oDfCHWSu2AHQkNfy9V0was0jKV1ZWOX5OMtRlzB+d3tuYqqoAuVR9NVWXkQIGXdwGl7unAk/XC0+yx9t6IjSCKrKsbFhhQV9VwBssS9TAB2DKDfZbTzPb528B9t7JEqKwdXC3QjjfQUB8FntH2fNBX8a3UTTiUX+uY0KbsyOW39zjXSW0LM+R9msV12jjsgnv4VerusM0ShMP6ZwFD97dDKqWBNmhXXQKNew5nB8fFwyfw8O3q2UfL21QWBddVDVt0L1dS1OfJdYAOuqOHu02qw5pfqRoarINq7HgJqwUdtligY+K7TZp8UXQBXXZoO5jDRnzNsAKh+nVMsBl1XV2u67nApvKWh7fAvZftlgjfVhHJFFmRDPYwmo2PLNAF6pF1zOAY1ly+3Jp7XwtwbhV9soAeDFhtsGs6aC77DnpSOkYV4+MuI2Z1o7Gh20LTCqe8nc6nVWhGY99631EZFWv5FP7l+KmTurak1gaKTzrQLNK6r9UyR8hblQ/jbAlmYUWRhYcjnDQhiRHNTBQctDU4K6w2QFc7IyySYoXPfRzATS8hYDY0qD/flZVThoZNbLJKh2ewXVkCrLXclY57bmJNphcnZSvWPMYO1wI00mEHXFUVU69vFquX2+kGPG0MAl/qC+pJXF2VK83wdcXX+tjVInbYrjiQS09t98elKw+PCuf7VNn2NzD6BG3aZs6SEPkLpbu+F9ltKvQ9tV3bZHwCPPIWFlAWIrFOjbzWO674Q9k8zKb4uhKTDZpFpDcKxD/yLEDKYqHdhgAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32269)">
            <g transform="matrix(226.2 0 0 87.2002 2519.9 2616.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAAASCAYAAADLw4ffAAAABHNCSVQICAgIfAhkiAAAAaVJREFUSImtllF2xCAIRR+2y+hn97+v2YT0YyR5IKhtyjlzJgriBZFEXl/fikJk/DcAUECaAh9DQc/SdMyN+YZ7DNKDbGystBHuNZf0BKy/F3xW4DEAMSh4wAtMMIFL0zkLbB+BeS4CsAy/W3gAd3bCT4TgGulayHYG3oJvULC8tUie/RW8hH+X9QgAAKIewmy0AB/Ba5f5hByHQltQ9A28CyA6t6xzOcSA7FlrcFd2IF8BVOBPxILZw7uSmS/j2zDJOjspwP9a9xZMCj+tZ8dx8wgHem6KK2nWeSScgtIa4J0It3dSMqMc9zWf1eNVLl6XZj3T8wW/Trao+zi2BPVtt0laXXas7JSzzmMJevMvMoNzSSqdhIprAtvM3xPqlVI8RyfGJcVdQAiSpQ3gbjZUY1nZHNd7AJ96dHZa7n0QktHIfmIgqq5jraSmM8DiLTfPL3SZ7apN2t7O5h4s4eX4dV3oYoe5JHaUFUXhWzRflt7J6qKeSvIJ4eQ3AYzsnyw5c3g6H20eEDyDf3oaD/d8Bn94L/9VaM/nZVMFcBKYovzcPZEf8X9okCDj8cgAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32281)">
            <g transform="matrix(140.2 0 0 25.2002 2519.9 2616.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAFCAYAAAC5Fuf5AAAABHNCSVQICAgIfAhkiAAAAGZJREFUKJG1kDsOgDAMQ58D4v6X4yqMmKGhrVAFQggvTqx8nGhbF9ND4GiscI0tIEByy8k6ZU8ygDPcKaKZsIPgZ3igzR6obhbx6T41GSxlTWkuWrdB90a+XeqH6V+W5kGV30KXJx/ghCbo51ws8wAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32293)">
            <g transform="matrix(149.2 0 0 140.2 2519.9 2501.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAdCAYAAABSZrcyAAAABHNCSVQICAgIfAhkiAAAAaFJREFUSInNV0FyxCAMk9L8/509976rHsBgCCaEdjplJpvFGCzLBhx+fZ6Ca2J6kwAICOkN/0aW+3lgURA+IB3NJIEgCbmJBzZab3i3nRIbgQCQahAW75UYYQdAMI8EMq1Hvp33WU9KDOT+lue/1f7AeByk/+c5R2BvsowudYjXdTwvQKgsdTE+NDwytqY2bUu03wFil/tFzvdF5rUOKP/rHqqdY32/Bb33hEDWcaO+AmipBwLP9WNS46TxAO5pv56jLSPd8Nz7Bc9NL4p1lAKj2I8y33THxoPVl3cC29xIsmvyhZ5rfoWF1JeYsk6M6J/HfEC99WckGAC7bCIA05jf9ieJlwzNAUw9V64mpt4v0B8BOKc7Wqj3uLfDBEBOxSx7vZL95eBvAdzu81JsTBhw6xYAjV4Qs1vjl4UGx27ZVo8ALF4s3vsq3APgQazdapjTX0GOAUQgliuZFfojAKP5wMMyqqd/B4AH8ch4T38EoOSAfwYgHheQKwBMJnQsdDrnzucH7dcsmEz1c8uG4eR93PdLZ8FZQsuC6xfAvgzLzzc9J+zFc+3RkgAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32305)">
            <g transform="matrix(39.2002 0 0 29.2002 2581.9 2487.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAABHNCSVQICAgIfAhkiAAAAFtJREFUCJldzcEJw0AQQ9Gn8aaHlJji08EuOznYxhBdBOLzle/n3VCvlmC0HE2R0YYZfbQ9o0bLioamUTjHzb7aCgszhitZIex9qlOR8gBgw3nRRY3+A26oH9sPItomdxzu0A0AAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32317)">
            <g transform="matrix(101.2 0 0 135.2 2639.9 2578.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAcCAYAAACOGPReAAAABHNCSVQICAgIfAhkiAAAAbZJREFUSIm9lVtyIyEMRc9Vs4hZSNaa3QbNBwiEuu1J5iOq6rLdhqOrF+jzz4cbYAgBAkxg83s8PHyGeflsAQzIpRO2Hz0C72CnBTDUVYWaOFPeOoQA9PQORHdNpYIrQk+wa4KsBG74cmBAT/pN0J6AhpZy0ITkFJxJiF8+1zVLQHtQdyXMvwslnFWoO9Dwlc9bF8hPqGvBHWjnhg20CtRWf1M6X3QcX4VCmO5AS7BweiZip8NxrumgaRXlHfBMxZNFPsFH+CMTOnO4lKdeLV2wgT7DH+5bVpmhecoCqKk6D8EOfzA6or1SeUxTAta22vjBsT2mSaXOyldgwIyo+JkIhtK7aVWZG9DK2jvcx7uay70hCvMMrPC368Sur0pRvmPvnP+3/R7UVzuTmuiH0IA49SQPcPz32npa90KpJkRJ82twAGNv62uipicfN99QL3o6oTLkKZKwtk9STwrHVOUbsl4adUx9ReW07oDuaruiROLrOKWq7u2qTyFtz0wOGczFl3xd23mdFWSfsxRpaY7TXUttXCkB7isKX1dxbbOcJkdDaajIRRsKQD5Cknar1NENJx1wh79PRcQhR2XfCgAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32329)">
            <g transform="matrix(68.2002 0 0 87.2002 2658.9 2602.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAASCAYAAABrXO8xAAAABHNCSVQICAgIfAhkiAAAAHJJREFUOI3Fk0EOgCAMBKeEd3j1/w/zC9aDMbSAUGOie4K0w5YNyLasCoAQkMLZTYpDXnkIifr9XpbpFqghACkueerS1HuOM8iQBZxBasOQK9WAU3XvfjgBPQPNuCkWyFvHb0H1b/OPUTXwpzo9Y8fBoQd6rxVdOa2ULAAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32341)">
            <g transform="matrix(83.2002 0 0 107.2 2648.9 2592.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAWCAYAAAAmaHdCAAAABHNCSVQICAgIfAhkiAAAAIFJREFUOI3t1FEKwyAQhOF/JMfoY+9/sFxi8uCSJhLMJralDx0QUeRTdFHz42kBMrczFYABAKCMAhV5Q/7Ih5Apv1TRtjHgLFJegKOXYy6FBODmFCt2eifN7kexMhfbASK/88TfQGoddH8sOXOSDqR0sQWCQEMV22DruOYCssX2WQA0Lx9kkJIBNgAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32353)">
            <g transform="matrix(58.2002 0 0 72.2002 2663.9 2607.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAPCAYAAADQ4S5JAAAABHNCSVQICAgIfAhkiAAAAGdJREFUKJGtUEEOgDAIK2RP8eb/v+UPBA9mwbCCMbGntWuhQY59cwhqzD+7H4Oas+YhjNZIdH01A4B4saHaZkGUTmdcZqAzy8q1Nac6USmjOQAPNPg5YGu3bxusCjhVAc+Bp/Hkp7oAQz4NaUS4I/wAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32365)">
            <g transform="matrix(39.2002 0 0 54.2002 2672.9 2616.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAABHNCSVQICAgIfAhkiAAAAGRJREFUGJWFjkEOgCAMBGcrb/OHvtWT1AO0iMRIQloy7TI6j92RaNcBWg+AUSYogQBGLTPswHrAJcoKe3UDIxKYIZ4ellJGQkngoRnC0oApAQZ6vpfzQvobaB97jcENA4f6vXMDkzMSLTT+7DQAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32377)">
            <path
              fill="url(#linearGradient32383)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2590.81 2479.48l11.41 17.09c3.67-2.54 7.43-4.94 11.3-7.21-2.4-2.79-4.79-5.55-7.16-8.3-4.99-.55-10.18-1.08-15.55-1.58"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32393)">
            <path
              fill="url(#linearGradient119724)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2590.81 2479.47v.01c5.37.5 10.56 1.03 15.55 1.58l-.01-.01c-4.98-.54-10.17-1.07-15.54-1.58"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32409)">
            <path
              fill="url(#linearGradient32415)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2544.78 2410.5l46.03 68.97c5.37.51 10.56 1.04 15.54 1.58-24.67-28.54-47.24-54.47-61.57-70.55"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32425)">
            <path
              fill="url(#radialGradient32433)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2809.88 2771.16c-4.07 2.55-8.26 4.94-12.56 7.17 31.88 44.05 59.84 82.59 60.06 82.59l-.01-.01c-1.22-2.63-22.81-43.34-47.49-89.75"
            ></path>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32443)">
            <g transform="matrix(73.2002 0 0 92.2002 2605.9 2501.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAATCAYAAABPwleqAAAABHNCSVQICAgIfAhkiAAAAIdJREFUOI2d0k0SgCAIBlA/pvvfoiM2LWlhpfwJxaKZFB4m4Th3bndgevoh92h+4ZaFzKAsYbVP+pB595HldK4S3Iv97jnwdv4DBMeuAaIYyxNYhAC7GE9AIv3CioBGxoUVAI3Ibw6ACDG37QER4o4qAjQSzhngFFn+JBmyZcUz8gQzvhV70AV5wyy8q/XtywAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32455)">
            <g transform="matrix(44.2002 0 0 39.2002 2595.9 2482.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAICAYAAAArzdW1AAAABHNCSVQICAgIfAhkiAAAAGNJREFUGJVtz8ENwzAMBME9Qf0X4n5cTD7aPGQxNBABhD7HIZnPfUmAAVEY1DMQYSAgsEAD6xeK+5+7pXUT8K0ODBXMH3XBVIjZgdXIo/Ls5JG62qp28hlVarNms+tsPLkg8AWRaDJ4bF2nLAAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32467)">
            <g transform="matrix(87.2002 0 0 97.2002 2730.9 2688.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAUCAYAAACAl21KAAAABHNCSVQICAgIfAhkiAAAAUZJREFUOI11lEF2wyAMRP/Ivv9Ruu1xepIyXQhhQVzn8eKA+BpNBPr5+jaAeZ56H/UmsJ8Ii+0ZiBBCQGT8Ni5EIDAIISVB3kGBuXNSlXhm81KWSXJ92JlWwFRY6u7rKGvM7K74troBFdgDOWF3leEV/ABTZhmyA0919+FbC+4KwQfwQnipU3n0+FPq6vs/oPHyb6SiCq1ko7x/Epwlq68k7I75Y8w2gEgDATSWul7yri73L4+imVlQOWet8eHfYPbThL2a/aHSgRhbR1/Ab4PdqtWzXQ+gZ8lMdZ4wz1Lv2qSe7oB2II4F66XeavvrXL6p9AR2WP8jAisJNhJrdGA/yDH7R44FERAZEIhgQdlhsvZNL7BQu2cKWsBT3RssJiwyyGvswBd1B4ypbF5sdb3BrjA2/05YryTKxJyYn03dcxZPWFf1B7curujYUp/DAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32479)">
            <g transform="matrix(59.2002 0 0 39.2002 2725.9 2674.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAICAYAAADN5B7xAAAABHNCSVQICAgIfAhkiAAAAFBJREFUGJV90MENACAIA8Di/rs4hFv5ED8oFYj+ND1olDm6Ip4FQOhOiZbCRQjiA2pwXjXDGqghhncWrSsrBeQbGAqF9EW5UkRcEb9fisjSG9yCEIe8WEhaAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32491)">
            <g transform="matrix(116.2 0 0 150.2 2653.9 2549.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAfCAYAAAD9cg1AAAAABHNCSVQICAgIfAhkiAAAAX5JREFUSIm9llGOxiAIhAfi/W+yl9jj7CE6+2CpiGDN5s+SNE1FvgGqtvLz9U1BNyH7HQLARk+NIHo8Re4RQFe4/gFuaWlgAe006+hhOU+79+a2HXxXh/etYp1IEC2D+yfhvl0UPvNnoU5uFfwNHBMwoSiiJ3Aprkwojj8CGfxtsUZ/JtJ28BGYC9h03xqhTO3SLLCG6xTifVWlGrPP4R08WjKEMhHPSiuI8KXXk1DdwmdGvST1YLPlORqzWKYbaiXGmWFWtuhT9r8C1pnDU2Iyi4nd1e6smn6Vx/KAXYUgh8DechEP31WsMThvUxfxV5Z5xmrPg3AcvbjPFztrWABdEpzGx1ObgavIWs1qGdzGNE7y6if7bQcHXIvMkVVyYhn8FvDNmEWAs2+yjw1eNMI+2qtIBGyFkhGC9pJzEbOqhlp6/OU1ikDIVOQdtIdTBI0AIHaQ9G30yX/TsA9GNUMIGzFbOe5Fy7z62oULCnka9FTzVOSnFzKSvTviAvELKru8w11lRHIAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32503)">
            <g transform="matrix(92.2002 0 0 111.2 2667.9 2568.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAXCAYAAADpwXTaAAAABHNCSVQICAgIfAhkiAAAALhJREFUOI2tlMEOxCAIRBmz//8vm/26PdFDY7UwKKSdmxWewxiL/++rslUzaxVRmE9wVQnQyWL6hAz0DuIikIchMTVwnTP33WdgoJUrszVg1FEi0qm2xaC61kcng++KbzM9IqSH1x6NaJxXEt4qhhXzOmG0KWH46hv9742p9gW4U2tqvrliNrrNihuFsP9Q80UpmlkqgZWAXuY5bfK6GfK1i7fJAGx/FGxgKu4PSCAENtvW2FWUqUIOFZguod5MwzUAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32515)">
            <g transform="matrix(101.2 0 0 125.2 2663.9 2559.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAaCAYAAABYQRdDAAAABHNCSVQICAgIfAhkiAAAAMJJREFUSIm9lU0WwyAIhIWX+58j656uO7qweWCEEbXN7FT4wPww9D5fUqykXVbRdegcUbd1+LA+0N8XzTNwzgMHRQyDdUGTQAumBszz3SF41QGivtXD3CBeCodR4gDRvqnIqe4mY3poBghjKeh0Uw9AZ64Oclro6rcPoT/SQ9DFeaKSoNMMGMRw+MoRODyrLDxQFocX2wp7UgdgtYEdcGspbBeDuRbAeo/SZ0rWEpBn3YpCN3XhDgTAYmgiaaQ//KZSPibzM5KS09BrAAAAAElFTkSuQmCC"
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32527)">
            <g transform="matrix(83.2002 0 0 97.2002 2672.9 2573.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAUCAYAAABroNZJAAAABHNCSVQICAgIfAhkiAAAAK9JREFUOI2VlF0OwjAMg+2K+5+FA3AyJGQeRmD5Y2meonb54sTq+HzchTaYcr3ozwWsHjABHzGE5MIhpCgUwZW/qSFh7Fh0gPg9yhArVjzohDJAmJJfqNtLhAxD4knplsW9QzXkah/XkME+QpNVX/ZgFQvOSjZHKSB71lrTLYujtZYPIP7Zp1zAzbciQMH/O5KeD+B3d1JiM7LfgwzgB1itrWqfshMF2DhO3r/CuuMbQoksnNs3JqwAAAAASUVORK5CYII="
              ></image>
            </g>
          </g>
        </g>
        <g transform="matrix(.03528 0 0 -.03528 37.78 206.59)">
          <g clipPath="url(#clipPath32539)">
            <g transform="matrix(63.2002 0 0 82.2002 2682.9 2578.9)">
              <image
                width="1"
                height="1"
                imageRendering="optimizeSpeed"
                preserveAspectRatio="none"
                transform="matrix(1 0 0 -1 0 1)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAARCAYAAAAG/yacAAAABHNCSVQICAgIfAhkiAAAAJ9JREFUKJGVUm0OhTAIK8T7H+xdwosY6g/2AWxLfE1wSClVVJ77RwgOUD+MnhMACE0CEY8TxC9XEnSm5yyO6e40XVpormkWbMQcncXpH/CTqLfIUvlmsYpO77Pz5oGpM20Omd+J1gzrE9MFAS6Kbsl4FQA6fqiVtCIIwy5QZsEiqxsBAVpjGDdHb4oxatKcrDHcLGCkkvKy047c5CdH/gJbPzzCvlOM5AAAAABJRU5ErkJggg=="
              ></image>
            </g>
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="0.035"
          d="M134.752 112.347c-1.55-1.21-1.266-4.613-1.281-5.573v.921c0-.149-.01-.307-.01-.341v-.58a10.82 10.82 0 01-.086 1.217s-.453 3.413-1.271 4.12c-1.844 1.615-6.484 1.305-4.705 1.347 6.01.127 6.01 5.991 6.062 7.915v-.968c.005.07.01.128.01.162v.806c.127-4.554.114-7.433 5.356-7.818 1.736-.134-2.265.2-4.075-1.208"
        ></path>
      </g>
    </svg>
  );
};
